require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.array.reduce.js");

(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define([], factory);else if (typeof exports === 'object') exports["Gitalk"] = factory();else root["Gitalk"] = factory();
})(this, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            /******/
            configurable: false,

            /******/
            enumerable: true,

            /******/
            get: getter
            /******/

          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "/dist";
      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = 191);
      /******/
    }
    /************************************************************************/

    /******/
    ([
    /* 0 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = requiredArgs;

      function requiredArgs(required, args) {
        if (args.length < required) {
          throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
        }
      }
      /***/

    },
    /* 1 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = toDate;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name toDate
       * @category Common Helpers
       * @summary Convert the given argument to an instance of Date.
       *
       * @description
       * Convert the given argument to an instance of Date.
       *
       * If the argument is an instance of Date, the function returns its clone.
       *
       * If the argument is a number, it is treated as a timestamp.
       *
       * If the argument is none of the above, the function returns Invalid Date.
       *
       * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
       *
       * @param {Date|Number} argument - the value to convert
       * @returns {Date} the parsed date in the local time zone
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Clone the date:
       * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
       * //=> Tue Feb 11 2014 11:30:30
       *
       * @example
       * // Convert the timestamp to date:
       * const result = toDate(1392098430000)
       * //=> Tue Feb 11 2014 11:30:30
       */


      function toDate(argument) {
        __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var argStr = Object.prototype.toString.call(argument); // Clone the date

        if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
          // Prevent the date to lose the milliseconds when passed to new Date() in IE10
          return new Date(argument.getTime());
        } else if (typeof argument === 'number' || argStr === '[object Number]') {
          return new Date(argument);
        } else {
          if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

            console.warn(new Error().stack);
          }

          return new Date(NaN);
        }
      }
      /***/

    },
    /* 2 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = buildFormatLongFn;

      function buildFormatLongFn(args) {
        return function (dirtyOptions) {
          var options = dirtyOptions || {};
          var width = options.width ? String(options.width) : args.defaultWidth;
          var format = args.formats[width] || args.formats[args.defaultWidth];
          return format;
        };
      }
      /***/

    },
    /* 3 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = buildLocalizeFn;

      function buildLocalizeFn(args) {
        return function (dirtyIndex, dirtyOptions) {
          var options = dirtyOptions || {};
          var context = options.context ? String(options.context) : 'standalone';
          var valuesArray;

          if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
          } else {
            var _defaultWidth = args.defaultWidth;

            var _width = options.width ? String(options.width) : args.defaultWidth;

            valuesArray = args.values[_width] || args.values[_defaultWidth];
          }

          var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
          return valuesArray[index];
        };
      }
      /***/

    },
    /* 4 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = buildMatchPatternFn;

      function buildMatchPatternFn(args) {
        return function (dirtyString, dirtyOptions) {
          var string = String(dirtyString);
          var options = dirtyOptions || {};
          var matchResult = string.match(args.matchPattern);

          if (!matchResult) {
            return null;
          }

          var matchedString = matchResult[0];
          var parseResult = string.match(args.parsePattern);

          if (!parseResult) {
            return null;
          }

          var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
          value = options.valueCallback ? options.valueCallback(value) : value;
          return {
            value: value,
            rest: string.slice(matchedString.length)
          };
        };
      }
      /***/

    },
    /* 5 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = buildMatchFn;

      function buildMatchFn(args) {
        return function (dirtyString, dirtyOptions) {
          var string = String(dirtyString);
          var options = dirtyOptions || {};
          var width = options.width;
          var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
          var matchResult = string.match(matchPattern);

          if (!matchResult) {
            return null;
          }

          var matchedString = matchResult[0];
          var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
          var value;

          if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
            value = findIndex(parsePatterns, function (pattern) {
              return pattern.test(matchedString);
            });
          } else {
            value = findKey(parsePatterns, function (pattern) {
              return pattern.test(matchedString);
            });
          }

          value = args.valueCallback ? args.valueCallback(value) : value;
          value = options.valueCallback ? options.valueCallback(value) : value;
          return {
            value: value,
            rest: string.slice(matchedString.length)
          };
        };
      }

      function findKey(object, predicate) {
        for (var key in object) {
          if (object.hasOwnProperty(key) && predicate(object[key])) {
            return key;
          }
        }
      }

      function findIndex(array, predicate) {
        for (var key = 0; key < array.length; key++) {
          if (predicate(array[key])) {
            return key;
          }
        }
      }
      /***/

    },
    /* 6 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = toInteger;

      function toInteger(dirtyNumber) {
        if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
          return NaN;
        }

        var number = Number(dirtyNumber);

        if (isNaN(number)) {
          return number;
        }

        return number < 0 ? Math.ceil(number) : Math.floor(number);
      }
      /***/

    },
    /* 7 */

    /***/
    function (module, exports) {
      var core = module.exports = {
        version: '2.6.11'
      };
      if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

      /***/
    },
    /* 8 */

    /***/
    function (module, exports) {
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
      : Function('return this')();
      if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

      /***/
    },
    /* 9 */

    /***/
    function (module, exports, __webpack_require__) {
      var store = __webpack_require__(74)('wks');

      var uid = __webpack_require__(52);

      var Symbol = __webpack_require__(8).Symbol;

      var USE_SYMBOL = typeof Symbol == 'function';

      var $exports = module.exports = function (name) {
        return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
      };

      $exports.store = store;
      /***/
    },
    /* 10 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var bind = __webpack_require__(122);
      /*global toString:true*/
      // utils is a library of generic helper functions non-specific to axios


      var toString = Object.prototype.toString;
      /**
       * Determine if a value is an Array
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an Array, otherwise false
       */

      function isArray(val) {
        return toString.call(val) === '[object Array]';
      }
      /**
       * Determine if a value is undefined
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if the value is undefined, otherwise false
       */


      function isUndefined(val) {
        return typeof val === 'undefined';
      }
      /**
       * Determine if a value is a Buffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Buffer, otherwise false
       */


      function isBuffer(val) {
        return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
      }
      /**
       * Determine if a value is an ArrayBuffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an ArrayBuffer, otherwise false
       */


      function isArrayBuffer(val) {
        return toString.call(val) === '[object ArrayBuffer]';
      }
      /**
       * Determine if a value is a FormData
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an FormData, otherwise false
       */


      function isFormData(val) {
        return typeof FormData !== 'undefined' && val instanceof FormData;
      }
      /**
       * Determine if a value is a view on an ArrayBuffer
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
       */


      function isArrayBufferView(val) {
        var result;

        if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
          result = ArrayBuffer.isView(val);
        } else {
          result = val && val.buffer && val.buffer instanceof ArrayBuffer;
        }

        return result;
      }
      /**
       * Determine if a value is a String
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a String, otherwise false
       */


      function isString(val) {
        return typeof val === 'string';
      }
      /**
       * Determine if a value is a Number
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Number, otherwise false
       */


      function isNumber(val) {
        return typeof val === 'number';
      }
      /**
       * Determine if a value is an Object
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is an Object, otherwise false
       */


      function isObject(val) {
        return val !== null && typeof val === 'object';
      }
      /**
       * Determine if a value is a Date
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Date, otherwise false
       */


      function isDate(val) {
        return toString.call(val) === '[object Date]';
      }
      /**
       * Determine if a value is a File
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a File, otherwise false
       */


      function isFile(val) {
        return toString.call(val) === '[object File]';
      }
      /**
       * Determine if a value is a Blob
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Blob, otherwise false
       */


      function isBlob(val) {
        return toString.call(val) === '[object Blob]';
      }
      /**
       * Determine if a value is a Function
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Function, otherwise false
       */


      function isFunction(val) {
        return toString.call(val) === '[object Function]';
      }
      /**
       * Determine if a value is a Stream
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a Stream, otherwise false
       */


      function isStream(val) {
        return isObject(val) && isFunction(val.pipe);
      }
      /**
       * Determine if a value is a URLSearchParams object
       *
       * @param {Object} val The value to test
       * @returns {boolean} True if value is a URLSearchParams object, otherwise false
       */


      function isURLSearchParams(val) {
        return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
      }
      /**
       * Trim excess whitespace off the beginning and end of a string
       *
       * @param {String} str The String to trim
       * @returns {String} The String freed of excess whitespace
       */


      function trim(str) {
        return str.replace(/^\s*/, '').replace(/\s*$/, '');
      }
      /**
       * Determine if we're running in a standard browser environment
       *
       * This allows axios to run in a web worker, and react-native.
       * Both environments support XMLHttpRequest, but not fully standard globals.
       *
       * web workers:
       *  typeof window -> undefined
       *  typeof document -> undefined
       *
       * react-native:
       *  navigator.product -> 'ReactNative'
       * nativescript
       *  navigator.product -> 'NativeScript' or 'NS'
       */


      function isStandardBrowserEnv() {
        if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) {
          return false;
        }

        return typeof window !== 'undefined' && typeof document !== 'undefined';
      }
      /**
       * Iterate over an Array or an Object invoking a function for each item.
       *
       * If `obj` is an Array callback will be called passing
       * the value, index, and complete array for each item.
       *
       * If 'obj' is an Object callback will be called passing
       * the value, key, and complete object for each property.
       *
       * @param {Object|Array} obj The object to iterate
       * @param {Function} fn The callback to invoke for each item
       */


      function forEach(obj, fn) {
        // Don't bother if no value provided
        if (obj === null || typeof obj === 'undefined') {
          return;
        } // Force an array if not already something iterable


        if (typeof obj !== 'object') {
          /*eslint no-param-reassign:0*/
          obj = [obj];
        }

        if (isArray(obj)) {
          // Iterate over array values
          for (var i = 0, l = obj.length; i < l; i++) {
            fn.call(null, obj[i], i, obj);
          }
        } else {
          // Iterate over object keys
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
              fn.call(null, obj[key], key, obj);
            }
          }
        }
      }
      /**
       * Accepts varargs expecting each argument to be an object, then
       * immutably merges the properties of each object and returns result.
       *
       * When multiple objects contain the same key the later object in
       * the arguments list will take precedence.
       *
       * Example:
       *
       * ```js
       * var result = merge({foo: 123}, {foo: 456});
       * console.log(result.foo); // outputs 456
       * ```
       *
       * @param {Object} obj1 Object to merge
       * @returns {Object} Result of all merge properties
       */


      function
        /* obj1, obj2, obj3, ... */
      merge() {
        var result = {};

        function assignValue(val, key) {
          if (typeof result[key] === 'object' && typeof val === 'object') {
            result[key] = merge(result[key], val);
          } else {
            result[key] = val;
          }
        }

        for (var i = 0, l = arguments.length; i < l; i++) {
          forEach(arguments[i], assignValue);
        }

        return result;
      }
      /**
       * Function equal to merge with the difference being that no reference
       * to original objects is kept.
       *
       * @see merge
       * @param {Object} obj1 Object to merge
       * @returns {Object} Result of all merge properties
       */


      function
        /* obj1, obj2, obj3, ... */
      deepMerge() {
        var result = {};

        function assignValue(val, key) {
          if (typeof result[key] === 'object' && typeof val === 'object') {
            result[key] = deepMerge(result[key], val);
          } else if (typeof val === 'object') {
            result[key] = deepMerge({}, val);
          } else {
            result[key] = val;
          }
        }

        for (var i = 0, l = arguments.length; i < l; i++) {
          forEach(arguments[i], assignValue);
        }

        return result;
      }
      /**
       * Extends object a by mutably adding to it the properties of object b.
       *
       * @param {Object} a The object to be extended
       * @param {Object} b The object to copy properties from
       * @param {Object} thisArg The object to bind function to
       * @return {Object} The resulting value of object a
       */


      function extend(a, b, thisArg) {
        forEach(b, function assignValue(val, key) {
          if (thisArg && typeof val === 'function') {
            a[key] = bind(val, thisArg);
          } else {
            a[key] = val;
          }
        });
        return a;
      }

      module.exports = {
        isArray: isArray,
        isArrayBuffer: isArrayBuffer,
        isBuffer: isBuffer,
        isFormData: isFormData,
        isArrayBufferView: isArrayBufferView,
        isString: isString,
        isNumber: isNumber,
        isObject: isObject,
        isUndefined: isUndefined,
        isDate: isDate,
        isFile: isFile,
        isBlob: isBlob,
        isFunction: isFunction,
        isStream: isStream,
        isURLSearchParams: isURLSearchParams,
        isStandardBrowserEnv: isStandardBrowserEnv,
        forEach: forEach,
        merge: merge,
        deepMerge: deepMerge,
        extend: extend,
        trim: trim
      };
      /***/
    },
    /* 11 */

    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(8);

      var core = __webpack_require__(7);

      var ctx = __webpack_require__(29);

      var hide = __webpack_require__(23);

      var has = __webpack_require__(24);

      var PROTOTYPE = 'prototype';

      var $export = function $export(type, name, source) {
        var IS_FORCED = type & $export.F;
        var IS_GLOBAL = type & $export.G;
        var IS_STATIC = type & $export.S;
        var IS_PROTO = type & $export.P;
        var IS_BIND = type & $export.B;
        var IS_WRAP = type & $export.W;
        var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
        var expProto = exports[PROTOTYPE];
        var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
        var key, own, out;
        if (IS_GLOBAL) source = name;

        for (key in source) {
          // contains in native
          own = !IS_FORCED && target && target[key] !== undefined;
          if (own && has(exports, key)) continue; // export native or passed

          out = own ? target[key] : source[key]; // prevent global pollution for namespaces

          exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] // bind timers to global for call from export context
          : IS_BIND && own ? ctx(out, global) // wrap global constructors for prevent change them in library
          : IS_WRAP && target[key] == out ? function (C) {
            var F = function F(a, b, c) {
              if (this instanceof C) {
                switch (arguments.length) {
                  case 0:
                    return new C();

                  case 1:
                    return new C(a);

                  case 2:
                    return new C(a, b);
                }

                return new C(a, b, c);
              }

              return C.apply(this, arguments);
            };

            F[PROTOTYPE] = C[PROTOTYPE];
            return F; // make static versions for prototype methods
          }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%

          if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out; // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%

            if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
          }
        }
      }; // type bitmap


      $export.F = 1; // forced

      $export.G = 2; // global

      $export.S = 4; // static

      $export.P = 8; // proto

      $export.B = 16; // bind

      $export.W = 32; // wrap

      $export.U = 64; // safe

      $export.R = 128; // real proto method for `library`

      module.exports = $export;
      /***/
    },
    /* 12 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: true
      });
      /* WEBPACK VAR INJECTION */

      (function (process) {
        /* harmony export (binding) */
        __webpack_require__.d(__webpack_exports__, "version", function () {
          return version;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "DOM", function () {
          return DOM;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "Children", function () {
          return Children;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "render", function () {
          return render$1;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createClass", function () {
          return createClass;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createFactory", function () {
          return createFactory;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "createElement", function () {
          return createElement;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "cloneElement", function () {
          return cloneElement$1;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "isValidElement", function () {
          return isValidElement;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "findDOMNode", function () {
          return findDOMNode;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function () {
          return unmountComponentAtNode;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "Component", function () {
          return Component$1;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PureComponent", function () {
          return PureComponent;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function () {
          return renderSubtreeIntoContainer;
        });
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(195);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(202);
        /* harmony import */


        var __WEBPACK_IMPORTED_MODULE_1_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_preact__);
        /* harmony reexport (default from non-hamory) */


        __webpack_require__.d(__webpack_exports__, "PropTypes", function () {
          return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a;
        });

        var version = '15.1.0'; // trick libraries to think we are react

        var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');
        var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;
        var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper'; // don't autobind these methods since they already have guaranteed context.

        var AUTOBIND_BLACKLIST = {
          constructor: 1,
          render: 1,
          shouldComponentUpdate: 1,
          componentWillReceiveProps: 1,
          componentWillUpdate: 1,
          componentDidUpdate: 1,
          componentWillMount: 1,
          componentDidMount: 1,
          componentWillUnmount: 1,
          componentDidUnmount: 1
        };
        var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vert|word|writing|x)[A-Z]/;
        var BYPASS_HOOK = {};
        /*global process*/

        var DEV = typeof process === 'undefined' || !process.env || process.env.NODE_ENV !== 'production'; // a component that renders nothing. Used to replace components for unmountComponentAtNode.

        function EmptyComponent() {
          return null;
        } // make react think we're react.


        var VNode = __WEBPACK_IMPORTED_MODULE_1_preact__["h"]('a', null).constructor;

        VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
        VNode.prototype.preactCompatUpgraded = false;
        VNode.prototype.preactCompatNormalized = false;
        Object.defineProperty(VNode.prototype, 'type', {
          get: function get() {
            return this.nodeName;
          },
          set: function set(v) {
            this.nodeName = v;
          },
          configurable: true
        });
        Object.defineProperty(VNode.prototype, 'props', {
          get: function get() {
            return this.attributes;
          },
          set: function set(v) {
            this.attributes = v;
          },
          configurable: true
        });
        var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;

        __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
          if (oldEventHook) {
            e = oldEventHook(e);
          }

          e.persist = Object;
          e.nativeEvent = e;
          return e;
        };

        var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;

        __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
          if (!vnode.preactCompatUpgraded) {
            vnode.preactCompatUpgraded = true;
            var tag = vnode.nodeName,
                attrs = vnode.attributes = extend({}, vnode.attributes);

            if (typeof tag === 'function') {
              if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
                if (vnode.children && String(vnode.children) === '') {
                  vnode.children = undefined;
                }

                if (vnode.children) {
                  attrs.children = vnode.children;
                }

                if (!vnode.preactCompatNormalized) {
                  normalizeVNode(vnode);
                }

                handleComponentVNode(vnode);
              }
            } else {
              if (vnode.children && String(vnode.children) === '') {
                vnode.children = undefined;
              }

              if (vnode.children) {
                attrs.children = vnode.children;
              }

              if (attrs.defaultValue) {
                if (!attrs.value && attrs.value !== 0) {
                  attrs.value = attrs.defaultValue;
                }

                delete attrs.defaultValue;
              }

              handleElementVNode(vnode, attrs);
            }
          }

          if (oldVnodeHook) {
            oldVnodeHook(vnode);
          }
        };

        function handleComponentVNode(vnode) {
          var tag = vnode.nodeName,
              a = vnode.attributes;
          vnode.attributes = {};

          if (tag.defaultProps) {
            extend(vnode.attributes, tag.defaultProps);
          }

          if (a) {
            extend(vnode.attributes, a);
          }
        }

        function handleElementVNode(vnode, a) {
          var shouldSanitize, attrs, i;

          if (a) {
            for (i in a) {
              if (shouldSanitize = CAMEL_PROPS.test(i)) {
                break;
              }
            }

            if (shouldSanitize) {
              attrs = vnode.attributes = {};

              for (i in a) {
                if (a.hasOwnProperty(i)) {
                  attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
                }
              }
            }
          }
        } // proxy render() since React returns a Component reference.


        function render$1(vnode, parent, callback) {
          var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base; // ignore impossible previous renders

          if (prev && prev.parentNode !== parent) {
            prev = null;
          } // default to first Element child


          if (!prev) {
            prev = parent.children[0];
          } // remove unaffected siblings


          for (var i = parent.childNodes.length; i--;) {
            if (parent.childNodes[i] !== prev) {
              parent.removeChild(parent.childNodes[i]);
            }
          }

          var out = __WEBPACK_IMPORTED_MODULE_1_preact__["render"](vnode, parent, prev);

          if (parent) {
            parent._preactCompatRendered = out && (out._component || {
              base: out
            });
          }

          if (typeof callback === 'function') {
            callback();
          }

          return out && out._component || out;
        }

        var ContextProvider = function ContextProvider() {};

        ContextProvider.prototype.getChildContext = function () {
          return this.props.context;
        };

        ContextProvider.prototype.render = function (props) {
          return props.children[0];
        };

        function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
          var wrap = __WEBPACK_IMPORTED_MODULE_1_preact__["h"](ContextProvider, {
            context: parentComponent.context
          }, vnode);

          var c = render$1(wrap, container);

          if (callback) {
            callback(c);
          }

          return c._component || c.base;
        }

        function unmountComponentAtNode(container) {
          var existing = container._preactCompatRendered && container._preactCompatRendered.base;

          if (existing && existing.parentNode === container) {
            __WEBPACK_IMPORTED_MODULE_1_preact__["render"](__WEBPACK_IMPORTED_MODULE_1_preact__["h"](EmptyComponent), container, existing);

            return true;
          }

          return false;
        }

        var ARR = []; // This API is completely unnecessary for Preact, so it's basically passthrough.

        var Children = {
          map: function map(children, fn, ctx) {
            if (children == null) {
              return null;
            }

            children = Children.toArray(children);

            if (ctx && ctx !== children) {
              fn = fn.bind(ctx);
            }

            return children.map(fn);
          },
          forEach: function forEach(children, fn, ctx) {
            if (children == null) {
              return null;
            }

            children = Children.toArray(children);

            if (ctx && ctx !== children) {
              fn = fn.bind(ctx);
            }

            children.forEach(fn);
          },
          count: function count(children) {
            return children && children.length || 0;
          },
          only: function only(children) {
            children = Children.toArray(children);

            if (children.length !== 1) {
              throw new Error('Children.only() expects only one child.');
            }

            return children[0];
          },
          toArray: function toArray(children) {
            if (children == null) {
              return [];
            }

            return Array.isArray && Array.isArray(children) ? children : ARR.concat(children);
          }
        };
        /** Track current render() component for ref assignment */

        var currentComponent;

        function createFactory(type) {
          return createElement.bind(null, type);
        }

        var DOM = {};

        for (var i = ELEMENTS.length; i--;) {
          DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
        }

        function upgradeToVNodes(arr, offset) {
          for (var i = offset || 0; i < arr.length; i++) {
            var obj = arr[i];

            if (Array.isArray(obj)) {
              upgradeToVNodes(obj);
            } else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
              arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
            }
          }
        }

        function isStatelessComponent(c) {
          return typeof c === 'function' && !(c.prototype && c.prototype.render);
        } // wraps stateless functional components in a PropTypes validator


        function wrapStatelessComponent(WrappedComponent) {
          return createClass({
            displayName: WrappedComponent.displayName || WrappedComponent.name,
            render: function render() {
              return WrappedComponent(this.props, this.context);
            }
          });
        }

        function statelessComponentHook(Ctor) {
          var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];

          if (Wrapped) {
            return Wrapped === true ? Ctor : Wrapped;
          }

          Wrapped = wrapStatelessComponent(Ctor);
          Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, {
            configurable: true,
            value: true
          });
          Wrapped.displayName = Ctor.displayName;
          Wrapped.propTypes = Ctor.propTypes;
          Wrapped.defaultProps = Ctor.defaultProps;
          Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, {
            configurable: true,
            value: Wrapped
          });
          return Wrapped;
        }

        function createElement() {
          var args = [],
              len = arguments.length;

          while (len--) {
            args[len] = arguments[len];
          }

          upgradeToVNodes(args, 2);
          return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
        }

        function normalizeVNode(vnode) {
          vnode.preactCompatNormalized = true;
          applyClassName(vnode);

          if (isStatelessComponent(vnode.nodeName)) {
            vnode.nodeName = statelessComponentHook(vnode.nodeName);
          }

          var ref = vnode.attributes.ref,
              type = ref && typeof ref;

          if (currentComponent && (type === 'string' || type === 'number')) {
            vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
          }

          applyEventNormalization(vnode);
          return vnode;
        }

        function cloneElement$1(element, props) {
          var children = [],
              len = arguments.length - 2;

          while (len-- > 0) {
            children[len] = arguments[len + 2];
          }

          if (!isValidElement(element)) {
            return element;
          }

          var elementProps = element.attributes || element.props;

          var node = __WEBPACK_IMPORTED_MODULE_1_preact__["h"](element.nodeName || element.type, elementProps, element.children || elementProps && elementProps.children); // Only provide the 3rd argument if needed.
          // Arguments 3+ overwrite element.children in preactCloneElement


          var cloneArgs = [node, props];

          if (children && children.length) {
            cloneArgs.push(children);
          } else if (props && props.children) {
            cloneArgs.push(props.children);
          }

          return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
        }

        function isValidElement(element) {
          return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
        }

        function createStringRefProxy(name, component) {
          return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
            if (component && component.refs) {
              component.refs[name] = resolved;

              if (resolved === null) {
                delete component._refProxies[name];
                component = null;
              }
            }
          });
        }

        function applyEventNormalization(ref) {
          var nodeName = ref.nodeName;
          var attributes = ref.attributes;

          if (!attributes || typeof nodeName !== 'string') {
            return;
          }

          var props = {};

          for (var i in attributes) {
            props[i.toLowerCase()] = i;
          }

          if (props.ondoubleclick) {
            attributes.ondblclick = attributes[props.ondoubleclick];
            delete attributes[props.ondoubleclick];
          } // for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:


          if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
            var normalized = props.oninput || 'oninput';

            if (!attributes[normalized]) {
              attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
              delete attributes[props.onchange];
            }
          }
        }

        function applyClassName(ref) {
          var attributes = ref.attributes;

          if (!attributes) {
            return;
          }

          var cl = attributes.className || attributes.class;

          if (cl) {
            attributes.className = cl;
          }
        }

        function extend(base, props) {
          for (var key in props) {
            if (props.hasOwnProperty(key)) {
              base[key] = props[key];
            }
          }

          return base;
        }

        function shallowDiffers(a, b) {
          for (var i in a) {
            if (!(i in b)) {
              return true;
            }
          }

          for (var i$1 in b) {
            if (a[i$1] !== b[i$1]) {
              return true;
            }
          }

          return false;
        }

        function findDOMNode(component) {
          return component && component.base || component;
        }

        function F() {}

        function createClass(obj) {
          function cl(props, context) {
            bindAll(this);
            Component$1.call(this, props, context, BYPASS_HOOK);
            newComponentHook.call(this, props, context);
          }

          obj = extend({
            constructor: cl
          }, obj); // We need to apply mixins here so that getDefaultProps is correctly mixed

          if (obj.mixins) {
            applyMixins(obj, collateMixins(obj.mixins));
          }

          if (obj.statics) {
            extend(cl, obj.statics);
          }

          if (obj.propTypes) {
            cl.propTypes = obj.propTypes;
          }

          if (obj.defaultProps) {
            cl.defaultProps = obj.defaultProps;
          }

          if (obj.getDefaultProps) {
            cl.defaultProps = obj.getDefaultProps();
          }

          F.prototype = Component$1.prototype;
          cl.prototype = extend(new F(), obj);
          cl.displayName = obj.displayName || 'Component';
          return cl;
        } // Flatten an Array of mixins to a map of method name to mixin implementations


        function collateMixins(mixins) {
          var keyed = {};

          for (var i = 0; i < mixins.length; i++) {
            var mixin = mixins[i];

            for (var key in mixin) {
              if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
                (keyed[key] || (keyed[key] = [])).push(mixin[key]);
              }
            }
          }

          return keyed;
        } // apply a mapping of Arrays of mixin methods to a component prototype


        function applyMixins(proto, mixins) {
          for (var key in mixins) {
            if (mixins.hasOwnProperty(key)) {
              proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
            }
          }
        }

        function bindAll(ctx) {
          for (var i in ctx) {
            var v = ctx[i];

            if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
              (ctx[i] = v.bind(ctx)).__bound = true;
            }
          }
        }

        function callMethod(ctx, m, args) {
          if (typeof m === 'string') {
            m = ctx.constructor.prototype[m];
          }

          if (typeof m === 'function') {
            return m.apply(ctx, args);
          }
        }

        function multihook(hooks, skipDuplicates) {
          return function () {
            var arguments$1 = arguments;
            var this$1 = this;
            var ret;

            for (var i = 0; i < hooks.length; i++) {
              var r = callMethod(this$1, hooks[i], arguments$1);

              if (skipDuplicates && r != null) {
                if (!ret) {
                  ret = {};
                }

                for (var key in r) {
                  if (r.hasOwnProperty(key)) {
                    ret[key] = r[key];
                  }
                }
              } else if (typeof r !== 'undefined') {
                ret = r;
              }
            }

            return ret;
          };
        }

        function newComponentHook(props, context) {
          propsHook.call(this, props, context);
          this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
          this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
        }

        function propsHook(props, context) {
          if (!props) {
            return;
          } // React annoyingly special-cases single children, and some react components are ridiculously strict about this.


          var c = props.children;

          if (c && Array.isArray(c) && c.length === 1) {
            props.children = c[0]; // but its totally still going to be an Array.

            if (props.children && typeof props.children === 'object') {
              props.children.length = 1;
              props.children[0] = props.children;
            }
          } // add proptype checking


          if (DEV) {
            var ctor = typeof this === 'function' ? this : this.constructor,
                propTypes = this.propTypes || ctor.propTypes;
            var displayName = this.displayName || ctor.name;

            if (propTypes) {
              __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
            }
          }
        }

        function beforeRender(props) {
          currentComponent = this;
        }

        function afterRender() {
          if (currentComponent === this) {
            currentComponent = null;
          }
        }

        function Component$1(props, context, opts) {
          __WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);

          this.state = this.getInitialState ? this.getInitialState() : {};
          this.refs = {};
          this._refProxies = {};

          if (opts !== BYPASS_HOOK) {
            newComponentHook.call(this, props, context);
          }
        }

        extend(Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"](), {
          constructor: Component$1,
          isReactComponent: {},
          replaceState: function replaceState(state, callback) {
            var this$1 = this;
            this.setState(state, callback);

            for (var i in this$1.state) {
              if (!(i in state)) {
                delete this$1.state[i];
              }
            }
          },
          getDOMNode: function getDOMNode() {
            return this.base;
          },
          isMounted: function isMounted() {
            return !!this.base;
          }
        });

        function PureComponent(props, context) {
          Component$1.call(this, props, context);
        }

        F.prototype = Component$1.prototype;
        PureComponent.prototype = new F();
        PureComponent.prototype.isPureReactComponent = true;

        PureComponent.prototype.shouldComponentUpdate = function (props, state) {
          return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
        };

        var index = {
          version: version,
          DOM: DOM,
          PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
          Children: Children,
          render: render$1,
          createClass: createClass,
          createFactory: createFactory,
          createElement: createElement,
          cloneElement: cloneElement$1,
          isValidElement: isValidElement,
          findDOMNode: findDOMNode,
          unmountComponentAtNode: unmountComponentAtNode,
          Component: Component$1,
          PureComponent: PureComponent,
          unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
        };
        /* harmony default export */

        __webpack_exports__["default"] = index;
        /* WEBPACK VAR INJECTION */
      }).call(__webpack_exports__, __webpack_require__(18));
      /***/
    },
    /* 13 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameUTCWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfUTCWeek_index_js__ = __webpack_require__(50);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
        __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeftStartOfWeek = __WEBPACK_IMPORTED_MODULE_0__startOfUTCWeek_index_js__["a"
        /* default */
        ](dirtyDateLeft, options);

        var dateRightStartOfWeek = __WEBPACK_IMPORTED_MODULE_0__startOfUTCWeek_index_js__["a"
        /* default */
        ](dirtyDateRight, options);

        return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
      }
      /***/

    },
    /* 14 */

    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(20);

      module.exports = function (it) {
        if (!isObject(it)) throw TypeError(it + ' is not an object!');
        return it;
      };
      /***/

    },
    /* 15 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isValid;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isValid
       * @category Common Helpers
       * @summary Is the given date valid?
       *
       * @description
       * Returns false if argument is Invalid Date and true otherwise.
       * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
       * Invalid Date is a Date, whose time value is NaN.
       *
       * Time value of Date: http://es5.github.io/#x15.9.1.1
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - Now `isValid` doesn't throw an exception
       *   if the first argument is not an instance of Date.
       *   Instead, argument is converted beforehand using `toDate`.
       *
       *   Examples:
       *
       *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
       *   |---------------------------|---------------|---------------|
       *   | `new Date()`              | `true`        | `true`        |
       *   | `new Date('2016-01-01')`  | `true`        | `true`        |
       *   | `new Date('')`            | `false`       | `false`       |
       *   | `new Date(1488370835081)` | `true`        | `true`        |
       *   | `new Date(NaN)`           | `false`       | `false`       |
       *   | `'2016-01-01'`            | `TypeError`   | `false`       |
       *   | `''`                      | `TypeError`   | `false`       |
       *   | `1488370835081`           | `TypeError`   | `true`        |
       *   | `NaN`                     | `TypeError`   | `false`       |
       *
       *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
       *   that try to coerce arguments to the expected type
       *   (which is also the case with other *date-fns* functions).
       *
       * @param {*} date - the date to check
       * @returns {Boolean} the date is valid
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // For the valid date:
       * var result = isValid(new Date(2014, 1, 31))
       * //=> true
       *
       * @example
       * // For the value, convertable into a date:
       * var result = isValid(1393804800000)
       * //=> true
       *
       * @example
       * // For the invalid date:
       * var result = isValid(new Date(''))
       * //=> false
       */


      function isValid(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        return !isNaN(date);
      }
      /***/

    },
    /* 16 */

    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(14);

      var IE8_DOM_DEFINE = __webpack_require__(98);

      var toPrimitive = __webpack_require__(67);

      var dP = Object.defineProperty;
      exports.f = __webpack_require__(17) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return dP(O, P, Attributes);
        } catch (e) {
          /* empty */
        }
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
      };
      /***/
    },
    /* 17 */

    /***/
    function (module, exports, __webpack_require__) {
      // Thank's IE8 for his funny defineProperty
      module.exports = !__webpack_require__(30)(function () {
        return Object.defineProperty({}, 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });
      /***/
    },
    /* 18 */

    /***/
    function (module, exports) {
      // shim for using process in browser
      var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
      // don't break things.  But we need to wrap it in a try catch in case it is
      // wrapped in strict mode code which doesn't define any globals.  It's inside a
      // function because try/catches deoptimize in certain engines.

      var cachedSetTimeout;
      var cachedClearTimeout;

      function defaultSetTimout() {
        throw new Error('setTimeout has not been defined');
      }

      function defaultClearTimeout() {
        throw new Error('clearTimeout has not been defined');
      }

      (function () {
        try {
          if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
          } else {
            cachedSetTimeout = defaultSetTimout;
          }
        } catch (e) {
          cachedSetTimeout = defaultSetTimout;
        }

        try {
          if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
          } else {
            cachedClearTimeout = defaultClearTimeout;
          }
        } catch (e) {
          cachedClearTimeout = defaultClearTimeout;
        }
      })();

      function runTimeout(fun) {
        if (cachedSetTimeout === setTimeout) {
          //normal enviroments in sane situations
          return setTimeout(fun, 0);
        } // if setTimeout wasn't available but was latter defined


        if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
          cachedSetTimeout = setTimeout;
          return setTimeout(fun, 0);
        }

        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedSetTimeout(fun, 0);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
          }
        }
      }

      function runClearTimeout(marker) {
        if (cachedClearTimeout === clearTimeout) {
          //normal enviroments in sane situations
          return clearTimeout(marker);
        } // if clearTimeout wasn't available but was latter defined


        if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
          cachedClearTimeout = clearTimeout;
          return clearTimeout(marker);
        }

        try {
          // when when somebody has screwed with setTimeout but no I.E. maddness
          return cachedClearTimeout(marker);
        } catch (e) {
          try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
          } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
          }
        }
      }

      var queue = [];
      var draining = false;
      var currentQueue;
      var queueIndex = -1;

      function cleanUpNextTick() {
        if (!draining || !currentQueue) {
          return;
        }

        draining = false;

        if (currentQueue.length) {
          queue = currentQueue.concat(queue);
        } else {
          queueIndex = -1;
        }

        if (queue.length) {
          drainQueue();
        }
      }

      function drainQueue() {
        if (draining) {
          return;
        }

        var timeout = runTimeout(cleanUpNextTick);
        draining = true;
        var len = queue.length;

        while (len) {
          currentQueue = queue;
          queue = [];

          while (++queueIndex < len) {
            if (currentQueue) {
              currentQueue[queueIndex].run();
            }
          }

          queueIndex = -1;
          len = queue.length;
        }

        currentQueue = null;
        draining = false;
        runClearTimeout(timeout);
      }

      process.nextTick = function (fun) {
        var args = new Array(arguments.length - 1);

        if (arguments.length > 1) {
          for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
          }
        }

        queue.push(new Item(fun, args));

        if (queue.length === 1 && !draining) {
          runTimeout(drainQueue);
        }
      }; // v8 likes predictible objects


      function Item(fun, array) {
        this.fun = fun;
        this.array = array;
      }

      Item.prototype.run = function () {
        this.fun.apply(null, this.array);
      };

      process.title = 'browser';
      process.browser = true;
      process.env = {};
      process.argv = [];
      process.version = ''; // empty string to avoid regexp issues

      process.versions = {};

      function noop() {}

      process.on = noop;
      process.addListener = noop;
      process.once = noop;
      process.off = noop;
      process.removeListener = noop;
      process.removeAllListeners = noop;
      process.emit = noop;
      process.prependListener = noop;
      process.prependOnceListener = noop;

      process.listeners = function (name) {
        return [];
      };

      process.binding = function (name) {
        throw new Error('process.binding is not supported');
      };

      process.cwd = function () {
        return '/';
      };

      process.chdir = function (dir) {
        throw new Error('process.chdir is not supported');
      };

      process.umask = function () {
        return 0;
      };
      /***/

    },
    /* 19 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getTimezoneOffsetInMilliseconds;
      var MILLISECONDS_IN_MINUTE = 60000;

      function getDateMillisecondsPart(date) {
        return date.getTime() % MILLISECONDS_IN_MINUTE;
      }
      /**
       * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
       * They usually appear for dates that denote time before the timezones were introduced
       * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
       * and GMT+01:00:00 after that date)
       *
       * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
       * which would lead to incorrect calculations.
       *
       * This function returns the timezone offset in milliseconds that takes seconds in account.
       */


      function getTimezoneOffsetInMilliseconds(dirtyDate) {
        var date = new Date(dirtyDate.getTime());
        var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
        date.setSeconds(0, 0);
        var hasNegativeUTCOffset = baseTimezoneOffset > 0;
        var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? (MILLISECONDS_IN_MINUTE + getDateMillisecondsPart(date)) % MILLISECONDS_IN_MINUTE : getDateMillisecondsPart(date);
        return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
      }
      /***/

    },
    /* 20 */

    /***/
    function (module, exports) {
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
      };
      /***/

    },
    /* 21 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addDays
       * @category Day Helpers
       * @summary Add the specified number of days to the given date.
       *
       * @description
       * Add the specified number of days to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the days added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 10 days to 1 September 2014:
       * var result = addDays(new Date(2014, 8, 1), 10)
       * //=> Thu Sep 11 2014 00:00:00
       */


      function addDays(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        if (isNaN(amount)) {
          return new Date(NaN);
        }

        if (!amount) {
          // If 0 days, no-op to avoid changing times in the hour before end of DST
          return date;
        }

        date.setDate(date.getDate() + amount);
        return date;
      }
      /***/

    },
    /* 22 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfWeek
       * @category Week Helpers
       * @summary Return the start of a week for the given date.
       *
       * @description
       * Return the start of a week for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date} the start of a week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // The start of a week for 2 September 2014 11:55:00:
       * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sun Aug 31 2014 00:00:00
       *
       * @example
       * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
       * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
       * //=> Mon Sep 01 2014 00:00:00
       */


      function startOfWeek(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ](localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ](options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        }

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = date.getDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setDate(date.getDate() - diff);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 23 */

    /***/
    function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(16);

      var createDesc = __webpack_require__(39);

      module.exports = __webpack_require__(17) ? function (object, key, value) {
        return dP.f(object, key, createDesc(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };
      /***/
    },
    /* 24 */

    /***/
    function (module, exports) {
      var hasOwnProperty = {}.hasOwnProperty;

      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };
      /***/

    },
    /* 25 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(22);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfISOWeek
       * @category ISO Week Helpers
       * @summary Return the start of an ISO week for the given date.
       *
       * @description
       * Return the start of an ISO week for the given date.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of an ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of an ISO week for 2 September 2014 11:55:00:
       * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Mon Sep 01 2014 00:00:00
       */


      function startOfISOWeek(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ](dirtyDate, {
          weekStartsOn: 1
        });
      }
      /***/

    },
    /* 26 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__ = __webpack_require__(57);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_DAY = 86400000;
      /**
       * @name differenceInCalendarDays
       * @category Day Helpers
       * @summary Get the number of calendar days between the given dates.
       *
       * @description
       * Get the number of calendar days between the given dates. This means that the times are removed
       * from the dates and then the difference in days is calculated.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar days
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar days are between
       * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
       * var result = differenceInCalendarDays(
       *   new Date(2012, 6, 2, 0, 0),
       *   new Date(2011, 6, 2, 23, 0)
       * )
       * //=> 366
       * // How many calendar days are between
       * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
       * var result = differenceInCalendarDays(
       *   new Date(2011, 6, 3, 0, 1),
       *   new Date(2011, 6, 2, 23, 59)
       * )
       * //=> 1
       */

      function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var startOfDayLeft = __WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var startOfDayRight = __WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var timestampLeft = startOfDayLeft.getTime() - __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](startOfDayLeft);

        var timestampRight = startOfDayRight.getTime() - __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](startOfDayRight); // Round the number of days to the nearest integer
        // because the number of milliseconds in a day is not constant
        // (e.g. it's different in the day of the daylight saving time clock shift)


        return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
      }
      /***/

    },
    /* 27 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = compareAsc;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name compareAsc
       * @category Common Helpers
       * @summary Compare the two dates and return -1, 0 or 1.
       *
       * @description
       * Compare the two dates and return 1 if the first date is after the second,
       * -1 if the first date is before the second or 0 if dates are equal.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to compare
       * @param {Date|Number} dateRight - the second date to compare
       * @returns {Number} the result of the comparison
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Compare 11 February 1987 and 10 July 1989:
       * var result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
       * //=> -1
       *
       * @example
       * // Sort the array of dates:
       * var result = [
       *   new Date(1995, 6, 2),
       *   new Date(1987, 1, 11),
       *   new Date(1989, 6, 10)
       * ].sort(compareAsc)
       * //=> [
       * //   Wed Feb 11 1987 00:00:00,
       * //   Mon Jul 10 1989 00:00:00,
       * //   Sun Jul 02 1995 00:00:00
       * // ]
       */


      function compareAsc(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var diff = dateLeft.getTime() - dateRight.getTime();

        if (diff < 0) {
          return -1;
        } else if (diff > 0) {
          return 1; // Return 0 if diff is 0; return NaN if diff is NaN
        } else {
          return diff;
        }
      }
      /***/

    },
    /* 28 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(48);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(339);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(35);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(36);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(37);
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (United States).
       * @language English
       * @iso-639-2 eng
       * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
       * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
       */


      var locale = {
        code: 'en-US',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 29 */

    /***/
    function (module, exports, __webpack_require__) {
      // optional / simple context binding
      var aFunction = __webpack_require__(51);

      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;

        switch (length) {
          case 1:
            return function (a) {
              return fn.call(that, a);
            };

          case 2:
            return function (a, b) {
              return fn.call(that, a, b);
            };

          case 3:
            return function (a, b, c) {
              return fn.call(that, a, b, c);
            };
        }

        return function
          /* ...args */
        () {
          return fn.apply(that, arguments);
        };
      };
      /***/

    },
    /* 30 */

    /***/
    function (module, exports) {
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (e) {
          return true;
        }
      };
      /***/

    },
    /* 31 */

    /***/
    function (module, exports) {
      module.exports = {};
      /***/
    },
    /* 32 */

    /***/
    function (module, exports, __webpack_require__) {
      // to indexed object, toObject with fallback for non-array-like ES3 strings
      var IObject = __webpack_require__(104);

      var defined = __webpack_require__(70);

      module.exports = function (it) {
        return IObject(defined(it));
      };
      /***/

    },
    /* 33 */

    /***/
    function (module, exports, __webpack_require__) {
      // 7.1.13 ToObject(argument)
      var defined = __webpack_require__(70);

      module.exports = function (it) {
        return Object(defined(it));
      };
      /***/

    },
    /* 34 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(25);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Get the ISO week-numbering year of the given date.
       *
       * @description
       * Get the ISO week-numbering year of the given date,
       * which always starts 3 days before the year's first Thursday.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `getISOYear` to `getISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the ISO week-numbering year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which ISO-week numbering year is 2 January 2005?
       * var result = getISOWeekYear(new Date(2005, 0, 2))
       * //=> 2004
       */


      function getISOWeekYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);

        var startOfNextYear = __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ](fourthOfJanuaryOfNextYear);

        var fourthOfJanuaryOfThisYear = new Date(0);
        fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
        fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);

        var startOfThisYear = __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ](fourthOfJanuaryOfThisYear);

        if (date.getTime() >= startOfNextYear.getTime()) {
          return year + 1;
        } else if (date.getTime() >= startOfThisYear.getTime()) {
          return year;
        } else {
          return year - 1;
        }
      }
      /***/

    },
    /* 35 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'last' eeee 'at' p",
        yesterday: "'yesterday at' p",
        today: "'today at' p",
        tomorrow: "'tomorrow at' p",
        nextWeek: "eeee 'at' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 36 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['B', 'A'],
        abbreviated: ['BC', 'AD'],
        wide: ['Before Christ', 'Anno Domini']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      };
      var dayValues = {
        narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mi',
          noon: 'n',
          morning: 'morning',
          afternoon: 'afternoon',
          evening: 'evening',
          night: 'night'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'midnight',
          noon: 'noon',
          morning: 'morning',
          afternoon: 'afternoon',
          evening: 'evening',
          night: 'night'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnight',
          noon: 'noon',
          morning: 'morning',
          afternoon: 'afternoon',
          evening: 'evening',
          night: 'night'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mi',
          noon: 'n',
          morning: 'in the morning',
          afternoon: 'in the afternoon',
          evening: 'in the evening',
          night: 'at night'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'midnight',
          noon: 'noon',
          morning: 'in the morning',
          afternoon: 'in the afternoon',
          evening: 'in the evening',
          night: 'at night'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnight',
          noon: 'noon',
          morning: 'in the morning',
          afternoon: 'in the afternoon',
          evening: 'in the evening',
          night: 'at night'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return number + 'st';

            case 2:
              return number + 'nd';

            case 3:
              return number + 'rd';
          }
        }

        return number + 'th';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 37 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(b|a)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(before christ|before common era|anno domini|common era)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(a|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](th|st|nd|rd)? quarter/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
        wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|mo|tu|we|th|fr|sa)/i,
        abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
        wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 38 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addLeadingZeros;

      function addLeadingZeros(number, targetLength) {
        var sign = number < 0 ? '-' : '';
        var output = Math.abs(number).toString();

        while (output.length < targetLength) {
          output = '0' + output;
        }

        return sign + output;
      }
      /***/

    },
    /* 39 */

    /***/
    function (module, exports) {
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };
      /***/

    },
    /* 40 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var $at = __webpack_require__(210)(true); // 21.1.3.27 String.prototype[@@iterator]()


      __webpack_require__(101)(String, 'String', function (iterated) {
        this._t = String(iterated); // target

        this._i = 0; // next index
        // 21.1.5.2.1 %StringIteratorPrototype%.next()
      }, function () {
        var O = this._t;
        var index = this._i;
        var point;
        if (index >= O.length) return {
          value: undefined,
          done: true
        };
        point = $at(O, index);
        this._i += point.length;
        return {
          value: point,
          done: false
        };
      });
      /***/

    },
    /* 41 */

    /***/
    function (module, exports) {
      module.exports = true;
      /***/
    },
    /* 42 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.14 / 15.2.3.14 Object.keys(O)
      var $keys = __webpack_require__(103);

      var enumBugKeys = __webpack_require__(75);

      module.exports = Object.keys || function keys(O) {
        return $keys(O, enumBugKeys);
      };
      /***/

    },
    /* 43 */

    /***/
    function (module, exports) {
      var toString = {}.toString;

      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };
      /***/

    },
    /* 44 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addMonths;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addMonths
       * @category Month Helpers
       * @summary Add the specified number of months to the given date.
       *
       * @description
       * Add the specified number of months to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the months added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 5 months to 1 September 2014:
       * var result = addMonths(new Date(2014, 8, 1), 5)
       * //=> Sun Feb 01 2015 00:00:00
       */


      function addMonths(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        if (isNaN(amount)) {
          return new Date(NaN);
        }

        if (!amount) {
          // If 0 months, no-op to avoid changing times in the hour before end of DST
          return date;
        }

        var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
        // month, day, etc. For example, new Date(2020, 1, 0) returns 31 Dec 2019 and
        // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
        // want except that dates will wrap around the end of a month, meaning that
        // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
        // we'll default to the end of the desired month by adding 1 to the desired
        // month and using a date of 0 to back up one day to the end of the desired
        // month.

        var endOfDesiredMonth = new Date(date.getTime());
        endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
        var daysInMonth = endOfDesiredMonth.getDate();

        if (dayOfMonth >= daysInMonth) {
          // If we're already at the end of the month, then this is the correct date
          // and we're done.
          return endOfDesiredMonth;
        } else {
          // Otherwise, we now know that setting the original day-of-month value won't
          // cause an overflow, so set the desired day-of-month. Note that we can't
          // just set the date of `endOfDesiredMonth` because that object may have had
          // its time changed in the unusual case where where a DST transition was on
          // the last day of the month and its local time was in the hour skipped or
          // repeated next to a DST transition.  So we use `date` instead which is
          // guaranteed to still have the original time.
          date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
          return date;
        }
      }
      /***/

    },
    /* 45 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addMilliseconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addMilliseconds
       * @category Millisecond Helpers
       * @summary Add the specified number of milliseconds to the given date.
       *
       * @description
       * Add the specified number of milliseconds to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the milliseconds added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
       * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
       * //=> Thu Jul 10 2014 12:45:30.750
       */


      function addMilliseconds(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var timestamp = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getTime();

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return new Date(timestamp + amount);
      }
      /***/

    },
    /* 46 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(34);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(25);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Return the start of an ISO week-numbering year for the given date.
       *
       * @description
       * Return the start of an ISO week-numbering year,
       * which always starts 3 days before the year's first Thursday.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of an ISO week-numbering year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of an ISO week-numbering year for 2 July 2005:
       * var result = startOfISOWeekYear(new Date(2005, 6, 2))
       * //=> Mon Jan 03 2005 00:00:00
       */


      function startOfISOWeekYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var year = __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDate);

        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setFullYear(year, 0, 4);
        fourthOfJanuary.setHours(0, 0, 0, 0);

        var date = __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ](fourthOfJanuary);

        return date;
      }
      /***/

    },
    /* 47 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(57);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameDay
       * @category Day Helpers
       * @summary Are the given dates in the same day?
       *
       * @description
       * Are the given dates in the same day?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same day
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
       * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
       * //=> true
       */


      function isSameDay(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeftStartOfDay = __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRightStartOfDay = __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
      }
      /***/

    },
    /* 48 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'less than a second',
          other: 'less than {{count}} seconds'
        },
        xSeconds: {
          one: '1 second',
          other: '{{count}} seconds'
        },
        halfAMinute: 'half a minute',
        lessThanXMinutes: {
          one: 'less than a minute',
          other: 'less than {{count}} minutes'
        },
        xMinutes: {
          one: '1 minute',
          other: '{{count}} minutes'
        },
        aboutXHours: {
          one: 'about 1 hour',
          other: 'about {{count}} hours'
        },
        xHours: {
          one: '1 hour',
          other: '{{count}} hours'
        },
        xDays: {
          one: '1 day',
          other: '{{count}} days'
        },
        aboutXWeeks: {
          one: 'about 1 week',
          other: 'about {{count}} weeks'
        },
        xWeeks: {
          one: '1 week',
          other: '{{count}} weeks'
        },
        aboutXMonths: {
          one: 'about 1 month',
          other: 'about {{count}} months'
        },
        xMonths: {
          one: '1 month',
          other: '{{count}} months'
        },
        aboutXYears: {
          one: 'about 1 year',
          other: 'about {{count}} years'
        },
        xYears: {
          one: '1 year',
          other: '{{count}} years'
        },
        overXYears: {
          one: 'over 1 year',
          other: 'over {{count}} years'
        },
        almostXYears: {
          one: 'almost 1 year',
          other: 'almost {{count}} years'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'in ' + result;
          } else {
            return result + ' ago';
          }
        }

        return result;
      }
      /***/

    },
    /* 49 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subMilliseconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(45);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subMilliseconds
       * @category Millisecond Helpers
       * @summary Subtract the specified number of milliseconds from the given date.
       *
       * @description
       * Subtract the specified number of milliseconds from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the milliseconds subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
       * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
       * //=> Thu Jul 10 2014 12:45:29.250
       */


      function subMilliseconds(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 50 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfUTCWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function startOfUTCWeek(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        }

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 51 */

    /***/
    function (module, exports) {
      module.exports = function (it) {
        if (typeof it != 'function') throw TypeError(it + ' is not a function!');
        return it;
      };
      /***/

    },
    /* 52 */

    /***/
    function (module, exports) {
      var id = 0;
      var px = Math.random();

      module.exports = function (key) {
        return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
      };
      /***/

    },
    /* 53 */

    /***/
    function (module, exports, __webpack_require__) {
      var def = __webpack_require__(16).f;

      var has = __webpack_require__(24);

      var TAG = __webpack_require__(9)('toStringTag');

      module.exports = function (it, tag, stat) {
        if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
          configurable: true,
          value: tag
        });
      };
      /***/

    },
    /* 54 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(215);

      var global = __webpack_require__(8);

      var hide = __webpack_require__(23);

      var Iterators = __webpack_require__(31);

      var TO_STRING_TAG = __webpack_require__(9)('toStringTag');

      var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

      for (var i = 0; i < DOMIterables.length; i++) {
        var NAME = DOMIterables[i];
        var Collection = global[NAME];
        var proto = Collection && Collection.prototype;
        if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
        Iterators[NAME] = Iterators.Array;
      }
      /***/

    },
    /* 55 */

    /***/
    function (module, exports) {
      exports.f = {}.propertyIsEnumerable;
      /***/
    },
    /* 56 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isWeekend;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isWeekend
       * @category Weekday Helpers
       * @summary Does the given date fall on a weekend?
       *
       * @description
       * Does the given date fall on a weekend?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date falls on a weekend
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Does 5 October 2014 fall on a weekend?
       * var result = isWeekend(new Date(2014, 9, 5))
       * //=> true
       */


      function isWeekend(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = date.getDay();
        return day === 0 || day === 6;
      }
      /***/

    },
    /* 57 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfDay
       * @category Day Helpers
       * @summary Return the start of a day for the given date.
       *
       * @description
       * Return the start of a day for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a day
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a day for 2 September 2014 11:55:00:
       * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 02 2014 00:00:00
       */


      function startOfDay(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 58 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addWeeks;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addWeeks
       * @category Week Helpers
       * @summary Add the specified number of weeks to the given date.
       *
       * @description
       * Add the specified number of week to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the weeks added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 4 weeks to 1 September 2014:
       * var result = addWeeks(new Date(2014, 8, 1), 4)
       * //=> Mon Sep 29 2014 00:00:00
       */


      function addWeeks(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        var days = amount * 7;
        return __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["a"
        /* default */
        ](dirtyDate, days);
      }
      /***/

    },
    /* 59 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInMilliseconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInMilliseconds
       * @category Millisecond Helpers
       * @summary Get the number of milliseconds between the given dates.
       *
       * @description
       * Get the number of milliseconds between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of milliseconds
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many milliseconds are between
       * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
       * var result = differenceInMilliseconds(
       *   new Date(2014, 6, 2, 12, 30, 21, 700),
       *   new Date(2014, 6, 2, 12, 30, 20, 600)
       * )
       * //=> 1100
       */


      function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeft.getTime() - dateRight.getTime();
      }
      /***/

    },
    /* 60 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInMonths;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarMonths_index_js__ = __webpack_require__(140);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInMonths
       * @category Month Helpers
       * @summary Get the number of full months between the given dates.
       *
       * @description
       * Get the number of full months between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full months
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full months are between 31 January 2014 and 1 September 2014?
       * var result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
       * //=> 7
       */


      function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var sign = __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ](dateLeft, dateRight);

        var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarMonths_index_js__["a"
        /* default */
        ](dateLeft, dateRight));
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value

        var isLastMonthNotFull = __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ](dateLeft, dateRight) === -sign;
        var result = sign * (difference - isLastMonthNotFull); // Prevent negative zero

        return result === 0 ? 0 : result;
      }
      /***/

    },
    /* 61 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInSeconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__ = __webpack_require__(59);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInSeconds
       * @category Second Helpers
       * @summary Get the number of seconds between the given dates.
       *
       * @description
       * Get the number of seconds between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of seconds
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many seconds are between
       * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
       * var result = differenceInSeconds(
       *   new Date(2014, 6, 2, 12, 30, 20, 0),
       *   new Date(2014, 6, 2, 12, 30, 7, 999)
       * )
       * //=> 12
       */


      function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var diff = __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__["a"
        /* default */
        ](dirtyDateLeft, dirtyDateRight) / 1000;
        return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
      }
      /***/

    },
    /* 62 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfMonth
       * @category Month Helpers
       * @summary Return the start of a month for the given date.
       *
       * @description
       * Return the start of a month for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a month for 2 September 2014 11:55:00:
       * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Mon Sep 01 2014 00:00:00
       */


      function startOfMonth(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        date.setDate(1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 63 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfUTCISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function startOfUTCISOWeek(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var weekStartsOn = 1;

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = date.getUTCDay();
        var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
        date.setUTCDate(date.getUTCDate() - diff);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 64 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      exports.default = function (instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      };
      /***/

    },
    /* 65 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _defineProperty = __webpack_require__(192);

      var _defineProperty2 = _interopRequireDefault(_defineProperty);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, _defineProperty2.default)(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();
      /***/

    },
    /* 66 */

    /***/
    function (module, exports, __webpack_require__) {
      var isObject = __webpack_require__(20);

      var document = __webpack_require__(8).document; // typeof document.createElement is 'object' in old IE


      var is = isObject(document) && isObject(document.createElement);

      module.exports = function (it) {
        return is ? document.createElement(it) : {};
      };
      /***/

    },
    /* 67 */

    /***/
    function (module, exports, __webpack_require__) {
      // 7.1.1 ToPrimitive(input [, PreferredType])
      var isObject = __webpack_require__(20); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string


      module.exports = function (it, S) {
        if (!isObject(it)) return it;
        var fn, val;
        if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
        if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
        throw TypeError("Can't convert object to primitive value");
      };
      /***/

    },
    /* 68 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
      module.exports = ReactPropTypesSecret;
      /***/
    },
    /* 69 */

    /***/
    function (module, exports) {
      // 7.1.4 ToInteger
      var ceil = Math.ceil;
      var floor = Math.floor;

      module.exports = function (it) {
        return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
      };
      /***/

    },
    /* 70 */

    /***/
    function (module, exports) {
      // 7.2.1 RequireObjectCoercible(argument)
      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on  " + it);
        return it;
      };
      /***/

    },
    /* 71 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
      var anObject = __webpack_require__(14);

      var dPs = __webpack_require__(212);

      var enumBugKeys = __webpack_require__(75);

      var IE_PROTO = __webpack_require__(73)('IE_PROTO');

      var Empty = function Empty() {
        /* empty */
      };

      var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

      var _createDict = function createDict() {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = __webpack_require__(66)('iframe');

        var i = enumBugKeys.length;
        var lt = '<';
        var gt = '>';
        var iframeDocument;
        iframe.style.display = 'none';

        __webpack_require__(105).appendChild(iframe);

        iframe.src = 'javascript:'; // eslint-disable-line no-script-url
        // createDict = iframe.contentWindow.Object;
        // html.removeChild(iframe);

        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
        iframeDocument.close();
        _createDict = iframeDocument.F;

        while (i--) {
          delete _createDict[PROTOTYPE][enumBugKeys[i]];
        }

        return _createDict();
      };

      module.exports = Object.create || function create(O, Properties) {
        var result;

        if (O !== null) {
          Empty[PROTOTYPE] = anObject(O);
          result = new Empty();
          Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

          result[IE_PROTO] = O;
        } else result = _createDict();

        return Properties === undefined ? result : dPs(result, Properties);
      };
      /***/

    },
    /* 72 */

    /***/
    function (module, exports, __webpack_require__) {
      // 7.1.15 ToLength
      var toInteger = __webpack_require__(69);

      var min = Math.min;

      module.exports = function (it) {
        return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
      };
      /***/

    },
    /* 73 */

    /***/
    function (module, exports, __webpack_require__) {
      var shared = __webpack_require__(74)('keys');

      var uid = __webpack_require__(52);

      module.exports = function (key) {
        return shared[key] || (shared[key] = uid(key));
      };
      /***/

    },
    /* 74 */

    /***/
    function (module, exports, __webpack_require__) {
      var core = __webpack_require__(7);

      var global = __webpack_require__(8);

      var SHARED = '__core-js_shared__';
      var store = global[SHARED] || (global[SHARED] = {});
      (module.exports = function (key, value) {
        return store[key] || (store[key] = value !== undefined ? value : {});
      })('versions', []).push({
        version: core.version,
        mode: __webpack_require__(41) ? 'pure' : 'global',
        copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
      });
      /***/
    },
    /* 75 */

    /***/
    function (module, exports) {
      // IE 8- don't enum bug keys
      module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
      /***/
    },
    /* 76 */

    /***/
    function (module, exports, __webpack_require__) {
      // getting tag from 19.1.3.6 Object.prototype.toString()
      var cof = __webpack_require__(43);

      var TAG = __webpack_require__(9)('toStringTag'); // ES3 wrong here


      var ARG = cof(function () {
        return arguments;
      }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

      var tryGet = function tryGet(it, key) {
        try {
          return it[key];
        } catch (e) {
          /* empty */
        }
      };

      module.exports = function (it) {
        var O, T, B;
        return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
        : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
        : ARG ? cof(O) // ES3 arguments fallback
        : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
      };
      /***/

    },
    /* 77 */

    /***/
    function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(76);

      var ITERATOR = __webpack_require__(9)('iterator');

      var Iterators = __webpack_require__(31);

      module.exports = __webpack_require__(7).getIteratorMethod = function (it) {
        if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
      };
      /***/

    },
    /* 78 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // 25.4.1.5 NewPromiseCapability(C)

      var aFunction = __webpack_require__(51);

      function PromiseCapability(C) {
        var resolve, reject;
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      }

      module.exports.f = function (C) {
        return new PromiseCapability(C);
      };
      /***/

    },
    /* 79 */

    /***/
    function (module, exports) {
      exports.f = Object.getOwnPropertySymbols;
      /***/
    },
    /* 80 */

    /***/
    function (module, exports, __webpack_require__) {
      exports.f = __webpack_require__(9);
      /***/
    },
    /* 81 */

    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(8);

      var core = __webpack_require__(7);

      var LIBRARY = __webpack_require__(41);

      var wksExt = __webpack_require__(80);

      var defineProperty = __webpack_require__(16).f;

      module.exports = function (name) {
        var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
        if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
          value: wksExt.f(name)
        });
      };
      /***/

    },
    /* 82 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.omit = omit;
      exports.arraysEqual = arraysEqual;

      var isElementAnSFC = exports.isElementAnSFC = function isElementAnSFC(element) {
        var isNativeDOMElement = typeof element.type === 'string';

        if (isNativeDOMElement) {
          return false;
        }

        return !element.type.prototype.isReactComponent;
      };

      function omit(obj) {
        var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var result = {};
        Object.keys(obj).forEach(function (key) {
          if (attrs.indexOf(key) === -1) {
            result[key] = obj[key];
          }
        });
        return result;
      }

      function arraysEqual(a, b) {
        var sameObject = a === b;

        if (sameObject) {
          return true;
        }

        var notBothArrays = !Array.isArray(a) || !Array.isArray(b);
        var differentLengths = a.length !== b.length;

        if (notBothArrays || differentLengths) {
          return false;
        }

        return a.every(function (element, index) {
          return element === b[index];
        });
      }

      function memoizeString(fn) {
        var cache = {};
        return function (str) {
          if (!cache[str]) {
            cache[str] = fn(str);
          }

          return cache[str];
        };
      }

      var hyphenate = exports.hyphenate = memoizeString(function (str) {
        return str.replace(/([A-Z])/g, '-$1').toLowerCase();
      });
      /***/
    },
    /* 83 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSunday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSunday
       * @category Weekday Helpers
       * @summary Is the given date Sunday?
       *
       * @description
       * Is the given date Sunday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Sunday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 21 September 2014 Sunday?
       * var result = isSunday(new Date(2014, 8, 21))
       * //=> true
       */


      function isSunday(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getDay() === 0;
      }
      /***/

    },
    /* 84 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addHours;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(45);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_HOUR = 3600000;
      /**
       * @name addHours
       * @category Hour Helpers
       * @summary Add the specified number of hours to the given date.
       *
       * @description
       * Add the specified number of hours to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the hours added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 2 hours to 10 July 2014 23:00:00:
       * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
       * //=> Fri Jul 11 2014 01:00:00
       */

      function addHours(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a"
        /* default */
        ](dirtyDate, amount * MILLISECONDS_IN_HOUR);
      }
      /***/

    },
    /* 85 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addQuarters;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(44);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addQuarters
       * @category Quarter Helpers
       * @summary Add the specified number of year quarters to the given date.
       *
       * @description
       * Add the specified number of year quarters to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the quarters added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 1 quarter to 1 September 2014:
       * var result = addQuarters(new Date(2014, 8, 1), 1)
       * //=> Mon Dec 01 2014 00:00:00
       */


      function addQuarters(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        var months = amount * 3;
        return __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a"
        /* default */
        ](dirtyDate, months);
      }
      /***/

    },
    /* 86 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__ = __webpack_require__(26);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0); // Like `compareAsc` but uses local time not UTC, which is needed
      // for accurate equality comparisons of UTC timestamps that end up
      // having the same representation in local time, e.g. one hour before
      // DST ends vs. the instant that DST ends.


      function compareLocalAsc(dateLeft, dateRight) {
        var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

        if (diff < 0) {
          return -1;
        } else if (diff > 0) {
          return 1; // Return 0 if diff is 0; return NaN if diff is NaN
        } else {
          return diff;
        }
      }
      /**
       * @name differenceInDays
       * @category Day Helpers
       * @summary Get the number of full days between the given dates.
       *
       * @description
       * Get the number of full day periods between two dates. Fractional days are
       * truncated towards zero.
       *
       * One "full day" is the distance between a local time in one day to the same
       * local time on the next or previous day. A full day can sometimes be less than
       * or more than 24 hours if a daylight savings change happens between two dates.
       *
       * To ignore DST and only measure exact 24-hour periods, use this instead:
       * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
       *
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full days according to the local timezone
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full days are between
       * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
       * var result = differenceInDays(
       *   new Date(2012, 6, 2, 0, 0),
       *   new Date(2011, 6, 2, 23, 0)
       * )
       * //=> 365
       * // How many full days are between
       * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
       * var result = differenceInDays(
       *   new Date(2011, 6, 3, 0, 1),
       *   new Date(2011, 6, 2, 23, 59)
       * )
       * //=> 0
       * // How many full days are between
       * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
       * // Note: because local time is used, the
       * // result will always be 92 days, even in
       * // time zones where DST starts and the
       * // period has only 92*24-1 hours.
       * var result = differenceInDays(
       *   new Date(2020, 5, 1),
       *   new Date(2020, 2, 1)
       * )
      //=> 92
       */


      function differenceInDays(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var sign = compareLocalAsc(dateLeft, dateRight);
        var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarDays_index_js__["a"
        /* default */
        ](dateLeft, dateRight));
        dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
        // If so, result must be decreased by 1 in absolute value

        var isLastDayNotFull = compareLocalAsc(dateLeft, dateRight) === -sign;
        var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

        return result === 0 ? 0 : result;
      }
      /***/

    },
    /* 87 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfQuarter
       * @category Quarter Helpers
       * @summary Return the start of a year quarter for the given date.
       *
       * @description
       * Return the start of a year quarter for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a quarter
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a quarter for 2 September 2014 11:55:00:
       * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Jul 01 2014 00:00:00
       */


      function startOfQuarter(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var currentMonth = date.getMonth();
        var month = currentMonth - currentMonth % 3;
        date.setMonth(month, 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 88 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachWeekendOfInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__eachDayOfInterval_index_js__ = __webpack_require__(148);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isSunday_index_js__ = __webpack_require__(83);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__isWeekend_index_js__ = __webpack_require__(56);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachWeekendOfInterval
       * @category Interval Helpers
       * @summary List all the Saturdays and Sundays in the given date interval.
       *
       * @description
       * Get all the Saturdays and Sundays in the given date interval.
       *
       * @param {Interval} interval - the given interval. See [Interval]{@link docs/types/Interval}
       * @returns {Date[]} an array containing all the Saturdays and Sundays
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Lists all Saturdays and Sundays in the given date interval
       * var result = eachWeekendOfInterval({
       *   start: new Date(2018, 8, 17),
       *   end: new Date(2018, 8, 30)
       * })
       * //=> [
       * //   Sat Sep 22 2018 00:00:00,
       * //   Sun Sep 23 2018 00:00:00,
       * //   Sat Sep 29 2018 00:00:00,
       * //   Sun Sep 30 2018 00:00:00
       * // ]
       */


      function eachWeekendOfInterval(interval) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var dateInterval = __WEBPACK_IMPORTED_MODULE_0__eachDayOfInterval_index_js__["a"
        /* default */
        ](interval);

        var weekends = [];
        var index = 0;

        while (index < dateInterval.length) {
          var date = dateInterval[index++];

          if (__WEBPACK_IMPORTED_MODULE_2__isWeekend_index_js__["a"
          /* default */
          ](date)) {
            weekends.push(date);
            if (__WEBPACK_IMPORTED_MODULE_1__isSunday_index_js__["a"
            /* default */
            ](date)) index = index + 5;
          }
        }

        return weekends;
      }
      /***/

    },
    /* 89 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfMonth
       * @category Month Helpers
       * @summary Return the end of a month for the given date.
       *
       * @description
       * Return the end of a month for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a month for 2 September 2014 11:55:00:
       * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 30 2014 23:59:59.999
       */


      function endOfMonth(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var month = date.getMonth();
        date.setFullYear(date.getFullYear(), month + 1, 0);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    },
    /* 90 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfYear
       * @category Year Helpers
       * @summary Return the start of a year for the given date.
       *
       * @description
       * Return the start of a year for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a year for 2 September 2014 11:55:00:
       * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
       * //=> Wed Jan 01 2014 00:00:00
       */


      function startOfYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var cleanDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var date = new Date(0);
        date.setFullYear(cleanDate.getFullYear(), 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 91 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfDay
       * @category Day Helpers
       * @summary Return the end of a day for the given date.
       *
       * @description
       * Return the end of a day for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a day
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a day for 2 September 2014 11:55:00:
       * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 02 2014 23:59:59.999
       */


      function endOfDay(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    },
    /* 92 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(50);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function getUTCWeekYear(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate, dirtyOptions);

        var year = date.getUTCFullYear();
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
          throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        }

        var firstWeekOfNextYear = new Date(0);
        firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
        firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);

        var startOfNextYear = __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a"
        /* default */
        ](firstWeekOfNextYear, dirtyOptions);

        var firstWeekOfThisYear = new Date(0);
        firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);

        var startOfThisYear = __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a"
        /* default */
        ](firstWeekOfThisYear, dirtyOptions);

        if (date.getTime() >= startOfNextYear.getTime()) {
          return year + 1;
        } else if (date.getTime() >= startOfThisYear.getTime()) {
          return year;
        } else {
          return year - 1;
        }
      }
      /***/

    },
    /* 93 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getWeekYear_index_js__ = __webpack_require__(170);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__ = __webpack_require__(22);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfWeekYear
       * @category Week-Numbering Year Helpers
       * @summary Return the start of a local week-numbering year for the given date.
       *
       * @description
       * Return the start of a local week-numbering year.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Date} the start of a week-numbering year
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // The start of an a week-numbering year for 2 July 2005 with default settings:
       * var result = startOfWeekYear(new Date(2005, 6, 2))
       * //=> Sun Dec 26 2004 00:00:00
       *
       * @example
       * // The start of a week-numbering year for 2 July 2005
       * // if Monday is the first day of week
       * // and 4 January is always in the first week of the year:
       * var result = startOfWeekYear(new Date(2005, 6, 2), {
       *   weekStartsOn: 1,
       *   firstWeekContainsDate: 4
       * })
       * //=> Mon Jan 03 2005 00:00:00
       */


      function startOfWeekYear(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](options.firstWeekContainsDate);

        var year = __WEBPACK_IMPORTED_MODULE_0__getWeekYear_index_js__["a"
        /* default */
        ](dirtyDate, dirtyOptions);

        var firstWeek = new Date(0);
        firstWeek.setFullYear(year, 0, firstWeekContainsDate);
        firstWeek.setHours(0, 0, 0, 0);

        var date = __WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__["a"
        /* default */
        ](firstWeek, dirtyOptions);

        return date;
      }
      /***/

    },
    /* 94 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subDays
       * @category Day Helpers
       * @summary Subtract the specified number of days from the given date.
       *
       * @description
       * Subtract the specified number of days from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the days subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 10 days from 1 September 2014:
       * var result = subDays(new Date(2014, 8, 1), 10)
       * //=> Fri Aug 22 2014 00:00:00
       */


      function subDays(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 95 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(22);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameWeek
       * @category Week Helpers
       * @summary Are the given dates in the same week?
       *
       * @description
       * Are the given dates in the same week?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Boolean} the dates are in the same week
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // Are 31 August 2014 and 4 September 2014 in the same week?
       * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4))
       * //=> true
       *
       * @example
       * // If week starts with Monday,
       * // are 31 August 2014 and 4 September 2014 in the same week?
       * var result = isSameWeek(new Date(2014, 7, 31), new Date(2014, 8, 4), {
       *   weekStartsOn: 1
       * })
       * //=> false
       */


      function isSameWeek(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeftStartOfWeek = __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ](dirtyDateLeft, dirtyOptions);

        var dateRightStartOfWeek = __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ](dirtyDateRight, dirtyOptions);

        return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
      }
      /***/

    },
    /* 96 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__ = __webpack_require__(164);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setMonth
       * @category Month Helpers
       * @summary Set the month to the given date.
       *
       * @description
       * Set the month to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} month - the month of the new date
       * @returns {Date} the new date with the month set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set February to 1 September 2014:
       * var result = setMonth(new Date(2014, 8, 1), 1)
       * //=> Sat Feb 01 2014 00:00:00
       */


      function setMonth(dirtyDate, dirtyMonth) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var month = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyMonth);

        var year = date.getFullYear();
        var day = date.getDate();
        var dateWithDesiredMonth = new Date(0);
        dateWithDesiredMonth.setFullYear(year, month, 15);
        dateWithDesiredMonth.setHours(0, 0, 0, 0);

        var daysInMonth = __WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__["a"
        /* default */
        ](dateWithDesiredMonth); // Set the last day of the new month
        // if the original date was the last day of the longer month


        date.setMonth(month, Math.min(day, daysInMonth));
        return date;
      }
      /***/

    },
    /* 97 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var numberValues = {
        locale: {
          '1': '१',
          '2': '२',
          '3': '३',
          '4': '४',
          '5': '५',
          '6': '६',
          '7': '७',
          '8': '८',
          '9': '९',
          '0': '०'
        },
        number: {
          '१': '1',
          '२': '2',
          '३': '3',
          '४': '4',
          '५': '5',
          '६': '6',
          '७': '7',
          '८': '8',
          '९': '9',
          '०': '0'
        } // CLDR #1585 - #1592

      };
      var eraValues = {
        narrow: ['ईसा-पूर्व', 'ईस्वी'],
        abbreviated: ['ईसा-पूर्व', 'ईस्वी'],
        wide: ['ईसा-पूर्व', 'ईसवी सन'] // CLDR #1593 - #1616

      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['ति1', 'ति2', 'ति3', 'ति4'],
        wide: ['पहली तिमाही', 'दूसरी तिमाही', 'तीसरी तिमाही', 'चौथी तिमाही'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.
        // https://www.unicode.org/cldr/charts/32/summary/hi.html
        // CLDR #1617 - #1688

      };
      var monthValues = {
        narrow: ['ज', 'फ़', 'मा', 'अ', 'मई', 'जू', 'जु', 'अग', 'सि', 'अक्तू', 'न', 'दि'],
        abbreviated: ['जन', 'फ़र', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुल', 'अग', 'सित', 'अक्तू', 'नव', 'दिस'],
        wide: ['जनवरी', 'फ़रवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्तूबर', 'नवंबर', 'दिसंबर'] // CLDR #1689 - #1744

      };
      var dayValues = {
        narrow: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
        short: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
        abbreviated: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
        wide: ['रविवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'पूर्वाह्न',
          pm: 'अपराह्न',
          midnight: 'मध्यरात्रि',
          noon: 'दोपहर',
          morning: 'सुबह',
          afternoon: 'दोपहर',
          evening: 'शाम',
          night: 'रात'
        },
        abbreviated: {
          am: 'पूर्वाह्न',
          pm: 'अपराह्न',
          midnight: 'मध्यरात्रि',
          noon: 'दोपहर',
          morning: 'सुबह',
          afternoon: 'दोपहर',
          evening: 'शाम',
          night: 'रात'
        },
        wide: {
          am: 'पूर्वाह्न',
          pm: 'अपराह्न',
          midnight: 'मध्यरात्रि',
          noon: 'दोपहर',
          morning: 'सुबह',
          afternoon: 'दोपहर',
          evening: 'शाम',
          night: 'रात'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'पूर्वाह्न',
          pm: 'अपराह्न',
          midnight: 'मध्यरात्रि',
          noon: 'दोपहर',
          morning: 'सुबह',
          afternoon: 'दोपहर',
          evening: 'शाम',
          night: 'रात'
        },
        abbreviated: {
          am: 'पूर्वाह्न',
          pm: 'अपराह्न',
          midnight: 'मध्यरात्रि',
          noon: 'दोपहर',
          morning: 'सुबह',
          afternoon: 'दोपहर',
          evening: 'शाम',
          night: 'रात'
        },
        wide: {
          am: 'पूर्वाह्न',
          pm: 'अपराह्न',
          midnight: 'मध्यरात्रि',
          noon: 'दोपहर',
          morning: 'सुबह',
          afternoon: 'दोपहर',
          evening: 'शाम',
          night: 'रात'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = localize.localeToNumber(dirtyNumber);
        var localeNumber = localize.numberToLocale(number);
        var rem10 = number % 10;

        switch (rem10) {
          case 2:
          case 3:
          case 4:
          case 6:
          case 1:
          case 5:
          case 7:
          case 8:
          case 9:
          case 0:
            return localeNumber;
        }
      }

      function localeToNumber(locale) {
        var number = locale.toString().replace(/[१२३४५६७८९०]/g, function (match) {
          return numberValues.number[match];
        });
        return Number(number);
      }

      function numberToLocale(number) {
        return number.toString().replace(/\d/g, function (match) {
          return numberValues.locale[match];
        });
      }

      var localize = {
        localeToNumber: localeToNumber,
        numberToLocale: numberToLocale,
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 98 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = !__webpack_require__(17) && !__webpack_require__(30)(function () {
        return Object.defineProperty(__webpack_require__(66)('div'), 'a', {
          get: function get() {
            return 7;
          }
        }).a != 7;
      });
      /***/
    },
    /* 99 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (process) {
        if (process.env.NODE_ENV === 'production') {
          module.exports = __webpack_require__(196);
        } else {
          module.exports = __webpack_require__(197);
        }
        /* WEBPACK VAR INJECTION */

      }).call(exports, __webpack_require__(18));
      /***/
    },
    /* 100 */

    /***/
    function (module, exports) {
      /***/
    },
    /* 101 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var LIBRARY = __webpack_require__(41);

      var $export = __webpack_require__(11);

      var redefine = __webpack_require__(102);

      var hide = __webpack_require__(23);

      var Iterators = __webpack_require__(31);

      var $iterCreate = __webpack_require__(211);

      var setToStringTag = __webpack_require__(53);

      var getPrototypeOf = __webpack_require__(106);

      var ITERATOR = __webpack_require__(9)('iterator');

      var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

      var FF_ITERATOR = '@@iterator';
      var KEYS = 'keys';
      var VALUES = 'values';

      var returnThis = function returnThis() {
        return this;
      };

      module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
        $iterCreate(Constructor, NAME, next);

        var getMethod = function getMethod(kind) {
          if (!BUGGY && kind in proto) return proto[kind];

          switch (kind) {
            case KEYS:
              return function keys() {
                return new Constructor(this, kind);
              };

            case VALUES:
              return function values() {
                return new Constructor(this, kind);
              };
          }

          return function entries() {
            return new Constructor(this, kind);
          };
        };

        var TAG = NAME + ' Iterator';
        var DEF_VALUES = DEFAULT == VALUES;
        var VALUES_BUG = false;
        var proto = Base.prototype;
        var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
        var $default = $native || getMethod(DEFAULT);
        var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
        var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
        var methods, key, IteratorPrototype; // Fix native

        if ($anyNative) {
          IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

          if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

            if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
          }
        } // fix Array#{values, @@iterator}.name in V8 / FF


        if (DEF_VALUES && $native && $native.name !== VALUES) {
          VALUES_BUG = true;

          $default = function values() {
            return $native.call(this);
          };
        } // Define iterator


        if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
          hide(proto, ITERATOR, $default);
        } // Plug for library


        Iterators[NAME] = $default;
        Iterators[TAG] = returnThis;

        if (DEFAULT) {
          methods = {
            values: DEF_VALUES ? $default : getMethod(VALUES),
            keys: IS_SET ? $default : getMethod(KEYS),
            entries: $entries
          };
          if (FORCED) for (key in methods) {
            if (!(key in proto)) redefine(proto, key, methods[key]);
          } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
        }

        return methods;
      };
      /***/

    },
    /* 102 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(23);
      /***/
    },
    /* 103 */

    /***/
    function (module, exports, __webpack_require__) {
      var has = __webpack_require__(24);

      var toIObject = __webpack_require__(32);

      var arrayIndexOf = __webpack_require__(213)(false);

      var IE_PROTO = __webpack_require__(73)('IE_PROTO');

      module.exports = function (object, names) {
        var O = toIObject(object);
        var i = 0;
        var result = [];
        var key;

        for (key in O) {
          if (key != IE_PROTO) has(O, key) && result.push(key);
        } // Don't enum bug & hidden keys


        while (names.length > i) {
          if (has(O, key = names[i++])) {
            ~arrayIndexOf(result, key) || result.push(key);
          }
        }

        return result;
      };
      /***/

    },
    /* 104 */

    /***/
    function (module, exports, __webpack_require__) {
      // fallback for non-array-like ES3 and non-enumerable old V8 strings
      var cof = __webpack_require__(43); // eslint-disable-next-line no-prototype-builtins


      module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
        return cof(it) == 'String' ? it.split('') : Object(it);
      };
      /***/
    },
    /* 105 */

    /***/
    function (module, exports, __webpack_require__) {
      var document = __webpack_require__(8).document;

      module.exports = document && document.documentElement;
      /***/
    },
    /* 106 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
      var has = __webpack_require__(24);

      var toObject = __webpack_require__(33);

      var IE_PROTO = __webpack_require__(73)('IE_PROTO');

      var ObjectProto = Object.prototype;

      module.exports = Object.getPrototypeOf || function (O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];

        if (typeof O.constructor == 'function' && O instanceof O.constructor) {
          return O.constructor.prototype;
        }

        return O instanceof Object ? ObjectProto : null;
      };
      /***/

    },
    /* 107 */

    /***/
    function (module, exports, __webpack_require__) {
      // call something on iterator step with safe closing on error
      var anObject = __webpack_require__(14);

      module.exports = function (iterator, fn, value, entries) {
        try {
          return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
        } catch (e) {
          var ret = iterator['return'];
          if (ret !== undefined) anObject(ret.call(iterator));
          throw e;
        }
      };
      /***/

    },
    /* 108 */

    /***/
    function (module, exports, __webpack_require__) {
      // check on default Array iterator
      var Iterators = __webpack_require__(31);

      var ITERATOR = __webpack_require__(9)('iterator');

      var ArrayProto = Array.prototype;

      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
      };
      /***/

    },
    /* 109 */

    /***/
    function (module, exports, __webpack_require__) {
      // 7.3.20 SpeciesConstructor(O, defaultConstructor)
      var anObject = __webpack_require__(14);

      var aFunction = __webpack_require__(51);

      var SPECIES = __webpack_require__(9)('species');

      module.exports = function (O, D) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
      };
      /***/

    },
    /* 110 */

    /***/
    function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(29);

      var invoke = __webpack_require__(221);

      var html = __webpack_require__(105);

      var cel = __webpack_require__(66);

      var global = __webpack_require__(8);

      var process = global.process;
      var setTask = global.setImmediate;
      var clearTask = global.clearImmediate;
      var MessageChannel = global.MessageChannel;
      var Dispatch = global.Dispatch;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = 'onreadystatechange';
      var defer, channel, port;

      var run = function run() {
        var id = +this; // eslint-disable-next-line no-prototype-builtins

        if (queue.hasOwnProperty(id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };

      var listener = function listener(event) {
        run.call(event.data);
      }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


      if (!setTask || !clearTask) {
        setTask = function setImmediate(fn) {
          var args = [];
          var i = 1;

          while (arguments.length > i) {
            args.push(arguments[i++]);
          }

          queue[++counter] = function () {
            // eslint-disable-next-line no-new-func
            invoke(typeof fn == 'function' ? fn : Function(fn), args);
          };

          defer(counter);
          return counter;
        };

        clearTask = function clearImmediate(id) {
          delete queue[id];
        }; // Node.js 0.8-


        if (__webpack_require__(43)(process) == 'process') {
          defer = function defer(id) {
            process.nextTick(ctx(run, id, 1));
          }; // Sphere (JS game engine) Dispatch API

        } else if (Dispatch && Dispatch.now) {
          defer = function defer(id) {
            Dispatch.now(ctx(run, id, 1));
          }; // Browsers with MessageChannel, includes WebWorkers

        } else if (MessageChannel) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
          // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
        } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
          defer = function defer(id) {
            global.postMessage(id + '', '*');
          };

          global.addEventListener('message', listener, false); // IE8-
        } else if (ONREADYSTATECHANGE in cel('script')) {
          defer = function defer(id) {
            html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this);
              run.call(id);
            };
          }; // Rest old browsers

        } else {
          defer = function defer(id) {
            setTimeout(ctx(run, id, 1), 0);
          };
        }
      }

      module.exports = {
        set: setTask,
        clear: clearTask
      };
      /***/
    },
    /* 111 */

    /***/
    function (module, exports) {
      module.exports = function (exec) {
        try {
          return {
            e: false,
            v: exec()
          };
        } catch (e) {
          return {
            e: true,
            v: e
          };
        }
      };
      /***/

    },
    /* 112 */

    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(14);

      var isObject = __webpack_require__(20);

      var newPromiseCapability = __webpack_require__(78);

      module.exports = function (C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };
      /***/

    },
    /* 113 */

    /***/
    function (module, exports, __webpack_require__) {
      var ITERATOR = __webpack_require__(9)('iterator');

      var SAFE_CLOSING = false;

      try {
        var riter = [7][ITERATOR]();

        riter['return'] = function () {
          SAFE_CLOSING = true;
        }; // eslint-disable-next-line no-throw-literal


        Array.from(riter, function () {
          throw 2;
        });
      } catch (e) {
        /* empty */
      }

      module.exports = function (exec, skipClosing) {
        if (!skipClosing && !SAFE_CLOSING) return false;
        var safe = false;

        try {
          var arr = [7];
          var iter = arr[ITERATOR]();

          iter.next = function () {
            return {
              done: safe = true
            };
          };

          arr[ITERATOR] = function () {
            return iter;
          };

          exec(arr);
        } catch (e) {
          /* empty */
        }

        return safe;
      };
      /***/

    },
    /* 114 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(232),
        __esModule: true
      };
      /***/
    },
    /* 115 */

    /***/
    function (module, exports, __webpack_require__) {
      // most Object methods by ES6 should accept primitives
      var $export = __webpack_require__(11);

      var core = __webpack_require__(7);

      var fails = __webpack_require__(30);

      module.exports = function (KEY, exec) {
        var fn = (core.Object || {})[KEY] || Object[KEY];
        var exp = {};
        exp[KEY] = exec(fn);
        $export($export.S + $export.F * fails(function () {
          fn(1);
        }), 'Object', exp);
      };
      /***/

    },
    /* 116 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _typeof2 = __webpack_require__(117);

      var _typeof3 = _interopRequireDefault(_typeof2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
      };
      /***/

    },
    /* 117 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _iterator = __webpack_require__(234);

      var _iterator2 = _interopRequireDefault(_iterator);

      var _symbol = __webpack_require__(236);

      var _symbol2 = _interopRequireDefault(_symbol);

      var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
        return typeof obj;
      } : function (obj) {
        return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
      };

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
        return typeof obj === "undefined" ? "undefined" : _typeof(obj);
      } : function (obj) {
        return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
      };
      /***/
    },
    /* 118 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
      var $keys = __webpack_require__(103);

      var hiddenKeys = __webpack_require__(75).concat('length', 'prototype');

      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return $keys(O, hiddenKeys);
      };
      /***/

    },
    /* 119 */

    /***/
    function (module, exports, __webpack_require__) {
      var pIE = __webpack_require__(55);

      var createDesc = __webpack_require__(39);

      var toIObject = __webpack_require__(32);

      var toPrimitive = __webpack_require__(67);

      var has = __webpack_require__(24);

      var IE8_DOM_DEFINE = __webpack_require__(98);

      var gOPD = Object.getOwnPropertyDescriptor;
      exports.f = __webpack_require__(17) ? gOPD : function getOwnPropertyDescriptor(O, P) {
        O = toIObject(O);
        P = toPrimitive(P, true);
        if (IE8_DOM_DEFINE) try {
          return gOPD(O, P);
        } catch (e) {
          /* empty */
        }
        if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
      };
      /***/
    },
    /* 120 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _setPrototypeOf = __webpack_require__(245);

      var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

      var _create = __webpack_require__(249);

      var _create2 = _interopRequireDefault(_create);

      var _typeof2 = __webpack_require__(117);

      var _typeof3 = _interopRequireDefault(_typeof2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
        }

        subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
      };
      /***/

    },
    /* 121 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.hasClassInParent = exports.formatErrorMsg = exports.getMetaContent = exports.axiosGithub = exports.axiosJSON = exports.queryStringify = exports.queryParse = undefined;

      var _keys = __webpack_require__(272);

      var _keys2 = _interopRequireDefault(_keys);

      var _slicedToArray2 = __webpack_require__(275);

      var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

      var _axios = __webpack_require__(282);

      var _axios2 = _interopRequireDefault(_axios);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var queryParse = exports.queryParse = function queryParse() {
        var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
        if (!search) return {};
        var queryString = search[0] === '?' ? search.substring(1) : search;
        var query = {};
        queryString.split('&').forEach(function (queryStr) {
          var _queryStr$split = queryStr.split('='),
              _queryStr$split2 = (0, _slicedToArray3.default)(_queryStr$split, 2),
              key = _queryStr$split2[0],
              value = _queryStr$split2[1];
          /* istanbul ignore else */


          if (key) query[decodeURIComponent(key)] = decodeURIComponent(value);
        });
        return query;
      };

      var queryStringify = exports.queryStringify = function queryStringify(query) {
        var queryString = (0, _keys2.default)(query).map(function (key) {
          return key + '=' + encodeURIComponent(query[key] || '');
        }).join('&');
        return queryString;
      };

      var axiosJSON = exports.axiosJSON = _axios2.default.create({
        headers: {
          'Accept': 'application/json'
        }
      });

      var axiosGithub = exports.axiosGithub = _axios2.default.create({
        baseURL: 'https://api.github.com',
        headers: {
          'Accept': 'application/json'
        }
      });

      var getMetaContent = exports.getMetaContent = function getMetaContent(name, content) {
        /* istanbul ignore next */
        content || (content = 'content');
        /* istanbul ignore next */

        var el = window.document.querySelector('meta[name=\'' + name + '\']');
        /* istanbul ignore next */

        return el && el.getAttribute(content);
      };

      var formatErrorMsg = exports.formatErrorMsg = function formatErrorMsg(err) {
        var msg = 'Error: ';

        if (err.response && err.response.data && err.response.data.message) {
          msg += err.response.data.message + '. ';
          err.response.data.errors && (msg += err.response.data.errors.map(function (e) {
            return e.message;
          }).join(', '));
        } else {
          msg += err.message;
        }

        return msg;
      };

      var hasClassInParent = exports.hasClassInParent = function hasClassInParent(element) {
        for (var _len = arguments.length, className = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          className[_key - 1] = arguments[_key];
        }
        /* istanbul ignore next */


        var yes = false;
        /* istanbul ignore next */

        if (typeof element.className === 'undefined') return false;
        /* istanbul ignore next */

        var classes = element.className.split(' ');
        /* istanbul ignore next */

        className.forEach(function (c, i) {
          /* istanbul ignore next */
          yes = yes || classes.indexOf(c) >= 0;
        });
        /* istanbul ignore next */

        if (yes) return yes;
        /* istanbul ignore next */

        return element.parentNode && hasClassInParent(element.parentNode, className);
      };
      /***/

    },
    /* 122 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      module.exports = function bind(fn, thisArg) {
        return function wrap() {
          var args = new Array(arguments.length);

          for (var i = 0; i < args.length; i++) {
            args[i] = arguments[i];
          }

          return fn.apply(thisArg, args);
        };
      };
      /***/

    },
    /* 123 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);

      function encode(val) {
        return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
      }
      /**
       * Build a URL by appending params to the end
       *
       * @param {string} url The base of the url (e.g., http://www.google.com)
       * @param {object} [params] The params to be appended
       * @returns {string} The formatted url
       */


      module.exports = function buildURL(url, params, paramsSerializer) {
        /*eslint no-param-reassign:0*/
        if (!params) {
          return url;
        }

        var serializedParams;

        if (paramsSerializer) {
          serializedParams = paramsSerializer(params);
        } else if (utils.isURLSearchParams(params)) {
          serializedParams = params.toString();
        } else {
          var parts = [];
          utils.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') {
              return;
            }

            if (utils.isArray(val)) {
              key = key + '[]';
            } else {
              val = [val];
            }

            utils.forEach(val, function parseValue(v) {
              if (utils.isDate(v)) {
                v = v.toISOString();
              } else if (utils.isObject(v)) {
                v = JSON.stringify(v);
              }

              parts.push(encode(key) + '=' + encode(v));
            });
          });
          serializedParams = parts.join('&');
        }

        if (serializedParams) {
          var hashmarkIndex = url.indexOf('#');

          if (hashmarkIndex !== -1) {
            url = url.slice(0, hashmarkIndex);
          }

          url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
        }

        return url;
      };
      /***/

    },
    /* 124 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      module.exports = function isCancel(value) {
        return !!(value && value.__CANCEL__);
      };
      /***/

    },
    /* 125 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (process) {
        var utils = __webpack_require__(10);

        var normalizeHeaderName = __webpack_require__(288);

        var DEFAULT_CONTENT_TYPE = {
          'Content-Type': 'application/x-www-form-urlencoded'
        };

        function setContentTypeIfUnset(headers, value) {
          if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
            headers['Content-Type'] = value;
          }
        }

        function getDefaultAdapter() {
          var adapter;

          if (typeof XMLHttpRequest !== 'undefined') {
            // For browsers use XHR adapter
            adapter = __webpack_require__(126);
          } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
            // For node use HTTP adapter
            adapter = __webpack_require__(126);
          }

          return adapter;
        }

        var defaults = {
          adapter: getDefaultAdapter(),
          transformRequest: [function transformRequest(data, headers) {
            normalizeHeaderName(headers, 'Accept');
            normalizeHeaderName(headers, 'Content-Type');

            if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
              return data;
            }

            if (utils.isArrayBufferView(data)) {
              return data.buffer;
            }

            if (utils.isURLSearchParams(data)) {
              setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
              return data.toString();
            }

            if (utils.isObject(data)) {
              setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
              return JSON.stringify(data);
            }

            return data;
          }],
          transformResponse: [function transformResponse(data) {
            /*eslint no-param-reassign:0*/
            if (typeof data === 'string') {
              try {
                data = JSON.parse(data);
              } catch (e) {
                /* Ignore */
              }
            }

            return data;
          }],

          /**
           * A timeout in milliseconds to abort a request. If set to 0 (default) a
           * timeout is not created.
           */
          timeout: 0,
          xsrfCookieName: 'XSRF-TOKEN',
          xsrfHeaderName: 'X-XSRF-TOKEN',
          maxContentLength: -1,
          validateStatus: function validateStatus(status) {
            return status >= 200 && status < 300;
          }
        };
        defaults.headers = {
          common: {
            'Accept': 'application/json, text/plain, */*'
          }
        };
        utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
          defaults.headers[method] = {};
        });
        utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
          defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
        });
        module.exports = defaults;
        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(18));
      /***/
    },
    /* 126 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);

      var settle = __webpack_require__(289);

      var buildURL = __webpack_require__(123);

      var buildFullPath = __webpack_require__(291);

      var parseHeaders = __webpack_require__(294);

      var isURLSameOrigin = __webpack_require__(295);

      var createError = __webpack_require__(127);

      module.exports = function xhrAdapter(config) {
        return new Promise(function dispatchXhrRequest(resolve, reject) {
          var requestData = config.data;
          var requestHeaders = config.headers;

          if (utils.isFormData(requestData)) {
            delete requestHeaders['Content-Type']; // Let the browser set it
          }

          var request = new XMLHttpRequest(); // HTTP basic authentication

          if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password || '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
          }

          var fullPath = buildFullPath(config.baseURL, config.url);
          request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true); // Set the request timeout in MS

          request.timeout = config.timeout; // Listen for ready state

          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            } // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request


            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
              return;
            } // Prepare the response


            var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
              data: responseData,
              status: request.status,
              statusText: request.statusText,
              headers: responseHeaders,
              config: config,
              request: request
            };
            settle(resolve, reject, response); // Clean up request

            request = null;
          }; // Handle browser request cancellation (as opposed to a manual cancellation)


          request.onabort = function handleAbort() {
            if (!request) {
              return;
            }

            reject(createError('Request aborted', config, 'ECONNABORTED', request)); // Clean up request

            request = null;
          }; // Handle low level network errors


          request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(createError('Network Error', config, null, request)); // Clean up request

            request = null;
          }; // Handle timeout


          request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';

            if (config.timeoutErrorMessage) {
              timeoutErrorMessage = config.timeoutErrorMessage;
            }

            reject(createError(timeoutErrorMessage, config, 'ECONNABORTED', request)); // Clean up request

            request = null;
          }; // Add xsrf header
          // This is only done if running in a standard browser environment.
          // Specifically not if we're in a web worker, or react-native.


          if (utils.isStandardBrowserEnv()) {
            var cookies = __webpack_require__(296); // Add xsrf header


            var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

            if (xsrfValue) {
              requestHeaders[config.xsrfHeaderName] = xsrfValue;
            }
          } // Add headers to the request


          if ('setRequestHeader' in request) {
            utils.forEach(requestHeaders, function setRequestHeader(val, key) {
              if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
                // Remove Content-Type if data is undefined
                delete requestHeaders[key];
              } else {
                // Otherwise add header to the request
                request.setRequestHeader(key, val);
              }
            });
          } // Add withCredentials to request if needed


          if (!utils.isUndefined(config.withCredentials)) {
            request.withCredentials = !!config.withCredentials;
          } // Add responseType to request if needed


          if (config.responseType) {
            try {
              request.responseType = config.responseType;
            } catch (e) {
              // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
              // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
              if (config.responseType !== 'json') {
                throw e;
              }
            }
          } // Handle progress if needed


          if (typeof config.onDownloadProgress === 'function') {
            request.addEventListener('progress', config.onDownloadProgress);
          } // Not all browsers support upload events


          if (typeof config.onUploadProgress === 'function' && request.upload) {
            request.upload.addEventListener('progress', config.onUploadProgress);
          }

          if (config.cancelToken) {
            // Handle cancellation
            config.cancelToken.promise.then(function onCanceled(cancel) {
              if (!request) {
                return;
              }

              request.abort();
              reject(cancel); // Clean up request

              request = null;
            });
          }

          if (requestData === undefined) {
            requestData = null;
          } // Send the request


          request.send(requestData);
        });
      };
      /***/

    },
    /* 127 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var enhanceError = __webpack_require__(290);
      /**
       * Create an Error with the specified message, config, error code, request and response.
       *
       * @param {string} message The error message.
       * @param {Object} config The config.
       * @param {string} [code] The error code (for example, 'ECONNABORTED').
       * @param {Object} [request] The request.
       * @param {Object} [response] The response.
       * @returns {Error} The created error.
       */


      module.exports = function createError(message, config, code, request, response) {
        var error = new Error(message);
        return enhanceError(error, config, code, request, response);
      };
      /***/

    },
    /* 128 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);
      /**
       * Config-specific merge-function which creates a new config-object
       * by merging two configuration objects together.
       *
       * @param {Object} config1
       * @param {Object} config2
       * @returns {Object} New object resulting from merging config2 to config1
       */


      module.exports = function mergeConfig(config1, config2) {
        // eslint-disable-next-line no-param-reassign
        config2 = config2 || {};
        var config = {};
        var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
        var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
        var defaultToConfig2Keys = ['baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer', 'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName', 'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent', 'httpsAgent', 'cancelToken', 'socketPath'];
        utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
          if (typeof config2[prop] !== 'undefined') {
            config[prop] = config2[prop];
          }
        });
        utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
          if (utils.isObject(config2[prop])) {
            config[prop] = utils.deepMerge(config1[prop], config2[prop]);
          } else if (typeof config2[prop] !== 'undefined') {
            config[prop] = config2[prop];
          } else if (utils.isObject(config1[prop])) {
            config[prop] = utils.deepMerge(config1[prop]);
          } else if (typeof config1[prop] !== 'undefined') {
            config[prop] = config1[prop];
          }
        });
        utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
          if (typeof config2[prop] !== 'undefined') {
            config[prop] = config2[prop];
          } else if (typeof config1[prop] !== 'undefined') {
            config[prop] = config1[prop];
          }
        });
        var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
        var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
          return axiosKeys.indexOf(key) === -1;
        });
        utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
          if (typeof config2[prop] !== 'undefined') {
            config[prop] = config2[prop];
          } else if (typeof config1[prop] !== 'undefined') {
            config[prop] = config1[prop];
          }
        });
        return config;
      };
      /***/

    },
    /* 129 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * A `Cancel` is an object that is thrown when an operation is canceled.
       *
       * @class
       * @param {string=} message The message.
       */

      function Cancel(message) {
        this.message = message;
      }

      Cancel.prototype.toString = function toString() {
        return 'Cancel' + (this.message ? ': ' + this.message : '');
      };

      Cancel.prototype.__CANCEL__ = true;
      module.exports = Cancel;
      /***/
    },
    /* 130 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _react = __webpack_require__(12);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (_ref) {
        var src = _ref.src,
            className = _ref.className,
            alt = _ref.alt,
            _ref$defaultSrc = _ref.defaultSrc,
            defaultSrc = _ref$defaultSrc === undefined ? '//cdn.jsdelivr.net/npm/gitalk@1/src/assets/icon/github.svg' : _ref$defaultSrc;
        return _react2.default.createElement('div', {
          className: 'gt-avatar ' + className
        }, _react2.default.createElement('img', {
          src: src || defaultSrc,
          alt: '@' + alt,
          onError: function onError(e) {
            e.target.src = defaultSrc;
          }
        }));
      };
      /***/

    },
    /* 131 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _react = __webpack_require__(12);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (_ref) {
        var className = _ref.className,
            text = _ref.text,
            name = _ref.name;
        return _react2.default.createElement("span", {
          className: "gt-ico " + className
        }, _react2.default.createElement("span", {
          className: "gt-svg",
          dangerouslySetInnerHTML: {
            __html: __webpack_require__(302)("./" + name + ".svg")
          }
        }), text && _react2.default.createElement("span", {
          className: "gt-ico-text"
        }, text));
      };
      /***/

    },
    /* 132 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addBusinessDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__ = __webpack_require__(56);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__isSunday_index_js__ = __webpack_require__(83);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__isSaturday_index_js__ = __webpack_require__(133);
      /**
       * @name addBusinessDays
       * @category Day Helpers
       * @summary Add the specified number of business days (mon - fri) to the given date.
       *
       * @description
       * Add the specified number of business days (mon - fri) to the given date, ignoring weekends.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of business days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the business days added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 10 business days to 1 September 2014:
       * var result = addBusinessDays(new Date(2014, 8, 1), 10)
       * //=> Mon Sep 15 2014 00:00:00 (skipped weekend days)
       */


      function addBusinessDays(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var startedOnWeekend = __WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__["a"
        /* default */
        ](date);

        var amount = __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        if (isNaN(amount)) return new Date(NaN);
        var hours = date.getHours();
        var sign = amount < 0 ? -1 : 1;

        var fullWeeks = __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](amount / 5);

        date.setDate(date.getDate() + fullWeeks * 7); // Get remaining days not part of a full week

        var restDays = Math.abs(amount % 5); // Loops over remaining days

        while (restDays > 0) {
          date.setDate(date.getDate() + sign);
          if (!__WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__["a"
          /* default */
          ](date)) restDays -= 1;
        } // If the date is a weekend day and we reduce a dividable of
        // 5 from it, we land on a weekend date.
        // To counter this, we add days accordingly to land on the next business day


        if (startedOnWeekend && __WEBPACK_IMPORTED_MODULE_0__isWeekend_index_js__["a"
        /* default */
        ](date) && amount !== 0) {
          // If we're reducing days, we want to add days until we land on a weekday
          // If we're adding days we want to reduce days until we land on a weekday
          if (__WEBPACK_IMPORTED_MODULE_5__isSaturday_index_js__["a"
          /* default */
          ](date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
          if (__WEBPACK_IMPORTED_MODULE_4__isSunday_index_js__["a"
          /* default */
          ](date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
        } // Restore hours to avoid DST lag


        date.setHours(hours);
        return date;
      }
      /***/

    },
    /* 133 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSaturday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSaturday
       * @category Weekday Helpers
       * @summary Is the given date Saturday?
       *
       * @description
       * Is the given date Saturday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Saturday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 27 September 2014 Saturday?
       * var result = isSaturday(new Date(2014, 8, 27))
       * //=> true
       */


      function isSaturday(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getDay() === 6;
      }
      /***/

    },
    /* 134 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addISOWeekYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__getISOWeekYear_index_js__ = __webpack_require__(34);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__setISOWeekYear_index_js__ = __webpack_require__(135);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addISOWeekYears
       * @category ISO Week-Numbering Year Helpers
       * @summary Add the specified number of ISO week-numbering years to the given date.
       *
       * @description
       * Add the specified number of ISO week-numbering years to the given date.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `addISOYears` to `addISOWeekYears`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of ISO week-numbering years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the ISO week-numbering years added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 5 ISO week-numbering years to 2 July 2010:
       * var result = addISOWeekYears(new Date(2010, 6, 2), 5)
       * //=> Fri Jun 26 2015 00:00:00
       */


      function addISOWeekYears(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_2__setISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDate, __WEBPACK_IMPORTED_MODULE_1__getISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDate) + amount);
      }
      /***/

    },
    /* 135 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__ = __webpack_require__(46);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__ = __webpack_require__(26);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Set the ISO week-numbering year to the given date.
       *
       * @description
       * Set the ISO week-numbering year to the given date,
       * saving the week number and the weekday number.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `setISOYear` to `setISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} isoWeekYear - the ISO week-numbering year of the new date
       * @returns {Date} the new date with the ISO week-numbering year set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set ISO week-numbering year 2007 to 29 December 2008:
       * var result = setISOWeekYear(new Date(2008, 11, 29), 2007)
       * //=> Mon Jan 01 2007 00:00:00
       */


      function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
        __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var isoWeekYear = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyISOWeekYear);

        var diff = __WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__["a"
        /* default */
        ](date, __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a"
        /* default */
        ](date));

        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
        fourthOfJanuary.setHours(0, 0, 0, 0);
        date = __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a"
        /* default */
        ](fourthOfJanuary);
        date.setDate(date.getDate() + diff);
        return date;
      }
      /***/

    },
    /* 136 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addMinutes;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(45);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_MINUTE = 60000;
      /**
       * @name addMinutes
       * @category Minute Helpers
       * @summary Add the specified number of minutes to the given date.
       *
       * @description
       * Add the specified number of minutes to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the minutes added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 30 minutes to 10 July 2014 12:00:00:
       * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
       * //=> Thu Jul 10 2014 12:30:00
       */

      function addMinutes(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a"
        /* default */
        ](dirtyDate, amount * MILLISECONDS_IN_MINUTE);
      }
      /***/

    },
    /* 137 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addSeconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(45);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addSeconds
       * @category Second Helpers
       * @summary Add the specified number of seconds to the given date.
       *
       * @description
       * Add the specified number of seconds to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the seconds added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 30 seconds to 10 July 2014 12:45:00:
       * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
       * //=> Thu Jul 10 2014 12:45:30
       */


      function addSeconds(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a"
        /* default */
        ](dirtyDate, amount * 1000);
      }
      /***/

    },
    /* 138 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = addYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(44);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name addYears
       * @category Year Helpers
       * @summary Add the specified number of years to the given date.
       *
       * @description
       * Add the specified number of years to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the years added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add 5 years to 1 September 2014:
       * var result = addYears(new Date(2014, 8, 1), 5)
       * //=> Sun Sep 01 2019 00:00:00
       */


      function addYears(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a"
        /* default */
        ](dirtyDate, amount * 12);
      }
      /***/

    },
    /* 139 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarISOWeekYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(34);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInCalendarISOWeekYears
       * @category ISO Week-Numbering Year Helpers
       * @summary Get the number of calendar ISO week-numbering years between the given dates.
       *
       * @description
       * Get the number of calendar ISO week-numbering years between the given dates.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `differenceInCalendarISOYears` to `differenceInCalendarISOWeekYears`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar ISO week-numbering years
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
       * var result = differenceInCalendarISOWeekYears(
       *   new Date(2012, 0, 1),
       *   new Date(2010, 0, 1)
       * )
       * //=> 2
       */


      function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDateLeft) - __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDateRight);
      }
      /***/

    },
    /* 140 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarMonths;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInCalendarMonths
       * @category Month Helpers
       * @summary Get the number of calendar months between the given dates.
       *
       * @description
       * Get the number of calendar months between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar months
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar months are between 31 January 2014 and 1 September 2014?
       * var result = differenceInCalendarMonths(
       *   new Date(2014, 8, 1),
       *   new Date(2014, 0, 31)
       * )
       * //=> 8
       */


      function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
        var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
        return yearDiff * 12 + monthDiff;
      }
      /***/

    },
    /* 141 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getQuarter
       * @category Quarter Helpers
       * @summary Get the year quarter of the given date.
       *
       * @description
       * Get the year quarter of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the quarter
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which quarter is 2 July 2014?
       * var result = getQuarter(new Date(2014, 6, 2))
       * //=> 3
       */


      function getQuarter(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var quarter = Math.floor(date.getMonth() / 3) + 1;
        return quarter;
      }
      /***/

    },
    /* 142 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarWeeks;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(22);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name differenceInCalendarWeeks
       * @category Week Helpers
       * @summary Get the number of calendar weeks between the given dates.
       *
       * @description
       * Get the number of calendar weeks between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Number} the number of calendar weeks
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
       * var result = differenceInCalendarWeeks(
       *   new Date(2014, 6, 20),
       *   new Date(2014, 6, 5)
       * )
       * //=> 3
       *
       * @example
       * // If the week starts on Monday,
       * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
       * var result = differenceInCalendarWeeks(
       *   new Date(2014, 6, 20),
       *   new Date(2014, 6, 5),
       *   { weekStartsOn: 1 }
       * )
       * //=> 2
       */

      function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var startOfWeekLeft = __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ](dirtyDateLeft, dirtyOptions);

        var startOfWeekRight = __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ](dirtyDateRight, dirtyOptions);

        var timestampLeft = startOfWeekLeft.getTime() - __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](startOfWeekLeft);

        var timestampRight = startOfWeekRight.getTime() - __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](startOfWeekRight); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)


        return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
      }
      /***/

    },
    /* 143 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInCalendarYears
       * @category Year Helpers
       * @summary Get the number of calendar years between the given dates.
       *
       * @description
       * Get the number of calendar years between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar years
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar years are between 31 December 2013 and 11 February 2015?
       * var result = differenceInCalendarYears(
       *   new Date(2015, 1, 11),
       *   new Date(2013, 11, 31)
       * )
       * //=> 2
       */


      function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeft.getFullYear() - dateRight.getFullYear();
      }
      /***/

    },
    /* 144 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInHours;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__ = __webpack_require__(59);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_HOUR = 3600000;
      /**
       * @name differenceInHours
       * @category Hour Helpers
       * @summary Get the number of hours between the given dates.
       *
       * @description
       * Get the number of hours between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of hours
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
       * var result = differenceInHours(
       *   new Date(2014, 6, 2, 19, 0),
       *   new Date(2014, 6, 2, 6, 50)
       * )
       * //=> 12
       */

      function differenceInHours(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var diff = __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__["a"
        /* default */
        ](dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR;
        return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
      }
      /***/

    },
    /* 145 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subISOWeekYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addISOWeekYears_index_js__ = __webpack_require__(134);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subISOWeekYears
       * @category ISO Week-Numbering Year Helpers
       * @summary Subtract the specified number of ISO week-numbering years from the given date.
       *
       * @description
       * Subtract the specified number of ISO week-numbering years from the given date.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `subISOYears` to `subISOWeekYears`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `setWeekYear`.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of ISO week-numbering years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the ISO week-numbering years subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 5 ISO week-numbering years from 1 September 2014:
       * var result = subISOWeekYears(new Date(2014, 8, 1), 5)
       * //=> Mon Aug 31 2009 00:00:00
       */


      function subISOWeekYears(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addISOWeekYears_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 146 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInMinutes;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__ = __webpack_require__(59);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_MINUTE = 60000;
      /**
       * @name differenceInMinutes
       * @category Minute Helpers
       * @summary Get the number of minutes between the given dates.
       *
       * @description
       * Get the signed number of full (rounded towards 0) minutes between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of minutes
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
       * var result = differenceInMinutes(
       *   new Date(2014, 6, 2, 12, 20, 0),
       *   new Date(2014, 6, 2, 12, 7, 59)
       * )
       * //=> 12
       *
       * @example
       * // How many minutes are from 10:01:59 to 10:00:00
       * var result = differenceInMinutes(
       *   new Date(2000, 0, 1, 10, 0, 0),
       *   new Date(2000, 0, 1, 10, 1, 59)
       * )
       * //=> -1
       */

      function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var diff = __WEBPACK_IMPORTED_MODULE_0__differenceInMilliseconds_index_js__["a"
        /* default */
        ](dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE;
        return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
      }
      /***/

    },
    /* 147 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarYears_index_js__ = __webpack_require__(143);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInYears
       * @category Year Helpers
       * @summary Get the number of full years between the given dates.
       *
       * @description
       * Get the number of full years between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full years
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full years are between 31 December 2013 and 11 February 2015?
       * var result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
       * //=> 1
       */


      function differenceInYears(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var sign = __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ](dateLeft, dateRight);

        var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarYears_index_js__["a"
        /* default */
        ](dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
        // with leap days

        dateLeft.setFullYear('1584');
        dateRight.setFullYear('1584'); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
        // If so, result must be decreased by 1 in absolute value

        var isLastYearNotFull = __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ](dateLeft, dateRight) === -sign;
        var result = sign * (difference - isLastYearNotFull); // Prevent negative zero

        return result === 0 ? 0 : result;
      }
      /***/

    },
    /* 148 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachDayOfInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachDayOfInterval
       * @category Interval Helpers
       * @summary Return the array of dates within the specified time interval.
       *
       * @description
       * Return the array of dates within the specified time interval.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `eachDay` to `eachDayOfInterval`.
       *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
       *
       *   ```
       *   2.1.3
       *   time interval
       *   part of the time axis limited by two instants
       *   ```
       *
       *   Also, this function now accepts an object with `start` and `end` properties
       *   instead of two arguments as an interval.
       *   This function now throws `RangeError` if the start of the interval is after its end
       *   or if any date in the interval is `Invalid Date`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
       *
       *   // v2.0.0 onward
       *
       *   eachDayOfInterval(
       *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
       *   )
       *   ```
       *
       * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
       * @param {Object} [options] - an object with options.
       * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
       * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.step` must be a number greater than 1
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each day between 6 October 2014 and 10 October 2014:
       * var result = eachDayOfInterval({
       *   start: new Date(2014, 9, 6),
       *   end: new Date(2014, 9, 10)
       * })
       * //=> [
       * //   Mon Oct 06 2014 00:00:00,
       * //   Tue Oct 07 2014 00:00:00,
       * //   Wed Oct 08 2014 00:00:00,
       * //   Thu Oct 09 2014 00:00:00,
       * //   Fri Oct 10 2014 00:00:00
       * // ]
       */


      function eachDayOfInterval(dirtyInterval, options) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var interval = dirtyInterval || {};

        var startDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](interval.start);

        var endDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](interval.end);

        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError('Invalid interval');
        }

        var dates = [];
        var currentDate = startDate;
        currentDate.setHours(0, 0, 0, 0);
        var step = options && 'step' in options ? Number(options.step) : 1;
        if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

        while (currentDate.getTime() <= endTime) {
          dates.push(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ](currentDate));
          currentDate.setDate(currentDate.getDate() + step);
          currentDate.setHours(0, 0, 0, 0);
        }

        return dates;
      }
      /***/

    },
    /* 149 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfYear
       * @category Year Helpers
       * @summary Return the end of a year for the given date.
       *
       * @description
       * Return the end of a year for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a year for 2 September 2014 11:55:00:
       * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
       * //=> Wed Dec 31 2014 23:59:59.999
       */


      function endOfYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        date.setFullYear(year + 1, 0, 0);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    },
    /* 150 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfWeek
       * @category Week Helpers
       * @summary Return the end of a week for the given date.
       *
       * @description
       * Return the end of a week for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date} the end of a week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // The end of a week for 2 September 2014 11:55:00:
       * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sat Sep 06 2014 23:59:59.999
       *
       * @example
       * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
       * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
       * //=> Sun Sep 07 2014 23:59:59.999
       */


      function endOfWeek(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ](localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ](options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        }

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = date.getDay();
        var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
        date.setDate(date.getDate() + diff);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    },
    /* 151 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = format;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isValid_index_js__ = __webpack_require__(15);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__ = __webpack_require__(28);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__ = __webpack_require__(49);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__ = __webpack_require__(340);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__ = __webpack_require__(156);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__ = __webpack_require__(157);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__ = __webpack_require__(0); // This RegExp consists of three parts separated by `|`:
      // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
      //   (one of the certain letters followed by `o`)
      // - (\w)\1* matches any sequences of the same letter
      // - '' matches two quote characters in a row
      // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
      //   except a single quote symbol, which ends the sequence.
      //   Two quote characters do not end the sequence.
      //   If there is no matching single quote
      //   then the sequence will continue until the end of the string.
      // - . matches any single character unmatched by previous parts of the RegExps


      var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
      // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

      var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      var escapedStringRegExp = /^'([^]*?)'?$/;
      var doubleQuoteRegExp = /''/g;
      var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
      /**
       * @name format
       * @category Common Helpers
       * @summary Format the date.
       *
       * @description
       * Return the formatted date string in the given format. The result may vary by locale.
       *
       * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
       * > See: https://git.io/fxCyr
       *
       * The characters wrapped between two single quotes characters (') are escaped.
       * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
       * (see the last example)
       *
       * Format of the string is based on Unicode Technical Standard #35:
       * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
       * with a few additions (see note 7 below the table).
       *
       * Accepted patterns:
       * | Unit                            | Pattern | Result examples                   | Notes |
       * |---------------------------------|---------|-----------------------------------|-------|
       * | Era                             | G..GGG  | AD, BC                            |       |
       * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
       * |                                 | GGGGG   | A, B                              |       |
       * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
       * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
       * |                                 | yy      | 44, 01, 00, 17                    | 5     |
       * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
       * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
       * |                                 | yyyyy   | ...                               | 3,5   |
       * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
       * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
       * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
       * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
       * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
       * |                                 | YYYYY   | ...                               | 3,5   |
       * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
       * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
       * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
       * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
       * |                                 | RRRRR   | ...                               | 3,5,7 |
       * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
       * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
       * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
       * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
       * |                                 | uuuuu   | ...                               | 3,5   |
       * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
       * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
       * |                                 | QQ      | 01, 02, 03, 04                    |       |
       * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
       * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
       * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
       * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
       * |                                 | qq      | 01, 02, 03, 04                    |       |
       * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
       * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
       * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
       * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
       * |                                 | MM      | 01, 02, ..., 12                   |       |
       * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
       * |                                 | MMMM    | January, February, ..., December  | 2     |
       * |                                 | MMMMM   | J, F, ..., D                      |       |
       * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
       * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
       * |                                 | LL      | 01, 02, ..., 12                   |       |
       * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
       * |                                 | LLLL    | January, February, ..., December  | 2     |
       * |                                 | LLLLL   | J, F, ..., D                      |       |
       * | Local week of year              | w       | 1, 2, ..., 53                     |       |
       * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
       * |                                 | ww      | 01, 02, ..., 53                   |       |
       * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
       * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
       * |                                 | II      | 01, 02, ..., 53                   | 7     |
       * | Day of month                    | d       | 1, 2, ..., 31                     |       |
       * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
       * |                                 | dd      | 01, 02, ..., 31                   |       |
       * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
       * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
       * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
       * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
       * |                                 | DDDD    | ...                               | 3     |
       * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
       * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
       * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
       * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
       * |                                 | ii      | 01, 02, ..., 07                   | 7     |
       * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
       * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
       * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
       * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
       * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
       * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
       * |                                 | ee      | 02, 03, ..., 01                   |       |
       * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
       * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
       * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
       * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
       * |                                 | cc      | 02, 03, ..., 01                   |       |
       * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
       * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
       * | AM, PM                          | a..aaa  | AM, PM                            |       |
       * |                                 | aaaa    | a.m., p.m.                        | 2     |
       * |                                 | aaaaa   | a, p                              |       |
       * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
       * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
       * |                                 | bbbbb   | a, p, n, mi                       |       |
       * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
       * |                                 | BBBB    | at night, in the morning, ...     | 2     |
       * |                                 | BBBBB   | at night, in the morning, ...     |       |
       * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
       * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
       * |                                 | hh      | 01, 02, ..., 11, 12               |       |
       * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
       * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
       * |                                 | HH      | 00, 01, 02, ..., 23               |       |
       * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
       * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
       * |                                 | KK      | 01, 02, ..., 11, 00               |       |
       * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
       * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
       * |                                 | kk      | 24, 01, 02, ..., 23               |       |
       * | Minute                          | m       | 0, 1, ..., 59                     |       |
       * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
       * |                                 | mm      | 00, 01, ..., 59                   |       |
       * | Second                          | s       | 0, 1, ..., 59                     |       |
       * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
       * |                                 | ss      | 00, 01, ..., 59                   |       |
       * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
       * |                                 | SS      | 00, 01, ..., 99                   |       |
       * |                                 | SSS     | 000, 0001, ..., 999               |       |
       * |                                 | SSSS    | ...                               | 3     |
       * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
       * |                                 | XX      | -0800, +0530, Z                   |       |
       * |                                 | XXX     | -08:00, +05:30, Z                 |       |
       * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
       * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
       * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
       * |                                 | xx      | -0800, +0530, +0000               |       |
       * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
       * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
       * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
       * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
       * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
       * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
       * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
       * | Seconds timestamp               | t       | 512969520                         | 7     |
       * |                                 | tt      | ...                               | 3,7   |
       * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
       * |                                 | TT      | ...                               | 3,7   |
       * | Long localized date             | P       | 05/29/1453                        | 7     |
       * |                                 | PP      | May 29, 1453                      | 7     |
       * |                                 | PPP     | May 29th, 1453                    | 7     |
       * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
       * | Long localized time             | p       | 12:00 AM                          | 7     |
       * |                                 | pp      | 12:00:00 AM                       | 7     |
       * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
       * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
       * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
       * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
       * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
       * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
       * Notes:
       * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
       *    are the same as "stand-alone" units, but are different in some languages.
       *    "Formatting" units are declined according to the rules of the language
       *    in the context of a date. "Stand-alone" units are always nominative singular:
       *
       *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
       *
       *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
       *
       * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
       *    the single quote characters (see below).
       *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
       *    the output will be the same as default pattern for this unit, usually
       *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
       *    are marked with "2" in the last column of the table.
       *
       *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
       *
       *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
       *
       *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
       *
       *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
       *
       *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
       *
       * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
       *    The output will be padded with zeros to match the length of the pattern.
       *
       *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
       *
       * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
       *    These tokens represent the shortest form of the quarter.
       *
       * 5. The main difference between `y` and `u` patterns are B.C. years:
       *
       *    | Year | `y` | `u` |
       *    |------|-----|-----|
       *    | AC 1 |   1 |   1 |
       *    | BC 1 |   1 |   0 |
       *    | BC 2 |   2 |  -1 |
       *
       *    Also `yy` always returns the last two digits of a year,
       *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
       *
       *    | Year | `yy` | `uu` |
       *    |------|------|------|
       *    | 1    |   01 |   01 |
       *    | 14   |   14 |   14 |
       *    | 376  |   76 |  376 |
       *    | 1453 |   53 | 1453 |
       *
       *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
       *    except local week-numbering years are dependent on `options.weekStartsOn`
       *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
       *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
       *
       * 6. Specific non-location timezones are currently unavailable in `date-fns`,
       *    so right now these tokens fall back to GMT timezones.
       *
       * 7. These patterns are not in the Unicode Technical Standard #35:
       *    - `i`: ISO day of week
       *    - `I`: ISO week of year
       *    - `R`: ISO week-numbering year
       *    - `t`: seconds timestamp
       *    - `T`: milliseconds timestamp
       *    - `o`: ordinal number modifier
       *    - `P`: long localized date
       *    - `p`: long localized time
       *
       * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
       *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
       *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The second argument is now required for the sake of explicitness.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   format(new Date(2016, 0, 1))
       *
       *   // v2.0.0 onward
       *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
       *   ```
       *
       * - New format string API for `format` function
       *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
       *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
       *
       * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
       *
       * @param {Date|Number} date - the original date
       * @param {String} format - the string of tokens
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
       * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
       *   see: https://git.io/fxCyr
       * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
       *   see: https://git.io/fxCyr
       * @returns {String} the formatted date string
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.locale` must contain `localize` property
       * @throws {RangeError} `options.locale` must contain `formatLong` property
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} format string contains an unescaped latin alphabet character
       *
       * @example
       * // Represent 11 February 2014 in middle-endian format:
       * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
       * //=> '02/11/2014'
       *
       * @example
       * // Represent 2 July 2014 in Esperanto:
       * import { eoLocale } from 'date-fns/locale/eo'
       * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
       *   locale: eoLocale
       * })
       * //=> '2-a de julio 2014'
       *
       * @example
       * // Escape string by single quote characters:
       * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
       * //=> "3 o'clock"
       */

      function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var formatStr = String(dirtyFormatStr);
        var options = dirtyOptions || {};
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__["a"
        /* default */
        ];
        var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a"
        /* default */
        ](localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a"
        /* default */
        ](options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
          throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        }

        var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a"
        /* default */
        ](localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a"
        /* default */
        ](options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        }

        if (!locale.localize) {
          throw new RangeError('locale must contain localize property');
        }

        if (!locale.formatLong) {
          throw new RangeError('locale must contain formatLong property');
        }

        var originalDate = __WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        if (!__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["a"
        /* default */
        ](originalDate)) {
          throw new RangeError('Invalid time value');
        } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
        // This ensures that when UTC functions will be implemented, locales will be compatible with them.
        // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


        var timezoneOffset = __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](originalDate);

        var utcDate = __WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__["a"
        /* default */
        ](originalDate, timezoneOffset);

        var formatterOptions = {
          firstWeekContainsDate: firstWeekContainsDate,
          weekStartsOn: weekStartsOn,
          locale: locale,
          _originalDate: originalDate
        };
        var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
          var firstCharacter = substring[0];

          if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__["a"
            /* default */
            ][firstCharacter];
            return longFormatter(substring, locale.formatLong, formatterOptions);
          }

          return substring;
        }).join('').match(formattingTokensRegExp).map(function (substring) {
          // Replace two single quote characters with one single quote character
          if (substring === "''") {
            return "'";
          }

          var firstCharacter = substring[0];

          if (firstCharacter === "'") {
            return cleanEscapedString(substring);
          }

          var formatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__["a"
          /* default */
          ][firstCharacter];

          if (formatter) {
            if (!options.useAdditionalWeekYearTokens && __WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["b"
            /* isProtectedWeekYearToken */
            ](substring)) {
              __WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c"
              /* throwProtectedError */
              ](substring, dirtyFormatStr, dirtyDate);
            }

            if (!options.useAdditionalDayOfYearTokens && __WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["a"
            /* isProtectedDayOfYearToken */
            ](substring)) {
              __WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c"
              /* throwProtectedError */
              ](substring, dirtyFormatStr, dirtyDate);
            }

            return formatter(utcDate, substring, locale.localize, formatterOptions);
          }

          if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
            throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
          }

          return substring;
        }).join('');
        return result;
      }

      function cleanEscapedString(input) {
        return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
      }
      /***/

    },
    /* 152 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__ = __webpack_require__(38);
      /*
       * |     | Unit                           |     | Unit                           |
       * |-----|--------------------------------|-----|--------------------------------|
       * |  a  | AM, PM                         |  A* |                                |
       * |  d  | Day of month                   |  D  |                                |
       * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
       * |  m  | Minute                         |  M  | Month                          |
       * |  s  | Second                         |  S  | Fraction of second             |
       * |  y  | Year (abs)                     |  Y  |                                |
       *
       * Letters marked by * are not implemented but reserved by Unicode standard.
       */


      var formatters = {
        // Year
        y: function y(date, token) {
          // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
          // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
          // |----------|-------|----|-------|-------|-------|
          // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
          // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
          // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
          // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
          // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
          var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

          var year = signedYear > 0 ? signedYear : 1 - signedYear;
          return __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ](token === 'yy' ? year % 100 : year, token.length);
        },
        // Month
        M: function M(date, token) {
          var month = date.getUTCMonth();
          return token === 'M' ? String(month + 1) : __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ](month + 1, 2);
        },
        // Day of the month
        d: function d(date, token) {
          return __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ](date.getUTCDate(), token.length);
        },
        // AM or PM
        a: function a(date, token) {
          var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

          switch (token) {
            case 'a':
            case 'aa':
            case 'aaa':
              return dayPeriodEnumValue.toUpperCase();

            case 'aaaaa':
              return dayPeriodEnumValue[0];

            case 'aaaa':
            default:
              return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
          }
        },
        // Hour [1-12]
        h: function h(date, token) {
          return __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ](date.getUTCHours() % 12 || 12, token.length);
        },
        // Hour [0-23]
        H: function H(date, token) {
          return __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ](date.getUTCHours(), token.length);
        },
        // Minute
        m: function m(date, token) {
          return __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ](date.getUTCMinutes(), token.length);
        },
        // Second
        s: function s(date, token) {
          return __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ](date.getUTCSeconds(), token.length);
        },
        // Fraction of second
        S: function S(date, token) {
          var numberOfDigits = token.length;
          var milliseconds = date.getUTCMilliseconds();
          var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
          return __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a"
          /* default */
          ](fractionalSeconds, token.length);
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatters;
      /***/
    },
    /* 153 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(63);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__ = __webpack_require__(342);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376

      function getUTCISOWeek(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var diff = __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a"
        /* default */
        ](date).getTime() - __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__["a"
        /* default */
        ](date).getTime(); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)


        return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
      }
      /***/

    },
    /* 154 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(63);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function getUTCISOWeekYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getUTCFullYear();
        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);

        var startOfNextYear = __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a"
        /* default */
        ](fourthOfJanuaryOfNextYear);

        var fourthOfJanuaryOfThisYear = new Date(0);
        fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
        fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);

        var startOfThisYear = __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a"
        /* default */
        ](fourthOfJanuaryOfThisYear);

        if (date.getTime() >= startOfNextYear.getTime()) {
          return year + 1;
        } else if (date.getTime() >= startOfThisYear.getTime()) {
          return year;
        } else {
          return year - 1;
        }
      }
      /***/

    },
    /* 155 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__ = __webpack_require__(50);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__ = __webpack_require__(343);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376

      function getUTCWeek(dirtyDate, options) {
        __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var diff = __WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__["a"
        /* default */
        ](date, options).getTime() - __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__["a"
        /* default */
        ](date, options).getTime(); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)


        return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
      }
      /***/

    },
    /* 156 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      function dateLongFormatter(pattern, formatLong) {
        switch (pattern) {
          case 'P':
            return formatLong.date({
              width: 'short'
            });

          case 'PP':
            return formatLong.date({
              width: 'medium'
            });

          case 'PPP':
            return formatLong.date({
              width: 'long'
            });

          case 'PPPP':
          default:
            return formatLong.date({
              width: 'full'
            });
        }
      }

      function timeLongFormatter(pattern, formatLong) {
        switch (pattern) {
          case 'p':
            return formatLong.time({
              width: 'short'
            });

          case 'pp':
            return formatLong.time({
              width: 'medium'
            });

          case 'ppp':
            return formatLong.time({
              width: 'long'
            });

          case 'pppp':
          default:
            return formatLong.time({
              width: 'full'
            });
        }
      }

      function dateTimeLongFormatter(pattern, formatLong) {
        var matchResult = pattern.match(/(P+)(p+)?/);
        var datePattern = matchResult[1];
        var timePattern = matchResult[2];

        if (!timePattern) {
          return dateLongFormatter(pattern, formatLong);
        }

        var dateTimeFormat;

        switch (datePattern) {
          case 'P':
            dateTimeFormat = formatLong.dateTime({
              width: 'short'
            });
            break;

          case 'PP':
            dateTimeFormat = formatLong.dateTime({
              width: 'medium'
            });
            break;

          case 'PPP':
            dateTimeFormat = formatLong.dateTime({
              width: 'long'
            });
            break;

          case 'PPPP':
          default:
            dateTimeFormat = formatLong.dateTime({
              width: 'full'
            });
            break;
        }

        return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
      }

      var longFormatters = {
        p: timeLongFormatter,
        P: dateTimeLongFormatter
      };
      /* harmony default export */

      __webpack_exports__["a"] = longFormatters;
      /***/
    },
    /* 157 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isProtectedDayOfYearToken;
      /* harmony export (immutable) */

      __webpack_exports__["b"] = isProtectedWeekYearToken;
      /* harmony export (immutable) */

      __webpack_exports__["c"] = throwProtectedError;
      var protectedDayOfYearTokens = ['D', 'DD'];
      var protectedWeekYearTokens = ['YY', 'YYYY'];

      function isProtectedDayOfYearToken(token) {
        return protectedDayOfYearTokens.indexOf(token) !== -1;
      }

      function isProtectedWeekYearToken(token) {
        return protectedWeekYearTokens.indexOf(token) !== -1;
      }

      function throwProtectedError(token, format, input) {
        if (token === 'YYYY') {
          throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        } else if (token === 'YY') {
          throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        } else if (token === 'D') {
          throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        } else if (token === 'DD') {
          throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
        }
      }
      /***/

    },
    /* 158 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInMonths_index_js__ = __webpack_require__(60);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__differenceInSeconds_index_js__ = __webpack_require__(61);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__locale_en_US_index_js__ = __webpack_require__(28);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_cloneObject_index_js__ = __webpack_require__(159);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MINUTES_IN_DAY = 1440;
      var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
      var MINUTES_IN_MONTH = 43200;
      var MINUTES_IN_TWO_MONTHS = 86400;
      /**
       * @name formatDistance
       * @category Common Helpers
       * @summary Return the distance between the given dates in words.
       *
       * @description
       * Return the distance between the given dates in words.
       *
       * | Distance between dates                                            | Result              |
       * |-------------------------------------------------------------------|---------------------|
       * | 0 ... 30 secs                                                     | less than a minute  |
       * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
       * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
       * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
       * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
       * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
       * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
       * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
       * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
       * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
       * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
       * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
       * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
       * | N yrs ... N yrs 3 months                                          | about N years       |
       * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
       * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
       *
       * With `options.includeSeconds == true`:
       * | Distance between dates | Result               |
       * |------------------------|----------------------|
       * | 0 secs ... 5 secs      | less than 5 seconds  |
       * | 5 secs ... 10 secs     | less than 10 seconds |
       * | 10 secs ... 20 secs    | less than 20 seconds |
       * | 20 secs ... 40 secs    | half a minute        |
       * | 40 secs ... 60 secs    | less than a minute   |
       * | 60 secs ... 90 secs    | 1 minute             |
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `distanceInWords ` to `formatDistance`
       *   to make its name consistent with `format` and `formatRelative`.
       *
       * - The order of arguments is swapped to make the function
       *   consistent with `differenceIn...` functions.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWords(
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     new Date(1986, 3, 4, 11, 32, 0),
       *     { addSuffix: true }
       *   ) //=> 'in about 1 hour'
       *
       *   // v2.0.0 onward
       *
       *   formatDistance(
       *     new Date(1986, 3, 4, 11, 32, 0),
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     { addSuffix: true }
       *   ) //=> 'in about 1 hour'
       *   ```
       *
       * @param {Date|Number} date - the date
       * @param {Date|Number} baseDate - the date to compare with
       * @param {Object} [options] - an object with options.
       * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
       * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {String} the distance in words
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `baseDate` must not be Invalid Date
       * @throws {RangeError} `options.locale` must contain `formatDistance` property
       *
       * @example
       * // What is the distance between 2 July 2014 and 1 January 2015?
       * var result = formatDistance(new Date(2014, 6, 2), new Date(2015, 0, 1))
       * //=> '6 months'
       *
       * @example
       * // What is the distance between 1 January 2015 00:00:15
       * // and 1 January 2015 00:00:00, including seconds?
       * var result = formatDistance(
       *   new Date(2015, 0, 1, 0, 0, 15),
       *   new Date(2015, 0, 1, 0, 0, 0),
       *   { includeSeconds: true }
       * )
       * //=> 'less than 20 seconds'
       *
       * @example
       * // What is the distance from 1 January 2016
       * // to 1 January 2015, with a suffix?
       * var result = formatDistance(new Date(2015, 0, 1), new Date(2016, 0, 1), {
       *   addSuffix: true
       * })
       * //=> 'about 1 year ago'
       *
       * @example
       * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
       * import { eoLocale } from 'date-fns/locale/eo'
       * var result = formatDistance(new Date(2016, 7, 1), new Date(2015, 0, 1), {
       *   locale: eoLocale
       * })
       * //=> 'pli ol 1 jaro'
       */

      function formatDistance(dirtyDate, dirtyBaseDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_3__locale_en_US_index_js__["a"
        /* default */
        ];

        if (!locale.formatDistance) {
          throw new RangeError('locale must contain formatDistance property');
        }

        var comparison = __WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__["a"
        /* default */
        ](dirtyDate, dirtyBaseDate);

        if (isNaN(comparison)) {
          throw new RangeError('Invalid time value');
        }

        var localizeOptions = __WEBPACK_IMPORTED_MODULE_5__lib_cloneObject_index_js__["a"
        /* default */
        ](options);

        localizeOptions.addSuffix = Boolean(options.addSuffix);
        localizeOptions.comparison = comparison;
        var dateLeft;
        var dateRight;

        if (comparison > 0) {
          dateLeft = __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
          /* default */
          ](dirtyBaseDate);
          dateRight = __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
          /* default */
          ](dirtyDate);
        } else {
          dateLeft = __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
          /* default */
          ](dirtyDate);
          dateRight = __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
          /* default */
          ](dirtyBaseDate);
        }

        var seconds = __WEBPACK_IMPORTED_MODULE_2__differenceInSeconds_index_js__["a"
        /* default */
        ](dateRight, dateLeft);

        var offsetInSeconds = (__WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](dateRight) - __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](dateLeft)) / 1000;
        var minutes = Math.round((seconds - offsetInSeconds) / 60);
        var months; // 0 up to 2 mins

        if (minutes < 2) {
          if (options.includeSeconds) {
            if (seconds < 5) {
              return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            } else if (seconds < 10) {
              return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            } else if (seconds < 20) {
              return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            } else if (seconds < 40) {
              return locale.formatDistance('halfAMinute', null, localizeOptions);
            } else if (seconds < 60) {
              return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            } else {
              return locale.formatDistance('xMinutes', 1, localizeOptions);
            }
          } else {
            if (minutes === 0) {
              return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            } else {
              return locale.formatDistance('xMinutes', minutes, localizeOptions);
            }
          } // 2 mins up to 0.75 hrs

        } else if (minutes < 45) {
          return locale.formatDistance('xMinutes', minutes, localizeOptions); // 0.75 hrs up to 1.5 hrs
        } else if (minutes < 90) {
          return locale.formatDistance('aboutXHours', 1, localizeOptions); // 1.5 hrs up to 24 hrs
        } else if (minutes < MINUTES_IN_DAY) {
          var hours = Math.round(minutes / 60);
          return locale.formatDistance('aboutXHours', hours, localizeOptions); // 1 day up to 1.75 days
        } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
          return locale.formatDistance('xDays', 1, localizeOptions); // 1.75 days up to 30 days
        } else if (minutes < MINUTES_IN_MONTH) {
          var days = Math.round(minutes / MINUTES_IN_DAY);
          return locale.formatDistance('xDays', days, localizeOptions); // 1 month up to 2 months
        } else if (minutes < MINUTES_IN_TWO_MONTHS) {
          months = Math.round(minutes / MINUTES_IN_MONTH);
          return locale.formatDistance('aboutXMonths', months, localizeOptions);
        }

        months = __WEBPACK_IMPORTED_MODULE_1__differenceInMonths_index_js__["a"
        /* default */
        ](dateRight, dateLeft); // 2 months up to 12 months

        if (months < 12) {
          var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
          return locale.formatDistance('xMonths', nearestMonth, localizeOptions); // 1 year up to max Date
        } else {
          var monthsSinceStartOfYear = months % 12;
          var years = Math.floor(months / 12); // N years up to 1 years 3 months

          if (monthsSinceStartOfYear < 3) {
            return locale.formatDistance('aboutXYears', years, localizeOptions); // N years 3 months up to N years 9 months
          } else if (monthsSinceStartOfYear < 9) {
            return locale.formatDistance('overXYears', years, localizeOptions); // N years 9 months up to N year 12 months
          } else {
            return locale.formatDistance('almostXYears', years + 1, localizeOptions);
          }
        }
      }
      /***/

    },
    /* 159 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = cloneObject;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__assign_index_js__ = __webpack_require__(160);

      function cloneObject(dirtyObject) {
        return __WEBPACK_IMPORTED_MODULE_0__assign_index_js__["a"
        /* default */
        ]({}, dirtyObject);
      }
      /***/

    },
    /* 160 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = assign;

      function assign(target, dirtyObject) {
        if (target == null) {
          throw new TypeError('assign requires that input parameter not be null or undefined');
        }

        dirtyObject = dirtyObject || {};

        for (var property in dirtyObject) {
          if (dirtyObject.hasOwnProperty(property)) {
            target[property] = dirtyObject[property];
          }
        }

        return target;
      }
      /***/

    },
    /* 161 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistanceStrict;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__compareAsc_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__differenceInSeconds_index_js__ = __webpack_require__(61);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_cloneObject_index_js__ = __webpack_require__(159);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__locale_en_US_index_js__ = __webpack_require__(28);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MINUTES_IN_DAY = 1440;
      var MINUTES_IN_MONTH = 43200;
      var MINUTES_IN_YEAR = 525600;
      /**
       * @name formatDistanceStrict
       * @category Common Helpers
       * @summary Return the distance between the given dates in words.
       *
       * @description
       * Return the distance between the given dates in words, using strict units.
       * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
       * 'less than' and the like.
       *
       * | Distance between dates | Result              |
       * |------------------------|---------------------|
       * | 0 ... 59 secs          | [0..59] seconds     |
       * | 1 ... 59 mins          | [1..59] minutes     |
       * | 1 ... 23 hrs           | [1..23] hours       |
       * | 1 ... 29 days          | [1..29] days        |
       * | 1 ... 11 months        | [1..11] months      |
       * | 1 ... N years          | [1..N]  years       |
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
       *   to make its name consistent with `format` and `formatRelative`.
       *
       * - The order of arguments is swapped to make the function
       *   consistent with `differenceIn...` functions.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWordsStrict(
       *     new Date(2015, 0, 2),
       *     new Date(2014, 6, 2)
       *   ) //=> '6 months'
       *
       *   // v2.0.0 onward
       *
       *   formatDistanceStrict(
       *     new Date(2014, 6, 2),
       *     new Date(2015, 0, 2)
       *   ) //=> '6 months'
       *   ```
       *
       * - `partialMethod` option is renamed to `roundingMethod`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWordsStrict(
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     new Date(1986, 3, 4, 10, 33, 1),
       *     { partialMethod: 'ceil' }
       *   ) //=> '2 minutes'
       *
       *   // v2.0.0 onward
       *
       *   formatDistanceStrict(
       *     new Date(1986, 3, 4, 10, 33, 1),
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     { roundingMethod: 'ceil' }
       *   ) //=> '2 minutes'
       *   ```
       *
       * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
       *
       * - `unit` option now accepts one of the strings:
       *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWordsStrict(
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     new Date(1986, 3, 4, 10, 33, 1),
       *     { unit: 'm' }
       *   )
       *
       *   // v2.0.0 onward
       *
       *   formatDistanceStrict(
       *     new Date(1986, 3, 4, 10, 33, 1),
       *     new Date(1986, 3, 4, 10, 32, 0),
       *     { unit: 'minute' }
       *   )
       *   ```
       *
       * @param {Date|Number} date - the date
       * @param {Date|Number} baseDate - the date to compare with
       * @param {Object} [options] - an object with options.
       * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
       * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
       * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {String} the distance in words
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `baseDate` must not be Invalid Date
       * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
       * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
       * @throws {RangeError} `options.locale` must contain `formatDistance` property
       *
       * @example
       * // What is the distance between 2 July 2014 and 1 January 2015?
       * var result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
       * //=> '6 months'
       *
       * @example
       * // What is the distance between 1 January 2015 00:00:15
       * // and 1 January 2015 00:00:00?
       * var result = formatDistanceStrict(
       *   new Date(2015, 0, 1, 0, 0, 15),
       *   new Date(2015, 0, 1, 0, 0, 0)
       * )
       * //=> '15 seconds'
       *
       * @example
       * // What is the distance from 1 January 2016
       * // to 1 January 2015, with a suffix?
       * var result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
       *   addSuffix: true
       * })
       * //=> '1 year ago'
       *
       * @example
       * // What is the distance from 1 January 2016
       * // to 1 January 2015, in minutes?
       * var result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
       *   unit: 'minute'
       * })
       * //=> '525600 minutes'
       *
       * @example
       * // What is the distance from 1 January 2015
       * // to 28 January 2015, in months, rounded up?
       * var result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
       *   unit: 'month',
       *   roundingMethod: 'ceil'
       * })
       * //=> '1 month'
       *
       * @example
       * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
       * import { eoLocale } from 'date-fns/locale/eo'
       * var result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
       *   locale: eoLocale
       * })
       * //=> '1 jaro'
       */

      function formatDistanceStrict(dirtyDate, dirtyBaseDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_5__locale_en_US_index_js__["a"
        /* default */
        ];

        if (!locale.formatDistance) {
          throw new RangeError('locale must contain localize.formatDistance property');
        }

        var comparison = __WEBPACK_IMPORTED_MODULE_1__compareAsc_index_js__["a"
        /* default */
        ](dirtyDate, dirtyBaseDate);

        if (isNaN(comparison)) {
          throw new RangeError('Invalid time value');
        }

        var localizeOptions = __WEBPACK_IMPORTED_MODULE_4__lib_cloneObject_index_js__["a"
        /* default */
        ](options);

        localizeOptions.addSuffix = Boolean(options.addSuffix);
        localizeOptions.comparison = comparison;
        var dateLeft;
        var dateRight;

        if (comparison > 0) {
          dateLeft = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ](dirtyBaseDate);
          dateRight = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ](dirtyDate);
        } else {
          dateLeft = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ](dirtyDate);
          dateRight = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ](dirtyBaseDate);
        }

        var roundingMethod = options.roundingMethod == null ? 'round' : String(options.roundingMethod);
        var roundingMethodFn;

        if (roundingMethod === 'floor') {
          roundingMethodFn = Math.floor;
        } else if (roundingMethod === 'ceil') {
          roundingMethodFn = Math.ceil;
        } else if (roundingMethod === 'round') {
          roundingMethodFn = Math.round;
        } else {
          throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
        }

        var seconds = __WEBPACK_IMPORTED_MODULE_3__differenceInSeconds_index_js__["a"
        /* default */
        ](dateRight, dateLeft);

        var offsetInSeconds = (__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](dateRight) - __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](dateLeft)) / 1000;
        var minutes = roundingMethodFn((seconds - offsetInSeconds) / 60);
        var unit;

        if (options.unit == null) {
          if (minutes < 1) {
            unit = 'second';
          } else if (minutes < 60) {
            unit = 'minute';
          } else if (minutes < MINUTES_IN_DAY) {
            unit = 'hour';
          } else if (minutes < MINUTES_IN_MONTH) {
            unit = 'day';
          } else if (minutes < MINUTES_IN_YEAR) {
            unit = 'month';
          } else {
            unit = 'year';
          }
        } else {
          unit = String(options.unit);
        } // 0 up to 60 seconds


        if (unit === 'second') {
          return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
        } else if (unit === 'minute') {
          return locale.formatDistance('xMinutes', minutes, localizeOptions); // 1 up to 24 hours
        } else if (unit === 'hour') {
          var hours = roundingMethodFn(minutes / 60);
          return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
        } else if (unit === 'day') {
          var days = roundingMethodFn(minutes / MINUTES_IN_DAY);
          return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
        } else if (unit === 'month') {
          var months = roundingMethodFn(minutes / MINUTES_IN_MONTH);
          return locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
        } else if (unit === 'year') {
          var years = roundingMethodFn(minutes / MINUTES_IN_YEAR);
          return locale.formatDistance('xYears', years, localizeOptions);
        }

        throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
      }
      /***/

    },
    /* 162 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getDate;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDate
       * @category Day Helpers
       * @summary Get the day of the month of the given date.
       *
       * @description
       * Get the day of the month of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the day of month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which day of the month is 29 February 2012?
       * var result = getDate(new Date(2012, 1, 29))
       * //=> 29
       */


      function getDate(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var dayOfMonth = date.getDate();
        return dayOfMonth;
      }
      /***/

    },
    /* 163 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDay
       * @category Weekday Helpers
       * @summary Get the day of the week of the given date.
       *
       * @description
       * Get the day of the week of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which day of the week is 29 February 2012?
       * var result = getDay(new Date(2012, 1, 29))
       * //=> 3
       */


      function getDay(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = date.getDay();
        return day;
      }
      /***/

    },
    /* 164 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getDaysInMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDaysInMonth
       * @category Month Helpers
       * @summary Get the number of days in a month of the given date.
       *
       * @description
       * Get the number of days in a month of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the number of days in a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // How many days are in February 2000?
       * var result = getDaysInMonth(new Date(2000, 1))
       * //=> 29
       */


      function getDaysInMonth(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        var monthIndex = date.getMonth();
        var lastDayOfMonth = new Date(0);
        lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
        lastDayOfMonth.setHours(0, 0, 0, 0);
        return lastDayOfMonth.getDate();
      }
      /***/

    },
    /* 165 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isLeapYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isLeapYear
       * @category Year Helpers
       * @summary Is the given date in the leap year?
       *
       * @description
       * Is the given date in the leap year?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in the leap year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 1 September 2012 in the leap year?
       * var result = isLeapYear(new Date(2012, 8, 1))
       * //=> true
       */


      function isLeapYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
      }
      /***/

    },
    /* 166 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getISODay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getISODay
       * @category Weekday Helpers
       * @summary Get the day of the ISO week of the given date.
       *
       * @description
       * Get the day of the ISO week of the given date,
       * which is 7 for Sunday, 1 for Monday etc.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the day of ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which day of the ISO week is 26 February 2012?
       * var result = getISODay(new Date(2012, 1, 26))
       * //=> 7
       */


      function getISODay(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = date.getDay();

        if (day === 0) {
          day = 7;
        }

        return day;
      }
      /***/

    },
    /* 167 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(25);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__ = __webpack_require__(46);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name getISOWeek
       * @category ISO Week Helpers
       * @summary Get the ISO week of the given date.
       *
       * @description
       * Get the ISO week of the given date.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which week of the ISO-week numbering year is 2 January 2005?
       * var result = getISOWeek(new Date(2005, 0, 2))
       * //=> 53
       */

      function getISOWeek(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var diff = __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ](date).getTime() - __WEBPACK_IMPORTED_MODULE_2__startOfISOWeekYear_index_js__["a"
        /* default */
        ](date).getTime(); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)


        return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
      }
      /***/

    },
    /* 168 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getTime;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getTime
       * @category Timestamp Helpers
       * @summary Get the milliseconds timestamp of the given date.
       *
       * @description
       * Get the milliseconds timestamp of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the timestamp
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the timestamp of 29 February 2012 11:45:05.123:
       * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
       * //=> 1330515905123
       */


      function getTime(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var timestamp = date.getTime();
        return timestamp;
      }
      /***/

    },
    /* 169 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(22);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__ = __webpack_require__(93);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name getWeek
       * @category Week Helpers
       * @summary Get the local week index of the given date.
       *
       * @description
       * Get the local week index of the given date.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Number} the week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // Which week of the local week numbering year is 2 January 2005 with default options?
       * var result = getISOWeek(new Date(2005, 0, 2))
       * //=> 2
       *
       * // Which week of the local week numbering year is 2 January 2005,
       * // if Monday is the first day of the week,
       * // and the first week of the year always contains 4 January?
       * var result = getISOWeek(new Date(2005, 0, 2), {
       *   weekStartsOn: 1,
       *   firstWeekContainsDate: 4
       * })
       * //=> 53
       */

      function getWeek(dirtyDate, options) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var diff = __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ](date, options).getTime() - __WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__["a"
        /* default */
        ](date, options).getTime(); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)


        return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
      }
      /***/

    },
    /* 170 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(22);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getWeekYear
       * @category Week-Numbering Year Helpers
       * @summary Get the local week-numbering year of the given date.
       *
       * @description
       * Get the local week-numbering year of the given date.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Number} the local week-numbering year
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // Which week numbering year is 26 December 2004 with the default settings?
       * var result = getWeekYear(new Date(2004, 11, 26))
       * //=> 2005
       *
       * @example
       * // Which week numbering year is 26 December 2004 if week starts on Saturday?
       * var result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
       * //=> 2004
       *
       * @example
       * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
       * var result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
       * //=> 2004
       */


      function getWeekYear(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
          throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        }

        var firstWeekOfNextYear = new Date(0);
        firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
        firstWeekOfNextYear.setHours(0, 0, 0, 0);

        var startOfNextYear = __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ](firstWeekOfNextYear, dirtyOptions);

        var firstWeekOfThisYear = new Date(0);
        firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
        firstWeekOfThisYear.setHours(0, 0, 0, 0);

        var startOfThisYear = __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["a"
        /* default */
        ](firstWeekOfThisYear, dirtyOptions);

        if (date.getTime() >= startOfNextYear.getTime()) {
          return year + 1;
        } else if (date.getTime() >= startOfThisYear.getTime()) {
          return year;
        } else {
          return year - 1;
        }
      }
      /***/

    },
    /* 171 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lastDayOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfMonth
       * @category Month Helpers
       * @summary Return the last day of a month for the given date.
       *
       * @description
       * Return the last day of a month for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the last day of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of a month for 2 September 2014 11:55:00:
       * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 30 2014 00:00:00
       */


      function lastDayOfMonth(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var month = date.getMonth();
        date.setFullYear(date.getFullYear(), month + 1, 0);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 172 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = sub;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__subDays_index_js__ = __webpack_require__(94);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__subMonths_index_js__ = __webpack_require__(173);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__ = __webpack_require__(6);
      /**
       * @name sub
       * @category Common Helpers
       * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
       *
       * @description
       * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
       *
       * | Key     | Description                        |
       * |---------|------------------------------------|
       * | years   | Amount of years to be subtracted   |
       * | months  | Amount of months to be subtracted  |
       * | weeks   | Amount of weeks to be subtracted   |
       * | days    | Amount of days to be subtracted    |
       * | hours   | Amount of hours to be subtracted   |
       * | minutes | Amount of minutes to be subtracted |
       * | seconds | Amount of seconds to be subtracted |
       *
       * All values default to 0
       *
       * @returns {Date} the new date with the seconds subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract the following duration from 15 June 2017 15:29:20
       * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
       *   years: 2,
       *   months: 9,
       *   weeks: 1,
       *   days: 7,
       *   hours: 5,
       *   minutes: 9,
       *   seconds: 30
       * })
       * //=> Mon Sep 1 2014 10:19:50
       */


      function sub(dirtyDate, duration) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        if (!duration || typeof duration !== 'object') return new Date(NaN);
        var years = 'years' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.years) : 0;
        var months = 'months' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.months) : 0;
        var weeks = 'weeks' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.weeks) : 0;
        var days = 'days' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.days) : 0;
        var hours = 'hours' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.hours) : 0;
        var minutes = 'minutes' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.minutes) : 0;
        var seconds = 'seconds' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.seconds) : 0; // Subtract years and months

        var dateWithoutMonths = __WEBPACK_IMPORTED_MODULE_1__subMonths_index_js__["a"
        /* default */
        ](__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](dirtyDate), months + years * 12); // Subtract weeks and days


        var dateWithoutDays = __WEBPACK_IMPORTED_MODULE_0__subDays_index_js__["a"
        /* default */
        ](dateWithoutMonths, days + weeks * 7); // Subtract hours, minutes and seconds


        var minutestoSub = minutes + hours * 60;
        var secondstoSub = seconds + minutestoSub * 60;
        var mstoSub = secondstoSub * 1000;
        var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
        return finalDate;
      }
      /***/

    },
    /* 173 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subMonths;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(44);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subMonths
       * @category Month Helpers
       * @summary Subtract the specified number of months from the given date.
       *
       * @description
       * Subtract the specified number of months from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the months subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 5 months from 1 February 2015:
       * var result = subMonths(new Date(2015, 1, 1), 5)
       * //=> Mon Sep 01 2014 00:00:00
       */


      function subMonths(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 174 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = parse;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__ = __webpack_require__(28);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__ = __webpack_require__(49);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__ = __webpack_require__(160);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__ = __webpack_require__(156);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__ = __webpack_require__(157);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__ = __webpack_require__(379);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
      // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
      //   (one of the certain letters followed by `o`)
      // - (\w)\1* matches any sequences of the same letter
      // - '' matches two quote characters in a row
      // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
      //   except a single quote symbol, which ends the sequence.
      //   Two quote characters do not end the sequence.
      //   If there is no matching single quote
      //   then the sequence will continue until the end of the string.
      // - . matches any single character unmatched by previous parts of the RegExps

      var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
      // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

      var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
      var escapedStringRegExp = /^'([^]*?)'?$/;
      var doubleQuoteRegExp = /''/g;
      var notWhitespaceRegExp = /\S/;
      var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
      /**
       * @name parse
       * @category Common Helpers
       * @summary Parse the date.
       *
       * @description
       * Return the date parsed from string using the given format string.
       *
       * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
       * > See: https://git.io/fxCyr
       *
       * The characters in the format string wrapped between two single quotes characters (') are escaped.
       * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
       *
       * Format of the format string is based on Unicode Technical Standard #35:
       * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
       * with a few additions (see note 5 below the table).
       *
       * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
       * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
       *
       * ```javascript
       * parse('23 AM', 'HH a', new Date())
       * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
       * ```
       *
       * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
       *
       * Accepted format string patterns:
       * | Unit                            |Prior| Pattern | Result examples                   | Notes |
       * |---------------------------------|-----|---------|-----------------------------------|-------|
       * | Era                             | 140 | G..GGG  | AD, BC                            |       |
       * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
       * |                                 |     | GGGGG   | A, B                              |       |
       * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
       * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
       * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
       * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
       * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
       * |                                 |     | yyyyy   | ...                               | 2,4   |
       * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
       * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
       * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
       * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
       * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
       * |                                 |     | YYYYY   | ...                               | 2,4   |
       * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
       * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
       * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
       * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
       * |                                 |     | RRRRR   | ...                               | 2,4,5 |
       * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
       * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
       * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
       * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
       * |                                 |     | uuuuu   | ...                               | 2,4   |
       * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
       * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
       * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
       * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
       * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
       * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
       * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
       * |                                 |     | qq      | 01, 02, 03, 04                    |       |
       * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
       * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
       * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
       * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
       * |                                 |     | MM      | 01, 02, ..., 12                   |       |
       * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
       * |                                 |     | MMMM    | January, February, ..., December  | 2     |
       * |                                 |     | MMMMM   | J, F, ..., D                      |       |
       * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
       * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
       * |                                 |     | LL      | 01, 02, ..., 12                   |       |
       * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
       * |                                 |     | LLLL    | January, February, ..., December  | 2     |
       * |                                 |     | LLLLL   | J, F, ..., D                      |       |
       * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
       * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
       * |                                 |     | ww      | 01, 02, ..., 53                   |       |
       * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
       * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
       * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
       * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
       * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
       * |                                 |     | dd      | 01, 02, ..., 31                   |       |
       * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
       * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
       * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
       * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
       * |                                 |     | DDDD    | ...                               | 2     |
       * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
       * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
       * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
       * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
       * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
       * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
       * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
       * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
       * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
       * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
       * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
       * |                                 |     | ee      | 02, 03, ..., 01                   |       |
       * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
       * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
       * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
       * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
       * |                                 |     | cc      | 02, 03, ..., 01                   |       |
       * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
       * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
       * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
       * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
       * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
       * |                                 |     | aaaaa   | a, p                              |       |
       * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
       * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
       * |                                 |     | bbbbb   | a, p, n, mi                       |       |
       * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
       * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
       * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
       * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
       * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
       * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
       * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
       * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
       * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
       * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
       * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
       * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
       * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
       * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
       * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
       * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
       * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
       * |                                 |     | mm      | 00, 01, ..., 59                   |       |
       * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
       * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
       * |                                 |     | ss      | 00, 01, ..., 59                   |       |
       * | Seconds timestamp               |  40 | t       | 512969520                         |       |
       * |                                 |     | tt      | ...                               | 2     |
       * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
       * |                                 |     | SS      | 00, 01, ..., 99                   |       |
       * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
       * |                                 |     | SSSS    | ...                               | 2     |
       * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
       * |                                 |     | TT      | ...                               | 2     |
       * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
       * |                                 |     | XX      | -0800, +0530, Z                   |       |
       * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
       * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
       * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
       * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
       * |                                 |     | xx      | -0800, +0530, +0000               |       |
       * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
       * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
       * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
       * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
       * |                                 |     | PP      | May 29, 1453                      |       |
       * |                                 |     | PPP     | May 29th, 1453                    |       |
       * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
       * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
       * |                                 |     | pp      | 12:00:00 AM                       |       |
       * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
       * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
       * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
       * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
       * Notes:
       * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
       *    are the same as "stand-alone" units, but are different in some languages.
       *    "Formatting" units are declined according to the rules of the language
       *    in the context of a date. "Stand-alone" units are always nominative singular.
       *    In `format` function, they will produce different result:
       *
       *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
       *
       *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
       *
       *    `parse` will try to match both formatting and stand-alone units interchangably.
       *
       * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
       *    the single quote characters (see below).
       *    If the sequence is longer than listed in table:
       *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
       *      as wide as the sequence
       *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
       *      These variations are marked with "2" in the last column of the table.
       *
       * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
       *    These tokens represent the shortest form of the quarter.
       *
       * 4. The main difference between `y` and `u` patterns are B.C. years:
       *
       *    | Year | `y` | `u` |
       *    |------|-----|-----|
       *    | AC 1 |   1 |   1 |
       *    | BC 1 |   1 |   0 |
       *    | BC 2 |   2 |  -1 |
       *
       *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
       *
       *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
       *
       *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
       *
       *    while `uu` will just assign the year as is:
       *
       *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
       *
       *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
       *
       *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
       *    except local week-numbering years are dependent on `options.weekStartsOn`
       *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
       *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
       *
       * 5. These patterns are not in the Unicode Technical Standard #35:
       *    - `i`: ISO day of week
       *    - `I`: ISO week of year
       *    - `R`: ISO week-numbering year
       *    - `o`: ordinal number modifier
       *    - `P`: long localized date
       *    - `p`: long localized time
       *
       * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
       *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
       *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
       *    on the given locale.
       *
       *    using `en-US` locale: `P` => `MM/dd/yyyy`
       *    using `en-US` locale: `p` => `hh:mm a`
       *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
       *    using `pt-BR` locale: `p` => `HH:mm`
       *
       * Values will be assigned to the date in the descending order of its unit's priority.
       * Units of an equal priority overwrite each other in the order of appearance.
       *
       * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
       * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
       *
       * `referenceDate` must be passed for correct work of the function.
       * If you're not sure which `referenceDate` to supply, create a new instance of Date:
       * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
       * In this case parsing will be done in the context of the current date.
       * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
       * then `Invalid Date` will be returned.
       *
       * The result may vary by locale.
       *
       * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
       *
       * If parsing failed, `Invalid Date` will be returned.
       * Invalid Date is a Date, whose time value is NaN.
       * Time value of Date: http://es5.github.io/#x15.9.1.1
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - Old `parse` was renamed to `toDate`.
       *   Now `parse` is a new function which parses a string using a provided format.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   parse('2016-01-01')
       *
       *   // v2.0.0 onward
       *   toDate('2016-01-01')
       *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
       *   ```
       *
       * @param {String} dateString - the string to parse
       * @param {String} formatString - the string of tokens
       * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
       *   see: https://git.io/fxCyr
       * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
       *   see: https://git.io/fxCyr
       * @returns {Date} the parsed date
       * @throws {TypeError} 3 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       * @throws {RangeError} `options.locale` must contain `match` property
       * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
       * @throws {RangeError} format string contains an unescaped latin alphabet character
       *
       * @example
       * // Parse 11 February 2014 from middle-endian format:
       * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
       * //=> Tue Feb 11 2014 00:00:00
       *
       * @example
       * // Parse 28th of February in Esperanto locale in the context of 2010 year:
       * import eo from 'date-fns/locale/eo'
       * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
       *   locale: eo
       * })
       * //=> Sun Feb 28 2010 00:00:00
       */

      function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_9__lib_requiredArgs_index_js__["a"
        /* default */
        ](3, arguments);

        var dateString = String(dirtyDateString);
        var formatString = String(dirtyFormatString);
        var options = dirtyOptions || {};
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__["a"
        /* default */
        ];

        if (!locale.match) {
          throw new RangeError('locale must contain match property');
        }

        var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a"
        /* default */
        ](localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a"
        /* default */
        ](options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

        if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
          throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
        }

        var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a"
        /* default */
        ](localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a"
        /* default */
        ](options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        }

        if (formatString === '') {
          if (dateString === '') {
            return __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
            /* default */
            ](dirtyReferenceDate);
          } else {
            return new Date(NaN);
          }
        }

        var subFnOptions = {
          firstWeekContainsDate: firstWeekContainsDate,
          weekStartsOn: weekStartsOn,
          locale: locale // If timezone isn't specified, it will be set to the system timezone

        };
        var setters = [{
          priority: TIMEZONE_UNIT_PRIORITY,
          subPriority: -1,
          set: dateToSystemTimezone,
          index: 0
        }];
        var i;
        var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
          var firstCharacter = substring[0];

          if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__["a"
            /* default */
            ][firstCharacter];
            return longFormatter(substring, locale.formatLong, subFnOptions);
          }

          return substring;
        }).join('').match(formattingTokensRegExp);
        var usedTokens = [];

        for (i = 0; i < tokens.length; i++) {
          var token = tokens[i];

          if (!options.useAdditionalWeekYearTokens && __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["b"
          /* isProtectedWeekYearToken */
          ](token)) {
            __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c"
            /* throwProtectedError */
            ](token, formatString, dirtyDateString);
          }

          if (!options.useAdditionalDayOfYearTokens && __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["a"
          /* isProtectedDayOfYearToken */
          ](token)) {
            __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c"
            /* throwProtectedError */
            ](token, formatString, dirtyDateString);
          }

          var firstCharacter = token[0];
          var parser = __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__["a"
          /* default */
          ][firstCharacter];

          if (parser) {
            var incompatibleTokens = parser.incompatibleTokens;

            if (Array.isArray(incompatibleTokens)) {
              var incompatibleToken = void 0;

              for (var _i = 0; _i < usedTokens.length; _i++) {
                var usedToken = usedTokens[_i].token;

                if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
                  incompatibleToken = usedTokens[_i];
                  break;
                }
              }

              if (incompatibleToken) {
                throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
              }
            } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
              throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
            }

            usedTokens.push({
              token: firstCharacter,
              fullToken: token
            });
            var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

            if (!parseResult) {
              return new Date(NaN);
            }

            setters.push({
              priority: parser.priority,
              subPriority: parser.subPriority || 0,
              set: parser.set,
              validate: parser.validate,
              value: parseResult.value,
              index: setters.length
            });
            dateString = parseResult.rest;
          } else {
            if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
              throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
            } // Replace two single quote characters with one single quote character


            if (token === "''") {
              token = "'";
            } else if (firstCharacter === "'") {
              token = cleanEscapedString(token);
            } // Cut token from string, or, if string doesn't match the token, return Invalid Date


            if (dateString.indexOf(token) === 0) {
              dateString = dateString.slice(token.length);
            } else {
              return new Date(NaN);
            }
          }
        } // Check if the remaining input contains something other than whitespace


        if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
          return new Date(NaN);
        }

        var uniquePrioritySetters = setters.map(function (setter) {
          return setter.priority;
        }).sort(function (a, b) {
          return b - a;
        }).filter(function (priority, index, array) {
          return array.indexOf(priority) === index;
        }).map(function (priority) {
          return setters.filter(function (setter) {
            return setter.priority === priority;
          }).sort(function (a, b) {
            return b.subPriority - a.subPriority;
          });
        }).map(function (setterArray) {
          return setterArray[0];
        });

        var date = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](dirtyReferenceDate);

        if (isNaN(date)) {
          return new Date(NaN);
        } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
        // This ensures that when UTC functions will be implemented, locales will be compatible with them.
        // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


        var utcDate = __WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__["a"
        /* default */
        ](date, __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](date));

        var flags = {};

        for (i = 0; i < uniquePrioritySetters.length; i++) {
          var setter = uniquePrioritySetters[i];

          if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
            return new Date(NaN);
          }

          var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

          if (result[0]) {
            utcDate = result[0];

            __WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__["a"
            /* default */
            ](flags, result[1]); // Result is date

          } else {
            utcDate = result;
          }
        }

        return utcDate;
      }

      function dateToSystemTimezone(date, flags) {
        if (flags.timestampIsSet) {
          return date;
        }

        var convertedDate = new Date(0);
        convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
        return convertedDate;
      }

      function cleanEscapedString(input) {
        return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
      }
      /***/

    },
    /* 175 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameHour;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__ = __webpack_require__(176);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameHour
       * @category Hour Helpers
       * @summary Are the given dates in the same hour?
       *
       * @description
       * Are the given dates in the same hour?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same hour
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
       * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
       * //=> true
       */


      function isSameHour(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeftStartOfHour = __WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRightStartOfHour = __WEBPACK_IMPORTED_MODULE_0__startOfHour_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
      }
      /***/

    },
    /* 176 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfHour;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfHour
       * @category Hour Helpers
       * @summary Return the start of an hour for the given date.
       *
       * @description
       * Return the start of an hour for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of an hour
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of an hour for 2 September 2014 11:55:00:
       * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
       * //=> Tue Sep 02 2014 11:00:00
       */


      function startOfHour(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        date.setMinutes(0, 0, 0);
        return date;
      }
      /***/

    },
    /* 177 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__ = __webpack_require__(95);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameISOWeek
       * @category ISO Week Helpers
       * @summary Are the given dates in the same ISO week?
       *
       * @description
       * Are the given dates in the same ISO week?
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same ISO week
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
       * var result = isSameISOWeek(new Date(2014, 8, 1), new Date(2014, 8, 7))
       * //=> true
       */


      function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__["a"
        /* default */
        ](dirtyDateLeft, dirtyDateRight, {
          weekStartsOn: 1
        });
      }
      /***/

    },
    /* 178 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameMinute;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__ = __webpack_require__(179);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameMinute
       * @category Minute Helpers
       * @summary Are the given dates in the same minute?
       *
       * @description
       * Are the given dates in the same minute?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same minute
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
       * // in the same minute?
       * var result = isSameMinute(
       *   new Date(2014, 8, 4, 6, 30),
       *   new Date(2014, 8, 4, 6, 30, 15)
       * )
       * //=> true
       */


      function isSameMinute(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeftStartOfMinute = __WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRightStartOfMinute = __WEBPACK_IMPORTED_MODULE_0__startOfMinute_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
      }
      /***/

    },
    /* 179 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfMinute;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfMinute
       * @category Minute Helpers
       * @summary Return the start of a minute for the given date.
       *
       * @description
       * Return the start of a minute for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a minute
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a minute for 1 December 2014 22:15:45.400:
       * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
       * //=> Mon Dec 01 2014 22:15:00
       */


      function startOfMinute(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        date.setSeconds(0, 0);
        return date;
      }
      /***/

    },
    /* 180 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameMonth
       * @category Month Helpers
       * @summary Are the given dates in the same month?
       *
       * @description
       * Are the given dates in the same month?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same month
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 2 September 2014 and 25 September 2014 in the same month?
       * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
       * //=> true
       */


      function isSameMonth(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
      }
      /***/

    },
    /* 181 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__ = __webpack_require__(87);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameQuarter
       * @category Quarter Helpers
       * @summary Are the given dates in the same year quarter?
       *
       * @description
       * Are the given dates in the same year quarter?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same quarter
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 1 January 2014 and 8 March 2014 in the same quarter?
       * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
       * //=> true
       */


      function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeftStartOfQuarter = __WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRightStartOfQuarter = __WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
      }
      /***/

    },
    /* 182 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameSecond;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__ = __webpack_require__(183);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameSecond
       * @category Second Helpers
       * @summary Are the given dates in the same second?
       *
       * @description
       * Are the given dates in the same second?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same second
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
       * // in the same second?
       * var result = isSameSecond(
       *   new Date(2014, 8, 4, 6, 30, 15),
       *   new Date(2014, 8, 4, 6, 30, 15, 500)
       * )
       * //=> true
       */


      function isSameSecond(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeftStartOfSecond = __WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRightStartOfSecond = __WEBPACK_IMPORTED_MODULE_0__startOfSecond_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
      }
      /***/

    },
    /* 183 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfSecond;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfSecond
       * @category Second Helpers
       * @summary Return the start of a second for the given date.
       *
       * @description
       * Return the start of a second for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a second
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a second for 1 December 2014 22:15:45.400:
       * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
       * //=> Mon Dec 01 2014 22:15:45.000
       */


      function startOfSecond(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        date.setMilliseconds(0);
        return date;
      }
      /***/

    },
    /* 184 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameYear
       * @category Year Helpers
       * @summary Are the given dates in the same year?
       *
       * @description
       * Are the given dates in the same year?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same year
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 2 September 2014 and 25 September 2014 in the same year?
       * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
       * //=> true
       */


      function isSameYear(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeft.getFullYear() === dateRight.getFullYear();
      }
      /***/

    },
    /* 185 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lastDayOfWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfWeek
       * @category Week Helpers
       * @summary Return the last day of a week for the given date.
       *
       * @description
       * Return the last day of a week for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date} the last day of a week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // The last day of a week for 2 September 2014 11:55:00:
       * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sat Sep 06 2014 00:00:00
       *
       * @example
       * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
       * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
       * //=> Sun Sep 07 2014 00:00:00
       */


      function lastDayOfWeek(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ](localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ](options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError('weekStartsOn must be between 0 and 6');
        }

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = date.getDay();
        var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
        date.setHours(0, 0, 0, 0);
        date.setDate(date.getDate() + diff);
        return date;
      }
      /***/

    },
    /* 186 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var numberValues = {
        locale: {
          '1': '১',
          '2': '২',
          '3': '৩',
          '4': '৪',
          '5': '৫',
          '6': '৬',
          '7': '৭',
          '8': '৮',
          '9': '৯',
          '0': '০'
        },
        number: {
          '১': '1',
          '২': '2',
          '৩': '3',
          '৪': '4',
          '৫': '5',
          '৬': '6',
          '৭': '7',
          '৮': '8',
          '৯': '9',
          '০': '0'
        }
      };
      var eraValues = {
        narrow: ['খ্রিঃপূঃ', 'খ্রিঃ'],
        abbreviated: ['খ্রিঃপূর্ব', 'খ্রিঃ'],
        wide: ['খ্রিস্টপূর্ব', 'খ্রিস্টাব্দ']
      };
      var quarterValues = {
        narrow: ['১', '২', '৩', '৪'],
        abbreviated: ['১ত্রৈ', '২ত্রৈ', '৩ত্রৈ', '৪ত্রৈ'],
        wide: ['১ম ত্রৈমাসিক', '২য় ত্রৈমাসিক', '৩য় ত্রৈমাসিক', '৪র্থ ত্রৈমাসিক']
      };
      var monthValues = {
        narrow: ['জানু', 'ফেব্রু', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্ট', 'অক্টো', 'নভে', 'ডিসে'],
        abbreviated: ['জানু', 'ফেব্রু', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্ট', 'অক্টো', 'নভে', 'ডিসে'],
        wide: ['জানুয়ারি', 'ফেব্রুয়ারি', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্টেম্বর', 'অক্টোবর', 'নভেম্বর', 'ডিসেম্বর']
      };
      var dayValues = {
        narrow: ['র', 'সো', 'ম', 'বু', 'বৃ', 'শু', 'শ'],
        short: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহ', 'শুক্র', 'শনি'],
        abbreviated: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহ', 'শুক্র', 'শনি'],
        wide: ['রবিবার', 'সোমবার', 'মঙ্গলবার', 'বুধবার', 'বৃহস্পতিবার ', 'শুক্রবার', 'শনিবার']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'পূ',
          pm: 'অপ',
          midnight: 'মধ্যরাত',
          noon: 'মধ্যাহ্ন',
          morning: 'সকাল',
          afternoon: 'বিকাল',
          evening: 'সন্ধ্যা',
          night: 'রাত'
        },
        abbreviated: {
          am: 'পূর্বাহ্ন',
          pm: 'অপরাহ্ন',
          midnight: 'মধ্যরাত',
          noon: 'মধ্যাহ্ন',
          morning: 'সকাল',
          afternoon: 'বিকাল',
          evening: 'সন্ধ্যা',
          night: 'রাত'
        },
        wide: {
          am: 'পূর্বাহ্ন',
          pm: 'অপরাহ্ন',
          midnight: 'মধ্যরাত',
          noon: 'মধ্যাহ্ন',
          morning: 'সকাল',
          afternoon: 'বিকাল',
          evening: 'সন্ধ্যা',
          night: 'রাত'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'পূ',
          pm: 'অপ',
          midnight: 'মধ্যরাত',
          noon: 'মধ্যাহ্ন',
          morning: 'সকাল',
          afternoon: 'বিকাল',
          evening: 'সন্ধ্যা',
          night: 'রাত'
        },
        abbreviated: {
          am: 'পূর্বাহ্ন',
          pm: 'অপরাহ্ন',
          midnight: 'মধ্যরাত',
          noon: 'মধ্যাহ্ন',
          morning: 'সকাল',
          afternoon: 'বিকাল',
          evening: 'সন্ধ্যা',
          night: 'রাত'
        },
        wide: {
          am: 'পূর্বাহ্ন',
          pm: 'অপরাহ্ন',
          midnight: 'মধ্যরাত',
          noon: 'মধ্যাহ্ন',
          morning: 'সকাল',
          afternoon: 'বিকাল',
          evening: 'সন্ধ্যা',
          night: 'রাত'
        }
      };

      function dateOrdinalNumber(number, localeNumber) {
        if (number > 18 && number <= 31) {
          return localeNumber + 'শে';
        } else {
          switch (number) {
            case 1:
              return localeNumber + 'লা';

            case 2:
            case 3:
              return localeNumber + 'রা';

            case 4:
              return localeNumber + 'ঠা';

            default:
              return localeNumber + 'ই';
          }
        }
      }

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = localize.localeToNumber(dirtyNumber);
        var localeNumber = localize.numberToLocale(number);
        var unit = dirtyOptions.unit;

        if (unit === 'date') {
          return dateOrdinalNumber(number, localeNumber);
        }

        if (number > 10 || number === 0) return localeNumber + 'তম';
        var rem10 = number % 10;

        switch (rem10) {
          case 2:
          case 3:
            return localeNumber + 'য়';

          case 4:
            return localeNumber + 'র্থ';

          case 6:
            return localeNumber + 'ষ্ঠ';

          case 1:
          case 5:
          case 7:
          case 8:
          case 9:
          case 0:
            return localeNumber + 'ম';
        }
      }

      function localeToNumber(locale) {
        var number = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
          return numberValues.number[match];
        });
        return Number(number);
      }

      function numberToLocale(number) {
        return number.toString().replace(/\d/g, function (match) {
          return numberValues.locale[match];
        });
      }

      var localize = {
        localeToNumber: localeToNumber,
        numberToLocale: numberToLocale,
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 187 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'moins d’une seconde',
          other: 'moins de {{count}} secondes'
        },
        xSeconds: {
          one: '1 seconde',
          other: '{{count}} secondes'
        },
        halfAMinute: '30 secondes',
        lessThanXMinutes: {
          one: 'moins d’une minute',
          other: 'moins de {{count}} minutes'
        },
        xMinutes: {
          one: '1 minute',
          other: '{{count}} minutes'
        },
        aboutXHours: {
          one: 'environ 1 heure',
          other: 'environ {{count}} heures'
        },
        xHours: {
          one: '1 heure',
          other: '{{count}} heures'
        },
        xDays: {
          one: '1 jour',
          other: '{{count}} jours'
        },
        aboutXWeeks: {
          one: 'environ 1 semaine',
          other: 'environ {{count}} semaines'
        },
        xWeeks: {
          one: '1 semaine',
          other: '{{count}} semaines'
        },
        aboutXMonths: {
          one: 'environ 1 mois',
          other: 'environ {{count}} mois'
        },
        xMonths: {
          one: '1 mois',
          other: '{{count}} mois'
        },
        aboutXYears: {
          one: 'environ 1 an',
          other: 'environ {{count}} ans'
        },
        xYears: {
          one: '1 an',
          other: '{{count}} ans'
        },
        overXYears: {
          one: 'plus d’un an',
          other: 'plus de {{count}} ans'
        },
        almostXYears: {
          one: 'presqu’un an',
          other: 'presque {{count}} ans'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'dans ' + result;
          } else {
            return 'il y a ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 188 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'dernier à' p",
        yesterday: "'hier à' p",
        today: "'aujourd’hui à' p",
        tomorrow: "'demain à' p'",
        nextWeek: "eeee 'prochain à' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 189 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['av. J.-C', 'ap. J.-C'],
        abbreviated: ['av. J.-C', 'ap. J.-C'],
        wide: ['avant Jésus-Christ', 'après Jésus-Christ']
      };
      var quarterValues = {
        narrow: ['T1', 'T2', 'T3', 'T4'],
        abbreviated: ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'],
        wide: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
        wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
      };
      var dayValues = {
        narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
        abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
        wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'minuit',
          noon: 'midi',
          morning: 'mat.',
          afternoon: 'ap.m.',
          evening: 'soir',
          night: 'mat.'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'minuit',
          noon: 'midi',
          morning: 'matin',
          afternoon: 'après-midi',
          evening: 'soir',
          night: 'matin'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'minuit',
          noon: 'midi',
          morning: 'du matin',
          afternoon: 'de l’après-midi',
          evening: 'du soir',
          night: 'du matin'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (number === 0) {
          return number;
        }

        if (unit === 'year' || unit === 'hour' || unit === 'week') {
          if (number === 1) {
            suffix = 'ère';
          } else {
            suffix = 'ème';
          }
        } else {
          if (number === 1) {
            suffix = 'er';
          } else {
            suffix = 'ème';
          }
        }

        return number + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 190 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
        abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
        wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
      };
      var parseEraPatterns = {
        any: [/^av/i, /^ap/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^t[1234]/i,
        wide: /^[1234](er|ème|e)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
        wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[lmjvsd]/i,
        short: /^(di|lu|ma|me|je|ve|sa)/i,
        abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
        wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
        any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
        any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^min/i,
          noon: /^mid/i,
          morning: /mat/i,
          afternoon: /ap/i,
          evening: /soir/i,
          night: /nuit/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 191 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var _classCallCheck2 = __webpack_require__(64);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(65);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _react = __webpack_require__(12);

      var _react2 = _interopRequireDefault(_react);

      var _reactDom = __webpack_require__(12);

      __webpack_require__(203);

      var _gitalk = __webpack_require__(207);

      var _gitalk2 = _interopRequireDefault(_gitalk);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var Gitalk = function () {
        function Gitalk() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          (0, _classCallCheck3.default)(this, Gitalk);
          this.options = options;
        }

        (0, _createClass3.default)(Gitalk, [{
          key: 'render',
          value: function render(container, callback) {
            var node = null;
            container = container || this.options.container;
            if (!container) throw new Error('Container is required: ' + container);

            if (!(container instanceof HTMLElement)) {
              node = window.document.getElementById(container);
              if (!node) throw new Error('Container not found, window.document.getElementById: ' + container);
            } else {
              node = container;
            }

            if (!callback) {
              callback = function callback() {};
            }

            return (0, _reactDom.render)(_react2.default.createElement(_gitalk2.default, {
              options: this.options
            }), node, callback);
          }
        }]);
        return Gitalk;
      }();

      module.exports = Gitalk;
      /***/
    },
    /* 192 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(193),
        __esModule: true
      };
      /***/
    },
    /* 193 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(194);

      var $Object = __webpack_require__(7).Object;

      module.exports = function defineProperty(it, key, desc) {
        return $Object.defineProperty(it, key, desc);
      };
      /***/

    },
    /* 194 */

    /***/
    function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(11); // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)


      $export($export.S + $export.F * !__webpack_require__(17), 'Object', {
        defineProperty: __webpack_require__(16).f
      });
      /***/
    },
    /* 195 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (process) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        *
        * This source code is licensed under the MIT license found in the
        * LICENSE file in the root directory of this source tree.
        */
        if (process.env.NODE_ENV !== 'production') {
          var ReactIs = __webpack_require__(99); // By explicitly using `prop-types` you are opting into new development behavior.
          // http://fb.me/prop-types-in-prod


          var throwOnDirectAccess = true;
          module.exports = __webpack_require__(198)(ReactIs.isElement, throwOnDirectAccess);
        } else {
          // By explicitly using `prop-types` you are opting into new production behavior.
          // http://fb.me/prop-types-in-prod
          module.exports = __webpack_require__(201)();
        }
        /* WEBPACK VAR INJECTION */

      }).call(exports, __webpack_require__(18));
      /***/
    },
    /* 196 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /** @license React v16.12.0
       * react-is.production.min.js
       *
       * Copyright (c) Facebook, Inc. and its affiliates.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      Object.defineProperty(exports, "__esModule", {
        value: !0
      });
      var b = "function" === typeof Symbol && Symbol.for,
          c = b ? Symbol.for("react.element") : 60103,
          d = b ? Symbol.for("react.portal") : 60106,
          e = b ? Symbol.for("react.fragment") : 60107,
          f = b ? Symbol.for("react.strict_mode") : 60108,
          g = b ? Symbol.for("react.profiler") : 60114,
          h = b ? Symbol.for("react.provider") : 60109,
          k = b ? Symbol.for("react.context") : 60110,
          l = b ? Symbol.for("react.async_mode") : 60111,
          m = b ? Symbol.for("react.concurrent_mode") : 60111,
          n = b ? Symbol.for("react.forward_ref") : 60112,
          p = b ? Symbol.for("react.suspense") : 60113,
          q = b ? Symbol.for("react.suspense_list") : 60120,
          r = b ? Symbol.for("react.memo") : 60115,
          t = b ? Symbol.for("react.lazy") : 60116,
          v = b ? Symbol.for("react.fundamental") : 60117,
          w = b ? Symbol.for("react.responder") : 60118,
          x = b ? Symbol.for("react.scope") : 60119;

      function y(a) {
        if ("object" === typeof a && null !== a) {
          var u = a.$$typeof;

          switch (u) {
            case c:
              switch (a = a.type, a) {
                case l:
                case m:
                case e:
                case g:
                case f:
                case p:
                  return a;

                default:
                  switch (a = a && a.$$typeof, a) {
                    case k:
                    case n:
                    case t:
                    case r:
                    case h:
                      return a;

                    default:
                      return u;
                  }

              }

            case d:
              return u;
          }
        }
      }

      function z(a) {
        return y(a) === m;
      }

      exports.typeOf = y;
      exports.AsyncMode = l;
      exports.ConcurrentMode = m;
      exports.ContextConsumer = k;
      exports.ContextProvider = h;
      exports.Element = c;
      exports.ForwardRef = n;
      exports.Fragment = e;
      exports.Lazy = t;
      exports.Memo = r;
      exports.Portal = d;
      exports.Profiler = g;
      exports.StrictMode = f;
      exports.Suspense = p;

      exports.isValidElementType = function (a) {
        return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === v || a.$$typeof === w || a.$$typeof === x);
      };

      exports.isAsyncMode = function (a) {
        return z(a) || y(a) === l;
      };

      exports.isConcurrentMode = z;

      exports.isContextConsumer = function (a) {
        return y(a) === k;
      };

      exports.isContextProvider = function (a) {
        return y(a) === h;
      };

      exports.isElement = function (a) {
        return "object" === typeof a && null !== a && a.$$typeof === c;
      };

      exports.isForwardRef = function (a) {
        return y(a) === n;
      };

      exports.isFragment = function (a) {
        return y(a) === e;
      };

      exports.isLazy = function (a) {
        return y(a) === t;
      };

      exports.isMemo = function (a) {
        return y(a) === r;
      };

      exports.isPortal = function (a) {
        return y(a) === d;
      };

      exports.isProfiler = function (a) {
        return y(a) === g;
      };

      exports.isStrictMode = function (a) {
        return y(a) === f;
      };

      exports.isSuspense = function (a) {
        return y(a) === p;
      };
      /***/

    },
    /* 197 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (process) {
        /** @license React v16.12.0
        * react-is.development.js
        *
        * Copyright (c) Facebook, Inc. and its affiliates.
        *
        * This source code is licensed under the MIT license found in the
        * LICENSE file in the root directory of this source tree.
        */
        if (process.env.NODE_ENV !== "production") {
          (function () {
            'use strict';

            Object.defineProperty(exports, '__esModule', {
              value: true
            }); // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
            // nor polyfill, then a plain number is used for performance.

            var hasSymbol = typeof Symbol === 'function' && Symbol.for;
            var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
            var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
            var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
            var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
            var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
            var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
            var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
            // (unstable) APIs that have been removed. Can we remove the symbols?

            var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
            var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
            var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
            var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
            var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
            var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
            var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
            var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
            var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
            var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

            function isValidElementType(type) {
              return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
              type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE);
            }
            /**
             * Forked from fbjs/warning:
             * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
             *
             * Only change is we use console.warn instead of console.error,
             * and do nothing when 'console' is not supported.
             * This really simplifies the code.
             * ---
             * Similar to invariant but only logs a warning if the condition is not met.
             * This can be used to log issues in development environments in critical
             * paths. Removing the logging code for production environments will keep the
             * same logic and follow the same code paths.
             */


            var lowPriorityWarningWithoutStack = function lowPriorityWarningWithoutStack() {};

            {
              var printWarning = function printWarning(format) {
                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  args[_key - 1] = arguments[_key];
                }

                var argIndex = 0;
                var message = 'Warning: ' + format.replace(/%s/g, function () {
                  return args[argIndex++];
                });

                if (typeof console !== 'undefined') {
                  console.warn(message);
                }

                try {
                  // --- Welcome to debugging React ---
                  // This error was thrown as a convenience so that you can use this stack
                  // to find the callsite that caused this warning to fire.
                  throw new Error(message);
                } catch (x) {}
              };

              lowPriorityWarningWithoutStack = function lowPriorityWarningWithoutStack(condition, format) {
                if (format === undefined) {
                  throw new Error('`lowPriorityWarningWithoutStack(condition, format, ...args)` requires a warning ' + 'message argument');
                }

                if (!condition) {
                  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
                    args[_key2 - 2] = arguments[_key2];
                  }

                  printWarning.apply(void 0, [format].concat(args));
                }
              };
            }
            var lowPriorityWarningWithoutStack$1 = lowPriorityWarningWithoutStack;

            function typeOf(object) {
              if (typeof object === 'object' && object !== null) {
                var $$typeof = object.$$typeof;

                switch ($$typeof) {
                  case REACT_ELEMENT_TYPE:
                    var type = object.type;

                    switch (type) {
                      case REACT_ASYNC_MODE_TYPE:
                      case REACT_CONCURRENT_MODE_TYPE:
                      case REACT_FRAGMENT_TYPE:
                      case REACT_PROFILER_TYPE:
                      case REACT_STRICT_MODE_TYPE:
                      case REACT_SUSPENSE_TYPE:
                        return type;

                      default:
                        var $$typeofType = type && type.$$typeof;

                        switch ($$typeofType) {
                          case REACT_CONTEXT_TYPE:
                          case REACT_FORWARD_REF_TYPE:
                          case REACT_LAZY_TYPE:
                          case REACT_MEMO_TYPE:
                          case REACT_PROVIDER_TYPE:
                            return $$typeofType;

                          default:
                            return $$typeof;
                        }

                    }

                  case REACT_PORTAL_TYPE:
                    return $$typeof;
                }
              }

              return undefined;
            } // AsyncMode is deprecated along with isAsyncMode


            var AsyncMode = REACT_ASYNC_MODE_TYPE;
            var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
            var ContextConsumer = REACT_CONTEXT_TYPE;
            var ContextProvider = REACT_PROVIDER_TYPE;
            var Element = REACT_ELEMENT_TYPE;
            var ForwardRef = REACT_FORWARD_REF_TYPE;
            var Fragment = REACT_FRAGMENT_TYPE;
            var Lazy = REACT_LAZY_TYPE;
            var Memo = REACT_MEMO_TYPE;
            var Portal = REACT_PORTAL_TYPE;
            var Profiler = REACT_PROFILER_TYPE;
            var StrictMode = REACT_STRICT_MODE_TYPE;
            var Suspense = REACT_SUSPENSE_TYPE;
            var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

            function isAsyncMode(object) {
              {
                if (!hasWarnedAboutDeprecatedIsAsyncMode) {
                  hasWarnedAboutDeprecatedIsAsyncMode = true;
                  lowPriorityWarningWithoutStack$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
                }
              }
              return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
            }

            function isConcurrentMode(object) {
              return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
            }

            function isContextConsumer(object) {
              return typeOf(object) === REACT_CONTEXT_TYPE;
            }

            function isContextProvider(object) {
              return typeOf(object) === REACT_PROVIDER_TYPE;
            }

            function isElement(object) {
              return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
            }

            function isForwardRef(object) {
              return typeOf(object) === REACT_FORWARD_REF_TYPE;
            }

            function isFragment(object) {
              return typeOf(object) === REACT_FRAGMENT_TYPE;
            }

            function isLazy(object) {
              return typeOf(object) === REACT_LAZY_TYPE;
            }

            function isMemo(object) {
              return typeOf(object) === REACT_MEMO_TYPE;
            }

            function isPortal(object) {
              return typeOf(object) === REACT_PORTAL_TYPE;
            }

            function isProfiler(object) {
              return typeOf(object) === REACT_PROFILER_TYPE;
            }

            function isStrictMode(object) {
              return typeOf(object) === REACT_STRICT_MODE_TYPE;
            }

            function isSuspense(object) {
              return typeOf(object) === REACT_SUSPENSE_TYPE;
            }

            exports.typeOf = typeOf;
            exports.AsyncMode = AsyncMode;
            exports.ConcurrentMode = ConcurrentMode;
            exports.ContextConsumer = ContextConsumer;
            exports.ContextProvider = ContextProvider;
            exports.Element = Element;
            exports.ForwardRef = ForwardRef;
            exports.Fragment = Fragment;
            exports.Lazy = Lazy;
            exports.Memo = Memo;
            exports.Portal = Portal;
            exports.Profiler = Profiler;
            exports.StrictMode = StrictMode;
            exports.Suspense = Suspense;
            exports.isValidElementType = isValidElementType;
            exports.isAsyncMode = isAsyncMode;
            exports.isConcurrentMode = isConcurrentMode;
            exports.isContextConsumer = isContextConsumer;
            exports.isContextProvider = isContextProvider;
            exports.isElement = isElement;
            exports.isForwardRef = isForwardRef;
            exports.isFragment = isFragment;
            exports.isLazy = isLazy;
            exports.isMemo = isMemo;
            exports.isPortal = isPortal;
            exports.isProfiler = isProfiler;
            exports.isStrictMode = isStrictMode;
            exports.isSuspense = isSuspense;
          })();
        }
        /* WEBPACK VAR INJECTION */

      }).call(exports, __webpack_require__(18));
      /***/
    },
    /* 198 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (process) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        *
        * This source code is licensed under the MIT license found in the
        * LICENSE file in the root directory of this source tree.
        */
        var ReactIs = __webpack_require__(99);

        var assign = __webpack_require__(199);

        var ReactPropTypesSecret = __webpack_require__(68);

        var checkPropTypes = __webpack_require__(200);

        var has = Function.call.bind(Object.prototype.hasOwnProperty);

        var printWarning = function printWarning() {};

        if (process.env.NODE_ENV !== 'production') {
          printWarning = function printWarning(text) {
            var message = 'Warning: ' + text;

            if (typeof console !== 'undefined') {
              console.error(message);
            }

            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };
        }

        function emptyFunctionThatReturnsNull() {
          return null;
        }

        module.exports = function (isValidElement, throwOnDirectAccess) {
          /* global Symbol */
          var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
          var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

          /**
           * Returns the iterator method function contained on the iterable object.
           *
           * Be sure to invoke the function with the iterable as context:
           *
           *     var iteratorFn = getIteratorFn(myIterable);
           *     if (iteratorFn) {
           *       var iterator = iteratorFn.call(myIterable);
           *       ...
           *     }
           *
           * @param {?object} maybeIterable
           * @return {?function}
           */

          function getIteratorFn(maybeIterable) {
            var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

            if (typeof iteratorFn === 'function') {
              return iteratorFn;
            }
          }
          /**
           * Collection of methods that allow declaration and validation of props that are
           * supplied to React components. Example usage:
           *
           *   var Props = require('ReactPropTypes');
           *   var MyArticle = React.createClass({
           *     propTypes: {
           *       // An optional string prop named "description".
           *       description: Props.string,
           *
           *       // A required enum prop named "category".
           *       category: Props.oneOf(['News','Photos']).isRequired,
           *
           *       // A prop named "dialog" that requires an instance of Dialog.
           *       dialog: Props.instanceOf(Dialog).isRequired
           *     },
           *     render: function() { ... }
           *   });
           *
           * A more formal specification of how these methods are used:
           *
           *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
           *   decl := ReactPropTypes.{type}(.isRequired)?
           *
           * Each and every declaration produces a function with the same signature. This
           * allows the creation of custom validation functions. For example:
           *
           *  var MyLink = React.createClass({
           *    propTypes: {
           *      // An optional string or URI prop named "href".
           *      href: function(props, propName, componentName) {
           *        var propValue = props[propName];
           *        if (propValue != null && typeof propValue !== 'string' &&
           *            !(propValue instanceof URI)) {
           *          return new Error(
           *            'Expected a string or an URI for ' + propName + ' in ' +
           *            componentName
           *          );
           *        }
           *      }
           *    },
           *    render: function() {...}
           *  });
           *
           * @internal
           */


          var ANONYMOUS = '<<anonymous>>'; // Important!
          // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

          var ReactPropTypes = {
            array: createPrimitiveTypeChecker('array'),
            bool: createPrimitiveTypeChecker('boolean'),
            func: createPrimitiveTypeChecker('function'),
            number: createPrimitiveTypeChecker('number'),
            object: createPrimitiveTypeChecker('object'),
            string: createPrimitiveTypeChecker('string'),
            symbol: createPrimitiveTypeChecker('symbol'),
            any: createAnyTypeChecker(),
            arrayOf: createArrayOfTypeChecker,
            element: createElementTypeChecker(),
            elementType: createElementTypeTypeChecker(),
            instanceOf: createInstanceTypeChecker,
            node: createNodeChecker(),
            objectOf: createObjectOfTypeChecker,
            oneOf: createEnumTypeChecker,
            oneOfType: createUnionTypeChecker,
            shape: createShapeTypeChecker,
            exact: createStrictShapeTypeChecker
          };
          /**
           * inlined Object.is polyfill to avoid requiring consumers ship their own
           * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
           */

          /*eslint-disable no-self-compare*/

          function is(x, y) {
            // SameValue algorithm
            if (x === y) {
              // Steps 1-5, 7-10
              // Steps 6.b-6.e: +0 != -0
              return x !== 0 || 1 / x === 1 / y;
            } else {
              // Step 6.a: NaN == NaN
              return x !== x && y !== y;
            }
          }
          /*eslint-enable no-self-compare*/

          /**
           * We use an Error-like object for backward compatibility as people may call
           * PropTypes directly and inspect their output. However, we don't use real
           * Errors anymore. We don't inspect their stack anyway, and creating them
           * is prohibitively expensive if they are created too often, such as what
           * happens in oneOfType() for any type before the one that matched.
           */


          function PropTypeError(message) {
            this.message = message;
            this.stack = '';
          } // Make `instanceof Error` still work for returned errors.


          PropTypeError.prototype = Error.prototype;

          function createChainableTypeChecker(validate) {
            if (process.env.NODE_ENV !== 'production') {
              var manualPropTypeCallCache = {};
              var manualPropTypeWarningCount = 0;
            }

            function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
              componentName = componentName || ANONYMOUS;
              propFullName = propFullName || propName;

              if (secret !== ReactPropTypesSecret) {
                if (throwOnDirectAccess) {
                  // New behavior only for users of `prop-types` package
                  var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
                  err.name = 'Invariant Violation';
                  throw err;
                } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
                  // Old behavior for people using React.PropTypes
                  var cacheKey = componentName + ':' + propName;

                  if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                  manualPropTypeWarningCount < 3) {
                    printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                    manualPropTypeCallCache[cacheKey] = true;
                    manualPropTypeWarningCount++;
                  }
                }
              }

              if (props[propName] == null) {
                if (isRequired) {
                  if (props[propName] === null) {
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                  }

                  return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }

                return null;
              } else {
                return validate(props, propName, componentName, location, propFullName);
              }
            }

            var chainedCheckType = checkType.bind(null, false);
            chainedCheckType.isRequired = checkType.bind(null, true);
            return chainedCheckType;
          }

          function createPrimitiveTypeChecker(expectedType) {
            function validate(props, propName, componentName, location, propFullName, secret) {
              var propValue = props[propName];
              var propType = getPropType(propValue);

              if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createAnyTypeChecker() {
            return createChainableTypeChecker(emptyFunctionThatReturnsNull);
          }

          function createArrayOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
              }

              var propValue = props[propName];

              if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
              }

              for (var i = 0; i < propValue.length; i++) {
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);

                if (error instanceof Error) {
                  return error;
                }
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createElementTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];

              if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createElementTypeTypeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];

              if (!ReactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createInstanceTypeChecker(expectedClass) {
            function validate(props, propName, componentName, location, propFullName) {
              if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createEnumTypeChecker(expectedValues) {
            if (!Array.isArray(expectedValues)) {
              if (process.env.NODE_ENV !== 'production') {
                if (arguments.length > 1) {
                  printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                } else {
                  printWarning('Invalid argument supplied to oneOf, expected an array.');
                }
              }

              return emptyFunctionThatReturnsNull;
            }

            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];

              for (var i = 0; i < expectedValues.length; i++) {
                if (is(propValue, expectedValues[i])) {
                  return null;
                }
              }

              var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);

                if (type === 'symbol') {
                  return String(value);
                }

                return value;
              });
              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
            }

            return createChainableTypeChecker(validate);
          }

          function createObjectOfTypeChecker(typeChecker) {
            function validate(props, propName, componentName, location, propFullName) {
              if (typeof typeChecker !== 'function') {
                return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
              }

              var propValue = props[propName];
              var propType = getPropType(propValue);

              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
              }

              for (var key in propValue) {
                if (has(propValue, key)) {
                  var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

                  if (error instanceof Error) {
                    return error;
                  }
                }
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createUnionTypeChecker(arrayOfTypeCheckers) {
            if (!Array.isArray(arrayOfTypeCheckers)) {
              process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
              return emptyFunctionThatReturnsNull;
            }

            for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
              var checker = arrayOfTypeCheckers[i];

              if (typeof checker !== 'function') {
                printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return emptyFunctionThatReturnsNull;
              }
            }

            function validate(props, propName, componentName, location, propFullName) {
              for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                var checker = arrayOfTypeCheckers[i];

                if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
                  return null;
                }
              }

              return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
            }

            return createChainableTypeChecker(validate);
          }

          function createNodeChecker() {
            function validate(props, propName, componentName, location, propFullName) {
              if (!isNode(props[propName])) {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              var propType = getPropType(propValue);

              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
              }

              for (var key in shapeTypes) {
                var checker = shapeTypes[key];

                if (!checker) {
                  continue;
                }

                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

                if (error) {
                  return error;
                }
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function createStrictShapeTypeChecker(shapeTypes) {
            function validate(props, propName, componentName, location, propFullName) {
              var propValue = props[propName];
              var propType = getPropType(propValue);

              if (propType !== 'object') {
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
              } // We need to check all keys in case some are required but missing from
              // props.


              var allKeys = assign({}, props[propName], shapeTypes);

              for (var key in allKeys) {
                var checker = shapeTypes[key];

                if (!checker) {
                  return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                }

                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);

                if (error) {
                  return error;
                }
              }

              return null;
            }

            return createChainableTypeChecker(validate);
          }

          function isNode(propValue) {
            switch (typeof propValue) {
              case 'number':
              case 'string':
              case 'undefined':
                return true;

              case 'boolean':
                return !propValue;

              case 'object':
                if (Array.isArray(propValue)) {
                  return propValue.every(isNode);
                }

                if (propValue === null || isValidElement(propValue)) {
                  return true;
                }

                var iteratorFn = getIteratorFn(propValue);

                if (iteratorFn) {
                  var iterator = iteratorFn.call(propValue);
                  var step;

                  if (iteratorFn !== propValue.entries) {
                    while (!(step = iterator.next()).done) {
                      if (!isNode(step.value)) {
                        return false;
                      }
                    }
                  } else {
                    // Iterator will provide entry [k,v] tuples rather than values.
                    while (!(step = iterator.next()).done) {
                      var entry = step.value;

                      if (entry) {
                        if (!isNode(entry[1])) {
                          return false;
                        }
                      }
                    }
                  }
                } else {
                  return false;
                }

                return true;

              default:
                return false;
            }
          }

          function isSymbol(propType, propValue) {
            // Native Symbol.
            if (propType === 'symbol') {
              return true;
            } // falsy value can't be a Symbol


            if (!propValue) {
              return false;
            } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


            if (propValue['@@toStringTag'] === 'Symbol') {
              return true;
            } // Fallback for non-spec compliant Symbols which are polyfilled.


            if (typeof Symbol === 'function' && propValue instanceof Symbol) {
              return true;
            }

            return false;
          } // Equivalent of `typeof` but with special handling for array and regexp.


          function getPropType(propValue) {
            var propType = typeof propValue;

            if (Array.isArray(propValue)) {
              return 'array';
            }

            if (propValue instanceof RegExp) {
              // Old webkits (at least until Android 4.0) return 'function' rather than
              // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
              // passes PropTypes.object.
              return 'object';
            }

            if (isSymbol(propType, propValue)) {
              return 'symbol';
            }

            return propType;
          } // This handles more types than `getPropType`. Only used for error messages.
          // See `createPrimitiveTypeChecker`.


          function getPreciseType(propValue) {
            if (typeof propValue === 'undefined' || propValue === null) {
              return '' + propValue;
            }

            var propType = getPropType(propValue);

            if (propType === 'object') {
              if (propValue instanceof Date) {
                return 'date';
              } else if (propValue instanceof RegExp) {
                return 'regexp';
              }
            }

            return propType;
          } // Returns a string that is postfixed to a warning about an invalid type.
          // For example, "undefined" or "of type array"


          function getPostfixForTypeWarning(value) {
            var type = getPreciseType(value);

            switch (type) {
              case 'array':
              case 'object':
                return 'an ' + type;

              case 'boolean':
              case 'date':
              case 'regexp':
                return 'a ' + type;

              default:
                return type;
            }
          } // Returns class name of the object, if any.


          function getClassName(propValue) {
            if (!propValue.constructor || !propValue.constructor.name) {
              return ANONYMOUS;
            }

            return propValue.constructor.name;
          }

          ReactPropTypes.checkPropTypes = checkPropTypes;
          ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
          ReactPropTypes.PropTypes = ReactPropTypes;
          return ReactPropTypes;
        };
        /* WEBPACK VAR INJECTION */

      }).call(exports, __webpack_require__(18));
      /***/
    },
    /* 199 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */

      /* eslint-disable no-unused-vars */

      var getOwnPropertySymbols = Object.getOwnPropertySymbols;
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var propIsEnumerable = Object.prototype.propertyIsEnumerable;

      function toObject(val) {
        if (val === null || val === undefined) {
          throw new TypeError('Object.assign cannot be called with null or undefined');
        }

        return Object(val);
      }

      function shouldUseNative() {
        try {
          if (!Object.assign) {
            return false;
          } // Detect buggy property enumeration order in older V8 versions.
          // https://bugs.chromium.org/p/v8/issues/detail?id=4118


          var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

          test1[5] = 'de';

          if (Object.getOwnPropertyNames(test1)[0] === '5') {
            return false;
          } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


          var test2 = {};

          for (var i = 0; i < 10; i++) {
            test2['_' + String.fromCharCode(i)] = i;
          }

          var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
            return test2[n];
          });

          if (order2.join('') !== '0123456789') {
            return false;
          } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


          var test3 = {};
          'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
            test3[letter] = letter;
          });

          if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
            return false;
          }

          return true;
        } catch (err) {
          // We don't expect any of the above to throw, but better to be safe.
          return false;
        }
      }

      module.exports = shouldUseNative() ? Object.assign : function (target, source) {
        var from;
        var to = toObject(target);
        var symbols;

        for (var s = 1; s < arguments.length; s++) {
          from = Object(arguments[s]);

          for (var key in from) {
            if (hasOwnProperty.call(from, key)) {
              to[key] = from[key];
            }
          }

          if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);

            for (var i = 0; i < symbols.length; i++) {
              if (propIsEnumerable.call(from, symbols[i])) {
                to[symbols[i]] = from[symbols[i]];
              }
            }
          }
        }

        return to;
      };
      /***/
    },
    /* 200 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (process) {
        /**
        * Copyright (c) 2013-present, Facebook, Inc.
        *
        * This source code is licensed under the MIT license found in the
        * LICENSE file in the root directory of this source tree.
        */
        var printWarning = function printWarning() {};

        if (process.env.NODE_ENV !== 'production') {
          var ReactPropTypesSecret = __webpack_require__(68);

          var loggedTypeFailures = {};
          var has = Function.call.bind(Object.prototype.hasOwnProperty);

          printWarning = function printWarning(text) {
            var message = 'Warning: ' + text;

            if (typeof console !== 'undefined') {
              console.error(message);
            }

            try {
              // --- Welcome to debugging React ---
              // This error was thrown as a convenience so that you can use this stack
              // to find the callsite that caused this warning to fire.
              throw new Error(message);
            } catch (x) {}
          };
        }
        /**
         * Assert that the values match with the type specs.
         * Error messages are memorized and will only be shown once.
         *
         * @param {object} typeSpecs Map of name to a ReactPropType
         * @param {object} values Runtime values that need to be type-checked
         * @param {string} location e.g. "prop", "context", "child context"
         * @param {string} componentName Name of the component for error messages.
         * @param {?Function} getStack Returns the component stack.
         * @private
         */


        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
          if (process.env.NODE_ENV !== 'production') {
            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error; // Prop type validation may throw. In case they do, we don't want to
                // fail the render phase where it didn't fail before. So we log it.
                // After these have been cleaned up, we'll let them throw.

                try {
                  // This is intentionally an invariant that gets caught. It's the same
                  // behavior as without this statement except with a better message.
                  if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.');
                    err.name = 'Invariant Violation';
                    throw err;
                  }

                  error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                } catch (ex) {
                  error = ex;
                }

                if (error && !(error instanceof Error)) {
                  printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
                }

                if (error instanceof Error && !(error.message in loggedTypeFailures)) {
                  // Only monitor this failure once because there tends to be a lot of the
                  // same error.
                  loggedTypeFailures[error.message] = true;
                  var stack = getStack ? getStack() : '';
                  printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
                }
              }
            }
          }
        }
        /**
         * Resets warning cache when testing.
         *
         * @private
         */


        checkPropTypes.resetWarningCache = function () {
          if (process.env.NODE_ENV !== 'production') {
            loggedTypeFailures = {};
          }
        };

        module.exports = checkPropTypes;
        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(18));
      /***/
    },
    /* 201 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Copyright (c) 2013-present, Facebook, Inc.
       *
       * This source code is licensed under the MIT license found in the
       * LICENSE file in the root directory of this source tree.
       */

      var ReactPropTypesSecret = __webpack_require__(68);

      function emptyFunction() {}

      function emptyFunctionWithReset() {}

      emptyFunctionWithReset.resetWarningCache = emptyFunction;

      module.exports = function () {
        function shim(props, propName, componentName, location, propFullName, secret) {
          if (secret === ReactPropTypesSecret) {
            // It is still safe when called from React.
            return;
          }

          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        }

        ;
        shim.isRequired = shim;

        function getShim() {
          return shim;
        }

        ; // Important!
        // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

        var ReactPropTypes = {
          array: shim,
          bool: shim,
          func: shim,
          number: shim,
          object: shim,
          string: shim,
          symbol: shim,
          any: shim,
          arrayOf: getShim,
          element: shim,
          elementType: shim,
          instanceOf: getShim,
          node: shim,
          objectOf: getShim,
          oneOf: getShim,
          oneOfType: getShim,
          shape: getShim,
          exact: getShim,
          checkPropTypes: emptyFunctionWithReset,
          resetWarningCache: emptyFunction
        };
        ReactPropTypes.PropTypes = ReactPropTypes;
        return ReactPropTypes;
      };
      /***/

    },
    /* 202 */

    /***/
    function (module, exports, __webpack_require__) {
      !function () {
        'use strict';

        function VNode() {}

        function h(nodeName, attributes) {
          var lastSimple,
              child,
              simple,
              i,
              children = EMPTY_CHILDREN;

          for (i = arguments.length; i-- > 2;) {
            stack.push(arguments[i]);
          }

          if (attributes && null != attributes.children) {
            if (!stack.length) stack.push(attributes.children);
            delete attributes.children;
          }

          while (stack.length) {
            if ((child = stack.pop()) && void 0 !== child.pop) for (i = child.length; i--;) {
              stack.push(child[i]);
            } else {
              if (child === !0 || child === !1) child = null;
              if (simple = 'function' != typeof nodeName) if (null == child) child = '';else if ('number' == typeof child) child = String(child);else if ('string' != typeof child) simple = !1;
              if (simple && lastSimple) children[children.length - 1] += child;else if (children === EMPTY_CHILDREN) children = [child];else children.push(child);
              lastSimple = simple;
            }
          }

          var p = new VNode();
          p.nodeName = nodeName;
          p.children = children;
          p.attributes = null == attributes ? void 0 : attributes;
          p.key = null == attributes ? void 0 : attributes.key;
          if (void 0 !== options.vnode) options.vnode(p);
          return p;
        }

        function extend(obj, props) {
          for (var i in props) {
            obj[i] = props[i];
          }

          return obj;
        }

        function cloneElement(vnode, props) {
          return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
        }

        function enqueueRender(component) {
          if (!component.__d && (component.__d = !0) && 1 == items.push(component)) (options.debounceRendering || setTimeout)(rerender);
        }

        function rerender() {
          var p,
              list = items;
          items = [];

          while (p = list.pop()) {
            if (p.__d) renderComponent(p);
          }
        }

        function isSameNodeType(node, vnode, hydrating) {
          if ('string' == typeof vnode || 'number' == typeof vnode) return void 0 !== node.splitText;
          if ('string' == typeof vnode.nodeName) return !node._componentConstructor && isNamedNode(node, vnode.nodeName);else return hydrating || node._componentConstructor === vnode.nodeName;
        }

        function isNamedNode(node, nodeName) {
          return node.__n === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
        }

        function getNodeProps(vnode) {
          var props = extend({}, vnode.attributes);
          props.children = vnode.children;
          var defaultProps = vnode.nodeName.defaultProps;
          if (void 0 !== defaultProps) for (var i in defaultProps) {
            if (void 0 === props[i]) props[i] = defaultProps[i];
          }
          return props;
        }

        function createNode(nodeName, isSvg) {
          var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
          node.__n = nodeName;
          return node;
        }

        function removeNode(node) {
          if (node.parentNode) node.parentNode.removeChild(node);
        }

        function setAccessor(node, name, old, value, isSvg) {
          if ('className' === name) name = 'class';
          if ('key' === name) ;else if ('ref' === name) {
            if (old) old(null);
            if (value) value(node);
          } else if ('class' === name && !isSvg) node.className = value || '';else if ('style' === name) {
            if (!value || 'string' == typeof value || 'string' == typeof old) node.style.cssText = value || '';

            if (value && 'object' == typeof value) {
              if ('string' != typeof old) for (var i in old) {
                if (!(i in value)) node.style[i] = '';
              }

              for (var i in value) {
                node.style[i] = 'number' == typeof value[i] && IS_NON_DIMENSIONAL.test(i) === !1 ? value[i] + 'px' : value[i];
              }
            }
          } else if ('dangerouslySetInnerHTML' === name) {
            if (value) node.innerHTML = value.__html || '';
          } else if ('o' == name[0] && 'n' == name[1]) {
            var useCapture = name !== (name = name.replace(/Capture$/, ''));
            name = name.toLowerCase().substring(2);

            if (value) {
              if (!old) node.addEventListener(name, eventProxy, useCapture);
            } else node.removeEventListener(name, eventProxy, useCapture);

            (node.__l || (node.__l = {}))[name] = value;
          } else if ('list' !== name && 'type' !== name && !isSvg && name in node) {
            setProperty(node, name, null == value ? '' : value);
            if (null == value || value === !1) node.removeAttribute(name);
          } else {
            var ns = isSvg && name !== (name = name.replace(/^xlink\:?/, ''));
            if (null == value || value === !1) {
              if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
            } else if ('function' != typeof value) if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
          }
        }

        function setProperty(node, name, value) {
          try {
            node[name] = value;
          } catch (e) {}
        }

        function eventProxy(e) {
          return this.__l[e.type](options.event && options.event(e) || e);
        }

        function flushMounts() {
          var c;

          while (c = mounts.pop()) {
            if (options.afterMount) options.afterMount(c);
            if (c.componentDidMount) c.componentDidMount();
          }
        }

        function diff(dom, vnode, context, mountAll, parent, componentRoot) {
          if (!diffLevel++) {
            isSvgMode = null != parent && void 0 !== parent.ownerSVGElement;
            hydrating = null != dom && !('__preactattr_' in dom);
          }

          var ret = idiff(dom, vnode, context, mountAll, componentRoot);
          if (parent && ret.parentNode !== parent) parent.appendChild(ret);

          if (! --diffLevel) {
            hydrating = !1;
            if (!componentRoot) flushMounts();
          }

          return ret;
        }

        function idiff(dom, vnode, context, mountAll, componentRoot) {
          var out = dom,
              prevSvgMode = isSvgMode;
          if (null == vnode) vnode = '';

          if ('string' == typeof vnode) {
            if (dom && void 0 !== dom.splitText && dom.parentNode && (!dom._component || componentRoot)) {
              if (dom.nodeValue != vnode) dom.nodeValue = vnode;
            } else {
              out = document.createTextNode(vnode);

              if (dom) {
                if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
                recollectNodeTree(dom, !0);
              }
            }

            out.__preactattr_ = !0;
            return out;
          }

          if ('function' == typeof vnode.nodeName) return buildComponentFromVNode(dom, vnode, context, mountAll);
          isSvgMode = 'svg' === vnode.nodeName ? !0 : 'foreignObject' === vnode.nodeName ? !1 : isSvgMode;

          if (!dom || !isNamedNode(dom, String(vnode.nodeName))) {
            out = createNode(String(vnode.nodeName), isSvgMode);

            if (dom) {
              while (dom.firstChild) {
                out.appendChild(dom.firstChild);
              }

              if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
              recollectNodeTree(dom, !0);
            }
          }

          var fc = out.firstChild,
              props = out.__preactattr_ || (out.__preactattr_ = {}),
              vchildren = vnode.children;

          if (!hydrating && vchildren && 1 === vchildren.length && 'string' == typeof vchildren[0] && null != fc && void 0 !== fc.splitText && null == fc.nextSibling) {
            if (fc.nodeValue != vchildren[0]) fc.nodeValue = vchildren[0];
          } else if (vchildren && vchildren.length || null != fc) innerDiffNode(out, vchildren, context, mountAll, hydrating || null != props.dangerouslySetInnerHTML);

          diffAttributes(out, vnode.attributes, props);
          isSvgMode = prevSvgMode;
          return out;
        }

        function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
          var j,
              c,
              vchild,
              child,
              originalChildren = dom.childNodes,
              children = [],
              keyed = {},
              keyedLen = 0,
              min = 0,
              len = originalChildren.length,
              childrenLen = 0,
              vlen = vchildren ? vchildren.length : 0;
          if (0 !== len) for (var i = 0; i < len; i++) {
            var _child = originalChildren[i],
                props = _child.__preactattr_,
                key = vlen && props ? _child._component ? _child._component.__k : props.key : null;

            if (null != key) {
              keyedLen++;
              keyed[key] = _child;
            } else if (props || (void 0 !== _child.splitText ? isHydrating ? _child.nodeValue.trim() : !0 : isHydrating)) children[childrenLen++] = _child;
          }
          if (0 !== vlen) for (var i = 0; i < vlen; i++) {
            vchild = vchildren[i];
            child = null;
            var key = vchild.key;

            if (null != key) {
              if (keyedLen && void 0 !== keyed[key]) {
                child = keyed[key];
                keyed[key] = void 0;
                keyedLen--;
              }
            } else if (!child && min < childrenLen) for (j = min; j < childrenLen; j++) {
              if (void 0 !== children[j] && isSameNodeType(c = children[j], vchild, isHydrating)) {
                child = c;
                children[j] = void 0;
                if (j === childrenLen - 1) childrenLen--;
                if (j === min) min++;
                break;
              }
            }

            child = idiff(child, vchild, context, mountAll);
            if (child && child !== dom) if (i >= len) dom.appendChild(child);else if (child !== originalChildren[i]) if (child === originalChildren[i + 1]) removeNode(originalChildren[i]);else dom.insertBefore(child, originalChildren[i] || null);
          }
          if (keyedLen) for (var i in keyed) {
            if (void 0 !== keyed[i]) recollectNodeTree(keyed[i], !1);
          }

          while (min <= childrenLen) {
            if (void 0 !== (child = children[childrenLen--])) recollectNodeTree(child, !1);
          }
        }

        function recollectNodeTree(node, unmountOnly) {
          var component = node._component;
          if (component) unmountComponent(component);else {
            if (null != node.__preactattr_ && node.__preactattr_.ref) node.__preactattr_.ref(null);
            if (unmountOnly === !1 || null == node.__preactattr_) removeNode(node);
            removeChildren(node);
          }
        }

        function removeChildren(node) {
          node = node.lastChild;

          while (node) {
            var next = node.previousSibling;
            recollectNodeTree(node, !0);
            node = next;
          }
        }

        function diffAttributes(dom, attrs, old) {
          var name;

          for (name in old) {
            if ((!attrs || null == attrs[name]) && null != old[name]) setAccessor(dom, name, old[name], old[name] = void 0, isSvgMode);
          }

          for (name in attrs) {
            if (!('children' === name || 'innerHTML' === name || name in old && attrs[name] === ('value' === name || 'checked' === name ? dom[name] : old[name]))) setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
          }
        }

        function collectComponent(component) {
          var name = component.constructor.name;
          (components[name] || (components[name] = [])).push(component);
        }

        function createComponent(Ctor, props, context) {
          var inst,
              list = components[Ctor.name];

          if (Ctor.prototype && Ctor.prototype.render) {
            inst = new Ctor(props, context);
            Component.call(inst, props, context);
          } else {
            inst = new Component(props, context);
            inst.constructor = Ctor;
            inst.render = doRender;
          }

          if (list) for (var i = list.length; i--;) {
            if (list[i].constructor === Ctor) {
              inst.__b = list[i].__b;
              list.splice(i, 1);
              break;
            }
          }
          return inst;
        }

        function doRender(props, state, context) {
          return this.constructor(props, context);
        }

        function setComponentProps(component, props, opts, context, mountAll) {
          if (!component.__x) {
            component.__x = !0;
            if (component.__r = props.ref) delete props.ref;
            if (component.__k = props.key) delete props.key;

            if (!component.base || mountAll) {
              if (component.componentWillMount) component.componentWillMount();
            } else if (component.componentWillReceiveProps) component.componentWillReceiveProps(props, context);

            if (context && context !== component.context) {
              if (!component.__c) component.__c = component.context;
              component.context = context;
            }

            if (!component.__p) component.__p = component.props;
            component.props = props;
            component.__x = !1;
            if (0 !== opts) if (1 === opts || options.syncComponentUpdates !== !1 || !component.base) renderComponent(component, 1, mountAll);else enqueueRender(component);
            if (component.__r) component.__r(component);
          }
        }

        function renderComponent(component, opts, mountAll, isChild) {
          if (!component.__x) {
            var rendered,
                inst,
                cbase,
                props = component.props,
                state = component.state,
                context = component.context,
                previousProps = component.__p || props,
                previousState = component.__s || state,
                previousContext = component.__c || context,
                isUpdate = component.base,
                nextBase = component.__b,
                initialBase = isUpdate || nextBase,
                initialChildComponent = component._component,
                skip = !1;

            if (isUpdate) {
              component.props = previousProps;
              component.state = previousState;
              component.context = previousContext;
              if (2 !== opts && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === !1) skip = !0;else if (component.componentWillUpdate) component.componentWillUpdate(props, state, context);
              component.props = props;
              component.state = state;
              component.context = context;
            }

            component.__p = component.__s = component.__c = component.__b = null;
            component.__d = !1;

            if (!skip) {
              rendered = component.render(props, state, context);
              if (component.getChildContext) context = extend(extend({}, context), component.getChildContext());
              var toUnmount,
                  base,
                  childComponent = rendered && rendered.nodeName;

              if ('function' == typeof childComponent) {
                var childProps = getNodeProps(rendered);
                inst = initialChildComponent;
                if (inst && inst.constructor === childComponent && childProps.key == inst.__k) setComponentProps(inst, childProps, 1, context, !1);else {
                  toUnmount = inst;
                  component._component = inst = createComponent(childComponent, childProps, context);
                  inst.__b = inst.__b || nextBase;
                  inst.__u = component;
                  setComponentProps(inst, childProps, 0, context, !1);
                  renderComponent(inst, 1, mountAll, !0);
                }
                base = inst.base;
              } else {
                cbase = initialBase;
                toUnmount = initialChildComponent;
                if (toUnmount) cbase = component._component = null;

                if (initialBase || 1 === opts) {
                  if (cbase) cbase._component = null;
                  base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, !0);
                }
              }

              if (initialBase && base !== initialBase && inst !== initialChildComponent) {
                var baseParent = initialBase.parentNode;

                if (baseParent && base !== baseParent) {
                  baseParent.replaceChild(base, initialBase);

                  if (!toUnmount) {
                    initialBase._component = null;
                    recollectNodeTree(initialBase, !1);
                  }
                }
              }

              if (toUnmount) unmountComponent(toUnmount);
              component.base = base;

              if (base && !isChild) {
                var componentRef = component,
                    t = component;

                while (t = t.__u) {
                  (componentRef = t).base = base;
                }

                base._component = componentRef;
                base._componentConstructor = componentRef.constructor;
              }
            }

            if (!isUpdate || mountAll) mounts.unshift(component);else if (!skip) {
              flushMounts();
              if (component.componentDidUpdate) component.componentDidUpdate(previousProps, previousState, previousContext);
              if (options.afterUpdate) options.afterUpdate(component);
            }
            if (null != component.__h) while (component.__h.length) {
              component.__h.pop().call(component);
            }
            if (!diffLevel && !isChild) flushMounts();
          }
        }

        function buildComponentFromVNode(dom, vnode, context, mountAll) {
          var c = dom && dom._component,
              originalComponent = c,
              oldDom = dom,
              isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
              isOwner = isDirectOwner,
              props = getNodeProps(vnode);

          while (c && !isOwner && (c = c.__u)) {
            isOwner = c.constructor === vnode.nodeName;
          }

          if (c && isOwner && (!mountAll || c._component)) {
            setComponentProps(c, props, 3, context, mountAll);
            dom = c.base;
          } else {
            if (originalComponent && !isDirectOwner) {
              unmountComponent(originalComponent);
              dom = oldDom = null;
            }

            c = createComponent(vnode.nodeName, props, context);

            if (dom && !c.__b) {
              c.__b = dom;
              oldDom = null;
            }

            setComponentProps(c, props, 1, context, mountAll);
            dom = c.base;

            if (oldDom && dom !== oldDom) {
              oldDom._component = null;
              recollectNodeTree(oldDom, !1);
            }
          }

          return dom;
        }

        function unmountComponent(component) {
          if (options.beforeUnmount) options.beforeUnmount(component);
          var base = component.base;
          component.__x = !0;
          if (component.componentWillUnmount) component.componentWillUnmount();
          component.base = null;
          var inner = component._component;
          if (inner) unmountComponent(inner);else if (base) {
            if (base.__preactattr_ && base.__preactattr_.ref) base.__preactattr_.ref(null);
            component.__b = base;
            removeNode(base);
            collectComponent(component);
            removeChildren(base);
          }
          if (component.__r) component.__r(null);
        }

        function Component(props, context) {
          this.__d = !0;
          this.context = context;
          this.props = props;
          this.state = this.state || {};
        }

        function render(vnode, parent, merge) {
          return diff(merge, vnode, {}, !1, parent, !1);
        }

        var options = {};
        var stack = [];
        var EMPTY_CHILDREN = [];
        var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;
        var items = [];
        var mounts = [];
        var diffLevel = 0;
        var isSvgMode = !1;
        var hydrating = !1;
        var components = {};
        extend(Component.prototype, {
          setState: function setState(state, callback) {
            var s = this.state;
            if (!this.__s) this.__s = extend({}, s);
            extend(s, 'function' == typeof state ? state(s, this.props) : state);
            if (callback) (this.__h = this.__h || []).push(callback);
            enqueueRender(this);
          },
          forceUpdate: function forceUpdate(callback) {
            if (callback) (this.__h = this.__h || []).push(callback);
            renderComponent(this, 2);
          },
          render: function render() {}
        });
        var preact = {
          h: h,
          createElement: h,
          cloneElement: cloneElement,
          Component: Component,
          render: render,
          rerender: rerender,
          options: options
        };
        if (true) module.exports = preact;else self.preact = preact;
      }();
      /***/
    },
    /* 203 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // This file can be required in Browserify and Node.js for automatic polyfill
      // To use it:  require('es6-promise/auto');

      module.exports = __webpack_require__(204).polyfill();
      /***/
    },
    /* 204 */

    /***/
    function (module, exports, __webpack_require__) {
      /* WEBPACK VAR INJECTION */
      (function (process, global) {
        var require;
        /*!
        * @overview es6-promise - a tiny implementation of Promises/A+.
        * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
        * @license   Licensed under MIT license
        *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
        * @version   4.1.1
        */


        (function (global, factory) {
          true ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.ES6Promise = factory();
        })(this, function () {
          'use strict';

          function objectOrFunction(x) {
            var type = typeof x;
            return x !== null && (type === 'object' || type === 'function');
          }

          function isFunction(x) {
            return typeof x === 'function';
          }

          var _isArray = undefined;

          if (Array.isArray) {
            _isArray = Array.isArray;
          } else {
            _isArray = function _isArray(x) {
              return Object.prototype.toString.call(x) === '[object Array]';
            };
          }

          var isArray = _isArray;
          var len = 0;
          var vertxNext = undefined;
          var customSchedulerFn = undefined;

          var asap = function asap(callback, arg) {
            queue[len] = callback;
            queue[len + 1] = arg;
            len += 2;

            if (len === 2) {
              // If len is 2, that means that we need to schedule an async flush.
              // If additional callbacks are queued before the queue is flushed, they
              // will be processed by this flush that we are scheduling.
              if (customSchedulerFn) {
                customSchedulerFn(flush);
              } else {
                scheduleFlush();
              }
            }
          };

          function setScheduler(scheduleFn) {
            customSchedulerFn = scheduleFn;
          }

          function setAsap(asapFn) {
            asap = asapFn;
          }

          var browserWindow = typeof window !== 'undefined' ? window : undefined;
          var browserGlobal = browserWindow || {};
          var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
          var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]'; // test for web worker but not in IE10

          var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined'; // node

          function useNextTick() {
            // node version 0.10.x displays a deprecation warning when nextTick is used recursively
            // see https://github.com/cujojs/when/issues/410 for details
            return function () {
              return process.nextTick(flush);
            };
          } // vertx


          function useVertxTimer() {
            if (typeof vertxNext !== 'undefined') {
              return function () {
                vertxNext(flush);
              };
            }

            return useSetTimeout();
          }

          function useMutationObserver() {
            var iterations = 0;
            var observer = new BrowserMutationObserver(flush);
            var node = document.createTextNode('');
            observer.observe(node, {
              characterData: true
            });
            return function () {
              node.data = iterations = ++iterations % 2;
            };
          } // web worker


          function useMessageChannel() {
            var channel = new MessageChannel();
            channel.port1.onmessage = flush;
            return function () {
              return channel.port2.postMessage(0);
            };
          }

          function useSetTimeout() {
            // Store setTimeout reference so es6-promise will be unaffected by
            // other code modifying setTimeout (like sinon.useFakeTimers())
            var globalSetTimeout = setTimeout;
            return function () {
              return globalSetTimeout(flush, 1);
            };
          }

          var queue = new Array(1000);

          function flush() {
            for (var i = 0; i < len; i += 2) {
              var callback = queue[i];
              var arg = queue[i + 1];
              callback(arg);
              queue[i] = undefined;
              queue[i + 1] = undefined;
            }

            len = 0;
          }

          function attemptVertx() {
            try {
              var r = require;

              var vertx = __webpack_require__(206);

              vertxNext = vertx.runOnLoop || vertx.runOnContext;
              return useVertxTimer();
            } catch (e) {
              return useSetTimeout();
            }
          }

          var scheduleFlush = undefined; // Decide what async method to use to triggering processing of queued callbacks:

          if (isNode) {
            scheduleFlush = useNextTick();
          } else if (BrowserMutationObserver) {
            scheduleFlush = useMutationObserver();
          } else if (isWorker) {
            scheduleFlush = useMessageChannel();
          } else if (browserWindow === undefined && "function" === 'function') {
            scheduleFlush = attemptVertx();
          } else {
            scheduleFlush = useSetTimeout();
          }

          function then(onFulfillment, onRejection) {
            var _arguments = arguments;
            var parent = this;
            var child = new this.constructor(noop);

            if (child[PROMISE_ID] === undefined) {
              makePromise(child);
            }

            var _state = parent._state;

            if (_state) {
              (function () {
                var callback = _arguments[_state - 1];
                asap(function () {
                  return invokeCallback(_state, child, callback, parent._result);
                });
              })();
            } else {
              subscribe(parent, child, onFulfillment, onRejection);
            }

            return child;
          }
          /**
            `Promise.resolve` returns a promise that will become resolved with the
            passed `value`. It is shorthand for the following:
          
            ```javascript
            let promise = new Promise(function(resolve, reject){
              resolve(1);
            });
          
            promise.then(function(value){
              // value === 1
            });
            ```
          
            Instead of writing the above, your code now simply becomes the following:
          
            ```javascript
            let promise = Promise.resolve(1);
          
            promise.then(function(value){
              // value === 1
            });
            ```
          
            @method resolve
            @static
            @param {Any} value value that the returned promise will be resolved with
            Useful for tooling.
            @return {Promise} a promise that will become fulfilled with the given
            `value`
          */


          function resolve$1(object) {
            /*jshint validthis:true */
            var Constructor = this;

            if (object && typeof object === 'object' && object.constructor === Constructor) {
              return object;
            }

            var promise = new Constructor(noop);
            resolve(promise, object);
            return promise;
          }

          var PROMISE_ID = Math.random().toString(36).substring(16);

          function noop() {}

          var PENDING = void 0;
          var FULFILLED = 1;
          var REJECTED = 2;
          var GET_THEN_ERROR = new ErrorObject();

          function selfFulfillment() {
            return new TypeError("You cannot resolve a promise with itself");
          }

          function cannotReturnOwn() {
            return new TypeError('A promises callback cannot return that same promise.');
          }

          function getThen(promise) {
            try {
              return promise.then;
            } catch (error) {
              GET_THEN_ERROR.error = error;
              return GET_THEN_ERROR;
            }
          }

          function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
            try {
              then$$1.call(value, fulfillmentHandler, rejectionHandler);
            } catch (e) {
              return e;
            }
          }

          function handleForeignThenable(promise, thenable, then$$1) {
            asap(function (promise) {
              var sealed = false;
              var error = tryThen(then$$1, thenable, function (value) {
                if (sealed) {
                  return;
                }

                sealed = true;

                if (thenable !== value) {
                  resolve(promise, value);
                } else {
                  fulfill(promise, value);
                }
              }, function (reason) {
                if (sealed) {
                  return;
                }

                sealed = true;
                reject(promise, reason);
              }, 'Settle: ' + (promise._label || ' unknown promise'));

              if (!sealed && error) {
                sealed = true;
                reject(promise, error);
              }
            }, promise);
          }

          function handleOwnThenable(promise, thenable) {
            if (thenable._state === FULFILLED) {
              fulfill(promise, thenable._result);
            } else if (thenable._state === REJECTED) {
              reject(promise, thenable._result);
            } else {
              subscribe(thenable, undefined, function (value) {
                return resolve(promise, value);
              }, function (reason) {
                return reject(promise, reason);
              });
            }
          }

          function handleMaybeThenable(promise, maybeThenable, then$$1) {
            if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
              handleOwnThenable(promise, maybeThenable);
            } else {
              if (then$$1 === GET_THEN_ERROR) {
                reject(promise, GET_THEN_ERROR.error);
                GET_THEN_ERROR.error = null;
              } else if (then$$1 === undefined) {
                fulfill(promise, maybeThenable);
              } else if (isFunction(then$$1)) {
                handleForeignThenable(promise, maybeThenable, then$$1);
              } else {
                fulfill(promise, maybeThenable);
              }
            }
          }

          function resolve(promise, value) {
            if (promise === value) {
              reject(promise, selfFulfillment());
            } else if (objectOrFunction(value)) {
              handleMaybeThenable(promise, value, getThen(value));
            } else {
              fulfill(promise, value);
            }
          }

          function publishRejection(promise) {
            if (promise._onerror) {
              promise._onerror(promise._result);
            }

            publish(promise);
          }

          function fulfill(promise, value) {
            if (promise._state !== PENDING) {
              return;
            }

            promise._result = value;
            promise._state = FULFILLED;

            if (promise._subscribers.length !== 0) {
              asap(publish, promise);
            }
          }

          function reject(promise, reason) {
            if (promise._state !== PENDING) {
              return;
            }

            promise._state = REJECTED;
            promise._result = reason;
            asap(publishRejection, promise);
          }

          function subscribe(parent, child, onFulfillment, onRejection) {
            var _subscribers = parent._subscribers;
            var length = _subscribers.length;
            parent._onerror = null;
            _subscribers[length] = child;
            _subscribers[length + FULFILLED] = onFulfillment;
            _subscribers[length + REJECTED] = onRejection;

            if (length === 0 && parent._state) {
              asap(publish, parent);
            }
          }

          function publish(promise) {
            var subscribers = promise._subscribers;
            var settled = promise._state;

            if (subscribers.length === 0) {
              return;
            }

            var child = undefined,
                callback = undefined,
                detail = promise._result;

            for (var i = 0; i < subscribers.length; i += 3) {
              child = subscribers[i];
              callback = subscribers[i + settled];

              if (child) {
                invokeCallback(settled, child, callback, detail);
              } else {
                callback(detail);
              }
            }

            promise._subscribers.length = 0;
          }

          function ErrorObject() {
            this.error = null;
          }

          var TRY_CATCH_ERROR = new ErrorObject();

          function tryCatch(callback, detail) {
            try {
              return callback(detail);
            } catch (e) {
              TRY_CATCH_ERROR.error = e;
              return TRY_CATCH_ERROR;
            }
          }

          function invokeCallback(settled, promise, callback, detail) {
            var hasCallback = isFunction(callback),
                value = undefined,
                error = undefined,
                succeeded = undefined,
                failed = undefined;

            if (hasCallback) {
              value = tryCatch(callback, detail);

              if (value === TRY_CATCH_ERROR) {
                failed = true;
                error = value.error;
                value.error = null;
              } else {
                succeeded = true;
              }

              if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
              }
            } else {
              value = detail;
              succeeded = true;
            }

            if (promise._state !== PENDING) {// noop
            } else if (hasCallback && succeeded) {
              resolve(promise, value);
            } else if (failed) {
              reject(promise, error);
            } else if (settled === FULFILLED) {
              fulfill(promise, value);
            } else if (settled === REJECTED) {
              reject(promise, value);
            }
          }

          function initializePromise(promise, resolver) {
            try {
              resolver(function resolvePromise(value) {
                resolve(promise, value);
              }, function rejectPromise(reason) {
                reject(promise, reason);
              });
            } catch (e) {
              reject(promise, e);
            }
          }

          var id = 0;

          function nextId() {
            return id++;
          }

          function makePromise(promise) {
            promise[PROMISE_ID] = id++;
            promise._state = undefined;
            promise._result = undefined;
            promise._subscribers = [];
          }

          function Enumerator$1(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);

            if (!this.promise[PROMISE_ID]) {
              makePromise(this.promise);
            }

            if (isArray(input)) {
              this.length = input.length;
              this._remaining = input.length;
              this._result = new Array(this.length);

              if (this.length === 0) {
                fulfill(this.promise, this._result);
              } else {
                this.length = this.length || 0;

                this._enumerate(input);

                if (this._remaining === 0) {
                  fulfill(this.promise, this._result);
                }
              }
            } else {
              reject(this.promise, validationError());
            }
          }

          function validationError() {
            return new Error('Array Methods must be provided an Array');
          }

          Enumerator$1.prototype._enumerate = function (input) {
            for (var i = 0; this._state === PENDING && i < input.length; i++) {
              this._eachEntry(input[i], i);
            }
          };

          Enumerator$1.prototype._eachEntry = function (entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;

            if (resolve$$1 === resolve$1) {
              var _then = getThen(entry);

              if (_then === then && entry._state !== PENDING) {
                this._settledAt(entry._state, i, entry._result);
              } else if (typeof _then !== 'function') {
                this._remaining--;
                this._result[i] = entry;
              } else if (c === Promise$2) {
                var promise = new c(noop);
                handleMaybeThenable(promise, entry, _then);

                this._willSettleAt(promise, i);
              } else {
                this._willSettleAt(new c(function (resolve$$1) {
                  return resolve$$1(entry);
                }), i);
              }
            } else {
              this._willSettleAt(resolve$$1(entry), i);
            }
          };

          Enumerator$1.prototype._settledAt = function (state, i, value) {
            var promise = this.promise;

            if (promise._state === PENDING) {
              this._remaining--;

              if (state === REJECTED) {
                reject(promise, value);
              } else {
                this._result[i] = value;
              }
            }

            if (this._remaining === 0) {
              fulfill(promise, this._result);
            }
          };

          Enumerator$1.prototype._willSettleAt = function (promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function (value) {
              return enumerator._settledAt(FULFILLED, i, value);
            }, function (reason) {
              return enumerator._settledAt(REJECTED, i, reason);
            });
          };
          /**
            `Promise.all` accepts an array of promises, and returns a new promise which
            is fulfilled with an array of fulfillment values for the passed promises, or
            rejected with the reason of the first passed promise to be rejected. It casts all
            elements of the passed iterable to promises as it runs this algorithm.
          
            Example:
          
            ```javascript
            let promise1 = resolve(1);
            let promise2 = resolve(2);
            let promise3 = resolve(3);
            let promises = [ promise1, promise2, promise3 ];
          
            Promise.all(promises).then(function(array){
              // The array here would be [ 1, 2, 3 ];
            });
            ```
          
            If any of the `promises` given to `all` are rejected, the first promise
            that is rejected will be given as an argument to the returned promises's
            rejection handler. For example:
          
            Example:
          
            ```javascript
            let promise1 = resolve(1);
            let promise2 = reject(new Error("2"));
            let promise3 = reject(new Error("3"));
            let promises = [ promise1, promise2, promise3 ];
          
            Promise.all(promises).then(function(array){
              // Code here never runs because there are rejected promises!
            }, function(error) {
              // error.message === "2"
            });
            ```
          
            @method all
            @static
            @param {Array} entries array of promises
            @param {String} label optional string for labeling the promise.
            Useful for tooling.
            @return {Promise} promise that is fulfilled when all `promises` have been
            fulfilled, or rejected if any of them become rejected.
            @static
          */


          function all$1(entries) {
            return new Enumerator$1(this, entries).promise;
          }
          /**
            `Promise.race` returns a new promise which is settled in the same way as the
            first passed promise to settle.
          
            Example:
          
            ```javascript
            let promise1 = new Promise(function(resolve, reject){
              setTimeout(function(){
                resolve('promise 1');
              }, 200);
            });
          
            let promise2 = new Promise(function(resolve, reject){
              setTimeout(function(){
                resolve('promise 2');
              }, 100);
            });
          
            Promise.race([promise1, promise2]).then(function(result){
              // result === 'promise 2' because it was resolved before promise1
              // was resolved.
            });
            ```
          
            `Promise.race` is deterministic in that only the state of the first
            settled promise matters. For example, even if other promises given to the
            `promises` array argument are resolved, but the first settled promise has
            become rejected before the other promises became fulfilled, the returned
            promise will become rejected:
          
            ```javascript
            let promise1 = new Promise(function(resolve, reject){
              setTimeout(function(){
                resolve('promise 1');
              }, 200);
            });
          
            let promise2 = new Promise(function(resolve, reject){
              setTimeout(function(){
                reject(new Error('promise 2'));
              }, 100);
            });
          
            Promise.race([promise1, promise2]).then(function(result){
              // Code here never runs
            }, function(reason){
              // reason.message === 'promise 2' because promise 2 became rejected before
              // promise 1 became fulfilled
            });
            ```
          
            An example real-world use case is implementing timeouts:
          
            ```javascript
            Promise.race([ajax('foo.json'), timeout(5000)])
            ```
          
            @method race
            @static
            @param {Array} promises array of promises to observe
            Useful for tooling.
            @return {Promise} a promise which settles in the same way as the first passed
            promise to settle.
          */


          function race$1(entries) {
            /*jshint validthis:true */
            var Constructor = this;

            if (!isArray(entries)) {
              return new Constructor(function (_, reject) {
                return reject(new TypeError('You must pass an array to race.'));
              });
            } else {
              return new Constructor(function (resolve, reject) {
                var length = entries.length;

                for (var i = 0; i < length; i++) {
                  Constructor.resolve(entries[i]).then(resolve, reject);
                }
              });
            }
          }
          /**
            `Promise.reject` returns a promise rejected with the passed `reason`.
            It is shorthand for the following:
          
            ```javascript
            let promise = new Promise(function(resolve, reject){
              reject(new Error('WHOOPS'));
            });
          
            promise.then(function(value){
              // Code here doesn't run because the promise is rejected!
            }, function(reason){
              // reason.message === 'WHOOPS'
            });
            ```
          
            Instead of writing the above, your code now simply becomes the following:
          
            ```javascript
            let promise = Promise.reject(new Error('WHOOPS'));
          
            promise.then(function(value){
              // Code here doesn't run because the promise is rejected!
            }, function(reason){
              // reason.message === 'WHOOPS'
            });
            ```
          
            @method reject
            @static
            @param {Any} reason value that the returned promise will be rejected with.
            Useful for tooling.
            @return {Promise} a promise rejected with the given `reason`.
          */


          function reject$1(reason) {
            /*jshint validthis:true */
            var Constructor = this;
            var promise = new Constructor(noop);
            reject(promise, reason);
            return promise;
          }

          function needsResolver() {
            throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
          }

          function needsNew() {
            throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
          }
          /**
            Promise objects represent the eventual result of an asynchronous operation. The
            primary way of interacting with a promise is through its `then` method, which
            registers callbacks to receive either a promise's eventual value or the reason
            why the promise cannot be fulfilled.
          
            Terminology
            -----------
          
            - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
            - `thenable` is an object or function that defines a `then` method.
            - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
            - `exception` is a value that is thrown using the throw statement.
            - `reason` is a value that indicates why a promise was rejected.
            - `settled` the final resting state of a promise, fulfilled or rejected.
          
            A promise can be in one of three states: pending, fulfilled, or rejected.
          
            Promises that are fulfilled have a fulfillment value and are in the fulfilled
            state.  Promises that are rejected have a rejection reason and are in the
            rejected state.  A fulfillment value is never a thenable.
          
            Promises can also be said to *resolve* a value.  If this value is also a
            promise, then the original promise's settled state will match the value's
            settled state.  So a promise that *resolves* a promise that rejects will
            itself reject, and a promise that *resolves* a promise that fulfills will
            itself fulfill.
          
          
            Basic Usage:
            ------------
          
            ```js
            let promise = new Promise(function(resolve, reject) {
              // on success
              resolve(value);
          
              // on failure
              reject(reason);
            });
          
            promise.then(function(value) {
              // on fulfillment
            }, function(reason) {
              // on rejection
            });
            ```
          
            Advanced Usage:
            ---------------
          
            Promises shine when abstracting away asynchronous interactions such as
            `XMLHttpRequest`s.
          
            ```js
            function getJSON(url) {
              return new Promise(function(resolve, reject){
                let xhr = new XMLHttpRequest();
          
                xhr.open('GET', url);
                xhr.onreadystatechange = handler;
                xhr.responseType = 'json';
                xhr.setRequestHeader('Accept', 'application/json');
                xhr.send();
          
                function handler() {
                  if (this.readyState === this.DONE) {
                    if (this.status === 200) {
                      resolve(this.response);
                    } else {
                      reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
                    }
                  }
                };
              });
            }
          
            getJSON('/posts.json').then(function(json) {
              // on fulfillment
            }, function(reason) {
              // on rejection
            });
            ```
          
            Unlike callbacks, promises are great composable primitives.
          
            ```js
            Promise.all([
              getJSON('/posts'),
              getJSON('/comments')
            ]).then(function(values){
              values[0] // => postsJSON
              values[1] // => commentsJSON
          
              return values;
            });
            ```
          
            @class Promise
            @param {function} resolver
            Useful for tooling.
            @constructor
          */


          function Promise$2(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];

            if (noop !== resolver) {
              typeof resolver !== 'function' && needsResolver();
              this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
            }
          }

          Promise$2.all = all$1;
          Promise$2.race = race$1;
          Promise$2.resolve = resolve$1;
          Promise$2.reject = reject$1;
          Promise$2._setScheduler = setScheduler;
          Promise$2._setAsap = setAsap;
          Promise$2._asap = asap;
          Promise$2.prototype = {
            constructor: Promise$2,

            /**
              The primary way of interacting with a promise is through its `then` method,
              which registers callbacks to receive either a promise's eventual value or the
              reason why the promise cannot be fulfilled.
            
              ```js
              findUser().then(function(user){
                // user is available
              }, function(reason){
                // user is unavailable, and you are given the reason why
              });
              ```
            
              Chaining
              --------
            
              The return value of `then` is itself a promise.  This second, 'downstream'
              promise is resolved with the return value of the first promise's fulfillment
              or rejection handler, or rejected if the handler throws an exception.
            
              ```js
              findUser().then(function (user) {
                return user.name;
              }, function (reason) {
                return 'default name';
              }).then(function (userName) {
                // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
                // will be `'default name'`
              });
            
              findUser().then(function (user) {
                throw new Error('Found user, but still unhappy');
              }, function (reason) {
                throw new Error('`findUser` rejected and we're unhappy');
              }).then(function (value) {
                // never reached
              }, function (reason) {
                // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
                // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
              });
              ```
              If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
            
              ```js
              findUser().then(function (user) {
                throw new PedagogicalException('Upstream error');
              }).then(function (value) {
                // never reached
              }).then(function (value) {
                // never reached
              }, function (reason) {
                // The `PedgagocialException` is propagated all the way down to here
              });
              ```
            
              Assimilation
              ------------
            
              Sometimes the value you want to propagate to a downstream promise can only be
              retrieved asynchronously. This can be achieved by returning a promise in the
              fulfillment or rejection handler. The downstream promise will then be pending
              until the returned promise is settled. This is called *assimilation*.
            
              ```js
              findUser().then(function (user) {
                return findCommentsByAuthor(user);
              }).then(function (comments) {
                // The user's comments are now available
              });
              ```
            
              If the assimliated promise rejects, then the downstream promise will also reject.
            
              ```js
              findUser().then(function (user) {
                return findCommentsByAuthor(user);
              }).then(function (comments) {
                // If `findCommentsByAuthor` fulfills, we'll have the value here
              }, function (reason) {
                // If `findCommentsByAuthor` rejects, we'll have the reason here
              });
              ```
            
              Simple Example
              --------------
            
              Synchronous Example
            
              ```javascript
              let result;
            
              try {
                result = findResult();
                // success
              } catch(reason) {
                // failure
              }
              ```
            
              Errback Example
            
              ```js
              findResult(function(result, err){
                if (err) {
                  // failure
                } else {
                  // success
                }
              });
              ```
            
              Promise Example;
            
              ```javascript
              findResult().then(function(result){
                // success
              }, function(reason){
                // failure
              });
              ```
            
              Advanced Example
              --------------
            
              Synchronous Example
            
              ```javascript
              let author, books;
            
              try {
                author = findAuthor();
                books  = findBooksByAuthor(author);
                // success
              } catch(reason) {
                // failure
              }
              ```
            
              Errback Example
            
              ```js
            
              function foundBooks(books) {
            
              }
            
              function failure(reason) {
            
              }
            
              findAuthor(function(author, err){
                if (err) {
                  failure(err);
                  // failure
                } else {
                  try {
                    findBoooksByAuthor(author, function(books, err) {
                      if (err) {
                        failure(err);
                      } else {
                        try {
                          foundBooks(books);
                        } catch(reason) {
                          failure(reason);
                        }
                      }
                    });
                  } catch(error) {
                    failure(err);
                  }
                  // success
                }
              });
              ```
            
              Promise Example;
            
              ```javascript
              findAuthor().
                then(findBooksByAuthor).
                then(function(books){
                  // found books
              }).catch(function(reason){
                // something went wrong
              });
              ```
            
              @method then
              @param {Function} onFulfilled
              @param {Function} onRejected
              Useful for tooling.
              @return {Promise}
            */
            then: then,

            /**
              `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
              as the catch block of a try/catch statement.
            
              ```js
              function findAuthor(){
                throw new Error('couldn't find that author');
              }
            
              // synchronous
              try {
                findAuthor();
              } catch(reason) {
                // something went wrong
              }
            
              // async with promises
              findAuthor().catch(function(reason){
                // something went wrong
              });
              ```
            
              @method catch
              @param {Function} onRejection
              Useful for tooling.
              @return {Promise}
            */
            'catch': function _catch(onRejection) {
              return this.then(null, onRejection);
            }
          };
          /*global self*/

          function polyfill$1() {
            var local = undefined;

            if (typeof global !== 'undefined') {
              local = global;
            } else if (typeof self !== 'undefined') {
              local = self;
            } else {
              try {
                local = Function('return this')();
              } catch (e) {
                throw new Error('polyfill failed because global object is unavailable in this environment');
              }
            }

            var P = local.Promise;

            if (P) {
              var promiseToString = null;

              try {
                promiseToString = Object.prototype.toString.call(P.resolve());
              } catch (e) {// silently ignored
              }

              if (promiseToString === '[object Promise]' && !P.cast) {
                return;
              }
            }

            local.Promise = Promise$2;
          } // Strange compat..


          Promise$2.polyfill = polyfill$1;
          Promise$2.Promise = Promise$2;
          return Promise$2;
        });
        /* WEBPACK VAR INJECTION */

      }).call(exports, __webpack_require__(18), __webpack_require__(205));
      /***/
    },
    /* 205 */

    /***/
    function (module, exports) {
      var g; // This works in non-strict mode

      g = function () {
        return this;
      }();

      try {
        // This works if eval is allowed (see CSP)
        g = g || Function("return this")() || (1, eval)("this");
      } catch (e) {
        // This works if the window reference is available
        if (typeof window === "object") g = window;
      } // g can still be undefined, but nothing to do about it...
      // We return undefined, instead of nothing here, so it's
      // easier to handle this case. if(!global) { ...}


      module.exports = g;
      /***/
    },
    /* 206 */

    /***/
    function (module, exports) {
      /* (ignored) */

      /***/
    },
    /* 207 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var _promise = __webpack_require__(208);

      var _promise2 = _interopRequireDefault(_promise);

      var _assign = __webpack_require__(228);

      var _assign2 = _interopRequireDefault(_assign);

      var _getPrototypeOf = __webpack_require__(114);

      var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

      var _classCallCheck2 = __webpack_require__(64);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(65);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(116);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(120);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(12);

      var _react2 = _interopRequireDefault(_react);

      var _reactFlipMove = __webpack_require__(252);

      var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);

      var _autosize = __webpack_require__(259);

      var _autosize2 = _interopRequireDefault(_autosize);

      var _i18n = __webpack_require__(260);

      var _i18n2 = _interopRequireDefault(_i18n);

      __webpack_require__(271);

      var _util = __webpack_require__(121);

      var _avatar = __webpack_require__(130);

      var _avatar2 = _interopRequireDefault(_avatar);

      var _button = __webpack_require__(299);

      var _button2 = _interopRequireDefault(_button);

      var _action = __webpack_require__(300);

      var _action2 = _interopRequireDefault(_action);

      var _comment = __webpack_require__(301);

      var _comment2 = _interopRequireDefault(_comment);

      var _svg = __webpack_require__(131);

      var _svg2 = _interopRequireDefault(_svg);

      var _const = __webpack_require__(856);

      var _getComments = __webpack_require__(857);

      var _getComments2 = _interopRequireDefault(_getComments);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var GitalkComponent = function (_Component) {
        (0, _inherits3.default)(GitalkComponent, _Component);

        function GitalkComponent(props) {
          (0, _classCallCheck3.default)(this, GitalkComponent);

          var _this = (0, _possibleConstructorReturn3.default)(this, (GitalkComponent.__proto__ || (0, _getPrototypeOf2.default)(GitalkComponent)).call(this, props));

          _this.state = {
            user: null,
            issue: null,
            comments: [],
            localComments: [],
            comment: '',
            page: 1,
            pagerDirection: 'last',
            cursor: null,
            previewHtml: '',
            isNoInit: false,
            isIniting: true,
            isCreating: false,
            isLoading: false,
            isLoadMore: false,
            isLoadOver: false,
            isIssueCreating: false,
            isPopupVisible: false,
            isInputFocused: false,
            isPreview: false,
            isOccurError: false,
            errorMsg: ''
          };

          _this.getCommentsV3 = function (issue) {
            var _this$options = _this.options,
                clientID = _this$options.clientID,
                clientSecret = _this$options.clientSecret,
                perPage = _this$options.perPage;
            var page = _this.state.page;
            return _this.getIssue().then(function (issue) {
              if (!issue) return;
              return _util.axiosGithub.get(issue.comments_url, {
                headers: {
                  Accept: 'application/vnd.github.v3.full+json'
                },
                auth: {
                  username: clientID,
                  password: clientSecret
                },
                params: {
                  per_page: perPage,
                  page: page
                }
              }).then(function (res) {
                var _this$state = _this.state,
                    comments = _this$state.comments,
                    issue = _this$state.issue;
                var isLoadOver = false;
                var cs = comments.concat(res.data);

                if (cs.length >= issue.comments || res.data.length < perPage) {
                  isLoadOver = true;
                }

                _this.setState({
                  comments: cs,
                  isLoadOver: isLoadOver,
                  page: page + 1
                });

                return cs;
              });
            });
          };

          _this.getRef = function (e) {
            _this.publicBtnEL = e;
          };

          _this.reply = function (replyComment) {
            return function () {
              var comment = _this.state.comment;
              var replyCommentBody = replyComment.body;
              var replyCommentArray = replyCommentBody.split('\n');
              replyCommentArray.unshift('@' + replyComment.user.login);
              replyCommentArray = replyCommentArray.map(function (t) {
                return '> ' + t;
              });
              replyCommentArray.push('');
              replyCommentArray.push('');
              if (comment) replyCommentArray.unshift('');

              _this.setState({
                comment: comment + replyCommentArray.join('\n')
              }, function () {
                _autosize2.default.update(_this.commentEL);

                _this.commentEL.focus();
              });
            };
          };

          _this.handlePopup = function (e) {
            e.preventDefault();
            e.stopPropagation();
            var isVisible = !_this.state.isPopupVisible;

            var hideHandle = function hideHandle(e1) {
              if ((0, _util.hasClassInParent)(e1.target, 'gt-user', 'gt-popup')) {
                return;
              }

              window.document.removeEventListener('click', hideHandle);

              _this.setState({
                isPopupVisible: false
              });
            };

            _this.setState({
              isPopupVisible: isVisible
            });

            if (isVisible) {
              window.document.addEventListener('click', hideHandle);
            } else {
              window.document.removeEventListener('click', hideHandle);
            }
          };

          _this.handleLogin = function () {
            var comment = _this.state.comment;
            window.localStorage.setItem(_const.GT_COMMENT, encodeURIComponent(comment));
            window.location.href = _this.loginLink;
          };

          _this.handleIssueCreate = function () {
            _this.setState({
              isIssueCreating: true
            });

            _this.createIssue().then(function (issue) {
              _this.setState({
                isIssueCreating: false,
                isOccurError: false
              });

              return _this.getComments(issue);
            }).catch(function (err) {
              _this.setState({
                isIssueCreating: false,
                isOccurError: true,
                errorMsg: (0, _util.formatErrorMsg)(err)
              });
            }).then(function (res) {
              if (res) {
                _this.setState({
                  isNoInit: false
                });
              }
            });
          };

          _this.handleCommentCreate = function (e) {
            if (!_this.state.comment.length) {
              e && e.preventDefault();

              _this.commentEL.focus();

              return;
            }

            _this.setState(function (state) {
              if (state.isCreating) return;

              _this.createComment().then(function () {
                return _this.setState({
                  isCreating: false,
                  isOccurError: false
                });
              }).catch(function (err) {
                _this.setState({
                  isCreating: false,
                  isOccurError: true,
                  errorMsg: (0, _util.formatErrorMsg)(err)
                });
              });

              return {
                isCreating: true
              };
            });
          };

          _this.handleCommentPreview = function (e) {
            _this.setState({
              isPreview: !_this.state.isPreview
            });

            _util.axiosGithub.post('/markdown', {
              text: _this.state.comment
            }, {
              headers: _this.accessToken && {
                Authorization: 'token ' + _this.accessToken
              }
            }).then(function (res) {
              _this.setState({
                previewHtml: res.data
              });
            }).catch(function (err) {
              _this.setState({
                isOccurError: true,
                errorMsg: (0, _util.formatErrorMsg)(err)
              });
            });
          };

          _this.handleCommentLoad = function () {
            var _this$state2 = _this.state,
                issue = _this$state2.issue,
                isLoadMore = _this$state2.isLoadMore;
            if (isLoadMore) return;

            _this.setState({
              isLoadMore: true
            });

            _this.getComments(issue).then(function () {
              return _this.setState({
                isLoadMore: false
              });
            });
          };

          _this.handleCommentChange = function (e) {
            return _this.setState({
              comment: e.target.value
            });
          };

          _this.handleLogout = function () {
            _this.logout();

            window.location.reload();
          };

          _this.handleCommentFocus = function (e) {
            var distractionFreeMode = _this.options.distractionFreeMode;
            if (!distractionFreeMode) return e.preventDefault();

            _this.setState({
              isInputFocused: true
            });
          };

          _this.handleCommentBlur = function (e) {
            var distractionFreeMode = _this.options.distractionFreeMode;
            if (!distractionFreeMode) return e.preventDefault();

            _this.setState({
              isInputFocused: false
            });
          };

          _this.handleSort = function (direction) {
            return function (e) {
              _this.setState({
                pagerDirection: direction
              });
            };
          };

          _this.handleCommentKeyDown = function (e) {
            var enableHotKey = _this.options.enableHotKey;

            if (enableHotKey && (e.metaKey || e.ctrlKey) && e.keyCode === 13) {
              _this.publicBtnEL && _this.publicBtnEL.focus();

              _this.handleCommentCreate();
            }
          };

          _this.options = (0, _assign2.default)({}, {
            id: window.location.href,
            number: -1,
            labels: ['Gitalk'],
            title: window.document.title,
            body: '',
            // window.location.href + header.meta[description]
            language: window.navigator.language || window.navigator.userLanguage,
            perPage: 10,
            pagerDirection: 'last',
            // last or first
            createIssueManually: false,
            distractionFreeMode: false,
            proxy: 'https://cors-anywhere.azm.workers.dev/https://github.com/login/oauth/access_token',
            flipMoveOptions: {
              staggerDelayBy: 150,
              appearAnimation: 'accordionVertical',
              enterAnimation: 'accordionVertical',
              leaveAnimation: 'accordionVertical'
            },
            enableHotKey: true,
            url: window.location.href,
            defaultAuthor: {
              avatarUrl: '//avatars1.githubusercontent.com/u/29697133?s=50',
              login: 'null',
              url: ''
            },
            updateCountCallback: null
          }, props.options);
          _this.state.pagerDirection = _this.options.pagerDirection;
          var storedComment = window.localStorage.getItem(_const.GT_COMMENT);

          if (storedComment) {
            _this.state.comment = decodeURIComponent(storedComment);
            window.localStorage.removeItem(_const.GT_COMMENT);
          }

          var query = (0, _util.queryParse)();

          if (query.code) {
            var code = query.code;
            delete query.code;
            var replacedUrl = '' + window.location.origin + window.location.pathname + (0, _util.queryStringify)(query) + window.location.hash;
            history.replaceState(null, null, replacedUrl);
            _this.options = (0, _assign2.default)({}, _this.options, {
              url: replacedUrl,
              id: replacedUrl
            }, props.options);

            _util.axiosJSON.post(_this.options.proxy, {
              code: code,
              client_id: _this.options.clientID,
              client_secret: _this.options.clientSecret
            }).then(function (res) {
              if (res.data && res.data.access_token) {
                _this.accessToken = res.data.access_token;

                _this.getInit().then(function () {
                  return _this.setState({
                    isIniting: false
                  });
                }).catch(function (err) {
                  console.log('err:', err);

                  _this.setState({
                    isIniting: false,
                    isOccurError: true,
                    errorMsg: (0, _util.formatErrorMsg)(err)
                  });
                });
              } else {
                // no access_token
                console.log('res.data err:', res.data);

                _this.setState({
                  isOccurError: true,
                  errorMsg: (0, _util.formatErrorMsg)(new Error('no access token'))
                });
              }
            }).catch(function (err) {
              console.log('err: ', err);

              _this.setState({
                isOccurError: true,
                errorMsg: (0, _util.formatErrorMsg)(err)
              });
            });
          } else {
            _this.getInit().then(function () {
              return _this.setState({
                isIniting: false
              });
            }).catch(function (err) {
              console.log('err:', err);

              _this.setState({
                isIniting: false,
                isOccurError: true,
                errorMsg: (0, _util.formatErrorMsg)(err)
              });
            });
          }

          _this.i18n = (0, _i18n2.default)(_this.options.language);
          return _this;
        }

        (0, _createClass3.default)(GitalkComponent, [{
          key: 'componentDidUpdate',
          value: function componentDidUpdate() {
            this.commentEL && (0, _autosize2.default)(this.commentEL);
          }
        }, {
          key: 'getInit',
          value: function getInit() {
            var _this2 = this;

            return this.getUserInfo().then(function () {
              return _this2.getIssue();
            }).then(function (issue) {
              return _this2.getComments(issue);
            });
          }
        }, {
          key: 'getUserInfo',
          value: function getUserInfo() {
            var _this3 = this;

            if (!this.accessToken) {
              return new _promise2.default(function (resolve) {
                resolve();
              });
            }

            return _util.axiosGithub.get('/user', {
              headers: {
                Authorization: 'token ' + this.accessToken
              }
            }).then(function (res) {
              _this3.setState({
                user: res.data
              });
            }).catch(function (err) {
              _this3.logout();
            });
          }
        }, {
          key: 'getIssueById',
          value: function getIssueById() {
            var _this4 = this;

            var _options = this.options,
                owner = _options.owner,
                repo = _options.repo,
                number = _options.number,
                clientID = _options.clientID,
                clientSecret = _options.clientSecret;
            var getUrl = '/repos/' + owner + '/' + repo + '/issues/' + number;
            return new _promise2.default(function (resolve, reject) {
              _util.axiosGithub.get(getUrl, {
                auth: {
                  username: clientID,
                  password: clientSecret
                },
                params: {
                  t: Date.now()
                }
              }).then(function (res) {
                var issue = null;

                if (res && res.data && res.data.number === number) {
                  issue = res.data;

                  _this4.setState({
                    issue: issue,
                    isNoInit: false
                  });
                }

                resolve(issue);
              }).catch(function (err) {
                // When the status code is 404, promise will be resolved with null
                if (err.response.status === 404) resolve(null);
                reject(err);
              });
            });
          }
        }, {
          key: 'getIssueByLabels',
          value: function getIssueByLabels() {
            var _this5 = this;

            var _options2 = this.options,
                owner = _options2.owner,
                repo = _options2.repo,
                id = _options2.id,
                labels = _options2.labels,
                clientID = _options2.clientID,
                clientSecret = _options2.clientSecret;
            return _util.axiosGithub.get('/repos/' + owner + '/' + repo + '/issues', {
              auth: {
                username: clientID,
                password: clientSecret
              },
              params: {
                labels: labels.concat(id).join(','),
                t: Date.now()
              }
            }).then(function (res) {
              var createIssueManually = _this5.options.createIssueManually;
              var isNoInit = false;
              var issue = null;

              if (!(res && res.data && res.data.length)) {
                if (!createIssueManually && _this5.isAdmin) {
                  return _this5.createIssue();
                }

                isNoInit = true;
              } else {
                issue = res.data[0];
              }

              _this5.setState({
                issue: issue,
                isNoInit: isNoInit
              });

              return issue;
            });
          }
        }, {
          key: 'getIssue',
          value: function getIssue() {
            var _this6 = this;

            var number = this.options.number;
            var issue = this.state.issue;

            if (issue) {
              this.setState({
                isNoInit: false
              });
              return _promise2.default.resolve(issue);
            }

            if (typeof number === 'number' && number > 0) {
              return this.getIssueById().then(function (resIssue) {
                if (!resIssue) return _this6.getIssueByLabels();
                return resIssue;
              });
            }

            return this.getIssueByLabels();
          }
        }, {
          key: 'createIssue',
          value: function createIssue() {
            var _this7 = this;

            var _options3 = this.options,
                owner = _options3.owner,
                repo = _options3.repo,
                title = _options3.title,
                body = _options3.body,
                id = _options3.id,
                labels = _options3.labels,
                url = _options3.url;
            return _util.axiosGithub.post('/repos/' + owner + '/' + repo + '/issues', {
              title: title,
              labels: labels.concat(id),
              body: body || url + ' \n\n ' + ((0, _util.getMetaContent)('description') || (0, _util.getMetaContent)('description', 'og:description') || '')
            }, {
              headers: {
                Authorization: 'token ' + this.accessToken
              }
            }).then(function (res) {
              _this7.setState({
                issue: res.data
              });

              return res.data;
            });
          } // Get comments via v3 api, don't require login, but sorting feature is disable

        }, {
          key: 'getComments',
          value: function getComments(issue) {
            if (!issue) return; // Get comments via v4 graphql api, login required and sorting feature is available

            if (this.accessToken) return _getComments2.default.call(this, issue);
            return this.getCommentsV3(issue);
          }
        }, {
          key: 'createComment',
          value: function createComment() {
            var _this8 = this;

            var _state = this.state,
                comment = _state.comment,
                localComments = _state.localComments,
                comments = _state.comments;
            return this.getIssue().then(function (issue) {
              return _util.axiosGithub.post(issue.comments_url, {
                body: comment
              }, {
                headers: {
                  Accept: 'application/vnd.github.v3.full+json',
                  Authorization: 'token ' + _this8.accessToken
                }
              });
            }).then(function (res) {
              _this8.setState({
                comment: '',
                comments: comments.concat(res.data),
                localComments: localComments.concat(res.data)
              });
            });
          }
        }, {
          key: 'logout',
          value: function logout() {
            this.setState({
              user: null
            });
            window.localStorage.removeItem(_const.GT_ACCESS_TOKEN);
          }
        }, {
          key: 'like',
          value: function like(comment) {
            var _this9 = this;

            var _options4 = this.options,
                owner = _options4.owner,
                repo = _options4.repo;
            var user = this.state.user;
            var comments = this.state.comments;

            _util.axiosGithub.post('/repos/' + owner + '/' + repo + '/issues/comments/' + comment.id + '/reactions', {
              content: 'heart'
            }, {
              headers: {
                Authorization: 'token ' + this.accessToken,
                Accept: 'application/vnd.github.squirrel-girl-preview'
              }
            }).then(function (res) {
              comments = comments.map(function (c) {
                if (c.id === comment.id) {
                  if (c.reactions) {
                    if (!~c.reactions.nodes.findIndex(function (n) {
                      return n.user.login === user.login;
                    })) {
                      c.reactions.totalCount += 1;
                    }
                  } else {
                    c.reactions = {
                      nodes: []
                    };
                    c.reactions.totalCount = 1;
                  }

                  c.reactions.nodes.push(res.data);
                  c.reactions.viewerHasReacted = true;
                  return (0, _assign2.default)({}, c);
                }

                return c;
              });

              _this9.setState({
                comments: comments
              });
            });
          }
        }, {
          key: 'unLike',
          value: function unLike(comment) {
            var _this10 = this;

            var user = this.state.user;
            var comments = this.state.comments; // const {  user } = this.state
            // let id
            // comment.reactions.nodes.forEach(r => {
            //   if (r.user.login = user.login) id = r.databaseId
            // })
            // return axiosGithub.delete(`/reactions/${id}`, {
            //   headers: {
            //     Authorization: `token ${this.accessToken}`,
            //     Accept: 'application/vnd.github.squirrel-girl-preview'
            //   }
            // }).then(res => {
            //   console.log('res:', res)
            // })

            var getQL = function getQL(id) {
              return {
                operationName: 'RemoveReaction',
                query: '\n          mutation RemoveReaction{\n            removeReaction (input:{\n              subjectId: "' + id + '",\n              content: HEART\n            }) {\n              reaction {\n                content\n              }\n            }\n          }\n        '
              };
            };

            _util.axiosGithub.post('/graphql', getQL(comment.gId), {
              headers: {
                Authorization: 'bearer ' + this.accessToken
              }
            }).then(function (res) {
              if (res.data) {
                comments = comments.map(function (c) {
                  if (c.id === comment.id) {
                    var index = c.reactions.nodes.findIndex(function (n) {
                      return n.user.login === user.login;
                    });

                    if (~index) {
                      c.reactions.totalCount -= 1;
                      c.reactions.nodes.splice(index, 1);
                    }

                    c.reactions.viewerHasReacted = false;
                    return (0, _assign2.default)({}, c);
                  }

                  return c;
                });

                _this10.setState({
                  comments: comments
                });
              }
            });
          }
        }, {
          key: 'initing',
          value: function initing() {
            return _react2.default.createElement('div', {
              className: 'gt-initing'
            }, _react2.default.createElement('i', {
              className: 'gt-loader'
            }), _react2.default.createElement('p', {
              className: 'gt-initing-text'
            }, this.i18n.t('init')));
          }
        }, {
          key: 'noInit',
          value: function noInit() {
            var _state2 = this.state,
                user = _state2.user,
                isIssueCreating = _state2.isIssueCreating;
            var _options5 = this.options,
                owner = _options5.owner,
                repo = _options5.repo,
                admin = _options5.admin;
            return _react2.default.createElement('div', {
              className: 'gt-no-init',
              key: 'no-init'
            }, _react2.default.createElement('p', {
              dangerouslySetInnerHTML: {
                __html: this.i18n.t('no-found-related', {
                  link: '<a href="https://github.com/' + owner + '/' + repo + '/issues">Issues</a>'
                })
              }
            }), _react2.default.createElement('p', null, this.i18n.t('please-contact', {
              user: [].concat(admin).map(function (u) {
                return '@' + u;
              }).join(' ')
            })), this.isAdmin ? _react2.default.createElement('p', null, _react2.default.createElement(_button2.default, {
              onClick: this.handleIssueCreate,
              isLoading: isIssueCreating,
              text: this.i18n.t('init-issue')
            })) : null, !user && _react2.default.createElement(_button2.default, {
              className: 'gt-btn-login',
              onClick: this.handleLogin,
              text: this.i18n.t('login-with-github')
            }));
          }
        }, {
          key: 'header',
          value: function header() {
            var _this11 = this;

            var _state3 = this.state,
                user = _state3.user,
                comment = _state3.comment,
                isCreating = _state3.isCreating,
                previewHtml = _state3.previewHtml,
                isPreview = _state3.isPreview;
            return _react2.default.createElement('div', {
              className: 'gt-header',
              key: 'header'
            }, user ? _react2.default.createElement(_avatar2.default, {
              className: 'gt-header-avatar',
              src: user.avatar_url,
              alt: user.login
            }) : _react2.default.createElement('a', {
              className: 'gt-avatar-github',
              onClick: this.handleLogin
            }, _react2.default.createElement(_svg2.default, {
              className: 'gt-ico-github',
              name: 'github'
            })), _react2.default.createElement('div', {
              className: 'gt-header-comment'
            }, _react2.default.createElement('textarea', {
              ref: function ref(t) {
                _this11.commentEL = t;
              },
              className: 'gt-header-textarea ' + (isPreview ? 'hide' : ''),
              value: comment,
              onChange: this.handleCommentChange,
              onFocus: this.handleCommentFocus,
              onBlur: this.handleCommentBlur,
              onKeyDown: this.handleCommentKeyDown,
              placeholder: this.i18n.t('leave-a-comment')
            }), _react2.default.createElement('div', {
              className: 'gt-header-preview markdown-body ' + (isPreview ? '' : 'hide'),
              dangerouslySetInnerHTML: {
                __html: previewHtml
              }
            }), _react2.default.createElement('div', {
              className: 'gt-header-controls'
            }, _react2.default.createElement('a', {
              className: 'gt-header-controls-tip',
              href: 'https://guides.github.com/features/mastering-markdown/',
              target: '_blank',
              rel: 'noopener noreferrer'
            }, _react2.default.createElement(_svg2.default, {
              className: 'gt-ico-tip',
              name: 'tip',
              text: this.i18n.t('support-markdown')
            })), user && _react2.default.createElement(_button2.default, {
              getRef: this.getRef,
              className: 'gt-btn-public',
              onClick: this.handleCommentCreate,
              text: this.i18n.t('comment'),
              isLoading: isCreating
            }), _react2.default.createElement(_button2.default, {
              className: 'gt-btn-preview',
              onClick: this.handleCommentPreview,
              text: isPreview ? this.i18n.t('edit') : this.i18n.t('preview') // isLoading={isPreviewing}

            }), !user && _react2.default.createElement(_button2.default, {
              className: 'gt-btn-login',
              onClick: this.handleLogin,
              text: this.i18n.t('login-with-github')
            }))));
          }
        }, {
          key: 'comments',
          value: function comments() {
            var _this12 = this;

            var _state4 = this.state,
                user = _state4.user,
                comments = _state4.comments,
                isLoadOver = _state4.isLoadOver,
                isLoadMore = _state4.isLoadMore,
                pagerDirection = _state4.pagerDirection;
            var _options6 = this.options,
                language = _options6.language,
                flipMoveOptions = _options6.flipMoveOptions,
                admin = _options6.admin;
            var totalComments = comments.concat([]);

            if (pagerDirection === 'last' && this.accessToken) {
              totalComments.reverse();
            }

            return _react2.default.createElement('div', {
              className: 'gt-comments',
              key: 'comments'
            }, _react2.default.createElement(_reactFlipMove2.default, flipMoveOptions, totalComments.map(function (c) {
              return _react2.default.createElement(_comment2.default, {
                comment: c,
                key: c.id,
                user: user,
                language: language,
                commentedText: _this12.i18n.t('commented'),
                admin: admin,
                replyCallback: _this12.reply(c),
                likeCallback: c.reactions && c.reactions.viewerHasReacted ? _this12.unLike.bind(_this12, c) : _this12.like.bind(_this12, c)
              });
            })), !totalComments.length && _react2.default.createElement('p', {
              className: 'gt-comments-null'
            }, this.i18n.t('first-comment-person')), !isLoadOver && totalComments.length ? _react2.default.createElement('div', {
              className: 'gt-comments-controls'
            }, _react2.default.createElement(_button2.default, {
              className: 'gt-btn-loadmore',
              onClick: this.handleCommentLoad,
              isLoading: isLoadMore,
              text: this.i18n.t('load-more')
            })) : null);
          }
        }, {
          key: 'meta',
          value: function meta() {
            var _state5 = this.state,
                user = _state5.user,
                issue = _state5.issue,
                isPopupVisible = _state5.isPopupVisible,
                pagerDirection = _state5.pagerDirection,
                localComments = _state5.localComments;
            var cnt = (issue && issue.comments) + localComments.length;
            var isDesc = pagerDirection === 'last';
            var updateCountCallback = this.options.updateCountCallback; // window.GITALK_COMMENTS_COUNT = cnt

            if (updateCountCallback && {}.toString.call(updateCountCallback) === '[object Function]') {
              try {
                updateCountCallback(cnt);
              } catch (err) {
                console.log('An error occurred executing the updateCountCallback:', err);
              }
            }

            return _react2.default.createElement('div', {
              className: 'gt-meta',
              key: 'meta'
            }, _react2.default.createElement('span', {
              className: 'gt-counts',
              dangerouslySetInnerHTML: {
                __html: this.i18n.t('counts', {
                  counts: '<a class="gt-link gt-link-counts" href="' + (issue && issue.html_url) + '" target="_blank" rel="noopener noreferrer">' + cnt + '</a>',
                  smart_count: cnt
                })
              }
            }), isPopupVisible && _react2.default.createElement('div', {
              className: 'gt-popup'
            }, user ? _react2.default.createElement(_action2.default, {
              className: 'gt-action-sortasc' + (!isDesc ? ' is--active' : ''),
              onClick: this.handleSort('first'),
              text: this.i18n.t('sort-asc')
            }) : null, user ? _react2.default.createElement(_action2.default, {
              className: 'gt-action-sortdesc' + (isDesc ? ' is--active' : ''),
              onClick: this.handleSort('last'),
              text: this.i18n.t('sort-desc')
            }) : null, user ? _react2.default.createElement(_action2.default, {
              className: 'gt-action-logout',
              onClick: this.handleLogout,
              text: this.i18n.t('logout')
            }) : _react2.default.createElement('a', {
              className: 'gt-action gt-action-login',
              onClick: this.handleLogin
            }, this.i18n.t('login-with-github')), _react2.default.createElement('div', {
              className: 'gt-copyright'
            }, _react2.default.createElement('a', {
              className: 'gt-link gt-link-project',
              href: 'https://github.com/gitalk/gitalk',
              target: '_blank',
              rel: 'noopener noreferrer'
            }, 'Gitalk'), _react2.default.createElement('span', {
              className: 'gt-version'
            }, _const.GT_VERSION))), _react2.default.createElement('div', {
              className: 'gt-user'
            }, user ? _react2.default.createElement('div', {
              className: isPopupVisible ? 'gt-user-inner is--poping' : 'gt-user-inner',
              onClick: this.handlePopup
            }, _react2.default.createElement('span', {
              className: 'gt-user-name'
            }, user.login), _react2.default.createElement(_svg2.default, {
              className: 'gt-ico-arrdown',
              name: 'arrow_down'
            })) : _react2.default.createElement('div', {
              className: isPopupVisible ? 'gt-user-inner is--poping' : 'gt-user-inner',
              onClick: this.handlePopup
            }, _react2.default.createElement('span', {
              className: 'gt-user-name'
            }, this.i18n.t('anonymous')), _react2.default.createElement(_svg2.default, {
              className: 'gt-ico-arrdown',
              name: 'arrow_down'
            }))));
          }
        }, {
          key: 'render',
          value: function render() {
            var _state6 = this.state,
                isIniting = _state6.isIniting,
                isNoInit = _state6.isNoInit,
                isOccurError = _state6.isOccurError,
                errorMsg = _state6.errorMsg,
                isInputFocused = _state6.isInputFocused;
            return _react2.default.createElement('div', {
              className: 'gt-container' + (isInputFocused ? ' gt-input-focused' : '')
            }, isIniting && this.initing(), !isIniting && (isNoInit ? [] : [this.meta()]), isOccurError && _react2.default.createElement('div', {
              className: 'gt-error'
            }, errorMsg), !isIniting && (isNoInit ? [this.noInit()] : [this.header(), this.comments()]));
          }
        }, {
          key: 'accessToken',
          get: function get() {
            return this._accessToke || window.localStorage.getItem(_const.GT_ACCESS_TOKEN);
          },
          set: function set(token) {
            window.localStorage.setItem(_const.GT_ACCESS_TOKEN, token);
            this._accessToken = token;
          }
        }, {
          key: 'loginLink',
          get: function get() {
            var githubOauthUrl = 'https://github.com/login/oauth/authorize';
            var clientID = this.options.clientID;
            var query = {
              client_id: clientID,
              redirect_uri: window.location.href,
              scope: 'public_repo'
            };
            return githubOauthUrl + '?' + (0, _util.queryStringify)(query);
          }
        }, {
          key: 'isAdmin',
          get: function get() {
            var admin = this.options.admin;
            var user = this.state.user;
            return user && ~[].concat(admin).map(function (a) {
              return a.toLowerCase();
            }).indexOf(user.login.toLowerCase());
          }
        }]);
        return GitalkComponent;
      }(_react.Component);

      module.exports = GitalkComponent;
      /***/
    },
    /* 208 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(209),
        __esModule: true
      };
      /***/
    },
    /* 209 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(100);

      __webpack_require__(40);

      __webpack_require__(54);

      __webpack_require__(218);

      __webpack_require__(226);

      __webpack_require__(227);

      module.exports = __webpack_require__(7).Promise;
      /***/
    },
    /* 210 */

    /***/
    function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(69);

      var defined = __webpack_require__(70); // true  -> String#at
      // false -> String#codePointAt


      module.exports = function (TO_STRING) {
        return function (that, pos) {
          var s = String(defined(that));
          var i = toInteger(pos);
          var l = s.length;
          var a, b;
          if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
          a = s.charCodeAt(i);
          return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
        };
      };
      /***/

    },
    /* 211 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var create = __webpack_require__(71);

      var descriptor = __webpack_require__(39);

      var setToStringTag = __webpack_require__(53);

      var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

      __webpack_require__(23)(IteratorPrototype, __webpack_require__(9)('iterator'), function () {
        return this;
      });

      module.exports = function (Constructor, NAME, next) {
        Constructor.prototype = create(IteratorPrototype, {
          next: descriptor(1, next)
        });
        setToStringTag(Constructor, NAME + ' Iterator');
      };
      /***/

    },
    /* 212 */

    /***/
    function (module, exports, __webpack_require__) {
      var dP = __webpack_require__(16);

      var anObject = __webpack_require__(14);

      var getKeys = __webpack_require__(42);

      module.exports = __webpack_require__(17) ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = getKeys(Properties);
        var length = keys.length;
        var i = 0;
        var P;

        while (length > i) {
          dP.f(O, P = keys[i++], Properties[P]);
        }

        return O;
      };
      /***/
    },
    /* 213 */

    /***/
    function (module, exports, __webpack_require__) {
      // false -> Array#indexOf
      // true  -> Array#includes
      var toIObject = __webpack_require__(32);

      var toLength = __webpack_require__(72);

      var toAbsoluteIndex = __webpack_require__(214);

      module.exports = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value; // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare

          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++]; // eslint-disable-next-line no-self-compare

            if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
          } else for (; length > index; index++) {
            if (IS_INCLUDES || index in O) {
              if (O[index] === el) return IS_INCLUDES || index || 0;
            }
          }
          return !IS_INCLUDES && -1;
        };
      };
      /***/

    },
    /* 214 */

    /***/
    function (module, exports, __webpack_require__) {
      var toInteger = __webpack_require__(69);

      var max = Math.max;
      var min = Math.min;

      module.exports = function (index, length) {
        index = toInteger(index);
        return index < 0 ? max(index + length, 0) : min(index, length);
      };
      /***/

    },
    /* 215 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var addToUnscopables = __webpack_require__(216);

      var step = __webpack_require__(217);

      var Iterators = __webpack_require__(31);

      var toIObject = __webpack_require__(32); // 22.1.3.4 Array.prototype.entries()
      // 22.1.3.13 Array.prototype.keys()
      // 22.1.3.29 Array.prototype.values()
      // 22.1.3.30 Array.prototype[@@iterator]()


      module.exports = __webpack_require__(101)(Array, 'Array', function (iterated, kind) {
        this._t = toIObject(iterated); // target

        this._i = 0; // next index

        this._k = kind; // kind
        // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
      }, function () {
        var O = this._t;
        var kind = this._k;
        var index = this._i++;

        if (!O || index >= O.length) {
          this._t = undefined;
          return step(1);
        }

        if (kind == 'keys') return step(0, index);
        if (kind == 'values') return step(0, O[index]);
        return step(0, [index, O[index]]);
      }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

      Iterators.Arguments = Iterators.Array;
      addToUnscopables('keys');
      addToUnscopables('values');
      addToUnscopables('entries');
      /***/
    },
    /* 216 */

    /***/
    function (module, exports) {
      module.exports = function () {
        /* empty */
      };
      /***/

    },
    /* 217 */

    /***/
    function (module, exports) {
      module.exports = function (done, value) {
        return {
          value: value,
          done: !!done
        };
      };
      /***/

    },
    /* 218 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var LIBRARY = __webpack_require__(41);

      var global = __webpack_require__(8);

      var ctx = __webpack_require__(29);

      var classof = __webpack_require__(76);

      var $export = __webpack_require__(11);

      var isObject = __webpack_require__(20);

      var aFunction = __webpack_require__(51);

      var anInstance = __webpack_require__(219);

      var forOf = __webpack_require__(220);

      var speciesConstructor = __webpack_require__(109);

      var task = __webpack_require__(110).set;

      var microtask = __webpack_require__(222)();

      var newPromiseCapabilityModule = __webpack_require__(78);

      var perform = __webpack_require__(111);

      var userAgent = __webpack_require__(223);

      var promiseResolve = __webpack_require__(112);

      var PROMISE = 'Promise';
      var TypeError = global.TypeError;
      var process = global.process;
      var versions = process && process.versions;
      var v8 = versions && versions.v8 || '';
      var $Promise = global[PROMISE];
      var isNode = classof(process) == 'process';

      var empty = function empty() {
        /* empty */
      };

      var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
      var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
      var USE_NATIVE = !!function () {
        try {
          // correct subclassing with @@species support
          var promise = $Promise.resolve(1);

          var FakePromise = (promise.constructor = {})[__webpack_require__(9)('species')] = function (exec) {
            exec(empty, empty);
          }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


          return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
          // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
          // we can't detect it synchronously, so just check versions
          && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
        } catch (e) {
          /* empty */
        }
      }(); // helpers

      var isThenable = function isThenable(it) {
        var then;
        return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
      };

      var notify = function notify(promise, isReject) {
        if (promise._n) return;
        promise._n = true;
        var chain = promise._c;
        microtask(function () {
          var value = promise._v;
          var ok = promise._s == 1;
          var i = 0;

          var run = function run(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;

            try {
              if (handler) {
                if (!ok) {
                  if (promise._h == 2) onHandleUnhandled(promise);
                  promise._h = 1;
                }

                if (handler === true) result = value;else {
                  if (domain) domain.enter();
                  result = handler(value); // may throw

                  if (domain) {
                    domain.exit();
                    exited = true;
                  }
                }

                if (result === reaction.promise) {
                  reject(TypeError('Promise-chain cycle'));
                } else if (then = isThenable(result)) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (e) {
              if (domain && !exited) domain.exit();
              reject(e);
            }
          };

          while (chain.length > i) {
            run(chain[i++]);
          } // variable length - can't use forEach


          promise._c = [];
          promise._n = false;
          if (isReject && !promise._h) onUnhandled(promise);
        });
      };

      var onUnhandled = function onUnhandled(promise) {
        task.call(global, function () {
          var value = promise._v;
          var unhandled = isUnhandled(promise);
          var result, handler, console;

          if (unhandled) {
            result = perform(function () {
              if (isNode) {
                process.emit('unhandledRejection', value, promise);
              } else if (handler = global.onunhandledrejection) {
                handler({
                  promise: promise,
                  reason: value
                });
              } else if ((console = global.console) && console.error) {
                console.error('Unhandled promise rejection', value);
              }
            }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

            promise._h = isNode || isUnhandled(promise) ? 2 : 1;
          }

          promise._a = undefined;
          if (unhandled && result.e) throw result.v;
        });
      };

      var isUnhandled = function isUnhandled(promise) {
        return promise._h !== 1 && (promise._a || promise._c).length === 0;
      };

      var onHandleUnhandled = function onHandleUnhandled(promise) {
        task.call(global, function () {
          var handler;

          if (isNode) {
            process.emit('rejectionHandled', promise);
          } else if (handler = global.onrejectionhandled) {
            handler({
              promise: promise,
              reason: promise._v
            });
          }
        });
      };

      var $reject = function $reject(value) {
        var promise = this;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap

        promise._v = value;
        promise._s = 2;
        if (!promise._a) promise._a = promise._c.slice();
        notify(promise, true);
      };

      var $resolve = function $resolve(value) {
        var promise = this;
        var then;
        if (promise._d) return;
        promise._d = true;
        promise = promise._w || promise; // unwrap

        try {
          if (promise === value) throw TypeError("Promise can't be resolved itself");

          if (then = isThenable(value)) {
            microtask(function () {
              var wrapper = {
                _w: promise,
                _d: false
              }; // wrap

              try {
                then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
              } catch (e) {
                $reject.call(wrapper, e);
              }
            });
          } else {
            promise._v = value;
            promise._s = 1;
            notify(promise, false);
          }
        } catch (e) {
          $reject.call({
            _w: promise,
            _d: false
          }, e); // wrap
        }
      }; // constructor polyfill


      if (!USE_NATIVE) {
        // 25.4.3.1 Promise(executor)
        $Promise = function Promise(executor) {
          anInstance(this, $Promise, PROMISE, '_h');
          aFunction(executor);
          Internal.call(this);

          try {
            executor(ctx($resolve, this, 1), ctx($reject, this, 1));
          } catch (err) {
            $reject.call(this, err);
          }
        }; // eslint-disable-next-line no-unused-vars


        Internal = function Promise(executor) {
          this._c = []; // <- awaiting reactions

          this._a = undefined; // <- checked in isUnhandled reactions

          this._s = 0; // <- state

          this._d = false; // <- done

          this._v = undefined; // <- value

          this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

          this._n = false; // <- notify
        };

        Internal.prototype = __webpack_require__(224)($Promise.prototype, {
          // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
          then: function then(onFulfilled, onRejected) {
            var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = isNode ? process.domain : undefined;

            this._c.push(reaction);

            if (this._a) this._a.push(reaction);
            if (this._s) notify(this, false);
            return reaction.promise;
          },
          // 25.4.5.1 Promise.prototype.catch(onRejected)
          'catch': function _catch(onRejected) {
            return this.then(undefined, onRejected);
          }
        });

        OwnPromiseCapability = function OwnPromiseCapability() {
          var promise = new Internal();
          this.promise = promise;
          this.resolve = ctx($resolve, promise, 1);
          this.reject = ctx($reject, promise, 1);
        };

        newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
          return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
        };
      }

      $export($export.G + $export.W + $export.F * !USE_NATIVE, {
        Promise: $Promise
      });

      __webpack_require__(53)($Promise, PROMISE);

      __webpack_require__(225)(PROMISE);

      Wrapper = __webpack_require__(7)[PROMISE]; // statics

      $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
        // 25.4.4.5 Promise.reject(r)
        reject: function reject(r) {
          var capability = newPromiseCapability(this);
          var $$reject = capability.reject;
          $$reject(r);
          return capability.promise;
        }
      });
      $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
        // 25.4.4.6 Promise.resolve(x)
        resolve: function resolve(x) {
          return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
        }
      });
      $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(113)(function (iter) {
        $Promise.all(iter)['catch'](empty);
      })), PROMISE, {
        // 25.4.4.1 Promise.all(iterable)
        all: function all(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var resolve = capability.resolve;
          var reject = capability.reject;
          var result = perform(function () {
            var values = [];
            var index = 0;
            var remaining = 1;
            forOf(iterable, false, function (promise) {
              var $index = index++;
              var alreadyCalled = false;
              values.push(undefined);
              remaining++;
              C.resolve(promise).then(function (value) {
                if (alreadyCalled) return;
                alreadyCalled = true;
                values[$index] = value;
                --remaining || resolve(values);
              }, reject);
            });
            --remaining || resolve(values);
          });
          if (result.e) reject(result.v);
          return capability.promise;
        },
        // 25.4.4.4 Promise.race(iterable)
        race: function race(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var reject = capability.reject;
          var result = perform(function () {
            forOf(iterable, false, function (promise) {
              C.resolve(promise).then(capability.resolve, reject);
            });
          });
          if (result.e) reject(result.v);
          return capability.promise;
        }
      });
      /***/
    },
    /* 219 */

    /***/
    function (module, exports) {
      module.exports = function (it, Constructor, name, forbiddenField) {
        if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
          throw TypeError(name + ': incorrect invocation!');
        }

        return it;
      };
      /***/

    },
    /* 220 */

    /***/
    function (module, exports, __webpack_require__) {
      var ctx = __webpack_require__(29);

      var call = __webpack_require__(107);

      var isArrayIter = __webpack_require__(108);

      var anObject = __webpack_require__(14);

      var toLength = __webpack_require__(72);

      var getIterFn = __webpack_require__(77);

      var BREAK = {};
      var RETURN = {};

      var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
        var iterFn = ITERATOR ? function () {
          return iterable;
        } : getIterFn(iterable);
        var f = ctx(fn, that, entries ? 2 : 1);
        var index = 0;
        var length, step, iterator, result;
        if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

        if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
          result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
          if (result === BREAK || result === RETURN) return result;
        } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
          result = call(iterator, f, step.value, entries);
          if (result === BREAK || result === RETURN) return result;
        }
      };

      exports.BREAK = BREAK;
      exports.RETURN = RETURN;
      /***/
    },
    /* 221 */

    /***/
    function (module, exports) {
      // fast apply, http://jsperf.lnkit.com/fast-apply/5
      module.exports = function (fn, args, that) {
        var un = that === undefined;

        switch (args.length) {
          case 0:
            return un ? fn() : fn.call(that);

          case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);

          case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

          case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

          case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
        }

        return fn.apply(that, args);
      };
      /***/

    },
    /* 222 */

    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(8);

      var macrotask = __webpack_require__(110).set;

      var Observer = global.MutationObserver || global.WebKitMutationObserver;
      var process = global.process;
      var Promise = global.Promise;
      var isNode = __webpack_require__(43)(process) == 'process';

      module.exports = function () {
        var head, last, notify;

        var flush = function flush() {
          var parent, fn;
          if (isNode && (parent = process.domain)) parent.exit();

          while (head) {
            fn = head.fn;
            head = head.next;

            try {
              fn();
            } catch (e) {
              if (head) notify();else last = undefined;
              throw e;
            }
          }

          last = undefined;
          if (parent) parent.enter();
        }; // Node.js


        if (isNode) {
          notify = function notify() {
            process.nextTick(flush);
          }; // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339

        } else if (Observer && !(global.navigator && global.navigator.standalone)) {
          var toggle = true;
          var node = document.createTextNode('');
          new Observer(flush).observe(node, {
            characterData: true
          }); // eslint-disable-line no-new

          notify = function notify() {
            node.data = toggle = !toggle;
          }; // environments with maybe non-completely correct, but existent Promise

        } else if (Promise && Promise.resolve) {
          // Promise.resolve without an argument throws an error in LG WebOS 2
          var promise = Promise.resolve(undefined);

          notify = function notify() {
            promise.then(flush);
          }; // for other environments - macrotask based on:
          // - setImmediate
          // - MessageChannel
          // - window.postMessag
          // - onreadystatechange
          // - setTimeout

        } else {
          notify = function notify() {
            // strange IE + webpack dev server bug - use .call(global)
            macrotask.call(global, flush);
          };
        }

        return function (fn) {
          var task = {
            fn: fn,
            next: undefined
          };
          if (last) last.next = task;

          if (!head) {
            head = task;
            notify();
          }

          last = task;
        };
      };
      /***/

    },
    /* 223 */

    /***/
    function (module, exports, __webpack_require__) {
      var global = __webpack_require__(8);

      var navigator = global.navigator;
      module.exports = navigator && navigator.userAgent || '';
      /***/
    },
    /* 224 */

    /***/
    function (module, exports, __webpack_require__) {
      var hide = __webpack_require__(23);

      module.exports = function (target, src, safe) {
        for (var key in src) {
          if (safe && target[key]) target[key] = src[key];else hide(target, key, src[key]);
        }

        return target;
      };
      /***/

    },
    /* 225 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var global = __webpack_require__(8);

      var core = __webpack_require__(7);

      var dP = __webpack_require__(16);

      var DESCRIPTORS = __webpack_require__(17);

      var SPECIES = __webpack_require__(9)('species');

      module.exports = function (KEY) {
        var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
        if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
          configurable: true,
          get: function get() {
            return this;
          }
        });
      };
      /***/

    },
    /* 226 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // https://github.com/tc39/proposal-promise-finally

      var $export = __webpack_require__(11);

      var core = __webpack_require__(7);

      var global = __webpack_require__(8);

      var speciesConstructor = __webpack_require__(109);

      var promiseResolve = __webpack_require__(112);

      $export($export.P + $export.R, 'Promise', {
        'finally': function _finally(onFinally) {
          var C = speciesConstructor(this, core.Promise || global.Promise);
          var isFunction = typeof onFinally == 'function';
          return this.then(isFunction ? function (x) {
            return promiseResolve(C, onFinally()).then(function () {
              return x;
            });
          } : onFinally, isFunction ? function (e) {
            return promiseResolve(C, onFinally()).then(function () {
              throw e;
            });
          } : onFinally);
        }
      });
      /***/
    },
    /* 227 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // https://github.com/tc39/proposal-promise-try

      var $export = __webpack_require__(11);

      var newPromiseCapability = __webpack_require__(78);

      var perform = __webpack_require__(111);

      $export($export.S, 'Promise', {
        'try': function _try(callbackfn) {
          var promiseCapability = newPromiseCapability.f(this);
          var result = perform(callbackfn);
          (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
          return promiseCapability.promise;
        }
      });
      /***/
    },
    /* 228 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(229),
        __esModule: true
      };
      /***/
    },
    /* 229 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(230);

      module.exports = __webpack_require__(7).Object.assign;
      /***/
    },
    /* 230 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.3.1 Object.assign(target, source)
      var $export = __webpack_require__(11);

      $export($export.S + $export.F, 'Object', {
        assign: __webpack_require__(231)
      });
      /***/
    },
    /* 231 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // 19.1.2.1 Object.assign(target, source, ...)

      var DESCRIPTORS = __webpack_require__(17);

      var getKeys = __webpack_require__(42);

      var gOPS = __webpack_require__(79);

      var pIE = __webpack_require__(55);

      var toObject = __webpack_require__(33);

      var IObject = __webpack_require__(104);

      var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

      module.exports = !$assign || __webpack_require__(30)(function () {
        var A = {};
        var B = {}; // eslint-disable-next-line no-undef

        var S = Symbol();
        var K = 'abcdefghijklmnopqrst';
        A[S] = 7;
        K.split('').forEach(function (k) {
          B[k] = k;
        });
        return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
      }) ? function assign(target, source) {
        // eslint-disable-line no-unused-vars
        var T = toObject(target);
        var aLen = arguments.length;
        var index = 1;
        var getSymbols = gOPS.f;
        var isEnum = pIE.f;

        while (aLen > index) {
          var S = IObject(arguments[index++]);
          var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
          var length = keys.length;
          var j = 0;
          var key;

          while (length > j) {
            key = keys[j++];
            if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
          }
        }

        return T;
      } : $assign;
      /***/
    },
    /* 232 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(233);

      module.exports = __webpack_require__(7).Object.getPrototypeOf;
      /***/
    },
    /* 233 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.9 Object.getPrototypeOf(O)
      var toObject = __webpack_require__(33);

      var $getPrototypeOf = __webpack_require__(106);

      __webpack_require__(115)('getPrototypeOf', function () {
        return function getPrototypeOf(it) {
          return $getPrototypeOf(toObject(it));
        };
      });
      /***/

    },
    /* 234 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(235),
        __esModule: true
      };
      /***/
    },
    /* 235 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(40);

      __webpack_require__(54);

      module.exports = __webpack_require__(80).f('iterator');
      /***/
    },
    /* 236 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(237),
        __esModule: true
      };
      /***/
    },
    /* 237 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(238);

      __webpack_require__(100);

      __webpack_require__(243);

      __webpack_require__(244);

      module.exports = __webpack_require__(7).Symbol;
      /***/
    },
    /* 238 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // ECMAScript 6 symbols shim

      var global = __webpack_require__(8);

      var has = __webpack_require__(24);

      var DESCRIPTORS = __webpack_require__(17);

      var $export = __webpack_require__(11);

      var redefine = __webpack_require__(102);

      var META = __webpack_require__(239).KEY;

      var $fails = __webpack_require__(30);

      var shared = __webpack_require__(74);

      var setToStringTag = __webpack_require__(53);

      var uid = __webpack_require__(52);

      var wks = __webpack_require__(9);

      var wksExt = __webpack_require__(80);

      var wksDefine = __webpack_require__(81);

      var enumKeys = __webpack_require__(240);

      var isArray = __webpack_require__(241);

      var anObject = __webpack_require__(14);

      var isObject = __webpack_require__(20);

      var toObject = __webpack_require__(33);

      var toIObject = __webpack_require__(32);

      var toPrimitive = __webpack_require__(67);

      var createDesc = __webpack_require__(39);

      var _create = __webpack_require__(71);

      var gOPNExt = __webpack_require__(242);

      var $GOPD = __webpack_require__(119);

      var $GOPS = __webpack_require__(79);

      var $DP = __webpack_require__(16);

      var $keys = __webpack_require__(42);

      var gOPD = $GOPD.f;
      var dP = $DP.f;
      var gOPN = gOPNExt.f;
      var $Symbol = global.Symbol;
      var $JSON = global.JSON;

      var _stringify = $JSON && $JSON.stringify;

      var PROTOTYPE = 'prototype';
      var HIDDEN = wks('_hidden');
      var TO_PRIMITIVE = wks('toPrimitive');
      var isEnum = {}.propertyIsEnumerable;
      var SymbolRegistry = shared('symbol-registry');
      var AllSymbols = shared('symbols');
      var OPSymbols = shared('op-symbols');
      var ObjectProto = Object[PROTOTYPE];
      var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
      var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

      var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

      var setSymbolDesc = DESCRIPTORS && $fails(function () {
        return _create(dP({}, 'a', {
          get: function get() {
            return dP(this, 'a', {
              value: 7
            }).a;
          }
        })).a != 7;
      }) ? function (it, key, D) {
        var protoDesc = gOPD(ObjectProto, key);
        if (protoDesc) delete ObjectProto[key];
        dP(it, key, D);
        if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
      } : dP;

      var wrap = function wrap(tag) {
        var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

        sym._k = tag;
        return sym;
      };

      var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
        return typeof it == 'symbol';
      } : function (it) {
        return it instanceof $Symbol;
      };

      var $defineProperty = function defineProperty(it, key, D) {
        if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
        anObject(it);
        key = toPrimitive(key, true);
        anObject(D);

        if (has(AllSymbols, key)) {
          if (!D.enumerable) {
            if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
            it[HIDDEN][key] = true;
          } else {
            if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
            D = _create(D, {
              enumerable: createDesc(0, false)
            });
          }

          return setSymbolDesc(it, key, D);
        }

        return dP(it, key, D);
      };

      var $defineProperties = function defineProperties(it, P) {
        anObject(it);
        var keys = enumKeys(P = toIObject(P));
        var i = 0;
        var l = keys.length;
        var key;

        while (l > i) {
          $defineProperty(it, key = keys[i++], P[key]);
        }

        return it;
      };

      var $create = function create(it, P) {
        return P === undefined ? _create(it) : $defineProperties(_create(it), P);
      };

      var $propertyIsEnumerable = function propertyIsEnumerable(key) {
        var E = isEnum.call(this, key = toPrimitive(key, true));
        if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
        return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
      };

      var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
        it = toIObject(it);
        key = toPrimitive(key, true);
        if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
        var D = gOPD(it, key);
        if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
        return D;
      };

      var $getOwnPropertyNames = function getOwnPropertyNames(it) {
        var names = gOPN(toIObject(it));
        var result = [];
        var i = 0;
        var key;

        while (names.length > i) {
          if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
        }

        return result;
      };

      var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
        var IS_OP = it === ObjectProto;
        var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
        var result = [];
        var i = 0;
        var key;

        while (names.length > i) {
          if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
        }

        return result;
      }; // 19.4.1.1 Symbol([description])


      if (!USE_NATIVE) {
        $Symbol = function Symbol() {
          if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
          var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

          var $set = function $set(value) {
            if (this === ObjectProto) $set.call(OPSymbols, value);
            if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
            setSymbolDesc(this, tag, createDesc(1, value));
          };

          if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
            configurable: true,
            set: $set
          });
          return wrap(tag);
        };

        redefine($Symbol[PROTOTYPE], 'toString', function toString() {
          return this._k;
        });
        $GOPD.f = $getOwnPropertyDescriptor;
        $DP.f = $defineProperty;
        __webpack_require__(118).f = gOPNExt.f = $getOwnPropertyNames;
        __webpack_require__(55).f = $propertyIsEnumerable;
        $GOPS.f = $getOwnPropertySymbols;

        if (DESCRIPTORS && !__webpack_require__(41)) {
          redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
        }

        wksExt.f = function (name) {
          return wrap(wks(name));
        };
      }

      $export($export.G + $export.W + $export.F * !USE_NATIVE, {
        Symbol: $Symbol
      });

      for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
      'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
        wks(es6Symbols[j++]);
      }

      for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
        wksDefine(wellKnownSymbols[k++]);
      }

      $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
        // 19.4.2.1 Symbol.for(key)
        'for': function _for(key) {
          return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
        },
        // 19.4.2.5 Symbol.keyFor(sym)
        keyFor: function keyFor(sym) {
          if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

          for (var key in SymbolRegistry) {
            if (SymbolRegistry[key] === sym) return key;
          }
        },
        useSetter: function useSetter() {
          setter = true;
        },
        useSimple: function useSimple() {
          setter = false;
        }
      });
      $export($export.S + $export.F * !USE_NATIVE, 'Object', {
        // 19.1.2.2 Object.create(O [, Properties])
        create: $create,
        // 19.1.2.4 Object.defineProperty(O, P, Attributes)
        defineProperty: $defineProperty,
        // 19.1.2.3 Object.defineProperties(O, Properties)
        defineProperties: $defineProperties,
        // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
        // 19.1.2.7 Object.getOwnPropertyNames(O)
        getOwnPropertyNames: $getOwnPropertyNames,
        // 19.1.2.8 Object.getOwnPropertySymbols(O)
        getOwnPropertySymbols: $getOwnPropertySymbols
      }); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
      // https://bugs.chromium.org/p/v8/issues/detail?id=3443

      var FAILS_ON_PRIMITIVES = $fails(function () {
        $GOPS.f(1);
      });
      $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
          return $GOPS.f(toObject(it));
        }
      }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

      $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
        var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
        // WebKit converts symbol values to JSON as null
        // V8 throws on boxed symbols

        return _stringify([S]) != '[null]' || _stringify({
          a: S
        }) != '{}' || _stringify(Object(S)) != '{}';
      })), 'JSON', {
        stringify: function stringify(it) {
          var args = [it];
          var i = 1;
          var replacer, $replacer;

          while (arguments.length > i) {
            args.push(arguments[i++]);
          }

          $replacer = replacer = args[1];
          if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

          if (!isArray(replacer)) replacer = function replacer(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!isSymbol(value)) return value;
          };
          args[1] = replacer;
          return _stringify.apply($JSON, args);
        }
      }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

      $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(23)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

      setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

      setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

      setToStringTag(global.JSON, 'JSON', true);
      /***/
    },
    /* 239 */

    /***/
    function (module, exports, __webpack_require__) {
      var META = __webpack_require__(52)('meta');

      var isObject = __webpack_require__(20);

      var has = __webpack_require__(24);

      var setDesc = __webpack_require__(16).f;

      var id = 0;

      var isExtensible = Object.isExtensible || function () {
        return true;
      };

      var FREEZE = !__webpack_require__(30)(function () {
        return isExtensible(Object.preventExtensions({}));
      });

      var setMeta = function setMeta(it) {
        setDesc(it, META, {
          value: {
            i: 'O' + ++id,
            // object ID
            w: {} // weak collections IDs

          }
        });
      };

      var fastKey = function fastKey(it, create) {
        // return primitive with prefix
        if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return 'F'; // not necessary to add metadata

          if (!create) return 'E'; // add missing metadata

          setMeta(it); // return object ID
        }

        return it[META].i;
      };

      var getWeak = function getWeak(it, create) {
        if (!has(it, META)) {
          // can't set metadata to uncaught frozen object
          if (!isExtensible(it)) return true; // not necessary to add metadata

          if (!create) return false; // add missing metadata

          setMeta(it); // return hash weak collections IDs
        }

        return it[META].w;
      }; // add metadata on freeze-family methods calling


      var onFreeze = function onFreeze(it) {
        if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
        return it;
      };

      var meta = module.exports = {
        KEY: META,
        NEED: false,
        fastKey: fastKey,
        getWeak: getWeak,
        onFreeze: onFreeze
      };
      /***/
    },
    /* 240 */

    /***/
    function (module, exports, __webpack_require__) {
      // all enumerable object keys, includes symbols
      var getKeys = __webpack_require__(42);

      var gOPS = __webpack_require__(79);

      var pIE = __webpack_require__(55);

      module.exports = function (it) {
        var result = getKeys(it);
        var getSymbols = gOPS.f;

        if (getSymbols) {
          var symbols = getSymbols(it);
          var isEnum = pIE.f;
          var i = 0;
          var key;

          while (symbols.length > i) {
            if (isEnum.call(it, key = symbols[i++])) result.push(key);
          }
        }

        return result;
      };
      /***/

    },
    /* 241 */

    /***/
    function (module, exports, __webpack_require__) {
      // 7.2.2 IsArray(argument)
      var cof = __webpack_require__(43);

      module.exports = Array.isArray || function isArray(arg) {
        return cof(arg) == 'Array';
      };
      /***/

    },
    /* 242 */

    /***/
    function (module, exports, __webpack_require__) {
      // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
      var toIObject = __webpack_require__(32);

      var gOPN = __webpack_require__(118).f;

      var toString = {}.toString;
      var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

      var getWindowNames = function getWindowNames(it) {
        try {
          return gOPN(it);
        } catch (e) {
          return windowNames.slice();
        }
      };

      module.exports.f = function getOwnPropertyNames(it) {
        return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
      };
      /***/

    },
    /* 243 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(81)('asyncIterator');
      /***/

    },
    /* 244 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(81)('observable');
      /***/

    },
    /* 245 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(246),
        __esModule: true
      };
      /***/
    },
    /* 246 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(247);

      module.exports = __webpack_require__(7).Object.setPrototypeOf;
      /***/
    },
    /* 247 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.3.19 Object.setPrototypeOf(O, proto)
      var $export = __webpack_require__(11);

      $export($export.S, 'Object', {
        setPrototypeOf: __webpack_require__(248).set
      });
      /***/
    },
    /* 248 */

    /***/
    function (module, exports, __webpack_require__) {
      // Works with __proto__ only. Old v8 can't work with null proto objects.

      /* eslint-disable no-proto */
      var isObject = __webpack_require__(20);

      var anObject = __webpack_require__(14);

      var check = function check(O, proto) {
        anObject(O);
        if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
      };

      module.exports = {
        set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
        function (test, buggy, set) {
          try {
            set = __webpack_require__(29)(Function.call, __webpack_require__(119).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
          } catch (e) {
            buggy = true;
          }

          return function setPrototypeOf(O, proto) {
            check(O, proto);
            if (buggy) O.__proto__ = proto;else set(O, proto);
            return O;
          };
        }({}, false) : undefined),
        check: check
      };
      /***/
    },
    /* 249 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(250),
        __esModule: true
      };
      /***/
    },
    /* 250 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(251);

      var $Object = __webpack_require__(7).Object;

      module.exports = function create(P, D) {
        return $Object.create(P, D);
      };
      /***/

    },
    /* 251 */

    /***/
    function (module, exports, __webpack_require__) {
      var $export = __webpack_require__(11); // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])


      $export($export.S, 'Object', {
        create: __webpack_require__(71)
      });
      /***/
    },
    /* 252 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _FlipMove = __webpack_require__(253);

      var _FlipMove2 = _interopRequireDefault(_FlipMove);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = _FlipMove2.default;
      /**
       * React Flip Move
       * (c) 2016-present Joshua Comeau
       */

      module.exports = exports['default'];
      /***/
    },
    /* 253 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _slicedToArray = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if (Symbol.iterator in Object(arr)) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };

      var _createClass = function () {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        return function (Constructor, protoProps, staticProps) {
          if (protoProps) defineProperties(Constructor.prototype, protoProps);
          if (staticProps) defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();

      var _react = __webpack_require__(12);

      var _react2 = _interopRequireDefault(_react);

      __webpack_require__(254);

      var _propConverter = __webpack_require__(255);

      var _propConverter2 = _interopRequireDefault(_propConverter);

      var _domManipulation = __webpack_require__(258);

      var _helpers = __webpack_require__(82);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }

      function _possibleConstructorReturn(self, call) {
        if (!self) {
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        }

        return call && (typeof call === "object" || typeof call === "function") ? call : self;
      }

      function _inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) {
          throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
        }

        subClass.prototype = Object.create(superClass && superClass.prototype, {
          constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
      }
      /**
       * React Flip Move
       * (c) 2016-present Joshua Comeau
       *
       * For information on how this code is laid out, check out CODE_TOUR.md
       */

      /* eslint-disable react/prop-types */


      var transitionEnd = (0, _domManipulation.whichTransitionEvent)();
      var noBrowserSupport = !transitionEnd;

      function getKey(childData) {
        return childData.key || '';
      }

      var FlipMove = function (_Component) {
        _inherits(FlipMove, _Component);

        function FlipMove() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, FlipMove);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FlipMove.__proto__ || Object.getPrototypeOf(FlipMove)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            children: _react.Children.toArray(_this.props.children).map(function (element) {
              return _extends({}, element, {
                element: element,
                appearing: true
              });
            })
          }, _this.childrenData = {}, _this.parentData = {
            domNode: null,
            boundingBox: null
          }, _this.heightPlaceholderData = {
            domNode: null
          }, _this.remainingAnimations = 0, _this.childrenToAnimate = [], _this.runAnimation = function () {
            var dynamicChildren = _this.state.children.filter(_this.doesChildNeedToBeAnimated);

            dynamicChildren.forEach(function (child, n) {
              _this.remainingAnimations += 1;

              _this.childrenToAnimate.push(getKey(child));

              _this.animateChild(child, n);
            });

            if (typeof _this.props.onStartAll === 'function') {
              _this.callChildrenHook(_this.props.onStartAll);
            }
          }, _this.doesChildNeedToBeAnimated = function (child) {
            // If the child doesn't have a key, it's an immovable child (one that we
            // do not want to do FLIP stuff to.)
            if (!getKey(child)) {
              return false;
            }

            var childData = _this.getChildData(getKey(child));

            var childDomNode = childData.domNode;
            var childBoundingBox = childData.boundingBox;
            var parentBoundingBox = _this.parentData.boundingBox;

            if (!childDomNode) {
              return false;
            }

            var _this$props = _this.props,
                appearAnimation = _this$props.appearAnimation,
                enterAnimation = _this$props.enterAnimation,
                leaveAnimation = _this$props.leaveAnimation,
                getPosition = _this$props.getPosition;
            var isAppearingWithAnimation = child.appearing && appearAnimation;
            var isEnteringWithAnimation = child.entering && enterAnimation;
            var isLeavingWithAnimation = child.leaving && leaveAnimation;

            if (isAppearingWithAnimation || isEnteringWithAnimation || isLeavingWithAnimation) {
              return true;
            } // If it isn't entering/leaving, we want to animate it if it's
            // on-screen position has changed.


            var _getPositionDelta = (0, _domManipulation.getPositionDelta)({
              childDomNode: childDomNode,
              childBoundingBox: childBoundingBox,
              parentBoundingBox: parentBoundingBox,
              getPosition: getPosition
            }),
                _getPositionDelta2 = _slicedToArray(_getPositionDelta, 2),
                dX = _getPositionDelta2[0],
                dY = _getPositionDelta2[1];

            return dX !== 0 || dY !== 0;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        } // Copy props.children into state.
        // To understand why this is important (and not an anti-pattern), consider
        // how "leave" animations work. An item has "left" when the component
        // receives a new set of props that do NOT contain the item.
        // If we just render the props as-is, the item would instantly disappear.
        // We want to keep the item rendered for a little while, until its animation
        // can complete. Because we cannot mutate props, we make `state` the source
        // of truth.
        // FlipMove needs to know quite a bit about its children in order to do
        // its job. We store these as a property on the instance. We're not using
        // state, because we don't want changes to trigger re-renders, we just
        // need a place to keep the data for reference, when changes happen.
        // This field should not be accessed directly. Instead, use getChildData,
        // putChildData, etc...
        // Similarly, track the dom node and box of our parent element.
        // If `maintainContainerHeight` prop is set to true, we'll create a
        // placeholder element which occupies space so that the parent height
        // doesn't change when items are removed from the document flow (which
        // happens during leave animations)
        // Keep track of remaining animations so we know when to fire the
        // all-finished callback, and clean up after ourselves.
        // NOTE: we can't simply use childrenToAnimate.length to track remaining
        // animations, because we need to maintain the list of animating children,
        // to pass to the `onFinishAll` handler.


        _createClass(FlipMove, [{
          key: 'componentDidMount',
          value: function componentDidMount() {
            // Run our `appearAnimation` if it was requested, right after the
            // component mounts.
            var shouldTriggerFLIP = this.props.appearAnimation && !this.isAnimationDisabled(this.props);

            if (shouldTriggerFLIP) {
              this.prepForAnimation();
              this.runAnimation();
            }
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            // When the component is handed new props, we need to figure out the
            // "resting" position of all currently-rendered DOM nodes.
            // We store that data in this.parent and this.children,
            // so it can be used later to work out the animation.
            this.updateBoundingBoxCaches(); // Convert opaque children object to array.

            var nextChildren = _react.Children.toArray(nextProps.children); // Next, we need to update our state, so that it contains our new set of
            // children. If animation is disabled or unsupported, this is easy;
            // we just copy our props into state.
            // Assuming that we can animate, though, we have to do some work.
            // Essentially, we want to keep just-deleted nodes in the DOM for a bit
            // longer, so that we can animate them away.


            this.setState({
              children: this.isAnimationDisabled(nextProps) ? nextChildren.map(function (element) {
                return _extends({}, element, {
                  element: element
                });
              }) : this.calculateNextSetOfChildren(nextChildren)
            });
          }
        }, {
          key: 'componentDidUpdate',
          value: function componentDidUpdate(previousProps) {
            // If the children have been re-arranged, moved, or added/removed,
            // trigger the main FLIP animation.
            //
            // IMPORTANT: We need to make sure that the children have actually changed.
            // At the end of the transition, we clean up nodes that need to be removed.
            var oldChildrenKeys = _react.Children.toArray(this.props.children).map(function (d) {
              return d.key;
            });

            var nextChildrenKeys = _react.Children.toArray(previousProps.children).map(function (d) {
              return d.key;
            });

            var shouldTriggerFLIP = !(0, _helpers.arraysEqual)(oldChildrenKeys, nextChildrenKeys) && !this.isAnimationDisabled(this.props);

            if (shouldTriggerFLIP) {
              this.prepForAnimation();
              this.runAnimation();
            }
          }
        }, {
          key: 'calculateNextSetOfChildren',
          value: function calculateNextSetOfChildren(nextChildren) {
            var _this2 = this; // We want to:
            //   - Mark all new children as `entering`
            //   - Pull in previous children that aren't in nextChildren, and mark them
            //     as `leaving`
            //   - Preserve the nextChildren list order, with leaving children in their
            //     appropriate places.
            //


            var updatedChildren = nextChildren.map(function (nextChild) {
              var child = _this2.findChildByKey(nextChild.key || ''); // If the current child did exist, but it was in the midst of leaving,
              // we want to treat it as though it's entering


              var isEntering = !child || child.leaving;
              return _extends({}, nextChild, {
                element: nextChild,
                entering: isEntering
              });
            }); // This is tricky. We want to keep the nextChildren's ordering, but with
            // any just-removed items maintaining their original position.
            // eg.
            //   this.state.children  = [ 1, 2, 3, 4 ]
            //   nextChildren         = [ 3, 1 ]
            //
            // In this example, we've removed the '2' & '4'
            // We want to end up with:  [ 2, 3, 1, 4 ]
            //
            // To accomplish that, we'll iterate through this.state.children. whenever
            // we find a match, we'll append our `leaving` flag to it, and insert it
            // into the nextChildren in its ORIGINAL position. Note that, as we keep
            // inserting old items into the new list, the "original" position will
            // keep incrementing.

            var numOfChildrenLeaving = 0;
            this.state.children.forEach(function (child, index) {
              var isLeaving = !nextChildren.find(function (_ref2) {
                var key = _ref2.key;
                return key === getKey(child);
              }); // If the child isn't leaving (or, if there is no leave animation),
              // we don't need to add it into the state children.

              if (!isLeaving || !_this2.props.leaveAnimation) return;

              var nextChild = _extends({}, child, {
                leaving: true
              });

              var nextChildIndex = index + numOfChildrenLeaving;
              updatedChildren.splice(nextChildIndex, 0, nextChild);
              numOfChildrenLeaving += 1;
            });
            return updatedChildren;
          }
        }, {
          key: 'prepForAnimation',
          value: function prepForAnimation() {
            var _this3 = this; // Our animation prep consists of:
            // - remove children that are leaving from the DOM flow, so that the new
            //   layout can be accurately calculated,
            // - update the placeholder container height, if needed, to ensure that
            //   the parent's height doesn't collapse.


            var _props = this.props,
                leaveAnimation = _props.leaveAnimation,
                maintainContainerHeight = _props.maintainContainerHeight,
                getPosition = _props.getPosition; // we need to make all leaving nodes "invisible" to the layout calculations
            // that will take place in the next step (this.runAnimation).

            if (leaveAnimation) {
              var leavingChildren = this.state.children.filter(function (child) {
                return child.leaving;
              });
              leavingChildren.forEach(function (leavingChild) {
                var childData = _this3.getChildData(getKey(leavingChild)); // We need to take the items out of the "flow" of the document, so that
                // its siblings can move to take its place.


                if (childData.boundingBox) {
                  (0, _domManipulation.removeNodeFromDOMFlow)(childData, _this3.props.verticalAlignment);
                }
              });

              if (maintainContainerHeight && this.heightPlaceholderData.domNode) {
                (0, _domManipulation.updateHeightPlaceholder)({
                  domNode: this.heightPlaceholderData.domNode,
                  parentData: this.parentData,
                  getPosition: getPosition
                });
              }
            } // For all children not in the middle of entering or leaving,
            // we need to reset the transition, so that the NEW shuffle starts from
            // the right place.


            this.state.children.forEach(function (child) {
              var _getChildData = _this3.getChildData(getKey(child)),
                  domNode = _getChildData.domNode; // Ignore children that don't render DOM nodes (eg. by returning null)


              if (!domNode) {
                return;
              }

              if (!child.entering && !child.leaving) {
                (0, _domManipulation.applyStylesToDOMNode)({
                  domNode: domNode,
                  styles: {
                    transition: ''
                  }
                });
              }
            });
          }
        }, {
          key: 'animateChild',
          value: function animateChild(child, index) {
            var _this4 = this;

            var _getChildData2 = this.getChildData(getKey(child)),
                domNode = _getChildData2.domNode;

            if (!domNode) {
              return;
            } // Apply the relevant style for this DOM node
            // This is the offset from its actual DOM position.
            // eg. if an item has been re-rendered 20px lower, we want to apply a
            // style of 'transform: translate(-20px)', so that it appears to be where
            // it started.
            // In FLIP terminology, this is the 'Invert' stage.


            (0, _domManipulation.applyStylesToDOMNode)({
              domNode: domNode,
              styles: this.computeInitialStyles(child)
            }); // Start by invoking the onStart callback for this child.

            if (this.props.onStart) this.props.onStart(child, domNode); // Next, animate the item from it's artificially-offset position to its
            // new, natural position.

            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                // NOTE, RE: the double-requestAnimationFrame:
                // Sadly, this is the most browser-compatible way to do this I've found.
                // Essentially we need to set the initial styles outside of any request
                // callbacks to avoid batching them. Then, a frame needs to pass with
                // the styles above rendered. Then, on the second frame, we can apply
                // our final styles to perform the animation.
                // Our first order of business is to "undo" the styles applied in the
                // previous frames, while also adding a `transition` property.
                // This way, the item will smoothly transition from its old position
                // to its new position.
                // eslint-disable-next-line flowtype/require-variable-type
                var styles = {
                  transition: (0, _domManipulation.createTransitionString)(index, _this4.props),
                  transform: '',
                  opacity: ''
                };

                if (child.appearing && _this4.props.appearAnimation) {
                  styles = _extends({}, styles, _this4.props.appearAnimation.to);
                } else if (child.entering && _this4.props.enterAnimation) {
                  styles = _extends({}, styles, _this4.props.enterAnimation.to);
                } else if (child.leaving && _this4.props.leaveAnimation) {
                  styles = _extends({}, styles, _this4.props.leaveAnimation.to);
                } // In FLIP terminology, this is the 'Play' stage.


                (0, _domManipulation.applyStylesToDOMNode)({
                  domNode: domNode,
                  styles: styles
                });
              });
            });
            this.bindTransitionEndHandler(child);
          }
        }, {
          key: 'bindTransitionEndHandler',
          value: function bindTransitionEndHandler(child) {
            var _this5 = this;

            var _getChildData3 = this.getChildData(getKey(child)),
                domNode = _getChildData3.domNode;

            if (!domNode) {
              return;
            } // The onFinish callback needs to be bound to the transitionEnd event.
            // We also need to unbind it when the transition completes, so this ugly
            // inline function is required (we need it here so it closes over
            // dependent variables `child` and `domNode`)


            var transitionEndHandler = function transitionEndHandler(ev) {
              // It's possible that this handler is fired not on our primary transition,
              // but on a nested transition (eg. a hover effect). Ignore these cases.
              if (ev.target !== domNode) return; // Remove the 'transition' inline style we added. This is cleanup.

              domNode.style.transition = ''; // Trigger any applicable onFinish/onFinishAll hooks

              _this5.triggerFinishHooks(child, domNode);

              domNode.removeEventListener(transitionEnd, transitionEndHandler);

              if (child.leaving) {
                _this5.removeChildData(getKey(child));
              }
            };

            domNode.addEventListener(transitionEnd, transitionEndHandler);
          }
        }, {
          key: 'triggerFinishHooks',
          value: function triggerFinishHooks(child, domNode) {
            var _this6 = this;

            if (this.props.onFinish) this.props.onFinish(child, domNode); // Reduce the number of children we need to animate by 1,
            // so that we can tell when all children have finished.

            this.remainingAnimations -= 1;

            if (this.remainingAnimations === 0) {
              // Remove any items from the DOM that have left, and reset `entering`.
              var nextChildren = this.state.children.filter(function (_ref3) {
                var leaving = _ref3.leaving;
                return !leaving;
              }).map(function (item) {
                return _extends({}, item, {
                  appearing: false,
                  entering: false
                });
              });
              this.setState({
                children: nextChildren
              }, function () {
                if (typeof _this6.props.onFinishAll === 'function') {
                  _this6.callChildrenHook(_this6.props.onFinishAll);
                } // Reset our variables for the next iteration


                _this6.childrenToAnimate = [];
              }); // If the placeholder was holding the container open while elements were
              // leaving, we we can now set its height to zero.

              if (this.heightPlaceholderData.domNode) {
                this.heightPlaceholderData.domNode.style.height = '0';
              }
            }
          }
        }, {
          key: 'callChildrenHook',
          value: function callChildrenHook(hook) {
            var _this7 = this;

            var elements = [];
            var domNodes = [];
            this.childrenToAnimate.forEach(function (childKey) {
              // If this was an exit animation, the child may no longer exist.
              // If so, skip it.
              var child = _this7.findChildByKey(childKey);

              if (!child) {
                return;
              }

              elements.push(child);

              if (_this7.hasChildData(childKey)) {
                domNodes.push(_this7.getChildData(childKey).domNode);
              }
            });
            hook(elements, domNodes);
          }
        }, {
          key: 'updateBoundingBoxCaches',
          value: function updateBoundingBoxCaches() {
            var _this8 = this; // This is the ONLY place that parentData and childrenData's
            // bounding boxes are updated. They will be calculated at other times
            // to be compared to this value, but it's important that the cache is
            // updated once per update.


            var parentDomNode = this.parentData.domNode;

            if (!parentDomNode) {
              return;
            }

            this.parentData.boundingBox = this.props.getPosition(parentDomNode);
            this.state.children.forEach(function (child) {
              var childKey = getKey(child); // It is possible that a child does not have a `key` property;
              // Ignore these children, they don't need to be moved.

              if (!childKey) {
                return;
              } // In very rare circumstances, for reasons unknown, the ref is never
              // populated for certain children. In this case, avoid doing this update.
              // see: https://github.com/joshwcomeau/react-flip-move/pull/91


              if (!_this8.hasChildData(childKey)) {
                return;
              }

              var childData = _this8.getChildData(childKey); // If the child element returns null, we need to avoid trying to
              // account for it


              if (!childData.domNode || !child) {
                return;
              }

              _this8.setChildData(childKey, {
                boundingBox: (0, _domManipulation.getRelativeBoundingBox)({
                  childDomNode: childData.domNode,
                  parentDomNode: parentDomNode,
                  getPosition: _this8.props.getPosition
                })
              });
            });
          }
        }, {
          key: 'computeInitialStyles',
          value: function computeInitialStyles(child) {
            if (child.appearing) {
              return this.props.appearAnimation ? this.props.appearAnimation.from : {};
            } else if (child.entering) {
              if (!this.props.enterAnimation) {
                return {};
              } // If this child was in the middle of leaving, it still has its
              // absolute positioning styles applied. We need to undo those.


              return _extends({
                position: '',
                top: '',
                left: '',
                right: '',
                bottom: ''
              }, this.props.enterAnimation.from);
            } else if (child.leaving) {
              return this.props.leaveAnimation ? this.props.leaveAnimation.from : {};
            }

            var childData = this.getChildData(getKey(child));
            var childDomNode = childData.domNode;
            var childBoundingBox = childData.boundingBox;
            var parentBoundingBox = this.parentData.boundingBox;

            if (!childDomNode) {
              return {};
            }

            var _getPositionDelta3 = (0, _domManipulation.getPositionDelta)({
              childDomNode: childDomNode,
              childBoundingBox: childBoundingBox,
              parentBoundingBox: parentBoundingBox,
              getPosition: this.props.getPosition
            }),
                _getPositionDelta4 = _slicedToArray(_getPositionDelta3, 2),
                dX = _getPositionDelta4[0],
                dY = _getPositionDelta4[1];

            return {
              transform: 'translate(' + dX + 'px, ' + dY + 'px)'
            };
          } // eslint-disable-next-line class-methods-use-this

        }, {
          key: 'isAnimationDisabled',
          value: function isAnimationDisabled(props) {
            // If the component is explicitly passed a `disableAllAnimations` flag,
            // we can skip this whole process. Similarly, if all of the numbers have
            // been set to 0, there is no point in trying to animate; doing so would
            // only cause a flicker (and the intent is probably to disable animations)
            // We can also skip this rigamarole if there's no browser support for it.
            return noBrowserSupport || props.disableAllAnimations || props.duration === 0 && props.delay === 0 && props.staggerDurationBy === 0 && props.staggerDelayBy === 0;
          }
        }, {
          key: 'findChildByKey',
          value: function findChildByKey(key) {
            return this.state.children.find(function (child) {
              return getKey(child) === key;
            });
          }
        }, {
          key: 'hasChildData',
          value: function hasChildData(key) {
            // Object has some built-in properties on its prototype, such as toString.  hasOwnProperty makes
            // sure that key is present on childrenData itself, not on its prototype.
            return Object.prototype.hasOwnProperty.call(this.childrenData, key);
          }
        }, {
          key: 'getChildData',
          value: function getChildData(key) {
            return this.hasChildData(key) ? this.childrenData[key] : {};
          }
        }, {
          key: 'setChildData',
          value: function setChildData(key, data) {
            this.childrenData[key] = _extends({}, this.getChildData(key), data);
          }
        }, {
          key: 'removeChildData',
          value: function removeChildData(key) {
            delete this.childrenData[key];
          }
        }, {
          key: 'createHeightPlaceholder',
          value: function createHeightPlaceholder() {
            var _this9 = this;

            var typeName = this.props.typeName; // If requested, create an invisible element at the end of the list.
            // Its height will be modified to prevent the container from collapsing
            // prematurely.

            var isContainerAList = typeName === 'ul' || typeName === 'ol';
            var placeholderType = isContainerAList ? 'li' : 'div';
            return _react2.default.createElement(placeholderType, {
              key: 'height-placeholder',
              ref: function ref(domNode) {
                _this9.heightPlaceholderData.domNode = domNode;
              },
              style: {
                visibility: 'hidden',
                height: 0
              }
            });
          }
        }, {
          key: 'childrenWithRefs',
          value: function childrenWithRefs() {
            var _this10 = this; // We need to clone the provided children, capturing a reference to the
            // underlying DOM node. Flip Move needs to use the React escape hatches to
            // be able to do its calculations.


            return this.state.children.map(function (child) {
              return _react2.default.cloneElement(child.element, {
                ref: function ref(element) {
                  // Stateless Functional Components are not supported by FlipMove,
                  // because they don't have instances.
                  if (!element) {
                    return;
                  }

                  var domNode = (0, _domManipulation.getNativeNode)(element);

                  _this10.setChildData(getKey(child), {
                    domNode: domNode
                  });
                }
              });
            });
          }
        }, {
          key: 'render',
          value: function render() {
            var _this11 = this;

            var _props2 = this.props,
                typeName = _props2.typeName,
                delegated = _props2.delegated,
                leaveAnimation = _props2.leaveAnimation,
                maintainContainerHeight = _props2.maintainContainerHeight;

            var props = _extends({}, delegated, {
              ref: function ref(node) {
                _this11.parentData.domNode = node;
              }
            });

            var children = this.childrenWithRefs();

            if (leaveAnimation && maintainContainerHeight) {
              children.push(this.createHeightPlaceholder());
            }

            return _react2.default.createElement(typeName, props, children);
          }
        }]);

        return FlipMove;
      }(_react.Component);

      exports.default = (0, _propConverter2.default)(FlipMove);
      module.exports = exports['default'];
      /***/
    },
    /* 254 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict"; // @noflow

      /**
       * React Flip Move - Polyfills
       * (c) 2016-present Joshua Comeau
       */

      /* eslint-disable */

      if (!Array.prototype.find) {
        Array.prototype.find = function (predicate) {
          if (this === null) {
            throw new TypeError('Array.prototype.find called on null or undefined');
          }

          if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
          }

          var list = Object(this);
          var length = list.length >>> 0;
          var thisArg = arguments[1];
          var value = void 0;

          for (var i = 0; i < length; i++) {
            value = list[i];

            if (predicate.call(thisArg, value, i, list)) {
              return value;
            }
          }

          return undefined;
        };
      }

      if (!Array.prototype.every) {
        Array.prototype.every = function (callbackfn, thisArg) {
          'use strict';

          var T, k;

          if (this == null) {
            throw new TypeError('this is null or not defined');
          }

          var O = Object(this);
          var len = O.length >>> 0;

          if (typeof callbackfn !== 'function') {
            throw new TypeError();
          }

          if (arguments.length > 1) {
            T = thisArg;
          }

          k = 0;

          while (k < len) {
            var kValue;

            if (k in O) {
              kValue = O[k];
              var testResult = callbackfn.call(T, kValue, k, O);

              if (!testResult) {
                return false;
              }
            }

            k++;
          }

          return true;
        };
      }

      if (!Array.isArray) {
        Array.isArray = function (arg) {
          return Object.prototype.toString.call(arg) === '[object Array]';
        };
      }
      /***/

    },
    /* 255 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /* WEBPACK VAR INJECTION */

      (function (process) {
        Object.defineProperty(exports, "__esModule", {
          value: true
        });

        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
          return typeof obj;
        } : function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _react = __webpack_require__(12);

        var _react2 = _interopRequireDefault(_react);

        var _errorMessages = __webpack_require__(256);

        var _enterLeavePresets = __webpack_require__(257);

        var _helpers = __webpack_require__(82);

        function _interopRequireDefault(obj) {
          return obj && obj.__esModule ? obj : {
            default: obj
          };
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        /**
         * React Flip Move | propConverter
         * (c) 2016-present Joshua Comeau
         *
         * Abstracted away a bunch of the messy business with props.
         *   - props flow types and defaultProps
         *   - Type conversion (We accept 'string' and 'number' values for duration,
         *     delay, and other fields, but we actually need them to be ints.)
         *   - Children conversion (we need the children to be an array. May not always
         *     be, if a single child is passed in.)
         *   - Resolving animation presets into their base CSS styles
         */

        /* eslint-disable block-scoped-var */


        var nodeEnv = void 0;

        try {
          nodeEnv = process.env.NODE_ENV;
        } catch (e) {
          nodeEnv = 'development';
        }

        function propConverter(ComposedComponent) {
          var _class, _temp;

          return _temp = _class = function (_Component) {
            _inherits(FlipMovePropConverter, _Component);

            function FlipMovePropConverter() {
              _classCallCheck(this, FlipMovePropConverter);

              return _possibleConstructorReturn(this, (FlipMovePropConverter.__proto__ || Object.getPrototypeOf(FlipMovePropConverter)).apply(this, arguments));
            }

            _createClass(FlipMovePropConverter, [{
              key: 'checkForStatelessFunctionalComponents',
              // eslint-disable-next-line class-methods-use-this
              value: function checkForStatelessFunctionalComponents(children) {
                // Skip all console warnings in production.
                // Bail early, to avoid unnecessary work.
                if (nodeEnv === 'production') {
                  return;
                } // FlipMove does not support stateless functional components.
                // Check to see if any supplied components won't work.
                // If the child doesn't have a key, it means we aren't animating it.
                // It's allowed to be an SFC, since we ignore it.


                var childArray = _react.Children.toArray(children);

                var noStateless = childArray.every(function (child) {
                  return !(0, _helpers.isElementAnSFC)(child) || typeof child.key === 'undefined';
                });

                if (!noStateless) {
                  (0, _errorMessages.statelessFunctionalComponentSupplied)();
                }
              }
            }, {
              key: 'convertProps',
              value: function convertProps(props) {
                var workingProps = {
                  // explicitly bypass the props that don't need conversion
                  children: props.children,
                  easing: props.easing,
                  onStart: props.onStart,
                  onFinish: props.onFinish,
                  onStartAll: props.onStartAll,
                  onFinishAll: props.onFinishAll,
                  typeName: props.typeName,
                  disableAllAnimations: props.disableAllAnimations,
                  getPosition: props.getPosition,
                  maintainContainerHeight: props.maintainContainerHeight,
                  verticalAlignment: props.verticalAlignment,
                  // Do string-to-int conversion for all timing-related props
                  duration: this.convertTimingProp('duration'),
                  delay: this.convertTimingProp('delay'),
                  staggerDurationBy: this.convertTimingProp('staggerDurationBy'),
                  staggerDelayBy: this.convertTimingProp('staggerDelayBy'),
                  // Our enter/leave animations can be specified as boolean (default or
                  // disabled), string (preset name), or object (actual animation values).
                  // Let's standardize this so that they're always objects
                  appearAnimation: this.convertAnimationProp(props.appearAnimation, _enterLeavePresets.appearPresets),
                  enterAnimation: this.convertAnimationProp(props.enterAnimation, _enterLeavePresets.enterPresets),
                  leaveAnimation: this.convertAnimationProp(props.leaveAnimation, _enterLeavePresets.leavePresets),
                  delegated: {}
                };
                this.checkForStatelessFunctionalComponents(workingProps.children); // Accept `disableAnimations`, but add a deprecation warning

                if (typeof props.disableAnimations !== 'undefined') {
                  if (nodeEnv !== 'production') {
                    (0, _errorMessages.deprecatedDisableAnimations)();
                  }

                  workingProps.disableAllAnimations = props.disableAnimations;
                } // Gather any additional props;
                // they will be delegated to the ReactElement created.


                var primaryPropKeys = Object.keys(workingProps);
                var delegatedProps = (0, _helpers.omit)(this.props, primaryPropKeys); // The FlipMove container element needs to have a non-static position.
                // We use `relative` by default, but it can be overridden by the user.
                // Now that we're delegating props, we need to merge this in.

                delegatedProps.style = _extends({
                  position: 'relative'
                }, delegatedProps.style);
                workingProps.delegated = delegatedProps;
                return workingProps;
              }
            }, {
              key: 'convertTimingProp',
              value: function convertTimingProp(prop) {
                var rawValue = this.props[prop];
                var value = typeof rawValue === 'number' ? rawValue : parseInt(rawValue, 10);

                if (isNaN(value)) {
                  var defaultValue = FlipMovePropConverter.defaultProps[prop];

                  if (nodeEnv !== 'production') {
                    (0, _errorMessages.invalidTypeForTimingProp)({
                      prop: prop,
                      value: rawValue,
                      defaultValue: defaultValue
                    });
                  }

                  return defaultValue;
                }

                return value;
              } // eslint-disable-next-line class-methods-use-this

            }, {
              key: 'convertAnimationProp',
              value: function convertAnimationProp(animation, presets) {
                switch (typeof animation === 'undefined' ? 'undefined' : _typeof(animation)) {
                  case 'boolean':
                    {
                      // If it's true, we want to use the default preset.
                      // If it's false, we want to use the 'none' preset.
                      return presets[animation ? _enterLeavePresets.defaultPreset : _enterLeavePresets.disablePreset];
                    }

                  case 'string':
                    {
                      var presetKeys = Object.keys(presets);

                      if (presetKeys.indexOf(animation) === -1) {
                        if (nodeEnv !== 'production') {
                          (0, _errorMessages.invalidEnterLeavePreset)({
                            value: animation,
                            acceptableValues: presetKeys.join(', '),
                            defaultValue: _enterLeavePresets.defaultPreset
                          });
                        }

                        return presets[_enterLeavePresets.defaultPreset];
                      }

                      return presets[animation];
                    }

                  default:
                    {
                      return animation;
                    }
                }
              }
            }, {
              key: 'render',
              value: function render() {
                return _react2.default.createElement(ComposedComponent, this.convertProps(this.props));
              }
            }]);

            return FlipMovePropConverter;
          }(_react.Component), _class.defaultProps = {
            easing: 'ease-in-out',
            duration: 350,
            delay: 0,
            staggerDurationBy: 0,
            staggerDelayBy: 0,
            typeName: 'div',
            enterAnimation: _enterLeavePresets.defaultPreset,
            leaveAnimation: _enterLeavePresets.defaultPreset,
            disableAllAnimations: false,
            getPosition: function getPosition(node) {
              return node.getBoundingClientRect();
            },
            maintainContainerHeight: false,
            verticalAlignment: 'top'
          }, _temp;
        }

        exports.default = propConverter;
        module.exports = exports['default'];
        /* WEBPACK VAR INJECTION */
      }).call(exports, __webpack_require__(18));
      /***/
    },
    /* 256 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      function warnOnce(msg) {
        var hasWarned = false;
        return function () {
          if (!hasWarned) {
            console.warn(msg);
            hasWarned = true;
          }
        };
      }

      var statelessFunctionalComponentSupplied = exports.statelessFunctionalComponentSupplied = warnOnce('\n>> Error, via react-flip-move <<\n\nYou provided a stateless functional component as a child to <FlipMove>. Unfortunately, SFCs aren\'t supported, because Flip Move needs access to the backing instances via refs, and SFCs don\'t have a public instance that holds that info.\n\nPlease wrap your components in a native element (eg. <div>), or a non-functional component.\n');

      var invalidTypeForTimingProp = exports.invalidTypeForTimingProp = function invalidTypeForTimingProp(args) {
        return console.error('\n>> Error, via react-flip-move <<\n\nThe prop you provided for \'' + args.prop + '\' is invalid. It needs to be a positive integer, or a string that can be resolved to a number. The value you provided is \'' + args.value + '\'.\n\nAs a result,  the default value for this parameter will be used, which is \'' + args.defaultValue + '\'.\n');
      };

      var deprecatedDisableAnimations = exports.deprecatedDisableAnimations = warnOnce('\n>> Warning, via react-flip-move <<\n\nThe \'disableAnimations\' prop you provided is deprecated. Please switch to use \'disableAllAnimations\'.\n\nThis will become a silent error in future versions of react-flip-move.\n');

      var invalidEnterLeavePreset = exports.invalidEnterLeavePreset = function invalidEnterLeavePreset(args) {
        return console.error('\n>> Error, via react-flip-move <<\n\nThe enter/leave preset you provided is invalid. We don\'t currently have a \'' + args.value + ' preset.\'\n\nAcceptable values are ' + args.acceptableValues + '. The default value of \'' + args.defaultValue + '\' will be used.\n');
      };
      /***/

    },
    /* 257 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var enterPresets = exports.enterPresets = {
        elevator: {
          from: {
            transform: 'scale(0)',
            opacity: '0'
          },
          to: {
            transform: '',
            opacity: ''
          }
        },
        fade: {
          from: {
            opacity: '0'
          },
          to: {
            opacity: ''
          }
        },
        accordionVertical: {
          from: {
            transform: 'scaleY(0)',
            transformOrigin: 'center top'
          },
          to: {
            transform: '',
            transformOrigin: 'center top'
          }
        },
        accordionHorizontal: {
          from: {
            transform: 'scaleX(0)',
            transformOrigin: 'left center'
          },
          to: {
            transform: '',
            transformOrigin: 'left center'
          }
        },
        none: null
      };
      /**
       * React Flip Move | enterLeavePresets
       * (c) 2016-present Joshua Comeau
       *
       * This contains the master list of presets available for enter/leave animations,
       * along with the mapping between preset and styles.
       */

      var leavePresets = exports.leavePresets = {
        elevator: {
          from: {
            transform: 'scale(1)',
            opacity: '1'
          },
          to: {
            transform: 'scale(0)',
            opacity: '0'
          }
        },
        fade: {
          from: {
            opacity: '1'
          },
          to: {
            opacity: '0'
          }
        },
        accordionVertical: {
          from: {
            transform: 'scaleY(1)',
            transformOrigin: 'center top'
          },
          to: {
            transform: 'scaleY(0)',
            transformOrigin: 'center top'
          }
        },
        accordionHorizontal: {
          from: {
            transform: 'scaleX(1)',
            transformOrigin: 'left center'
          },
          to: {
            transform: 'scaleX(0)',
            transformOrigin: 'left center'
          }
        },
        none: null
      }; // For now, appearPresets will be identical to enterPresets.
      // Assigning a custom export in case we ever want to add appear-specific ones.

      var appearPresets = exports.appearPresets = enterPresets; // Embarrassingly enough, v2.0 launched with typo'ed preset names.
      // To avoid penning a new major version over something so inconsequential,
      // we're supporting both spellings. In a future version, these alternatives
      // may be deprecated.
      // $FlowFixMe

      enterPresets.accordianVertical = enterPresets.accordionVertical; // $FlowFixMe

      enterPresets.accordianHorizontal = enterPresets.accordionHorizontal; // $FlowFixMe

      leavePresets.accordianVertical = leavePresets.accordionVertical; // $FlowFixMe

      leavePresets.accordianHorizontal = leavePresets.accordionHorizontal;
      var defaultPreset = exports.defaultPreset = 'elevator';
      var disablePreset = exports.disablePreset = 'none';
      /***/
    },
    /* 258 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.createTransitionString = exports.getNativeNode = exports.updateHeightPlaceholder = exports.removeNodeFromDOMFlow = exports.getPositionDelta = exports.getRelativeBoundingBox = undefined;

      var _extends = Object.assign || function (target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];

          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }

        return target;
      };
      /**
       * React Flip Move
       * (c) 2016-present Joshua Comeau
       *
       * These methods read from and write to the DOM.
       * They almost always have side effects, and will hopefully become the
       * only spot in the codebase with impure functions.
       */


      exports.applyStylesToDOMNode = applyStylesToDOMNode;
      exports.whichTransitionEvent = whichTransitionEvent;

      var _reactDom = __webpack_require__(12);

      var _helpers = __webpack_require__(82);

      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }

        return obj;
      }

      function applyStylesToDOMNode(_ref) {
        var domNode = _ref.domNode,
            styles = _ref.styles; // Can't just do an object merge because domNode.styles is no regular object.
        // Need to do it this way for the engine to fire its `set` listeners.

        Object.keys(styles).forEach(function (key) {
          domNode.style.setProperty((0, _helpers.hyphenate)(key), styles[key]);
        });
      } // Modified from Modernizr


      function whichTransitionEvent() {
        var transitions = {
          transition: 'transitionend',
          '-o-transition': 'oTransitionEnd',
          '-moz-transition': 'transitionend',
          '-webkit-transition': 'webkitTransitionEnd'
        }; // If we're running in a browserless environment (eg. SSR), it doesn't apply.
        // Return a placeholder string, for consistent type return.

        if (typeof document === 'undefined') return '';
        var el = document.createElement('fakeelement');
        var match = Object.keys(transitions).find(function (t) {
          return el.style.getPropertyValue(t) !== undefined;
        }); // If no `transition` is found, we must be running in a browser so ancient,
        // React itself won't run. Return an empty string, for consistent type return

        return match ? transitions[match] : '';
      }

      var getRelativeBoundingBox = exports.getRelativeBoundingBox = function getRelativeBoundingBox(_ref2) {
        var childDomNode = _ref2.childDomNode,
            parentDomNode = _ref2.parentDomNode,
            getPosition = _ref2.getPosition;
        var parentBox = getPosition(parentDomNode);

        var _getPosition = getPosition(childDomNode),
            top = _getPosition.top,
            left = _getPosition.left,
            right = _getPosition.right,
            bottom = _getPosition.bottom,
            width = _getPosition.width,
            height = _getPosition.height;

        return {
          top: top - parentBox.top,
          left: left - parentBox.left,
          right: parentBox.right - right,
          bottom: parentBox.bottom - bottom,
          width: width,
          height: height
        };
      };
      /** getPositionDelta
       * This method returns the delta between two bounding boxes, to figure out
       * how many pixels on each axis the element has moved.
       *
       */


      var getPositionDelta = exports.getPositionDelta = function getPositionDelta(_ref3) {
        var childDomNode = _ref3.childDomNode,
            childBoundingBox = _ref3.childBoundingBox,
            parentBoundingBox = _ref3.parentBoundingBox,
            getPosition = _ref3.getPosition; // TEMP: A mystery bug is sometimes causing unnecessary boundingBoxes to

        var defaultBox = {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height: 0,
          width: 0
        }; // Our old box is its last calculated position, derived on mount or at the
        // start of the previous animation.

        var oldRelativeBox = childBoundingBox || defaultBox;
        var parentBox = parentBoundingBox || defaultBox; // Our new box is the new final resting place: Where we expect it to wind up
        // after the animation. First we get the box in absolute terms (AKA relative
        // to the viewport), and then we calculate its relative box (relative to the
        // parent container)

        var newAbsoluteBox = getPosition(childDomNode);
        var newRelativeBox = {
          top: newAbsoluteBox.top - parentBox.top,
          left: newAbsoluteBox.left - parentBox.left
        };
        return [oldRelativeBox.left - newRelativeBox.left, oldRelativeBox.top - newRelativeBox.top];
      };
      /** removeNodeFromDOMFlow
       * This method does something very sneaky: it removes a DOM node from the
       * document flow, but without actually changing its on-screen position.
       *
       * It works by calculating where the node is, and then applying styles
       * so that it winds up being positioned absolutely, but in exactly the
       * same place.
       *
       * This is a vital part of the FLIP technique.
       */


      var removeNodeFromDOMFlow = exports.removeNodeFromDOMFlow = function removeNodeFromDOMFlow(childData, verticalAlignment) {
        var domNode = childData.domNode,
            boundingBox = childData.boundingBox;

        if (!domNode || !boundingBox) {
          return;
        } // For this to work, we have to offset any given `margin`.


        var computed = window.getComputedStyle(domNode); // We need to clean up margins, by converting and removing suffix:
        // eg. '21px' -> 21

        var marginAttrs = ['margin-top', 'margin-left', 'margin-right'];
        var margins = marginAttrs.reduce(function (acc, margin) {
          var propertyVal = computed.getPropertyValue(margin);
          return _extends({}, acc, _defineProperty({}, margin, Number(propertyVal.replace('px', ''))));
        }, {}); // If we're bottom-aligned, we need to add the height of the child to its
        // top offset. This is because, when the container is bottom-aligned, its
        // height shrinks from the top, not the bottom. We're removing this node
        // from the flow, so the top is going to drop by its height.

        var topOffset = verticalAlignment === 'bottom' ? boundingBox.top - boundingBox.height : boundingBox.top;
        var styles = {
          position: 'absolute',
          top: topOffset - margins['margin-top'] + 'px',
          left: boundingBox.left - margins['margin-left'] + 'px',
          right: boundingBox.right - margins['margin-right'] + 'px'
        };
        applyStylesToDOMNode({
          domNode: domNode,
          styles: styles
        });
      };
      /** updateHeightPlaceholder
       * An optional property to FlipMove is a `maintainContainerHeight` boolean.
       * This property creates a node that fills space, so that the parent
       * container doesn't collapse when its children are removed from the
       * document flow.
       */


      var updateHeightPlaceholder = exports.updateHeightPlaceholder = function updateHeightPlaceholder(_ref4) {
        var domNode = _ref4.domNode,
            parentData = _ref4.parentData,
            getPosition = _ref4.getPosition;
        var parentDomNode = parentData.domNode;
        var parentBoundingBox = parentData.boundingBox;

        if (!parentDomNode || !parentBoundingBox) {
          return;
        } // We need to find the height of the container *without* the placeholder.
        // Since it's possible that the placeholder might already be present,
        // we first set its height to 0.
        // This allows the container to collapse down to the size of just its
        // content (plus container padding or borders if any).


        applyStylesToDOMNode({
          domNode: domNode,
          styles: {
            height: '0'
          }
        }); // Find the distance by which the container would be collapsed by elements
        // leaving. We compare the freshly-available parent height with the original,
        // cached container height.

        var originalParentHeight = parentBoundingBox.height;
        var collapsedParentHeight = getPosition(parentDomNode).height;
        var reductionInHeight = originalParentHeight - collapsedParentHeight; // If the container has become shorter, update the padding element's
        // height to take up the difference. Otherwise set its height to zero,
        // so that it has no effect.

        var styles = {
          height: reductionInHeight > 0 ? reductionInHeight + 'px' : '0'
        };
        applyStylesToDOMNode({
          domNode: domNode,
          styles: styles
        });
      };

      var getNativeNode = exports.getNativeNode = function getNativeNode(element) {
        // When running in a windowless environment, abort!
        if (typeof HTMLElement === 'undefined') {
          return null;
        } // `element` may already be a native node.


        if (element instanceof HTMLElement) {
          return element;
        } // While ReactDOM's `findDOMNode` is discouraged, it's the only
        // publicly-exposed way to find the underlying DOM node for
        // composite components.


        var foundNode = (0, _reactDom.findDOMNode)(element);

        if (!(foundNode instanceof HTMLElement)) {
          // Text nodes are not supported
          return null;
        }

        return foundNode;
      };

      var createTransitionString = exports.createTransitionString = function createTransitionString(index, props) {
        var delay = props.delay,
            duration = props.duration;
        var staggerDurationBy = props.staggerDurationBy,
            staggerDelayBy = props.staggerDelayBy,
            easing = props.easing;
        delay += index * staggerDelayBy;
        duration += index * staggerDurationBy;
        var cssProperties = ['transform', 'opacity'];
        return cssProperties.map(function (prop) {
          return prop + ' ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
        }).join(', ');
      };
      /***/

    },
    /* 259 */

    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
      /*!
      Autosize 3.0.21
      license: MIT
      http://www.jacklmoore.com/autosize
      */


      (function (global, factory) {
        if (true) {
          !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
          factory(exports, module);
        } else {
          var mod = {
            exports: {}
          };
          factory(mod.exports, mod);
          global.autosize = mod.exports;
        }
      })(this, function (exports, module) {
        'use strict';

        var map = typeof Map === "function" ? new Map() : function () {
          var keys = [];
          var values = [];
          return {
            has: function has(key) {
              return keys.indexOf(key) > -1;
            },
            get: function get(key) {
              return values[keys.indexOf(key)];
            },
            set: function set(key, value) {
              if (keys.indexOf(key) === -1) {
                keys.push(key);
                values.push(value);
              }
            },
            'delete': function _delete(key) {
              var index = keys.indexOf(key);

              if (index > -1) {
                keys.splice(index, 1);
                values.splice(index, 1);
              }
            }
          };
        }();

        var createEvent = function createEvent(name) {
          return new Event(name, {
            bubbles: true
          });
        };

        try {
          new Event('test');
        } catch (e) {
          // IE does not support `new Event()`
          createEvent = function createEvent(name) {
            var evt = document.createEvent('Event');
            evt.initEvent(name, true, false);
            return evt;
          };
        }

        function assign(ta) {
          if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
          var heightOffset = null;
          var clientWidth = ta.clientWidth;
          var cachedHeight = null;

          function init() {
            var style = window.getComputedStyle(ta, null);

            if (style.resize === 'vertical') {
              ta.style.resize = 'none';
            } else if (style.resize === 'both') {
              ta.style.resize = 'horizontal';
            }

            if (style.boxSizing === 'content-box') {
              heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
            } else {
              heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
            } // Fix when a textarea is not on document body and heightOffset is Not a Number


            if (isNaN(heightOffset)) {
              heightOffset = 0;
            }

            update();
          }

          function changeOverflow(value) {
            {
              // Chrome/Safari-specific fix:
              // When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
              // made available by removing the scrollbar. The following forces the necessary text reflow.
              var width = ta.style.width;
              ta.style.width = '0px'; // Force reflow:

              /* jshint ignore:start */

              ta.offsetWidth;
              /* jshint ignore:end */

              ta.style.width = width;
            }
            ta.style.overflowY = value;
          }

          function getParentOverflows(el) {
            var arr = [];

            while (el && el.parentNode && el.parentNode instanceof Element) {
              if (el.parentNode.scrollTop) {
                arr.push({
                  node: el.parentNode,
                  scrollTop: el.parentNode.scrollTop
                });
              }

              el = el.parentNode;
            }

            return arr;
          }

          function resize() {
            var originalHeight = ta.style.height;
            var overflows = getParentOverflows(ta);
            var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)

            ta.style.height = 'auto';
            var endHeight = ta.scrollHeight + heightOffset;

            if (ta.scrollHeight === 0) {
              // If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
              ta.style.height = originalHeight;
              return;
            }

            ta.style.height = endHeight + 'px'; // used to check if an update is actually necessary on window.resize

            clientWidth = ta.clientWidth; // prevents scroll-position jumping

            overflows.forEach(function (el) {
              el.node.scrollTop = el.scrollTop;
            });

            if (docTop) {
              document.documentElement.scrollTop = docTop;
            }
          }

          function update() {
            resize();
            var styleHeight = Math.round(parseFloat(ta.style.height));
            var computed = window.getComputedStyle(ta, null); // Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box

            var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight; // The actual height not matching the style height (set via the resize method) indicates that
            // the max-height has been exceeded, in which case the overflow should be allowed.

            if (actualHeight !== styleHeight) {
              if (computed.overflowY === 'hidden') {
                changeOverflow('scroll');
                resize();
                actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
              }
            } else {
              // Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
              if (computed.overflowY !== 'hidden') {
                changeOverflow('hidden');
                resize();
                actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
              }
            }

            if (cachedHeight !== actualHeight) {
              cachedHeight = actualHeight;
              var evt = createEvent('autosize:resized');

              try {
                ta.dispatchEvent(evt);
              } catch (err) {// Firefox will throw an error on dispatchEvent for a detached element
                // https://bugzilla.mozilla.org/show_bug.cgi?id=889376
              }
            }
          }

          var pageResize = function pageResize() {
            if (ta.clientWidth !== clientWidth) {
              update();
            }
          };

          var destroy = function (style) {
            window.removeEventListener('resize', pageResize, false);
            ta.removeEventListener('input', update, false);
            ta.removeEventListener('keyup', update, false);
            ta.removeEventListener('autosize:destroy', destroy, false);
            ta.removeEventListener('autosize:update', update, false);
            Object.keys(style).forEach(function (key) {
              ta.style[key] = style[key];
            });
            map['delete'](ta);
          }.bind(ta, {
            height: ta.style.height,
            resize: ta.style.resize,
            overflowY: ta.style.overflowY,
            overflowX: ta.style.overflowX,
            wordWrap: ta.style.wordWrap
          });

          ta.addEventListener('autosize:destroy', destroy, false); // IE9 does not fire onpropertychange or oninput for deletions,
          // so binding to onkeyup to catch most of those events.
          // There is no way that I know of to detect something like 'cut' in IE9.

          if ('onpropertychange' in ta && 'oninput' in ta) {
            ta.addEventListener('keyup', update, false);
          }

          window.addEventListener('resize', pageResize, false);
          ta.addEventListener('input', update, false);
          ta.addEventListener('autosize:update', update, false);
          ta.style.overflowX = 'hidden';
          ta.style.wordWrap = 'break-word';
          map.set(ta, {
            destroy: destroy,
            update: update
          });
          init();
        }

        function destroy(ta) {
          var methods = map.get(ta);

          if (methods) {
            methods.destroy();
          }
        }

        function update(ta) {
          var methods = map.get(ta);

          if (methods) {
            methods.update();
          }
        }

        var autosize = null; // Do nothing in Node.js environment and IE8 (or lower)

        if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
          autosize = function autosize(el) {
            return el;
          };

          autosize.destroy = function (el) {
            return el;
          };

          autosize.update = function (el) {
            return el;
          };
        } else {
          autosize = function autosize(el, options) {
            if (el) {
              Array.prototype.forEach.call(el.length ? el : [el], function (x) {
                return assign(x, options);
              });
            }

            return el;
          };

          autosize.destroy = function (el) {
            if (el) {
              Array.prototype.forEach.call(el.length ? el : [el], destroy);
            }

            return el;
          };

          autosize.update = function (el) {
            if (el) {
              Array.prototype.forEach.call(el.length ? el : [el], update);
            }

            return el;
          };
        }

        module.exports = autosize;
      });
      /***/

    },
    /* 260 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      exports.default = function (language) {
        return new _polyglot2.default({
          phrases: i18nMap[language] || i18nMap.en,
          locale: language
        });
      };

      var _polyglot = __webpack_require__(261);

      var _polyglot2 = _interopRequireDefault(_polyglot);

      var _zhCN = __webpack_require__(262);

      var _zhCN2 = _interopRequireDefault(_zhCN);

      var _zhTW = __webpack_require__(263);

      var _zhTW2 = _interopRequireDefault(_zhTW);

      var _en = __webpack_require__(264);

      var _en2 = _interopRequireDefault(_en);

      var _esES = __webpack_require__(265);

      var _esES2 = _interopRequireDefault(_esES);

      var _fr = __webpack_require__(266);

      var _fr2 = _interopRequireDefault(_fr);

      var _ru = __webpack_require__(267);

      var _ru2 = _interopRequireDefault(_ru);

      var _de = __webpack_require__(268);

      var _de2 = _interopRequireDefault(_de);

      var _pl = __webpack_require__(269);

      var _pl2 = _interopRequireDefault(_pl);

      var _ko = __webpack_require__(270);

      var _ko2 = _interopRequireDefault(_ko);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var i18nMap = {
        'zh': _zhCN2.default,
        'zh-CN': _zhCN2.default,
        'zh-TW': _zhTW2.default,
        'en': _en2.default,
        'es-ES': _esES2.default,
        'fr': _fr2.default,
        'ru': _ru2.default,
        'de': _de2.default,
        'pl': _pl2.default,
        'ko': _ko2.default
      };
      /***/
    },
    /* 261 */

    /***/
    function (module, exports, __webpack_require__) {
      var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__; //     (c) 2012 Airbnb, Inc.
      //
      //     polyglot.js may be freely distributed under the terms of the BSD
      //     license. For all licensing information, details, and documention:
      //     http://airbnb.github.com/polyglot.js
      //
      //
      // Polyglot.js is an I18n helper library written in JavaScript, made to
      // work both in the browser and in Node. It provides a simple solution for
      // interpolation and pluralization, based off of Airbnb's
      // experience adding I18n functionality to its Backbone.js and Node apps.
      //
      // Polylglot is agnostic to your translation backend. It doesn't perform any
      // translation; it simply gives you a way to manage translated phrases from
      // your client- or server-side JavaScript application.
      //


      (function (root, factory) {
        if (true) {
          !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
            return factory(root);
          }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof exports === 'object') {
          module.exports = factory(root);
        } else {
          root.Polyglot = factory(root);
        }
      })(this, function (root) {
        'use strict'; // ### Polyglot class constructor

        function Polyglot(options) {
          options = options || {};
          this.phrases = {};
          this.extend(options.phrases || {});
          this.currentLocale = options.locale || 'en';
          this.allowMissing = !!options.allowMissing;
          this.warn = options.warn || warn;
        } // ### Version


        Polyglot.VERSION = '0.4.3'; // ### polyglot.locale([locale])
        //
        // Get or set locale. Internally, Polyglot only uses locale for pluralization.

        Polyglot.prototype.locale = function (newLocale) {
          if (newLocale) this.currentLocale = newLocale;
          return this.currentLocale;
        }; // ### polyglot.extend(phrases)
        //
        // Use `extend` to tell Polyglot how to translate a given key.
        //
        //     polyglot.extend({
        //       "hello": "Hello",
        //       "hello_name": "Hello, %{name}"
        //     });
        //
        // The key can be any string.  Feel free to call `extend` multiple times;
        // it will override any phrases with the same key, but leave existing phrases
        // untouched.
        //
        // It is also possible to pass nested phrase objects, which get flattened
        // into an object with the nested keys concatenated using dot notation.
        //
        //     polyglot.extend({
        //       "nav": {
        //         "hello": "Hello",
        //         "hello_name": "Hello, %{name}",
        //         "sidebar": {
        //           "welcome": "Welcome"
        //         }
        //       }
        //     });
        //
        //     console.log(polyglot.phrases);
        //     // {
        //     //   'nav.hello': 'Hello',
        //     //   'nav.hello_name': 'Hello, %{name}',
        //     //   'nav.sidebar.welcome': 'Welcome'
        //     // }
        //
        // `extend` accepts an optional second argument, `prefix`, which can be used
        // to prefix every key in the phrases object with some string, using dot
        // notation.
        //
        //     polyglot.extend({
        //       "hello": "Hello",
        //       "hello_name": "Hello, %{name}"
        //     }, "nav");
        //
        //     console.log(polyglot.phrases);
        //     // {
        //     //   'nav.hello': 'Hello',
        //     //   'nav.hello_name': 'Hello, %{name}'
        //     // }
        //
        // This feature is used internally to support nested phrase objects.


        Polyglot.prototype.extend = function (morePhrases, prefix) {
          var phrase;

          for (var key in morePhrases) {
            if (morePhrases.hasOwnProperty(key)) {
              phrase = morePhrases[key];
              if (prefix) key = prefix + '.' + key;

              if (typeof phrase === 'object') {
                this.extend(phrase, key);
              } else {
                this.phrases[key] = phrase;
              }
            }
          }
        }; // ### polyglot.clear()
        //
        // Clears all phrases. Useful for special cases, such as freeing
        // up memory if you have lots of phrases but no longer need to
        // perform any translation. Also used internally by `replace`.


        Polyglot.prototype.clear = function () {
          this.phrases = {};
        }; // ### polyglot.replace(phrases)
        //
        // Completely replace the existing phrases with a new set of phrases.
        // Normally, just use `extend` to add more phrases, but under certain
        // circumstances, you may want to make sure no old phrases are lying around.


        Polyglot.prototype.replace = function (newPhrases) {
          this.clear();
          this.extend(newPhrases);
        }; // ### polyglot.t(key, options)
        //
        // The most-used method. Provide a key, and `t` will return the
        // phrase.
        //
        //     polyglot.t("hello");
        //     => "Hello"
        //
        // The phrase value is provided first by a call to `polyglot.extend()` or
        // `polyglot.replace()`.
        //
        // Pass in an object as the second argument to perform interpolation.
        //
        //     polyglot.t("hello_name", {name: "Spike"});
        //     => "Hello, Spike"
        //
        // If you like, you can provide a default value in case the phrase is missing.
        // Use the special option key "_" to specify a default.
        //
        //     polyglot.t("i_like_to_write_in_language", {
        //       _: "I like to write in %{language}.",
        //       language: "JavaScript"
        //     });
        //     => "I like to write in JavaScript."
        //


        Polyglot.prototype.t = function (key, options) {
          var phrase, result;
          options = options == null ? {} : options; // allow number as a pluralization shortcut

          if (typeof options === 'number') {
            options = {
              smart_count: options
            };
          }

          if (typeof this.phrases[key] === 'string') {
            phrase = this.phrases[key];
          } else if (typeof options._ === 'string') {
            phrase = options._;
          } else if (this.allowMissing) {
            phrase = key;
          } else {
            this.warn('Missing translation for key: "' + key + '"');
            result = key;
          }

          if (typeof phrase === 'string') {
            options = clone(options);
            result = choosePluralForm(phrase, this.currentLocale, options.smart_count);
            result = interpolate(result, options);
          }

          return result;
        }; // ### polyglot.has(key)
        //
        // Check if polyglot has a translation for given key


        Polyglot.prototype.has = function (key) {
          return key in this.phrases;
        }; // #### Pluralization methods
        // The string that separates the different phrase possibilities.


        var delimeter = '||||'; // Mapping from pluralization group plural logic.

        var pluralTypes = {
          chinese: function chinese(n) {
            return 0;
          },
          german: function german(n) {
            return n !== 1 ? 1 : 0;
          },
          french: function french(n) {
            return n > 1 ? 1 : 0;
          },
          russian: function russian(n) {
            return n % 10 === 1 && n % 100 !== 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
          },
          czech: function czech(n) {
            return n === 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2;
          },
          polish: function polish(n) {
            return n === 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
          },
          icelandic: function icelandic(n) {
            return n % 10 !== 1 || n % 100 === 11 ? 1 : 0;
          }
        }; // Mapping from pluralization group to individual locales.

        var pluralTypeToLanguages = {
          chinese: ['fa', 'id', 'ja', 'ko', 'lo', 'ms', 'th', 'tr', 'zh'],
          german: ['da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hu', 'it', 'nl', 'no', 'pt', 'sv'],
          french: ['fr', 'tl', 'pt-br'],
          russian: ['hr', 'ru'],
          czech: ['cs'],
          polish: ['pl'],
          icelandic: ['is']
        };

        function langToTypeMap(mapping) {
          var type,
              langs,
              l,
              ret = {};

          for (type in mapping) {
            if (mapping.hasOwnProperty(type)) {
              langs = mapping[type];

              for (l in langs) {
                ret[langs[l]] = type;
              }
            }
          }

          return ret;
        } // Trim a string.


        function trim(str) {
          var trimRe = /^\s+|\s+$/g;
          return str.replace(trimRe, '');
        } // Based on a phrase text that contains `n` plural forms separated
        // by `delimeter`, a `locale`, and a `count`, choose the correct
        // plural form, or none if `count` is `null`.


        function choosePluralForm(text, locale, count) {
          var ret, texts, chosenText;

          if (count != null && text) {
            texts = text.split(delimeter);
            chosenText = texts[pluralTypeIndex(locale, count)] || texts[0];
            ret = trim(chosenText);
          } else {
            ret = text;
          }

          return ret;
        }

        function pluralTypeName(locale) {
          var langToPluralType = langToTypeMap(pluralTypeToLanguages);
          return langToPluralType[locale] || langToPluralType.en;
        }

        function pluralTypeIndex(locale, count) {
          return pluralTypes[pluralTypeName(locale)](count);
        } // ### interpolate
        //
        // Does the dirty work. Creates a `RegExp` object for each
        // interpolation placeholder.


        function interpolate(phrase, options) {
          for (var arg in options) {
            if (arg !== '_' && options.hasOwnProperty(arg)) {
              // We create a new `RegExp` each time instead of using a more-efficient
              // string replace so that the same argument can be replaced multiple times
              // in the same phrase.
              phrase = phrase.replace(new RegExp('%\\{' + arg + '\\}', 'g'), options[arg]);
            }
          }

          return phrase;
        } // ### warn
        //
        // Provides a warning in the console if a phrase key is missing.


        function warn(message) {
          root.console && root.console.warn && root.console.warn('WARNING: ' + message);
        } // ### clone
        //
        // Clone an object.


        function clone(source) {
          var ret = {};

          for (var prop in source) {
            ret[prop] = source[prop];
          }

          return ret;
        }

        return Polyglot;
      });
      /***/

    },
    /* 262 */

    /***/
    function (module, exports) {
      module.exports = {
        "init": "Gitalk 加载中 ...",
        "no-found-related": "未找到相关的 %{link} 进行评论",
        "please-contact": "请联系 %{user} 初始化创建",
        "init-issue": "初始化 Issue",
        "leave-a-comment": "说点什么",
        "preview": "预览",
        "edit": "编辑",
        "comment": "评论",
        "support-markdown": "支持 Markdown 语法",
        "login-with-github": "使用 GitHub 登录",
        "first-comment-person": "来做第一个留言的人吧！",
        "commented": "发表于",
        "load-more": "加载更多",
        "counts": "%{counts} 条评论",
        "sort-asc": "从旧到新排序",
        "sort-desc": "从新到旧排序",
        "logout": "注销",
        "anonymous": "未登录用户"
      };
      /***/
    },
    /* 263 */

    /***/
    function (module, exports) {
      module.exports = {
        "init": "Gitalk 載入中…",
        "no-found-related": "未找到相關的 %{link}",
        "please-contact": "請聯絡 %{user} 初始化評論",
        "init-issue": "初始化 Issue",
        "leave-a-comment": "寫點什麼",
        "preview": "預覽",
        "edit": "編輯",
        "comment": "評論",
        "support-markdown": "支援 Markdown 語法",
        "login-with-github": "使用 GitHub 登入",
        "first-comment-person": "成為首個留言的人吧！",
        "commented": "評論於",
        "load-more": "載入更多",
        "counts": "%{counts} 筆評論",
        "sort-asc": "從舊至新排序",
        "sort-desc": "從新至舊排序",
        "logout": "登出",
        "anonymous": "訪客"
      };
      /***/
    },
    /* 264 */

    /***/
    function (module, exports) {
      module.exports = {
        "init": "Gitalking ...",
        "no-found-related": "Related %{link} not found",
        "please-contact": "Please contact %{user} to initialize the comment",
        "init-issue": "Init Issue",
        "leave-a-comment": "Leave a comment",
        "preview": "Preview",
        "edit": "Edit",
        "comment": "Comment",
        "support-markdown": "Markdown is supported",
        "login-with-github": "Login with GitHub",
        "first-comment-person": "Be the first person to leave a comment!",
        "commented": "commented",
        "load-more": "Load more",
        "counts": "%{counts} comment |||| %{counts} comments",
        "sort-asc": "Sort by Oldest",
        "sort-desc": "Sort by Latest",
        "logout": "Logout",
        "anonymous": "Anonymous"
      };
      /***/
    },
    /* 265 */

    /***/
    function (module, exports) {
      module.exports = {
        "init": "Gitalking ...",
        "no-found-related": "Link %{link} no encontrado",
        "please-contact": "Por favor contacta con %{user} para inicializar el comentario",
        "init-issue": "Iniciar Issue",
        "leave-a-comment": "Deja un comentario",
        "preview": "Avance",
        "edit": "Editar",
        "comment": "Comentario",
        "support-markdown": "Markdown es soportado",
        "login-with-github": "Entrar con GitHub",
        "first-comment-person": "Sé el primero en dejar un comentario!",
        "commented": "comentó",
        "load-more": "Cargar más",
        "counts": "%{counts} comentario |||| %{counts} comentarios",
        "sort-asc": "Ordenar por Antiguos",
        "sort-desc": "Ordenar por Recientes",
        "logout": "Salir",
        "anonymous": "Anónimo"
      };
      /***/
    },
    /* 266 */

    /***/
    function (module, exports) {
      module.exports = {
        "init": "Gitalking ...",
        "no-found-related": "Lien %{link} non trouvé",
        "please-contact": "S’il vous plaît contactez %{user} pour initialiser les commentaires",
        "init-issue": "Initialisation des issues",
        "leave-a-comment": "Laisser un commentaire",
        "preview": "Aperçu",
        "edit": "Modifier",
        "comment": "Commentaire",
        "support-markdown": "Markdown est supporté",
        "login-with-github": "Se connecter avec GitHub",
        "first-comment-person": "Être le premier à laisser un commentaire !",
        "commented": "commenter",
        "load-more": "Charger plus",
        "counts": "%{counts} commentaire |||| %{counts} commentaires",
        "sort-asc": "Trier par plus ancien",
        "sort-desc": "Trier par plus récent",
        "logout": "Déconnexion",
        "anonymous": "Anonyme"
      };
      /***/
    },
    /* 267 */

    /***/
    function (module, exports) {
      module.exports = {
        "init": "Gitalking ...",
        "no-found-related": "Связанные %{link} не найдены",
        "please-contact": "Пожалуйста, свяжитесь с %{user} чтобы инициализировать комментарий",
        "init-issue": "Выпуск инициализации",
        "leave-a-comment": "Оставить комментарий",
        "preview": "Предварительный просмотр",
        "edit": "Pедактировать",
        "comment": "Комментарий",
        "support-markdown": "Поддерживается Markdown",
        "login-with-github": "Вход через GitHub",
        "first-comment-person": "Будьте первым, кто оставил комментарий",
        "commented": "прокомментированный",
        "load-more": "Загрузить ещё",
        "counts": "%{counts} комментарий |||| %{counts} комментариев",
        "sort-asc": "Сортировать по старым",
        "sort-desc": "Сортировать по последним",
        "logout": "Выход",
        "anonymous": "Анонимный"
      };
      /***/
    },
    /* 268 */

    /***/
    function (module, exports) {
      module.exports = {
        "init": "Gitalking ...",
        "no-found-related": "Zugehöriger %{link} nicht gefunden",
        "please-contact": "Bitte kontaktiere %{user} um den Kommentar zu initialisieren",
        "init-issue": "Initialisiere Issue",
        "leave-a-comment": "Hinterlasse einen Kommentar",
        "preview": "Vorschau",
        "edit": "Editieren",
        "comment": "Kommentieren",
        "support-markdown": "Markdown wird unterstützt",
        "login-with-github": "Mit GitHub-Account anmelden",
        "first-comment-person": "Sei die erste Person, welche einen Kommentar hinterlässt!",
        "commented": "kommentierte",
        "load-more": "Zeige mehr",
        "counts": "%{counts} Kommentar |||| %{counts} Kommentare",
        "sort-asc": "Älteste zuerst",
        "sort-desc": "Neuste zuerst",
        "logout": "Abmelden",
        "anonymous": "Anonym"
      };
      /***/
    },
    /* 269 */

    /***/
    function (module, exports) {
      module.exports = {
        "init": "Gitalking ...",
        "no-found-related": "Nie znaleziono powiązanego zgłoszenia: %{link}",
        "please-contact": "Skontaktuj się z %{user}, aby umożliwić komentowanie",
        "init-issue": "Utwórz zgłoszenie (GitHub Issue)",
        "leave-a-comment": "Skomentuj",
        "preview": "Podgląd",
        "edit": "Edytuj",
        "comment": "Wyślij",
        "support-markdown": "Możesz użyć składni Markdown",
        "login-with-github": "Zaloguj się poprzez GitHub",
        "first-comment-person": "Skomentuj jako pierwszy!",
        "commented": "skomentowany",
        "load-more": "Załaduj więcej",
        "counts": "%{counts} komentarz |||| %{counts} komentarze |||| %{counts} komentarzy",
        "sort-asc": "Sortuj od najstarszych",
        "sort-desc": "Sortuj od najnowszych",
        "logout": "Wyloguj",
        "anonymous": "Anonimowy"
      };
      /***/
    },
    /* 270 */

    /***/
    function (module, exports) {
      module.exports = {
        "init": "초기화 중 ...",
        "no-found-related": "관련 링크를 찾을 수 없습니다: %{link} ",
        "please-contact": "초기화를 위해 %{user} 에게 연락해 주세요",
        "init-issue": "이슈 초기화",
        "leave-a-comment": "댓글을 남겨보세요",
        "preview": "미리보기",
        "edit": "수정하기",
        "comment": "댓글 달기",
        "support-markdown": "마크다운(Markdown) 문법 지원",
        "login-with-github": "GitHub로 로그인하기",
        "first-comment-person": "첫 번째로 댓글을 남겨보세요!",
        "commented": "님이 작성함",
        "load-more": "더 보기",
        "counts": "댓글 %{counts} 개",
        "sort-asc": "오래된 댓글 먼저",
        "sort-desc": "최신 댓글 먼저",
        "logout": "로그아웃",
        "anonymous": "익명"
      };
      /***/
    },
    /* 271 */

    /***/
    function (module, exports) {// removed by extract-text-webpack-plugin

      /***/
    },
    /* 272 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(273),
        __esModule: true
      };
      /***/
    },
    /* 273 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(274);

      module.exports = __webpack_require__(7).Object.keys;
      /***/
    },
    /* 274 */

    /***/
    function (module, exports, __webpack_require__) {
      // 19.1.2.14 Object.keys(O)
      var toObject = __webpack_require__(33);

      var $keys = __webpack_require__(42);

      __webpack_require__(115)('keys', function () {
        return function keys(it) {
          return $keys(toObject(it));
        };
      });
      /***/

    },
    /* 275 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _isIterable2 = __webpack_require__(276);

      var _isIterable3 = _interopRequireDefault(_isIterable2);

      var _getIterator2 = __webpack_require__(279);

      var _getIterator3 = _interopRequireDefault(_getIterator2);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function () {
        function sliceIterator(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"]) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        return function (arr, i) {
          if (Array.isArray(arr)) {
            return arr;
          } else if ((0, _isIterable3.default)(Object(arr))) {
            return sliceIterator(arr, i);
          } else {
            throw new TypeError("Invalid attempt to destructure non-iterable instance");
          }
        };
      }();
      /***/

    },
    /* 276 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(277),
        __esModule: true
      };
      /***/
    },
    /* 277 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(54);

      __webpack_require__(40);

      module.exports = __webpack_require__(278);
      /***/
    },
    /* 278 */

    /***/
    function (module, exports, __webpack_require__) {
      var classof = __webpack_require__(76);

      var ITERATOR = __webpack_require__(9)('iterator');

      var Iterators = __webpack_require__(31);

      module.exports = __webpack_require__(7).isIterable = function (it) {
        var O = Object(it);
        return O[ITERATOR] !== undefined || '@@iterator' in O // eslint-disable-next-line no-prototype-builtins
        || Iterators.hasOwnProperty(classof(O));
      };
      /***/

    },
    /* 279 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(280),
        __esModule: true
      };
      /***/
    },
    /* 280 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(54);

      __webpack_require__(40);

      module.exports = __webpack_require__(281);
      /***/
    },
    /* 281 */

    /***/
    function (module, exports, __webpack_require__) {
      var anObject = __webpack_require__(14);

      var get = __webpack_require__(77);

      module.exports = __webpack_require__(7).getIterator = function (it) {
        var iterFn = get(it);
        if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
        return anObject(iterFn.call(it));
      };
      /***/

    },
    /* 282 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = __webpack_require__(283);
      /***/
    },
    /* 283 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);

      var bind = __webpack_require__(122);

      var Axios = __webpack_require__(284);

      var mergeConfig = __webpack_require__(128);

      var defaults = __webpack_require__(125);
      /**
       * Create an instance of Axios
       *
       * @param {Object} defaultConfig The default config for the instance
       * @return {Axios} A new instance of Axios
       */


      function createInstance(defaultConfig) {
        var context = new Axios(defaultConfig);
        var instance = bind(Axios.prototype.request, context); // Copy axios.prototype to instance

        utils.extend(instance, Axios.prototype, context); // Copy context to instance

        utils.extend(instance, context);
        return instance;
      } // Create the default instance to be exported


      var axios = createInstance(defaults); // Expose Axios class to allow class inheritance

      axios.Axios = Axios; // Factory for creating new instances

      axios.create = function create(instanceConfig) {
        return createInstance(mergeConfig(axios.defaults, instanceConfig));
      }; // Expose Cancel & CancelToken


      axios.Cancel = __webpack_require__(129);
      axios.CancelToken = __webpack_require__(297);
      axios.isCancel = __webpack_require__(124); // Expose all/spread

      axios.all = function all(promises) {
        return Promise.all(promises);
      };

      axios.spread = __webpack_require__(298);
      module.exports = axios; // Allow use of default import syntax in TypeScript

      module.exports.default = axios;
      /***/
    },
    /* 284 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);

      var buildURL = __webpack_require__(123);

      var InterceptorManager = __webpack_require__(285);

      var dispatchRequest = __webpack_require__(286);

      var mergeConfig = __webpack_require__(128);
      /**
       * Create a new instance of Axios
       *
       * @param {Object} instanceConfig The default config for the instance
       */


      function Axios(instanceConfig) {
        this.defaults = instanceConfig;
        this.interceptors = {
          request: new InterceptorManager(),
          response: new InterceptorManager()
        };
      }
      /**
       * Dispatch a request
       *
       * @param {Object} config The config specific for this request (merged with this.defaults)
       */


      Axios.prototype.request = function request(config) {
        /*eslint no-param-reassign:0*/
        // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof config === 'string') {
          config = arguments[1] || {};
          config.url = arguments[0];
        } else {
          config = config || {};
        }

        config = mergeConfig(this.defaults, config); // Set config.method

        if (config.method) {
          config.method = config.method.toLowerCase();
        } else if (this.defaults.method) {
          config.method = this.defaults.method.toLowerCase();
        } else {
          config.method = 'get';
        } // Hook up interceptors middleware


        var chain = [dispatchRequest, undefined];
        var promise = Promise.resolve(config);
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
          chain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
          chain.push(interceptor.fulfilled, interceptor.rejected);
        });

        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }

        return promise;
      };

      Axios.prototype.getUri = function getUri(config) {
        config = mergeConfig(this.defaults, config);
        return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
      }; // Provide aliases for supported request methods


      utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
        /*eslint func-names:0*/
        Axios.prototype[method] = function (url, config) {
          return this.request(utils.merge(config || {}, {
            method: method,
            url: url
          }));
        };
      });
      utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
        /*eslint func-names:0*/
        Axios.prototype[method] = function (url, data, config) {
          return this.request(utils.merge(config || {}, {
            method: method,
            url: url,
            data: data
          }));
        };
      });
      module.exports = Axios;
      /***/
    },
    /* 285 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);

      function InterceptorManager() {
        this.handlers = [];
      }
      /**
       * Add a new interceptor to the stack
       *
       * @param {Function} fulfilled The function to handle `then` for a `Promise`
       * @param {Function} rejected The function to handle `reject` for a `Promise`
       *
       * @return {Number} An ID used to remove interceptor later
       */


      InterceptorManager.prototype.use = function use(fulfilled, rejected) {
        this.handlers.push({
          fulfilled: fulfilled,
          rejected: rejected
        });
        return this.handlers.length - 1;
      };
      /**
       * Remove an interceptor from the stack
       *
       * @param {Number} id The ID that was returned by `use`
       */


      InterceptorManager.prototype.eject = function eject(id) {
        if (this.handlers[id]) {
          this.handlers[id] = null;
        }
      };
      /**
       * Iterate over all the registered interceptors
       *
       * This method is particularly useful for skipping over any
       * interceptors that may have become `null` calling `eject`.
       *
       * @param {Function} fn The function to call for each interceptor
       */


      InterceptorManager.prototype.forEach = function forEach(fn) {
        utils.forEach(this.handlers, function forEachHandler(h) {
          if (h !== null) {
            fn(h);
          }
        });
      };

      module.exports = InterceptorManager;
      /***/
    },
    /* 286 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);

      var transformData = __webpack_require__(287);

      var isCancel = __webpack_require__(124);

      var defaults = __webpack_require__(125);
      /**
       * Throws a `Cancel` if cancellation has been requested.
       */


      function throwIfCancellationRequested(config) {
        if (config.cancelToken) {
          config.cancelToken.throwIfRequested();
        }
      }
      /**
       * Dispatch a request to the server using the configured adapter.
       *
       * @param {object} config The config that is to be used for the request
       * @returns {Promise} The Promise to be fulfilled
       */


      module.exports = function dispatchRequest(config) {
        throwIfCancellationRequested(config); // Ensure headers exist

        config.headers = config.headers || {}; // Transform request data

        config.data = transformData(config.data, config.headers, config.transformRequest); // Flatten headers

        config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
        utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
          delete config.headers[method];
        });
        var adapter = config.adapter || defaults.adapter;
        return adapter(config).then(function onAdapterResolution(response) {
          throwIfCancellationRequested(config); // Transform response data

          response.data = transformData(response.data, response.headers, config.transformResponse);
          return response;
        }, function onAdapterRejection(reason) {
          if (!isCancel(reason)) {
            throwIfCancellationRequested(config); // Transform response data

            if (reason && reason.response) {
              reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
            }
          }

          return Promise.reject(reason);
        });
      };
      /***/

    },
    /* 287 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);
      /**
       * Transform the data for a request or a response
       *
       * @param {Object|String} data The data to be transformed
       * @param {Array} headers The headers for the request or response
       * @param {Array|Function} fns A single function or Array of functions
       * @returns {*} The resulting transformed data
       */


      module.exports = function transformData(data, headers, fns) {
        /*eslint no-param-reassign:0*/
        utils.forEach(fns, function transform(fn) {
          data = fn(data, headers);
        });
        return data;
      };
      /***/

    },
    /* 288 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);

      module.exports = function normalizeHeaderName(headers, normalizedName) {
        utils.forEach(headers, function processHeader(value, name) {
          if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
          }
        });
      };
      /***/

    },
    /* 289 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var createError = __webpack_require__(127);
      /**
       * Resolve or reject a Promise based on response status.
       *
       * @param {Function} resolve A function that resolves the promise.
       * @param {Function} reject A function that rejects the promise.
       * @param {object} response The response.
       */


      module.exports = function settle(resolve, reject, response) {
        var validateStatus = response.config.validateStatus;

        if (!validateStatus || validateStatus(response.status)) {
          resolve(response);
        } else {
          reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
        }
      };
      /***/

    },
    /* 290 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Update an Error with the specified config, error code, and response.
       *
       * @param {Error} error The error to update.
       * @param {Object} config The config.
       * @param {string} [code] The error code (for example, 'ECONNABORTED').
       * @param {Object} [request] The request.
       * @param {Object} [response] The response.
       * @returns {Error} The error.
       */

      module.exports = function enhanceError(error, config, code, request, response) {
        error.config = config;

        if (code) {
          error.code = code;
        }

        error.request = request;
        error.response = response;
        error.isAxiosError = true;

        error.toJSON = function () {
          return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
          };
        };

        return error;
      };
      /***/

    },
    /* 291 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var isAbsoluteURL = __webpack_require__(292);

      var combineURLs = __webpack_require__(293);
      /**
       * Creates a new URL by combining the baseURL with the requestedURL,
       * only when the requestedURL is not already an absolute URL.
       * If the requestURL is absolute, this function returns the requestedURL untouched.
       *
       * @param {string} baseURL The base URL
       * @param {string} requestedURL Absolute or relative URL to combine
       * @returns {string} The combined full path
       */


      module.exports = function buildFullPath(baseURL, requestedURL) {
        if (baseURL && !isAbsoluteURL(requestedURL)) {
          return combineURLs(baseURL, requestedURL);
        }

        return requestedURL;
      };
      /***/

    },
    /* 292 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Determines whether the specified URL is absolute
       *
       * @param {string} url The URL to test
       * @returns {boolean} True if the specified URL is absolute, otherwise false
       */

      module.exports = function isAbsoluteURL(url) {
        // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
        // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
        // by any combination of letters, digits, plus, period, or hyphen.
        return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
      };
      /***/

    },
    /* 293 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Creates a new URL by combining the specified URLs
       *
       * @param {string} baseURL The base URL
       * @param {string} relativeURL The relative URL
       * @returns {string} The combined URL
       */

      module.exports = function combineURLs(baseURL, relativeURL) {
        return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
      };
      /***/

    },
    /* 294 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10); // Headers whose duplicates are ignored by node
      // c.f. https://nodejs.org/api/http.html#http_message_headers


      var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];
      /**
       * Parse headers into an object
       *
       * ```
       * Date: Wed, 27 Aug 2014 08:58:49 GMT
       * Content-Type: application/json
       * Connection: keep-alive
       * Transfer-Encoding: chunked
       * ```
       *
       * @param {String} headers Headers needing to be parsed
       * @returns {Object} Headers parsed into an object
       */

      module.exports = function parseHeaders(headers) {
        var parsed = {};
        var key;
        var val;
        var i;

        if (!headers) {
          return parsed;
        }

        utils.forEach(headers.split('\n'), function parser(line) {
          i = line.indexOf(':');
          key = utils.trim(line.substr(0, i)).toLowerCase();
          val = utils.trim(line.substr(i + 1));

          if (key) {
            if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
              return;
            }

            if (key === 'set-cookie') {
              parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
            } else {
              parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
            }
          }
        });
        return parsed;
      };
      /***/

    },
    /* 295 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);

      module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement('a');
        var originURL;
        /**
        * Parse a URL to discover it's components
        *
        * @param {String} url The URL to be parsed
        * @returns {Object}
        */

        function resolveURL(url) {
          var href = url;

          if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
          }

          urlParsingNode.setAttribute('href', href); // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils

          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
          };
        }

        originURL = resolveURL(window.location.href);
        /**
        * Determine if a URL shares the same origin as the current location
        *
        * @param {String} requestURL The URL to test
        * @returns {boolean} True if URL shares the same origin, otherwise false
        */

        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }() : // Non standard browser envs (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }();
      /***/
    },
    /* 296 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var utils = __webpack_require__(10);

      module.exports = utils.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
      function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));

            if (utils.isNumber(expires)) {
              cookie.push('expires=' + new Date(expires).toGMTString());
            }

            if (utils.isString(path)) {
              cookie.push('path=' + path);
            }

            if (utils.isString(domain)) {
              cookie.push('domain=' + domain);
            }

            if (secure === true) {
              cookie.push('secure');
            }

            document.cookie = cookie.join('; ');
          },
          read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
          },
          remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
          }
        };
      }() : // Non standard browser env (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return {
          write: function write() {},
          read: function read() {
            return null;
          },
          remove: function remove() {}
        };
      }();
      /***/
    },
    /* 297 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var Cancel = __webpack_require__(129);
      /**
       * A `CancelToken` is an object that can be used to request cancellation of an operation.
       *
       * @class
       * @param {Function} executor The executor function.
       */


      function CancelToken(executor) {
        if (typeof executor !== 'function') {
          throw new TypeError('executor must be a function.');
        }

        var resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
          resolvePromise = resolve;
        });
        var token = this;
        executor(function cancel(message) {
          if (token.reason) {
            // Cancellation has already been requested
            return;
          }

          token.reason = new Cancel(message);
          resolvePromise(token.reason);
        });
      }
      /**
       * Throws a `Cancel` if cancellation has been requested.
       */


      CancelToken.prototype.throwIfRequested = function throwIfRequested() {
        if (this.reason) {
          throw this.reason;
        }
      };
      /**
       * Returns an object that contains a new `CancelToken` and a function that, when called,
       * cancels the `CancelToken`.
       */


      CancelToken.source = function source() {
        var cancel;
        var token = new CancelToken(function executor(c) {
          cancel = c;
        });
        return {
          token: token,
          cancel: cancel
        };
      };

      module.exports = CancelToken;
      /***/
    },
    /* 298 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";
      /**
       * Syntactic sugar for invoking a function and expanding an array for arguments.
       *
       * Common use case would be to use `Function.prototype.apply`.
       *
       *  ```js
       *  function f(x, y, z) {}
       *  var args = [1, 2, 3];
       *  f.apply(null, args);
       *  ```
       *
       * With `spread` this example can be re-written.
       *
       *  ```js
       *  spread(function(x, y, z) {})([1, 2, 3]);
       *  ```
       *
       * @param {Function} callback
       * @returns {Function}
       */

      module.exports = function spread(callback) {
        return function wrap(arr) {
          return callback.apply(null, arr);
        };
      };
      /***/

    },
    /* 299 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _react = __webpack_require__(12);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (_ref) {
        var className = _ref.className,
            getRef = _ref.getRef,
            onClick = _ref.onClick,
            onMouseDown = _ref.onMouseDown,
            text = _ref.text,
            isLoading = _ref.isLoading;
        return _react2.default.createElement("button", {
          ref: function ref(el) {
            return getRef && getRef(el);
          },
          className: "gt-btn " + className,
          onClick: onClick,
          onMouseDown: onMouseDown
        }, _react2.default.createElement("span", {
          className: "gt-btn-text"
        }, text), isLoading && _react2.default.createElement("span", {
          className: "gt-btn-loading gt-spinner"
        }));
      };
      /***/

    },
    /* 300 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _react = __webpack_require__(12);

      var _react2 = _interopRequireDefault(_react);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (_ref) {
        var className = _ref.className,
            onClick = _ref.onClick,
            text = _ref.text;
        return _react2.default.createElement("a", {
          className: "gt-action " + className,
          onClick: onClick
        }, _react2.default.createElement("span", {
          className: "gt-action-text"
        }, text));
      };
      /***/

    },
    /* 301 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _getPrototypeOf = __webpack_require__(114);

      var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

      var _classCallCheck2 = __webpack_require__(64);

      var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

      var _createClass2 = __webpack_require__(65);

      var _createClass3 = _interopRequireDefault(_createClass2);

      var _possibleConstructorReturn2 = __webpack_require__(116);

      var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

      var _inherits2 = __webpack_require__(120);

      var _inherits3 = _interopRequireDefault(_inherits2);

      var _react = __webpack_require__(12);

      var _react2 = _interopRequireDefault(_react);

      var _avatar = __webpack_require__(130);

      var _avatar2 = _interopRequireDefault(_avatar);

      var _svg = __webpack_require__(131);

      var _svg2 = _interopRequireDefault(_svg);

      var _dateFns = __webpack_require__(310);

      var _locale = __webpack_require__(439);

      __webpack_require__(855);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      if (typeof window !== 'undefined') {
        window.GT_i18n_LocaleMap = {
          zh: _locale.zhCN,
          'zh-CN': _locale.zhCN,
          'zh-TW': _locale.zhTW,
          'es-ES': _locale.es,
          fr: _locale.fr,
          ru: _locale.ru,
          pl: _locale.pl,
          ko: _locale.ko,
          de: _locale.de
        };
      }

      var Comment = function (_Component) {
        (0, _inherits3.default)(Comment, _Component);

        function Comment() {
          (0, _classCallCheck3.default)(this, Comment);
          return (0, _possibleConstructorReturn3.default)(this, (Comment.__proto__ || (0, _getPrototypeOf2.default)(Comment)).apply(this, arguments));
        }

        (0, _createClass3.default)(Comment, [{
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(_ref) {
            var comment = _ref.comment;
            return comment !== this.props.comment;
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            var comment = this.node;
            var emailResponse = comment.querySelector('.email-hidden-toggle>a');

            if (emailResponse) {
              emailResponse.addEventListener('click', function (e) {
                e.preventDefault();
                comment.querySelector('.email-hidden-reply').classList.toggle('expanded');
              }, true);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this2 = this;

            var _props = this.props,
                comment = _props.comment,
                user = _props.user,
                language = _props.language,
                _props$commentedText = _props.commentedText,
                commentedText = _props$commentedText === undefined ? '' : _props$commentedText,
                _props$admin = _props.admin,
                admin = _props$admin === undefined ? [] : _props$admin,
                replyCallback = _props.replyCallback,
                likeCallback = _props.likeCallback;
            var enableEdit = user && comment.user.login === user.login;
            var isAdmin = ~[].concat(admin).map(function (a) {
              return a.toLowerCase();
            }).indexOf(comment.user.login.toLowerCase());
            var reactions = comment.reactions;
            var reactionTotalCount = '';

            if (reactions && reactions.totalCount) {
              reactionTotalCount = reactions.totalCount;

              if (reactions.totalCount === 100 && reactions.pageInfo && reactions.pageInfo.hasNextPage) {
                reactionTotalCount = '100+';
              }
            }

            return _react2.default.createElement('div', {
              ref: function ref(node) {
                _this2.node = node;
              },
              className: 'gt-comment ' + (isAdmin ? 'gt-comment-admin' : '')
            }, _react2.default.createElement(_avatar2.default, {
              className: 'gt-comment-avatar',
              src: comment.user && comment.user.avatar_url,
              alt: comment.user && comment.user.login
            }), _react2.default.createElement('div', {
              className: 'gt-comment-content'
            }, _react2.default.createElement('div', {
              className: 'gt-comment-header'
            }, _react2.default.createElement('div', {
              className: 'gt-comment-block-' + (user ? '2' : '1')
            }), _react2.default.createElement('a', {
              className: 'gt-comment-username',
              href: comment.user && comment.user.html_url
            }, comment.user && comment.user.login), _react2.default.createElement('span', {
              className: 'gt-comment-text'
            }, commentedText), _react2.default.createElement('span', {
              className: 'gt-comment-date'
            }, (0, _dateFns.formatDistanceToNow)((0, _dateFns.parseISO)(comment.created_at), {
              addSuffix: true,
              locale: window.GT_i18n_LocaleMap[language]
            })), reactions && _react2.default.createElement('a', {
              className: 'gt-comment-like',
              title: 'Like',
              onClick: likeCallback
            }, reactions.viewerHasReacted ? _react2.default.createElement(_svg2.default, {
              className: 'gt-ico-heart',
              name: 'heart_on',
              text: reactionTotalCount
            }) : _react2.default.createElement(_svg2.default, {
              className: 'gt-ico-heart',
              name: 'heart',
              text: reactionTotalCount
            })), enableEdit ? _react2.default.createElement('a', {
              href: comment.html_url,
              className: 'gt-comment-edit',
              title: 'Edit',
              target: '_blank',
              rel: 'noopener noreferrer'
            }, _react2.default.createElement(_svg2.default, {
              className: 'gt-ico-edit',
              name: 'edit'
            })) : _react2.default.createElement('a', {
              className: 'gt-comment-reply',
              title: 'Reply',
              onClick: replyCallback
            }, _react2.default.createElement(_svg2.default, {
              className: 'gt-ico-reply',
              name: 'reply'
            }))), _react2.default.createElement('div', {
              className: 'gt-comment-body markdown-body',
              dangerouslySetInnerHTML: {
                __html: comment.body_html
              }
            })));
          }
        }]);
        return Comment;
      }(_react.Component);

      exports.default = Comment;
      /***/
    },
    /* 302 */

    /***/
    function (module, exports, __webpack_require__) {
      var map = {
        "./arrow_down.svg": 303,
        "./edit.svg": 304,
        "./github.svg": 305,
        "./heart.svg": 306,
        "./heart_on.svg": 307,
        "./reply.svg": 308,
        "./tip.svg": 309
      };

      function webpackContext(req) {
        return __webpack_require__(webpackContextResolve(req));
      }

      ;

      function webpackContextResolve(req) {
        var id = map[req];
        if (!(id + 1)) // check for number or string
          throw new Error("Cannot find module '" + req + "'.");
        return id;
      }

      ;

      webpackContext.keys = function webpackContextKeys() {
        return Object.keys(map);
      };

      webpackContext.resolve = webpackContextResolve;
      module.exports = webpackContext;
      webpackContext.id = 302;
      /***/
    },
    /* 303 */

    /***/
    function (module, exports) {
      module.exports = "<svg viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" p-id=\"1619\"><path d=\"M511.872 676.8c-0.003 0-0.006 0-0.008 0-9.137 0-17.379-3.829-23.21-9.97l-251.277-265.614c-5.415-5.72-8.743-13.464-8.744-21.984 0-17.678 14.33-32.008 32.008-32.008 9.157 0 17.416 3.845 23.25 10.009l228.045 241.103 228.224-241.088c5.855-6.165 14.113-10.001 23.266-10.001 8.516 0 16.256 3.32 21.998 8.736 12.784 12.145 13.36 32.434 1.264 45.233l-251.52 265.6c-5.844 6.155-14.086 9.984-23.223 9.984-0.025 0-0.051 0-0.076 0z\" p-id=\"1620\"></path></svg>";
      /***/
    },
    /* 304 */

    /***/
    function (module, exports) {
      module.exports = "<svg viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M785.333333 85.333333C774.666667 85.333333 763.2 90.133333 754.666667 98.666667L682.666667 170.666667 853.333333 341.333333 925.333333 269.333333C942.4 252.266667 942.4 222.133333 925.333333 209.333333L814.666667 98.666667C806.133333 90.133333 796 85.333333 785.333333 85.333333zM640 217.333333 85.333333 768 85.333333 938.666667 256 938.666667 806.666667 384 640 217.333333z\"></path>\n</svg>\n";
      /***/
    },
    /* 305 */

    /***/
    function (module, exports) {
      module.exports = "<svg viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M64 524C64 719.602 189.356 885.926 364.113 947.017 387.65799 953 384 936.115 384 924.767L384 847.107C248.118 863.007 242.674 773.052 233.5 758.001 215 726.501 171.5 718.501 184.5 703.501 215.5 687.501 247 707.501 283.5 761.501 309.956 800.642 361.366 794.075 387.658 787.497 393.403 763.997 405.637 743.042 422.353 726.638 281.774 701.609 223 615.67 223 513.5 223 464.053 239.322 418.406 271.465 381.627 251.142 320.928 273.421 269.19 276.337 261.415 334.458 256.131 394.888 302.993 399.549 306.685 432.663 297.835 470.341 293 512.5 293 554.924 293 592.81 297.896 626.075 306.853 637.426 298.219 693.46 258.054 747.5 262.966 750.382 270.652 772.185 321.292 753.058 381.083 785.516 417.956 802 463.809 802 513.5 802 615.874 742.99 701.953 601.803 726.786 625.381 750.003 640 782.295 640 818.008L640 930.653C640.752 939.626 640 948.664978 655.086 948.665 832.344 888.962 960 721.389 960 524 960 276.576 759.424 76 512 76 264.577 76 64 276.576 64 524Z\"></path>\n</svg>\n";
      /***/
    },
    /* 306 */

    /***/
    function (module, exports) {
      module.exports = "<svg viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n  <path d=\"M527.061333 166.528A277.333333 277.333333 0 0 1 1000.618667 362.666667a277.333333 277.333333 0 0 1-81.28 196.138666l-377.173334 377.173334a42.666667 42.666667 0 0 1-60.330666 0l-377.173334-377.173334a277.376 277.376 0 0 1 392.277334-392.277333l15.061333 15.061333 15.061333-15.061333z m286.72 377.173333l45.226667-45.226666a192 192 0 0 0-135.808-327.893334 192 192 0 0 0-135.808 56.32l-45.226667 45.226667a42.666667 42.666667 0 0 1-60.330666 0l-45.226667-45.226667a192.042667 192.042667 0 0 0-271.616 271.573334L512 845.482667l301.781333-301.781334z\"></path>\n</svg>\n";
      /***/
    },
    /* 307 */

    /***/
    function (module, exports) {
      module.exports = "<svg t=\"1512463363724\" viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n  <path d=\"M527.061333 166.528A277.333333 277.333333 0 0 1 1000.618667 362.666667a277.333333 277.333333 0 0 1-81.28 196.138666l-377.173334 377.173334a42.666667 42.666667 0 0 1-60.330666 0l-377.173334-377.173334a277.376 277.376 0 0 1 392.277334-392.277333l15.061333 15.061333 15.061333-15.061333z\"></path>\n</svg>\n";
      /***/
    },
    /* 308 */

    /***/
    function (module, exports) {
      module.exports = "<svg viewBox=\"0 0 1332 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M529.066665 273.066666 529.066665 0 51.2 477.866666 529.066665 955.733335 529.066665 675.84C870.4 675.84 1109.333335 785.066665 1280 1024 1211.733335 682.666665 1006.933335 341.333334 529.066665 273.066666\"></path>\n</svg>\n";
      /***/
    },
    /* 309 */

    /***/
    function (module, exports) {
      module.exports = "<svg viewBox=\"0 0 1024 1024\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M512 366.949535c-16.065554 0-29.982212 13.405016-29.982212 29.879884l0 359.070251c0 16.167882 13.405016 29.879884 29.982212 29.879884 15.963226 0 29.879884-13.405016 29.879884-29.879884L541.879884 396.829419C541.879884 380.763865 528.474868 366.949535 512 366.949535L512 366.949535z\"\n    p-id=\"3083\"></path>\n  <path d=\"M482.017788 287.645048c0-7.776956 3.274508-15.553912 8.80024-21.181973 5.525732-5.525732 13.302688-8.80024 21.181973-8.80024 7.776956 0 15.553912 3.274508 21.079644 8.80024 5.525732 5.62806 8.80024 13.405016 8.80024 21.181973 0 7.776956-3.274508 15.656241-8.80024 21.181973-5.525732 5.525732-13.405016 8.697911-21.079644 8.697911-7.879285 0-15.656241-3.274508-21.181973-8.697911C485.292295 303.301289 482.017788 295.524333 482.017788 287.645048L482.017788 287.645048z\"\n    p-id=\"3084\"></path>\n  <path d=\"M512 946.844409c-239.8577 0-434.895573-195.037873-434.895573-434.895573 0-239.8577 195.037873-434.895573 434.895573-434.895573 239.755371 0 434.895573 195.037873 434.895573 434.895573C946.895573 751.806535 751.755371 946.844409 512 946.844409zM512 126.17088c-212.740682 0-385.880284 173.037274-385.880284 385.777955 0 212.740682 173.037274 385.777955 385.880284 385.777955 212.740682 0 385.777955-173.037274 385.777955-385.777955C897.777955 299.208154 724.740682 126.17088 512 126.17088z\"\n    p-id=\"3085\"></path>\n</svg>\n";
      /***/
    },
    /* 310 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: true
      });
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__add_index_js__ = __webpack_require__(311);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "add", function () {
        return __WEBPACK_IMPORTED_MODULE_0__add_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addBusinessDays_index_js__ = __webpack_require__(132);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addBusinessDays", function () {
        return __WEBPACK_IMPORTED_MODULE_1__addBusinessDays_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__addDays_index_js__ = __webpack_require__(21);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addDays", function () {
        return __WEBPACK_IMPORTED_MODULE_2__addDays_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__addHours_index_js__ = __webpack_require__(84);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addHours", function () {
        return __WEBPACK_IMPORTED_MODULE_3__addHours_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__addISOWeekYears_index_js__ = __webpack_require__(134);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addISOWeekYears", function () {
        return __WEBPACK_IMPORTED_MODULE_4__addISOWeekYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__addMilliseconds_index_js__ = __webpack_require__(45);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addMilliseconds", function () {
        return __WEBPACK_IMPORTED_MODULE_5__addMilliseconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__addMinutes_index_js__ = __webpack_require__(136);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addMinutes", function () {
        return __WEBPACK_IMPORTED_MODULE_6__addMinutes_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__addMonths_index_js__ = __webpack_require__(44);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addMonths", function () {
        return __WEBPACK_IMPORTED_MODULE_7__addMonths_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__addQuarters_index_js__ = __webpack_require__(85);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addQuarters", function () {
        return __WEBPACK_IMPORTED_MODULE_8__addQuarters_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__addSeconds_index_js__ = __webpack_require__(137);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addSeconds", function () {
        return __WEBPACK_IMPORTED_MODULE_9__addSeconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_10__addWeeks_index_js__ = __webpack_require__(58);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addWeeks", function () {
        return __WEBPACK_IMPORTED_MODULE_10__addWeeks_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_11__addYears_index_js__ = __webpack_require__(138);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "addYears", function () {
        return __WEBPACK_IMPORTED_MODULE_11__addYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_12__areIntervalsOverlapping_index_js__ = __webpack_require__(312);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "areIntervalsOverlapping", function () {
        return __WEBPACK_IMPORTED_MODULE_12__areIntervalsOverlapping_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_13__closestIndexTo_index_js__ = __webpack_require__(313);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "closestIndexTo", function () {
        return __WEBPACK_IMPORTED_MODULE_13__closestIndexTo_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_14__closestTo_index_js__ = __webpack_require__(314);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "closestTo", function () {
        return __WEBPACK_IMPORTED_MODULE_14__closestTo_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_15__compareAsc_index_js__ = __webpack_require__(27);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "compareAsc", function () {
        return __WEBPACK_IMPORTED_MODULE_15__compareAsc_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_16__compareDesc_index_js__ = __webpack_require__(315);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "compareDesc", function () {
        return __WEBPACK_IMPORTED_MODULE_16__compareDesc_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_17__differenceInBusinessDays_index_js__ = __webpack_require__(316);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInBusinessDays", function () {
        return __WEBPACK_IMPORTED_MODULE_17__differenceInBusinessDays_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_18__differenceInCalendarDays_index_js__ = __webpack_require__(26);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInCalendarDays", function () {
        return __WEBPACK_IMPORTED_MODULE_18__differenceInCalendarDays_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_19__differenceInCalendarISOWeekYears_index_js__ = __webpack_require__(139);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInCalendarISOWeekYears", function () {
        return __WEBPACK_IMPORTED_MODULE_19__differenceInCalendarISOWeekYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_20__differenceInCalendarISOWeeks_index_js__ = __webpack_require__(317);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInCalendarISOWeeks", function () {
        return __WEBPACK_IMPORTED_MODULE_20__differenceInCalendarISOWeeks_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_21__differenceInCalendarMonths_index_js__ = __webpack_require__(140);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInCalendarMonths", function () {
        return __WEBPACK_IMPORTED_MODULE_21__differenceInCalendarMonths_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_22__differenceInCalendarQuarters_index_js__ = __webpack_require__(318);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInCalendarQuarters", function () {
        return __WEBPACK_IMPORTED_MODULE_22__differenceInCalendarQuarters_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_23__differenceInCalendarWeeks_index_js__ = __webpack_require__(142);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInCalendarWeeks", function () {
        return __WEBPACK_IMPORTED_MODULE_23__differenceInCalendarWeeks_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_24__differenceInCalendarYears_index_js__ = __webpack_require__(143);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInCalendarYears", function () {
        return __WEBPACK_IMPORTED_MODULE_24__differenceInCalendarYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_25__differenceInDays_index_js__ = __webpack_require__(86);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInDays", function () {
        return __WEBPACK_IMPORTED_MODULE_25__differenceInDays_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_26__differenceInHours_index_js__ = __webpack_require__(144);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInHours", function () {
        return __WEBPACK_IMPORTED_MODULE_26__differenceInHours_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_27__differenceInISOWeekYears_index_js__ = __webpack_require__(319);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInISOWeekYears", function () {
        return __WEBPACK_IMPORTED_MODULE_27__differenceInISOWeekYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_28__differenceInMilliseconds_index_js__ = __webpack_require__(59);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInMilliseconds", function () {
        return __WEBPACK_IMPORTED_MODULE_28__differenceInMilliseconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_29__differenceInMinutes_index_js__ = __webpack_require__(146);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInMinutes", function () {
        return __WEBPACK_IMPORTED_MODULE_29__differenceInMinutes_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_30__differenceInMonths_index_js__ = __webpack_require__(60);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInMonths", function () {
        return __WEBPACK_IMPORTED_MODULE_30__differenceInMonths_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_31__differenceInQuarters_index_js__ = __webpack_require__(320);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInQuarters", function () {
        return __WEBPACK_IMPORTED_MODULE_31__differenceInQuarters_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_32__differenceInSeconds_index_js__ = __webpack_require__(61);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInSeconds", function () {
        return __WEBPACK_IMPORTED_MODULE_32__differenceInSeconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_33__differenceInWeeks_index_js__ = __webpack_require__(321);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInWeeks", function () {
        return __WEBPACK_IMPORTED_MODULE_33__differenceInWeeks_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_34__differenceInYears_index_js__ = __webpack_require__(147);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "differenceInYears", function () {
        return __WEBPACK_IMPORTED_MODULE_34__differenceInYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_35__eachDayOfInterval_index_js__ = __webpack_require__(148);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eachDayOfInterval", function () {
        return __WEBPACK_IMPORTED_MODULE_35__eachDayOfInterval_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_36__eachHourOfInterval_index_js__ = __webpack_require__(322);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eachHourOfInterval", function () {
        return __WEBPACK_IMPORTED_MODULE_36__eachHourOfInterval_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_37__eachMonthOfInterval_index_js__ = __webpack_require__(323);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eachMonthOfInterval", function () {
        return __WEBPACK_IMPORTED_MODULE_37__eachMonthOfInterval_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_38__eachQuarterOfInterval_index_js__ = __webpack_require__(324);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eachQuarterOfInterval", function () {
        return __WEBPACK_IMPORTED_MODULE_38__eachQuarterOfInterval_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_39__eachWeekOfInterval_index_js__ = __webpack_require__(325);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eachWeekOfInterval", function () {
        return __WEBPACK_IMPORTED_MODULE_39__eachWeekOfInterval_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_40__eachWeekendOfInterval_index_js__ = __webpack_require__(88);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eachWeekendOfInterval", function () {
        return __WEBPACK_IMPORTED_MODULE_40__eachWeekendOfInterval_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_41__eachWeekendOfMonth_index_js__ = __webpack_require__(326);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eachWeekendOfMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_41__eachWeekendOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_42__eachWeekendOfYear_index_js__ = __webpack_require__(327);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eachWeekendOfYear", function () {
        return __WEBPACK_IMPORTED_MODULE_42__eachWeekendOfYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_43__eachYearOfInterval_index_js__ = __webpack_require__(328);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eachYearOfInterval", function () {
        return __WEBPACK_IMPORTED_MODULE_43__eachYearOfInterval_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_44__endOfDay_index_js__ = __webpack_require__(91);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfDay", function () {
        return __WEBPACK_IMPORTED_MODULE_44__endOfDay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_45__endOfDecade_index_js__ = __webpack_require__(329);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfDecade", function () {
        return __WEBPACK_IMPORTED_MODULE_45__endOfDecade_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_46__endOfHour_index_js__ = __webpack_require__(330);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfHour", function () {
        return __WEBPACK_IMPORTED_MODULE_46__endOfHour_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_47__endOfISOWeek_index_js__ = __webpack_require__(331);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfISOWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_47__endOfISOWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_48__endOfISOWeekYear_index_js__ = __webpack_require__(332);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfISOWeekYear", function () {
        return __WEBPACK_IMPORTED_MODULE_48__endOfISOWeekYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_49__endOfMinute_index_js__ = __webpack_require__(333);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfMinute", function () {
        return __WEBPACK_IMPORTED_MODULE_49__endOfMinute_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_50__endOfMonth_index_js__ = __webpack_require__(89);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_50__endOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_51__endOfQuarter_index_js__ = __webpack_require__(334);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfQuarter", function () {
        return __WEBPACK_IMPORTED_MODULE_51__endOfQuarter_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_52__endOfSecond_index_js__ = __webpack_require__(335);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfSecond", function () {
        return __WEBPACK_IMPORTED_MODULE_52__endOfSecond_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_53__endOfToday_index_js__ = __webpack_require__(336);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfToday", function () {
        return __WEBPACK_IMPORTED_MODULE_53__endOfToday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_54__endOfTomorrow_index_js__ = __webpack_require__(337);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfTomorrow", function () {
        return __WEBPACK_IMPORTED_MODULE_54__endOfTomorrow_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_55__endOfWeek_index_js__ = __webpack_require__(150);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_55__endOfWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_56__endOfYear_index_js__ = __webpack_require__(149);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfYear", function () {
        return __WEBPACK_IMPORTED_MODULE_56__endOfYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_57__endOfYesterday_index_js__ = __webpack_require__(338);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "endOfYesterday", function () {
        return __WEBPACK_IMPORTED_MODULE_57__endOfYesterday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_58__format_index_js__ = __webpack_require__(151);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "format", function () {
        return __WEBPACK_IMPORTED_MODULE_58__format_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_59__formatDistance_index_js__ = __webpack_require__(158);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatDistance", function () {
        return __WEBPACK_IMPORTED_MODULE_59__formatDistance_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_60__formatDistanceStrict_index_js__ = __webpack_require__(161);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatDistanceStrict", function () {
        return __WEBPACK_IMPORTED_MODULE_60__formatDistanceStrict_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_61__formatDistanceToNow_index_js__ = __webpack_require__(344);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatDistanceToNow", function () {
        return __WEBPACK_IMPORTED_MODULE_61__formatDistanceToNow_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_62__formatDistanceToNowStrict_index_js__ = __webpack_require__(345);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatDistanceToNowStrict", function () {
        return __WEBPACK_IMPORTED_MODULE_62__formatDistanceToNowStrict_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_63__formatDuration_index_js__ = __webpack_require__(346);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatDuration", function () {
        return __WEBPACK_IMPORTED_MODULE_63__formatDuration_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_64__formatISO_index_js__ = __webpack_require__(347);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatISO", function () {
        return __WEBPACK_IMPORTED_MODULE_64__formatISO_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_65__formatISO9075_index_js__ = __webpack_require__(348);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatISO9075", function () {
        return __WEBPACK_IMPORTED_MODULE_65__formatISO9075_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_66__formatISODuration_index_js__ = __webpack_require__(349);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatISODuration", function () {
        return __WEBPACK_IMPORTED_MODULE_66__formatISODuration_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_67__formatRFC3339_index_js__ = __webpack_require__(350);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatRFC3339", function () {
        return __WEBPACK_IMPORTED_MODULE_67__formatRFC3339_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_68__formatRFC7231_index_js__ = __webpack_require__(351);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatRFC7231", function () {
        return __WEBPACK_IMPORTED_MODULE_68__formatRFC7231_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_69__formatRelative_index_js__ = __webpack_require__(352);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "formatRelative", function () {
        return __WEBPACK_IMPORTED_MODULE_69__formatRelative_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_70__fromUnixTime_index_js__ = __webpack_require__(353);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "fromUnixTime", function () {
        return __WEBPACK_IMPORTED_MODULE_70__fromUnixTime_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_71__getDate_index_js__ = __webpack_require__(162);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getDate", function () {
        return __WEBPACK_IMPORTED_MODULE_71__getDate_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_72__getDay_index_js__ = __webpack_require__(163);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getDay", function () {
        return __WEBPACK_IMPORTED_MODULE_72__getDay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_73__getDayOfYear_index_js__ = __webpack_require__(354);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getDayOfYear", function () {
        return __WEBPACK_IMPORTED_MODULE_73__getDayOfYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_74__getDaysInMonth_index_js__ = __webpack_require__(164);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getDaysInMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_74__getDaysInMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_75__getDaysInYear_index_js__ = __webpack_require__(355);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getDaysInYear", function () {
        return __WEBPACK_IMPORTED_MODULE_75__getDaysInYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_76__getDecade_index_js__ = __webpack_require__(356);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getDecade", function () {
        return __WEBPACK_IMPORTED_MODULE_76__getDecade_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_77__getHours_index_js__ = __webpack_require__(357);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getHours", function () {
        return __WEBPACK_IMPORTED_MODULE_77__getHours_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_78__getISODay_index_js__ = __webpack_require__(166);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getISODay", function () {
        return __WEBPACK_IMPORTED_MODULE_78__getISODay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_79__getISOWeek_index_js__ = __webpack_require__(167);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getISOWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_79__getISOWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_80__getISOWeekYear_index_js__ = __webpack_require__(34);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getISOWeekYear", function () {
        return __WEBPACK_IMPORTED_MODULE_80__getISOWeekYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_81__getISOWeeksInYear_index_js__ = __webpack_require__(358);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getISOWeeksInYear", function () {
        return __WEBPACK_IMPORTED_MODULE_81__getISOWeeksInYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_82__getMilliseconds_index_js__ = __webpack_require__(359);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getMilliseconds", function () {
        return __WEBPACK_IMPORTED_MODULE_82__getMilliseconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_83__getMinutes_index_js__ = __webpack_require__(360);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getMinutes", function () {
        return __WEBPACK_IMPORTED_MODULE_83__getMinutes_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_84__getMonth_index_js__ = __webpack_require__(361);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_84__getMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_85__getOverlappingDaysInIntervals_index_js__ = __webpack_require__(362);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getOverlappingDaysInIntervals", function () {
        return __WEBPACK_IMPORTED_MODULE_85__getOverlappingDaysInIntervals_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_86__getQuarter_index_js__ = __webpack_require__(141);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getQuarter", function () {
        return __WEBPACK_IMPORTED_MODULE_86__getQuarter_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_87__getSeconds_index_js__ = __webpack_require__(363);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getSeconds", function () {
        return __WEBPACK_IMPORTED_MODULE_87__getSeconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_88__getTime_index_js__ = __webpack_require__(168);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getTime", function () {
        return __WEBPACK_IMPORTED_MODULE_88__getTime_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_89__getUnixTime_index_js__ = __webpack_require__(364);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getUnixTime", function () {
        return __WEBPACK_IMPORTED_MODULE_89__getUnixTime_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_90__getWeek_index_js__ = __webpack_require__(169);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_90__getWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_91__getWeekOfMonth_index_js__ = __webpack_require__(365);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getWeekOfMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_91__getWeekOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_92__getWeekYear_index_js__ = __webpack_require__(170);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getWeekYear", function () {
        return __WEBPACK_IMPORTED_MODULE_92__getWeekYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_93__getWeeksInMonth_index_js__ = __webpack_require__(366);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getWeeksInMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_93__getWeeksInMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_94__getYear_index_js__ = __webpack_require__(367);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "getYear", function () {
        return __WEBPACK_IMPORTED_MODULE_94__getYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_95__intervalToDuration_index_js__ = __webpack_require__(368);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "intervalToDuration", function () {
        return __WEBPACK_IMPORTED_MODULE_95__intervalToDuration_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_96__isAfter_index_js__ = __webpack_require__(369);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isAfter", function () {
        return __WEBPACK_IMPORTED_MODULE_96__isAfter_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_97__isBefore_index_js__ = __webpack_require__(370);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isBefore", function () {
        return __WEBPACK_IMPORTED_MODULE_97__isBefore_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_98__isDate_index_js__ = __webpack_require__(371);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isDate", function () {
        return __WEBPACK_IMPORTED_MODULE_98__isDate_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_99__isEqual_index_js__ = __webpack_require__(372);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isEqual", function () {
        return __WEBPACK_IMPORTED_MODULE_99__isEqual_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_100__isExists_index_js__ = __webpack_require__(373);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isExists", function () {
        return __WEBPACK_IMPORTED_MODULE_100__isExists_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_101__isFirstDayOfMonth_index_js__ = __webpack_require__(374);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isFirstDayOfMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_101__isFirstDayOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_102__isFriday_index_js__ = __webpack_require__(375);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isFriday", function () {
        return __WEBPACK_IMPORTED_MODULE_102__isFriday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_103__isFuture_index_js__ = __webpack_require__(376);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isFuture", function () {
        return __WEBPACK_IMPORTED_MODULE_103__isFuture_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_104__isLastDayOfMonth_index_js__ = __webpack_require__(377);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isLastDayOfMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_104__isLastDayOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_105__isLeapYear_index_js__ = __webpack_require__(165);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isLeapYear", function () {
        return __WEBPACK_IMPORTED_MODULE_105__isLeapYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_106__isMatch_index_js__ = __webpack_require__(378);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isMatch", function () {
        return __WEBPACK_IMPORTED_MODULE_106__isMatch_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_107__isMonday_index_js__ = __webpack_require__(384);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isMonday", function () {
        return __WEBPACK_IMPORTED_MODULE_107__isMonday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_108__isPast_index_js__ = __webpack_require__(385);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isPast", function () {
        return __WEBPACK_IMPORTED_MODULE_108__isPast_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_109__isSameDay_index_js__ = __webpack_require__(47);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameDay", function () {
        return __WEBPACK_IMPORTED_MODULE_109__isSameDay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_110__isSameHour_index_js__ = __webpack_require__(175);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameHour", function () {
        return __WEBPACK_IMPORTED_MODULE_110__isSameHour_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_111__isSameISOWeek_index_js__ = __webpack_require__(177);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameISOWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_111__isSameISOWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_112__isSameISOWeekYear_index_js__ = __webpack_require__(386);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameISOWeekYear", function () {
        return __WEBPACK_IMPORTED_MODULE_112__isSameISOWeekYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_113__isSameMinute_index_js__ = __webpack_require__(178);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameMinute", function () {
        return __WEBPACK_IMPORTED_MODULE_113__isSameMinute_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_114__isSameMonth_index_js__ = __webpack_require__(180);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_114__isSameMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_115__isSameQuarter_index_js__ = __webpack_require__(181);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameQuarter", function () {
        return __WEBPACK_IMPORTED_MODULE_115__isSameQuarter_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_116__isSameSecond_index_js__ = __webpack_require__(182);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameSecond", function () {
        return __WEBPACK_IMPORTED_MODULE_116__isSameSecond_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_117__isSameWeek_index_js__ = __webpack_require__(95);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_117__isSameWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_118__isSameYear_index_js__ = __webpack_require__(184);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSameYear", function () {
        return __WEBPACK_IMPORTED_MODULE_118__isSameYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_119__isSaturday_index_js__ = __webpack_require__(133);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSaturday", function () {
        return __WEBPACK_IMPORTED_MODULE_119__isSaturday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_120__isSunday_index_js__ = __webpack_require__(83);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isSunday", function () {
        return __WEBPACK_IMPORTED_MODULE_120__isSunday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_121__isThisHour_index_js__ = __webpack_require__(387);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isThisHour", function () {
        return __WEBPACK_IMPORTED_MODULE_121__isThisHour_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_122__isThisISOWeek_index_js__ = __webpack_require__(388);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isThisISOWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_122__isThisISOWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_123__isThisMinute_index_js__ = __webpack_require__(389);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isThisMinute", function () {
        return __WEBPACK_IMPORTED_MODULE_123__isThisMinute_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_124__isThisMonth_index_js__ = __webpack_require__(390);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isThisMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_124__isThisMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_125__isThisQuarter_index_js__ = __webpack_require__(391);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isThisQuarter", function () {
        return __WEBPACK_IMPORTED_MODULE_125__isThisQuarter_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_126__isThisSecond_index_js__ = __webpack_require__(392);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isThisSecond", function () {
        return __WEBPACK_IMPORTED_MODULE_126__isThisSecond_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_127__isThisWeek_index_js__ = __webpack_require__(393);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isThisWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_127__isThisWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_128__isThisYear_index_js__ = __webpack_require__(394);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isThisYear", function () {
        return __WEBPACK_IMPORTED_MODULE_128__isThisYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_129__isThursday_index_js__ = __webpack_require__(395);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isThursday", function () {
        return __WEBPACK_IMPORTED_MODULE_129__isThursday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_130__isToday_index_js__ = __webpack_require__(396);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isToday", function () {
        return __WEBPACK_IMPORTED_MODULE_130__isToday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_131__isTomorrow_index_js__ = __webpack_require__(397);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isTomorrow", function () {
        return __WEBPACK_IMPORTED_MODULE_131__isTomorrow_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_132__isTuesday_index_js__ = __webpack_require__(398);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isTuesday", function () {
        return __WEBPACK_IMPORTED_MODULE_132__isTuesday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_133__isValid_index_js__ = __webpack_require__(15);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isValid", function () {
        return __WEBPACK_IMPORTED_MODULE_133__isValid_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_134__isWednesday_index_js__ = __webpack_require__(399);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isWednesday", function () {
        return __WEBPACK_IMPORTED_MODULE_134__isWednesday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_135__isWeekend_index_js__ = __webpack_require__(56);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isWeekend", function () {
        return __WEBPACK_IMPORTED_MODULE_135__isWeekend_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_136__isWithinInterval_index_js__ = __webpack_require__(400);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isWithinInterval", function () {
        return __WEBPACK_IMPORTED_MODULE_136__isWithinInterval_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_137__isYesterday_index_js__ = __webpack_require__(401);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "isYesterday", function () {
        return __WEBPACK_IMPORTED_MODULE_137__isYesterday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_138__lastDayOfDecade_index_js__ = __webpack_require__(402);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lastDayOfDecade", function () {
        return __WEBPACK_IMPORTED_MODULE_138__lastDayOfDecade_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_139__lastDayOfISOWeek_index_js__ = __webpack_require__(403);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lastDayOfISOWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_139__lastDayOfISOWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_140__lastDayOfISOWeekYear_index_js__ = __webpack_require__(404);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lastDayOfISOWeekYear", function () {
        return __WEBPACK_IMPORTED_MODULE_140__lastDayOfISOWeekYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_141__lastDayOfMonth_index_js__ = __webpack_require__(171);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lastDayOfMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_141__lastDayOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_142__lastDayOfQuarter_index_js__ = __webpack_require__(405);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lastDayOfQuarter", function () {
        return __WEBPACK_IMPORTED_MODULE_142__lastDayOfQuarter_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_143__lastDayOfWeek_index_js__ = __webpack_require__(185);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lastDayOfWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_143__lastDayOfWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_144__lastDayOfYear_index_js__ = __webpack_require__(406);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lastDayOfYear", function () {
        return __WEBPACK_IMPORTED_MODULE_144__lastDayOfYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_145__lightFormat_index_js__ = __webpack_require__(407);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lightFormat", function () {
        return __WEBPACK_IMPORTED_MODULE_145__lightFormat_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_146__max_index_js__ = __webpack_require__(408);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "max", function () {
        return __WEBPACK_IMPORTED_MODULE_146__max_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_147__min_index_js__ = __webpack_require__(409);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "min", function () {
        return __WEBPACK_IMPORTED_MODULE_147__min_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_148__parse_index_js__ = __webpack_require__(174);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "parse", function () {
        return __WEBPACK_IMPORTED_MODULE_148__parse_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_149__parseISO_index_js__ = __webpack_require__(410);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "parseISO", function () {
        return __WEBPACK_IMPORTED_MODULE_149__parseISO_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_150__parseJSON_index_js__ = __webpack_require__(411);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "parseJSON", function () {
        return __WEBPACK_IMPORTED_MODULE_150__parseJSON_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_151__roundToNearestMinutes_index_js__ = __webpack_require__(412);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "roundToNearestMinutes", function () {
        return __WEBPACK_IMPORTED_MODULE_151__roundToNearestMinutes_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_152__set_index_js__ = __webpack_require__(413);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "set", function () {
        return __WEBPACK_IMPORTED_MODULE_152__set_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_153__setDate_index_js__ = __webpack_require__(414);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setDate", function () {
        return __WEBPACK_IMPORTED_MODULE_153__setDate_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_154__setDay_index_js__ = __webpack_require__(415);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setDay", function () {
        return __WEBPACK_IMPORTED_MODULE_154__setDay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_155__setDayOfYear_index_js__ = __webpack_require__(416);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setDayOfYear", function () {
        return __WEBPACK_IMPORTED_MODULE_155__setDayOfYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_156__setHours_index_js__ = __webpack_require__(417);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setHours", function () {
        return __WEBPACK_IMPORTED_MODULE_156__setHours_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_157__setISODay_index_js__ = __webpack_require__(418);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setISODay", function () {
        return __WEBPACK_IMPORTED_MODULE_157__setISODay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_158__setISOWeek_index_js__ = __webpack_require__(419);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setISOWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_158__setISOWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_159__setISOWeekYear_index_js__ = __webpack_require__(135);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setISOWeekYear", function () {
        return __WEBPACK_IMPORTED_MODULE_159__setISOWeekYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_160__setMilliseconds_index_js__ = __webpack_require__(420);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setMilliseconds", function () {
        return __WEBPACK_IMPORTED_MODULE_160__setMilliseconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_161__setMinutes_index_js__ = __webpack_require__(421);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setMinutes", function () {
        return __WEBPACK_IMPORTED_MODULE_161__setMinutes_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_162__setMonth_index_js__ = __webpack_require__(96);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_162__setMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_163__setQuarter_index_js__ = __webpack_require__(422);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setQuarter", function () {
        return __WEBPACK_IMPORTED_MODULE_163__setQuarter_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_164__setSeconds_index_js__ = __webpack_require__(423);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setSeconds", function () {
        return __WEBPACK_IMPORTED_MODULE_164__setSeconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_165__setWeek_index_js__ = __webpack_require__(424);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_165__setWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_166__setWeekYear_index_js__ = __webpack_require__(425);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setWeekYear", function () {
        return __WEBPACK_IMPORTED_MODULE_166__setWeekYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_167__setYear_index_js__ = __webpack_require__(426);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "setYear", function () {
        return __WEBPACK_IMPORTED_MODULE_167__setYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_168__startOfDay_index_js__ = __webpack_require__(57);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfDay", function () {
        return __WEBPACK_IMPORTED_MODULE_168__startOfDay_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_169__startOfDecade_index_js__ = __webpack_require__(427);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfDecade", function () {
        return __WEBPACK_IMPORTED_MODULE_169__startOfDecade_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_170__startOfHour_index_js__ = __webpack_require__(176);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfHour", function () {
        return __WEBPACK_IMPORTED_MODULE_170__startOfHour_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_171__startOfISOWeek_index_js__ = __webpack_require__(25);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfISOWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_171__startOfISOWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_172__startOfISOWeekYear_index_js__ = __webpack_require__(46);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfISOWeekYear", function () {
        return __WEBPACK_IMPORTED_MODULE_172__startOfISOWeekYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_173__startOfMinute_index_js__ = __webpack_require__(179);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfMinute", function () {
        return __WEBPACK_IMPORTED_MODULE_173__startOfMinute_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_174__startOfMonth_index_js__ = __webpack_require__(62);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfMonth", function () {
        return __WEBPACK_IMPORTED_MODULE_174__startOfMonth_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_175__startOfQuarter_index_js__ = __webpack_require__(87);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfQuarter", function () {
        return __WEBPACK_IMPORTED_MODULE_175__startOfQuarter_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_176__startOfSecond_index_js__ = __webpack_require__(183);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfSecond", function () {
        return __WEBPACK_IMPORTED_MODULE_176__startOfSecond_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_177__startOfToday_index_js__ = __webpack_require__(428);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfToday", function () {
        return __WEBPACK_IMPORTED_MODULE_177__startOfToday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_178__startOfTomorrow_index_js__ = __webpack_require__(429);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfTomorrow", function () {
        return __WEBPACK_IMPORTED_MODULE_178__startOfTomorrow_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_179__startOfWeek_index_js__ = __webpack_require__(22);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfWeek", function () {
        return __WEBPACK_IMPORTED_MODULE_179__startOfWeek_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_180__startOfWeekYear_index_js__ = __webpack_require__(93);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfWeekYear", function () {
        return __WEBPACK_IMPORTED_MODULE_180__startOfWeekYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_181__startOfYear_index_js__ = __webpack_require__(90);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfYear", function () {
        return __WEBPACK_IMPORTED_MODULE_181__startOfYear_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_182__startOfYesterday_index_js__ = __webpack_require__(430);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "startOfYesterday", function () {
        return __WEBPACK_IMPORTED_MODULE_182__startOfYesterday_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_183__sub_index_js__ = __webpack_require__(172);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "sub", function () {
        return __WEBPACK_IMPORTED_MODULE_183__sub_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_184__subBusinessDays_index_js__ = __webpack_require__(431);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subBusinessDays", function () {
        return __WEBPACK_IMPORTED_MODULE_184__subBusinessDays_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_185__subDays_index_js__ = __webpack_require__(94);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subDays", function () {
        return __WEBPACK_IMPORTED_MODULE_185__subDays_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_186__subHours_index_js__ = __webpack_require__(432);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subHours", function () {
        return __WEBPACK_IMPORTED_MODULE_186__subHours_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_187__subISOWeekYears_index_js__ = __webpack_require__(145);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subISOWeekYears", function () {
        return __WEBPACK_IMPORTED_MODULE_187__subISOWeekYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_188__subMilliseconds_index_js__ = __webpack_require__(49);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subMilliseconds", function () {
        return __WEBPACK_IMPORTED_MODULE_188__subMilliseconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_189__subMinutes_index_js__ = __webpack_require__(433);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subMinutes", function () {
        return __WEBPACK_IMPORTED_MODULE_189__subMinutes_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_190__subMonths_index_js__ = __webpack_require__(173);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subMonths", function () {
        return __WEBPACK_IMPORTED_MODULE_190__subMonths_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_191__subQuarters_index_js__ = __webpack_require__(434);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subQuarters", function () {
        return __WEBPACK_IMPORTED_MODULE_191__subQuarters_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_192__subSeconds_index_js__ = __webpack_require__(435);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subSeconds", function () {
        return __WEBPACK_IMPORTED_MODULE_192__subSeconds_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_193__subWeeks_index_js__ = __webpack_require__(436);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subWeeks", function () {
        return __WEBPACK_IMPORTED_MODULE_193__subWeeks_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_194__subYears_index_js__ = __webpack_require__(437);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "subYears", function () {
        return __WEBPACK_IMPORTED_MODULE_194__subYears_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_195__toDate_index_js__ = __webpack_require__(1);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "toDate", function () {
        return __WEBPACK_IMPORTED_MODULE_195__toDate_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_196__constants_index_js__ = __webpack_require__(438);
      /* harmony namespace reexport (by provided) */


      __webpack_require__.d(__webpack_exports__, "maxTime", function () {
        return __WEBPACK_IMPORTED_MODULE_196__constants_index_js__["a"];
      });
      /* harmony namespace reexport (by provided) */


      __webpack_require__.d(__webpack_exports__, "minTime", function () {
        return __WEBPACK_IMPORTED_MODULE_196__constants_index_js__["b"];
      }); // This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

      /***/

    },
    /* 311 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = add;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(44);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__ = __webpack_require__(6);
      /**
       * @name add
       * @category Common Helpers
       * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
       *
       * @description
       * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       *
       * | Key            | Description                        |
       * |----------------|------------------------------------|
       * | years          | Amount of years to be added        |
       * | months         | Amount of months to be added       |
       * | weeks          | Amount of weeks to be added       |
       * | days           | Amount of days to be added         |
       * | hours          | Amount of hours to be added        |
       * | minutes        | Amount of minutes to be added      |
       * | seconds        | Amount of seconds to be added      |
       *
       * All values default to 0
       *
       * @returns {Date} the new date with the seconds added
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Add the following duration to 1 September 2014, 10:19:50
       * var result = add(new Date(2014, 8, 1, 10, 19, 50), {
       *   years: 2,
       *   months: 9,
       *   weeks: 1,
       *   days: 7,
       *   hours: 5,
       *   minutes: 9,
       *   seconds: 30,
       * })
       * //=> Thu Jun 15 2017 15:29:20
       */


      function add(dirtyDate, duration) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        if (!duration || typeof duration !== 'object') return new Date(NaN);
        var years = 'years' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.years) : 0;
        var months = 'months' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.months) : 0;
        var weeks = 'weeks' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.weeks) : 0;
        var days = 'days' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.days) : 0;
        var hours = 'hours' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.hours) : 0;
        var minutes = 'minutes' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.minutes) : 0;
        var seconds = 'seconds' in duration ? __WEBPACK_IMPORTED_MODULE_4__lib_toInteger_index_js__["a"
        /* default */
        ](duration.seconds) : 0; // Add years and months

        var date = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var dateWithMonths = months || years ? __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["a"
        /* default */
        ](date, months + years * 12) : date; // Add weeks and days

        var dateWithDays = days || weeks ? __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a"
        /* default */
        ](dateWithMonths, days + weeks * 7) : dateWithMonths; // Add days, hours, minutes and seconds

        var minutesToAdd = minutes + hours * 60;
        var secondsToAdd = seconds + minutesToAdd * 60;
        var msToAdd = secondsToAdd * 1000;
        var finalDate = new Date(dateWithDays.getTime() + msToAdd);
        return finalDate;
      }
      /***/

    },
    /* 312 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = areIntervalsOverlapping;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name areIntervalsOverlapping
       * @category Interval Helpers
       * @summary Is the given time interval overlapping with another time interval?
       *
       * @description
       * Is the given time interval overlapping with another time interval? Adjacent intervals do not count as overlapping.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `areRangesOverlapping` to `areIntervalsOverlapping`.
       *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
       *
       *   ```
       *   2.1.3
       *   time interval
       *   part of the time axis limited by two instants
       *   ```
       *
       *   Also, this function now accepts an object with `start` and `end` properties
       *   instead of two arguments as an interval.
       *   This function now throws `RangeError` if the start of the interval is after its end
       *   or if any date in the interval is `Invalid Date`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   areRangesOverlapping(
       *     new Date(2014, 0, 10), new Date(2014, 0, 20),
       *     new Date(2014, 0, 17), new Date(2014, 0, 21)
       *   )
       *
       *   // v2.0.0 onward
       *
       *   areIntervalsOverlapping(
       *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
       *   )
       *   ```
       *
       * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/types/Interval}
       * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/types/Interval}
       * @param {Object} [options] - the object with options
       * @param {Boolean} [options.inclusive=false] - whether the comparison is inclusive or not
       * @returns {Boolean} whether the time intervals are overlapping
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // For overlapping time intervals:
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
       * )
       * //=> true
       *
       * @example
       * // For non-overlapping time intervals:
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
       * )
       * //=> false
       *
       * @example
       * // For adjacent time intervals:
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 30) }
       * )
       * //=> false
       *
       * @example
       * // Using the inclusive option:
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) }
       * )
       * //=> false
       * areIntervalsOverlapping(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 20), end: new Date(2014, 0, 24) },
       *   { inclusive: true }
       * )
       * //=> true
       */


      function areIntervalsOverlapping(dirtyIntervalLeft, dirtyIntervalRight) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var intervalLeft = dirtyIntervalLeft || {};
        var intervalRight = dirtyIntervalRight || {};

        var leftStartTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](intervalLeft.start).getTime();

        var leftEndTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](intervalLeft.end).getTime();

        var rightStartTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](intervalRight.start).getTime();

        var rightEndTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`


        if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
          throw new RangeError('Invalid interval');
        }

        if (options.inclusive) {
          return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
        }

        return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
      }
      /***/

    },
    /* 313 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = closestIndexTo;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name closestIndexTo
       * @category Common Helpers
       * @summary Return an index of the closest date from the array comparing to the given date.
       *
       * @description
       * Return an index of the closest date from the array comparing to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - Now, `closestIndexTo` doesn't throw an exception
       *   when the second argument is not an array, and returns Invalid Date instead.
       *
       * @param {Date|Number} dateToCompare - the date to compare with
       * @param {Date[]|Number[]} datesArray - the array to search
       * @returns {Number} an index of the date closest to the given date
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Which date is closer to 6 September 2015?
       * var dateToCompare = new Date(2015, 8, 6)
       * var datesArray = [
       *   new Date(2015, 0, 1),
       *   new Date(2016, 0, 1),
       *   new Date(2017, 0, 1)
       * ]
       * var result = closestIndexTo(dateToCompare, datesArray)
       * //=> 1
       */


      function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateToCompare = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateToCompare);

        if (isNaN(dateToCompare)) {
          return NaN;
        }

        var timeToCompare = dateToCompare.getTime();
        var datesArray; // `dirtyDatesArray` is undefined or null

        if (dirtyDatesArray == null) {
          datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
        } else if (typeof dirtyDatesArray.forEach === 'function') {
          datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
        } else {
          datesArray = Array.prototype.slice.call(dirtyDatesArray);
        }

        var result;
        var minDistance;
        datesArray.forEach(function (dirtyDate, index) {
          var currentDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ](dirtyDate);

          if (isNaN(currentDate)) {
            result = NaN;
            minDistance = NaN;
            return;
          }

          var distance = Math.abs(timeToCompare - currentDate.getTime());

          if (result == null || distance < minDistance) {
            result = index;
            minDistance = distance;
          }
        });
        return result;
      }
      /***/

    },
    /* 314 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = closestTo;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name closestTo
       * @category Common Helpers
       * @summary Return a date from the array closest to the given date.
       *
       * @description
       * Return a date from the array closest to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - Now, `closestTo` doesn't throw an exception
       *   when the second argument is not an array, and returns Invalid Date instead.
       *
       * @param {Date|Number} dateToCompare - the date to compare with
       * @param {Date[]|Number[]} datesArray - the array to search
       * @returns {Date} the date from the array closest to the given date
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
       * var dateToCompare = new Date(2015, 8, 6)
       * var result = closestTo(dateToCompare, [
       *   new Date(2000, 0, 1),
       *   new Date(2030, 0, 1)
       * ])
       * //=> Tue Jan 01 2030 00:00:00
       */


      function closestTo(dirtyDateToCompare, dirtyDatesArray) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateToCompare = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateToCompare);

        if (isNaN(dateToCompare)) {
          return new Date(NaN);
        }

        var timeToCompare = dateToCompare.getTime();
        var datesArray; // `dirtyDatesArray` is undefined or null

        if (dirtyDatesArray == null) {
          datesArray = []; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
        } else if (typeof dirtyDatesArray.forEach === 'function') {
          datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array. Otherwise, make it empty Array
        } else {
          datesArray = Array.prototype.slice.call(dirtyDatesArray);
        }

        var result;
        var minDistance;
        datesArray.forEach(function (dirtyDate) {
          var currentDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ](dirtyDate);

          if (isNaN(currentDate)) {
            result = new Date(NaN);
            minDistance = NaN;
            return;
          }

          var distance = Math.abs(timeToCompare - currentDate.getTime());

          if (result == null || distance < minDistance) {
            result = currentDate;
            minDistance = distance;
          }
        });
        return result;
      }
      /***/

    },
    /* 315 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = compareDesc;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name compareDesc
       * @category Common Helpers
       * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
       *
       * @description
       * Compare the two dates and return -1 if the first date is after the second,
       * 1 if the first date is before the second or 0 if dates are equal.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to compare
       * @param {Date|Number} dateRight - the second date to compare
       * @returns {Number} the result of the comparison
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
       * var result = compareDesc(new Date(1987, 1, 11), new Date(1989, 6, 10))
       * //=> 1
       *
       * @example
       * // Sort the array of dates in reverse chronological order:
       * var result = [
       *   new Date(1995, 6, 2),
       *   new Date(1987, 1, 11),
       *   new Date(1989, 6, 10)
       * ].sort(compareDesc)
       * //=> [
       * //   Sun Jul 02 1995 00:00:00,
       * //   Mon Jul 10 1989 00:00:00,
       * //   Wed Feb 11 1987 00:00:00
       * // ]
       */


      function compareDesc(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var diff = dateLeft.getTime() - dateRight.getTime();

        if (diff > 0) {
          return -1;
        } else if (diff < 0) {
          return 1; // Return 0 if diff is 0; return NaN if diff is NaN
        } else {
          return diff;
        }
      }
      /***/

    },
    /* 316 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInBusinessDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isValid_index_js__ = __webpack_require__(15);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isWeekend_index_js__ = __webpack_require__(56);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__ = __webpack_require__(26);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__addDays_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__isSameDay_index_js__ = __webpack_require__(47);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInBusinessDays
       * @category Day Helpers
       * @summary Get the number of business days between the given dates.
       *
       * @description
       * Get the number of business day periods between the given dates.
       * Business days being days that arent in the weekend.
       * Like `differenceInCalendarDays`, the function removes the times from
       * the dates before calculating the difference.
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of business days
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many business days are between
       * // 10 January 2014 and 20 July 2014?
       * var result = differenceInBusinessDays(
       *   new Date(2014, 6, 20),
       *   new Date(2014, 0, 10)
       * )
       * //=> 136
       */


      function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_7__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        if (!__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["a"
        /* default */
        ](dateLeft) || !__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["a"
        /* default */
        ](dateRight)) return new Date(NaN);

        var calendarDifference = __WEBPACK_IMPORTED_MODULE_3__differenceInCalendarDays_index_js__["a"
        /* default */
        ](dateLeft, dateRight);

        var sign = calendarDifference < 0 ? -1 : 1;

        var weeks = __WEBPACK_IMPORTED_MODULE_6__lib_toInteger_index_js__["a"
        /* default */
        ](calendarDifference / 7);

        var result = weeks * 5;
        dateRight = __WEBPACK_IMPORTED_MODULE_4__addDays_index_js__["a"
        /* default */
        ](dateRight, weeks * 7); // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week

        while (!__WEBPACK_IMPORTED_MODULE_5__isSameDay_index_js__["a"
        /* default */
        ](dateLeft, dateRight)) {
          // sign is used to account for both negative and positive differences
          result += __WEBPACK_IMPORTED_MODULE_1__isWeekend_index_js__["a"
          /* default */
          ](dateRight) ? 0 : sign;
          dateRight = __WEBPACK_IMPORTED_MODULE_4__addDays_index_js__["a"
          /* default */
          ](dateRight, sign);
        }

        return result === 0 ? 0 : result;
      }
      /***/

    },
    /* 317 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarISOWeeks;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(25);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name differenceInCalendarISOWeeks
       * @category ISO Week Helpers
       * @summary Get the number of calendar ISO weeks between the given dates.
       *
       * @description
       * Get the number of calendar ISO weeks between the given dates.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar ISO weeks
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
       * var result = differenceInCalendarISOWeeks(
       *   new Date(2014, 6, 21),
       *   new Date(2014, 6, 6)
       * )
       * //=> 3
       */

      function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var startOfISOWeekLeft = __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var startOfISOWeekRight = __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var timestampLeft = startOfISOWeekLeft.getTime() - __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](startOfISOWeekLeft);

        var timestampRight = startOfISOWeekRight.getTime() - __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](startOfISOWeekRight); // Round the number of days to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)


        return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
      }
      /***/

    },
    /* 318 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInCalendarQuarters;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__ = __webpack_require__(141);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInCalendarQuarters
       * @category Quarter Helpers
       * @summary Get the number of calendar quarters between the given dates.
       *
       * @description
       * Get the number of calendar quarters between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of calendar quarters
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
       * var result = differenceInCalendarQuarters(
       *   new Date(2014, 6, 2),
       *   new Date(2013, 11, 31)
       * )
       * //=> 3
       */


      function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();

        var quarterDiff = __WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__["a"
        /* default */
        ](dateLeft) - __WEBPACK_IMPORTED_MODULE_0__getQuarter_index_js__["a"
        /* default */
        ](dateRight);

        return yearDiff * 4 + quarterDiff;
      }
      /***/

    },
    /* 319 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInISOWeekYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInCalendarISOWeekYears_index_js__ = __webpack_require__(139);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__subISOWeekYears_index_js__ = __webpack_require__(145);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInISOWeekYears
       * @category ISO Week-Numbering Year Helpers
       * @summary Get the number of full ISO week-numbering years between the given dates.
       *
       * @description
       * Get the number of full ISO week-numbering years between the given dates.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `differenceInISOYears` to `differenceInISOWeekYears`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full ISO week-numbering years
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
       * var result = differenceInISOWeekYears(
       *   new Date(2012, 0, 1),
       *   new Date(2010, 0, 1)
       * )
       * //=> 1
       */


      function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateRight);

        var sign = __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ](dateLeft, dateRight);

        var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_1__differenceInCalendarISOWeekYears_index_js__["a"
        /* default */
        ](dateLeft, dateRight));
        dateLeft = __WEBPACK_IMPORTED_MODULE_3__subISOWeekYears_index_js__["a"
        /* default */
        ](dateLeft, sign * difference); // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
        // if last calendar ISO year is not full
        // If so, result must be decreased by 1 in absolute value

        var isLastISOWeekYearNotFull = __WEBPACK_IMPORTED_MODULE_2__compareAsc_index_js__["a"
        /* default */
        ](dateLeft, dateRight) === -sign;
        var result = sign * (difference - isLastISOWeekYearNotFull); // Prevent negative zero

        return result === 0 ? 0 : result;
      }
      /***/

    },
    /* 320 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInQuarters;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInMonths_index_js__ = __webpack_require__(60);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInQuarters
       * @category Quarter Helpers
       * @summary Get the number of full quarters between the given dates.
       *
       * @description
       * Get the number of full quarters between the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full quarters
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full quarters are between 31 December 2013 and 2 July 2014?
       * var result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
       * //=> 2
       */


      function differenceInQuarters(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var diff = __WEBPACK_IMPORTED_MODULE_0__differenceInMonths_index_js__["a"
        /* default */
        ](dirtyDateLeft, dirtyDateRight) / 3;
        return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
      }
      /***/

    },
    /* 321 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = differenceInWeeks;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInDays_index_js__ = __webpack_require__(86);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name differenceInWeeks
       * @category Week Helpers
       * @summary Get the number of full weeks between the given dates.
       *
       * @description
       * Get the number of full weeks between two dates. Fractional weeks are
       * truncated towards zero.
       *
       * One "full week" is the distance between a local time in one day to the same
       * local time 7 days earlier or later. A full week can sometimes be less than
       * or more than 7*24 hours if a daylight savings change happens between two dates.
       *
       * To ignore DST and only measure exact 7*24-hour periods, use this instead:
       * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
       *
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the later date
       * @param {Date|Number} dateRight - the earlier date
       * @returns {Number} the number of full weeks
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // How many full weeks are between 5 July 2014 and 20 July 2014?
       * var result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
       * //=> 2
       *
       * // How many full weeks are between
       * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
       * // Note: because local time is used, the
       * // result will always be 8 weeks (54 days),
       * // even if DST starts and the period has
       * // only 54*24-1 hours.
       * var result = differenceInWeeks(
       *   new Date(2020, 5, 1),
       *   new Date(2020, 2, 6)
       * )
       * //=> 8
       */


      function differenceInWeeks(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var diff = __WEBPACK_IMPORTED_MODULE_0__differenceInDays_index_js__["a"
        /* default */
        ](dirtyDateLeft, dirtyDateRight) / 7;
        return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
      }
      /***/

    },
    /* 322 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachHourOfInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addHours_index_js__ = __webpack_require__(84);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachHourOfInterval
       * @category Interval Helpers
       * @summary Return the array of hours within the specified time interval.
       *
       * @description
       * Return the array of hours within the specified time interval.
       *
       * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
       * @param {Object} [options] - an object with options.
       * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
       * @returns {Date[]} the array with starts of hours from the hour of the interval start to the hour of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.step` must be a number greater than 1
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each hour between 6 October 2014, 12:00 and 10 October 2014, 15:00
       * var result = eachHourOfInterval({
       *   start: new Date(2014, 9, 6, 12),
       *   end: new Date(2014, 9, 6, 15)
       * })
       * //=> [
       * //   Mon Oct 06 2014 12:00:00,
       * //   Mon Oct 06 2014 13:00:00,
       * //   Mon Oct 06 2014 14:00:00,
       * //   Mon Oct 06 2014 15:00:00
       * // ]
       */


      function eachHourOfInterval(dirtyInterval, options) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var interval = dirtyInterval || {};

        var startDate = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](interval.start);

        var endDate = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](interval.end);

        var startTime = startDate.getTime();
        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startTime <= endTime)) {
          throw new RangeError('Invalid interval');
        }

        var dates = [];
        var currentDate = startDate;
        currentDate.setMinutes(0, 0, 0);
        var step = options && 'step' in options ? Number(options.step) : 1;
        if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

        while (currentDate.getTime() <= endTime) {
          dates.push(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
          /* default */
          ](currentDate));
          currentDate = __WEBPACK_IMPORTED_MODULE_0__addHours_index_js__["a"
          /* default */
          ](currentDate, step);
        }

        return dates;
      }
      /***/

    },
    /* 323 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachMonthOfInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachMonthOfInterval
       * @category Interval Helpers
       * @summary Return the array of months within the specified time interval.
       *
       * @description
       * Return the array of months within the specified time interval.
       *
       * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
       * @returns {Date[]} the array with starts of months from the month of the interval start to the month of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each month between 6 February 2014 and 10 August 2014:
       * var result = eachMonthOfInterval({
       *   start: new Date(2014, 1, 6),
       *   end: new Date(2014, 7, 10)
       * })
       * //=> [
       * //   Sat Feb 01 2014 00:00:00,
       * //   Sat Mar 01 2014 00:00:00,
       * //   Tue Apr 01 2014 00:00:00,
       * //   Thu May 01 2014 00:00:00,
       * //   Sun Jun 01 2014 00:00:00,
       * //   Tue Jul 01 2014 00:00:00,
       * //   Fri Aug 01 2014 00:00:00
       * // ]
       */


      function eachMonthOfInterval(dirtyInterval) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var interval = dirtyInterval || {};

        var startDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](interval.start);

        var endDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](interval.end);

        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError('Invalid interval');
        }

        var dates = [];
        var currentDate = startDate;
        currentDate.setHours(0, 0, 0, 0);
        currentDate.setDate(1);

        while (currentDate.getTime() <= endTime) {
          dates.push(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ](currentDate));
          currentDate.setMonth(currentDate.getMonth() + 1);
        }

        return dates;
      }
      /***/

    },
    /* 324 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachQuarterOfInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addQuarters_index_js__ = __webpack_require__(85);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfQuarter_index_js__ = __webpack_require__(87);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachQuarterOfInterval
       * @category Interval Helpers
       * @summary Return the array of quarters within the specified time interval.
       *
       * @description
       * Return the array of quarters within the specified time interval.
       *
       * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
       * @returns {Date[]} the array with starts of quarters from the quarter of the interval start to the quarter of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each quarter within interval 6 February 2014 - 10 August 2014:
       * var result = eachQuarterOfInterval({
       *   start: new Date(2014, 1, 6),
       *   end: new Date(2014, 7, 10)
       * })
       * //=> [
       * //   Wed Jan 01 2014 00:00:00,
       * //   Tue Apr 01 2014 00:00:00,
       * //   Tue Jul 01 2014 00:00:00,
       * // ]
       */


      function eachQuarterOfInterval(dirtyInterval) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var interval = dirtyInterval || {};

        var startDate = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](interval.start);

        var endDate = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](interval.end);

        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError('Invalid interval');
        }

        var startDateQuarter = __WEBPACK_IMPORTED_MODULE_1__startOfQuarter_index_js__["a"
        /* default */
        ](startDate);

        var endDateQuarter = __WEBPACK_IMPORTED_MODULE_1__startOfQuarter_index_js__["a"
        /* default */
        ](endDate);

        endTime = endDateQuarter.getTime();
        var quarters = [];
        var currentQuarter = startDateQuarter;

        while (currentQuarter.getTime() <= endTime) {
          quarters.push(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ](currentQuarter));
          currentQuarter = __WEBPACK_IMPORTED_MODULE_0__addQuarters_index_js__["a"
          /* default */
          ](currentQuarter, 1);
        }

        return quarters;
      }
      /***/

    },
    /* 325 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachWeekOfInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addWeeks_index_js__ = __webpack_require__(58);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__ = __webpack_require__(22);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachWeekOfInterval
       * @category Interval Helpers
       * @summary Return the array of weeks within the specified time interval.
       *
       * @description
       * Return the array of weeks within the specified time interval.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date[]} the array with starts of weeks from the week of the interval start to the week of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be 0, 1, ..., 6
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each week within interval 6 October 2014 - 23 November 2014:
       * var result = eachWeekOfInterval({
       *   start: new Date(2014, 9, 6),
       *   end: new Date(2014, 10, 23)
       * })
       * //=> [
       * //   Sun Oct 05 2014 00:00:00,
       * //   Sun Oct 12 2014 00:00:00,
       * //   Sun Oct 19 2014 00:00:00,
       * //   Sun Oct 26 2014 00:00:00,
       * //   Sun Nov 02 2014 00:00:00,
       * //   Sun Nov 09 2014 00:00:00,
       * //   Sun Nov 16 2014 00:00:00,
       * //   Sun Nov 23 2014 00:00:00
       * // ]
       */


      function eachWeekOfInterval(dirtyInterval, options) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var interval = dirtyInterval || {};

        var startDate = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](interval.start);

        var endDate = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](interval.end);

        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError('Invalid interval');
        }

        var startDateWeek = __WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__["a"
        /* default */
        ](startDate, options);

        var endDateWeek = __WEBPACK_IMPORTED_MODULE_1__startOfWeek_index_js__["a"
        /* default */
        ](endDate, options); // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet


        startDateWeek.setHours(15);
        endDateWeek.setHours(15);
        endTime = endDateWeek.getTime();
        var weeks = [];
        var currentWeek = startDateWeek;

        while (currentWeek.getTime() <= endTime) {
          currentWeek.setHours(0);
          weeks.push(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
          /* default */
          ](currentWeek));
          currentWeek = __WEBPACK_IMPORTED_MODULE_0__addWeeks_index_js__["a"
          /* default */
          ](currentWeek, 1);
          currentWeek.setHours(15);
        }

        return weeks;
      }
      /***/

    },
    /* 326 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachWeekendOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__ = __webpack_require__(88);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfMonth_index_js__ = __webpack_require__(62);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__ = __webpack_require__(89);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachWeekendOfMonth
       * @category Month Helpers
       * @summary List all the Saturdays and Sundays in the given month.
       *
       * @description
       * Get all the Saturdays and Sundays in the given month.
       *
       * @param {Date|Number} date - the given month
       * @returns {Date[]} an array containing all the Saturdays and Sundays
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The passed date is invalid
       *
       * @example
       * // Lists all Saturdays and Sundays in the given month
       * var result = eachWeekendOfMonth(new Date(2022, 1, 1))
       * //=> [
       * //   Sat Feb 05 2022 00:00:00,
       * //   Sun Feb 06 2022 00:00:00,
       * //   Sat Feb 12 2022 00:00:00,
       * //   Sun Feb 13 2022 00:00:00,
       * //   Sat Feb 19 2022 00:00:00,
       * //   Sun Feb 20 2022 00:00:00,
       * //   Sat Feb 26 2022 00:00:00,
       * //   Sun Feb 27 2022 00:00:00
       * // ]
       */


      function eachWeekendOfMonth(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var startDate = __WEBPACK_IMPORTED_MODULE_1__startOfMonth_index_js__["a"
        /* default */
        ](dirtyDate);

        if (isNaN(startDate)) throw new RangeError('The passed date is invalid');

        var endDate = __WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__["a"
        /* default */
        ](dirtyDate);

        return __WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__["a"
        /* default */
        ]({
          start: startDate,
          end: endDate
        });
      }
      /***/

    },
    /* 327 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachWeekendOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__ = __webpack_require__(88);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__ = __webpack_require__(90);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__endOfYear_index_js__ = __webpack_require__(149);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachWeekendOfYear
       * @category Year Helpers
       * @summary List all the Saturdays and Sundays in the year.
       *
       * @description
       * Get all the Saturdays and Sundays in the year.
       *
       * @param {Date|Number} date - the given year
       * @returns {Date[]} an array containing all the Saturdays and Sundays
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The passed date is invalid
       *
       * @example
       * // Lists all Saturdays and Sundays in the year
       * var result = eachWeekendOfYear(new Date(2020, 1, 1))
       * //=> [
       * //   Sat Jan 03 2020 00:00:00,
       * //   Sun Jan 04 2020 00:00:00,
       * //   ...
       * //   Sun Dec 27 2020 00:00:00
       * // ]
       * ]
       */


      function eachWeekendOfYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var startDate = __WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__["a"
        /* default */
        ](dirtyDate);

        if (isNaN(startDate)) throw new RangeError('The passed date is invalid');

        var endDate = __WEBPACK_IMPORTED_MODULE_2__endOfYear_index_js__["a"
        /* default */
        ](dirtyDate);

        return __WEBPACK_IMPORTED_MODULE_0__eachWeekendOfInterval_index_js__["a"
        /* default */
        ]({
          start: startDate,
          end: endDate
        });
      }
      /***/

    },
    /* 328 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = eachYearOfInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name eachYearOfInterval
       * @category Interval Helpers
       * @summary Return the array of yearly timestamps within the specified time interval.
       *
       * @description
       * Return the array of yearly timestamps within the specified time interval.
       *
       * @param {Interval} interval - the interval. See [Interval]{@link docs/types/Interval}
       * @returns {Date[]} the array with starts of yearly timestamps from the month of the interval start to the month of the interval end
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // Each year between 6 February 2014 and 10 August 2017:
       * var result = eachYearOfInterval({
       *   start: new Date(2014, 1, 6),
       *   end: new Date(2017, 7, 10)
       * })
       * //=> [
       * //   Wed Jan 01 2014 00:00:00,
       * //   Thu Jan 01 2015 00:00:00,
       * //   Fri Jan 01 2016 00:00:00,
       * //   Sun Jan 01 2017 00:00:00
       * // ]
       */


      function eachYearOfInterval(dirtyInterval) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var interval = dirtyInterval || {};

        var startDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](interval.start);

        var endDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](interval.end);

        var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

        if (!(startDate.getTime() <= endTime)) {
          throw new RangeError('Invalid interval');
        }

        var dates = [];
        var currentDate = startDate;
        currentDate.setHours(0, 0, 0, 0);
        currentDate.setMonth(0, 1);

        while (currentDate.getTime() <= endTime) {
          dates.push(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ](currentDate));
          currentDate.setFullYear(currentDate.getFullYear() + 1);
        }

        return dates;
      }
      /***/

    },
    /* 329 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfDecade;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfDecade
       * @category Decade Helpers
       * @summary Return the end of a decade for the given date.
       *
       * @description
       * Return the end of a decade for the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a decade
       * @param {Object} [options] - an object with options.
       * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
       *
       * @example
       * // The end of a decade for 12 May 1984 00:00:00:
       * var result = endOfDecade(new Date(1984, 4, 12, 00, 00, 00))
       * //=> Dec 31 1989 23:59:59.999
       */


      function endOfDecade(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        var decade = 9 + Math.floor(year / 10) * 10;
        date.setFullYear(decade, 11, 31);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    },
    /* 330 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfHour;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfHour
       * @category Hour Helpers
       * @summary Return the end of an hour for the given date.
       *
       * @description
       * Return the end of an hour for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of an hour
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of an hour for 2 September 2014 11:55:00:
       * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
       * //=> Tue Sep 02 2014 11:59:59.999
       */


      function endOfHour(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        date.setMinutes(59, 59, 999);
        return date;
      }
      /***/

    },
    /* 331 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__endOfWeek_index_js__ = __webpack_require__(150);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfISOWeek
       * @category ISO Week Helpers
       * @summary Return the end of an ISO week for the given date.
       *
       * @description
       * Return the end of an ISO week for the given date.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of an ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of an ISO week for 2 September 2014 11:55:00:
       * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sun Sep 07 2014 23:59:59.999
       */


      function endOfISOWeek(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__endOfWeek_index_js__["a"
        /* default */
        ](dirtyDate, {
          weekStartsOn: 1
        });
      }
      /***/

    },
    /* 332 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(34);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(25);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Return the end of an ISO week-numbering year for the given date.
       *
       * @description
       * Return the end of an ISO week-numbering year,
       * which always starts 3 days before the year's first Thursday.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `endOfISOYear` to `endOfISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `addWeekYears`.
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of an ISO week-numbering year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of an ISO week-numbering year for 2 July 2005:
       * var result = endOfISOWeekYear(new Date(2005, 6, 2))
       * //=> Sun Jan 01 2006 23:59:59.999
       */


      function endOfISOWeekYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var year = __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDate);

        var fourthOfJanuaryOfNextYear = new Date(0);
        fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
        fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);

        var date = __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ](fourthOfJanuaryOfNextYear);

        date.setMilliseconds(date.getMilliseconds() - 1);
        return date;
      }
      /***/

    },
    /* 333 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfMinute;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfMinute
       * @category Minute Helpers
       * @summary Return the end of a minute for the given date.
       *
       * @description
       * Return the end of a minute for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a minute
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a minute for 1 December 2014 22:15:45.400:
       * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
       * //=> Mon Dec 01 2014 22:15:59.999
       */


      function endOfMinute(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        date.setSeconds(59, 999);
        return date;
      }
      /***/

    },
    /* 334 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfQuarter
       * @category Quarter Helpers
       * @summary Return the end of a year quarter for the given date.
       *
       * @description
       * Return the end of a year quarter for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a quarter
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a quarter for 2 September 2014 11:55:00:
       * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 30 2014 23:59:59.999
       */


      function endOfQuarter(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var currentMonth = date.getMonth();
        var month = currentMonth - currentMonth % 3 + 3;
        date.setMonth(month, 0);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    },
    /* 335 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfSecond;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name endOfSecond
       * @category Second Helpers
       * @summary Return the end of a second for the given date.
       *
       * @description
       * Return the end of a second for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of a second
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The end of a second for 1 December 2014 22:15:45.400:
       * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
       * //=> Mon Dec 01 2014 22:15:45.999
       */


      function endOfSecond(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        date.setMilliseconds(999);
        return date;
      }
      /***/

    },
    /* 336 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfToday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__endOfDay_index_js__ = __webpack_require__(91);
      /**
       * @name endOfToday
       * @category Day Helpers
       * @summary Return the end of today.
       * @pure false
       *
       * @description
       * Return the end of today.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the end of today
       *
       * @example
       * // If today is 6 October 2014:
       * var result = endOfToday()
       * //=> Mon Oct 6 2014 23:59:59.999
       */


      function endOfToday() {
        return __WEBPACK_IMPORTED_MODULE_0__endOfDay_index_js__["a"
        /* default */
        ](Date.now());
      }
      /***/

    },
    /* 337 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfTomorrow;
      /**
       * @name endOfTomorrow
       * @category Day Helpers
       * @summary Return the end of tomorrow.
       * @pure false
       *
       * @description
       * Return the end of tomorrow.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `new Date()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the end of tomorrow
       *
       * @example
       * // If today is 6 October 2014:
       * var result = endOfTomorrow()
       * //=> Tue Oct 7 2014 23:59:59.999
       */

      function endOfTomorrow() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var day = now.getDate();
        var date = new Date(0);
        date.setFullYear(year, month, day + 1);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    },
    /* 338 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = endOfYesterday;
      /**
       * @name endOfYesterday
       * @category Day Helpers
       * @summary Return the end of yesterday.
       * @pure false
       *
       * @description
       * Return the end of yesterday.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `new Date()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the end of yesterday
       *
       * @example
       * // If today is 6 October 2014:
       * var result = endOfYesterday()
       * //=> Sun Oct 5 2014 23:59:59.999
       */

      function endOfYesterday() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var day = now.getDate();
        var date = new Date(0);
        date.setFullYear(year, month, day - 1);
        date.setHours(23, 59, 59, 999);
        return date;
      }
      /***/

    },
    /* 339 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 340 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__ = __webpack_require__(152);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_getUTCDayOfYear_index_js__ = __webpack_require__(341);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeek_index_js__ = __webpack_require__(153);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_getUTCISOWeekYear_index_js__ = __webpack_require__(154);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeek_index_js__ = __webpack_require__(155);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_getUTCWeekYear_index_js__ = __webpack_require__(92);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__ = __webpack_require__(38);

      var dayPeriodEnum = {
        am: 'am',
        pm: 'pm',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
        /*
         * |     | Unit                           |     | Unit                           |
         * |-----|--------------------------------|-----|--------------------------------|
         * |  a  | AM, PM                         |  A* | Milliseconds in day            |
         * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
         * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
         * |  d  | Day of month                   |  D  | Day of year                    |
         * |  e  | Local day of week              |  E  | Day of week                    |
         * |  f  |                                |  F* | Day of week in month           |
         * |  g* | Modified Julian day            |  G  | Era                            |
         * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
         * |  i! | ISO day of week                |  I! | ISO week of year               |
         * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
         * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
         * |  l* | (deprecated)                   |  L  | Stand-alone month              |
         * |  m  | Minute                         |  M  | Month                          |
         * |  n  |                                |  N  |                                |
         * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
         * |  p! | Long localized time            |  P! | Long localized date            |
         * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
         * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
         * |  s  | Second                         |  S  | Fraction of second             |
         * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
         * |  u  | Extended year                  |  U* | Cyclic year                    |
         * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
         * |  w  | Local week of year             |  W* | Week of month                  |
         * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
         * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
         * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
         *
         * Letters marked by * are not implemented but reserved by Unicode standard.
         *
         * Letters marked by ! are non-standard, but implemented by date-fns:
         * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
         * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
         *   i.e. 7 for Sunday, 1 for Monday, etc.
         * - `I` is ISO week of year, as opposed to `w` which is local week of year.
         * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
         *   `R` is supposed to be used in conjunction with `I` and `i`
         *   for universal ISO week-numbering date, whereas
         *   `Y` is supposed to be used in conjunction with `w` and `e`
         *   for week-numbering date specific to the locale.
         * - `P` is long localized date format
         * - `p` is long localized time format
         */

      };
      var formatters = {
        // Era
        G: function G(date, token, localize) {
          var era = date.getUTCFullYear() > 0 ? 1 : 0;

          switch (token) {
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
              return localize.era(era, {
                width: 'abbreviated'
              });
            // A, B

            case 'GGGGG':
              return localize.era(era, {
                width: 'narrow'
              });
            // Anno Domini, Before Christ

            case 'GGGG':
            default:
              return localize.era(era, {
                width: 'wide'
              });
          }
        },
        // Year
        y: function y(date, token, localize) {
          // Ordinal number
          if (token === 'yo') {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
              unit: 'year'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].y(date, token);
        },
        // Local week-numbering year
        Y: function Y(date, token, localize, options) {
          var signedWeekYear = __WEBPACK_IMPORTED_MODULE_5__lib_getUTCWeekYear_index_js__["a"
          /* default */
          ](date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)


          var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

          if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
            /* default */
            ](twoDigitYear, 2);
          } // Ordinal number


          if (token === 'Yo') {
            return localize.ordinalNumber(weekYear, {
              unit: 'year'
            });
          } // Padding


          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](weekYear, token.length);
        },
        // ISO week-numbering year
        R: function R(date, token) {
          var isoWeekYear = __WEBPACK_IMPORTED_MODULE_3__lib_getUTCISOWeekYear_index_js__["a"
          /* default */
          ](date); // Padding


          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](isoWeekYear, token.length);
        },
        // Extended year. This is a single number designating the year of this calendar system.
        // The main difference between `y` and `u` localizers are B.C. years:
        // | Year | `y` | `u` |
        // |------|-----|-----|
        // | AC 1 |   1 |   1 |
        // | BC 1 |   1 |   0 |
        // | BC 2 |   2 |  -1 |
        // Also `yy` always returns the last two digits of a year,
        // while `uu` pads single digit years to 2 characters and returns other years unchanged.
        u: function u(date, token) {
          var year = date.getUTCFullYear();
          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](year, token.length);
        },
        // Quarter
        Q: function Q(date, token, localize) {
          var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

          switch (token) {
            // 1, 2, 3, 4
            case 'Q':
              return String(quarter);
            // 01, 02, 03, 04

            case 'QQ':
              return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ](quarter, 2);
            // 1st, 2nd, 3rd, 4th

            case 'Qo':
              return localize.ordinalNumber(quarter, {
                unit: 'quarter'
              });
            // Q1, Q2, Q3, Q4

            case 'QQQ':
              return localize.quarter(quarter, {
                width: 'abbreviated',
                context: 'formatting'
              });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)

            case 'QQQQQ':
              return localize.quarter(quarter, {
                width: 'narrow',
                context: 'formatting'
              });
            // 1st quarter, 2nd quarter, ...

            case 'QQQQ':
            default:
              return localize.quarter(quarter, {
                width: 'wide',
                context: 'formatting'
              });
          }
        },
        // Stand-alone quarter
        q: function q(date, token, localize) {
          var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

          switch (token) {
            // 1, 2, 3, 4
            case 'q':
              return String(quarter);
            // 01, 02, 03, 04

            case 'qq':
              return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ](quarter, 2);
            // 1st, 2nd, 3rd, 4th

            case 'qo':
              return localize.ordinalNumber(quarter, {
                unit: 'quarter'
              });
            // Q1, Q2, Q3, Q4

            case 'qqq':
              return localize.quarter(quarter, {
                width: 'abbreviated',
                context: 'standalone'
              });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)

            case 'qqqqq':
              return localize.quarter(quarter, {
                width: 'narrow',
                context: 'standalone'
              });
            // 1st quarter, 2nd quarter, ...

            case 'qqqq':
            default:
              return localize.quarter(quarter, {
                width: 'wide',
                context: 'standalone'
              });
          }
        },
        // Month
        M: function M(date, token, localize) {
          var month = date.getUTCMonth();

          switch (token) {
            case 'M':
            case 'MM':
              return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
              /* default */
              ].M(date, token);
            // 1st, 2nd, ..., 12th

            case 'Mo':
              return localize.ordinalNumber(month + 1, {
                unit: 'month'
              });
            // Jan, Feb, ..., Dec

            case 'MMM':
              return localize.month(month, {
                width: 'abbreviated',
                context: 'formatting'
              });
            // J, F, ..., D

            case 'MMMMM':
              return localize.month(month, {
                width: 'narrow',
                context: 'formatting'
              });
            // January, February, ..., December

            case 'MMMM':
            default:
              return localize.month(month, {
                width: 'wide',
                context: 'formatting'
              });
          }
        },
        // Stand-alone month
        L: function L(date, token, localize) {
          var month = date.getUTCMonth();

          switch (token) {
            // 1, 2, ..., 12
            case 'L':
              return String(month + 1);
            // 01, 02, ..., 12

            case 'LL':
              return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ](month + 1, 2);
            // 1st, 2nd, ..., 12th

            case 'Lo':
              return localize.ordinalNumber(month + 1, {
                unit: 'month'
              });
            // Jan, Feb, ..., Dec

            case 'LLL':
              return localize.month(month, {
                width: 'abbreviated',
                context: 'standalone'
              });
            // J, F, ..., D

            case 'LLLLL':
              return localize.month(month, {
                width: 'narrow',
                context: 'standalone'
              });
            // January, February, ..., December

            case 'LLLL':
            default:
              return localize.month(month, {
                width: 'wide',
                context: 'standalone'
              });
          }
        },
        // Local week of year
        w: function w(date, token, localize, options) {
          var week = __WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeek_index_js__["a"
          /* default */
          ](date, options);

          if (token === 'wo') {
            return localize.ordinalNumber(week, {
              unit: 'week'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](week, token.length);
        },
        // ISO week of year
        I: function I(date, token, localize) {
          var isoWeek = __WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeek_index_js__["a"
          /* default */
          ](date);

          if (token === 'Io') {
            return localize.ordinalNumber(isoWeek, {
              unit: 'week'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](isoWeek, token.length);
        },
        // Day of the month
        d: function d(date, token, localize) {
          if (token === 'do') {
            return localize.ordinalNumber(date.getUTCDate(), {
              unit: 'date'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].d(date, token);
        },
        // Day of year
        D: function D(date, token, localize) {
          var dayOfYear = __WEBPACK_IMPORTED_MODULE_1__lib_getUTCDayOfYear_index_js__["a"
          /* default */
          ](date);

          if (token === 'Do') {
            return localize.ordinalNumber(dayOfYear, {
              unit: 'dayOfYear'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](dayOfYear, token.length);
        },
        // Day of week
        E: function E(date, token, localize) {
          var dayOfWeek = date.getUTCDay();

          switch (token) {
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
              return localize.day(dayOfWeek, {
                width: 'abbreviated',
                context: 'formatting'
              });
            // T

            case 'EEEEE':
              return localize.day(dayOfWeek, {
                width: 'narrow',
                context: 'formatting'
              });
            // Tu

            case 'EEEEEE':
              return localize.day(dayOfWeek, {
                width: 'short',
                context: 'formatting'
              });
            // Tuesday

            case 'EEEE':
            default:
              return localize.day(dayOfWeek, {
                width: 'wide',
                context: 'formatting'
              });
          }
        },
        // Local day of week
        e: function e(date, token, localize, options) {
          var dayOfWeek = date.getUTCDay();
          var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

          switch (token) {
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
              return String(localDayOfWeek);
            // Padded numerical value

            case 'ee':
              return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ](localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th

            case 'eo':
              return localize.ordinalNumber(localDayOfWeek, {
                unit: 'day'
              });

            case 'eee':
              return localize.day(dayOfWeek, {
                width: 'abbreviated',
                context: 'formatting'
              });
            // T

            case 'eeeee':
              return localize.day(dayOfWeek, {
                width: 'narrow',
                context: 'formatting'
              });
            // Tu

            case 'eeeeee':
              return localize.day(dayOfWeek, {
                width: 'short',
                context: 'formatting'
              });
            // Tuesday

            case 'eeee':
            default:
              return localize.day(dayOfWeek, {
                width: 'wide',
                context: 'formatting'
              });
          }
        },
        // Stand-alone local day of week
        c: function c(date, token, localize, options) {
          var dayOfWeek = date.getUTCDay();
          var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

          switch (token) {
            // Numerical value (same as in `e`)
            case 'c':
              return String(localDayOfWeek);
            // Padded numerical value

            case 'cc':
              return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ](localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th

            case 'co':
              return localize.ordinalNumber(localDayOfWeek, {
                unit: 'day'
              });

            case 'ccc':
              return localize.day(dayOfWeek, {
                width: 'abbreviated',
                context: 'standalone'
              });
            // T

            case 'ccccc':
              return localize.day(dayOfWeek, {
                width: 'narrow',
                context: 'standalone'
              });
            // Tu

            case 'cccccc':
              return localize.day(dayOfWeek, {
                width: 'short',
                context: 'standalone'
              });
            // Tuesday

            case 'cccc':
            default:
              return localize.day(dayOfWeek, {
                width: 'wide',
                context: 'standalone'
              });
          }
        },
        // ISO day of week
        i: function i(date, token, localize) {
          var dayOfWeek = date.getUTCDay();
          var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

          switch (token) {
            // 2
            case 'i':
              return String(isoDayOfWeek);
            // 02

            case 'ii':
              return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
              /* default */
              ](isoDayOfWeek, token.length);
            // 2nd

            case 'io':
              return localize.ordinalNumber(isoDayOfWeek, {
                unit: 'day'
              });
            // Tue

            case 'iii':
              return localize.day(dayOfWeek, {
                width: 'abbreviated',
                context: 'formatting'
              });
            // T

            case 'iiiii':
              return localize.day(dayOfWeek, {
                width: 'narrow',
                context: 'formatting'
              });
            // Tu

            case 'iiiiii':
              return localize.day(dayOfWeek, {
                width: 'short',
                context: 'formatting'
              });
            // Tuesday

            case 'iiii':
            default:
              return localize.day(dayOfWeek, {
                width: 'wide',
                context: 'formatting'
              });
          }
        },
        // AM or PM
        a: function a(date, token, localize) {
          var hours = date.getUTCHours();
          var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

          switch (token) {
            case 'a':
            case 'aa':
            case 'aaa':
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: 'abbreviated',
                context: 'formatting'
              });

            case 'aaaaa':
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: 'narrow',
                context: 'formatting'
              });

            case 'aaaa':
            default:
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: 'wide',
                context: 'formatting'
              });
          }
        },
        // AM, PM, midnight, noon
        b: function b(date, token, localize) {
          var hours = date.getUTCHours();
          var dayPeriodEnumValue;

          if (hours === 12) {
            dayPeriodEnumValue = dayPeriodEnum.noon;
          } else if (hours === 0) {
            dayPeriodEnumValue = dayPeriodEnum.midnight;
          } else {
            dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
          }

          switch (token) {
            case 'b':
            case 'bb':
            case 'bbb':
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: 'abbreviated',
                context: 'formatting'
              });

            case 'bbbbb':
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: 'narrow',
                context: 'formatting'
              });

            case 'bbbb':
            default:
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: 'wide',
                context: 'formatting'
              });
          }
        },
        // in the morning, in the afternoon, in the evening, at night
        B: function B(date, token, localize) {
          var hours = date.getUTCHours();
          var dayPeriodEnumValue;

          if (hours >= 17) {
            dayPeriodEnumValue = dayPeriodEnum.evening;
          } else if (hours >= 12) {
            dayPeriodEnumValue = dayPeriodEnum.afternoon;
          } else if (hours >= 4) {
            dayPeriodEnumValue = dayPeriodEnum.morning;
          } else {
            dayPeriodEnumValue = dayPeriodEnum.night;
          }

          switch (token) {
            case 'B':
            case 'BB':
            case 'BBB':
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: 'abbreviated',
                context: 'formatting'
              });

            case 'BBBBB':
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: 'narrow',
                context: 'formatting'
              });

            case 'BBBB':
            default:
              return localize.dayPeriod(dayPeriodEnumValue, {
                width: 'wide',
                context: 'formatting'
              });
          }
        },
        // Hour [1-12]
        h: function h(date, token, localize) {
          if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
              unit: 'hour'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].h(date, token);
        },
        // Hour [0-23]
        H: function H(date, token, localize) {
          if (token === 'Ho') {
            return localize.ordinalNumber(date.getUTCHours(), {
              unit: 'hour'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].H(date, token);
        },
        // Hour [0-11]
        K: function K(date, token, localize) {
          var hours = date.getUTCHours() % 12;

          if (token === 'Ko') {
            return localize.ordinalNumber(hours, {
              unit: 'hour'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](hours, token.length);
        },
        // Hour [1-24]
        k: function k(date, token, localize) {
          var hours = date.getUTCHours();
          if (hours === 0) hours = 24;

          if (token === 'ko') {
            return localize.ordinalNumber(hours, {
              unit: 'hour'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](hours, token.length);
        },
        // Minute
        m: function m(date, token, localize) {
          if (token === 'mo') {
            return localize.ordinalNumber(date.getUTCMinutes(), {
              unit: 'minute'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].m(date, token);
        },
        // Second
        s: function s(date, token, localize) {
          if (token === 'so') {
            return localize.ordinalNumber(date.getUTCSeconds(), {
              unit: 'second'
            });
          }

          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].s(date, token);
        },
        // Fraction of second
        S: function S(date, token) {
          return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a"
          /* default */
          ].S(date, token);
        },
        // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
        X: function X(date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timezoneOffset = originalDate.getTimezoneOffset();

          if (timezoneOffset === 0) {
            return 'Z';
          }

          switch (token) {
            // Hours and optional minutes
            case 'X':
              return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`

            case 'XXXX':
            case 'XX':
              // Hours and minutes without `:` delimiter
              return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`

            case 'XXXXX':
            case 'XXX': // Hours and minutes with `:` delimiter

            default:
              return formatTimezone(timezoneOffset, ':');
          }
        },
        // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
        x: function x(date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timezoneOffset = originalDate.getTimezoneOffset();

          switch (token) {
            // Hours and optional minutes
            case 'x':
              return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`

            case 'xxxx':
            case 'xx':
              // Hours and minutes without `:` delimiter
              return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`

            case 'xxxxx':
            case 'xxx': // Hours and minutes with `:` delimiter

            default:
              return formatTimezone(timezoneOffset, ':');
          }
        },
        // Timezone (GMT)
        O: function O(date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timezoneOffset = originalDate.getTimezoneOffset();

          switch (token) {
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
              return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long

            case 'OOOO':
            default:
              return 'GMT' + formatTimezone(timezoneOffset, ':');
          }
        },
        // Timezone (specific non-location)
        z: function z(date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timezoneOffset = originalDate.getTimezoneOffset();

          switch (token) {
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
              return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long

            case 'zzzz':
            default:
              return 'GMT' + formatTimezone(timezoneOffset, ':');
          }
        },
        // Seconds timestamp
        t: function t(date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timestamp = Math.floor(originalDate.getTime() / 1000);
          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](timestamp, token.length);
        },
        // Milliseconds timestamp
        T: function T(date, token, _localize, options) {
          var originalDate = options._originalDate || date;
          var timestamp = originalDate.getTime();
          return __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](timestamp, token.length);
        }
      };

      function formatTimezoneShort(offset, dirtyDelimiter) {
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);
        var hours = Math.floor(absOffset / 60);
        var minutes = absOffset % 60;

        if (minutes === 0) {
          return sign + String(hours);
        }

        var delimiter = dirtyDelimiter || '';
        return sign + String(hours) + delimiter + __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
        /* default */
        ](minutes, 2);
      }

      function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
        if (offset % 60 === 0) {
          var sign = offset > 0 ? '-' : '+';
          return sign + __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
          /* default */
          ](Math.abs(offset) / 60, 2);
        }

        return formatTimezone(offset, dirtyDelimiter);
      }

      function formatTimezone(offset, dirtyDelimiter) {
        var delimiter = dirtyDelimiter || '';
        var sign = offset > 0 ? '-' : '+';
        var absOffset = Math.abs(offset);

        var hours = __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
        /* default */
        ](Math.floor(absOffset / 60), 2);

        var minutes = __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a"
        /* default */
        ](absOffset % 60, 2);

        return sign + hours + delimiter + minutes;
      }
      /* harmony default export */


      __webpack_exports__["a"] = formatters;
      /***/
    },
    /* 341 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUTCDayOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376

      function getUTCDayOfYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var timestamp = date.getTime();
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
        var startOfYearTimestamp = date.getTime();
        var difference = timestamp - startOfYearTimestamp;
        return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
      }
      /***/

    },
    /* 342 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfUTCISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__ = __webpack_require__(154);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(63);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function startOfUTCISOWeekYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var year = __WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDate);

        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setUTCFullYear(year, 0, 4);
        fourthOfJanuary.setUTCHours(0, 0, 0, 0);

        var date = __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a"
        /* default */
        ](fourthOfJanuary);

        return date;
      }
      /***/

    },
    /* 343 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfUTCWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__getUTCWeekYear_index_js__ = __webpack_require__(92);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(50);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](options.firstWeekContainsDate);

        var year = __WEBPACK_IMPORTED_MODULE_1__getUTCWeekYear_index_js__["a"
        /* default */
        ](dirtyDate, dirtyOptions);

        var firstWeek = new Date(0);
        firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
        firstWeek.setUTCHours(0, 0, 0, 0);

        var date = __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a"
        /* default */
        ](firstWeek, dirtyOptions);

        return date;
      }
      /***/

    },
    /* 344 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistanceToNow;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__formatDistance_index_js__ = __webpack_require__(158);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name formatDistanceToNow
       * @category Common Helpers
       * @summary Return the distance between the given date and now in words.
       * @pure false
       *
       * @description
       * Return the distance between the given date and now in words.
       *
       * | Distance to now                                                   | Result              |
       * |-------------------------------------------------------------------|---------------------|
       * | 0 ... 30 secs                                                     | less than a minute  |
       * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
       * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
       * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
       * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
       * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
       * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
       * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
       * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
       * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
       * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
       * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
       * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
       * | N yrs ... N yrs 3 months                                          | about N years       |
       * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
       * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
       *
       * With `options.includeSeconds == true`:
       * | Distance to now     | Result               |
       * |---------------------|----------------------|
       * | 0 secs ... 5 secs   | less than 5 seconds  |
       * | 5 secs ... 10 secs  | less than 10 seconds |
       * | 10 secs ... 20 secs | less than 20 seconds |
       * | 20 secs ... 40 secs | half a minute        |
       * | 40 secs ... 60 secs | less than a minute   |
       * | 60 secs ... 90 secs | 1 minute             |
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `distanceInWordsToNow ` to `formatDistanceToNow`
       *   to make its name consistent with `format` and `formatRelative`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   distanceInWordsToNow(new Date(2014, 6, 2), { addSuffix: true })
       *   //=> 'in 6 months'
       *
       *   // v2.0.0 onward
       *
       *   formatDistanceToNow(new Date(2014, 6, 2), { addSuffix: true })
       *   //=> 'in 6 months'
       *   ```
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - the object with options
       * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
       * @param {Boolean} [options.addSuffix=false] - result specifies if now is earlier or later than the passed date
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {String} the distance in words
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.locale` must contain `formatDistance` property
       *
       * @example
       * // If today is 1 January 2015, what is the distance to 2 July 2014?
       * var result = formatDistanceToNow(
       *   new Date(2014, 6, 2)
       * )
       * //=> '6 months'
       *
       * @example
       * // If now is 1 January 2015 00:00:00,
       * // what is the distance to 1 January 2015 00:00:15, including seconds?
       * var result = formatDistanceToNow(
       *   new Date(2015, 0, 1, 0, 0, 15),
       *   {includeSeconds: true}
       * )
       * //=> 'less than 20 seconds'
       *
       * @example
       * // If today is 1 January 2015,
       * // what is the distance to 1 January 2016, with a suffix?
       * var result = formatDistanceToNow(
       *   new Date(2016, 0, 1),
       *   {addSuffix: true}
       * )
       * //=> 'in about 1 year'
       *
       * @example
       * // If today is 1 January 2015,
       * // what is the distance to 1 August 2016 in Esperanto?
       * var eoLocale = require('date-fns/locale/eo')
       * var result = formatDistanceToNow(
       *   new Date(2016, 7, 1),
       *   {locale: eoLocale}
       * )
       * //=> 'pli ol 1 jaro'
       */


      function formatDistanceToNow(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__formatDistance_index_js__["a"
        /* default */
        ](dirtyDate, Date.now(), dirtyOptions);
      }
      /***/

    },
    /* 345 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistanceToNowStrict;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__formatDistanceStrict_index_js__ = __webpack_require__(161);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name formatDistanceToNowStrict
       * @category Common Helpers
       * @summary Return the distance between the given date and now in words.
       * @pure false
       *
       * @description
       * Return the distance between the given dates in words, using strict units.
       * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
       * 'less than' and the like.
       *
       * | Distance between dates | Result              |
       * |------------------------|---------------------|
       * | 0 ... 59 secs          | [0..59] seconds     |
       * | 1 ... 59 mins          | [1..59] minutes     |
       * | 1 ... 23 hrs           | [1..23] hours       |
       * | 1 ... 29 days          | [1..29] days        |
       * | 1 ... 11 months        | [1..11] months      |
       * | 1 ... N years          | [1..N]  years       |
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
       * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
       * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {String} the distance in words
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.locale` must contain `formatDistance` property
       *
       * @example
       * // If today is 1 January 2015, what is the distance to 2 July 2014?
       * var result = formatDistanceToNowStrict(
       *   new Date(2014, 6, 2)
       * )
       * //=> '6 months'
       *
       * @example
       * // If now is 1 January 2015 00:00:00,
       * // what is the distance to 1 January 2015 00:00:15, including seconds?
       * var result = formatDistanceToNowStrict(
       *   new Date(2015, 0, 1, 0, 0, 15)
       * )
       * //=> '20 seconds'
       *
       * @example
       * // If today is 1 January 2015,
       * // what is the distance to 1 January 2016, with a suffix?
       * var result = formatDistanceToNowStrict(
       *   new Date(2016, 0, 1),
       *   {addSuffix: true}
       * )
       * //=> 'in 1 year'
       *
       * @example
       * // If today is 28 January 2015,
       * // what is the distance to 1 January 2015, in months, rounded up??
       * var result = formatDistanceToNowStrict(new Date(2015, 0, 1), {
       *   unit: 'month',
       *   roundingMethod: 'ceil'
       * })
       * //=> '1 month'
       *
       * @example
       * // If today is 1 January 2015,
       * // what is the distance to 1 August 2016 in Esperanto?
       * var eoLocale = require('date-fns/locale/eo')
       * var result = formatDistanceToNowStrict(
       *   new Date(2016, 7, 1),
       *   {locale: eoLocale}
       * )
       * //=> '1 jaro'
       */


      function formatDistanceToNowStrict(dirtyDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__formatDistanceStrict_index_js__["a"
        /* default */
        ](dirtyDate, Date.now(), dirtyOptions);
      }
      /***/

    },
    /* 346 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDuration;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__ = __webpack_require__(28);

      var defaultFormat = ['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds'];
      /**
       * @name formatDuration
       * @category Common Helpers
       * @summary Formats a duration in human-readable format
       *
       * @description
       * Return human-readable duration string i.e. "9 months 2 days"
       *
       * @param {Duration} duration - the duration to format
       * @param {Object} [options] - an object with options.
      
       * @param {string[]} [options.format=['years', 'months', 'weeks', 'days', 'hours', 'minutes', 'seconds']] - the array of units to format
       * @param {boolean} [options.zero=false] - should be zeros be included in the output?
       * @param {string} [options.delimiter=' '] - delimiter string
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @returns {string} the formatted date string
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Format full duration
       * formatDuration({
       *   years: 2,
       *   months: 9,
       *   weeks: 1,
       *   days: 7,
       *   hours: 5,
       *   minutes: 9,
       *   seconds: 30
       * })
       * //=> '2 years 9 months 1 week 7 days 5 hours 9 minutes 30 seconds
       *
       * @example
       * // Format partial duration
       * formatDuration({ months: 9, days: 2 })
       * //=> '9 months 2 days'
       *
       * @example
       * // Customize the format
       * formatDuration(
       *   {
       *     years: 2,
       *     months: 9,
       *     weeks: 1,
       *     days: 7,
       *     hours: 5,
       *     minutes: 9,
       *     seconds: 30
       *   },
       *   { format: ['months', 'weeks'] }
       * ) === '9 months 1 week'
       *
       * @example
       * // Customize the zeros presence
       * formatDuration({ years: 0, months: 9 })
       * //=> '9 months'
       * formatDuration({ years: 0, months: 9 }, null, { zero: true })
       * //=> '0 years 9 months'
       *
       * @example
       * // Customize the delimiter
       * formatDuration({ years: 2, months: 9, weeks: 3 }, { delimiter: ', ' })
       * //=> '2 years, 9 months, 3 weeks'
       */

      function formatDuration(duration) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (arguments.length < 1) {
          throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
        }

        var format = options.format || defaultFormat;
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__["a"
        /* default */
        ];
        var zero = options.zero || false;
        var delimiter = options.delimiter || ' ';
        var result = format.reduce(function (acc, unit) {
          var token = "x".concat(unit.replace(/(^.)/, function (m) {
            return m.toUpperCase();
          }));
          var addChunk = typeof duration[unit] === 'number' && (zero || duration[unit]);
          return addChunk ? acc.concat(locale.formatDistance(token, duration[unit])) : acc;
        }, []).join(delimiter);
        return result;
      }
      /***/

    },
    /* 347 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatISO;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(15);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(38);
      /**
       * @name formatISO
       * @category Common Helpers
       * @summary Format the date according to the ISO 8601 standard (http://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
       *
       * @description
       * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
       * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with time zone, or both.
       * @returns {String} the formatted date string
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.format` must be 'extended' or 'basic'
       * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
       *
       * @example
       * // Represent 18 September 2019 in ISO 8601 format (UTC):
       * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
       * //=> '2019-09-18T19:00:52Z'
       *
       * @example
       * // Represent 18 September 2019 in ISO 8601, short format (UTC):
       * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
       * //=> '20190918T190052'
       *
       * @example
       * // Represent 18 September 2019 in ISO 8601 format, date only:
       * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
       * //=> '2019-09-18'
       *
       * @example
       * // Represent 18 September 2019 in ISO 8601 format, time only (UTC):
       * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
       * //=> '19:00:52Z'
       */


      function formatISO(dirtyDate, dirtyOptions) {
        if (arguments.length < 1) {
          throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
        }

        var originalDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        if (!__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ](originalDate)) {
          throw new RangeError('Invalid time value');
        }

        var options = dirtyOptions || {};
        var format = options.format == null ? 'extended' : String(options.format);
        var representation = options.representation == null ? 'complete' : String(options.representation);

        if (format !== 'extended' && format !== 'basic') {
          throw new RangeError("format must be 'extended' or 'basic'");
        }

        if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
          throw new RangeError("representation must be 'date', 'time', or 'complete'");
        }

        var result = '';
        var tzOffset = '';
        var dateDelimiter = format === 'extended' ? '-' : '';
        var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

        if (representation !== 'time') {
          var day = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getDate(), 2);

          var month = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getMonth() + 1, 2);

          var year = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.


          result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
        } // Representation is either 'time' or 'complete'


        if (representation !== 'date') {
          // Add the timezone.
          var offset = originalDate.getTimezoneOffset();

          if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);

            var hourOffset = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
            /* default */
            ](Math.floor(absoluteOffset / 60), 2);

            var minuteOffset = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
            /* default */
            ](absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.


            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
          } else {
            tzOffset = 'Z';
          }

          var hour = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getHours(), 2);

          var minute = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getMinutes(), 2);

          var second = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'


          var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

          var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

          result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
        }

        return result;
      }
      /***/

    },
    /* 348 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatISO9075;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(15);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(38);
      /**
       * @name formatISO9075
       * @category Common Helpers
       * @summary Format the date according to the ISO 9075 standard (https://dev.mysql.com/doc/refman/5.7/en/date-and-time-functions.html#function_get-format).
       *
       * @description
       * Return the formatted date string in ISO 9075 format. Options may be passed to control the parts and notations of the date.
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
       * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time, or both.
       * @returns {String} the formatted date string
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.format` must be 'extended' or 'basic'
       * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
       *
       * @example
       * // Represent 18 September 2019 in ISO 9075 format:
       * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52))
       * //=> '2019-09-18 19:00:52'
       *
       * @example
       * // Represent 18 September 2019 in ISO 9075, short format:
       * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
       * //=> '20190918 190052'
       *
       * @example
       * // Represent 18 September 2019 in ISO 9075 format, date only:
       * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
       * //=> '2019-09-18'
       *
       * @example
       * // Represent 18 September 2019 in ISO 9075 format, time only:
       * const result = formatISO9075(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
       * //=> '19:00:52'
       */


      function formatISO9075(dirtyDate, dirtyOptions) {
        if (arguments.length < 1) {
          throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
        }

        var originalDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        if (!__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ](originalDate)) {
          throw new RangeError('Invalid time value');
        }

        var options = dirtyOptions || {};
        var format = options.format == null ? 'extended' : String(options.format);
        var representation = options.representation == null ? 'complete' : String(options.representation);

        if (format !== 'extended' && format !== 'basic') {
          throw new RangeError("format must be 'extended' or 'basic'");
        }

        if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
          throw new RangeError("representation must be 'date', 'time', or 'complete'");
        }

        var result = '';
        var dateDelimiter = format === 'extended' ? '-' : '';
        var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

        if (representation !== 'time') {
          var day = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getDate(), 2);

          var month = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getMonth() + 1, 2);

          var year = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.


          result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
        } // Representation is either 'time' or 'complete'


        if (representation !== 'date') {
          var hour = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getHours(), 2);

          var minute = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getMinutes(), 2);

          var second = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](originalDate.getSeconds(), 2); // If there's also date, separate it with time with a space


          var separator = result === '' ? '' : ' '; // HHmmss or HH:mm:ss.

          result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
        }

        return result;
      }
      /***/

    },
    /* 349 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatISODuration;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name formatISODuration
       * @category Common Helpers
       * @summary Format a duration object according as ISO 8601 duration string
       *
       * @description
       * Format a duration object according to the ISO 8601 duration standard (https://www.digi.com/resources/documentation/digidocs/90001437-13/reference/r_iso_8601_duration_format.htm)
       *
       * @param {Duration} duration - the duration to format
       *
       * @returns {String} The ISO 8601 duration string
       * @throws {TypeError} Requires 1 argument
       * @throws {Error} Argument must be an object
       *
       * @example
       * // Format the given duration as ISO 8601 string
       * formatISODuration({
       *   years: 39,
       *   months: 2,
       *   days: 20,
       *   hours: 7,
       *   minutes: 5,
       *   seconds: 0
       * })
       * //=> 'P39Y2M20DT0H0M0S'
       */


      function formatISODuration(duration) {
        __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        if (typeof duration !== 'object') throw new Error('Duration must be an object');
        var _duration$years = duration.years,
            years = _duration$years === void 0 ? 0 : _duration$years,
            _duration$months = duration.months,
            months = _duration$months === void 0 ? 0 : _duration$months,
            _duration$days = duration.days,
            days = _duration$days === void 0 ? 0 : _duration$days,
            _duration$hours = duration.hours,
            hours = _duration$hours === void 0 ? 0 : _duration$hours,
            _duration$minutes = duration.minutes,
            minutes = _duration$minutes === void 0 ? 0 : _duration$minutes,
            _duration$seconds = duration.seconds,
            seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
        return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
      }
      /***/

    },
    /* 350 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRFC3339;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(15);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(38);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(6);
      /**
       * @name formatRFC3339
       * @category Common Helpers
       * @summary Format the date according to the ISO 3339 standard (https://tools.ietf.org/html/rfc3339#section-5.6).
       *
       * @description
       * Return the formatted date string in ISO 3339 format. Options may be passed to control the parts and notations of the date.
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {0|1|2|3} [options.fractionDigits=0] - number of digits after the decimal point after seconds
       * @returns {String} the formatted date string
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `options.fractionDigits` must be between 0 and 3
       *
       * @example
       * // Represent 18 September 2019 in ISO 3339 format:
       * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52))
       * //=> '2019-09-18T19:00:52Z'
       *
       * @example
       * // Represent 18 September 2019 in ISO 3339 format, 2 digits of second fraction:
       * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 2 })
       * //=> '2019-09-18T19:00:52.23Z'
       *
       * @example
       * // Represent 18 September 2019 in ISO 3339 format, 3 digits of second fraction
       * const result = formatRFC3339(new Date(2019, 8, 18, 19, 0, 52, 234), { fractionDigits: 3 })
       * //=> '2019-09-18T19:00:52.234Z'
       */


      function formatRFC3339(dirtyDate, dirtyOptions) {
        if (arguments.length < 1) {
          throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
        }

        var originalDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        if (!__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ](originalDate)) {
          throw new RangeError('Invalid time value');
        }

        var options = dirtyOptions || {};
        var fractionDigits = options.fractionDigits == null ? 0 : __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ](options.fractionDigits); // Test if fractionDigits is between 0 and 3 _and_ is not NaN

        if (!(fractionDigits >= 0 && fractionDigits <= 3)) {
          throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
        }

        var day = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ](originalDate.getDate(), 2);

        var month = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ](originalDate.getMonth() + 1, 2);

        var year = originalDate.getFullYear();

        var hour = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ](originalDate.getHours(), 2);

        var minute = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ](originalDate.getMinutes(), 2);

        var second = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ](originalDate.getSeconds(), 2);

        var fractionalSecond = '';

        if (fractionDigits > 0) {
          var milliseconds = originalDate.getMilliseconds();
          var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
          fractionalSecond = '.' + __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](fractionalSeconds, fractionDigits);
        }

        var offset = '';
        var tzOffset = originalDate.getTimezoneOffset();

        if (tzOffset !== 0) {
          var absoluteOffset = Math.abs(tzOffset);

          var hourOffset = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](__WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
          /* default */
          ](absoluteOffset / 60), 2);

          var minuteOffset = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
          /* default */
          ](absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.


          var sign = tzOffset < 0 ? '+' : '-';
          offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else {
          offset = 'Z';
        }

        return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
      }
      /***/

    },
    /* 351 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRFC7231;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(15);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__ = __webpack_require__(38);

      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      /**
       * @name formatRFC7231
       * @category Common Helpers
       * @summary Format the date according to the RFC 7231 standard (https://tools.ietf.org/html/rfc7231#section-7.1.1.1).
       *
       * @description
       * Return the formatted date string in RFC 7231 format.
       * The result will always be in UTC timezone.
       *
       * @param {Date|Number} date - the original date
       * @returns {String} the formatted date string
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `date` must not be Invalid Date
       *
       * @example
       * // Represent 18 September 2019 in RFC 7231 format:
       * const result = formatRFC7231(new Date(2019, 8, 18, 19, 0, 52))
       * //=> 'Wed, 18 Sep 2019 19:00:52 GMT'
       */

      function formatRFC7231(dirtyDate) {
        if (arguments.length < 1) {
          throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
        }

        var originalDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        if (!__WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ](originalDate)) {
          throw new RangeError('Invalid time value');
        }

        var dayName = days[originalDate.getUTCDay()];

        var dayOfMonth = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ](originalDate.getUTCDate(), 2);

        var monthName = months[originalDate.getUTCMonth()];
        var year = originalDate.getUTCFullYear();

        var hour = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ](originalDate.getUTCHours(), 2);

        var minute = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ](originalDate.getUTCMinutes(), 2);

        var second = __WEBPACK_IMPORTED_MODULE_2__lib_addLeadingZeros_index_js__["a"
        /* default */
        ](originalDate.getUTCSeconds(), 2); // Result variables.


        return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
      }
      /***/

    },
    /* 352 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__ = __webpack_require__(26);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__format_index_js__ = __webpack_require__(151);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__ = __webpack_require__(28);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__ = __webpack_require__(49);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name formatRelative
       * @category Common Helpers
       * @summary Represent the date in words relative to the given base date.
       *
       * @description
       * Represent the date in words relative to the given base date.
       *
       * | Distance to the base date | Result                    |
       * |---------------------------|---------------------------|
       * | Previous 6 days           | last Sunday at 04:30 AM   |
       * | Last day                  | yesterday at 04:30 AM     |
       * | Same day                  | today at 04:30 AM         |
       * | Next day                  | tomorrow at 04:30 AM      |
       * | Next 6 days               | Sunday at 04:30 AM        |
       * | Other                     | 12/31/2017                |
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to format
       * @param {Date|Number} baseDate - the date to compare with
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {String} the date in words
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `date` must not be Invalid Date
       * @throws {RangeError} `baseDate` must not be Invalid Date
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.locale` must contain `localize` property
       * @throws {RangeError} `options.locale` must contain `formatLong` property
       * @throws {RangeError} `options.locale` must contain `formatRelative` property
       */


      function formatRelative(dirtyDate, dirtyBaseDate, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_6__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var baseDate = __WEBPACK_IMPORTED_MODULE_4__toDate_index_js__["a"
        /* default */
        ](dirtyBaseDate);

        var options = dirtyOptions || {};
        var locale = options.locale || __WEBPACK_IMPORTED_MODULE_2__locale_en_US_index_js__["a"
        /* default */
        ];

        if (!locale.localize) {
          throw new RangeError('locale must contain localize property');
        }

        if (!locale.formatLong) {
          throw new RangeError('locale must contain formatLong property');
        }

        if (!locale.formatRelative) {
          throw new RangeError('locale must contain formatRelative property');
        }

        var diff = __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__["a"
        /* default */
        ](date, baseDate);

        if (isNaN(diff)) {
          throw new RangeError('Invalid time value');
        }

        var token;

        if (diff < -6) {
          token = 'other';
        } else if (diff < -1) {
          token = 'lastWeek';
        } else if (diff < 0) {
          token = 'yesterday';
        } else if (diff < 1) {
          token = 'today';
        } else if (diff < 2) {
          token = 'tomorrow';
        } else if (diff < 7) {
          token = 'nextWeek';
        } else {
          token = 'other';
        }

        var utcDate = __WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__["a"
        /* default */
        ](date, __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](date));

        var utcBaseDate = __WEBPACK_IMPORTED_MODULE_3__subMilliseconds_index_js__["a"
        /* default */
        ](baseDate, __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](baseDate));

        var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, options);
        return __WEBPACK_IMPORTED_MODULE_1__format_index_js__["a"
        /* default */
        ](date, formatStr, options);
      }
      /***/

    },
    /* 353 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = fromUnixTime;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name fromUnixTime
       * @category Timestamp Helpers
       * @summary Create a date from a Unix timestamp.
       *
       * @description
       * Create a date from a Unix timestamp.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Number} unixTime - the given Unix timestamp
       * @returns {Date} the date
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Create the date 29 February 2012 11:45:05:
       * var result = fromUnixTime(1330515905)
       * //=> Wed Feb 29 2012 11:45:05
       */


      function fromUnixTime(dirtyUnixTime) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var unixTime = __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyUnixTime);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](unixTime * 1000);
      }
      /***/

    },
    /* 354 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getDayOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__ = __webpack_require__(90);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__ = __webpack_require__(26);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDayOfYear
       * @category Day Helpers
       * @summary Get the day of the year of the given date.
       *
       * @description
       * Get the day of the year of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the day of year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which day of the year is 2 July 2014?
       * var result = getDayOfYear(new Date(2014, 6, 2))
       * //=> 183
       */


      function getDayOfYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var diff = __WEBPACK_IMPORTED_MODULE_2__differenceInCalendarDays_index_js__["a"
        /* default */
        ](date, __WEBPACK_IMPORTED_MODULE_1__startOfYear_index_js__["a"
        /* default */
        ](date));

        var dayOfYear = diff + 1;
        return dayOfYear;
      }
      /***/

    },
    /* 355 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getDaysInYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isLeapYear_index_js__ = __webpack_require__(165);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDaysInYear
       * @category Year Helpers
       * @summary Get the number of days in a year of the given date.
       *
       * @description
       * Get the number of days in a year of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the number of days in a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // How many days are in 2012?
       * var result = getDaysInYear(new Date(2012, 0, 1))
       * //=> 366
       */


      function getDaysInYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        if (isNaN(date)) {
          return NaN;
        }

        return __WEBPACK_IMPORTED_MODULE_1__isLeapYear_index_js__["a"
        /* default */
        ](date) ? 366 : 365;
      }
      /***/

    },
    /* 356 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getDecade;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getDecade
       * @category Decade Helpers
       * @summary Get the decade of the given date.
       *
       * @description
       * Get the decade of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the year of decade
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which decade belongs 27 November 1942?
       * var result = getDecade(new Date(1942, 10, 27))
       * //=> 1940
       */


      function getDecade(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        var decade = Math.floor(year / 10) * 10;
        return decade;
      }
      /***/

    },
    /* 357 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getHours;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getHours
       * @category Hour Helpers
       * @summary Get the hours of the given date.
       *
       * @description
       * Get the hours of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the hours
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the hours of 29 February 2012 11:45:00:
       * var result = getHours(new Date(2012, 1, 29, 11, 45))
       * //=> 11
       */


      function getHours(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var hours = date.getHours();
        return hours;
      }
      /***/

    },
    /* 358 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getISOWeeksInYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__ = __webpack_require__(46);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(58);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_WEEK = 604800000;
      /**
       * @name getISOWeeksInYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Get the number of weeks in an ISO week-numbering year of the given date.
       *
       * @description
       * Get the number of weeks in an ISO week-numbering year of the given date.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the number of ISO weeks in a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // How many weeks are in ISO week-numbering year 2015?
       * var result = getISOWeeksInYear(new Date(2015, 1, 11))
       * //=> 53
       */

      function getISOWeeksInYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var thisYear = __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDate);

        var nextYear = __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a"
        /* default */
        ](__WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["a"
        /* default */
        ](thisYear, 60));

        var diff = nextYear.valueOf() - thisYear.valueOf(); // Round the number of weeks to the nearest integer
        // because the number of milliseconds in a week is not constant
        // (e.g. it's different in the week of the daylight saving time clock shift)

        return Math.round(diff / MILLISECONDS_IN_WEEK);
      }
      /***/

    },
    /* 359 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getMilliseconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getMilliseconds
       * @category Millisecond Helpers
       * @summary Get the milliseconds of the given date.
       *
       * @description
       * Get the milliseconds of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the milliseconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the milliseconds of 29 February 2012 11:45:05.123:
       * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
       * //=> 123
       */


      function getMilliseconds(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var milliseconds = date.getMilliseconds();
        return milliseconds;
      }
      /***/

    },
    /* 360 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getMinutes;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getMinutes
       * @category Minute Helpers
       * @summary Get the minutes of the given date.
       *
       * @description
       * Get the minutes of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the minutes
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the minutes of 29 February 2012 11:45:05:
       * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
       * //=> 45
       */


      function getMinutes(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var minutes = date.getMinutes();
        return minutes;
      }
      /***/

    },
    /* 361 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getMonth
       * @category Month Helpers
       * @summary Get the month of the given date.
       *
       * @description
       * Get the month of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which month is 29 February 2012?
       * var result = getMonth(new Date(2012, 1, 29))
       * //=> 1
       */


      function getMonth(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var month = date.getMonth();
        return month;
      }
      /***/

    },
    /* 362 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getOverlappingDaysInIntervals;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
      /**
       * @name getOverlappingDaysInIntervals
       * @category Interval Helpers
       * @summary Get the number of days that overlap in two time intervals
       *
       * @description
       * Get the number of days that overlap in two time intervals
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `getOverlappingDaysInRanges` to `getOverlappingDaysInIntervals`.
       *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
       *
       *   ```
       *   2.1.3
       *   time interval
       *   part of the time axis limited by two instants
       *   ```
       *
       *   Also, this function now accepts an object with `start` and `end` properties
       *   instead of two arguments as an interval.
       *   This function now throws `RangeError` if the start of the interval is after its end
       *   or if any date in the interval is `Invalid Date`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   getOverlappingDaysInRanges(
       *     new Date(2014, 0, 10), new Date(2014, 0, 20),
       *     new Date(2014, 0, 17), new Date(2014, 0, 21)
       *   )
       *
       *   // v2.0.0 onward
       *
       *   getOverlappingDaysInIntervals(
       *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *     { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
       *   )
       *   ```
       *
       * @param {Interval} intervalLeft - the first interval to compare. See [Interval]{@link docs/Interval}
       * @param {Interval} intervalRight - the second interval to compare. See [Interval]{@link docs/Interval}
       * @returns {Number} the number of days that overlap in two time intervals
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // For overlapping time intervals adds 1 for each started overlapping day:
       * getOverlappingDaysInIntervals(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 17), end: new Date(2014, 0, 21) }
       * )
       * //=> 3
       *
       * @example
       * // For non-overlapping time intervals returns 0:
       * getOverlappingDaysInIntervals(
       *   { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) },
       *   { start: new Date(2014, 0, 21), end: new Date(2014, 0, 22) }
       * )
       * //=> 0
       */

      function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var intervalLeft = dirtyIntervalLeft || {};
        var intervalRight = dirtyIntervalRight || {};

        var leftStartTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](intervalLeft.start).getTime();

        var leftEndTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](intervalLeft.end).getTime();

        var rightStartTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](intervalRight.start).getTime();

        var rightEndTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](intervalRight.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`


        if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) {
          throw new RangeError('Invalid interval');
        }

        var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;

        if (!isOverlapping) {
          return 0;
        }

        var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
        var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
        var differenceInMs = overlapEndDate - overlapStartDate;
        return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
      }
      /***/

    },
    /* 363 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getSeconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getSeconds
       * @category Second Helpers
       * @summary Get the seconds of the given date.
       *
       * @description
       * Get the seconds of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the seconds
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the seconds of 29 February 2012 11:45:05.123:
       * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
       * //=> 5
       */


      function getSeconds(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var seconds = date.getSeconds();
        return seconds;
      }
      /***/

    },
    /* 364 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getUnixTime;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getTime_index_js__ = __webpack_require__(168);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getUnixTime
       * @category Timestamp Helpers
       * @summary Get the seconds timestamp of the given date.
       *
       * @description
       * Get the seconds timestamp of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the timestamp
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Get the timestamp of 29 February 2012 11:45:05 CET:
       * var result = getUnixTime(new Date(2012, 1, 29, 11, 45, 5))
       * //=> 1330512305
       */


      function getUnixTime(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return Math.floor(__WEBPACK_IMPORTED_MODULE_0__getTime_index_js__["a"
        /* default */
        ](dirtyDate) / 1000);
      }
      /***/

    },
    /* 365 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getWeekOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getDate_index_js__ = __webpack_require__(162);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__getDay_index_js__ = __webpack_require__(163);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__ = __webpack_require__(62);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getWeekOfMonth
       * @category Week Helpers
       * @summary Get the week of the month of the given date.
       *
       * @description
       * Get the week of the month of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Number} the week of month
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // Which week of the month is 9 November 2017?
       * var result = getWeekOfMonth(new Date(2017, 10, 9))
       * //=> 2
       */


      function getWeekOfMonth(date, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ](localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ](options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        }

        var currentDayOfMonth = __WEBPACK_IMPORTED_MODULE_0__getDate_index_js__["a"
        /* default */
        ](date);

        if (isNaN(currentDayOfMonth)) {
          return currentDayOfMonth;
        }

        var startWeekDay = __WEBPACK_IMPORTED_MODULE_1__getDay_index_js__["a"
        /* default */
        ](__WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__["a"
        /* default */
        ](date));

        var lastDayOfFirstWeek = 0;

        if (startWeekDay >= weekStartsOn) {
          lastDayOfFirstWeek = weekStartsOn + 7 - startWeekDay;
        } else {
          lastDayOfFirstWeek = weekStartsOn - startWeekDay;
        }

        var weekNumber = 1;

        if (currentDayOfMonth > lastDayOfFirstWeek) {
          var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
          weekNumber = weekNumber + Math.ceil(remainingDaysAfterFirstWeek / 7);
        }

        return weekNumber;
      }
      /***/

    },
    /* 366 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getWeeksInMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarWeeks_index_js__ = __webpack_require__(142);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lastDayOfMonth_index_js__ = __webpack_require__(171);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__ = __webpack_require__(62);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getWeeksInMonth
       * @category Week Helpers
       * @summary Get the number of calendar weeks a month spans.
       *
       * @description
       * Get the number of calendar weeks the month in the given date spans.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Number} the number of calendar weeks
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // How many calendar weeks does February 2015 span?
       * var result = getWeeksInMonth(new Date(2015, 1, 8))
       * //=> 4
       *
       * @example
       * // If the week starts on Monday,
       * // how many calendar weeks does July 2017 span?
       * var result = getWeeksInMonth(new Date(2017, 6, 5), { weekStartsOn: 1 })
       * //=> 6
       */


      function getWeeksInMonth(date, options) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarWeeks_index_js__["a"
        /* default */
        ](__WEBPACK_IMPORTED_MODULE_1__lastDayOfMonth_index_js__["a"
        /* default */
        ](date), __WEBPACK_IMPORTED_MODULE_2__startOfMonth_index_js__["a"
        /* default */
        ](date), options) + 1;
      }
      /***/

    },
    /* 367 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = getYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name getYear
       * @category Year Helpers
       * @summary Get the year of the given date.
       *
       * @description
       * Get the year of the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the given date
       * @returns {Number} the year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which year is 2 July 2014?
       * var result = getYear(new Date(2014, 6, 2))
       * //=> 2014
       */


      function getYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        return year;
      }
      /***/

    },
    /* 368 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = intervalToDuration;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__ = __webpack_require__(27);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__differenceInYears_index_js__ = __webpack_require__(147);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__differenceInMonths_index_js__ = __webpack_require__(60);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__differenceInDays_index_js__ = __webpack_require__(86);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__differenceInHours_index_js__ = __webpack_require__(144);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__differenceInMinutes_index_js__ = __webpack_require__(146);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__differenceInSeconds_index_js__ = __webpack_require__(61);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__isValid_index_js__ = __webpack_require__(15);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_10__sub_index_js__ = __webpack_require__(172);
      /**
       * @name intervalToDuration
       * @category Common Helpers
       * @summary Convert interval to duration
       *
       * @description
       * Convert a interval object to a duration object.
       *
       * @param {Interval} interval - the interval to convert to duration
       *
       * @returns {Duration} The duration Object
       * @throws {TypeError} Requires 2 arguments
       * @throws {RangeError} `start` must not be Invalid Date
       * @throws {RangeError} `end` must not be Invalid Date
       *
       * @example
       * // Get the duration between January 15, 1929 and April 4, 1968.
       * intervalToDuration({
       *   start: new Date(1929, 0, 15, 12, 0, 0),
       *   end: new Date(1968, 3, 4, 19, 5, 0)
       * })
       * // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }
       */


      function intervalToDuration(_ref) {
        var start = _ref.start,
            end = _ref.end;

        __WEBPACK_IMPORTED_MODULE_8__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_9__toDate_index_js__["a"
        /* default */
        ](start);

        var dateRight = __WEBPACK_IMPORTED_MODULE_9__toDate_index_js__["a"
        /* default */
        ](end);

        if (!__WEBPACK_IMPORTED_MODULE_7__isValid_index_js__["a"
        /* default */
        ](dateLeft)) {
          throw new RangeError('Start Date is invalid');
        }

        if (!__WEBPACK_IMPORTED_MODULE_7__isValid_index_js__["a"
        /* default */
        ](dateRight)) {
          throw new RangeError('End Date is invalid');
        }

        var duration = {
          years: 0,
          months: 0,
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        };

        var sign = __WEBPACK_IMPORTED_MODULE_0__compareAsc_index_js__["a"
        /* default */
        ](dateLeft, dateRight);

        duration.years = Math.abs(__WEBPACK_IMPORTED_MODULE_1__differenceInYears_index_js__["a"
        /* default */
        ](dateLeft, dateRight));

        var remainingMonths = __WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ](dateLeft, {
          years: sign * duration.years
        });

        duration.months = Math.abs(__WEBPACK_IMPORTED_MODULE_2__differenceInMonths_index_js__["a"
        /* default */
        ](remainingMonths, dateRight));

        var remainingDays = __WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ](remainingMonths, {
          months: sign * duration.months
        });

        duration.days = Math.abs(__WEBPACK_IMPORTED_MODULE_3__differenceInDays_index_js__["a"
        /* default */
        ](remainingDays, dateRight));

        var remainingHours = __WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ](remainingDays, {
          days: sign * duration.days
        });

        duration.hours = Math.abs(__WEBPACK_IMPORTED_MODULE_4__differenceInHours_index_js__["a"
        /* default */
        ](remainingHours, dateRight));

        var remainingMinutes = __WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ](remainingHours, {
          hours: sign * duration.hours
        });

        duration.minutes = Math.abs(__WEBPACK_IMPORTED_MODULE_5__differenceInMinutes_index_js__["a"
        /* default */
        ](remainingMinutes, dateRight));

        var remainingSeconds = __WEBPACK_IMPORTED_MODULE_10__sub_index_js__["a"
        /* default */
        ](remainingMinutes, {
          minutes: sign * duration.minutes
        });

        duration.seconds = Math.abs(__WEBPACK_IMPORTED_MODULE_6__differenceInSeconds_index_js__["a"
        /* default */
        ](remainingSeconds, dateRight));
        return duration;
      }
      /***/

    },
    /* 369 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isAfter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isAfter
       * @category Common Helpers
       * @summary Is the first date after the second one?
       *
       * @description
       * Is the first date after the second one?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date that should be after the other one to return true
       * @param {Date|Number} dateToCompare - the date to compare with
       * @returns {Boolean} the first date is after the second date
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Is 10 July 1989 after 11 February 1987?
       * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
       * //=> true
       */


      function isAfter(dirtyDate, dirtyDateToCompare) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var dateToCompare = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateToCompare);

        return date.getTime() > dateToCompare.getTime();
      }
      /***/

    },
    /* 370 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isBefore;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isBefore
       * @category Common Helpers
       * @summary Is the first date before the second one?
       *
       * @description
       * Is the first date before the second one?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date that should be before the other one to return true
       * @param {Date|Number} dateToCompare - the date to compare with
       * @returns {Boolean} the first date is before the second date
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Is 10 July 1989 before 11 February 1987?
       * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
       * //=> false
       */


      function isBefore(dirtyDate, dirtyDateToCompare) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var dateToCompare = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDateToCompare);

        return date.getTime() < dateToCompare.getTime();
      }
      /***/

    },
    /* 371 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isDate;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isDate
       * @category Common Helpers
       * @summary Is the given value a date?
       *
       * @description
       * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {*} value - the value to check
       * @returns {boolean} true if the given value is a date
       * @throws {TypeError} 1 arguments required
       *
       * @example
       * // For a valid date:
       * var result = isDate(new Date())
       * //=> true
       *
       * @example
       * // For an invalid date:
       * var result = isDate(new Date(NaN))
       * //=> true
       *
       * @example
       * // For some value:
       * var result = isDate('2014-02-31')
       * //=> false
       *
       * @example
       * // For an object:
       * var result = isDate({})
       * //=> false
       */


      function isDate(value) {
        __WEBPACK_IMPORTED_MODULE_0__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
      }
      /***/

    },
    /* 372 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isEqual;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isEqual
       * @category Common Helpers
       * @summary Are the given dates equal?
       *
       * @description
       * Are the given dates equal?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} dateLeft - the first date to compare
       * @param {Date|Number} dateRight - the second date to compare
       * @returns {Boolean} the dates are equal
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
       * var result = isEqual(
       *   new Date(2014, 6, 2, 6, 30, 45, 0),
       *   new Date(2014, 6, 2, 6, 30, 45, 500)
       * )
       * //=> false
       */


      function isEqual(dirtyLeftDate, dirtyRightDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeft = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyLeftDate);

        var dateRight = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyRightDate);

        return dateLeft.getTime() === dateRight.getTime();
      }
      /***/

    },
    /* 373 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isExists;
      /**
       * @name isExists
       * @category Common Helpers
       * @summary Is the given date exists?
       *
       * @description
       * Checks if the given arguments convert to an existing date.
       *
       * @param {Number} year of the date to check
       * @param {Number} month of the date to check
       * @param {Number} day of the date to check
       * @returns {Boolean} the date exists
       * @throws {TypeError} 3 arguments required
       *
       * @example
       * // For the valid date:
       * var result = isExists(2018, 0, 31)
       * //=> true
       *
       * @example
       * // For the invalid date:
       * var result = isExists(2018, 1, 31)
       * //=> false
       */

      function isExists(year, month, day) {
        if (arguments.length < 3) {
          throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
        }

        var date = new Date(year, month, day);
        return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
      }
      /***/

    },
    /* 374 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isFirstDayOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isFirstDayOfMonth
       * @category Month Helpers
       * @summary Is the given date the first day of a month?
       *
       * @description
       * Is the given date the first day of a month?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is the first day of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 1 September 2014 the first day of a month?
       * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
       * //=> true
       */


      function isFirstDayOfMonth(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getDate() === 1;
      }
      /***/

    },
    /* 375 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isFriday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isFriday
       * @category Weekday Helpers
       * @summary Is the given date Friday?
       *
       * @description
       * Is the given date Friday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Friday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 26 September 2014 Friday?
       * var result = isFriday(new Date(2014, 8, 26))
       * //=> true
       */


      function isFriday(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getDay() === 5;
      }
      /***/

    },
    /* 376 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isFuture;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isFuture
       * @category Common Helpers
       * @summary Is the given date in the future?
       * @pure false
       *
       * @description
       * Is the given date in the future?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in the future
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 31 December 2014 in the future?
       * var result = isFuture(new Date(2014, 11, 31))
       * //=> true
       */


      function isFuture(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getTime() > Date.now();
      }
      /***/

    },
    /* 377 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isLastDayOfMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__endOfDay_index_js__ = __webpack_require__(91);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__ = __webpack_require__(89);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isLastDayOfMonth
       * @category Month Helpers
       * @summary Is the given date the last day of a month?
       *
       * @description
       * Is the given date the last day of a month?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is the last day of a month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 28 February 2014 the last day of a month?
       * var result = isLastDayOfMonth(new Date(2014, 1, 28))
       * //=> true
       */


      function isLastDayOfMonth(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        return __WEBPACK_IMPORTED_MODULE_1__endOfDay_index_js__["a"
        /* default */
        ](date).getTime() === __WEBPACK_IMPORTED_MODULE_2__endOfMonth_index_js__["a"
        /* default */
        ](date).getTime();
      }
      /***/

    },
    /* 378 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isMatch;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__parse_index_js__ = __webpack_require__(174);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__ = __webpack_require__(15);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isMatch
       * @category Common Helpers
       * @summary validates the date string against given formats
       *
       * @description
       * Return the true if given date is string correct against the given format else
       * will return false.
       *
       * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
       * > See: https://git.io/fxCyr
       *
       * The characters in the format string wrapped between two single quotes characters (') are escaped.
       * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
       *
       * Format of the format string is based on Unicode Technical Standard #35:
       * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
       * with a few additions (see note 5 below the table).
       *
       * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
       * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
       *
       * ```javascript
       * isMatch('23 AM', 'HH a')
       * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
       * ```
       *
       * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
       *
       * Accepted format string patterns:
       * | Unit                            |Prior| Pattern | Result examples                   | Notes |
       * |---------------------------------|-----|---------|-----------------------------------|-------|
       * | Era                             | 140 | G..GGG  | AD, BC                            |       |
       * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
       * |                                 |     | GGGGG   | A, B                              |       |
       * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
       * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
       * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
       * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
       * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
       * |                                 |     | yyyyy   | ...                               | 2,4   |
       * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
       * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
       * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
       * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
       * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
       * |                                 |     | YYYYY   | ...                               | 2,4   |
       * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
       * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
       * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
       * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
       * |                                 |     | RRRRR   | ...                               | 2,4,5 |
       * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
       * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
       * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
       * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
       * |                                 |     | uuuuu   | ...                               | 2,4   |
       * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
       * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
       * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
       * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
       * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
       * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
       * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
       * |                                 |     | qq      | 01, 02, 03, 04                    |       |
       * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
       * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
       * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
       * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
       * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
       * |                                 |     | MM      | 01, 02, ..., 12                   |       |
       * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
       * |                                 |     | MMMM    | January, February, ..., December  | 2     |
       * |                                 |     | MMMMM   | J, F, ..., D                      |       |
       * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
       * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
       * |                                 |     | LL      | 01, 02, ..., 12                   |       |
       * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
       * |                                 |     | LLLL    | January, February, ..., December  | 2     |
       * |                                 |     | LLLLL   | J, F, ..., D                      |       |
       * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
       * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
       * |                                 |     | ww      | 01, 02, ..., 53                   |       |
       * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
       * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
       * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
       * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
       * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
       * |                                 |     | dd      | 01, 02, ..., 31                   |       |
       * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
       * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
       * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
       * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
       * |                                 |     | DDDD    | ...                               | 2     |
       * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
       * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
       * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
       * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
       * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
       * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
       * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
       * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
       * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
       * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
       * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
       * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
       * |                                 |     | ee      | 02, 03, ..., 01                   |       |
       * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
       * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
       * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
       * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
       * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
       * |                                 |     | cc      | 02, 03, ..., 01                   |       |
       * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
       * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
       * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
       * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
       * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
       * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
       * |                                 |     | aaaaa   | a, p                              |       |
       * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
       * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
       * |                                 |     | bbbbb   | a, p, n, mi                       |       |
       * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
       * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
       * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
       * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
       * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
       * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
       * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
       * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
       * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
       * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
       * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
       * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
       * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
       * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
       * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
       * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
       * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
       * |                                 |     | mm      | 00, 01, ..., 59                   |       |
       * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
       * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
       * |                                 |     | ss      | 00, 01, ..., 59                   |       |
       * | Seconds timestamp               |  40 | t       | 512969520                         |       |
       * |                                 |     | tt      | ...                               | 2     |
       * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
       * |                                 |     | SS      | 00, 01, ..., 99                   |       |
       * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
       * |                                 |     | SSSS    | ...                               | 2     |
       * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
       * |                                 |     | TT      | ...                               | 2     |
       * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
       * |                                 |     | XX      | -0800, +0530, Z                   |       |
       * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
       * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
       * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
       * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
       * |                                 |     | xx      | -0800, +0530, +0000               |       |
       * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
       * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
       * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
       * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
       * |                                 |     | PP      | May 29, 1453                      |       |
       * |                                 |     | PPP     | May 29th, 1453                    |       |
       * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
       * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
       * |                                 |     | pp      | 12:00:00 AM                       |       |
       * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
       * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
       * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
       * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
       * Notes:
       * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
       *    are the same as "stand-alone" units, but are different in some languages.
       *    "Formatting" units are declined according to the rules of the language
       *    in the context of a date. "Stand-alone" units are always nominative singular.
       *    In `format` function, they will produce different result:
       *
       *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
       *
       *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
       *
       *    `isMatch` will try to match both formatting and stand-alone units interchangably.
       *
       * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
       *    the single quote characters (see below).
       *    If the sequence is longer than listed in table:
       *    - for numerical units (`yyyyyyyy`) `isMatch` will try to match a number
       *      as wide as the sequence
       *    - for text units (`MMMMMMMM`) `isMatch` will try to match the widest variation of the unit.
       *      These variations are marked with "2" in the last column of the table.
       *
       * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
       *    These tokens represent the shortest form of the quarter.
       *
       * 4. The main difference between `y` and `u` patterns are B.C. years:
       *
       *    | Year | `y` | `u` |
       *    |------|-----|-----|
       *    | AC 1 |   1 |   1 |
       *    | BC 1 |   1 |   0 |
       *    | BC 2 |   2 |  -1 |
       *
       *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
       *
       *    `isMatch('50', 'yy') //=> true`
       *
       *    `isMatch('75', 'yy') //=> true`
       *
       *    while `uu` will use the year as is:
       *
       *    `isMatch('50', 'uu') //=> true`
       *
       *    `isMatch('75', 'uu') //=> true`
       *
       *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
       *    except local week-numbering years are dependent on `options.weekStartsOn`
       *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
       *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
       *
       * 5. These patterns are not in the Unicode Technical Standard #35:
       *    - `i`: ISO day of week
       *    - `I`: ISO week of year
       *    - `R`: ISO week-numbering year
       *    - `o`: ordinal number modifier
       *    - `P`: long localized date
       *    - `p`: long localized time
       *
       * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
       *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
       *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
       *
       * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
       *    on the given locale.
       *
       *    using `en-US` locale: `P` => `MM/dd/yyyy`
       *    using `en-US` locale: `p` => `hh:mm a`
       *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
       *    using `pt-BR` locale: `p` => `HH:mm`
       *
       * Values will be checked in the descending order of its unit's priority.
       * Units of an equal priority overwrite each other in the order of appearance.
       *
       * If no values of higher priority are matched (e.g. when matching string 'January 1st' without a year),
       * the values will be taken from today's using `new Date()` date which works as a context of parsing.
       *
       * The result may vary by locale.
       *
       * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
       *
       *
       *
       * @param {String} dateString - the date string to verify
       * @param {String} formatString - the string of tokens
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
       *   see: https://git.io/fxCyr
       * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
       *   see: https://git.io/fxCyr
       * @returns {Boolean}
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       * @throws {RangeError} `options.locale` must contain `match` property
       * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
       * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
       * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
       * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
       * @throws {RangeError} format string contains an unescaped latin alphabet character
       *
       * @example
       * // Match 11 February 2014 from middle-endian format:
       * var result = isMatch('02/11/2014', 'MM/dd/yyyy')
       * //=> true
       *
       * @example
       * // Match 28th of February in Esperanto locale in the context of 2010 year:
       * import eo from 'date-fns/locale/eo'
       * var result = isMatch('28-a de februaro', "do 'de' MMMM", {
       *   locale: eo
       * })
       * //=> true
       */


      function isMatch(dateString, formatString, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        return __WEBPACK_IMPORTED_MODULE_1__isValid_index_js__["a"
        /* default */
        ](__WEBPACK_IMPORTED_MODULE_0__parse_index_js__["a"
        /* default */
        ](dateString, formatString, new Date(), dirtyOptions));
      }
      /***/

    },
    /* 379 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__ = __webpack_require__(92);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__ = __webpack_require__(380);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__ = __webpack_require__(381);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__ = __webpack_require__(382);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__ = __webpack_require__(383);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__ = __webpack_require__(63);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__ = __webpack_require__(50);

      var MILLISECONDS_IN_HOUR = 3600000;
      var MILLISECONDS_IN_MINUTE = 60000;
      var MILLISECONDS_IN_SECOND = 1000;
      var numericPatterns = {
        month: /^(1[0-2]|0?\d)/,
        // 0 to 12
        date: /^(3[0-1]|[0-2]?\d)/,
        // 0 to 31
        dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
        // 0 to 366
        week: /^(5[0-3]|[0-4]?\d)/,
        // 0 to 53
        hour23h: /^(2[0-3]|[0-1]?\d)/,
        // 0 to 23
        hour24h: /^(2[0-4]|[0-1]?\d)/,
        // 0 to 24
        hour11h: /^(1[0-1]|0?\d)/,
        // 0 to 11
        hour12h: /^(1[0-2]|0?\d)/,
        // 0 to 12
        minute: /^[0-5]?\d/,
        // 0 to 59
        second: /^[0-5]?\d/,
        // 0 to 59
        singleDigit: /^\d/,
        // 0 to 9
        twoDigits: /^\d{1,2}/,
        // 0 to 99
        threeDigits: /^\d{1,3}/,
        // 0 to 999
        fourDigits: /^\d{1,4}/,
        // 0 to 9999
        anyDigitsSigned: /^-?\d+/,
        singleDigitSigned: /^-?\d/,
        // 0 to 9, -0 to -9
        twoDigitsSigned: /^-?\d{1,2}/,
        // 0 to 99, -0 to -99
        threeDigitsSigned: /^-?\d{1,3}/,
        // 0 to 999, -0 to -999
        fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

      };
      var timezonePatterns = {
        basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
        basic: /^([+-])(\d{2})(\d{2})|Z/,
        basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
        extended: /^([+-])(\d{2}):(\d{2})|Z/,
        extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
      };

      function parseNumericPattern(pattern, string, valueCallback) {
        var matchResult = string.match(pattern);

        if (!matchResult) {
          return null;
        }

        var value = parseInt(matchResult[0], 10);
        return {
          value: valueCallback ? valueCallback(value) : value,
          rest: string.slice(matchResult[0].length)
        };
      }

      function parseTimezonePattern(pattern, string) {
        var matchResult = string.match(pattern);

        if (!matchResult) {
          return null;
        } // Input is 'Z'


        if (matchResult[0] === 'Z') {
          return {
            value: 0,
            rest: string.slice(1)
          };
        }

        var sign = matchResult[1] === '+' ? 1 : -1;
        var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
        var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
        var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
        return {
          value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
          rest: string.slice(matchResult[0].length)
        };
      }

      function parseAnyDigitsSigned(string, valueCallback) {
        return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
      }

      function parseNDigits(n, string, valueCallback) {
        switch (n) {
          case 1:
            return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

          case 2:
            return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

          case 3:
            return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

          case 4:
            return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

          default:
            return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
        }
      }

      function parseNDigitsSigned(n, string, valueCallback) {
        switch (n) {
          case 1:
            return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

          case 2:
            return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

          case 3:
            return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

          case 4:
            return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

          default:
            return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
        }
      }

      function dayPeriodEnumToHours(enumValue) {
        switch (enumValue) {
          case 'morning':
            return 4;

          case 'evening':
            return 17;

          case 'pm':
          case 'noon':
          case 'afternoon':
            return 12;

          case 'am':
          case 'midnight':
          case 'night':
          default:
            return 0;
        }
      }

      function normalizeTwoDigitYear(twoDigitYear, currentYear) {
        var isCommonEra = currentYear > 0; // Absolute number of the current year:
        // 1 -> 1 AC
        // 0 -> 1 BC
        // -1 -> 2 BC

        var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
        var result;

        if (absCurrentYear <= 50) {
          result = twoDigitYear || 100;
        } else {
          var rangeEnd = absCurrentYear + 50;
          var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
          var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
          result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
        }

        return isCommonEra ? result : 1 - result;
      }

      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

      function isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
      }
      /*
       * |     | Unit                           |     | Unit                           |
       * |-----|--------------------------------|-----|--------------------------------|
       * |  a  | AM, PM                         |  A* | Milliseconds in day            |
       * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
       * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
       * |  d  | Day of month                   |  D  | Day of year                    |
       * |  e  | Local day of week              |  E  | Day of week                    |
       * |  f  |                                |  F* | Day of week in month           |
       * |  g* | Modified Julian day            |  G  | Era                            |
       * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
       * |  i! | ISO day of week                |  I! | ISO week of year               |
       * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
       * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
       * |  l* | (deprecated)                   |  L  | Stand-alone month              |
       * |  m  | Minute                         |  M  | Month                          |
       * |  n  |                                |  N  |                                |
       * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
       * |  p  |                                |  P  |                                |
       * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
       * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
       * |  s  | Second                         |  S  | Fraction of second             |
       * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
       * |  u  | Extended year                  |  U* | Cyclic year                    |
       * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
       * |  w  | Local week of year             |  W* | Week of month                  |
       * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
       * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
       * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
       *
       * Letters marked by * are not implemented but reserved by Unicode standard.
       *
       * Letters marked by ! are non-standard, but implemented by date-fns:
       * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
       * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
       *   i.e. 7 for Sunday, 1 for Monday, etc.
       * - `I` is ISO week of year, as opposed to `w` which is local week of year.
       * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
       *   `R` is supposed to be used in conjunction with `I` and `i`
       *   for universal ISO week-numbering date, whereas
       *   `Y` is supposed to be used in conjunction with `w` and `e`
       *   for week-numbering date specific to the locale.
       */


      var parsers = {
        // Era
        G: {
          priority: 140,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              // AD, BC
              case 'G':
              case 'GG':
              case 'GGG':
                return match.era(string, {
                  width: 'abbreviated'
                }) || match.era(string, {
                  width: 'narrow'
                });
              // A, B

              case 'GGGGG':
                return match.era(string, {
                  width: 'narrow'
                });
              // Anno Domini, Before Christ

              case 'GGGG':
              default:
                return match.era(string, {
                  width: 'wide'
                }) || match.era(string, {
                  width: 'abbreviated'
                }) || match.era(string, {
                  width: 'narrow'
                });
            }
          },
          set: function set(date, flags, value, _options) {
            flags.era = value;
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['R', 'u', 't', 'T']
        },
        // Year
        y: {
          // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
          // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
          // |----------|-------|----|-------|-------|-------|
          // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
          // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
          // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
          // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
          // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
          priority: 130,
          parse: function parse(string, token, match, _options) {
            var valueCallback = function valueCallback(year) {
              return {
                year: year,
                isTwoDigitYear: token === 'yy'
              };
            };

            switch (token) {
              case 'y':
                return parseNDigits(4, string, valueCallback);

              case 'yo':
                return match.ordinalNumber(string, {
                  unit: 'year',
                  valueCallback: valueCallback
                });

              default:
                return parseNDigits(token.length, string, valueCallback);
            }
          },
          validate: function validate(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
          },
          set: function set(date, flags, value, _options) {
            var currentYear = date.getUTCFullYear();

            if (value.isTwoDigitYear) {
              var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
              date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
              date.setUTCHours(0, 0, 0, 0);
              return date;
            }

            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
        },
        // Local week-numbering year
        Y: {
          priority: 130,
          parse: function parse(string, token, match, _options) {
            var valueCallback = function valueCallback(year) {
              return {
                year: year,
                isTwoDigitYear: token === 'YY'
              };
            };

            switch (token) {
              case 'Y':
                return parseNDigits(4, string, valueCallback);

              case 'Yo':
                return match.ordinalNumber(string, {
                  unit: 'year',
                  valueCallback: valueCallback
                });

              default:
                return parseNDigits(token.length, string, valueCallback);
            }
          },
          validate: function validate(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
          },
          set: function set(date, flags, value, options) {
            var currentYear = __WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__["a"
            /* default */
            ](date, options);

            if (value.isTwoDigitYear) {
              var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
              date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
              date.setUTCHours(0, 0, 0, 0);
              return __WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a"
              /* default */
              ](date, options);
            }

            var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
            date.setUTCHours(0, 0, 0, 0);
            return __WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a"
            /* default */
            ](date, options);
          },
          incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
        },
        // ISO week-numbering year
        R: {
          priority: 130,
          parse: function parse(string, token, _match, _options) {
            if (token === 'R') {
              return parseNDigitsSigned(4, string);
            }

            return parseNDigitsSigned(token.length, string);
          },
          set: function set(_date, _flags, value, _options) {
            var firstWeekOfYear = new Date(0);
            firstWeekOfYear.setUTCFullYear(value, 0, 4);
            firstWeekOfYear.setUTCHours(0, 0, 0, 0);
            return __WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a"
            /* default */
            ](firstWeekOfYear);
          },
          incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
        },
        // Extended year
        u: {
          priority: 130,
          parse: function parse(string, token, _match, _options) {
            if (token === 'u') {
              return parseNDigitsSigned(4, string);
            }

            return parseNDigitsSigned(token.length, string);
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
        },
        // Quarter
        Q: {
          priority: 120,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              // 1, 2, 3, 4
              case 'Q':
              case 'QQ':
                // 01, 02, 03, 04
                return parseNDigits(token.length, string);
              // 1st, 2nd, 3rd, 4th

              case 'Qo':
                return match.ordinalNumber(string, {
                  unit: 'quarter'
                });
              // Q1, Q2, Q3, Q4

              case 'QQQ':
                return match.quarter(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.quarter(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // 1, 2, 3, 4 (narrow quarter; could be not numerical)

              case 'QQQQQ':
                return match.quarter(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // 1st quarter, 2nd quarter, ...

              case 'QQQQ':
              default:
                return match.quarter(string, {
                  width: 'wide',
                  context: 'formatting'
                }) || match.quarter(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.quarter(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 1 && value <= 4;
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
        },
        // Stand-alone quarter
        q: {
          priority: 120,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              // 1, 2, 3, 4
              case 'q':
              case 'qq':
                // 01, 02, 03, 04
                return parseNDigits(token.length, string);
              // 1st, 2nd, 3rd, 4th

              case 'qo':
                return match.ordinalNumber(string, {
                  unit: 'quarter'
                });
              // Q1, Q2, Q3, Q4

              case 'qqq':
                return match.quarter(string, {
                  width: 'abbreviated',
                  context: 'standalone'
                }) || match.quarter(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // 1, 2, 3, 4 (narrow quarter; could be not numerical)

              case 'qqqqq':
                return match.quarter(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // 1st quarter, 2nd quarter, ...

              case 'qqqq':
              default:
                return match.quarter(string, {
                  width: 'wide',
                  context: 'standalone'
                }) || match.quarter(string, {
                  width: 'abbreviated',
                  context: 'standalone'
                }) || match.quarter(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 1 && value <= 4;
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
        },
        // Month
        M: {
          priority: 110,
          parse: function parse(string, token, match, _options) {
            var valueCallback = function valueCallback(value) {
              return value - 1;
            };

            switch (token) {
              // 1, 2, ..., 12
              case 'M':
                return parseNumericPattern(numericPatterns.month, string, valueCallback);
              // 01, 02, ..., 12

              case 'MM':
                return parseNDigits(2, string, valueCallback);
              // 1st, 2nd, ..., 12th

              case 'Mo':
                return match.ordinalNumber(string, {
                  unit: 'month',
                  valueCallback: valueCallback
                });
              // Jan, Feb, ..., Dec

              case 'MMM':
                return match.month(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.month(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // J, F, ..., D

              case 'MMMMM':
                return match.month(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // January, February, ..., December

              case 'MMMM':
              default:
                return match.month(string, {
                  width: 'wide',
                  context: 'formatting'
                }) || match.month(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.month(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 0 && value <= 11;
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
        },
        // Stand-alone month
        L: {
          priority: 110,
          parse: function parse(string, token, match, _options) {
            var valueCallback = function valueCallback(value) {
              return value - 1;
            };

            switch (token) {
              // 1, 2, ..., 12
              case 'L':
                return parseNumericPattern(numericPatterns.month, string, valueCallback);
              // 01, 02, ..., 12

              case 'LL':
                return parseNDigits(2, string, valueCallback);
              // 1st, 2nd, ..., 12th

              case 'Lo':
                return match.ordinalNumber(string, {
                  unit: 'month',
                  valueCallback: valueCallback
                });
              // Jan, Feb, ..., Dec

              case 'LLL':
                return match.month(string, {
                  width: 'abbreviated',
                  context: 'standalone'
                }) || match.month(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // J, F, ..., D

              case 'LLLLL':
                return match.month(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // January, February, ..., December

              case 'LLLL':
              default:
                return match.month(string, {
                  width: 'wide',
                  context: 'standalone'
                }) || match.month(string, {
                  width: 'abbreviated',
                  context: 'standalone'
                }) || match.month(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 0 && value <= 11;
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
        },
        // Local week of year
        w: {
          priority: 100,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'w':
                return parseNumericPattern(numericPatterns.week, string);

              case 'wo':
                return match.ordinalNumber(string, {
                  unit: 'week'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 1 && value <= 53;
          },
          set: function set(date, _flags, value, options) {
            return __WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a"
            /* default */
            ](__WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__["a"
            /* default */
            ](date, value, options), options);
          },
          incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
        },
        // ISO week of year
        I: {
          priority: 100,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'I':
                return parseNumericPattern(numericPatterns.week, string);

              case 'Io':
                return match.ordinalNumber(string, {
                  unit: 'week'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 1 && value <= 53;
          },
          set: function set(date, _flags, value, options) {
            return __WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a"
            /* default */
            ](__WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__["a"
            /* default */
            ](date, value, options), options);
          },
          incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
        },
        // Day of the month
        d: {
          priority: 90,
          subPriority: 1,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'd':
                return parseNumericPattern(numericPatterns.date, string);

              case 'do':
                return match.ordinalNumber(string, {
                  unit: 'date'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = isLeapYearIndex(year);
            var month = date.getUTCMonth();

            if (isLeapYear) {
              return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
            } else {
              return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCDate(value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
        },
        // Day of year
        D: {
          priority: 90,
          subPriority: 1,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'D':
              case 'DD':
                return parseNumericPattern(numericPatterns.dayOfYear, string);

              case 'Do':
                return match.ordinalNumber(string, {
                  unit: 'date'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = isLeapYearIndex(year);

            if (isLeapYear) {
              return value >= 1 && value <= 366;
            } else {
              return value >= 1 && value <= 365;
            }
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCMonth(0, value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
        },
        // Day of week
        E: {
          priority: 90,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              // Tue
              case 'E':
              case 'EE':
              case 'EEE':
                return match.day(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'short',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // T

              case 'EEEEE':
                return match.day(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // Tu

              case 'EEEEEE':
                return match.day(string, {
                  width: 'short',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // Tuesday

              case 'EEEE':
              default:
                return match.day(string, {
                  width: 'wide',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'short',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 0 && value <= 6;
          },
          set: function set(date, _flags, value, options) {
            date = __WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a"
            /* default */
            ](date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
        },
        // Local day of week
        e: {
          priority: 90,
          parse: function parse(string, token, match, options) {
            var valueCallback = function valueCallback(value) {
              var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
              return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };

            switch (token) {
              // 3
              case 'e':
              case 'ee':
                // 03
                return parseNDigits(token.length, string, valueCallback);
              // 3rd

              case 'eo':
                return match.ordinalNumber(string, {
                  unit: 'day',
                  valueCallback: valueCallback
                });
              // Tue

              case 'eee':
                return match.day(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'short',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // T

              case 'eeeee':
                return match.day(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // Tu

              case 'eeeeee':
                return match.day(string, {
                  width: 'short',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
              // Tuesday

              case 'eeee':
              default:
                return match.day(string, {
                  width: 'wide',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'short',
                  context: 'formatting'
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 0 && value <= 6;
          },
          set: function set(date, _flags, value, options) {
            date = __WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a"
            /* default */
            ](date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
        },
        // Stand-alone local day of week
        c: {
          priority: 90,
          parse: function parse(string, token, match, options) {
            var valueCallback = function valueCallback(value) {
              var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
              return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };

            switch (token) {
              // 3
              case 'c':
              case 'cc':
                // 03
                return parseNDigits(token.length, string, valueCallback);
              // 3rd

              case 'co':
                return match.ordinalNumber(string, {
                  unit: 'day',
                  valueCallback: valueCallback
                });
              // Tue

              case 'ccc':
                return match.day(string, {
                  width: 'abbreviated',
                  context: 'standalone'
                }) || match.day(string, {
                  width: 'short',
                  context: 'standalone'
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // T

              case 'ccccc':
                return match.day(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // Tu

              case 'cccccc':
                return match.day(string, {
                  width: 'short',
                  context: 'standalone'
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
              // Tuesday

              case 'cccc':
              default:
                return match.day(string, {
                  width: 'wide',
                  context: 'standalone'
                }) || match.day(string, {
                  width: 'abbreviated',
                  context: 'standalone'
                }) || match.day(string, {
                  width: 'short',
                  context: 'standalone'
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'standalone'
                });
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 0 && value <= 6;
          },
          set: function set(date, _flags, value, options) {
            date = __WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a"
            /* default */
            ](date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
        },
        // ISO day of week
        i: {
          priority: 90,
          parse: function parse(string, token, match, _options) {
            var valueCallback = function valueCallback(value) {
              if (value === 0) {
                return 7;
              }

              return value;
            };

            switch (token) {
              // 2
              case 'i':
              case 'ii':
                // 02
                return parseNDigits(token.length, string);
              // 2nd

              case 'io':
                return match.ordinalNumber(string, {
                  unit: 'day'
                });
              // Tue

              case 'iii':
                return match.day(string, {
                  width: 'abbreviated',
                  context: 'formatting',
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: 'short',
                  context: 'formatting',
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'formatting',
                  valueCallback: valueCallback
                });
              // T

              case 'iiiii':
                return match.day(string, {
                  width: 'narrow',
                  context: 'formatting',
                  valueCallback: valueCallback
                });
              // Tu

              case 'iiiiii':
                return match.day(string, {
                  width: 'short',
                  context: 'formatting',
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'formatting',
                  valueCallback: valueCallback
                });
              // Tuesday

              case 'iiii':
              default:
                return match.day(string, {
                  width: 'wide',
                  context: 'formatting',
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: 'abbreviated',
                  context: 'formatting',
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: 'short',
                  context: 'formatting',
                  valueCallback: valueCallback
                }) || match.day(string, {
                  width: 'narrow',
                  context: 'formatting',
                  valueCallback: valueCallback
                });
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 1 && value <= 7;
          },
          set: function set(date, _flags, value, options) {
            date = __WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__["a"
            /* default */
            ](date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
        },
        // AM or PM
        a: {
          priority: 80,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'a':
              case 'aa':
              case 'aaa':
                return match.dayPeriod(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.dayPeriod(string, {
                  width: 'narrow',
                  context: 'formatting'
                });

              case 'aaaaa':
                return match.dayPeriod(string, {
                  width: 'narrow',
                  context: 'formatting'
                });

              case 'aaaa':
              default:
                return match.dayPeriod(string, {
                  width: 'wide',
                  context: 'formatting'
                }) || match.dayPeriod(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.dayPeriod(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
            }
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
        },
        // AM, PM, midnight
        b: {
          priority: 80,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'b':
              case 'bb':
              case 'bbb':
                return match.dayPeriod(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.dayPeriod(string, {
                  width: 'narrow',
                  context: 'formatting'
                });

              case 'bbbbb':
                return match.dayPeriod(string, {
                  width: 'narrow',
                  context: 'formatting'
                });

              case 'bbbb':
              default:
                return match.dayPeriod(string, {
                  width: 'wide',
                  context: 'formatting'
                }) || match.dayPeriod(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.dayPeriod(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
            }
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
        },
        // in the morning, in the afternoon, in the evening, at night
        B: {
          priority: 80,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'B':
              case 'BB':
              case 'BBB':
                return match.dayPeriod(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.dayPeriod(string, {
                  width: 'narrow',
                  context: 'formatting'
                });

              case 'BBBBB':
                return match.dayPeriod(string, {
                  width: 'narrow',
                  context: 'formatting'
                });

              case 'BBBB':
              default:
                return match.dayPeriod(string, {
                  width: 'wide',
                  context: 'formatting'
                }) || match.dayPeriod(string, {
                  width: 'abbreviated',
                  context: 'formatting'
                }) || match.dayPeriod(string, {
                  width: 'narrow',
                  context: 'formatting'
                });
            }
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['a', 'b', 't', 'T']
        },
        // Hour [1-12]
        h: {
          priority: 70,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'h':
                return parseNumericPattern(numericPatterns.hour12h, string);

              case 'ho':
                return match.ordinalNumber(string, {
                  unit: 'hour'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 1 && value <= 12;
          },
          set: function set(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;

            if (isPM && value < 12) {
              date.setUTCHours(value + 12, 0, 0, 0);
            } else if (!isPM && value === 12) {
              date.setUTCHours(0, 0, 0, 0);
            } else {
              date.setUTCHours(value, 0, 0, 0);
            }

            return date;
          },
          incompatibleTokens: ['H', 'K', 'k', 't', 'T']
        },
        // Hour [0-23]
        H: {
          priority: 70,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'H':
                return parseNumericPattern(numericPatterns.hour23h, string);

              case 'Ho':
                return match.ordinalNumber(string, {
                  unit: 'hour'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 0 && value <= 23;
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCHours(value, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
        },
        // Hour [0-11]
        K: {
          priority: 70,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'K':
                return parseNumericPattern(numericPatterns.hour11h, string);

              case 'Ko':
                return match.ordinalNumber(string, {
                  unit: 'hour'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 0 && value <= 11;
          },
          set: function set(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;

            if (isPM && value < 12) {
              date.setUTCHours(value + 12, 0, 0, 0);
            } else {
              date.setUTCHours(value, 0, 0, 0);
            }

            return date;
          },
          incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
        },
        // Hour [1-24]
        k: {
          priority: 70,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'k':
                return parseNumericPattern(numericPatterns.hour24h, string);

              case 'ko':
                return match.ordinalNumber(string, {
                  unit: 'hour'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 1 && value <= 24;
          },
          set: function set(date, _flags, value, _options) {
            var hours = value <= 24 ? value % 24 : value;
            date.setUTCHours(hours, 0, 0, 0);
            return date;
          },
          incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
        },
        // Minute
        m: {
          priority: 60,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 'm':
                return parseNumericPattern(numericPatterns.minute, string);

              case 'mo':
                return match.ordinalNumber(string, {
                  unit: 'minute'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 0 && value <= 59;
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCMinutes(value, 0, 0);
            return date;
          },
          incompatibleTokens: ['t', 'T']
        },
        // Second
        s: {
          priority: 50,
          parse: function parse(string, token, match, _options) {
            switch (token) {
              case 's':
                return parseNumericPattern(numericPatterns.second, string);

              case 'so':
                return match.ordinalNumber(string, {
                  unit: 'second'
                });

              default:
                return parseNDigits(token.length, string);
            }
          },
          validate: function validate(_date, value, _options) {
            return value >= 0 && value <= 59;
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCSeconds(value, 0);
            return date;
          },
          incompatibleTokens: ['t', 'T']
        },
        // Fraction of second
        S: {
          priority: 30,
          parse: function parse(string, token, _match, _options) {
            var valueCallback = function valueCallback(value) {
              return Math.floor(value * Math.pow(10, -token.length + 3));
            };

            return parseNDigits(token.length, string, valueCallback);
          },
          set: function set(date, _flags, value, _options) {
            date.setUTCMilliseconds(value);
            return date;
          },
          incompatibleTokens: ['t', 'T']
        },
        // Timezone (ISO-8601. +00:00 is `'Z'`)
        X: {
          priority: 10,
          parse: function parse(string, token, _match, _options) {
            switch (token) {
              case 'X':
                return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

              case 'XX':
                return parseTimezonePattern(timezonePatterns.basic, string);

              case 'XXXX':
                return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

              case 'XXXXX':
                return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

              case 'XXX':
              default:
                return parseTimezonePattern(timezonePatterns.extended, string);
            }
          },
          set: function set(date, flags, value, _options) {
            if (flags.timestampIsSet) {
              return date;
            }

            return new Date(date.getTime() - value);
          },
          incompatibleTokens: ['t', 'T', 'x']
        },
        // Timezone (ISO-8601)
        x: {
          priority: 10,
          parse: function parse(string, token, _match, _options) {
            switch (token) {
              case 'x':
                return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

              case 'xx':
                return parseTimezonePattern(timezonePatterns.basic, string);

              case 'xxxx':
                return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

              case 'xxxxx':
                return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

              case 'xxx':
              default:
                return parseTimezonePattern(timezonePatterns.extended, string);
            }
          },
          set: function set(date, flags, value, _options) {
            if (flags.timestampIsSet) {
              return date;
            }

            return new Date(date.getTime() - value);
          },
          incompatibleTokens: ['t', 'T', 'X']
        },
        // Seconds timestamp
        t: {
          priority: 40,
          parse: function parse(string, _token, _match, _options) {
            return parseAnyDigitsSigned(string);
          },
          set: function set(_date, _flags, value, _options) {
            return [new Date(value * 1000), {
              timestampIsSet: true
            }];
          },
          incompatibleTokens: '*'
        },
        // Milliseconds timestamp
        T: {
          priority: 20,
          parse: function parse(string, _token, _match, _options) {
            return parseAnyDigitsSigned(string);
          },
          set: function set(_date, _flags, value, _options) {
            return [new Date(value), {
              timestampIsSet: true
            }];
          },
          incompatibleTokens: '*'
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = parsers;
      /***/
    },
    /* 380 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setUTCDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        }

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](dirtyDay);

        var currentDay = date.getUTCDay();
        var remainder = day % 7;
        var dayIndex = (remainder + 7) % 7;
        var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
      }
      /***/

    },
    /* 381 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setUTCISODay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function setUTCISODay(dirtyDate, dirtyDay) {
        __WEBPACK_IMPORTED_MODULE_2__requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var day = __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](dirtyDay);

        if (day % 7 === 0) {
          day = day - 7;
        }

        var weekStartsOn = 1;

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var currentDay = date.getUTCDay();
        var remainder = day % 7;
        var dayIndex = (remainder + 7) % 7;
        var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
      }
      /***/

    },
    /* 382 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setUTCISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__ = __webpack_require__(153);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
        __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var isoWeek = __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](dirtyISOWeek);

        var diff = __WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__["a"
        /* default */
        ](date) - isoWeek;
        date.setUTCDate(date.getUTCDate() - diff * 7);
        return date;
      }
      /***/

    },
    /* 383 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setUTCWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__ = __webpack_require__(155);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__ = __webpack_require__(0); // This function will be a part of public API when UTC function will be implemented.
      // See issue: https://github.com/date-fns/date-fns/issues/376


      function setUTCWeek(dirtyDate, dirtyWeek, options) {
        __WEBPACK_IMPORTED_MODULE_3__requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var week = __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a"
        /* default */
        ](dirtyWeek);

        var diff = __WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__["a"
        /* default */
        ](date, options) - week;
        date.setUTCDate(date.getUTCDate() - diff * 7);
        return date;
      }
      /***/

    },
    /* 384 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isMonday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isMonday
       * @category Weekday Helpers
       * @summary Is the given date Monday?
       *
       * @description
       * Is the given date Monday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Monday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 22 September 2014 Monday?
       * var result = isMonday(new Date(2014, 8, 22))
       * //=> true
       */


      function isMonday(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getDay() === 1;
      }
      /***/

    },
    /* 385 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isPast;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isPast
       * @category Common Helpers
       * @summary Is the given date in the past?
       * @pure false
       *
       * @description
       * Is the given date in the past?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in the past
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 2 July 2014 in the past?
       * var result = isPast(new Date(2014, 6, 2))
       * //=> true
       */


      function isPast(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getTime() < Date.now();
      }
      /***/

    },
    /* 386 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isSameISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__ = __webpack_require__(46);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isSameISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Are the given dates in the same ISO week-numbering year?
       *
       * @description
       * Are the given dates in the same ISO week-numbering year?
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `isSameISOYear` to `isSameISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
       *
       * @param {Date|Number} dateLeft - the first date to check
       * @param {Date|Number} dateRight - the second date to check
       * @returns {Boolean} the dates are in the same ISO week-numbering year
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
       * var result = isSameISOWeekYear(new Date(2003, 11, 29), new Date(2005, 0, 2))
       * //=> true
       */


      function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var dateLeftStartOfYear = __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDateLeft);

        var dateRightStartOfYear = __WEBPACK_IMPORTED_MODULE_0__startOfISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDateRight);

        return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
      }
      /***/

    },
    /* 387 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isThisHour;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameHour_index_js__ = __webpack_require__(175);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisHour
       * @category Hour Helpers
       * @summary Is the given date in the same hour as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same hour as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this hour
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If now is 25 September 2014 18:30:15.500,
       * // is 25 September 2014 18:00:00 in this hour?
       * var result = isThisHour(new Date(2014, 8, 25, 18))
       * //=> true
       */


      function isThisHour(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameHour_index_js__["a"
        /* default */
        ](Date.now(), dirtyDate);
      }
      /***/

    },
    /* 388 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isThisISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameISOWeek_index_js__ = __webpack_require__(177);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisISOWeek
       * @category ISO Week Helpers
       * @summary Is the given date in the same ISO week as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same ISO week as the current date?
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
       * var result = isThisISOWeek(new Date(2014, 8, 22))
       * //=> true
       */


      function isThisISOWeek(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameISOWeek_index_js__["a"
        /* default */
        ](dirtyDate, Date.now());
      }
      /***/

    },
    /* 389 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isThisMinute;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameMinute_index_js__ = __webpack_require__(178);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisMinute
       * @category Minute Helpers
       * @summary Is the given date in the same minute as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same minute as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this minute
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If now is 25 September 2014 18:30:15.500,
       * // is 25 September 2014 18:30:00 in this minute?
       * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
       * //=> true
       */


      function isThisMinute(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameMinute_index_js__["a"
        /* default */
        ](Date.now(), dirtyDate);
      }
      /***/

    },
    /* 390 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isThisMonth;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameMonth_index_js__ = __webpack_require__(180);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisMonth
       * @category Month Helpers
       * @summary Is the given date in the same month as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same month as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this month
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 25 September 2014, is 15 September 2014 in this month?
       * var result = isThisMonth(new Date(2014, 8, 15))
       * //=> true
       */


      function isThisMonth(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameMonth_index_js__["a"
        /* default */
        ](Date.now(), dirtyDate);
      }
      /***/

    },
    /* 391 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isThisQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameQuarter_index_js__ = __webpack_require__(181);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisQuarter
       * @category Quarter Helpers
       * @summary Is the given date in the same quarter as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same quarter as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this quarter
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 25 September 2014, is 2 July 2014 in this quarter?
       * var result = isThisQuarter(new Date(2014, 6, 2))
       * //=> true
       */


      function isThisQuarter(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameQuarter_index_js__["a"
        /* default */
        ](Date.now(), dirtyDate);
      }
      /***/

    },
    /* 392 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isThisSecond;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameSecond_index_js__ = __webpack_require__(182);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisSecond
       * @category Second Helpers
       * @summary Is the given date in the same second as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same second as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this second
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If now is 25 September 2014 18:30:15.500,
       * // is 25 September 2014 18:30:15.000 in this second?
       * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
       * //=> true
       */


      function isThisSecond(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameSecond_index_js__["a"
        /* default */
        ](Date.now(), dirtyDate);
      }
      /***/

    },
    /* 393 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isThisWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__ = __webpack_require__(95);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisWeek
       * @category Week Helpers
       * @summary Is the given date in the same week as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same week as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @param {Object} [options] - the object with options
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Boolean} the date is in this week
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // If today is 25 September 2014, is 21 September 2014 in this week?
       * var result = isThisWeek(new Date(2014, 8, 21))
       * //=> true
       *
       * @example
       * // If today is 25 September 2014 and week starts with Monday
       * // is 21 September 2014 in this week?
       * var result = isThisWeek(new Date(2014, 8, 21), { weekStartsOn: 1 })
       * //=> false
       */


      function isThisWeek(dirtyDate, options) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameWeek_index_js__["a"
        /* default */
        ](dirtyDate, Date.now(), options);
      }
      /***/

    },
    /* 394 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isThisYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameYear_index_js__ = __webpack_require__(184);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThisYear
       * @category Year Helpers
       * @summary Is the given date in the same year as the current date?
       * @pure false
       *
       * @description
       * Is the given date in the same year as the current date?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is in this year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 25 September 2014, is 2 July 2014 in this year?
       * var result = isThisYear(new Date(2014, 6, 2))
       * //=> true
       */


      function isThisYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameYear_index_js__["a"
        /* default */
        ](dirtyDate, Date.now());
      }
      /***/

    },
    /* 395 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isThursday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isThursday
       * @category Weekday Helpers
       * @summary Is the given date Thursday?
       *
       * @description
       * Is the given date Thursday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Thursday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 25 September 2014 Thursday?
       * var result = isThursday(new Date(2014, 8, 25))
       * //=> true
       */


      function isThursday(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getDay() === 4;
      }
      /***/

    },
    /* 396 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isToday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__ = __webpack_require__(47);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isToday
       * @category Day Helpers
       * @summary Is the given date today?
       * @pure false
       *
       * @description
       * Is the given date today?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is today
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 6 October 14:00:00 today?
       * var result = isToday(new Date(2014, 9, 6, 14, 0))
       * //=> true
       */


      function isToday(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__["a"
        /* default */
        ](dirtyDate, Date.now());
      }
      /***/

    },
    /* 397 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isTomorrow;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__isSameDay_index_js__ = __webpack_require__(47);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isTomorrow
       * @category Day Helpers
       * @summary Is the given date tomorrow?
       * @pure false
       *
       * @description
       * Is the given date tomorrow?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is tomorrow
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
       * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
       * //=> true
       */


      function isTomorrow(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_1__isSameDay_index_js__["a"
        /* default */
        ](dirtyDate, __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a"
        /* default */
        ](Date.now(), 1));
      }
      /***/

    },
    /* 398 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isTuesday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isTuesday
       * @category Weekday Helpers
       * @summary Is the given date Tuesday?
       *
       * @description
       * Is the given date Tuesday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Tuesday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 23 September 2014 Tuesday?
       * var result = isTuesday(new Date(2014, 8, 23))
       * //=> true
       */


      function isTuesday(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getDay() === 2;
      }
      /***/

    },
    /* 399 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isWednesday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isWednesday
       * @category Weekday Helpers
       * @summary Is the given date Wednesday?
       *
       * @description
       * Is the given date Wednesday?
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is Wednesday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Is 24 September 2014 Wednesday?
       * var result = isWednesday(new Date(2014, 8, 24))
       * //=> true
       */


      function isWednesday(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getDay() === 3;
      }
      /***/

    },
    /* 400 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isWithinInterval;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isWithinInterval
       * @category Interval Helpers
       * @summary Is the given date within the interval?
       *
       * @description
       * Is the given date within the interval? (Including start and end.)
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `isWithinRange` to `isWithinInterval`.
       *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
       *
       *   ```
       *   2.1.3
       *   time interval
       *   part of the time axis limited by two instants
       *   ```
       *
       *   Also, this function now accepts an object with `start` and `end` properties
       *   instead of two arguments as an interval.
       *   This function now throws `RangeError` if the start of the interval is after its end
       *   or if any date in the interval is `Invalid Date`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *
       *   isWithinRange(
       *     new Date(2014, 0, 3),
       *     new Date(2014, 0, 1), new Date(2014, 0, 7)
       *   )
       *
       *   // v2.0.0 onward
       *
       *   isWithinInterval(
       *     new Date(2014, 0, 3),
       *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
       *   )
       *   ```
       *
       * @param {Date|Number} date - the date to check
       * @param {Interval} interval - the interval to check
       * @returns {Boolean} the date is within the interval
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} The start of an interval cannot be after its end
       * @throws {RangeError} Date in interval cannot be `Invalid Date`
       *
       * @example
       * // For the date within the interval:
       * isWithinInterval(new Date(2014, 0, 3), {
       *   start: new Date(2014, 0, 1),
       *   end: new Date(2014, 0, 7)
       * })
       * //=> true
       *
       * @example
       * // For the date outside of the interval:
       * isWithinInterval(new Date(2014, 0, 10), {
       *   start: new Date(2014, 0, 1),
       *   end: new Date(2014, 0, 7)
       * })
       * //=> false
       *
       * @example
       * // For date equal to interval start:
       * isWithinInterval(date, { start, end: date }) // => true
       *
       * @example
       * // For date equal to interval end:
       * isWithinInterval(date, { start: date, end }) // => true
       */


      function isWithinInterval(dirtyDate, dirtyInterval) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var interval = dirtyInterval || {};

        var time = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate).getTime();

        var startTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](interval.start).getTime();

        var endTime = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`


        if (!(startTime <= endTime)) {
          throw new RangeError('Invalid interval');
        }

        return time >= startTime && time <= endTime;
      }
      /***/

    },
    /* 401 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = isYesterday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__ = __webpack_require__(47);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__subDays_index_js__ = __webpack_require__(94);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name isYesterday
       * @category Day Helpers
       * @summary Is the given date yesterday?
       * @pure false
       *
       * @description
       * Is the given date yesterday?
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to check
       * @returns {Boolean} the date is yesterday
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
       * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
       * //=> true
       */


      function isYesterday(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__isSameDay_index_js__["a"
        /* default */
        ](dirtyDate, __WEBPACK_IMPORTED_MODULE_1__subDays_index_js__["a"
        /* default */
        ](Date.now(), 1));
      }
      /***/

    },
    /* 402 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lastDayOfDecade;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfDecade
       * @category Decade Helpers
       * @summary Return the last day of a decade for the given date.
       *
       * @description
       * Return the last day of a decade for the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the last day of a decade
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of a decade for 21 December 2012 21:12:00:
       * var result = lastDayOfDecade(new Date(2012, 11, 21, 21, 12, 00))
       * //=> Wed Dec 31 2019 00:00:00
       */


      function lastDayOfDecade(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        var decade = 9 + Math.floor(year / 10) * 10;
        date.setFullYear(decade + 1, 0, 0);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 403 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lastDayOfISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lastDayOfWeek_index_js__ = __webpack_require__(185);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfISOWeek
       * @category ISO Week Helpers
       * @summary Return the last day of an ISO week for the given date.
       *
       * @description
       * Return the last day of an ISO week for the given date.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the last day of an ISO week
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of an ISO week for 2 September 2014 11:55:00:
       * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Sun Sep 07 2014 00:00:00
       */


      function lastDayOfISOWeek(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        return __WEBPACK_IMPORTED_MODULE_0__lastDayOfWeek_index_js__["a"
        /* default */
        ](dirtyDate, {
          weekStartsOn: 1
        });
      }
      /***/

    },
    /* 404 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lastDayOfISOWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__ = __webpack_require__(34);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__ = __webpack_require__(25);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfISOWeekYear
       * @category ISO Week-Numbering Year Helpers
       * @summary Return the last day of an ISO week-numbering year for the given date.
       *
       * @description
       * Return the last day of an ISO week-numbering year,
       * which always starts 3 days before the year's first Thursday.
       * The result will be in the local timezone.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The function was renamed from `lastDayOfISOYear` to `lastDayOfISOWeekYear`.
       *   "ISO week year" is short for [ISO week-numbering year](https://en.wikipedia.org/wiki/ISO_week_date).
       *   This change makes the name consistent with
       *   locale-dependent week-numbering year helpers, e.g., `getWeekYear`.
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the end of an ISO week-numbering year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of an ISO week-numbering year for 2 July 2005:
       * var result = lastDayOfISOWeekYear(new Date(2005, 6, 2))
       * //=> Sun Jan 01 2006 00:00:00
       */


      function lastDayOfISOWeekYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var year = __WEBPACK_IMPORTED_MODULE_0__getISOWeekYear_index_js__["a"
        /* default */
        ](dirtyDate);

        var fourthOfJanuary = new Date(0);
        fourthOfJanuary.setFullYear(year + 1, 0, 4);
        fourthOfJanuary.setHours(0, 0, 0, 0);

        var date = __WEBPACK_IMPORTED_MODULE_1__startOfISOWeek_index_js__["a"
        /* default */
        ](fourthOfJanuary);

        date.setDate(date.getDate() - 1);
        return date;
      }
      /***/

    },
    /* 405 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lastDayOfQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfQuarter
       * @category Quarter Helpers
       * @summary Return the last day of a year quarter for the given date.
       *
       * @description
       * Return the last day of a year quarter for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @param {Object} [options] - an object with options.
       * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
       * @returns {Date} the last day of a quarter
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
       *
       * @example
       * // The last day of a quarter for 2 September 2014 11:55:00:
       * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
       * //=> Tue Sep 30 2014 00:00:00
       */


      function lastDayOfQuarter(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var currentMonth = date.getMonth();
        var month = currentMonth - currentMonth % 3 + 3;
        date.setMonth(month, 0);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 406 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lastDayOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name lastDayOfYear
       * @category Year Helpers
       * @summary Return the last day of a year for the given date.
       *
       * @description
       * Return the last day of a year for the given date.
       * The result will be in the local timezone.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the last day of a year
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The last day of a year for 2 September 2014 11:55:00:
       * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
       * //=> Wed Dec 31 2014 00:00:00
       */


      function lastDayOfYear(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        date.setFullYear(year + 1, 0, 0);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 407 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = lightFormat;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_format_lightFormatters_index_js__ = __webpack_require__(152);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(19);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__isValid_index_js__ = __webpack_require__(15);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__subMilliseconds_index_js__ = __webpack_require__(49);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__lib_requiredArgs_index_js__ = __webpack_require__(0); // This RegExp consists of three parts separated by `|`:
      // - (\w)\1* matches any sequences of the same letter
      // - '' matches two quote characters in a row
      // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
      //   except a single quote symbol, which ends the sequence.
      //   Two quote characters do not end the sequence.
      //   If there is no matching single quote
      //   then the sequence will continue until the end of the string.
      // - . matches any single character unmatched by previous parts of the RegExps


      var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
      var escapedStringRegExp = /^'([^]*?)'?$/;
      var doubleQuoteRegExp = /''/g;
      var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
      /**
       * @name lightFormat
       * @category Common Helpers
       * @summary Format the date.
       *
       * @description
       * Return the formatted date string in the given format. Unlike `format`,
       * `lightFormat` doesn't use locales and outputs date using the most popular tokens.
       *
       * > ⚠️ Please note that the `lightFormat` tokens differ from Moment.js and other libraries.
       * > See: https://git.io/fxCyr
       *
       * The characters wrapped between two single quotes characters (') are escaped.
       * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
       *
       * Format of the string is based on Unicode Technical Standard #35:
       * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
       *
       * Accepted patterns:
       * | Unit                            | Pattern | Result examples                   |
       * |---------------------------------|---------|-----------------------------------|
       * | AM, PM                          | a..aaa  | AM, PM                            |
       * |                                 | aaaa    | a.m., p.m.                        |
       * |                                 | aaaaa   | a, p                              |
       * | Calendar year                   | y       | 44, 1, 1900, 2017                 |
       * |                                 | yy      | 44, 01, 00, 17                    |
       * |                                 | yyy     | 044, 001, 000, 017                |
       * |                                 | yyyy    | 0044, 0001, 1900, 2017            |
       * | Month (formatting)              | M       | 1, 2, ..., 12                     |
       * |                                 | MM      | 01, 02, ..., 12                   |
       * | Day of month                    | d       | 1, 2, ..., 31                     |
       * |                                 | dd      | 01, 02, ..., 31                   |
       * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |
       * |                                 | hh      | 01, 02, ..., 11, 12               |
       * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |
       * |                                 | HH      | 00, 01, 02, ..., 23               |
       * | Minute                          | m       | 0, 1, ..., 59                     |
       * |                                 | mm      | 00, 01, ..., 59                   |
       * | Second                          | s       | 0, 1, ..., 59                     |
       * |                                 | ss      | 00, 01, ..., 59                   |
       * | Fraction of second              | S       | 0, 1, ..., 9                      |
       * |                                 | SS      | 00, 01, ..., 99                   |
       * |                                 | SSS     | 000, 0001, ..., 999               |
       * |                                 | SSSS    | ...                               |
       *
       * @param {Date|Number} date - the original date
       * @param {String} format - the string of tokens
       * @returns {String} the formatted date string
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} format string contains an unescaped latin alphabet character
       *
       * @example
       * var result = lightFormat(new Date(2014, 1, 11), 'yyyy-MM-dd')
       * //=> '2014-02-11'
       */

      function lightFormat(dirtyDate, dirtyFormatStr) {
        __WEBPACK_IMPORTED_MODULE_5__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var formatStr = String(dirtyFormatStr);

        var originalDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        if (!__WEBPACK_IMPORTED_MODULE_3__isValid_index_js__["a"
        /* default */
        ](originalDate)) {
          throw new RangeError('Invalid time value');
        } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
        // This ensures that when UTC functions will be implemented, locales will be compatible with them.
        // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


        var timezoneOffset = __WEBPACK_IMPORTED_MODULE_2__lib_getTimezoneOffsetInMilliseconds_index_js__["a"
        /* default */
        ](originalDate);

        var utcDate = __WEBPACK_IMPORTED_MODULE_4__subMilliseconds_index_js__["a"
        /* default */
        ](originalDate, timezoneOffset);

        var result = formatStr.match(formattingTokensRegExp).map(function (substring) {
          // Replace two single quote characters with one single quote character
          if (substring === "''") {
            return "'";
          }

          var firstCharacter = substring[0];

          if (firstCharacter === "'") {
            return cleanEscapedString(substring);
          }

          var formatter = __WEBPACK_IMPORTED_MODULE_1__lib_format_lightFormatters_index_js__["a"
          /* default */
          ][firstCharacter];

          if (formatter) {
            return formatter(utcDate, substring, null, {});
          }

          if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
            throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
          }

          return substring;
        }).join('');
        return result;
      }

      function cleanEscapedString(input) {
        return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
      }
      /***/

    },
    /* 408 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = max;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name max
       * @category Common Helpers
       * @summary Return the latest of the given dates.
       *
       * @description
       * Return the latest of the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - `max` function now accepts an array of dates rather than spread arguments.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   var date1 = new Date(1989, 6, 10)
       *   var date2 = new Date(1987, 1, 11)
       *   var maxDate = max(date1, date2)
       *
       *   // v2.0.0 onward:
       *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
       *   var maxDate = max(dates)
       *   ```
       *
       * @param {Date[]|Number[]} datesArray - the dates to compare
       * @returns {Date} the latest of the dates
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which of these dates is the latest?
       * var result = max([
       *   new Date(1989, 6, 10),
       *   new Date(1987, 1, 11),
       *   new Date(1995, 6, 2),
       *   new Date(1990, 0, 1)
       * ])
       * //=> Sun Jul 02 1995 00:00:00
       */


      function max(dirtyDatesArray) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

        if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
          datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
        } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
          datesArray = Array.prototype.slice.call(dirtyDatesArray);
        } else {
          // `dirtyDatesArray` is non-iterable, return Invalid Date
          return new Date(NaN);
        }

        var result;
        datesArray.forEach(function (dirtyDate) {
          var currentDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ](dirtyDate);

          if (result === undefined || result < currentDate || isNaN(currentDate)) {
            result = currentDate;
          }
        });
        return result || new Date(NaN);
      }
      /***/

    },
    /* 409 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = min;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name min
       * @category Common Helpers
       * @summary Return the earliest of the given dates.
       *
       * @description
       * Return the earliest of the given dates.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - `min` function now accepts an array of dates rather than spread arguments.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   var date1 = new Date(1989, 6, 10)
       *   var date2 = new Date(1987, 1, 11)
       *   var minDate = min(date1, date2)
       *
       *   // v2.0.0 onward:
       *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
       *   var minDate = min(dates)
       *   ```
       *
       * @param {Date[]|Number[]} datesArray - the dates to compare
       * @returns {Date} the earliest of the dates
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // Which of these dates is the earliest?
       * var result = min([
       *   new Date(1989, 6, 10),
       *   new Date(1987, 1, 11),
       *   new Date(1995, 6, 2),
       *   new Date(1990, 0, 1)
       * ])
       * //=> Wed Feb 11 1987 00:00:00
       */


      function min(dirtyDatesArray) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

        if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
          datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
        } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
          datesArray = Array.prototype.slice.call(dirtyDatesArray);
        } else {
          // `dirtyDatesArray` is non-iterable, return Invalid Date
          return new Date(NaN);
        }

        var result;
        datesArray.forEach(function (dirtyDate) {
          var currentDate = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
          /* default */
          ](dirtyDate);

          if (result === undefined || result > currentDate || isNaN(currentDate)) {
            result = currentDate;
          }
        });
        return result || new Date(NaN);
      }
      /***/

    },
    /* 410 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = parseISO;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);

      var MILLISECONDS_IN_HOUR = 3600000;
      var MILLISECONDS_IN_MINUTE = 60000;
      var DEFAULT_ADDITIONAL_DIGITS = 2;
      var patterns = {
        dateTimeDelimiter: /[T ]/,
        timeZoneDelimiter: /[Z ]/i,
        timezone: /([Z+-].*)$/
      };
      var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
      var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
      var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
      /**
       * @name parseISO
       * @category Common Helpers
       * @summary Parse ISO string
       *
       * @description
       * Parse the given string in ISO 8601 format and return an instance of Date.
       *
       * Function accepts complete ISO 8601 formats as well as partial implementations.
       * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
       *
       * If the argument isn't a string, the function cannot parse the string or
       * the values are invalid, it returns Invalid Date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * - The previous `parse` implementation was renamed to `parseISO`.
       *
       *   ```javascript
       *   // Before v2.0.0
       *   parse('2016-01-01')
       *
       *   // v2.0.0 onward
       *   parseISO('2016-01-01')
       *   ```
       *
       * - `parseISO` now validates separate date and time values in ISO-8601 strings
       *   and returns `Invalid Date` if the date is invalid.
       *
       *   ```javascript
       *   parseISO('2018-13-32')
       *   //=> Invalid Date
       *   ```
       *
       * - `parseISO` now doesn't fall back to `new Date` constructor
       *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
       *
       * @param {String} argument - the value to convert
       * @param {Object} [options] - an object with options.
       * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
       * @returns {Date} the parsed date in the local time zone
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
       *
       * @example
       * // Convert string '2014-02-11T11:30:30' to date:
       * var result = parseISO('2014-02-11T11:30:30')
       * //=> Tue Feb 11 2014 11:30:30
       *
       * @example
       * // Convert string '+02014101' to date,
       * // if the additional number of digits in the extended year format is 1:
       * var result = parseISO('+02014101', { additionalDigits: 1 })
       * //=> Fri Apr 11 2014 00:00:00
       */

      function parseISO(argument, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var options = dirtyOptions || {};
        var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](options.additionalDigits);

        if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
          throw new RangeError('additionalDigits must be 0, 1 or 2');
        }

        if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
          return new Date(NaN);
        }

        var dateStrings = splitDateString(argument);
        var date;

        if (dateStrings.date) {
          var parseYearResult = parseYear(dateStrings.date, additionalDigits);
          date = parseDate(parseYearResult.restDateString, parseYearResult.year);
        }

        if (isNaN(date) || !date) {
          return new Date(NaN);
        }

        var timestamp = date.getTime();
        var time = 0;
        var offset;

        if (dateStrings.time) {
          time = parseTime(dateStrings.time);

          if (isNaN(time) || time === null) {
            return new Date(NaN);
          }
        }

        if (dateStrings.timezone) {
          offset = parseTimezone(dateStrings.timezone);

          if (isNaN(offset)) {
            return new Date(NaN);
          }
        } else {
          var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
          // but we need it to be parsed in our timezone
          // so we use utc values to build date in our timezone.
          // Year values from 0 to 99 map to the years 1900 to 1999
          // so set year explicitly with setFullYear.

          var result = new Date(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate(), dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
          result.setFullYear(dirtyDate.getUTCFullYear());
          return result;
        }

        return new Date(timestamp + time + offset);
      }

      function splitDateString(dateString) {
        var dateStrings = {};
        var array = dateString.split(patterns.dateTimeDelimiter);
        var timeString; // The regex match should only return at maximum two array elements.
        // [date], [time], or [date, time].

        if (array.length > 2) {
          return dateStrings;
        }

        if (/:/.test(array[0])) {
          dateStrings.date = null;
          timeString = array[0];
        } else {
          dateStrings.date = array[0];
          timeString = array[1];

          if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
          }
        }

        if (timeString) {
          var token = patterns.timezone.exec(timeString);

          if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
          } else {
            dateStrings.time = timeString;
          }
        }

        return dateStrings;
      }

      function parseYear(dateString, additionalDigits) {
        var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
        var captures = dateString.match(regex); // Invalid ISO-formatted year

        if (!captures) return {
          year: null
        };
        var year = captures[1] && parseInt(captures[1]);
        var century = captures[2] && parseInt(captures[2]);
        return {
          year: century == null ? year : century * 100,
          restDateString: dateString.slice((captures[1] || captures[2]).length)
        };
      }

      function parseDate(dateString, year) {
        // Invalid ISO-formatted year
        if (year === null) return null;
        var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

        if (!captures) return null;
        var isWeekDate = !!captures[4];
        var dayOfYear = parseDateUnit(captures[1]);
        var month = parseDateUnit(captures[2]) - 1;
        var day = parseDateUnit(captures[3]);
        var week = parseDateUnit(captures[4]);
        var dayOfWeek = parseDateUnit(captures[5]) - 1;

        if (isWeekDate) {
          if (!validateWeekDate(year, week, dayOfWeek)) {
            return new Date(NaN);
          }

          return dayOfISOWeekYear(year, week, dayOfWeek);
        } else {
          var date = new Date(0);

          if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
            return new Date(NaN);
          }

          date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
          return date;
        }
      }

      function parseDateUnit(value) {
        return value ? parseInt(value) : 1;
      }

      function parseTime(timeString) {
        var captures = timeString.match(timeRegex);
        if (!captures) return null; // Invalid ISO-formatted time

        var hours = parseTimeUnit(captures[1]);
        var minutes = parseTimeUnit(captures[2]);
        var seconds = parseTimeUnit(captures[3]);

        if (!validateTime(hours, minutes, seconds)) {
          return NaN;
        }

        return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
      }

      function parseTimeUnit(value) {
        return value && parseFloat(value.replace(',', '.')) || 0;
      }

      function parseTimezone(timezoneString) {
        if (timezoneString === 'Z') return 0;
        var captures = timezoneString.match(timezoneRegex);
        if (!captures) return 0;
        var sign = captures[1] === '+' ? -1 : 1;
        var hours = parseInt(captures[2]);
        var minutes = captures[3] && parseInt(captures[3]) || 0;

        if (!validateTimezone(hours, minutes)) {
          return NaN;
        }

        return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
      }

      function dayOfISOWeekYear(isoWeekYear, week, day) {
        var date = new Date(0);
        date.setUTCFullYear(isoWeekYear, 0, 4);
        var fourthOfJanuaryDay = date.getUTCDay() || 7;
        var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
        date.setUTCDate(date.getUTCDate() + diff);
        return date;
      } // Validation functions
      // February is null to handle the leap year (using ||)


      var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      function isLeapYearIndex(year) {
        return year % 400 === 0 || year % 4 === 0 && year % 100;
      }

      function validateDate(year, month, date) {
        return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
      }

      function validateDayOfYearDate(year, dayOfYear) {
        return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
      }

      function validateWeekDate(_year, week, day) {
        return week >= 1 && week <= 53 && day >= 0 && day <= 6;
      }

      function validateTime(hours, minutes, seconds) {
        if (hours === 24) {
          return minutes === 0 && seconds === 0;
        }

        return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
      }

      function validateTimezone(_hours, minutes) {
        return minutes >= 0 && minutes <= 59;
      }
      /***/

    },
    /* 411 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = parseJSON;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name parseJSON
       * @category Common Helpers
       * @summary Parse a JSON date string
       *
       * @description
       * Converts a complete ISO date string in UTC time, the typical format for transmitting
       * a date in JSON, to a JavaScript `Date` instance.
       *
       * This is a minimal implementation for converting dates retrieved from a JSON API to
       * a `Date` instance which can be used with other functions in the `date-fns` library.
       * The following formats are supported:
       *
       * - `2000-03-15T05:20:10.123Z`: The output of `.toISOString()` and `JSON.stringify(new Date())`
       * - `2000-03-15T05:20:10Z`: Without milliseconds
       * - `2000-03-15T05:20:10+00:00`: With a zero offset, the default JSON encoded format in some other languages
       * - `2000-03-15T05:20:10+0000`: With a zero offset without a colon
       * - `2000-03-15T05:20:10`: Without a trailing 'Z' symbol
       * - `2000-03-15T05:20:10.1234567`: Up to 7 digits in milliseconds field. Only first 3 are taken into account since JS does not allow fractional milliseconds
       * - `2000-03-15 05:20:10`: With a space instead of a 'T' separator for APIs returning a SQL date without reformatting
       *
       * For convenience and ease of use these other input types are also supported
       * via [toDate]{@link https://date-fns.org/docs/toDate}:
       *
       * - A `Date` instance will be cloned
       * - A `number` will be treated as a timestamp
       *
       * Any other input type or invalid date strings will return an `Invalid Date`.
       *
       * @param {String|Number|Date} argument A fully formed ISO8601 date string to convert
       * @returns {Date} the parsed date in the local time zone
       * @throws {TypeError} 1 argument required
       */


      function parseJSON(argument) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        if (typeof argument === 'string') {
          var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|\+00:?00)?/);

          if (parts) {
            return new Date(Date.UTC(+parts[1], parts[2] - 1, +parts[3], +parts[4], +parts[5], +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
          }

          return new Date(NaN);
        }

        return __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](argument);
      }
      /***/

    },
    /* 412 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = roundToNearestMinutes;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(6);
      /**
       * @name roundToNearestMinutes
       * @category Minute Helpers
       * @summary Rounds the given date to the nearest minute
       *
       * @description
       * Rounds the given date to the nearest minute (or number of minutes).
       * Rounds up when the given date is exactly between the nearest round minutes.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to round
       * @param {Object} [options] - an object with options.
       * @param {Number} [options.nearestTo=1] - nearest number of minutes to round to. E.g. `15` to round to quarter hours.
       * @returns {Date} the new date rounded to the closest minute
       * @throws {TypeError} 1 argument required
       * @throws {RangeError} `options.nearestTo` must be between 1 and 30
       *
       * @example
       * // Round 10 July 2014 12:12:34 to nearest minute:
       * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34))
       * //=> Thu Jul 10 2014 12:13:00
       *
       * @example
       * // Round 10 July 2014 12:07:30 to nearest quarter hour:
       * var result = roundToNearestMinutes(new Date(2014, 6, 10, 12, 12, 34), { nearestTo: 15 })
       * // rounds up because given date is exactly between 12:00:00 and 12:15:00
       * //=> Thu Jul 10 2014 12:15:00
       */


      function roundToNearestMinutes(dirtyDate, options) {
        if (arguments.length < 1) {
          throw new TypeError('1 argument required, but only none provided present');
        }

        var nearestTo = options && 'nearestTo' in options ? __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a"
        /* default */
        ](options.nearestTo) : 1;

        if (nearestTo < 1 || nearestTo > 30) {
          throw new RangeError('`options.nearestTo` must be between 1 and 30');
        }

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case

        var minutes = date.getMinutes() + seconds / 60;
        var roundedMinutes = Math.floor(minutes / nearestTo) * nearestTo;
        var remainderMinutes = minutes % nearestTo;
        var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
      }
      /***/

    },
    /* 413 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = set;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__setMonth_index_js__ = __webpack_require__(96);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name set
       * @category Common Helpers
       * @summary Set date values to a given date.
       *
       * @description
       * Set date values to a given date.
       *
       * Sets time values to date from object `values`.
       * A value is not set if it is undefined or null or doesn't exist in `values`.
       *
       * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
       * to use native `Date#setX` methods. If you use this function, you may not want to include the
       * other `setX` functions that date-fns provides if you are concerned about the bundle size.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Object} values - an object with options
       * @param {Number} [values.year] - the number of years to be set
       * @param {Number} [values.month] - the number of months to be set
       * @param {Number} [values.date] - the number of days to be set
       * @param {Number} [values.hours] - the number of hours to be set
       * @param {Number} [values.minutes] - the number of minutes to be set
       * @param {Number} [values.seconds] - the number of seconds to be set
       * @param {Number} [values.milliseconds] - the number of milliseconds to be set
       * @returns {Date} the new date with options set
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `values` must be an object
       *
       * @example
       * // Transform 1 September 2014 into 20 October 2015 in a single line:
       * var result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
       * //=> Tue Oct 20 2015 00:00:00
       *
       * @example
       * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
       * var result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
       * //=> Mon Sep 01 2014 12:23:45
       */


      function set(dirtyDate, values) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        if (typeof values !== 'object' || values === null) {
          throw new RangeError('values parameter must be an object');
        }

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date


        if (isNaN(date)) {
          return new Date(NaN);
        }

        if (values.year != null) {
          date.setFullYear(values.year);
        }

        if (values.month != null) {
          date = __WEBPACK_IMPORTED_MODULE_1__setMonth_index_js__["a"
          /* default */
          ](date, values.month);
        }

        if (values.date != null) {
          date.setDate(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ](values.date));
        }

        if (values.hours != null) {
          date.setHours(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ](values.hours));
        }

        if (values.minutes != null) {
          date.setMinutes(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ](values.minutes));
        }

        if (values.seconds != null) {
          date.setSeconds(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ](values.seconds));
        }

        if (values.milliseconds != null) {
          date.setMilliseconds(__WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
          /* default */
          ](values.milliseconds));
        }

        return date;
      }
      /***/

    },
    /* 414 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setDate;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setDate
       * @category Day Helpers
       * @summary Set the day of the month to the given date.
       *
       * @description
       * Set the day of the month to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} dayOfMonth - the day of the month of the new date
       * @returns {Date} the new date with the day of the month set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set the 30th day of the month to 1 September 2014:
       * var result = setDate(new Date(2014, 8, 1), 30)
       * //=> Tue Sep 30 2014 00:00:00
       */


      function setDate(dirtyDate, dirtyDayOfMonth) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var dayOfMonth = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyDayOfMonth);

        date.setDate(dayOfMonth);
        return date;
      }
      /***/

    },
    /* 415 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setDay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setDay
       * @category Weekday Helpers
       * @summary Set the day of the week to the given date.
       *
       * @description
       * Set the day of the week to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} day - the day of the week of the new date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @returns {Date} the new date with the day of the week set
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       *
       * @example
       * // Set week day to Sunday, with the default weekStartsOn of Sunday:
       * var result = setDay(new Date(2014, 8, 1), 0)
       * //=> Sun Aug 31 2014 00:00:00
       *
       * @example
       * // Set week day to Sunday, with a weekStartsOn of Monday:
       * var result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
       * //=> Sun Sep 07 2014 00:00:00
       */


      function setDay(dirtyDate, dirtyDay, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
        var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](localeWeekStartsOn);
        var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

        if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
          throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
        }

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate, options);

        var day = __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyDay);

        var currentDay = date.getDay();
        var remainder = day % 7;
        var dayIndex = (remainder + 7) % 7;
        var delta = 7 - weekStartsOn;
        var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
        return __WEBPACK_IMPORTED_MODULE_0__addDays_index_js__["a"
        /* default */
        ](date, diff, options);
      }
      /***/

    },
    /* 416 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setDayOfYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setDayOfYear
       * @category Day Helpers
       * @summary Set the day of the year to the given date.
       *
       * @description
       * Set the day of the year to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} dayOfYear - the day of the year of the new date
       * @returns {Date} the new date with the day of the year set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set the 2nd day of the year to 2 July 2014:
       * var result = setDayOfYear(new Date(2014, 6, 2), 2)
       * //=> Thu Jan 02 2014 00:00:00
       */


      function setDayOfYear(dirtyDate, dirtyDayOfYear) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var dayOfYear = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyDayOfYear);

        date.setMonth(0);
        date.setDate(dayOfYear);
        return date;
      }
      /***/

    },
    /* 417 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setHours;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setHours
       * @category Hour Helpers
       * @summary Set the hours to the given date.
       *
       * @description
       * Set the hours to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} hours - the hours of the new date
       * @returns {Date} the new date with the hours set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set 4 hours to 1 September 2014 11:30:00:
       * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
       * //=> Mon Sep 01 2014 04:30:00
       */


      function setHours(dirtyDate, dirtyHours) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var hours = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyHours);

        date.setHours(hours);
        return date;
      }
      /***/

    },
    /* 418 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setISODay;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__addDays_index_js__ = __webpack_require__(21);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__getISODay_index_js__ = __webpack_require__(166);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setISODay
       * @category Weekday Helpers
       * @summary Set the day of the ISO week to the given date.
       *
       * @description
       * Set the day of the ISO week to the given date.
       * ISO week starts with Monday.
       * 7 is the index of Sunday, 1 is the index of Monday etc.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} day - the day of the ISO week of the new date
       * @returns {Date} the new date with the day of the ISO week set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set Sunday to 1 September 2014:
       * var result = setISODay(new Date(2014, 8, 1), 7)
       * //=> Sun Sep 07 2014 00:00:00
       */


      function setISODay(dirtyDate, dirtyDay) {
        __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var day = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyDay);

        var currentDay = __WEBPACK_IMPORTED_MODULE_3__getISODay_index_js__["a"
        /* default */
        ](date);

        var diff = day - currentDay;
        return __WEBPACK_IMPORTED_MODULE_2__addDays_index_js__["a"
        /* default */
        ](date, diff);
      }
      /***/

    },
    /* 419 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setISOWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__getISOWeek_index_js__ = __webpack_require__(167);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setISOWeek
       * @category ISO Week Helpers
       * @summary Set the ISO week to the given date.
       *
       * @description
       * Set the ISO week to the given date, saving the weekday number.
       *
       * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} isoWeek - the ISO week of the new date
       * @returns {Date} the new date with the ISO week set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set the 53rd ISO week to 7 August 2004:
       * var result = setISOWeek(new Date(2004, 7, 7), 53)
       * //=> Sat Jan 01 2005 00:00:00
       */


      function setISOWeek(dirtyDate, dirtyISOWeek) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var isoWeek = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyISOWeek);

        var diff = __WEBPACK_IMPORTED_MODULE_2__getISOWeek_index_js__["a"
        /* default */
        ](date) - isoWeek;
        date.setDate(date.getDate() - diff * 7);
        return date;
      }
      /***/

    },
    /* 420 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setMilliseconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setMilliseconds
       * @category Millisecond Helpers
       * @summary Set the milliseconds to the given date.
       *
       * @description
       * Set the milliseconds to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} milliseconds - the milliseconds of the new date
       * @returns {Date} the new date with the milliseconds set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
       * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
       * //=> Mon Sep 01 2014 11:30:40.300
       */


      function setMilliseconds(dirtyDate, dirtyMilliseconds) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var milliseconds = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyMilliseconds);

        date.setMilliseconds(milliseconds);
        return date;
      }
      /***/

    },
    /* 421 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setMinutes;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setMinutes
       * @category Minute Helpers
       * @summary Set the minutes to the given date.
       *
       * @description
       * Set the minutes to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} minutes - the minutes of the new date
       * @returns {Date} the new date with the minutes set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set 45 minutes to 1 September 2014 11:30:40:
       * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
       * //=> Mon Sep 01 2014 11:45:40
       */


      function setMinutes(dirtyDate, dirtyMinutes) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var minutes = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyMinutes);

        date.setMinutes(minutes);
        return date;
      }
      /***/

    },
    /* 422 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setQuarter;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__ = __webpack_require__(96);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setQuarter
       * @category Quarter Helpers
       * @summary Set the year quarter to the given date.
       *
       * @description
       * Set the year quarter to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} quarter - the quarter of the new date
       * @returns {Date} the new date with the quarter set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set the 2nd quarter to 2 July 2014:
       * var result = setQuarter(new Date(2014, 6, 2), 2)
       * //=> Wed Apr 02 2014 00:00:00
       */


      function setQuarter(dirtyDate, dirtyQuarter) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var quarter = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyQuarter);

        var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
        var diff = quarter - oldQuarter;
        return __WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__["a"
        /* default */
        ](date, date.getMonth() + diff * 3);
      }
      /***/

    },
    /* 423 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setSeconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setSeconds
       * @category Second Helpers
       * @summary Set the seconds to the given date.
       *
       * @description
       * Set the seconds to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} seconds - the seconds of the new date
       * @returns {Date} the new date with the seconds set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set 45 seconds to 1 September 2014 11:30:40:
       * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
       * //=> Mon Sep 01 2014 11:30:45
       */


      function setSeconds(dirtyDate, dirtySeconds) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var seconds = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtySeconds);

        date.setSeconds(seconds);
        return date;
      }
      /***/

    },
    /* 424 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setWeek;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__getWeek_index_js__ = __webpack_require__(169);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setWeek
       * @category Week Helpers
       * @summary Set the local week to the given date.
       *
       * @description
       * Set the local week to the given date, saving the weekday number.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} week - the week of the new date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Date} the new date with the local week set
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // Set the 1st week to 2 January 2005 with default options:
       * var result = setWeek(new Date(2005, 0, 2), 1)
       * //=> Sun Dec 26 2004 00:00:00
       *
       * @example
       * // Set the 1st week to 2 January 2005,
       * // if Monday is the first day of the week,
       * // and the first week of the year always contains 4 January:
       * var result = setWeek(new Date(2005, 0, 2), 1, {
       *   weekStartsOn: 1,
       *   firstWeekContainsDate: 4
       * })
       * //=> Sun Jan 4 2004 00:00:00
       */


      function setWeek(dirtyDate, dirtyWeek, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_3__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var week = __WEBPACK_IMPORTED_MODULE_2__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyWeek);

        var diff = __WEBPACK_IMPORTED_MODULE_0__getWeek_index_js__["a"
        /* default */
        ](date, dirtyOptions) - week;
        date.setDate(date.getDate() - diff * 7);
        return date;
      }
      /***/

    },
    /* 425 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setWeekYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__ = __webpack_require__(26);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__ = __webpack_require__(93);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setWeekYear
       * @category Week-Numbering Year Helpers
       * @summary Set the local week-numbering year to the given date.
       *
       * @description
       * Set the local week-numbering year to the given date,
       * saving the week number and the weekday number.
       * The exact calculation depends on the values of
       * `options.weekStartsOn` (which is the index of the first day of the week)
       * and `options.firstWeekContainsDate` (which is the day of January, which is always in
       * the first week of the week-numbering year)
       *
       * Week numbering: https://en.wikipedia.org/wiki/Week#Week_numbering
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} weekYear - the local week-numbering year of the new date
       * @param {Object} [options] - an object with options.
       * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
       * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
       * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
       * @returns {Date} the new date with the local week-numbering year set
       * @throws {TypeError} 2 arguments required
       * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
       * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
       *
       * @example
       * // Set the local week-numbering year 2004 to 2 January 2010 with default options:
       * var result = setWeekYear(new Date(2010, 0, 2), 2004)
       * //=> Sat Jan 03 2004 00:00:00
       *
       * @example
       * // Set the local week-numbering year 2004 to 2 January 2010,
       * // if Monday is the first day of week
       * // and 4 January is always in the first week of the year:
       * var result = setWeekYear(new Date(2010, 0, 2), 2004, {
       *   weekStartsOn: 1,
       *   firstWeekContainsDate: 4
       * })
       * //=> Sat Jan 01 2005 00:00:00
       */


      function setWeekYear(dirtyDate, dirtyWeekYear, dirtyOptions) {
        __WEBPACK_IMPORTED_MODULE_4__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var options = dirtyOptions || {};
        var locale = options.locale;
        var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
        var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ](localeFirstWeekContainsDate);
        var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ](options.firstWeekContainsDate);

        var date = __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var weekYear = __WEBPACK_IMPORTED_MODULE_3__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyWeekYear);

        var diff = __WEBPACK_IMPORTED_MODULE_0__differenceInCalendarDays_index_js__["a"
        /* default */
        ](date, __WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__["a"
        /* default */
        ](date, dirtyOptions));

        var firstWeek = new Date(0);
        firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
        firstWeek.setHours(0, 0, 0, 0);
        date = __WEBPACK_IMPORTED_MODULE_1__startOfWeekYear_index_js__["a"
        /* default */
        ](firstWeek, dirtyOptions);
        date.setDate(date.getDate() + diff);
        return date;
      }
      /***/

    },
    /* 426 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = setYear;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name setYear
       * @category Year Helpers
       * @summary Set the year to the given date.
       *
       * @description
       * Set the year to the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} year - the year of the new date
       * @returns {Date} the new date with the year set
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Set year 2013 to 1 September 2014:
       * var result = setYear(new Date(2014, 8, 1), 2013)
       * //=> Sun Sep 01 2013 00:00:00
       */


      function setYear(dirtyDate, dirtyYear) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date


        if (isNaN(date)) {
          return new Date(NaN);
        }

        date.setFullYear(year);
        return date;
      }
      /***/

    },
    /* 427 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfDecade;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(1);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name startOfDecade
       * @category Decade Helpers
       * @summary Return the start of a decade for the given date.
       *
       * @description
       * Return the start of a decade for the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the original date
       * @returns {Date} the start of a decade
       * @throws {TypeError} 1 argument required
       *
       * @example
       * // The start of a decade for 21 October 2015 00:00:00:
       * var result = startOfDecade(new Date(2015, 9, 21, 00, 00, 00))
       * //=> Jan 01 2010 00:00:00
       */


      function startOfDecade(dirtyDate) {
        __WEBPACK_IMPORTED_MODULE_1__lib_requiredArgs_index_js__["a"
        /* default */
        ](1, arguments);

        var date = __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["a"
        /* default */
        ](dirtyDate);

        var year = date.getFullYear();
        var decade = Math.floor(year / 10) * 10;
        date.setFullYear(decade, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 428 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfToday;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(57);
      /**
       * @name startOfToday
       * @category Day Helpers
       * @summary Return the start of today.
       * @pure false
       *
       * @description
       * Return the start of today.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `Date.now()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the start of today
       *
       * @example
       * // If today is 6 October 2014:
       * var result = startOfToday()
       * //=> Mon Oct 6 2014 00:00:00
       */


      function startOfToday() {
        return __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["a"
        /* default */
        ](Date.now());
      }
      /***/

    },
    /* 429 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfTomorrow;
      /**
       * @name startOfTomorrow
       * @category Day Helpers
       * @summary Return the start of tomorrow.
       * @pure false
       *
       * @description
       * Return the start of tomorrow.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `new Date()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the start of tomorrow
       *
       * @example
       * // If today is 6 October 2014:
       * var result = startOfTomorrow()
       * //=> Tue Oct 7 2014 00:00:00
       */

      function startOfTomorrow() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var day = now.getDate();
        var date = new Date(0);
        date.setFullYear(year, month, day + 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 430 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = startOfYesterday;
      /**
       * @name startOfYesterday
       * @category Day Helpers
       * @summary Return the start of yesterday.
       * @pure false
       *
       * @description
       * Return the start of yesterday.
       *
       * > ⚠️ Please note that this function is not present in the FP submodule as
       * > it uses `new Date()` internally hence impure and can't be safely curried.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @returns {Date} the start of yesterday
       *
       * @example
       * // If today is 6 October 2014:
       * var result = startOfYesterday()
       * //=> Sun Oct 5 2014 00:00:00
       */

      function startOfYesterday() {
        var now = new Date();
        var year = now.getFullYear();
        var month = now.getMonth();
        var day = now.getDate();
        var date = new Date(0);
        date.setFullYear(year, month, day - 1);
        date.setHours(0, 0, 0, 0);
        return date;
      }
      /***/

    },
    /* 431 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subBusinessDays;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addBusinessDays_index_js__ = __webpack_require__(132);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subBusinessDays
       * @category Day Helpers
       * @summary Substract the specified number of business days (mon - fri) to the given date.
       *
       * @description
       * Substract the specified number of business days (mon - fri) to the given date, ignoring weekends.
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of business days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the business days subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Substract 10 business days from 1 September 2014:
       * var result = subBusinessDays(new Date(2014, 8, 1), 10)
       * //=> Mon Aug 18 2014 00:00:00 (skipped weekend days)
       */


      function subBusinessDays(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addBusinessDays_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 432 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subHours;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addHours_index_js__ = __webpack_require__(84);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subHours
       * @category Hour Helpers
       * @summary Subtract the specified number of hours from the given date.
       *
       * @description
       * Subtract the specified number of hours from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of hours to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the hours subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 2 hours from 11 July 2014 01:00:00:
       * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
       * //=> Thu Jul 10 2014 23:00:00
       */


      function subHours(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addHours_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 433 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subMinutes;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__ = __webpack_require__(136);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subMinutes
       * @category Minute Helpers
       * @summary Subtract the specified number of minutes from the given date.
       *
       * @description
       * Subtract the specified number of minutes from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of minutes to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the minutes subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 30 minutes from 10 July 2014 12:00:00:
       * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
       * //=> Thu Jul 10 2014 11:30:00
       */


      function subMinutes(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 434 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subQuarters;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addQuarters_index_js__ = __webpack_require__(85);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subQuarters
       * @category Quarter Helpers
       * @summary Subtract the specified number of year quarters from the given date.
       *
       * @description
       * Subtract the specified number of year quarters from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the quarters subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 3 quarters from 1 September 2014:
       * var result = subQuarters(new Date(2014, 8, 1), 3)
       * //=> Sun Dec 01 2013 00:00:00
       */


      function subQuarters(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addQuarters_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 435 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subSeconds;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addSeconds_index_js__ = __webpack_require__(137);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subSeconds
       * @category Second Helpers
       * @summary Subtract the specified number of seconds from the given date.
       *
       * @description
       * Subtract the specified number of seconds from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of seconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the seconds subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 30 seconds from 10 July 2014 12:45:00:
       * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
       * //=> Thu Jul 10 2014 12:44:30
       */


      function subSeconds(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addSeconds_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 436 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subWeeks;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(58);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subWeeks
       * @category Week Helpers
       * @summary Subtract the specified number of weeks from the given date.
       *
       * @description
       * Subtract the specified number of weeks from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the weeks subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 4 weeks from 1 September 2014:
       * var result = subWeeks(new Date(2014, 8, 1), 4)
       * //=> Mon Aug 04 2014 00:00:00
       */


      function subWeeks(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 437 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = subYears;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(6);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__addYears_index_js__ = __webpack_require__(138);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__ = __webpack_require__(0);
      /**
       * @name subYears
       * @category Year Helpers
       * @summary Subtract the specified number of years from the given date.
       *
       * @description
       * Subtract the specified number of years from the given date.
       *
       * ### v2.0.0 breaking changes:
       *
       * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
       *
       * @param {Date|Number} date - the date to be changed
       * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
       * @returns {Date} the new date with the years subtracted
       * @throws {TypeError} 2 arguments required
       *
       * @example
       * // Subtract 5 years from 1 September 2014:
       * var result = subYears(new Date(2014, 8, 1), 5)
       * //=> Tue Sep 01 2009 00:00:00
       */


      function subYears(dirtyDate, dirtyAmount) {
        __WEBPACK_IMPORTED_MODULE_2__lib_requiredArgs_index_js__["a"
        /* default */
        ](2, arguments);

        var amount = __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a"
        /* default */
        ](dirtyAmount);

        return __WEBPACK_IMPORTED_MODULE_1__addYears_index_js__["a"
        /* default */
        ](dirtyDate, -amount);
      }
      /***/

    },
    /* 438 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (binding) */

      __webpack_require__.d(__webpack_exports__, "a", function () {
        return maxTime;
      });
      /* harmony export (binding) */


      __webpack_require__.d(__webpack_exports__, "b", function () {
        return minTime;
      });
      /**
       *  Maximum allowed time.
       *  @constant
       *  @type {number}
       *  @default
       */


      var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;
      /**
       *  Minimum allowed time.
       *  @constant
       *  @type {number}
       *  @default
       */

      var minTime = -maxTime;
      /***/
    },
    /* 439 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      Object.defineProperty(__webpack_exports__, "__esModule", {
        value: true
      });
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__af_index_js__ = __webpack_require__(440);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "af", function () {
        return __WEBPACK_IMPORTED_MODULE_0__af_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__ar_DZ_index_js__ = __webpack_require__(446);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "arDZ", function () {
        return __WEBPACK_IMPORTED_MODULE_1__ar_DZ_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__ar_MA_index_js__ = __webpack_require__(452);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "arMA", function () {
        return __WEBPACK_IMPORTED_MODULE_2__ar_MA_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__ar_SA_index_js__ = __webpack_require__(458);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "arSA", function () {
        return __WEBPACK_IMPORTED_MODULE_3__ar_SA_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__az_index_js__ = __webpack_require__(464);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "az", function () {
        return __WEBPACK_IMPORTED_MODULE_4__az_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_5__be_index_js__ = __webpack_require__(470);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "be", function () {
        return __WEBPACK_IMPORTED_MODULE_5__be_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_6__bg_index_js__ = __webpack_require__(476);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "bg", function () {
        return __WEBPACK_IMPORTED_MODULE_6__bg_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_7__bn_index_js__ = __webpack_require__(482);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "bn", function () {
        return __WEBPACK_IMPORTED_MODULE_7__bn_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_8__ca_index_js__ = __webpack_require__(487);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ca", function () {
        return __WEBPACK_IMPORTED_MODULE_8__ca_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_9__cs_index_js__ = __webpack_require__(493);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "cs", function () {
        return __WEBPACK_IMPORTED_MODULE_9__cs_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_10__cy_index_js__ = __webpack_require__(499);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "cy", function () {
        return __WEBPACK_IMPORTED_MODULE_10__cy_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_11__da_index_js__ = __webpack_require__(505);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "da", function () {
        return __WEBPACK_IMPORTED_MODULE_11__da_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_12__de_index_js__ = __webpack_require__(511);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "de", function () {
        return __WEBPACK_IMPORTED_MODULE_12__de_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_13__el_index_js__ = __webpack_require__(517);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "el", function () {
        return __WEBPACK_IMPORTED_MODULE_13__el_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_14__en_AU_index_js__ = __webpack_require__(523);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "enAU", function () {
        return __WEBPACK_IMPORTED_MODULE_14__en_AU_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_15__en_CA_index_js__ = __webpack_require__(525);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "enCA", function () {
        return __WEBPACK_IMPORTED_MODULE_15__en_CA_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_16__en_GB_index_js__ = __webpack_require__(528);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "enGB", function () {
        return __WEBPACK_IMPORTED_MODULE_16__en_GB_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_17__en_IN_index_js__ = __webpack_require__(530);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "enIN", function () {
        return __WEBPACK_IMPORTED_MODULE_17__en_IN_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_18__en_NZ_index_js__ = __webpack_require__(532);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "enNZ", function () {
        return __WEBPACK_IMPORTED_MODULE_18__en_NZ_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_19__en_US_index_js__ = __webpack_require__(28);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "enUS", function () {
        return __WEBPACK_IMPORTED_MODULE_19__en_US_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_20__eo_index_js__ = __webpack_require__(534);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eo", function () {
        return __WEBPACK_IMPORTED_MODULE_20__eo_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_21__es_index_js__ = __webpack_require__(540);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "es", function () {
        return __WEBPACK_IMPORTED_MODULE_21__es_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_22__et_index_js__ = __webpack_require__(546);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "et", function () {
        return __WEBPACK_IMPORTED_MODULE_22__et_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_23__eu_index_js__ = __webpack_require__(552);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "eu", function () {
        return __WEBPACK_IMPORTED_MODULE_23__eu_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_24__fa_IR_index_js__ = __webpack_require__(558);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "faIR", function () {
        return __WEBPACK_IMPORTED_MODULE_24__fa_IR_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_25__fi_index_js__ = __webpack_require__(564);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "fi", function () {
        return __WEBPACK_IMPORTED_MODULE_25__fi_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_26__fr_index_js__ = __webpack_require__(570);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "fr", function () {
        return __WEBPACK_IMPORTED_MODULE_26__fr_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_27__fr_CA_index_js__ = __webpack_require__(572);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "frCA", function () {
        return __WEBPACK_IMPORTED_MODULE_27__fr_CA_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_28__fr_CH_index_js__ = __webpack_require__(574);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "frCH", function () {
        return __WEBPACK_IMPORTED_MODULE_28__fr_CH_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_29__gd_index_js__ = __webpack_require__(580);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "gd", function () {
        return __WEBPACK_IMPORTED_MODULE_29__gd_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_30__gl_index_js__ = __webpack_require__(586);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "gl", function () {
        return __WEBPACK_IMPORTED_MODULE_30__gl_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_31__gu_index_js__ = __webpack_require__(592);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "gu", function () {
        return __WEBPACK_IMPORTED_MODULE_31__gu_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_32__he_index_js__ = __webpack_require__(598);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "he", function () {
        return __WEBPACK_IMPORTED_MODULE_32__he_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_33__hi_index_js__ = __webpack_require__(604);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "hi", function () {
        return __WEBPACK_IMPORTED_MODULE_33__hi_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_34__hr_index_js__ = __webpack_require__(609);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "hr", function () {
        return __WEBPACK_IMPORTED_MODULE_34__hr_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_35__hu_index_js__ = __webpack_require__(615);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "hu", function () {
        return __WEBPACK_IMPORTED_MODULE_35__hu_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_36__hy_index_js__ = __webpack_require__(621);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "hy", function () {
        return __WEBPACK_IMPORTED_MODULE_36__hy_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_37__id_index_js__ = __webpack_require__(627);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "id", function () {
        return __WEBPACK_IMPORTED_MODULE_37__id_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_38__is_index_js__ = __webpack_require__(633);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "is", function () {
        return __WEBPACK_IMPORTED_MODULE_38__is_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_39__it_index_js__ = __webpack_require__(639);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "it", function () {
        return __WEBPACK_IMPORTED_MODULE_39__it_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_40__ja_index_js__ = __webpack_require__(645);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ja", function () {
        return __WEBPACK_IMPORTED_MODULE_40__ja_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_41__ka_index_js__ = __webpack_require__(651);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ka", function () {
        return __WEBPACK_IMPORTED_MODULE_41__ka_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_42__kk_index_js__ = __webpack_require__(657);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "kk", function () {
        return __WEBPACK_IMPORTED_MODULE_42__kk_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_43__kn_index_js__ = __webpack_require__(663);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "kn", function () {
        return __WEBPACK_IMPORTED_MODULE_43__kn_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_44__ko_index_js__ = __webpack_require__(669);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ko", function () {
        return __WEBPACK_IMPORTED_MODULE_44__ko_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_45__lb_index_js__ = __webpack_require__(675);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lb", function () {
        return __WEBPACK_IMPORTED_MODULE_45__lb_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_46__lt_index_js__ = __webpack_require__(681);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lt", function () {
        return __WEBPACK_IMPORTED_MODULE_46__lt_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_47__lv_index_js__ = __webpack_require__(687);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "lv", function () {
        return __WEBPACK_IMPORTED_MODULE_47__lv_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_48__mk_index_js__ = __webpack_require__(693);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "mk", function () {
        return __WEBPACK_IMPORTED_MODULE_48__mk_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_49__ms_index_js__ = __webpack_require__(699);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ms", function () {
        return __WEBPACK_IMPORTED_MODULE_49__ms_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_50__mt_index_js__ = __webpack_require__(705);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "mt", function () {
        return __WEBPACK_IMPORTED_MODULE_50__mt_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_51__nb_index_js__ = __webpack_require__(711);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "nb", function () {
        return __WEBPACK_IMPORTED_MODULE_51__nb_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_52__nl_index_js__ = __webpack_require__(717);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "nl", function () {
        return __WEBPACK_IMPORTED_MODULE_52__nl_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_53__nl_BE_index_js__ = __webpack_require__(723);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "nlBE", function () {
        return __WEBPACK_IMPORTED_MODULE_53__nl_BE_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_54__nn_index_js__ = __webpack_require__(729);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "nn", function () {
        return __WEBPACK_IMPORTED_MODULE_54__nn_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_55__pl_index_js__ = __webpack_require__(735);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "pl", function () {
        return __WEBPACK_IMPORTED_MODULE_55__pl_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_56__pt_index_js__ = __webpack_require__(741);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "pt", function () {
        return __WEBPACK_IMPORTED_MODULE_56__pt_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_57__pt_BR_index_js__ = __webpack_require__(747);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ptBR", function () {
        return __WEBPACK_IMPORTED_MODULE_57__pt_BR_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_58__ro_index_js__ = __webpack_require__(753);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ro", function () {
        return __WEBPACK_IMPORTED_MODULE_58__ro_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_59__ru_index_js__ = __webpack_require__(759);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ru", function () {
        return __WEBPACK_IMPORTED_MODULE_59__ru_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_60__sk_index_js__ = __webpack_require__(765);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "sk", function () {
        return __WEBPACK_IMPORTED_MODULE_60__sk_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_61__sl_index_js__ = __webpack_require__(771);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "sl", function () {
        return __WEBPACK_IMPORTED_MODULE_61__sl_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_62__sr_index_js__ = __webpack_require__(777);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "sr", function () {
        return __WEBPACK_IMPORTED_MODULE_62__sr_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_63__sr_Latn_index_js__ = __webpack_require__(783);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "srLatn", function () {
        return __WEBPACK_IMPORTED_MODULE_63__sr_Latn_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_64__sv_index_js__ = __webpack_require__(789);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "sv", function () {
        return __WEBPACK_IMPORTED_MODULE_64__sv_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_65__ta_index_js__ = __webpack_require__(795);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ta", function () {
        return __WEBPACK_IMPORTED_MODULE_65__ta_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_66__te_index_js__ = __webpack_require__(801);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "te", function () {
        return __WEBPACK_IMPORTED_MODULE_66__te_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_67__th_index_js__ = __webpack_require__(807);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "th", function () {
        return __WEBPACK_IMPORTED_MODULE_67__th_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_68__tr_index_js__ = __webpack_require__(813);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "tr", function () {
        return __WEBPACK_IMPORTED_MODULE_68__tr_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_69__ug_index_js__ = __webpack_require__(819);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "ug", function () {
        return __WEBPACK_IMPORTED_MODULE_69__ug_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_70__uk_index_js__ = __webpack_require__(825);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "uk", function () {
        return __WEBPACK_IMPORTED_MODULE_70__uk_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_71__uz_index_js__ = __webpack_require__(831);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "uz", function () {
        return __WEBPACK_IMPORTED_MODULE_71__uz_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_72__vi_index_js__ = __webpack_require__(837);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "vi", function () {
        return __WEBPACK_IMPORTED_MODULE_72__vi_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_73__zh_CN_index_js__ = __webpack_require__(843);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "zhCN", function () {
        return __WEBPACK_IMPORTED_MODULE_73__zh_CN_index_js__["a"];
      });
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_74__zh_TW_index_js__ = __webpack_require__(849);
      /* harmony reexport (binding) */


      __webpack_require__.d(__webpack_exports__, "zhTW", function () {
        return __WEBPACK_IMPORTED_MODULE_74__zh_TW_index_js__["a"];
      }); // This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

      /***/

    },
    /* 440 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(441);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(442);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(443);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(444);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(445);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Afrikaans locale.
       * @language Afrikaans
       * @iso-639-2 afr
       * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
       */


      var locale = {
        code: 'af',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 441 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "minder as 'n sekonde",
          other: 'minder as {{count}} sekondes'
        },
        xSeconds: {
          one: '1 sekonde',
          other: '{{count}} sekondes'
        },
        halfAMinute: "'n halwe minuut",
        lessThanXMinutes: {
          one: "minder as 'n minuut",
          other: 'minder as {{count}} minute'
        },
        xMinutes: {
          one: "'n minuut",
          other: '{{count}} minute'
        },
        aboutXHours: {
          one: 'ongeveer 1 uur',
          other: 'ongeveer {{count}} ure'
        },
        xHours: {
          one: '1 uur',
          other: '{{count}} ure'
        },
        xDays: {
          one: '1 dag',
          other: '{{count}} dae'
        },
        aboutXWeeks: {
          one: 'ongeveer 1 week',
          other: 'ongeveer {{count}} weke'
        },
        xWeeks: {
          one: '1 week',
          other: '{{count}} weke'
        },
        aboutXMonths: {
          one: 'ongeveer 1 maand',
          other: 'ongeveer {{count}} maande'
        },
        xMonths: {
          one: '1 maand',
          other: '{{count}} maande'
        },
        aboutXYears: {
          one: 'ongeveer 1 jaar',
          other: 'ongeveer {{count}} jaar'
        },
        xYears: {
          one: '1 jaar',
          other: '{{count}} jaar'
        },
        overXYears: {
          one: 'meer as 1 jaar',
          other: 'meer as {{count}} jaar'
        },
        almostXYears: {
          one: 'byna 1 jaar',
          other: 'byna {{count}} jaar'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'oor ' + result;
          } else {
            return result + ' gelede';
          }
        }

        return result;
      }
      /***/

    },
    /* 442 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM yyyy',
        medium: 'd MMM yyyy',
        short: 'yyyy/MM/dd'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'om' {{time}}",
        long: "{{date}} 'om' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 443 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'verlede' eeee 'om' p",
        yesterday: "'gister om' p",
        today: "'vandag om' p",
        tomorrow: "'môre om' p",
        nextWeek: "eeee 'om' p",
        other: 'P'
      };

      function formatRelative(token) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 444 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['vC', 'nC'],
        abbreviated: ['vC', 'nC'],
        wide: ['voor Christus', 'na Christus']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['K1', 'K2', 'K3', 'K4'],
        wide: ['1ste kwartaal', '2de kwartaal', '3de kwartaal', '4de kwartaal']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
        wide: ['Januarie', 'Februarie', 'Maart', 'April', 'Mei', 'Junie', 'Julie', 'Augustus', 'September', 'Oktober', 'November', 'Desember']
      };
      var dayValues = {
        narrow: ['S', 'M', 'D', 'W', 'D', 'V', 'S'],
        short: ['So', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Sa'],
        abbreviated: ['Son', 'Maa', 'Din', 'Woe', 'Don', 'Vry', 'Sat'],
        wide: ['Sondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrydag', 'Saterdag']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'vm',
          pm: 'nm',
          midnight: 'middernag',
          noon: 'middaguur',
          morning: 'oggend',
          afternoon: 'middag',
          evening: 'laat middag',
          night: 'aand'
        },
        abbreviated: {
          am: 'vm',
          pm: 'nm',
          midnight: 'middernag',
          noon: 'middaguur',
          morning: 'oggend',
          afternoon: 'middag',
          evening: 'laat middag',
          night: 'aand'
        },
        wide: {
          am: 'vm',
          pm: 'nm',
          midnight: 'middernag',
          noon: 'middaguur',
          morning: 'oggend',
          afternoon: 'middag',
          evening: 'laat middag',
          night: 'aand'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'vm',
          pm: 'nm',
          midnight: 'middernag',
          noon: 'uur die middag',
          morning: 'uur die oggend',
          afternoon: 'uur die middag',
          evening: 'uur die aand',
          night: 'uur die aand'
        },
        abbreviated: {
          am: 'vm',
          pm: 'nm',
          midnight: 'middernag',
          noon: 'uur die middag',
          morning: 'uur die oggend',
          afternoon: 'uur die middag',
          evening: 'uur die aand',
          night: 'uur die aand'
        },
        wide: {
          am: 'vm',
          pm: 'nm',
          midnight: 'middernag',
          noon: 'uur die middag',
          morning: 'uur die oggend',
          afternoon: 'uur die middag',
          evening: 'uur die aand',
          night: 'uur die aand'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;

        if (rem100 < 20) {
          switch (rem100) {
            case 1:
            case 8:
              return number + 'ste';

            default:
              return number + 'de';
          }
        }

        return number + 'ste';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 445 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([vn]\.? ?C\.?)/,
        abbreviated: /^([vn]\. ?C\.?)/,
        wide: /^((voor|na) Christus)/
      };
      var parseEraPatterns = {
        any: [/^v/, /^n/]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K[1234]/i,
        wide: /^[1234](st|d)e kwartaal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
        wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^J/i, /^F/i, /^M/i, /^A/i, /^M/i, /^J/i, /^J/i, /^A/i, /^S/i, /^O/i, /^N/i, /^D/i],
        any: [/^Jan/i, /^Feb/i, /^Mrt/i, /^Apr/i, /^Mei/i, /^Jun/i, /^Jul/i, /^Aug/i, /^Sep/i, /^Okt/i, /^Nov/i, /^Dec/i]
      };
      var matchDayPatterns = {
        narrow: /^[smdwv]/i,
        short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
        abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
        wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
      };
      var parseDayPatterns = {
        narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
        any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^vm/i,
          pm: /^nm/i,
          midnight: /^middernag/i,
          noon: /^middaguur/i,
          morning: /oggend/i,
          afternoon: /middag/i,
          evening: /laat middag/i,
          night: /aand/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 446 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(447);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(448);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(449);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(450);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(451);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Arabic locale (Modern Standard Arabic ).
       * @language Modern Standard Arabic (Algeria) [ar-dz]
       * @iso-639-2 ara
       * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
       * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
       */


      var locale = {
        code: 'ar-DZ',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 447 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'أقل من ثانية واحدة',
          two: 'أقل من ثانتين',
          threeToTen: 'أقل من {{count}} ثواني',
          other: 'أقل من {{count}} ثانية'
        },
        xSeconds: {
          one: 'ثانية واحدة',
          two: 'ثانتين',
          threeToTen: '{{count}} ثواني',
          other: '{{count}} ثانية'
        },
        halfAMinute: 'نصف دقيقة',
        lessThanXMinutes: {
          one: 'أقل من دقيقة',
          two: 'أقل من دقيقتين',
          threeToTen: 'أقل من {{count}} دقائق',
          other: 'أقل من {{count}} دقيقة'
        },
        xMinutes: {
          one: 'دقيقة واحدة',
          two: 'دقيقتين',
          threeToTen: '{{count}} دقائق',
          other: '{{count}} دقيقة'
        },
        aboutXHours: {
          one: 'ساعة واحدة تقريباً',
          two: 'ساعتين تقريباً',
          threeToTen: '{{count}} ساعات تقريباً',
          other: '{{count}} ساعة تقريباً'
        },
        xHours: {
          one: 'ساعة واحدة',
          two: 'ساعتين',
          threeToTen: '{{count}} ساعات',
          other: '{{count}} ساعة'
        },
        xDays: {
          one: 'يوم واحد',
          two: 'يومين',
          threeToTen: '{{count}} أيام',
          other: '{{count}} يوم'
        },
        aboutXWeeks: {
          one: 'أسبوع واحد تقريباً',
          two: 'أسبوعين تقريباً',
          threeToTen: '{{count}} أسابيع تقريباً',
          other: '{{count}} أسبوع تقريباً'
        },
        xWeeks: {
          one: 'أسبوع واحد',
          two: 'أسبوعين',
          threeToTen: '{{count}} أسابيع',
          other: '{{count}} أسبوع'
        },
        aboutXMonths: {
          one: 'شهر واحد تقريباً',
          two: 'شهرين تقريباً',
          threeToTen: '{{count}} أشهر تقريباً',
          other: '{{count}} شهر تقريباً'
        },
        xMonths: {
          one: 'شهر واحد',
          two: 'شهرين',
          threeToTen: '{{count}} أشهر',
          other: '{{count}} شهر'
        },
        aboutXYears: {
          one: 'عام واحد تقريباً',
          two: 'عامين تقريباً',
          threeToTen: '{{count}} أعوام تقريباً',
          other: '{{count}} عام تقريباً'
        },
        xYears: {
          one: 'عام واحد',
          two: 'عامين',
          threeToTen: '{{count}} أعوام',
          other: '{{count}} عام'
        },
        overXYears: {
          one: 'أكثر من عام',
          two: 'أكثر من عامين',
          threeToTen: 'أكثر من {{count}} أعوام',
          other: 'أكثر من {{count}} عام'
        },
        almostXYears: {
          one: 'عام واحد تقريباً',
          two: 'عامين تقريباً',
          threeToTen: '{{count}} أعوام تقريباً',
          other: '{{count}} عام تقريباً'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2) {
          result = formatDistanceLocale[token].two;
        } else if (count <= 10) {
          result = formatDistanceLocale[token].threeToTen.replace('{{count}}', count);
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'في خلال ' + result;
          } else {
            return 'منذ ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 448 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'عند' {{time}}",
        long: "{{date}} 'عند' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 449 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'أخر' eeee 'عند' p",
        yesterday: "'أمس عند' p",
        today: "'اليوم عند' p",
        tomorrow: "'غداً عند' p",
        nextWeek: "eeee 'عند' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 450 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['ق', 'ب'],
        abbreviated: ['ق.م.', 'ب.م.'],
        wide: ['قبل الميلاد', 'بعد الميلاد']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
        wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
      };
      var monthValues = {
        narrow: ['ج', 'ف', 'م', 'أ', 'م', 'ج', 'ج', 'أ', 'س', 'أ', 'ن', 'د'],
        abbreviated: ['جانـ', 'فيفـ', 'مارس', 'أفريل', 'مايـ', 'جوانـ', 'جويـ', 'أوت', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
        wide: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
      };
      var dayValues = {
        narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
        short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
        abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
        wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ص',
          pm: 'م',
          midnight: 'ن',
          noon: 'ظ',
          morning: 'صباحاً',
          afternoon: 'بعد الظهر',
          evening: 'مساءاً',
          night: 'ليلاً'
        },
        abbreviated: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          morning: 'صباحاً',
          afternoon: 'بعد الظهر',
          evening: 'مساءاً',
          night: 'ليلاً'
        },
        wide: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          morning: 'صباحاً',
          afternoon: 'بعد الظهر',
          evening: 'مساءاً',
          night: 'ليلاً'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ص',
          pm: 'م',
          midnight: 'ن',
          noon: 'ظ',
          morning: 'في الصباح',
          afternoon: 'بعد الظـهر',
          evening: 'في المساء',
          night: 'في الليل'
        },
        abbreviated: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          morning: 'في الصباح',
          evening: 'في المساء',
          night: 'في الليل'
        },
        wide: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          afternoon: 'بعد الظـهر',
          evening: 'في المساء',
          night: 'في الليل'
        }
      };

      function ordinalNumber(dirtyNumber) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 451 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ق|ب)/i,
        abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
        wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
      };
      var parseEraPatterns = {
        any: [/^قبل/i, /^بعد/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ر[1234]/i,
        wide: /^الربع [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[جفمأسند]/i,
        abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
        wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
        any: [/^جان/i, /^فيف/i, /^مار/i, /^أفر/i, /^ماي/i, /^جوا/i, /^جوي/i, /^أوت/i, /^سبت/i, /^أكت/i, /^نوف/i, /^ديس/i]
      };
      var matchDayPatterns = {
        narrow: /^[حنثرخجس]/i,
        short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
        abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
        wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
      };
      var parseDayPatterns = {
        narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
        wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
        any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 452 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(453);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(454);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(455);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(456);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(457);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Arabic locale (Moroccan Arabic).
       * @language Moroccan Arabic
       * @iso-639-2 ara
       * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
       */


      var locale = {
        code: 'ar-MA',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          // Monday is 1
          weekStartsOn: 1,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 453 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'أقل من ثانية واحدة',
          two: 'أقل من ثانتين',
          threeToTen: 'أقل من {{count}} ثواني',
          other: 'أقل من {{count}} ثانية'
        },
        xSeconds: {
          one: 'ثانية واحدة',
          two: 'ثانتين',
          threeToTen: '{{count}} ثواني',
          other: '{{count}} ثانية'
        },
        halfAMinute: 'نصف دقيقة',
        lessThanXMinutes: {
          one: 'أقل من دقيقة',
          two: 'أقل من دقيقتين',
          threeToTen: 'أقل من {{count}} دقائق',
          other: 'أقل من {{count}} دقيقة'
        },
        xMinutes: {
          one: 'دقيقة واحدة',
          two: 'دقيقتين',
          threeToTen: '{{count}} دقائق',
          other: '{{count}} دقيقة'
        },
        aboutXHours: {
          one: 'ساعة واحدة تقريباً',
          two: 'ساعتين تقريباً',
          threeToTen: '{{count}} ساعات تقريباً',
          other: '{{count}} ساعة تقريباً'
        },
        xHours: {
          one: 'ساعة واحدة',
          two: 'ساعتين',
          threeToTen: '{{count}} ساعات',
          other: '{{count}} ساعة'
        },
        xDays: {
          one: 'يوم واحد',
          two: 'يومين',
          threeToTen: '{{count}} أيام',
          other: '{{count}} يوم'
        },
        aboutXWeeks: {
          one: 'أسبوع واحد تقريباً',
          two: 'أسبوعين تقريباً',
          threeToTen: '{{count}} أسابيع تقريباً',
          other: '{{count}} أسبوع تقريباً'
        },
        xWeeks: {
          one: 'أسبوع واحد',
          two: 'أسبوعين',
          threeToTen: '{{count}} أسابيع',
          other: '{{count}} أسبوع'
        },
        aboutXMonths: {
          one: 'شهر واحد تقريباً',
          two: 'شهرين تقريباً',
          threeToTen: '{{count}} أشهر تقريباً',
          other: '{{count}} شهر تقريباً'
        },
        xMonths: {
          one: 'شهر واحد',
          two: 'شهرين',
          threeToTen: '{{count}} أشهر',
          other: '{{count}} شهر'
        },
        aboutXYears: {
          one: 'عام واحد تقريباً',
          two: 'عامين تقريباً',
          threeToTen: '{{count}} أعوام تقريباً',
          other: '{{count}} عام تقريباً'
        },
        xYears: {
          one: 'عام واحد',
          two: 'عامين',
          threeToTen: '{{count}} أعوام',
          other: '{{count}} عام'
        },
        overXYears: {
          one: 'أكثر من عام',
          two: 'أكثر من عامين',
          threeToTen: 'أكثر من {{count}} أعوام',
          other: 'أكثر من {{count}} عام'
        },
        almostXYears: {
          one: 'عام واحد تقريباً',
          two: 'عامين تقريباً',
          threeToTen: '{{count}} أعوام تقريباً',
          other: '{{count}} عام تقريباً'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2) {
          result = formatDistanceLocale[token].two;
        } else if (count <= 10) {
          result = formatDistanceLocale[token].threeToTen.replace('{{count}}', count);
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'في خلال ' + result;
          } else {
            return 'منذ ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 454 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'عند' {{time}}",
        long: "{{date}} 'عند' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 455 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'أخر' eeee 'عند' p",
        yesterday: "'أمس عند' p",
        today: "'اليوم عند' p",
        tomorrow: "'غداً عند' p",
        nextWeek: "eeee 'عند' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 456 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['ق', 'ب'],
        abbreviated: ['ق.م.', 'ب.م.'],
        wide: ['قبل الميلاد', 'بعد الميلاد']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
        wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
      };
      var monthValues = {
        narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'غ', 'ش', 'أ', 'ن', 'د'],
        abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'ماي', 'يونـ', 'يولـ', 'غشت', 'شتنـ', 'أكتـ', 'نونـ', 'دجنـ'],
        wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'ماي', 'يونيو', 'يوليوز', 'غشت', 'شتنبر', 'أكتوبر', 'نونبر', 'دجنبر']
      };
      var dayValues = {
        narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
        short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
        abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
        wide: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ص',
          pm: 'م',
          midnight: 'ن',
          noon: 'ظ',
          morning: 'صباحاً',
          afternoon: 'بعد الظهر',
          evening: 'مساءاً',
          night: 'ليلاً'
        },
        abbreviated: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          morning: 'صباحاً',
          afternoon: 'بعد الظهر',
          evening: 'مساءاً',
          night: 'ليلاً'
        },
        wide: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          morning: 'صباحاً',
          afternoon: 'بعد الظهر',
          evening: 'مساءاً',
          night: 'ليلاً'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ص',
          pm: 'م',
          midnight: 'ن',
          noon: 'ظ',
          morning: 'في الصباح',
          afternoon: 'بعد الظـهر',
          evening: 'في المساء',
          night: 'في الليل'
        },
        abbreviated: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          morning: 'في الصباح',
          evening: 'في المساء',
          night: 'في الليل'
        },
        wide: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          afternoon: 'بعد الظـهر',
          evening: 'في المساء',
          night: 'في الليل'
        }
      };

      function ordinalNumber(dirtyNumber) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 457 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ق|ب)/i,
        abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
        wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
      };
      var parseEraPatterns = {
        any: [/^قبل/i, /^بعد/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ر[1234]/i,
        wide: /^الربع [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[يفمأمسند]/i,
        abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
        wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^غ/i, /^ش/i, /^أ/i, /^ن/i, /^د/i],
        any: [/^ين/i, /^فب/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^غشت/i, /^ش/i, /^أك/i, /^ن/i, /^د/i]
      };
      var matchDayPatterns = {
        narrow: /^[حنثرخجس]/i,
        short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
        abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
        wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
      };
      var parseDayPatterns = {
        narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
        wide: [/^الأحد/i, /^الإثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
        any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 458 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(459);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(460);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(461);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(462);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(463);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Arabic locale (Sauid Arabic).
       * @language Arabic
       * @iso-639-2 ara
       * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
       */


      var locale = {
        code: 'ar-SA',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 459 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'أقل من ثانية واحدة',
          two: 'أقل من ثانتين',
          threeToTen: 'أقل من {{count}} ثواني',
          other: 'أقل من {{count}} ثانية'
        },
        xSeconds: {
          one: 'ثانية واحدة',
          two: 'ثانتين',
          threeToTen: '{{count}} ثواني',
          other: '{{count}} ثانية'
        },
        halfAMinute: 'نصف دقيقة',
        lessThanXMinutes: {
          one: 'أقل من دقيقة',
          two: 'أقل من دقيقتين',
          threeToTen: 'أقل من {{count}} دقائق',
          other: 'أقل من {{count}} دقيقة'
        },
        xMinutes: {
          one: 'دقيقة واحدة',
          two: 'دقيقتين',
          threeToTen: '{{count}} دقائق',
          other: '{{count}} دقيقة'
        },
        aboutXHours: {
          one: 'ساعة واحدة تقريباً',
          two: 'ساعتين تقريباً',
          threeToTen: '{{count}} ساعات تقريباً',
          other: '{{count}} ساعة تقريباً'
        },
        xHours: {
          one: 'ساعة واحدة',
          two: 'ساعتين',
          threeToTen: '{{count}} ساعات',
          other: '{{count}} ساعة'
        },
        xDays: {
          one: 'يوم واحد',
          two: 'يومين',
          threeToTen: '{{count}} أيام',
          other: '{{count}} يوم'
        },
        aboutXWeeks: {
          one: 'أسبوع واحد تقريباً',
          two: 'أسبوعين تقريباً',
          threeToTen: '{{count}} أسابيع تقريباً',
          other: '{{count}} أسبوع تقريباً'
        },
        xWeeks: {
          one: 'أسبوع واحد',
          two: 'أسبوعين',
          threeToTen: '{{count}} أسابيع',
          other: '{{count}} أسبوع'
        },
        aboutXMonths: {
          one: 'شهر واحد تقريباً',
          two: 'شهرين تقريباً',
          threeToTen: '{{count}} أشهر تقريباً',
          other: '{{count}} شهر تقريباً'
        },
        xMonths: {
          one: 'شهر واحد',
          two: 'شهرين',
          threeToTen: '{{count}} أشهر',
          other: '{{count}} شهر'
        },
        aboutXYears: {
          one: 'عام واحد تقريباً',
          two: 'عامين تقريباً',
          threeToTen: '{{count}} أعوام تقريباً',
          other: '{{count}} عام تقريباً'
        },
        xYears: {
          one: 'عام واحد',
          two: 'عامين',
          threeToTen: '{{count}} أعوام',
          other: '{{count}} عام'
        },
        overXYears: {
          one: 'أكثر من عام',
          two: 'أكثر من عامين',
          threeToTen: 'أكثر من {{count}} أعوام',
          other: 'أكثر من {{count}} عام'
        },
        almostXYears: {
          one: 'عام واحد تقريباً',
          two: 'عامين تقريباً',
          threeToTen: '{{count}} أعوام تقريباً',
          other: '{{count}} عام تقريباً'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2) {
          result = formatDistanceLocale[token].two;
        } else if (count <= 10) {
          result = formatDistanceLocale[token].threeToTen.replace('{{count}}', count);
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'في خلال ' + result;
          } else {
            return 'منذ ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 460 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'عند' {{time}}",
        long: "{{date}} 'عند' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 461 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'أخر' eeee 'عند' p",
        yesterday: "'أمس عند' p",
        today: "'اليوم عند' p",
        tomorrow: "'غداً عند' p",
        nextWeek: "eeee 'عند' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 462 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['ق', 'ب'],
        abbreviated: ['ق.م.', 'ب.م.'],
        wide: ['قبل الميلاد', 'بعد الميلاد']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
        wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
      };
      var monthValues = {
        narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'أ', 'س', 'أ', 'ن', 'د'],
        abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'مايو', 'يونـ', 'يولـ', 'أغسـ', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
        wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
      };
      var dayValues = {
        narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
        short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
        abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
        wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ص',
          pm: 'م',
          midnight: 'ن',
          noon: 'ظ',
          morning: 'صباحاً',
          afternoon: 'بعد الظهر',
          evening: 'مساءاً',
          night: 'ليلاً'
        },
        abbreviated: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          morning: 'صباحاً',
          afternoon: 'بعد الظهر',
          evening: 'مساءاً',
          night: 'ليلاً'
        },
        wide: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          morning: 'صباحاً',
          afternoon: 'بعد الظهر',
          evening: 'مساءاً',
          night: 'ليلاً'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ص',
          pm: 'م',
          midnight: 'ن',
          noon: 'ظ',
          morning: 'في الصباح',
          afternoon: 'بعد الظـهر',
          evening: 'في المساء',
          night: 'في الليل'
        },
        abbreviated: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          morning: 'في الصباح',
          evening: 'في المساء',
          night: 'في الليل'
        },
        wide: {
          am: 'ص',
          pm: 'م',
          midnight: 'نصف الليل',
          noon: 'ظهر',
          afternoon: 'بعد الظـهر',
          evening: 'في المساء',
          night: 'في الليل'
        }
      };

      function ordinalNumber(dirtyNumber) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 463 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ق|ب)/i,
        abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
        wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
      };
      var parseEraPatterns = {
        any: [/^قبل/i, /^بعد/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ر[1234]/i,
        wide: /^الربع [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[يفمأمسند]/i,
        abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
        wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
        any: [/^ين/i, /^ف/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^أغ/i, /^س/i, /^أك/i, /^ن/i, /^د/i]
      };
      var matchDayPatterns = {
        narrow: /^[حنثرخجس]/i,
        short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
        abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
        wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
      };
      var parseDayPatterns = {
        narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
        wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
        any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
        any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mi/i,
          noon: /^no/i,
          morning: /morning/i,
          afternoon: /afternoon/i,
          evening: /evening/i,
          night: /night/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 464 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(465);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(466);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(467);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(468);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(469);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Azerbaijani locale.
       * @language Azerbaijani
       * @iso-639-2 aze
       */


      var locale = {
        code: 'az',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 465 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'bir saniyədən az',
          other: '{{count}} bir saniyədən az'
        },
        xSeconds: {
          one: '1 saniyə',
          other: '{{count}} saniyə'
        },
        halfAMinute: 'yarım dəqiqə',
        lessThanXMinutes: {
          one: 'bir dəqiqədən az',
          other: '{{count}} bir dəqiqədən az'
        },
        xMinutes: {
          one: 'bir dəqiqə',
          other: '{{count}} dəqiqə'
        },
        aboutXHours: {
          one: 'təxminən 1 saat',
          other: 'təxminən {{count}} saat'
        },
        xHours: {
          one: '1 saat',
          other: '{{count}} saat'
        },
        xDays: {
          one: '1 gün',
          other: '{{count}} gün'
        },
        aboutXWeeks: {
          one: 'təxminən 1 həftə',
          other: 'təxminən {{count}} həftə'
        },
        xWeeks: {
          one: '1 həftə',
          other: '{{count}} həftə'
        },
        aboutXMonths: {
          one: 'təxminən 1 ay',
          other: 'təxminən {{count}} ay'
        },
        xMonths: {
          one: '1 ay',
          other: '{{count}} ay'
        },
        aboutXYears: {
          one: 'təxminən 1 il',
          other: 'təxminən {{count}} il'
        },
        xYears: {
          one: '1 il',
          other: '{{count}} il'
        },
        overXYears: {
          one: '1 ildən çox',
          other: '{{count}} ildən çox'
        },
        almostXYears: {
          one: 'demək olar ki 1 il',
          other: 'demək olar ki {{count}} il'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + ' əvvəl';
          } else {
            return result + ' sonra';
          }
        }

        return result;
      }
      /***/

    },
    /* 466 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, do MMMM y 'il'",
        long: "do MMMM y 'il'",
        medium: "d MMM y 'il'",
        short: 'dd.MM.yyyy'
      };
      var timeFormats = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}} - 'də'",
        long: "{{date}} {{time}} - 'də'",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 467 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'sonuncu' eeee p -'də'",
        yesterday: "'dünən' p -'də'",
        today: "'bugün' p -'də'",
        tomorrow: "'sabah' p -'də'",
        nextWeek: "eeee p -'də'",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 468 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['B', 'A'],
        abbreviated: ['BC', 'AD'],
        wide: ["Hz. İsa'dan öncə", 'Anno Domini']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['K1', 'K2', 'K3', 'K4'],
        wide: ['1ci kvartal', '2ci kvartal', '3cü kvartal', '4cü kvartal'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['Y', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'İyun', 'İyul', 'Avq', 'Sen', 'Okt', 'Noy', 'Dek'],
        wide: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'İyun', 'İyul', 'Avqust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr']
      };
      var dayValues = {
        narrow: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
        short: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
        abbreviated: ['Baz', 'Baz.e', 'Çər.a', 'Çər', 'Cüm.a', 'Cüm', 'Şə'],
        wide: ['Bazar', 'Bazar ertəsi', 'Çərşənbə axşamı', 'Çərşənbə', 'Cümə axşamı', 'Cümə', 'Şənbə']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'am',
          pm: 'pm',
          midnight: 'gecəyarı',
          noon: 'gün',
          morning: 'səhər',
          afternoon: 'gündüz',
          evening: 'axşam',
          night: 'gecə'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'gecəyarı',
          noon: 'gün',
          morning: 'səhər',
          afternoon: 'gündüz',
          evening: 'axşam',
          night: 'gecə'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'gecəyarı',
          noon: 'gün',
          morning: 'səhər',
          afternoon: 'gündüz',
          evening: 'axşam',
          night: 'gecə'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'gecəyarı',
          noon: 'gün',
          morning: 'səhər',
          afternoon: 'gündüz',
          evening: 'axşam',
          night: 'gecə'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'gecəyarı',
          noon: 'gün',
          morning: 'səhər',
          afternoon: 'gündüz',
          evening: 'axşam',
          night: 'gecə'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'gecəyarı',
          noon: 'gün',
          morning: 'səhər',
          afternoon: 'gündüz',
          evening: 'axşam',
          night: 'gecə'
        }
      };
      var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
      };

      function getSuffix(number) {
        if (number === 0) {
          // special case for zero
          return number + '-ıncı';
        }

        var a = number % 10,
            b = number % 100 - a,
            c = number >= 100 ? 100 : null;
        return suffixes[a] || suffixes[b] || suffixes[c];
      }

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        var suffix = getSuffix(number);
        return number + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 469 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(b|a)$/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
        wide: /^(Hz. İsa'dan öncə|ümumi eradan əvvəl|anno domini|ümumi dövr)$/i
      };
      var parseEraPatterns = {
        any: [/^b$/i, /^(a|c)$/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]$/i,
        abbreviated: /^K[1234]$/i,
        wide: /^[1234](ci)? kvartal$/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[(?-i)yfmaisond]$/i,
        abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
        wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
      };
      var parseMonthPatterns = {
        narrow: [/^[(?-i)y]$/i, /^[(?-i)f]$/i, /^[(?-i)m]$/i, /^[(?-i)a]$/i, /^[(?-i)m]$/i, /^[(?-i)i]$/i, /^[(?-i)i]$/i, /^[(?-i)a]$/i, /^[(?-i)s]$/i, /^[(?-i)o]$/i, /^[(?-i)n]$/i, /^[(?-i)d]$/i],
        abbreviated: [/^Yan$/i, /^Fev$/i, /^Mar$/i, /^Apr$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avg$/i, /^Sen$/i, /^Okt$/i, /^Noy$/i, /^Dek$/i],
        wide: [/^Yanvar$/i, /^Fevral$/i, /^Mart$/i, /^Aprel$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avgust$/i, /^Sentyabr$/i, /^Oktyabr$/i, /^Noyabr$/i, /^Dekabr$/i]
      };
      var matchDayPatterns = {
        narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
        short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
        abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
        wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
      };
      var parseDayPatterns = {
        narrow: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i],
        abbreviated: [/^Baz\.e$/i, /^Çər$/i, /^Çər\.a$/i, /^Cüm$/i, /^Cüm\.a$/i, /^Şə$/i],
        wide: [/^Bazar$/i, /^Bazar ertəsi$/i, /^Çərşənbə axşamı$/i, /^Çərşənbə$/i, /^Cümə axşamı$/i, /^Cümə$/i, /^Şənbə$/i],
        any: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
        any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a$/i,
          pm: /^p$/i,
          midnight: /^gecəyarı$/i,
          noon: /^gün$/i,
          morning: /səhər$/i,
          afternoon: /gündüz$/i,
          evening: /axşam$/i,
          night: /gecə$/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 470 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(471);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(472);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(473);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(474);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(475);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Belarusian locale.
       * @language Belarusian
       * @iso-639-2 bel
       * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
       * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
       */


      var locale = {
        code: 'be',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 471 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;

      function declension(scheme, count) {
        // scheme for count=1 exists
        if (scheme.one !== undefined && count === 1) {
          return scheme.one;
        }

        var rem10 = count % 10;
        var rem100 = count % 100; // 1, 21, 31, ...

        if (rem10 === 1 && rem100 !== 11) {
          return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
        } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
          return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
        } else {
          return scheme.pluralGenitive.replace('{{count}}', count);
        }
      }

      function buildLocalizeTokenFn(scheme) {
        return function (count, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              if (scheme.future) {
                return declension(scheme.future, count);
              } else {
                return 'праз ' + declension(scheme.regular, count);
              }
            } else {
              if (scheme.past) {
                return declension(scheme.past, count);
              } else {
                return declension(scheme.regular, count) + ' таму';
              }
            }
          } else {
            return declension(scheme.regular, count);
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          regular: {
            one: 'менш за секунду',
            singularNominative: 'менш за {{count}} секунду',
            singularGenitive: 'менш за {{count}} секунды',
            pluralGenitive: 'менш за {{count}} секунд'
          },
          future: {
            one: 'менш, чым праз секунду',
            singularNominative: 'менш, чым праз {{count}} секунду',
            singularGenitive: 'менш, чым праз {{count}} секунды',
            pluralGenitive: 'менш, чым праз {{count}} секунд'
          }
        }),
        xSeconds: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} секунда',
            singularGenitive: '{{count}} секунды',
            pluralGenitive: '{{count}} секунд'
          },
          past: {
            singularNominative: '{{count}} секунду таму',
            singularGenitive: '{{count}} секунды таму',
            pluralGenitive: '{{count}} секунд таму'
          },
          future: {
            singularNominative: 'праз {{count}} секунду',
            singularGenitive: 'праз {{count}} секунды',
            pluralGenitive: 'праз {{count}} секунд'
          }
        }),
        halfAMinute: function halfAMinute(_, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              return 'праз паўхвіліны';
            } else {
              return 'паўхвіліны таму';
            }
          }

          return 'паўхвіліны';
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          regular: {
            one: 'менш за хвіліну',
            singularNominative: 'менш за {{count}} хвіліну',
            singularGenitive: 'менш за {{count}} хвіліны',
            pluralGenitive: 'менш за {{count}} хвілін'
          },
          future: {
            one: 'менш, чым праз хвіліну',
            singularNominative: 'менш, чым праз {{count}} хвіліну',
            singularGenitive: 'менш, чым праз {{count}} хвіліны',
            pluralGenitive: 'менш, чым праз {{count}} хвілін'
          }
        }),
        xMinutes: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} хвіліна',
            singularGenitive: '{{count}} хвіліны',
            pluralGenitive: '{{count}} хвілін'
          },
          past: {
            singularNominative: '{{count}} хвіліну таму',
            singularGenitive: '{{count}} хвіліны таму',
            pluralGenitive: '{{count}} хвілін таму'
          },
          future: {
            singularNominative: 'праз {{count}} хвіліну',
            singularGenitive: 'праз {{count}} хвіліны',
            pluralGenitive: 'праз {{count}} хвілін'
          }
        }),
        aboutXHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'каля {{count}} гадзіны',
            singularGenitive: 'каля {{count}} гадзін',
            pluralGenitive: 'каля {{count}} гадзін'
          },
          future: {
            singularNominative: 'прыблізна праз {{count}} гадзіну',
            singularGenitive: 'прыблізна праз {{count}} гадзіны',
            pluralGenitive: 'прыблізна праз {{count}} гадзін'
          }
        }),
        xHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} гадзіна',
            singularGenitive: '{{count}} гадзіны',
            pluralGenitive: '{{count}} гадзін'
          },
          past: {
            singularNominative: '{{count}} гадзіну таму',
            singularGenitive: '{{count}} гадзіны таму',
            pluralGenitive: '{{count}} гадзін таму'
          },
          future: {
            singularNominative: 'праз {{count}} гадзіну',
            singularGenitive: 'праз {{count}} гадзіны',
            pluralGenitive: 'праз {{count}} гадзін'
          }
        }),
        xDays: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} дзень',
            singularGenitive: '{{count}} дні',
            pluralGenitive: '{{count}} дзён'
          }
        }),
        aboutXWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'каля {{count}} месяца',
            // TODO
            singularGenitive: 'каля {{count}} месяцаў',
            // TODO
            pluralGenitive: 'каля {{count}} месяцаў' // TODO

          },
          future: {
            singularNominative: 'прыблізна праз {{count}} месяц',
            // TODO
            singularGenitive: 'прыблізна праз {{count}} месяцы',
            // TODO
            pluralGenitive: 'прыблізна праз {{count}} месяцаў' // TODO

          }
        }),
        xWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} месяц',
            singularGenitive: '{{count}} месяцы',
            pluralGenitive: '{{count}} месяцаў'
          }
        }),
        aboutXMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'каля {{count}} месяца',
            singularGenitive: 'каля {{count}} месяцаў',
            pluralGenitive: 'каля {{count}} месяцаў'
          },
          future: {
            singularNominative: 'прыблізна праз {{count}} месяц',
            singularGenitive: 'прыблізна праз {{count}} месяцы',
            pluralGenitive: 'прыблізна праз {{count}} месяцаў'
          }
        }),
        xMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} месяц',
            singularGenitive: '{{count}} месяцы',
            pluralGenitive: '{{count}} месяцаў'
          }
        }),
        aboutXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'каля {{count}} года',
            singularGenitive: 'каля {{count}} гадоў',
            pluralGenitive: 'каля {{count}} гадоў'
          },
          future: {
            singularNominative: 'прыблізна праз {{count}} год',
            singularGenitive: 'прыблізна праз {{count}} гады',
            pluralGenitive: 'прыблізна праз {{count}} гадоў'
          }
        }),
        xYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} год',
            singularGenitive: '{{count}} гады',
            pluralGenitive: '{{count}} гадоў'
          }
        }),
        overXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'больш за {{count}} год',
            singularGenitive: 'больш за {{count}} гады',
            pluralGenitive: 'больш за {{count}} гадоў'
          },
          future: {
            singularNominative: 'больш, чым праз {{count}} год',
            singularGenitive: 'больш, чым праз {{count}} гады',
            pluralGenitive: 'больш, чым праз {{count}} гадоў'
          }
        }),
        almostXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'амаль {{count}} год',
            singularGenitive: 'амаль {{count}} гады',
            pluralGenitive: 'амаль {{count}} гадоў'
          },
          future: {
            singularNominative: 'амаль праз {{count}} год',
            singularGenitive: 'амаль праз {{count}} гады',
            pluralGenitive: 'амаль праз {{count}} гадоў'
          }
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        return formatDistanceLocale[token](count, options);
      }
      /***/

    },
    /* 472 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, d MMMM y 'г.'",
        long: "d MMMM y 'г.'",
        medium: "d MMM y 'г.'",
        short: 'dd.MM.y'
      };
      var timeFormats = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        any: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 473 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13);

      var accusativeWeekdays = ['нядзелю', 'панядзелак', 'аўторак', 'сераду', 'чацвер', 'пятніцу', 'суботу'];

      function _lastWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 5:
          case 6:
            return "'у мінулую " + weekday + " а' p";

          case 1:
          case 2:
          case 4:
            return "'у мінулы " + weekday + " а' p";
        }
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];
        return "'у " + weekday + " а' p";
      }

      function _nextWeek(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 5:
          case 6:
            return "'у наступную " + weekday + " а' p";

          case 1:
          case 2:
          case 4:
            return "'у наступны " + weekday + " а' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _lastWeek(day);
          }
        },
        yesterday: "'учора а' p",
        today: "'сёння а' p",
        tomorrow: "'заўтра а' p",
        nextWeek: function nextWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _nextWeek(day);
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 474 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['да н.э.', 'н.э.'],
        abbreviated: ['да н. э.', 'н. э.'],
        wide: ['да нашай эры', 'нашай эры']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1-ы кв.', '2-і кв.', '3-і кв.', '4-ы кв.'],
        wide: ['1-ы квартал', '2-і квартал', '3-і квартал', '4-ы квартал']
      };
      var monthValues = {
        narrow: ['С', 'Л', 'С', 'К', 'М', 'Ч', 'Л', 'Ж', 'В', 'К', 'Л', 'С'],
        abbreviated: ['студз.', 'лют.', 'сак.', 'крас.', 'май', 'чэрв.', 'ліп.', 'жн.', 'вер.', 'кастр.', 'ліст.', 'снеж.'],
        wide: ['студзень', 'люты', 'сакавік', 'красавік', 'май', 'чэрвень', 'ліпень', 'жнівень', 'верасень', 'кастрычнік', 'лістапад', 'снежань']
      };
      var formattingMonthValues = {
        narrow: ['С', 'Л', 'С', 'К', 'М', 'Ч', 'Л', 'Ж', 'В', 'К', 'Л', 'С'],
        abbreviated: ['студз.', 'лют.', 'сак.', 'крас.', 'мая', 'чэрв.', 'ліп.', 'жн.', 'вер.', 'кастр.', 'ліст.', 'снеж.'],
        wide: ['студзеня', 'лютага', 'сакавіка', 'красавіка', 'мая', 'чэрвеня', 'ліпеня', 'жніўня', 'верасня', 'кастрычніка', 'лістапада', 'снежня']
      };
      var dayValues = {
        narrow: ['Н', 'П', 'А', 'С', 'Ч', 'П', 'С'],
        short: ['нд', 'пн', 'аў', 'ср', 'чц', 'пт', 'сб'],
        abbreviated: ['нядз', 'пан', 'аўт', 'сер', 'чац', 'пят', 'суб'],
        wide: ['нядзеля', 'панядзелак', 'аўторак', 'серада', 'чацвер', 'пятніца', 'субота']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'поўн.',
          noon: 'поўд.',
          morning: 'ран.',
          afternoon: 'дзень',
          evening: 'веч.',
          night: 'ноч'
        },
        abbreviated: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'поўн.',
          noon: 'поўд.',
          morning: 'ран.',
          afternoon: 'дзень',
          evening: 'веч.',
          night: 'ноч'
        },
        wide: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'поўнач',
          noon: 'поўдзень',
          morning: 'раніца',
          afternoon: 'дзень',
          evening: 'вечар',
          night: 'ноч'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'поўн.',
          noon: 'поўд.',
          morning: 'ран.',
          afternoon: 'дня',
          evening: 'веч.',
          night: 'ночы'
        },
        abbreviated: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'поўн.',
          noon: 'поўд.',
          morning: 'ран.',
          afternoon: 'дня',
          evening: 'веч.',
          night: 'ночы'
        },
        wide: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'поўнач',
          noon: 'поўдзень',
          morning: 'раніцы',
          afternoon: 'дня',
          evening: 'вечара',
          night: 'ночы'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var number = Number(dirtyNumber);
        var suffix;
        /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
         *  For date-month combinations should be used `d` formatter.
         *  Correct:   `d MMMM` (4 верасня)
         *  Incorrect: `do MMMM` (4-га верасня)
         *
         *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
         *  So for phrase "5th day of month" (`do дзень месяца`)
         *  library will produce:            `5-га дзень месяца`
         *  but correct spelling should be:  `5-ы дзень месяца`
         *
         *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
         */

        if (unit === 'date') {
          suffix = '-га';
        } else if (unit === 'hour' || unit === 'minute' || unit === 'second') {
          suffix = '-я';
        } else {
          suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? '-і' : '-ы';
        }

        return number + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'any',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 475 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((да )?н\.?\s?э\.?)/i,
        abbreviated: /^((да )?н\.?\s?э\.?)/i,
        wide: /^(да нашай эры|нашай эры|наша эра)/i
      };
      var parseEraPatterns = {
        any: [/^д/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
        wide: /^[1234](-?[ыі]?)? квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[слкмчжв]/i,
        abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
        wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
      };
      var parseMonthPatterns = {
        narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^м/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
        any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^ма/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
      };
      var matchDayPatterns = {
        narrow: /^[нпасч]/i,
        short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
        abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
        wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
      };
      var parseDayPatterns = {
        narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
        abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
        wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^дп/i,
          pm: /^пп/i,
          midnight: /^поўн/i,
          noon: /^поўд/i,
          morning: /^р/i,
          afternoon: /^д[зн]/i,
          evening: /^в/i,
          night: /^н/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 476 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(477);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(478);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(479);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(480);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(481);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Bulgarian locale.
       * @language Bulgarian
       * @iso-639-2 bul
       * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
       * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
       */


      var locale = {
        code: 'bg',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 477 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'по-малко от секунда',
          other: 'по-малко от {{count}} секунди'
        },
        xSeconds: {
          one: '1 секунда',
          other: '{{count}} секунди'
        },
        halfAMinute: 'половин минута',
        lessThanXMinutes: {
          one: 'по-малко от минута',
          other: 'по-малко от {{count}} минути'
        },
        xMinutes: {
          one: '1 минута',
          other: '{{count}} минути'
        },
        aboutXHours: {
          one: 'около час',
          other: 'около {{count}} часа'
        },
        xHours: {
          one: '1 час',
          other: '{{count}} часа'
        },
        xDays: {
          one: '1 ден',
          other: '{{count}} дни'
        },
        aboutXWeeks: {
          one: 'около седмица',
          other: 'около {{count}} седмици'
        },
        xWeeks: {
          one: '1 седмица',
          other: '{{count}} седмици'
        },
        aboutXMonths: {
          one: 'около месец',
          other: 'около {{count}} месеца'
        },
        xMonths: {
          one: '1 месец',
          other: '{{count}} месеца'
        },
        aboutXYears: {
          one: 'около година',
          other: 'около {{count}} години'
        },
        xYears: {
          one: '1 година',
          other: '{{count}} години'
        },
        overXYears: {
          one: 'над година',
          other: 'над {{count}} години'
        },
        almostXYears: {
          one: 'почти година',
          other: 'почти {{count}} години'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'след ' + result;
          } else {
            return 'преди ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 478 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, dd MMMM yyyy',
        long: 'dd MMMM yyyy',
        medium: 'dd MMM yyyy',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        any: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 479 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13); // Adapted from the `ru` translation


      var weekdays = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];

      function _lastWeek2(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'миналата " + weekday + " в' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'миналия " + weekday + " в' p";
        }
      }

      function thisWeek(day) {
        var weekday = weekdays[day];

        if (day === 2
        /* Tue */
        ) {
          return "'във " + weekday + " в' p";
        } else {
          return "'в " + weekday + " в' p";
        }
      }

      function _nextWeek2(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'следващата " + weekday + " в' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'следващия " + weekday + " в' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _lastWeek2(day);
          }
        },
        yesterday: "'вчера в' p",
        today: "'днес в' p",
        tomorrow: "'утре в' p",
        nextWeek: function nextWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _nextWeek2(day);
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 480 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['пр.н.е.', 'н.е.'],
        abbreviated: ['преди н. е.', 'н. е.'],
        wide: ['преди новата ера', 'новата ера']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1-во тримес.', '2-ро тримес.', '3-то тримес.', '4-то тримес.'],
        wide: ['1-во тримесечие', '2-ро тримесечие', '3-то тримесечие', '4-то тримесечие']
      };
      var monthValues = {
        abbreviated: ['яну', 'фев', 'мар', 'апр', 'май', 'юни', 'юли', 'авг', 'сеп', 'окт', 'ное', 'дек'],
        wide: ['януари', 'февруари', 'март', 'април', 'май', 'юни', 'юли', 'август', 'септември', 'октомври', 'ноември', 'декември']
      };
      var dayValues = {
        narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
        short: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
        abbreviated: ['нед', 'пон', 'вто', 'сря', 'чет', 'пет', 'съб'],
        wide: ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота']
      };
      var dayPeriodValues = {
        wide: {
          am: 'преди обяд',
          pm: 'след обяд',
          midnight: 'в полунощ',
          noon: 'на обяд',
          morning: 'сутринта',
          afternoon: 'следобед',
          evening: 'вечерта',
          night: 'през нощта'
        }
      };

      function isFeminine(unit) {
        return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
      }

      function isNeuter(unit) {
        return unit === 'quarter';
      }

      function numberWithSuffix(number, unit, masculine, feminine, neuter) {
        var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
        return number + '-' + suffix;
      }

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var number = Number(dirtyNumber);

        if (number === 0) {
          return numberWithSuffix(0, unit, 'ев', 'ева', 'ево');
        } else if (number % 1000 === 0) {
          return numberWithSuffix(number, unit, 'ен', 'на', 'но');
        } else if (number % 100 === 0) {
          return numberWithSuffix(number, unit, 'тен', 'тна', 'тно');
        }

        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return numberWithSuffix(number, unit, 'ви', 'ва', 'во');

            case 2:
              return numberWithSuffix(number, unit, 'ри', 'ра', 'ро');

            case 7:
            case 8:
              return numberWithSuffix(number, unit, 'ми', 'ма', 'мо');
          }
        }

        return numberWithSuffix(number, unit, 'ти', 'та', 'то');
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 481 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((пр)?н\.?\s?е\.?)/i,
        abbreviated: /^((пр)?н\.?\s?е\.?)/i,
        wide: /^(преди новата ера|новата ера|нова ера)/i
      };
      var parseEraPatterns = {
        any: [/^п/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
        wide: /^[1234](-?[врт]?о?)? тримесечие/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchDayPatterns = {
        narrow: /^[нпвсч]/i,
        short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
        abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
        wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
      };
      var parseDayPatterns = {
        narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
      };
      var matchMonthPatterns = {
        abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
        wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
      };
      var parseMonthPatterns = {
        any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^преди о/i,
          pm: /^след о/i,
          midnight: /^в пол/i,
          noon: /^на об/i,
          morning: /^сут/i,
          afternoon: /^следо/i,
          evening: /^веч/i,
          night: /^през н/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 482 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(483);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(484);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(485);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(186);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(486);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Bengali locale.
       * @language Bengali
       * @iso-639-2 ben
       * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
       * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
       */


      var locale = {
        code: 'bn',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 483 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__localize_index_js__ = __webpack_require__(186);

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'প্রায় ১ সেকেন্ড',
          other: 'প্রায় {{count}} সেকেন্ড'
        },
        xSeconds: {
          one: '১ সেকেন্ড',
          other: '{{count}} সেকেন্ড'
        },
        halfAMinute: 'আধ মিনিট',
        lessThanXMinutes: {
          one: 'প্রায় ১ মিনিট',
          other: 'প্রায় {{count}} মিনিট'
        },
        xMinutes: {
          one: '১ মিনিট',
          other: '{{count}} মিনিট'
        },
        aboutXHours: {
          one: 'প্রায় ১ ঘন্টা',
          other: 'প্রায় {{count}} ঘন্টা'
        },
        xHours: {
          one: '১ ঘন্টা',
          other: '{{count}} ঘন্টা'
        },
        xDays: {
          one: '১ দিন',
          other: '{{count}} দিন'
        },
        aboutXWeeks: {
          one: 'প্রায় ১ সপ্তাহ',
          other: 'প্রায় {{count}} সপ্তাহ'
        },
        xWeeks: {
          one: '১ সপ্তাহ',
          other: '{{count}} সপ্তাহ'
        },
        aboutXMonths: {
          one: 'প্রায় ১ মাস',
          other: 'প্রায় {{count}} মাস'
        },
        xMonths: {
          one: '১ মাস',
          other: '{{count}} মাস'
        },
        aboutXYears: {
          one: 'প্রায় ১ বছর',
          other: 'প্রায় {{count}} বছর'
        },
        xYears: {
          one: '১ বছর',
          other: '{{count}} বছর'
        },
        overXYears: {
          one: '১ বছরের বেশি',
          other: '{{count}} বছরের বেশি'
        },
        almostXYears: {
          one: 'প্রায় ১ বছর',
          other: 'প্রায় {{count}} বছর'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', __WEBPACK_IMPORTED_MODULE_0__localize_index_js__["a"
          /* default */
          ].numberToLocale(count));
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + ' এর মধ্যে';
          } else {
            return result + ' আগে';
          }
        }

        return result;
      }
      /***/

    },
    /* 484 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}} 'সময়'",
        long: "{{date}} {{time}} 'সময়'",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 485 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'গত' eeee 'সময়' p",
        yesterday: "'গতকাল' 'সময়' p",
        today: "'আজ' 'সময়' p",
        tomorrow: "'আগামীকাল' 'সময়' p",
        nextWeek: "eeee 'সময়' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 486 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
        abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
        wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
      };
      var parseEraPatterns = {
        narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
        abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
        wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[১২৩৪]/i,
        abbreviated: /^[১২৩৪]ত্রৈ/i,
        wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
      };
      var parseQuarterPatterns = {
        any: [/১/i, /২/i, /৩/i, /৪/i]
      };
      var matchMonthPatterns = {
        narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
        abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
        wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
      };
      var parseMonthPatterns = {
        any: [/^জানু/i, /^ফেব্রু/i, /^মার্চ/i, /^এপ্রিল/i, /^মে/i, /^জুন/i, /^জুলাই/i, /^আগস্ট/i, /^সেপ্ট/i, /^অক্টো/i, /^নভে/i, /^ডিসে/i]
      };
      var matchDayPatterns = {
        narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
        short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
        abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
        wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
      };
      var parseDayPatterns = {
        narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
        short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
        abbreviated: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
        wide: [/^রবিবার/i, /^সোমবার/i, /^মঙ্গলবার/i, /^বুধবার/i, /^বৃহস্পতিবার /i, /^শুক্রবার/i, /^শনিবার/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
        abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
        wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^পূ/i,
          pm: /^অপ/i,
          midnight: /^মধ্যরাত/i,
          noon: /^মধ্যাহ্ন/i,
          morning: /সকাল/i,
          afternoon: /বিকাল/i,
          evening: /সন্ধ্যা/i,
          night: /রাত/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 487 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(488);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(489);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(490);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(491);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(492);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Catalan locale.
       * @language Catalan
       * @iso-639-2 cat
       * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
       * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
       */


      var locale = {
        code: 'ca',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale; // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')

      /***/
    },
    /* 488 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      /**
       * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
       *    l'1 de juliol ('l'u')
       *    l'11 de novembre ('l'onze')
       *    l'11a clàusula del contracte ('l'onzena')
       *    la contractació d'11 jugadors ('d'onze')
       *    l'aval d'11.000 socis ('d'onze mil')
       *
       * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
       */

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: "menys d'un segon",
          eleven: "menys d'onze segons",
          other: 'menys de {{count}} segons'
        },
        xSeconds: {
          one: '1 segon',
          other: '{{count}} segons'
        },
        halfAMinute: 'mig minut',
        lessThanXMinutes: {
          one: "menys d'un minut",
          eleven: "menys d'onze minuts",
          other: 'menys de {{count}} minuts'
        },
        xMinutes: {
          one: '1 minut',
          other: '{{count}} minuts'
        },
        aboutXHours: {
          one: 'aproximadament una hora',
          other: 'aproximadament {{count}} hores'
        },
        xHours: {
          one: '1 hora',
          other: '{{count}} hores'
        },
        xDays: {
          one: '1 dia',
          other: '{{count}} dies'
        },
        aboutXWeeks: {
          one: 'aproximadament una setmana',
          other: 'aproximadament {{count}} setmanes'
        },
        xWeeks: {
          one: '1 setmana',
          other: '{{count}} setmanes'
        },
        aboutXMonths: {
          one: 'aproximadament un mes',
          other: 'aproximadament {{count}} mesos'
        },
        xMonths: {
          one: '1 mes',
          other: '{{count}} mesos'
        },
        aboutXYears: {
          one: 'aproximadament un any',
          other: 'aproximadament {{count}} anys'
        },
        xYears: {
          one: '1 any',
          other: '{{count}} anys'
        },
        overXYears: {
          one: "més d'un any",
          eleven: "més d'onze anys",
          other: 'més de {{count}} anys'
        },
        almostXYears: {
          one: 'gairebé un any',
          other: 'gairebé {{count}} anys'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 11 && formatDistanceLocale[token].eleven) {
          result = formatDistanceLocale[token].eleven;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'en ' + result;
          } else {
            return 'fa ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 489 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, d 'de' MMMM y",
        long: "d 'de' MMMM y",
        medium: 'd MMM y',
        short: 'dd/MM/y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'a les' {{time}}",
        long: "{{date}} 'a les' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 490 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'el' eeee 'passat a la' LT",
        yesterday: "'ahir a la' p",
        today: "'avui a la' p",
        tomorrow: "'demà a la' p",
        nextWeek: "eeee 'a la' p",
        other: 'P'
      };
      var formatRelativeLocalePlural = {
        lastWeek: "'el' eeee 'passat a les' p",
        yesterday: "'ahir a les' p",
        today: "'avui a les' p",
        tomorrow: "'demà a les' p",
        nextWeek: "eeee 'a les' p",
        other: 'P'
      };

      function formatRelative(token, date, _baseDate, _options) {
        if (date.getUTCHours() !== 1) {
          return formatRelativeLocalePlural[token];
        }

        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 491 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);
      /**
       * General information
       * Reference: https://aplicacions.llengua.gencat.cat
       * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
       */

      /**
       * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
       * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
       */


      var eraValues = {
        narrow: ['aC', 'dC'],
        abbreviated: ['a. de C.', 'd. de C.'],
        wide: ['abans de Crist', 'després de Crist']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['T1', 'T2', 'T3', 'T4'],
        wide: ['1r trimestre', '2n trimestre', '3r trimestre', '4t trimestre']
        /**
         * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
         * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
         *
         * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
         */

      };
      var monthValues = {
        narrow: ['GN', 'FB', 'MÇ', 'AB', 'MG', 'JN', 'JL', 'AG', 'ST', 'OC', 'NV', 'DS'],

        /**
         * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
         * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
         * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
         */
        abbreviated: ['gen.', 'febr.', 'març', 'abr.', 'maig', 'juny', 'jul.', 'ag.', 'set.', 'oct.', 'nov.', 'des.'],
        wide: ['gener', 'febrer', 'març', 'abril', 'maig', 'juny', 'juliol', 'agost', 'setembre', 'octubre', 'novembre', 'desembre']
        /**
         * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
         * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
         * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
         *
         * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
         * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
         * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
         *
         * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
         */

      };
      var dayValues = {
        narrow: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
        short: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
        abbreviated: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
        wide: ['diumenge', 'dilluns', 'dimarts', 'dimecres', 'dijous', 'divendres', 'dissabte']
        /**
         * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
         */

      };
      var dayPeriodValues = {
        narrow: {
          am: 'am',
          pm: 'pm',
          midnight: 'mitjanit',
          noon: 'migdia',
          morning: 'matí',
          afternoon: 'tarda',
          evening: 'vespre',
          night: 'nit'
        },
        abbreviated: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'mitjanit',
          noon: 'migdia',
          morning: 'matí',
          afternoon: 'tarda',
          evening: 'vespre',
          night: 'nit'
        },
        wide: {
          am: 'ante meridiem',
          pm: 'post meridiem',
          midnight: 'mitjanit',
          noon: 'migdia',
          morning: 'matí',
          afternoon: 'tarda',
          evening: 'vespre',
          night: 'nit'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'am',
          pm: 'pm',
          midnight: 'de la mitjanit',
          noon: 'del migdia',
          morning: 'del matí',
          afternoon: 'de la tarda',
          evening: 'del vespre',
          night: 'de la nit'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'de la mitjanit',
          noon: 'del migdia',
          morning: 'del matí',
          afternoon: 'de la tarda',
          evening: 'del vespre',
          night: 'de la nit'
        },
        wide: {
          am: 'ante meridiem',
          pm: 'post meridiem',
          midnight: 'de la mitjanit',
          noon: 'del migdia',
          morning: 'del matí',
          afternoon: 'de la tarda',
          evening: 'del vespre',
          night: 'de la nit'
        }
        /**
         * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
         * És optatiu posar punt després de la lletra.
         *
         * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
         *
         * @param {Number} dirtyNumber
         * @param {Object} [_dirtyOptions]
         */

      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return number + 'r';

            case 2:
              return number + 'n';

            case 3:
              return number + 'r';

            case 4:
              return number + 't';
          }
        }

        return number + 'è';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 492 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(aC|dC)/i,
        abbreviated: /^(a. de C.|d. de C.)/i,
        wide: /^(abans de Crist|despr[eé]s de Crist)/i
      };
      var parseEraPatterns = {
        narrow: [/^aC/i, /^dC/i],
        abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
        wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](è|r|n|r|t)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
        abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
        wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^GN/i, /^FB/i, /^MÇ/i, /^AB/i, /^MG/i, /^JN/i, /^JL/i, /^AG/i, /^ST/i, /^OC/i, /^NV/i, /^DS/i],
        abbreviated: [/^gen./i, /^febr./i, /^març/i, /^abr./i, /^maig/i, /^juny/i, /^jul./i, /^ag./i, /^set./i, /^oct./i, /^nov./i, /^des./i],
        wide: [/^gener/i, /^febrer/i, /^març/i, /^abril/i, /^maig/i, /^juny/i, /^juliol/i, /^agost/i, /^setembre/i, /^octubre/i, /^novembre/i, /^desembre/i]
      };
      var matchDayPatterns = {
        narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
        short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
        abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
        wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
      };
      var parseDayPatterns = {
        narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
        abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
        wide: [/^diumenge/i, /^dilluns/i, /^dimarts/i, /^dimecres/i, /^dijous/i, /^divendres/i, /^disssabte/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
        abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
        wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mitjanit/i,
          noon: /^migdia/i,
          morning: /matí/i,
          afternoon: /tarda/i,
          evening: /vespre/i,
          night: /nit/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 493 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(494);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(495);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(496);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(497);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(498);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Czech locale.
       * @language Czech
       * @iso-639-2 ces
       * @author David Rus [@davidrus]{@link https://github.com/davidrus}
       * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
       * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
       */


      var locale = {
        code: 'cs',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 494 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            regular: 'méně než vteřina',
            past: 'před méně než vteřinou',
            future: 'za méně než vteřinu'
          },
          few: {
            regular: 'méně než {{count}} vteřiny',
            past: 'před méně než {{count}} vteřinami',
            future: 'za méně než {{count}} vteřiny'
          },
          many: {
            regular: 'méně než {{count}} vteřin',
            past: 'před méně než {{count}} vteřinami',
            future: 'za méně než {{count}} vteřin'
          }
        },
        xSeconds: {
          one: {
            regular: 'vteřina',
            past: 'před vteřinou',
            future: 'za vteřinu'
          },
          few: {
            regular: '{{count}} vteřiny',
            past: 'před {{count}} vteřinami',
            future: 'za {{count}} vteřiny'
          },
          many: {
            regular: '{{count}} vteřin',
            past: 'před {{count}} vteřinami',
            future: 'za {{count}} vteřin'
          }
        },
        halfAMinute: {
          other: {
            regular: 'půl minuty',
            past: 'před půl minutou',
            future: 'za půl minuty'
          }
        },
        lessThanXMinutes: {
          one: {
            regular: 'méně než minuta',
            past: 'před méně než minutou',
            future: 'za méně než minutu'
          },
          few: {
            regular: 'méně než {{count}} minuty',
            past: 'před méně než {{count}} minutami',
            future: 'za méně než {{count}} minuty'
          },
          many: {
            regular: 'méně než {{count}} minut',
            past: 'před méně než {{count}} minutami',
            future: 'za méně než {{count}} minut'
          }
        },
        xMinutes: {
          one: {
            regular: 'minuta',
            past: 'před minutou',
            future: 'za minutu'
          },
          few: {
            regular: '{{count}} minuty',
            past: 'před {{count}} minutami',
            future: 'za {{count}} minuty'
          },
          many: {
            regular: '{{count}} minut',
            past: 'před {{count}} minutami',
            future: 'za {{count}} minut'
          }
        },
        aboutXHours: {
          one: {
            regular: 'přibližně hodina',
            past: 'přibližně před hodinou',
            future: 'přibližně za hodinu'
          },
          few: {
            regular: 'přibližně {{count}} hodiny',
            past: 'přibližně před {{count}} hodinami',
            future: 'přibližně za {{count}} hodiny'
          },
          many: {
            regular: 'přibližně {{count}} hodin',
            past: 'přibližně před {{count}} hodinami',
            future: 'přibližně za {{count}} hodin'
          }
        },
        xHours: {
          one: {
            regular: 'hodina',
            past: 'před hodinou',
            future: 'za hodinu'
          },
          few: {
            regular: '{{count}} hodiny',
            past: 'před {{count}} hodinami',
            future: 'za {{count}} hodiny'
          },
          many: {
            regular: '{{count}} hodin',
            past: 'před {{count}} hodinami',
            future: 'za {{count}} hodin'
          }
        },
        xDays: {
          one: {
            regular: 'den',
            past: 'před dnem',
            future: 'za den'
          },
          few: {
            regular: '{{count}} dny',
            past: 'před {{count}} dny',
            future: 'za {{count}} dny'
          },
          many: {
            regular: '{{count}} dní',
            past: 'před {{count}} dny',
            future: 'za {{count}} dní'
          }
        },
        aboutXWeeks: {
          one: {
            regular: 'přibližně týden',
            past: 'přibližně před týdnem',
            future: 'přibližně za týden'
          },
          few: {
            regular: 'přibližně {{count}} týdny',
            past: 'přibližně před {{count}} týdny',
            future: 'přibližně za {{count}} týdny'
          },
          many: {
            regular: 'přibližně {{count}} týdnů',
            past: 'přibližně před {{count}} týdny',
            future: 'přibližně za {{count}} týdnů'
          }
        },
        xWeeks: {
          one: {
            regular: 'týden',
            past: 'před týdnem',
            future: 'za týden'
          },
          few: {
            regular: '{{count}} týdny',
            past: 'před {{count}} týdny',
            future: 'za {{count}} týdny'
          },
          many: {
            regular: '{{count}} týdnů',
            past: 'před {{count}} týdny',
            future: 'za {{count}} týdnů'
          }
        },
        aboutXMonths: {
          one: {
            regular: 'přibližně měsíc',
            past: 'přibližně před měsícem',
            future: 'přibližně za měsíc'
          },
          few: {
            regular: 'přibližně {{count}} měsíce',
            past: 'přibližně před {{count}} měsíci',
            future: 'přibližně za {{count}} měsíce'
          },
          many: {
            regular: 'přibližně {{count}} měsíců',
            past: 'přibližně před {{count}} měsíci',
            future: 'přibližně za {{count}} měsíců'
          }
        },
        xMonths: {
          one: {
            regular: 'měsíc',
            past: 'před měsícem',
            future: 'za měsíc'
          },
          few: {
            regular: '{{count}} měsíce',
            past: 'před {{count}} měsíci',
            future: 'za {{count}} měsíce'
          },
          many: {
            regular: '{{count}} měsíců',
            past: 'před {{count}} měsíci',
            future: 'za {{count}} měsíců'
          }
        },
        aboutXYears: {
          one: {
            regular: 'přibližně rok',
            past: 'přibližně před rokem',
            future: 'přibližně za rok'
          },
          few: {
            regular: 'přibližně {{count}} roky',
            past: 'přibližně před {{count}} roky',
            future: 'přibližně za {{count}} roky'
          },
          many: {
            regular: 'přibližně {{count}} roků',
            past: 'přibližně před {{count}} roky',
            future: 'přibližně za {{count}} roků'
          }
        },
        xYears: {
          one: {
            regular: 'rok',
            past: 'před rokem',
            future: 'za rok'
          },
          few: {
            regular: '{{count}} roky',
            past: 'před {{count}} roky',
            future: 'za {{count}} roky'
          },
          many: {
            regular: '{{count}} roků',
            past: 'před {{count}} roky',
            future: 'za {{count}} roků'
          }
        },
        overXYears: {
          one: {
            regular: 'více než rok',
            past: 'před více než rokem',
            future: 'za více než rok'
          },
          few: {
            regular: 'více než {{count}} roky',
            past: 'před více než {{count}} roky',
            future: 'za více než {{count}} roky'
          },
          many: {
            regular: 'více než {{count}} roků',
            past: 'před více než {{count}} roky',
            future: 'za více než {{count}} roků'
          }
        },
        almostXYears: {
          one: {
            regular: 'skoro rok',
            past: 'skoro před rokem',
            future: 'skoro za rok'
          },
          few: {
            regular: 'skoro {{count}} roky',
            past: 'skoro před {{count}} roky',
            future: 'skoro za {{count}} roky'
          },
          many: {
            regular: 'skoro {{count}} roků',
            past: 'skoro před {{count}} roky',
            future: 'skoro za {{count}} roků'
          }
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var scheme = formatDistanceLocale[token]; // cs pluralization

        var pluralToken;

        if (typeof scheme.other === 'object') {
          pluralToken = 'other';
        } else if (count === 1) {
          pluralToken = 'one';
        } else if (count > 1 && count < 5 || count === 0) {
          pluralToken = 'few';
        } else {
          pluralToken = 'many';
        } // times


        var suffixExist = options.addSuffix === true;
        var comparison = options.comparison;
        var timeToken;

        if (suffixExist && comparison === -1) {
          timeToken = 'past';
        } else if (suffixExist && comparison === 1) {
          timeToken = 'future';
        } else {
          timeToken = 'regular';
        }

        return scheme[pluralToken][timeToken].replace('{{count}}', count);
      }
      /***/

    },
    /* 495 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d. MMMM yyyy',
        long: 'd. MMMM yyyy',
        medium: 'd.M.yyyy',
        short: 'd.M.yy'
      };
      var timeFormats = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'v' {{time}}",
        long: "{{date}} 'v' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 496 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var accusativeWeekdays = ['neděli', 'pondělí', 'úterý', 'středu', 'čtvrtek', 'pátek', 'sobotu'];
      var formatRelativeLocale = {
        lastWeek: "'poslední' eeee 've' p",
        yesterday: "'včera v' p",
        today: "'dnes v' p",
        tomorrow: "'zítra v' p",
        nextWeek: function nextWeek(date, _baseDate, _options) {
          var day = date.getUTCDay();
          return "'v " + accusativeWeekdays[day] + " o' p";
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 497 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['př. n. l.', 'n. l.'],
        abbreviated: ['př. n. l.', 'n. l.'],
        wide: ['před naším letopočtem', 'našeho letopočtu']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí'],
        wide: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí']
      };
      var monthValues = {
        narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
        abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
        wide: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec']
      };
      var formattingMonthValues = {
        narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
        abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
        wide: ['ledna', 'února', 'března', 'dubna', 'května', 'června', 'července', 'srpna', 'září', 'října', 'listopadu', 'prosince']
      };
      var dayValues = {
        narrow: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
        short: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
        abbreviated: ['ned', 'pon', 'úte', 'stř', 'čtv', 'pát', 'sob'],
        wide: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'dop.',
          pm: 'odp.',
          midnight: 'půlnoc',
          noon: 'poledne',
          morning: 'ráno',
          afternoon: 'odpoledne',
          evening: 'večer',
          night: 'noc'
        },
        abbreviated: {
          am: 'dop.',
          pm: 'odp.',
          midnight: 'půlnoc',
          noon: 'poledne',
          morning: 'ráno',
          afternoon: 'odpoledne',
          evening: 'večer',
          night: 'noc'
        },
        wide: {
          am: 'dopoledne',
          pm: 'odpoledne',
          midnight: 'půlnoc',
          noon: 'poledne',
          morning: 'ráno',
          afternoon: 'odpoledne',
          evening: 'večer',
          night: 'noc'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'dop.',
          pm: 'odp.',
          midnight: 'půlnoc',
          noon: 'poledne',
          morning: 'ráno',
          afternoon: 'odpoledne',
          evening: 'večer',
          night: 'noc'
        },
        abbreviated: {
          am: 'dop.',
          pm: 'odp.',
          midnight: 'půlnoc',
          noon: 'poledne',
          morning: 'ráno',
          afternoon: 'odpoledne',
          evening: 'večer',
          night: 'noc'
        },
        wide: {
          am: 'dopoledne',
          pm: 'odpoledne',
          midnight: 'půlnoc',
          noon: 'poledne',
          morning: 'ráno',
          afternoon: 'odpoledne',
          evening: 'večer',
          night: 'noc'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 498 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(p[řr]ed Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
        abbreviated: /^(pe[řr]ed Kr\.|pe[řr]ed n\. l\.|po Kr\.|n\. l\.)/i,
        wide: /^(p[řr]ed Kristem|pred na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
      };
      var parseEraPatterns = {
        any: [/^p[řr]/i, /^(po|n)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
        wide: /^[1234]\. [čc]tvrtlet[íi]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[lúubdkčcszřrlp]/i,
        abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
        wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
      };
      var parseMonthPatterns = {
        narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
        any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
      };
      var matchDayPatterns = {
        narrow: /^[npuúsčps]/i,
        short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
        abbreviated: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
        wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
      };
      var parseDayPatterns = {
        narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
        any: [/^ne/i, /^po/i, /^ut/i, /^st/i, /^[čc]t/i, /^p/i, /^so/i]
      };
      var matchDayPeriodPatterns = {
        any: /^dopoledne|dop\.?|odpoledne|odp\.?|půlnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^dop/i,
          pm: /^odp/i,
          midnight: /^p[ůu]lnoc/i,
          noon: /^poledne/i,
          morning: /r[áa]no/i,
          afternoon: /odpoledne/i,
          evening: /ve[čc]er/i,
          night: /noc/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 499 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(500);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(501);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(502);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(503);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(504);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Welsh locale.
       * @language Welsh
       * @iso-639-2 cym
       * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
       */


      var locale = {
        code: 'cy',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 500 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'llai na eiliad',
          other: 'llai na {{count}} eiliad'
        },
        xSeconds: {
          one: '1 eiliad',
          other: '{{count}} eiliad'
        },
        halfAMinute: 'hanner munud',
        lessThanXMinutes: {
          one: 'llai na munud',
          two: 'llai na 2 funud',
          other: 'llai na {{count}} munud'
        },
        xMinutes: {
          one: '1 munud',
          two: '2 funud',
          other: '{{count}} munud'
        },
        aboutXHours: {
          one: 'tua 1 awr',
          other: 'tua {{count}} awr'
        },
        xHours: {
          one: '1 awr',
          other: '{{count}} awr'
        },
        xDays: {
          one: '1 diwrnod',
          two: '2 ddiwrnod',
          other: '{{count}} diwrnod'
        },
        aboutXWeeks: {
          one: 'tua 1 wythnos',
          two: 'tua pythefnos',
          other: 'tua {{count}} wythnos'
        },
        xWeeks: {
          one: '1 wythnos',
          two: 'pythefnos',
          other: '{{count}} wythnos'
        },
        aboutXMonths: {
          one: 'tua 1 mis',
          two: 'tua 2 fis',
          other: 'tua {{count}} mis'
        },
        xMonths: {
          one: '1 mis',
          two: '2 fis',
          other: '{{count}} mis'
        },
        aboutXYears: {
          one: 'tua 1 flwyddyn',
          two: 'tua 2 flynedd',
          other: 'tua {{count}} mlynedd'
        },
        xYears: {
          one: '1 flwyddyn',
          two: '2 flynedd',
          other: '{{count}} mlynedd'
        },
        overXYears: {
          one: 'dros 1 flwyddyn',
          two: 'dros 2 flynedd',
          other: 'dros {{count}} mlynedd'
        },
        almostXYears: {
          one: 'bron 1 flwyddyn',
          two: 'bron 2 flynedd',
          other: 'bron {{count}} mlynedd'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2 && !!formatDistanceLocale[token].two) {
          result = formatDistanceLocale[token].two;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'mewn ' + result;
          } else {
            return result + ' yn ôl';
          }
        }

        return result;
      }
      /***/

    },
    /* 501 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM yyyy',
        medium: 'd MMM yyyy',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'am' {{time}}",
        long: "{{date}} 'am' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 502 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'diwethaf am' p",
        yesterday: "'ddoe am' p",
        today: "'heddiw am' p",
        tomorrow: "'yfory am' p",
        nextWeek: "eeee 'am' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 503 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['C', 'O'],
        abbreviated: ['CC', 'OC'],
        wide: ['Cyn Crist', 'Ar ôl Crist']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Ch1', 'Ch2', 'Ch3', 'Ch4'],
        wide: ['Chwarter 1af', '2ail chwarter', '3ydd chwarter', '4ydd chwarter'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['I', 'Ch', 'Ma', 'E', 'Mi', 'Me', 'G', 'A', 'Md', 'H', 'T', 'Rh'],
        abbreviated: ['Ion', 'Chwe', 'Maw', 'Ebr', 'Mai', 'Meh', 'Gor', 'Aws', 'Med', 'Hyd', 'Tach', 'Rhag'],
        wide: ['Ionawr', 'Chwefror', 'Mawrth', 'Ebrill', 'Mai', 'Mehefin', 'Gorffennaf', 'Awst', 'Medi', 'Hydref', 'Tachwedd', 'Rhagfyr']
      };
      var dayValues = {
        narrow: ['S', 'Ll', 'M', 'M', 'I', 'G', 'S'],
        short: ['Su', 'Ll', 'Ma', 'Me', 'Ia', 'Gw', 'Sa'],
        abbreviated: ['Sul', 'Llun', 'Maw', 'Mer', 'Iau', 'Gwe', 'Sad'],
        wide: ['dydd Sul', 'dydd Llun', 'dydd Mawrth', 'dydd Mercher', 'dydd Iau', 'dydd Gwener', 'dydd Sadwrn']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'b',
          pm: 'h',
          midnight: 'hn',
          noon: 'hd',
          morning: 'bore',
          afternoon: 'prynhawn',
          evening: "gyda'r nos",
          night: 'nos'
        },
        abbreviated: {
          am: 'yb',
          pm: 'yh',
          midnight: 'hanner nos',
          noon: 'hanner dydd',
          morning: 'bore',
          afternoon: 'prynhawn',
          evening: "gyda'r nos",
          night: 'nos'
        },
        wide: {
          am: 'y.b.',
          pm: 'y.h.',
          midnight: 'hanner nos',
          noon: 'hanner dydd',
          morning: 'bore',
          afternoon: 'prynhawn',
          evening: "gyda'r nos",
          night: 'nos'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'b',
          pm: 'h',
          midnight: 'hn',
          noon: 'hd',
          morning: 'yn y bore',
          afternoon: 'yn y prynhawn',
          evening: "gyda'r nos",
          night: 'yn y nos'
        },
        abbreviated: {
          am: 'yb',
          pm: 'yh',
          midnight: 'hanner nos',
          noon: 'hanner dydd',
          morning: 'yn y bore',
          afternoon: 'yn y prynhawn',
          evening: "gyda'r nos",
          night: 'yn y nos'
        },
        wide: {
          am: 'y.b.',
          pm: 'y.h.',
          midnight: 'hanner nos',
          noon: 'hanner dydd',
          morning: 'yn y bore',
          afternoon: 'yn y prynhawn',
          evening: "gyda'r nos",
          night: 'yn y nos'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);

        if (number < 20) {
          switch (number) {
            case 0:
              return number + 'fed';

            case 1:
              return number + 'af';

            case 2:
              return number + 'ail';

            case 3:
            case 4:
              return number + 'ydd';

            case 5:
            case 6:
              return number + 'ed';

            case 7:
            case 8:
            case 9:
            case 10:
            case 12:
            case 15:
            case 18:
              return number + 'fed';

            case 11:
            case 13:
            case 14:
            case 16:
            case 17:
            case 19:
              return number + 'eg';
          }
        } else if (number >= 50 && number <= 60 || number === 80 || number >= 100) {
          return number + 'fed';
        }

        return number + 'ain';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 504 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(c|o)/i,
        abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
        wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
      };
      var parseEraPatterns = {
        wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
        any: [/^c/i, /^o/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ch[1234]/i,
        wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
        abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
        wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
      };
      var parseMonthPatterns = {
        narrow: [/^i/i, /^ch/i, /^m/i, /^e/i, /^m/i, /^m/i, /^g/i, /^a/i, /^m/i, /^h/i, /^t/i, /^rh/i],
        any: [/^io/i, /^ch/i, /^maw/i, /^e/i, /^mai/i, /^meh/i, /^g/i, /^a/i, /^med/i, /^h/i, /^t/i, /^rh/i]
      };
      var matchDayPatterns = {
        narrow: /^(s|ll|m|i|g)/i,
        short: /^(su|ll|ma|me|ia|gw|sa)/i,
        abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
        wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
        wide: [/^dydd su/i, /^dydd ll/i, /^dydd ma/i, /^dydd me/i, /^dydd i/i, /^dydd g/i, /^dydd sa/i],
        any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
        any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^b|(y\.?\s?b\.?)/i,
          pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
          midnight: /^hn|hanner nos/i,
          noon: /^hd|hanner dydd/i,
          morning: /bore/i,
          afternoon: /prynhawn/i,
          evening: /^gyda'r nos$/i,
          night: /blah/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 505 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(506);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(507);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(508);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(509);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(510);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Danish locale.
       * @language Danish
       * @iso-639-2 dan
       * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
       * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
       * @author [@kgram]{@link https://github.com/kgram}
       * @author [@stefanbugge]{@link https://github.com/stefanbugge}
       */


      var locale = {
        code: 'da',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 506 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'mindre end ét sekund',
          other: 'mindre end {{count}} sekunder'
        },
        xSeconds: {
          one: '1 sekund',
          other: '{{count}} sekunder'
        },
        halfAMinute: 'ét halvt minut',
        lessThanXMinutes: {
          one: 'mindre end ét minut',
          other: 'mindre end {{count}} minutter'
        },
        xMinutes: {
          one: '1 minut',
          other: '{{count}} minutter'
        },
        aboutXHours: {
          one: 'cirka 1 time',
          other: 'cirka {{count}} timer'
        },
        xHours: {
          one: '1 time',
          other: '{{count}} timer'
        },
        xDays: {
          one: '1 dag',
          other: '{{count}} dage'
        },
        aboutXWeeks: {
          one: 'cirka 1 uge',
          other: 'cirka {{count}} uger'
        },
        xWeeks: {
          one: '1 uge',
          other: '{{count}} uger'
        },
        aboutXMonths: {
          one: 'cirka 1 måned',
          other: 'cirka {{count}} måneder'
        },
        xMonths: {
          one: '1 måned',
          other: '{{count}} måneder'
        },
        aboutXYears: {
          one: 'cirka 1 år',
          other: 'cirka {{count}} år'
        },
        xYears: {
          one: '1 år',
          other: '{{count}} år'
        },
        overXYears: {
          one: 'over 1 år',
          other: 'over {{count}} år'
        },
        almostXYears: {
          one: 'næsten 1 år',
          other: 'næsten {{count}} år'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'om ' + result;
          } else {
            return result + ' siden';
          }
        }

        return result;
      }
      /***/

    },
    /* 507 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE 'den' d. MMMM y",
        long: 'd. MMMM y',
        medium: 'd. MMM y',
        short: 'dd/MM/y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl'. {{time}}",
        long: "{{date}} 'kl'. {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 508 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'sidste' eeee 'kl.' p",
        yesterday: "'i går kl.' p",
        today: "'i dag kl.' p",
        tomorrow: "'i morgen kl.' p",
        nextWeek: "'på' eeee 'kl.' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 509 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['fvt', 'vt'],
        abbreviated: ['f.v.t.', 'v.t.'],
        wide: ['før vesterlandsk tidsregning', 'vesterlandsk tidsregning']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1. kvt.', '2. kvt.', '3. kvt.', '4. kvt.'],
        wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
        wide: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'] // Note that 'Days - abbreviated - Formatting' has periods at the end.
        // https://www.unicode.org/cldr/charts/32/summary/da.html#1760
        // This makes grammatical sense in danish, as most abbreviations have periods.

      };
      var dayValues = {
        narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
        short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
        abbreviated: ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'],
        wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'midnat',
          noon: 'middag',
          morning: 'morgen',
          afternoon: 'eftermiddag',
          evening: 'aften',
          night: 'nat'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'midnat',
          noon: 'middag',
          morning: 'morgen',
          afternoon: 'eftermiddag',
          evening: 'aften',
          night: 'nat'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnat',
          noon: 'middag',
          morning: 'morgen',
          afternoon: 'eftermiddag',
          evening: 'aften',
          night: 'nat'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'midnat',
          noon: 'middag',
          morning: 'om morgenen',
          afternoon: 'om eftermiddagen',
          evening: 'om aftenen',
          night: 'om natten'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'midnat',
          noon: 'middag',
          morning: 'om morgenen',
          afternoon: 'om eftermiddagen',
          evening: 'om aftenen',
          night: 'om natten'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnat',
          noon: 'middag',
          morning: 'om morgenen',
          afternoon: 'om eftermiddagen',
          evening: 'om aftenen',
          night: 'om natten'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 510 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(fKr|fvt|eKr|vt)/i,
        abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
        wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
      };
      var parseEraPatterns = {
        any: [/^f/i, /^(v|e)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]. kvt\./i,
        wide: /^[1234]\.? kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
        wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtofl]/i,
        short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
        abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
        wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
        any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
        any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /midnat/i,
          noon: /middag/i,
          morning: /morgen/i,
          afternoon: /eftermiddag/i,
          evening: /aften/i,
          night: /nat/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 511 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(512);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(513);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(514);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(515);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(516);
      /**
       * @type {Locale}
       * @category Locales
       * @summary German locale.
       * @language German
       * @iso-639-2 deu
       * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
       * @author Asia [@asia-t]{@link https://github.com/asia-t}
       * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
       * @author RomanErnst [@pex]{@link https://github.com/pex}
       * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
       */


      var locale = {
        code: 'de',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 512 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          standalone: {
            one: 'weniger als eine Sekunde',
            other: 'weniger als {{count}} Sekunden'
          },
          withPreposition: {
            one: 'weniger als einer Sekunde',
            other: 'weniger als {{count}} Sekunden'
          }
        },
        xSeconds: {
          standalone: {
            one: 'eine Sekunde',
            other: '{{count}} Sekunden'
          },
          withPreposition: {
            one: 'einer Sekunde',
            other: '{{count}} Sekunden'
          }
        },
        halfAMinute: {
          standalone: 'eine halbe Minute',
          withPreposition: 'einer halben Minute'
        },
        lessThanXMinutes: {
          standalone: {
            one: 'weniger als eine Minute',
            other: 'weniger als {{count}} Minuten'
          },
          withPreposition: {
            one: 'weniger als einer Minute',
            other: 'weniger als {{count}} Minuten'
          }
        },
        xMinutes: {
          standalone: {
            one: 'eine Minute',
            other: '{{count}} Minuten'
          },
          withPreposition: {
            one: 'einer Minute',
            other: '{{count}} Minuten'
          }
        },
        aboutXHours: {
          standalone: {
            one: 'etwa eine Stunde',
            other: 'etwa {{count}} Stunden'
          },
          withPreposition: {
            one: 'etwa einer Stunde',
            other: 'etwa {{count}} Stunden'
          }
        },
        xHours: {
          standalone: {
            one: 'eine Stunde',
            other: '{{count}} Stunden'
          },
          withPreposition: {
            one: 'einer Stunde',
            other: '{{count}} Stunden'
          }
        },
        xDays: {
          standalone: {
            one: 'ein Tag',
            other: '{{count}} Tage'
          },
          withPreposition: {
            one: 'einem Tag',
            other: '{{count}} Tagen'
          }
        },
        aboutXWeeks: {
          standalone: {
            one: 'etwa ein Woche',
            other: 'etwa {{count}} Wochen'
          },
          withPreposition: {
            one: 'etwa einem Woche',
            other: 'etwa {{count}} Wochen'
          }
        },
        xWeeks: {
          standalone: {
            one: 'ein Woche',
            other: '{{count}} Wochen'
          },
          withPreposition: {
            one: 'einem Woche',
            other: '{{count}} Wochen'
          }
        },
        aboutXMonths: {
          standalone: {
            one: 'etwa ein Monat',
            other: 'etwa {{count}} Monate'
          },
          withPreposition: {
            one: 'etwa einem Monat',
            other: 'etwa {{count}} Monaten'
          }
        },
        xMonths: {
          standalone: {
            one: 'ein Monat',
            other: '{{count}} Monate'
          },
          withPreposition: {
            one: 'einem Monat',
            other: '{{count}} Monaten'
          }
        },
        aboutXYears: {
          standalone: {
            one: 'etwa ein Jahr',
            other: 'etwa {{count}} Jahre'
          },
          withPreposition: {
            one: 'etwa einem Jahr',
            other: 'etwa {{count}} Jahren'
          }
        },
        xYears: {
          standalone: {
            one: 'ein Jahr',
            other: '{{count}} Jahre'
          },
          withPreposition: {
            one: 'einem Jahr',
            other: '{{count}} Jahren'
          }
        },
        overXYears: {
          standalone: {
            one: 'mehr als ein Jahr',
            other: 'mehr als {{count}} Jahre'
          },
          withPreposition: {
            one: 'mehr als einem Jahr',
            other: 'mehr als {{count}} Jahren'
          }
        },
        almostXYears: {
          standalone: {
            one: 'fast ein Jahr',
            other: 'fast {{count}} Jahre'
          },
          withPreposition: {
            one: 'fast einem Jahr',
            other: 'fast {{count}} Jahren'
          }
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
        var result;

        if (typeof usageGroup === 'string') {
          result = usageGroup;
        } else if (count === 1) {
          result = usageGroup.one;
        } else {
          result = usageGroup.other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'in ' + result;
          } else {
            return 'vor ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 513 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2); // DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008


      var dateFormats = {
        full: 'EEEE, do MMMM y',
        // Montag, 7. Januar 2018
        long: 'do MMMM y',
        // 7. Januar 2018
        medium: 'do MMM. y',
        // 7. Jan. 2018
        short: 'dd.MM.y' // 07.01.2018

      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'um' {{time}}",
        long: "{{date}} 'um' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 514 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'letzten' eeee 'um' p",
        yesterday: "'gestern um' p",
        today: "'heute um' p",
        tomorrow: "'morgen um' p",
        nextWeek: "eeee 'um' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 515 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['v.Chr.', 'n.Chr.'],
        abbreviated: ['v.Chr.', 'n.Chr.'],
        wide: ['vor Christus', 'nach Christus']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal'] // Note: in German, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
      };
      var dayValues = {
        narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
        short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
        abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
        wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'] // https://www.unicode.org/cldr/charts/32/summary/de.html#1881

      };
      var dayPeriodValues = {
        narrow: {
          am: 'vm.',
          pm: 'nm.',
          midnight: 'Mitternacht',
          noon: 'Mittag',
          morning: 'Morgen',
          afternoon: 'Nachm.',
          evening: 'Abend',
          night: 'Nacht'
        },
        abbreviated: {
          am: 'vorm.',
          pm: 'nachm.',
          midnight: 'Mitternacht',
          noon: 'Mittag',
          morning: 'Morgen',
          afternoon: 'Nachmittag',
          evening: 'Abend',
          night: 'Nacht'
        },
        wide: {
          am: 'vormittags',
          pm: 'nachmittags',
          midnight: 'Mitternacht',
          noon: 'Mittag',
          morning: 'Morgen',
          afternoon: 'Nachmittag',
          evening: 'Abend',
          night: 'Nacht'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'vm.',
          pm: 'nm.',
          midnight: 'Mitternacht',
          noon: 'Mittag',
          morning: 'morgens',
          afternoon: 'nachm.',
          evening: 'abends',
          night: 'nachts'
        },
        abbreviated: {
          am: 'vorm.',
          pm: 'nachm.',
          midnight: 'Mitternacht',
          noon: 'Mittag',
          morning: 'morgens',
          afternoon: 'nachmittags',
          evening: 'abends',
          night: 'nachts'
        },
        wide: {
          am: 'vormittags',
          pm: 'nachmittags',
          midnight: 'Mitternacht',
          noon: 'Mittag',
          morning: 'morgens',
          afternoon: 'nachmittags',
          evening: 'abends',
          night: 'nachts'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 516 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
        abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
        wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
      };
      var parseEraPatterns = {
        any: [/^v/i, /^n/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](\.)? Quartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mär|apr|mai|jun|jul|aug|sep|okt|nov|dez)/i,
        wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smdmf]/i,
        short: /^(so|mo|di|mi|do|fr|sa)/i,
        abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
        wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
      };
      var parseDayPatterns = {
        any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
        abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
        wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^v/i,
          pm: /^n/i,
          midnight: /^Mitte/i,
          noon: /^Mitta/i,
          morning: /morgens/i,
          afternoon: /nachmittags/i,
          // will never be matched. Afternoon is matched by `pm`
          evening: /abends/i,
          night: /nachts/i // will never be matched. Night is matched by `pm`

        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 517 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(518);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(519);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(520);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(521);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(522);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Greek locale.
       * @language Greek
       * @iso-639-2 ell
       * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
       * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
       */


      var locale = {
        code: 'el',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 518 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'λιγότερο από ένα δευτερόλεπτο',
          other: 'λιγότερο από {{count}} δευτερόλεπτα'
        },
        xSeconds: {
          one: '1 δευτερόλεπτο',
          other: '{{count}} δευτερόλεπτα'
        },
        halfAMinute: 'μισό λεπτό',
        lessThanXMinutes: {
          one: 'λιγότερο από ένα λεπτό',
          other: 'λιγότερο από {{count}} λεπτά'
        },
        xMinutes: {
          one: '1 λεπτό',
          other: '{{count}} λεπτά'
        },
        aboutXHours: {
          one: 'περίπου 1 ώρα',
          other: 'περίπου {{count}} ώρες'
        },
        xHours: {
          one: '1 ώρα',
          other: '{{count}} ώρες'
        },
        xDays: {
          one: '1 ημέρα',
          other: '{{count}} ημέρες'
        },
        aboutXWeeks: {
          one: 'περίπου 1 εβδομάδα',
          other: 'περίπου {{count}} εβδομάδες'
        },
        xWeeks: {
          one: '1 εβδομάδα',
          other: '{{count}} εβδομάδες'
        },
        aboutXMonths: {
          one: 'περίπου 1 μήνας',
          other: 'περίπου {{count}} μήνες'
        },
        xMonths: {
          one: '1 μήνας',
          other: '{{count}} μήνες'
        },
        aboutXYears: {
          one: 'περίπου 1 χρόνο',
          other: 'περίπου {{count}} χρόνια'
        },
        xYears: {
          one: '1 χρόνο',
          other: '{{count}} χρόνια'
        },
        overXYears: {
          one: 'πάνω από 1 χρόνο',
          other: 'πάνω από {{count}} χρόνια'
        },
        almostXYears: {
          one: 'περίπου 1 χρόνο',
          other: 'περίπου {{count}} χρόνια'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'σε ' + result;
          } else {
            return result + ' πριν';
          }
        }

        return result;
      }
      /***/

    },
    /* 519 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM y',
        long: 'd MMMM y',
        medium: 'd MMM y',
        short: 'd/M/yy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: '{{date}} - {{time}}',
        long: '{{date}} - {{time}}',
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 520 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function lastWeek(date) {
          switch (date.getUTCDay()) {
            case 6:
              //Σάββατο
              return "'το προηγούμενο' eeee 'στις' p";

            default:
              return "'την προηγούμενη' eeee 'στις' p";
          }
        },
        yesterday: "'χθες στις' p",
        today: "'σήμερα στις' p",
        tomorrow: "'αύριο στις' p",
        nextWeek: "eeee 'στις' p",
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];
        if (typeof format === 'function') return format(date, baseDate, options);
        return format;
      }
      /***/

    },
    /* 521 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['πΧ', 'μΧ'],
        abbreviated: ['π.Χ.', 'μ.Χ.'],
        wide: ['προ Χριστού', 'μετά Χριστόν']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Τ1', 'Τ2', 'Τ3', 'Τ4'],
        wide: ['1ο τρίμηνο', '2ο τρίμηνο', '3ο τρίμηνο', '4ο τρίμηνο']
      };
      var monthValues = {
        narrow: ['Ι', 'Φ', 'Μ', 'Α', 'Μ', 'Ι', 'Ι', 'Α', 'Σ', 'Ο', 'Ν', 'Δ'],
        abbreviated: ['Ιαν', 'Φεβ', 'Μάρ', 'Απρ', 'Μάι', 'Ιούν', 'Ιούλ', 'Αύγ', 'Σεπ', 'Οκτ', 'Νοέ', 'Δεκ'],
        wide: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος']
      };
      var formattingMonthValues = {
        narrow: ['Ι', 'Φ', 'Μ', 'Α', 'Μ', 'Ι', 'Ι', 'Α', 'Σ', 'Ο', 'Ν', 'Δ'],
        abbreviated: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαΐ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
        wide: ['Ιανουαρίου', 'Φεβρουαρίου', 'Μαρτίου', 'Απριλίου', 'Μαΐου', 'Ιουνίου', 'Ιουλίου', 'Αυγούστου', 'Σεπτεμβρίου', 'Οκτωβρίου', 'Νοεμβρίου', 'Δεκεμβρίου']
      };
      var dayValues = {
        narrow: ['Κ', 'Δ', 'T', 'Τ', 'Π', 'Π', 'Σ'],
        short: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πέ', 'Πα', 'Σά'],
        abbreviated: ['Κυρ', 'Δευ', 'Τρί', 'Τετ', 'Πέμ', 'Παρ', 'Σάβ'],
        wide: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'πμ',
          pm: 'μμ',
          midnight: 'μεσάνυχτα',
          noon: 'μεσημέρι',
          morning: 'πρωί',
          afternoon: 'απόγευμα',
          evening: 'βράδυ',
          night: 'νύχτα'
        },
        abbreviated: {
          am: 'π.μ.',
          pm: 'μ.μ.',
          midnight: 'μεσάνυχτα',
          noon: 'μεσημέρι',
          morning: 'πρωί',
          afternoon: 'απόγευμα',
          evening: 'βράδυ',
          night: 'νύχτα'
        },
        wide: {
          am: 'π.μ.',
          pm: 'μ.μ.',
          midnight: 'μεσάνυχτα',
          noon: 'μεσημέρι',
          morning: 'πρωί',
          afternoon: 'απόγευμα',
          evening: 'βράδυ',
          night: 'νύχτα'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (unit === 'year' || unit === 'month') {
          suffix = 'ος';
        } else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') {
          suffix = 'η';
        } else {
          suffix = 'ο';
        }

        return dirtyNumber + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 522 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(πΧ|μΧ)/i,
        abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
        wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
      };
      var parseEraPatterns = {
        any: [/^π/i, /^(μ|κ)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^τ[1234]/i,
        wide: /^[1234]ο? τρ(ί|ι)μηνο/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[ιφμαμιιασονδ]/i,
        abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
        wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
        any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
      };
      var matchDayPatterns = {
        narrow: /^[κδτπσ]/i,
        short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
        abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
        wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
      };
      var parseDayPatterns = {
        narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
        any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
        any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^πμ|π\.\s?μ\./i,
          pm: /^μμ|μ\.\s?μ\./i,
          midnight: /^μεσάν/i,
          noon: /^μεσημ(έ|ε)/i,
          morning: /πρω(ί|ι)/i,
          afternoon: /απ(ό|ο)γευμα/i,
          evening: /βρ(ά|α)δυ/i,
          night: /ν(ύ|υ)χτα/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 523 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__en_US_lib_formatDistance_index_js__ = __webpack_require__(48);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(524);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__ = __webpack_require__(35);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__ = __webpack_require__(36);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__ = __webpack_require__(37);
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (Australia).
       * @language English
       * @iso-639-2 eng
       * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
       */


      var locale = {
        code: 'en-AU',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__en_US_lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 524 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM yyyy',
        medium: 'd MMM yyyy',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 525 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(526);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(527);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__ = __webpack_require__(35);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__ = __webpack_require__(36);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__ = __webpack_require__(37);
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (Canada).
       * @language English
       * @iso-639-2 eng
       * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
       * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
       */


      var locale = {
        code: 'en-CA',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 526 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'less than a second',
          other: 'less than {{count}} seconds'
        },
        xSeconds: {
          one: 'a second',
          other: '{{count}} seconds'
        },
        halfAMinute: 'half a minute',
        lessThanXMinutes: {
          one: 'less than a minute',
          other: 'less than {{count}} minutes'
        },
        xMinutes: {
          one: 'a minute',
          other: '{{count}} minutes'
        },
        aboutXHours: {
          one: 'about an hour',
          other: 'about {{count}} hours'
        },
        xHours: {
          one: 'an hour',
          other: '{{count}} hours'
        },
        xDays: {
          one: 'a day',
          other: '{{count}} days'
        },
        aboutXWeeks: {
          one: 'about a week',
          other: 'about {{count}} weeks'
        },
        xWeeks: {
          one: 'a week',
          other: '{{count}} weeks'
        },
        aboutXMonths: {
          one: 'about a month',
          other: 'about {{count}} months'
        },
        xMonths: {
          one: 'a month',
          other: '{{count}} months'
        },
        aboutXYears: {
          one: 'about a year',
          other: 'about {{count}} years'
        },
        xYears: {
          one: 'a year',
          other: '{{count}} years'
        },
        overXYears: {
          one: 'over a year',
          other: 'over {{count}} years'
        },
        almostXYears: {
          one: 'almost a year',
          other: 'almost {{count}} years'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'in ' + result;
          } else {
            return result + ' ago';
          }
        }

        return result;
      }
      /***/

    },
    /* 527 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, MMMM do, yyyy',
        long: 'MMMM do, yyyy',
        medium: 'MMM d, yyyy',
        short: 'yyyy-MM-dd'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 528 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__en_US_lib_formatDistance_index_js__ = __webpack_require__(48);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(529);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__ = __webpack_require__(35);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__ = __webpack_require__(36);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__ = __webpack_require__(37);
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (United Kingdom).
       * @language English
       * @iso-639-2 eng
       * @author Alex [@glintik]{@link https://github.com/glintik}
       */


      var locale = {
        code: 'en-GB',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__en_US_lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 529 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM yyyy',
        medium: 'd MMM yyyy',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 530 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__en_US_lib_formatDistance_index_js__ = __webpack_require__(48);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(531);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__ = __webpack_require__(35);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__ = __webpack_require__(36);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__ = __webpack_require__(37);
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (India).
       * @language English
       * @iso-639-2 eng
       * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
       */


      var locale = {
        code: 'en-IN',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__en_US_lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1,
          // Monday is the first day of the week.
          firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.

        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 531 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM, yyyy',
        medium: 'd MMM, yyyy',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 532 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__en_US_lib_formatDistance_index_js__ = __webpack_require__(48);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(533);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__ = __webpack_require__(35);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__ = __webpack_require__(36);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__ = __webpack_require__(37);
      /**
       * @type {Locale}
       * @category Locales
       * @summary English locale (New Zealand).
       * @language English
       * @iso-639-2 eng
       * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
       */


      var locale = {
        code: 'en-NZ',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__en_US_lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__en_US_lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__en_US_lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__en_US_lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 533 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM yyyy',
        medium: 'd MMM yyyy',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'at' {{time}}",
        long: "{{date}} 'at' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 534 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(535);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(536);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(537);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(538);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(539);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Esperanto locale.
       * @language Esperanto
       * @iso-639-2 epo
       * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
       */


      var locale = {
        code: 'eo',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 535 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'malpli ol sekundo',
          other: 'malpli ol {{count}} sekundoj'
        },
        xSeconds: {
          one: '1 sekundo',
          other: '{{count}} sekundoj'
        },
        halfAMinute: 'duonminuto',
        lessThanXMinutes: {
          one: 'malpli ol minuto',
          other: 'malpli ol {{count}} minutoj'
        },
        xMinutes: {
          one: '1 minuto',
          other: '{{count}} minutoj'
        },
        aboutXHours: {
          one: 'proksimume 1 horo',
          other: 'proksimume {{count}} horoj'
        },
        xHours: {
          one: '1 horo',
          other: '{{count}} horoj'
        },
        xDays: {
          one: '1 tago',
          other: '{{count}} tagoj'
        },
        aboutXMonths: {
          one: 'proksimume 1 monato',
          other: 'proksimume {{count}} monatoj'
        },
        xWeeks: {
          one: '1 semajno',
          other: '{{count}} semajnoj'
        },
        aboutXWeeks: {
          one: 'proksimume 1 semajno',
          other: 'proksimume {{count}} semajnoj'
        },
        xMonths: {
          one: '1 monato',
          other: '{{count}} monatoj'
        },
        aboutXYears: {
          one: 'proksimume 1 jaro',
          other: 'proksimume {{count}} jaroj'
        },
        xYears: {
          one: '1 jaro',
          other: '{{count}} jaroj'
        },
        overXYears: {
          one: 'pli ol 1 jaro',
          other: 'pli ol {{count}} jaroj'
        },
        almostXYears: {
          one: 'preskaŭ 1 jaro',
          other: 'preskaŭ {{count}} jaroj'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'post ' + result;
          } else {
            return 'antaŭ ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 536 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, do 'de' MMMM y",
        long: 'y-MMMM-dd',
        medium: 'y-MMM-dd',
        short: 'yyyy-MM-dd'
      };
      var timeFormats = {
        full: "Ho 'horo kaj' m:ss zzzz",
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        any: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 537 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'pasinta' eeee 'je' p",
        yesterday: "'hieraŭ je' p",
        today: "'hodiaŭ je' p",
        tomorrow: "'morgaŭ je' p",
        nextWeek: "eeee 'je' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 538 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['aK', 'pK'],
        abbreviated: ['a.K.E.', 'p.K.E.'],
        wide: ['antaŭ Komuna Erao', 'Komuna Erao']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['K1', 'K2', 'K3', 'K4'],
        wide: ['1-a kvaronjaro', '2-a kvaronjaro', '3-a kvaronjaro', '4-a kvaronjaro']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aŭg', 'sep', 'okt', 'nov', 'dec'],
        wide: ['januaro', 'februaro', 'marto', 'aprilo', 'majo', 'junio', 'julio', 'aŭgusto', 'septembro', 'oktobro', 'novembro', 'decembro']
      };
      var dayValues = {
        narrow: ['D', 'L', 'M', 'M', 'Ĵ', 'V', 'S'],
        short: ['di', 'lu', 'ma', 'me', 'ĵa', 've', 'sa'],
        abbreviated: ['dim', 'lun', 'mar', 'mer', 'ĵaŭ', 'ven', 'sab'],
        wide: ['dimanĉo', 'lundo', 'mardo', 'merkredo', 'ĵaŭdo', 'vendredo', 'sabato']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'noktomezo',
          noon: 'tagmezo',
          morning: 'matene',
          afternoon: 'posttagmeze',
          evening: 'vespere',
          night: 'nokte'
        },
        abbreviated: {
          am: 'a.t.m.',
          pm: 'p.t.m.',
          midnight: 'noktomezo',
          noon: 'tagmezo',
          morning: 'matene',
          afternoon: 'posttagmeze',
          evening: 'vespere',
          night: 'nokte'
        },
        wide: {
          am: 'antaŭtagmeze',
          pm: 'posttagmeze',
          midnight: 'noktomezo',
          noon: 'tagmezo',
          morning: 'matene',
          afternoon: 'posttagmeze',
          evening: 'vespere',
          night: 'nokte'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + '-a';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 539 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([ap]k)/i,
        abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
        wide: /^((antaǔ |post )?komuna erao)/i
      };
      var parseEraPatterns = {
        any: [/^a/i, /^[kp]/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^k[1234]/i,
        wide: /^[1234](-?a)? kvaronjaro/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
        wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^a(u|ŭ)/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmĵjvs]/i,
        short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
        abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
        wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
        any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
        abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
        wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^noktom/i,
          noon: /^t/i,
          morning: /^m/i,
          afternoon: /^posttagmeze/i,
          evening: /^v/i,
          night: /^n/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 540 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(541);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(542);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(543);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(544);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(545);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Spanish locale.
       * @language Spanish
       * @iso-639-2 spa
       * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
       * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
       * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
       * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
       * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
       */


      var locale = {
        code: 'es',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 541 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'menos de un segundo',
          other: 'menos de {{count}} segundos'
        },
        xSeconds: {
          one: '1 segundo',
          other: '{{count}} segundos'
        },
        halfAMinute: 'medio minuto',
        lessThanXMinutes: {
          one: 'menos de un minuto',
          other: 'menos de {{count}} minutos'
        },
        xMinutes: {
          one: '1 minuto',
          other: '{{count}} minutos'
        },
        aboutXHours: {
          one: 'alrededor de 1 hora',
          other: 'alrededor de {{count}} horas'
        },
        xHours: {
          one: '1 hora',
          other: '{{count}} horas'
        },
        xDays: {
          one: '1 día',
          other: '{{count}} días'
        },
        aboutXWeeks: {
          one: 'alrededor de 1 semana',
          other: 'alrededor de {{count}} semanas'
        },
        xWeeks: {
          one: '1 semana',
          other: '{{count}} semanas'
        },
        aboutXMonths: {
          one: 'alrededor de 1 mes',
          other: 'alrededor de {{count}} meses'
        },
        xMonths: {
          one: '1 mes',
          other: '{{count}} meses'
        },
        aboutXYears: {
          one: 'alrededor de 1 año',
          other: 'alrededor de {{count}} años'
        },
        xYears: {
          one: '1 año',
          other: '{{count}} años'
        },
        overXYears: {
          one: 'más de 1 año',
          other: 'más de {{count}} años'
        },
        almostXYears: {
          one: 'casi 1 año',
          other: 'casi {{count}} años'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'en ' + result;
          } else {
            return 'hace ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 542 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, d 'de' MMMM 'de' y",
        long: "d 'de' MMMM 'de' y",
        medium: 'd MMM y',
        short: 'dd/MM/y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'a las' {{time}}",
        long: "{{date}} 'a las' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 543 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'el' eeee 'pasado a la' LT",
        yesterday: "'ayer a la' p",
        today: "'hoy a la' p",
        tomorrow: "'mañana a la' p",
        nextWeek: "eeee 'a la' p",
        other: 'P'
      };
      var formatRelativeLocalePlural = {
        lastWeek: "'el' eeee 'pasado a las' p",
        yesterday: "'ayer a las' p",
        today: "'hoy a las' p",
        tomorrow: "'mañana a las' p",
        nextWeek: "eeee 'a las' p",
        other: 'P'
      };

      function formatRelative(token, date, _baseDate, _options) {
        if (date.getUTCHours() !== 1) {
          return formatRelativeLocalePlural[token];
        }

        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 544 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['AC', 'DC'],
        abbreviated: ['AC', 'DC'],
        wide: ['antes de cristo', 'después de cristo']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['T1', 'T2', 'T3', 'T4'],
        wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
      };
      var monthValues = {
        narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
        abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
      };
      var dayValues = {
        narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
        short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sa'],
        abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mn',
          noon: 'md',
          morning: 'mañana',
          afternoon: 'tarde',
          evening: 'tarde',
          night: 'noche'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'medianoche',
          noon: 'mediodia',
          morning: 'mañana',
          afternoon: 'tarde',
          evening: 'tarde',
          night: 'noche'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'medianoche',
          noon: 'mediodia',
          morning: 'mañana',
          afternoon: 'tarde',
          evening: 'tarde',
          night: 'noche'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mn',
          noon: 'md',
          morning: 'de la mañana',
          afternoon: 'de la tarde',
          evening: 'de la tarde',
          night: 'de la noche'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'medianoche',
          noon: 'mediodia',
          morning: 'de la mañana',
          afternoon: 'de la tarde',
          evening: 'de la tarde',
          night: 'de la noche'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'medianoche',
          noon: 'mediodia',
          morning: 'de la mañana',
          afternoon: 'de la tarde',
          evening: 'de la tarde',
          night: 'de la noche'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + 'º';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 545 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ac|dc|a|d)/i,
        abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
        wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
      };
      var parseEraPatterns = {
        any: [/^ac/i, /^dc/i],
        wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](º)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[efmajsond]/i,
        abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
        wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmjvs]/i,
        short: /^(do|lu|ma|mi|ju|vi|sa)/i,
        abbreviated: /^(dom|lun|mar|mie|jue|vie|sab)/i,
        wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
        any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
        any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mn/i,
          noon: /^md/i,
          morning: /mañana/i,
          afternoon: /tarde/i,
          evening: /tarde/i,
          night: /noche/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 546 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(547);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(548);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(549);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(550);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(551);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Estonian locale.
       * @language Estonian
       * @iso-639-2 est
       * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
       */


      var locale = {
        code: 'et',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 547 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          standalone: {
            one: 'vähem kui üks sekund',
            other: 'vähem kui {{count}} sekundit'
          },
          withPreposition: {
            one: 'vähem kui ühe sekundi',
            other: 'vähem kui {{count}} sekundi'
          }
        },
        xSeconds: {
          standalone: {
            one: 'üks sekund',
            other: '{{count}} sekundit'
          },
          withPreposition: {
            one: 'ühe sekundi',
            other: '{{count}} sekundi'
          }
        },
        halfAMinute: {
          standalone: 'pool minutit',
          withPreposition: 'poole minuti'
        },
        lessThanXMinutes: {
          standalone: {
            one: 'vähem kui üks minut',
            other: 'vähem kui {{count}} minutit'
          },
          withPreposition: {
            one: 'vähem kui ühe minuti',
            other: 'vähem kui {{count}} minuti'
          }
        },
        xMinutes: {
          standalone: {
            one: 'üks minut',
            other: '{{count}} minutit'
          },
          withPreposition: {
            one: 'ühe minuti',
            other: '{{count}} minuti'
          }
        },
        aboutXHours: {
          standalone: {
            one: 'umbes üks tund',
            other: 'umbes {{count}} tundi'
          },
          withPreposition: {
            one: 'umbes ühe tunni',
            other: 'umbes {{count}} tunni'
          }
        },
        xHours: {
          standalone: {
            one: 'üks tund',
            other: '{{count}} tundi'
          },
          withPreposition: {
            one: 'ühe tunni',
            other: '{{count}} tunni'
          }
        },
        xDays: {
          standalone: {
            one: 'üks päev',
            other: '{{count}} päeva'
          },
          withPreposition: {
            one: 'ühe päeva',
            other: '{{count}} päeva'
          }
        },
        aboutXWeeks: {
          standalone: {
            one: 'umbes üks nädal',
            other: 'umbes {{count}} nädalat'
          },
          withPreposition: {
            one: 'umbes ühe nädala',
            other: 'umbes {{count}} nädala'
          }
        },
        xWeeks: {
          standalone: {
            one: 'üks nädal',
            other: '{{count}} nädalat'
          },
          withPreposition: {
            one: 'ühe nädala',
            other: '{{count}} nädala'
          }
        },
        aboutXMonths: {
          standalone: {
            one: 'umbes üks kuu',
            other: 'umbes {{count}} kuud'
          },
          withPreposition: {
            one: 'umbes ühe kuu',
            other: 'umbes {{count}} kuu'
          }
        },
        xMonths: {
          standalone: {
            one: 'üks kuu',
            other: '{{count}} kuud'
          },
          withPreposition: {
            one: 'ühe kuu',
            other: '{{count}} kuu'
          }
        },
        aboutXYears: {
          standalone: {
            one: 'umbes üks aasta',
            other: 'umbes {{count}} aastat'
          },
          withPreposition: {
            one: 'umbes ühe aasta',
            other: 'umbes {{count}} aasta'
          }
        },
        xYears: {
          standalone: {
            one: 'üks aasta',
            other: '{{count}} aastat'
          },
          withPreposition: {
            one: 'ühe aasta',
            other: '{{count}} aasta'
          }
        },
        overXYears: {
          standalone: {
            one: 'rohkem kui üks aasta',
            other: 'rohkem kui {{count}} aastat'
          },
          withPreposition: {
            one: 'rohkem kui ühe aasta',
            other: 'rohkem kui {{count}} aasta'
          }
        },
        almostXYears: {
          standalone: {
            one: 'peaaegu üks aasta',
            other: 'peaaegu {{count}} aastat'
          },
          withPreposition: {
            one: 'peaaegu ühe aasta',
            other: 'peaaegu {{count}} aasta'
          }
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
        var result;

        if (typeof usageGroup === 'string') {
          result = usageGroup;
        } else if (count === 1) {
          result = usageGroup.one;
        } else {
          result = usageGroup.other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + ' pärast';
          } else {
            return result + ' eest';
          }
        }

        return result;
      }
      /***/

    },
    /* 548 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'eeee, d. MMMM y',
        long: 'd. MMMM y',
        medium: 'd. MMM y',
        short: 'dd.MM.y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'kell' {{time}}",
        long: "{{date}} 'kell' {{time}}",
        medium: '{{date}}. {{time}}',
        short: '{{date}}. {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 549 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'eelmine' eeee 'kell' p",
        yesterday: "'eile kell' p",
        today: "'täna kell' p",
        tomorrow: "'homme kell' p",
        nextWeek: "'järgmine' eeee 'kell' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 550 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['e.m.a', 'm.a.j'],
        abbreviated: ['e.m.a', 'm.a.j'],
        wide: ['enne meie ajaarvamist', 'meie ajaarvamise järgi']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['K1', 'K2', 'K3', 'K4'],
        wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
      };
      var monthValues = {
        narrow: ['J', 'V', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['jaan', 'veebr', 'märts', 'apr', 'mai', 'juuni', 'juuli', 'aug', 'sept', 'okt', 'nov', 'dets'],
        wide: ['jaanuar', 'veebruar', 'märts', 'aprill', 'mai', 'juuni', 'juuli', 'august', 'september', 'oktoober', 'november', 'detsember']
      };
      var dayValues = {
        narrow: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
        short: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
        abbreviated: ['pühap.', 'esmasp.', 'teisip.', 'kolmap.', 'neljap.', 'reede.', 'laup.'],
        wide: ['pühapäev', 'esmaspäev', 'teisipäev', 'kolmapäev', 'neljapäev', 'reede', 'laupäev']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'kesköö',
          noon: 'keskpäev',
          morning: 'hommik',
          afternoon: 'pärastlõuna',
          evening: 'õhtu',
          night: 'öö'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'kesköö',
          noon: 'keskpäev',
          morning: 'hommik',
          afternoon: 'pärastlõuna',
          evening: 'õhtu',
          night: 'öö'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'kesköö',
          noon: 'keskpäev',
          morning: 'hommik',
          afternoon: 'pärastlõuna',
          evening: 'õhtu',
          night: 'öö'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'keskööl',
          noon: 'keskpäeval',
          morning: 'hommikul',
          afternoon: 'pärastlõunal',
          evening: 'õhtul',
          night: 'öösel'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'keskööl',
          noon: 'keskpäeval',
          morning: 'hommikul',
          afternoon: 'pärastlõunal',
          evening: 'õhtul',
          night: 'öösel'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'keskööl',
          noon: 'keskpäeval',
          morning: 'hommikul',
          afternoon: 'pärastlõunal',
          evening: 'õhtul',
          night: 'öösel'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          formattingValues: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          formattingValues: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          formattingValues: formattingDayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 551 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^\d+\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
        abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
        wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
      };
      var parseEraPatterns = {
        any: [/^e/i, /^(m|p)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K[1234]/i,
        wide: /^[1234](\.)? kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jvmasond]/i,
        abbreviated: /^('jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets')/i,
        wide: /^('jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember')/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[petknrl]/i,
        short: /^[petknrl]/i,
        abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
        wide: /^('pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev')/i
      };
      var parseDayPatterns = {
        any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|kesköö|keskpäev|hommik|pärastlõuna|õhtu|öö)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^keskö/i,
          noon: /^keskp/i,
          morning: /hommik/i,
          afternoon: /pärastlõuna/i,
          evening: /õhtu/i,
          night: /öö/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 552 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(553);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(554);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(555);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(556);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(557);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Basque locale.
       * @language Basque
       * @iso-639-2 eus
       * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
       */


      var locale = {
        code: 'eu',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 553 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'segundo bat baino gutxiago',
          other: '{{count}} segundo baino gutxiago'
        },
        xSeconds: {
          one: '1 segundo',
          other: '{{count}} segundo'
        },
        halfAMinute: 'minutu erdi',
        lessThanXMinutes: {
          one: 'minutu bat baino gutxiago',
          other: '{{count}} minutu baino gutxiago'
        },
        xMinutes: {
          one: '1 minutu',
          other: '{{count}} minutu'
        },
        aboutXHours: {
          one: '1 ordu gutxi gorabehera',
          other: '{{count}} ordu gutxi gorabehera'
        },
        xHours: {
          one: '1 ordu',
          other: '{{count}} ordu'
        },
        xDays: {
          one: '1 egun',
          other: '{{count}} egun'
        },
        aboutXWeeks: {
          one: 'aste 1 inguru',
          other: '{{count}} aste inguru'
        },
        xWeeks: {
          one: '1 aste',
          other: '{{count}} astean'
        },
        aboutXMonths: {
          one: '1 hilabete gutxi gorabehera',
          other: '{{count}} hilabete gutxi gorabehera'
        },
        xMonths: {
          one: '1 hilabete',
          other: '{{count}} hilabete'
        },
        aboutXYears: {
          one: '1 urte gutxi gorabehera',
          other: '{{count}} urte gutxi gorabehera'
        },
        xYears: {
          one: '1 urte',
          other: '{{count}} urte'
        },
        overXYears: {
          one: '1 urte baino gehiago',
          other: '{{count}} urte baino gehiago'
        },
        almostXYears: {
          one: 'ia 1 urte',
          other: 'ia {{count}} urte'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'en ' + result;
          } else {
            return 'duela ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 554 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, d 'de' MMMM y",
        long: "d 'de' MMMM y",
        medium: 'd MMM y',
        short: 'dd/MM/y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'tan' {{time}}",
        long: "{{date}} 'tan' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 555 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'joan den' eeee, LT",
        yesterday: "'atzo,' p",
        today: "'gaur,' p",
        tomorrow: "'bihar,' p",
        nextWeek: 'eeee, p',
        other: 'P'
      };
      var formatRelativeLocalePlural = {
        lastWeek: "'joan den' eeee, p",
        yesterday: "'atzo,' p",
        today: "'gaur,' p",
        tomorrow: "'bihar,' p",
        nextWeek: 'eeee, p',
        other: 'P'
      };

      function formatRelative(token, date, _baseDate, _options) {
        if (date.getUTCHours() !== 1) {
          return formatRelativeLocalePlural[token];
        }

        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 556 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['k.a.', 'k.o.'],
        abbreviated: ['k.a.', 'k.o.'],
        wide: ['kristo aurretik', 'kristo ondoren']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1H', '2H', '3H', '4H'],
        wide: ['1. hiruhilekoa', '2. hiruhilekoa', '3. hiruhilekoa', '4. hiruhilekoa']
      };
      var monthValues = {
        narrow: ['u', 'o', 'm', 'a', 'm', 'e', 'u', 'a', 'i', 'u', 'a', 'a'],
        abbreviated: ['urt', 'ots', 'mar', 'api', 'mai', 'eka', 'uzt', 'abu', 'ira', 'urr', 'aza', 'abe'],
        wide: ['urtarrila', 'otsaila', 'martxoa', 'apirila', 'maiatza', 'ekaina', 'uztaila', 'abuztua', 'iraila', 'urria', 'azaroa', 'abendua']
      };
      var dayValues = {
        narrow: ['i', 'a', 'a', 'a', 'o', 'o', 'l'],
        short: ['ig', 'al', 'as', 'az', 'og', 'or', 'lr'],
        abbreviated: ['iga', 'ast', 'ast', 'ast', 'ost', 'ost', 'lar'],
        wide: ['igandea', 'astelehena', 'asteartea', 'asteazkena', 'osteguna', 'ostirala', 'larunbata']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'ge',
          noon: 'eg',
          morning: 'goiza',
          afternoon: 'arratsaldea',
          evening: 'arratsaldea',
          night: 'gaua'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'gauerdia',
          noon: 'eguerdia',
          morning: 'goiza',
          afternoon: 'arratsaldea',
          evening: 'arratsaldea',
          night: 'gaua'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'gauerdia',
          noon: 'eguerdia',
          morning: 'goiza',
          afternoon: 'arratsaldea',
          evening: 'arratsaldea',
          night: 'gaua'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'ge',
          noon: 'eg',
          morning: 'goizean',
          afternoon: 'arratsaldean',
          evening: 'arratsaldean',
          night: 'gauean'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'gauerdia',
          noon: 'eguerdia',
          morning: 'goizean',
          afternoon: 'arratsaldean',
          evening: 'arratsaldean',
          night: 'gauean'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'gauerdia',
          noon: 'eguerdia',
          morning: 'goizean',
          afternoon: 'arratsaldean',
          evening: 'arratsaldean',
          night: 'gauean'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 557 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(k.a.|k.o.)/i,
        abbreviated: /^(k.a.|k.o.)/i,
        wide: /^(kristo aurretik|kristo ondoren)/i
      };
      var parseEraPatterns = {
        narrow: [/^k.a./i, /^k.o./i],
        abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
        wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]H/i,
        wide: /^[1234](.)? hiruhilekoa/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[uomaei]/i,
        abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
        wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
      };
      var parseMonthPatterns = {
        narrow: [/^u/i, /^o/i, /^m/i, /^a/i, /^m/i, /^e/i, /^u/i, /^a/i, /^i/i, /^u/i, /^a/i, /^a/i],
        any: [/^urt/i, /^ots/i, /^mar/i, /^api/i, /^mai/i, /^eka/i, /^uzt/i, /^abu/i, /^ira/i, /^urr/i, /^aza/i, /^abe/i]
      };
      var matchDayPatterns = {
        narrow: /^[iaol]/i,
        short: /^(ig|al|as|az|og|or|lr)/i,
        abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
        wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
      };
      var parseDayPatterns = {
        narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
        short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
        abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
        wide: [/^igandea/i, /^astelehena/i, /^asteartea/i, /^asteazkena/i, /^osteguna/i, /^ostirala/i, /^larunbata/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
        any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
      };
      var parseDayPeriodPatterns = {
        narrow: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^ge/i,
          noon: /^eg/i,
          morning: /goiz/i,
          afternoon: /arratsaldea/i,
          evening: /arratsaldea/i,
          night: /gau/i
        },
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^gauerdia/i,
          noon: /^eguerdia/i,
          morning: /goiz/i,
          afternoon: /arratsaldea/i,
          evening: /arratsaldea/i,
          night: /gau/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 558 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(559);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(560);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(561);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(562);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(563);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Persian/Farsi locale (Iran).
       * @language Persian
       * @iso-639-2 ira
       * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
       */


      var locale = {
        code: 'fa-IR',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 559 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'کمتر از یک ثانیه',
          other: 'کمتر از {{count}} ثانیه'
        },
        xSeconds: {
          one: '1 ثانیه',
          other: '{{count}} ثانیه'
        },
        halfAMinute: 'نیم دقیقه',
        lessThanXMinutes: {
          one: 'کمتر از یک دقیقه',
          other: 'کمتر از {{count}} دقیقه'
        },
        xMinutes: {
          one: '1 دقیقه',
          other: '{{count}} دقیقه'
        },
        aboutXHours: {
          one: 'حدود 1 ساعت',
          other: 'حدود {{count}} ساعت'
        },
        xHours: {
          one: '1 ساعت',
          other: '{{count}} ساعت'
        },
        xDays: {
          one: '1 روز',
          other: '{{count}} روز'
        },
        aboutXWeeks: {
          one: 'حدود 1 هفته',
          other: 'حدود {{count}} هفته'
        },
        xWeeks: {
          one: '1 هفته',
          other: '{{count}} هفته'
        },
        aboutXMonths: {
          one: 'حدود 1 ماه',
          other: 'حدود {{count}} ماه'
        },
        xMonths: {
          one: '1 ماه',
          other: '{{count}} ماه'
        },
        aboutXYears: {
          one: 'حدود 1 سال',
          other: 'حدود {{count}} سال'
        },
        xYears: {
          one: '1 سال',
          other: '{{count}} سال'
        },
        overXYears: {
          one: 'بیشتر از 1 سال',
          other: 'بیشتر از {{count}} سال'
        },
        almostXYears: {
          one: 'نزدیک 1 سال',
          other: 'نزدیک {{count}} سال'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'در ' + result;
          } else {
            return result + ' قبل';
          }
        }

        return result;
      }
      /***/

    },
    /* 560 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE do MMMM y',
        long: 'do MMMM y',
        medium: 'd MMM y',
        short: 'yyyy/MM/dd'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'در' {{time}}",
        long: "{{date}} 'در' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 561 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'گذشته در' p",
        yesterday: "'دیروز در' p",
        today: "'امروز در' p",
        tomorrow: "'فردا در' p",
        nextWeek: "eeee 'در' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 562 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['ق', 'ب'],
        abbreviated: ['ق.م.', 'ب.م.'],
        wide: ['قبل از میلاد', 'بعد از میلاد']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['س‌م1', 'س‌م2', 'س‌م3', 'س‌م4'],
        wide: ['سه‌ماهه 1', 'سه‌ماهه 2', 'سه‌ماهه 3', 'سه‌ماهه 4'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['ژ', 'ف', 'م', 'آ', 'م', 'ج', 'ج', 'آ', 'س', 'ا', 'ن', 'د'],
        abbreviated: ['ژانـ', 'فور', 'مارس', 'آپر', 'می', 'جون', 'جولـ', 'آگو', 'سپتـ', 'اکتـ', 'نوامـ', 'دسامـ'],
        wide: ['ژانویه', 'فوریه', 'مارس', 'آپریل', 'می', 'جون', 'جولای', 'آگوست', 'سپتامبر', 'اکتبر', 'نوامبر', 'دسامبر']
      };
      var dayValues = {
        narrow: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
        short: ['1ش', '2ش', '3ش', '4ش', '5ش', 'ج', 'ش'],
        abbreviated: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
        wide: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ق',
          pm: 'ب',
          midnight: 'ن',
          noon: 'ظ',
          morning: 'ص',
          afternoon: 'ب.ظ.',
          evening: 'ع',
          night: 'ش'
        },
        abbreviated: {
          am: 'ق.ظ.',
          pm: 'ب.ظ.',
          midnight: 'نیمه‌شب',
          noon: 'ظهر',
          morning: 'صبح',
          afternoon: 'بعدازظهر',
          evening: 'عصر',
          night: 'شب'
        },
        wide: {
          am: 'قبل‌ازظهر',
          pm: 'بعدازظهر',
          midnight: 'نیمه‌شب',
          noon: 'ظهر',
          morning: 'صبح',
          afternoon: 'بعدازظهر',
          evening: 'عصر',
          night: 'شب'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ق',
          pm: 'ب',
          midnight: 'ن',
          noon: 'ظ',
          morning: 'ص',
          afternoon: 'ب.ظ.',
          evening: 'ع',
          night: 'ش'
        },
        abbreviated: {
          am: 'ق.ظ.',
          pm: 'ب.ظ.',
          midnight: 'نیمه‌شب',
          noon: 'ظهر',
          morning: 'صبح',
          afternoon: 'بعدازظهر',
          evening: 'عصر',
          night: 'شب'
        },
        wide: {
          am: 'قبل‌ازظهر',
          pm: 'بعدازظهر',
          midnight: 'نیمه‌شب',
          noon: 'ظهر',
          morning: 'صبح',
          afternoon: 'بعدازظهر',
          evening: 'عصر',
          night: 'شب'
        }
      };

      function ordinalNumber(dirtyNumber) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 563 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ق|ب)/i,
        abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
        wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
      };
      var parseEraPatterns = {
        any: [/^قبل/i, /^بعد/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^س‌م[1234]/i,
        wide: /^سه‌ماهه [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[جژفمآاماسند]/i,
        abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
        wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
      };
      var parseMonthPatterns = {
        narrow: [/^(ژ|ج)/i, /^ف/i, /^م/i, /^(آ|ا)/i, /^م/i, /^(ژ|ج)/i, /^(ج|ژ)/i, /^(آ|ا)/i, /^س/i, /^ا/i, /^ن/i, /^د/i],
        any: [/^ژا/i, /^ف/i, /^ما/i, /^آپ/i, /^(می|مه)/i, /^(ژوئن|جون)/i, /^(ژوئی|جول)/i, /^(اوت|آگ)/i, /^س/i, /^(اوک|اک)/i, /^ن/i, /^د/i]
      };
      var matchDayPatterns = {
        narrow: /^[شیدسچپج]/i,
        short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
        abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
        wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
      };
      var parseDayPatterns = {
        narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
        any: [/^(ی|1ش|یکشنبه)/i, /^(د|2ش|دوشنبه)/i, /^(س|3ش|سه‌شنبه)/i, /^(چ|4ش|چهارشنبه)/i, /^(پ|5ش|پنجشنبه)/i, /^(ج|جمعه)/i, /^(ش|شنبه)/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
        abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
        wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
          pm: /^(ب|ب.ظ.|بعدازظهر)/i,
          midnight: /^(‌نیمه‌شب|ن)/i,
          noon: /^(ظ|ظهر)/i,
          morning: /(ص|صبح)/i,
          afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
          evening: /(ع|عصر)/i,
          night: /(ش|شب)/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 564 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(565);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(566);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(567);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(568);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(569);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Finnish locale.
       * @language Finnish
       * @iso-639-2 fin
       * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
       * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
       * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
       */


      var locale = {
        code: 'fi',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 565 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;

      function futureSeconds(text) {
        return text.replace(/sekuntia?/, 'sekunnin');
      }

      function futureMinutes(text) {
        return text.replace(/minuuttia?/, 'minuutin');
      }

      function futureHours(text) {
        return text.replace(/tuntia?/, 'tunnin');
      }

      function futureDays(text) {
        return text.replace(/päivää?/, 'päivän');
      }

      function futureWeeks(text) {
        return text.replace(/(viikko|viikkoa)/, 'viikon');
      }

      function futureMonths(text) {
        return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
      }

      function futureYears(text) {
        return text.replace(/(vuosi|vuotta)/, 'vuoden');
      }

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'alle sekunti',
          other: 'alle {{count}} sekuntia',
          futureTense: futureSeconds
        },
        xSeconds: {
          one: 'sekunti',
          other: '{{count}} sekuntia',
          futureTense: futureSeconds
        },
        halfAMinute: {
          one: 'puoli minuuttia',
          other: 'puoli minuuttia',
          futureTense: function futureTense(_text) {
            return 'puolen minuutin';
          }
        },
        lessThanXMinutes: {
          one: 'alle minuutti',
          other: 'alle {{count}} minuuttia',
          futureTense: futureMinutes
        },
        xMinutes: {
          one: 'minuutti',
          other: '{{count}} minuuttia',
          futureTense: futureMinutes
        },
        aboutXHours: {
          one: 'noin tunti',
          other: 'noin {{count}} tuntia',
          futureTense: futureHours
        },
        xHours: {
          one: 'tunti',
          other: '{{count}} tuntia',
          futureTense: futureHours
        },
        xDays: {
          one: 'päivä',
          other: '{{count}} päivää',
          futureTense: futureDays
        },
        aboutXWeeks: {
          one: 'noin viikko',
          other: 'noin {{count}} viikkoa',
          futureTense: futureWeeks
        },
        xWeeks: {
          one: 'viikko',
          other: '{{count}} viikkoa',
          futureTense: futureWeeks
        },
        aboutXMonths: {
          one: 'noin kuukausi',
          other: 'noin {{count}} kuukautta',
          futureTense: futureMonths
        },
        xMonths: {
          one: 'kuukausi',
          other: '{{count}} kuukautta',
          futureTense: futureMonths
        },
        aboutXYears: {
          one: 'noin vuosi',
          other: 'noin {{count}} vuotta',
          futureTense: futureYears
        },
        xYears: {
          one: 'vuosi',
          other: '{{count}} vuotta',
          futureTense: futureYears
        },
        overXYears: {
          one: 'yli vuosi',
          other: 'yli {{count}} vuotta',
          futureTense: futureYears
        },
        almostXYears: {
          one: 'lähes vuosi',
          other: 'lähes {{count}} vuotta',
          futureTense: futureYears
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var distance = formatDistanceLocale[token];
        var result = count === 1 ? distance.one : distance.other.replace('{{count}}', count);

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return distance.futureTense(result) + ' kuluttua';
          } else {
            return result + ' sitten';
          }
        }

        return result;
      }
      /***/

    },
    /* 566 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'eeee d. MMMM y',
        long: 'd. MMMM y',
        medium: 'd. MMM y',
        short: 'd.M.y'
      };
      var timeFormats = {
        full: 'HH.mm.ss zzzz',
        long: 'HH.mm.ss z',
        medium: 'HH.mm.ss',
        short: 'HH.mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'klo' {{time}}",
        long: "{{date}} 'klo' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 567 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'viime' eeee 'klo' p",
        yesterday: "'eilen klo' p",
        today: "'tänään klo' p",
        tomorrow: "'huomenna klo' p",
        nextWeek: "'ensi' eeee 'klo' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 568 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['eaa.', 'jaa.'],
        abbreviated: ['eaa.', 'jaa.'],
        wide: ['ennen ajanlaskun alkua', 'jälkeen ajanlaskun alun']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1. kvartaali', '2. kvartaali', '3. kvartaali', '4. kvartaali']
      };
      var monthValues = {
        narrow: ['T', 'H', 'M', 'H', 'T', 'K', 'H', 'E', 'S', 'L', 'M', 'J'],
        abbreviated: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
        wide: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu']
      };
      var formattingMonthValues = {
        narrow: monthValues.narrow,
        abbreviated: monthValues.abbreviated,
        wide: monthValues.wide.map(function (name) {
          return name + 'ta';
        })
      };
      var dayValues = {
        narrow: ['S', 'M', 'T', 'K', 'T', 'P', 'L'],
        short: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
        abbreviated: ['sunn.', 'maan.', 'tiis.', 'kesk.', 'torst.', 'perj.', 'la'],
        wide: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai']
      };
      var formattingDayValues = {
        narrow: dayValues.narrow,
        short: dayValues.short,
        abbreviated: dayValues.abbreviated,
        wide: dayValues.wide.map(function (name) {
          return name + 'na';
        })
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ap',
          pm: 'ip',
          midnight: 'keskiyö',
          noon: 'keskipäivä',
          morning: 'ap',
          afternoon: 'ip',
          evening: 'illalla',
          night: 'yöllä'
        },
        abbreviated: {
          am: 'ap',
          pm: 'ip',
          midnight: 'keskiyö',
          noon: 'keskipäivä',
          morning: 'ap',
          afternoon: 'ip',
          evening: 'illalla',
          night: 'yöllä'
        },
        wide: {
          am: 'ap',
          pm: 'ip',
          midnight: 'keskiyöllä',
          noon: 'keskipäivällä',
          morning: 'aamupäivällä',
          afternoon: 'iltapäivällä',
          evening: 'illalla',
          night: 'yöllä'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          formattingValues: formattingMonthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          formattingValues: formattingDayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 569 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(\.)/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(e|j)/i,
        abbreviated: /^(eaa.|jaa.)/i,
        wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
      };
      var parseEraPatterns = {
        any: [/^e/i, /^j/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234]\.? kvartaali/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[thmkeslj]/i,
        abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
        wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
      };
      var parseMonthPatterns = {
        narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
        any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtkpl]/i,
        short: /^(su|ma|ti|ke|to|pe|la)/i,
        abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
        wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
        any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
        any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ap/i,
          pm: /^ip/i,
          midnight: /^keskiyö/i,
          noon: /^keskipäivä/i,
          morning: /aamupäivällä/i,
          afternoon: /iltapäivällä/i,
          evening: /illalla/i,
          night: /yöllä/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 570 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(187);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(571);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(188);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(189);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(190);
      /**
       * @type {Locale}
       * @category Locales
       * @summary French locale.
       * @language French
       * @iso-639-2 fra
       * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
       * @author François B [@fbonzon]{@link https://github.com/fbonzon}
       */


      var locale = {
        code: 'fr',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 571 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE d MMMM y',
        long: 'd MMMM y',
        medium: 'd MMM y',
        short: 'dd/MM/y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'à' {{time}}",
        long: "{{date}} 'à' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 572 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__fr_lib_formatDistance_index_js__ = __webpack_require__(187);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__fr_lib_formatRelative_index_js__ = __webpack_require__(188);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__fr_lib_localize_index_js__ = __webpack_require__(189);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__fr_lib_match_index_js__ = __webpack_require__(190);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_formatLong_index_js__ = __webpack_require__(573); // Same as fr
      // Unique for fr-CA

      /**
       * @type {Locale}
       * @category Locales
       * @summary French locale (Canada).
       * @language French
       * @iso-639-2 fra
       * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
       * @author François B [@fbonzon]{@link https://github.com/fbonzon}
       * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
       */


      var locale = {
        code: 'fr-CA',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__fr_lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_4__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_1__fr_lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_2__fr_lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_3__fr_lib_match_index_js__["a"
        /* default */
        ],
        // Unique for fr-CA
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 573 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE d MMMM y',
        long: 'd MMMM y',
        medium: 'd MMM y',
        short: 'yy-MM-dd'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'à' {{time}}",
        long: "{{date}} 'à' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 574 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(575);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(576);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(577);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(578);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(579);
      /**
       * @type {Locale}
       * @category Locales
       * @summary French locale.
       * @language French
       * @iso-639-2 fra
       * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
       * @author François B [@fbonzon]{@link https://github.com/fbonzon}
       * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
       * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
       */


      var locale = {
        code: 'fr-CH',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 575 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'moins d’une seconde',
          other: 'moins de {{count}} secondes'
        },
        xSeconds: {
          one: '1 seconde',
          other: '{{count}} secondes'
        },
        halfAMinute: '30 secondes',
        lessThanXMinutes: {
          one: 'moins d’une minute',
          other: 'moins de {{count}} minutes'
        },
        xMinutes: {
          one: '1 minute',
          other: '{{count}} minutes'
        },
        aboutXHours: {
          one: 'environ 1 heure',
          other: 'environ {{count}} heures'
        },
        xHours: {
          one: '1 heure',
          other: '{{count}} heures'
        },
        xDays: {
          one: '1 jour',
          other: '{{count}} jours'
        },
        aboutXWeeks: {
          one: 'environ 1 semaine',
          other: 'environ {{count}} semaines'
        },
        xWeeks: {
          one: '1 semaine',
          other: '{{count}} semaines'
        },
        aboutXMonths: {
          one: 'environ 1 mois',
          other: 'environ {{count}} mois'
        },
        xMonths: {
          one: '1 mois',
          other: '{{count}} mois'
        },
        aboutXYears: {
          one: 'environ 1 an',
          other: 'environ {{count}} ans'
        },
        xYears: {
          one: '1 an',
          other: '{{count}} ans'
        },
        overXYears: {
          one: 'plus d’un an',
          other: 'plus de {{count}} ans'
        },
        almostXYears: {
          one: 'presqu’un an',
          other: 'presque {{count}} ans'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'dans ' + result;
          } else {
            return 'il y a ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 576 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE d MMMM y',
        long: 'd MMMM y',
        medium: 'd MMM y',
        short: 'dd.MM.y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'à' {{time}}",
        long: "{{date}} 'à' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 577 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'la semaine dernière à' p",
        yesterday: "'hier à' p",
        today: "'aujourd’hui à' p",
        tomorrow: "'demain à' p'",
        nextWeek: "eeee 'la semaine prochaine à' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 578 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['av. J.-C', 'ap. J.-C'],
        abbreviated: ['av. J.-C', 'ap. J.-C'],
        wide: ['avant Jésus-Christ', 'après Jésus-Christ']
      };
      var quarterValues = {
        narrow: ['T1', 'T2', 'T3', 'T4'],
        abbreviated: ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'],
        wide: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
        wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
      };
      var dayValues = {
        narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
        abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
        wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'minuit',
          noon: 'midi',
          morning: 'mat.',
          afternoon: 'ap.m.',
          evening: 'soir',
          night: 'mat.'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'minuit',
          noon: 'midi',
          morning: 'matin',
          afternoon: 'après-midi',
          evening: 'soir',
          night: 'matin'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'minuit',
          noon: 'midi',
          morning: 'du matin',
          afternoon: 'de l’après-midi',
          evening: 'du soir',
          night: 'du matin'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (number === 0) {
          return number;
        }

        if (unit === 'year' || unit === 'hour' || unit === 'week') {
          if (number === 1) {
            suffix = 'ère';
          } else {
            suffix = 'ème';
          }
        } else {
          if (number === 1) {
            suffix = 'er';
          } else {
            suffix = 'ème';
          }
        }

        return number + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 579 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
        abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
        wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
      };
      var parseEraPatterns = {
        any: [/^av/i, /^ap/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^t[1234]/i,
        wide: /^[1234](er|ème|e)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
        wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[lmjvsd]/i,
        short: /^(di|lu|ma|me|je|ve|sa)/i,
        abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
        wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
        any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
        any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^min/i,
          noon: /^mid/i,
          morning: /mat/i,
          afternoon: /ap/i,
          evening: /soir/i,
          night: /nuit/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 580 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(581);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(582);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(583);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(584);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(585);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Scottish Gaelic.
       * @language Scottish Gaelic
       * @iso-639-2 gla
       * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
       */


      var locale = {
        code: 'gd',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 581 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'nas lugha na diog',
          other: 'nas lugha na {{count}} diogan'
        },
        xSeconds: {
          one: '1 diog',
          two: '2 dhiog',
          twenty: '20 diog',
          other: '{{count}} diogan'
        },
        halfAMinute: 'leth mhionaid',
        lessThanXMinutes: {
          one: 'nas lugha na mionaid',
          other: 'nas lugha na {{count}} mionaidean'
        },
        xMinutes: {
          one: '1 mionaid',
          two: '2 mhionaid',
          twenty: '20 mionaid',
          other: '{{count}} mionaidean'
        },
        aboutXHours: {
          one: 'mu uair de thìde',
          other: 'mu {{count}} uairean de thìde'
        },
        xHours: {
          one: '1 uair de thìde',
          two: '2 uair de thìde',
          twenty: '20 uair de thìde',
          other: '{{count}} uairean de thìde'
        },
        xDays: {
          one: '1 là',
          other: '{{count}} là'
        },
        aboutXWeeks: {
          one: 'mu 1 seachdain',
          other: 'mu {{count}} seachdainean'
        },
        xWeeks: {
          one: '1 seachdain',
          other: '{{count}} seachdainean'
        },
        aboutXMonths: {
          one: 'mu mhìos',
          other: 'mu {{count}} mìosan'
        },
        xMonths: {
          one: '1 mìos',
          other: '{{count}} mìosan'
        },
        aboutXYears: {
          one: 'mu bhliadhna',
          other: 'mu {{count}} bliadhnaichean'
        },
        xYears: {
          one: '1 bhliadhna',
          other: '{{count}} bliadhna'
        },
        overXYears: {
          one: 'còrr is bliadhna',
          other: 'còrr is {{count}} bliadhnaichean'
        },
        almostXYears: {
          one: 'cha mhòr bliadhna',
          other: 'cha mhòr {{count}} bliadhnaichean'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2 && !!formatDistanceLocale[token].two) {
          result = formatDistanceLocale[token].two;
        } else if (count === 9 && !!formatDistanceLocale[token].nine) {
          result = formatDistanceLocale[token].nine;
        } else if (count === 20 && !!formatDistanceLocale[token].twenty) {
          result = formatDistanceLocale[token].twenty;
        } else if (count === 30 && !!formatDistanceLocale[token].thirty) {
          result = formatDistanceLocale[token].thirty;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'ann an ' + result;
          } else {
            return 'o chionn ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 582 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'aig' {{time}}",
        long: "{{date}} 'aig' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 583 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'mu dheireadh' eeee 'aig' p",
        //FIX
        yesterday: "'an-dè aig' p",
        today: "'an-diugh aig' p",
        tomorrow: "'a-màireach aig' p",
        nextWeek: "eeee 'aig' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 584 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['R', 'A'],
        abbreviated: ['RC', 'AD'],
        wide: ['ro Chrìosta', 'anno domini']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['C1', 'C2', 'C3', 'C4'],
        wide: ["a' chiad chairteal", 'an dàrna cairteal', 'an treas cairteal', 'an ceathramh cairteal'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['F', 'G', 'M', 'G', 'C', 'Ò', 'I', 'L', 'S', 'D', 'S', 'D'],
        abbreviated: ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'],
        wide: ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd']
      };
      var dayValues = {
        narrow: ['D', 'L', 'M', 'C', 'A', 'H', 'S'],
        short: ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'],
        abbreviated: ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        wide: ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'm',
          pm: 'f',
          midnight: 'm.o.',
          noon: 'm.l.',
          morning: 'madainn',
          afternoon: 'feasgar',
          evening: 'feasgar',
          night: 'oidhche'
        },
        abbreviated: {
          am: 'M.',
          pm: 'F.',
          midnight: 'meadhan oidhche',
          noon: 'meadhan là',
          morning: 'madainn',
          afternoon: 'feasgar',
          evening: 'feasgar',
          night: 'oidhche'
        },
        wide: {
          am: 'm.',
          pm: 'f.',
          midnight: 'meadhan oidhche',
          noon: 'meadhan là',
          morning: 'madainn',
          afternoon: 'feasgar',
          evening: 'feasgar',
          night: 'oidhche'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'm',
          pm: 'f',
          midnight: 'm.o.',
          noon: 'm.l.',
          morning: 'sa mhadainn',
          afternoon: 'feasgar',
          evening: 'feasgar',
          night: 'air an oidhche'
        },
        abbreviated: {
          am: 'M.',
          pm: 'F.',
          midnight: 'meadhan oidhche',
          noon: 'meadhan là',
          morning: 'sa mhadainn',
          afternoon: 'feasgar',
          evening: 'feasgar',
          night: 'air an oidhche'
        },
        wide: {
          am: 'm.',
          pm: 'f.',
          midnight: 'meadhan oidhche',
          noon: 'meadhan là',
          morning: 'sa mhadainn',
          afternoon: 'feasgar',
          evening: 'feasgar',
          night: 'air an oidhche'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return number + 'd';

            case 2:
              return number + 'na';
          }
        }

        if (rem100 === 12) {
          return number + 'na';
        }

        return number + 'mh';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 585 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(r|a)/i,
        abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
        wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(a|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^c[1234]/i,
        wide: /^[1234](cd|na|tr|mh)? cairteal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[fgmcòilsd]/i,
        abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
        wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
      };
      var parseMonthPatterns = {
        narrow: [/^f/i, /^g/i, /^m/i, /^g/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^s/i, /^d/i, /^s/i, /^d/i],
        any: [/^fa/i, /^ge/i, /^mà/i, /^gi/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^su/i, /^d/i, /^sa/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmcahs]/i,
        short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
        abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
        wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
        any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
        any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^m/i,
          pm: /^f/i,
          midnight: /^meadhan oidhche/i,
          noon: /^meadhan là/i,
          morning: /sa mhadainn/i,
          afternoon: /feasgar/i,
          evening: /feasgar/i,
          night: /air an oidhche/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 586 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(587);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(588);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(589);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(590);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(591);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Galician locale.
       * @language Galician
       * @iso-639-2 glg
       * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
       * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
       */


      var locale = {
        code: 'gl',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 587 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'menos dun segundo',
          other: 'menos de {{count}} segundos'
        },
        xSeconds: {
          one: '1 segundo',
          other: '{{count}} segundos'
        },
        halfAMinute: 'medio minuto',
        lessThanXMinutes: {
          one: 'menos dun minuto',
          other: 'menos de {{count}} minutos'
        },
        xMinutes: {
          one: '1 minuto',
          other: '{{count}} minutos'
        },
        aboutXHours: {
          one: 'arredor dunha hora',
          other: 'arredor de {{count}} horas'
        },
        xHours: {
          one: '1 hora',
          other: '{{count}} horas'
        },
        xDays: {
          one: '1 día',
          other: '{{count}} días'
        },
        aboutXWeeks: {
          one: 'arredor dunha semana',
          other: 'arredor de {{count}} semanas'
        },
        xWeeks: {
          one: '1 semana',
          other: '{{count}} semanas'
        },
        aboutXMonths: {
          one: 'arredor de 1 mes',
          other: 'arredor de {{count}} meses'
        },
        xMonths: {
          one: '1 mes',
          other: '{{count}} meses'
        },
        aboutXYears: {
          one: 'arredor dun ano',
          other: 'arredor de {{count}} anos'
        },
        xYears: {
          one: '1 ano',
          other: '{{count}} anos'
        },
        overXYears: {
          one: 'máis dun ano',
          other: 'máis de {{count}} anos'
        },
        almostXYears: {
          one: 'case un ano',
          other: 'case {{count}} anos'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'en ' + result;
          } else {
            return 'hai ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 588 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, d 'de' MMMM y",
        long: "d 'de' MMMM y",
        medium: 'd MMM y',
        short: 'dd/MM/y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'ás' {{time}}",
        long: "{{date}} 'ás' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 589 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'o' eeee 'pasado á' LT",
        yesterday: "'onte á' p",
        today: "'hoxe á' p",
        tomorrow: "'mañá á' p",
        nextWeek: "eeee 'á' p",
        other: 'P'
      };
      var formatRelativeLocalePlural = {
        lastWeek: "'o' eeee 'pasado ás' p",
        yesterday: "'onte ás' p",
        today: "'hoxe ás' p",
        tomorrow: "'mañá ás' p",
        nextWeek: "eeee 'ás' p",
        other: 'P'
      };

      function formatRelative(token, date, _baseDate, _options) {
        if (date.getUTCHours() !== 1) {
          return formatRelativeLocalePlural[token];
        }

        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 590 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['AC', 'DC'],
        abbreviated: ['AC', 'DC'],
        wide: ['antes de cristo', 'despois de cristo']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['T1', 'T2', 'T3', 'T4'],
        wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
      };
      var monthValues = {
        narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
        abbreviated: ['xan', 'feb', 'mar', 'abr', 'mai', 'xun', 'xul', 'ago', 'set', 'out', 'nov', 'dec'],
        wide: ['xaneiro', 'febreiro', 'marzo', 'abril', 'maio', 'xuño', 'xullo', 'agosto', 'setembro', 'outubro', 'novembro', 'decembro']
      };
      var dayValues = {
        narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
        short: ['do', 'lu', 'ma', 'me', 'xo', 've', 'sa'],
        abbreviated: ['dom', 'lun', 'mar', 'mer', 'xov', 'ven', 'sab'],
        wide: ['domingo', 'luns', 'martes', 'mércores', 'xoves', 'venres', 'sábado']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mn',
          noon: 'md',
          morning: 'mañá',
          afternoon: 'tarde',
          evening: 'tarde',
          night: 'noite'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'medianoite',
          noon: 'mediodía',
          morning: 'mañá',
          afternoon: 'tarde',
          evening: 'tardiña',
          night: 'noite'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'medianoite',
          noon: 'mediodía',
          morning: 'mañá',
          afternoon: 'tarde',
          evening: 'tardiña',
          night: 'noite'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mn',
          noon: 'md',
          morning: 'da mañá',
          afternoon: 'da tarde',
          evening: 'da tardiña',
          night: 'da noite'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'medianoite',
          noon: 'mediodía',
          morning: 'da mañá',
          afternoon: 'da tarde',
          evening: 'da tardiña',
          night: 'da noite'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'medianoite',
          noon: 'mediodía',
          morning: 'da mañá',
          afternoon: 'da tarde',
          evening: 'da tardiña',
          night: 'da noite'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + 'º';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 591 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ac|dc|a|d)/i,
        abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
        wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
      };
      var parseEraPatterns = {
        any: [/^ac/i, /^dc/i],
        wide: [/^(antes de cristo|antes da era com[uú]n)/i, /^(despois de cristo|era com[uú]n)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](º)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[xfmasond]/i,
        abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
        wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
      };
      var parseMonthPatterns = {
        narrow: [/^x/i, /^f/i, /^m/i, /^a/i, /^m/i, /^x/i, /^x/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^xan/i, /^feb/i, /^mar/i, /^abr/i, /^mai/i, /^xun/i, /^xul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dec/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmxvs]/i,
        short: /^(do|lu|ma|me|xo|ve|sa)/i,
        abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
        wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
        any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
        any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mn/i,
          noon: /^md/i,
          morning: /mañ[aá]/i,
          afternoon: /tarde/i,
          evening: /tardiña/i,
          night: /noite/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 592 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(593);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(594);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(595);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(596);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(597);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Gujarati locale (India).
       * @language Gujarati
       * @iso-639-2 guj
       * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
       */


      var locale = {
        code: 'gu',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 593 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance; // Source: https://www.unicode.org/cldr/charts/32/summary/gu.html

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'હમણાં',
          // CLDR #1461
          other: '​આશરે {{count}} સેકંડ'
        },
        xSeconds: {
          one: '1 સેકંડ',
          other: '{{count}} સેકંડ'
        },
        halfAMinute: 'અડધી મિનિટ',
        lessThanXMinutes: {
          one: 'આ મિનિટ',
          // CLDR #1448
          other: '​આશરે {{count}} મિનિટ'
        },
        xMinutes: {
          one: '1 મિનિટ',
          other: '{{count}} મિનિટ'
        },
        aboutXHours: {
          one: '​આશરે 1 કલાક',
          other: '​આશરે {{count}} કલાક'
        },
        xHours: {
          one: '1 કલાક',
          other: '{{count}} કલાક'
        },
        xDays: {
          one: '1 દિવસ',
          other: '{{count}} દિવસ'
        },
        aboutXWeeks: {
          one: 'આશરે 1 અઠવાડિયું',
          other: 'આશરે {{count}} અઠવાડિયા'
        },
        xWeeks: {
          one: '1 અઠવાડિયું',
          other: '{{count}} અઠવાડિયા'
        },
        aboutXMonths: {
          one: 'આશરે 1 મહિનો',
          other: 'આશરે {{count}} મહિના'
        },
        xMonths: {
          one: '1 મહિનો',
          other: '{{count}} મહિના'
        },
        aboutXYears: {
          one: 'આશરે 1 વર્ષ',
          other: 'આશરે {{count}} વર્ષ'
        },
        xYears: {
          one: '1 વર્ષ',
          other: '{{count}} વર્ષ'
        },
        overXYears: {
          one: '1 વર્ષથી વધુ',
          other: '{{count}} વર્ષથી વધુ'
        },
        almostXYears: {
          one: 'લગભગ 1 વર્ષ',
          other: 'લગભગ {{count}} વર્ષ'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + 'માં';
          } else {
            return result + ' પહેલાં';
          }
        }

        return result;
      }
      /***/

    },
    /* 594 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2); //Source: https://www.unicode.org/cldr/charts/32/summary/gu.html


      var dateFormats = {
        full: 'EEEE, d MMMM, y',
        // CLDR #1825
        long: 'd MMMM, y',
        // CLDR #1826
        medium: 'd MMM, y',
        // CLDR #1827
        short: 'd/M/yy' // CLDR #1828

      };
      var timeFormats = {
        full: 'hh:mm:ss a zzzz',
        // CLDR #1829
        long: 'hh:mm:ss a z',
        // CLDR #1830
        medium: 'hh:mm:ss a',
        // CLDR #1831
        short: 'hh:mm a' // CLDR #1832

      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        // CLDR #1833
        long: '{{date}} {{time}}',
        // CLDR #1834
        medium: '{{date}} {{time}}',
        // CLDR #1835
        short: '{{date}} {{time}}' // CLDR #1836

      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 595 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative; // Source: https://www.unicode.org/cldr/charts/32/summary/gu.html

      var formatRelativeLocale = {
        lastWeek: "'પાછલા' eeee p",
        // CLDR #1384
        yesterday: "'ગઈકાલે' p",
        // CLDR #1409
        today: "'આજે' p",
        // CLDR #1410
        tomorrow: "'આવતીકાલે' p",
        // CLDR #1411
        nextWeek: 'eeee p',
        // CLDR #1386
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 596 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3); // https://www.unicode.org/cldr/charts/32/summary/gu.html
      // #1621 - #1630


      var eraValues = {
        narrow: ['ઈસપૂ', 'ઈસ'],
        abbreviated: ['ઈ.સ.પૂર્વે', 'ઈ.સ.'],
        wide: ['ઈસવીસન પૂર્વે', 'ઈસવીસન'] // https://www.unicode.org/cldr/charts/32/summary/gu.html
        // #1631 - #1654

      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1લો ત્રિમાસ', '2જો ત્રિમાસ', '3જો ત્રિમાસ', '4થો ત્રિમાસ'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.
        // https://www.unicode.org/cldr/charts/32/summary/gu.html
        // #1655 - #1726

      };
      var monthValues = {
        narrow: ['જા', 'ફે', 'મા', 'એ', 'મે', 'જૂ', 'જુ', 'ઓ', 'સ', 'ઓ', 'ન', 'ડિ'],
        abbreviated: ['જાન્યુ', 'ફેબ્રુ', 'માર્ચ', 'એપ્રિલ', 'મે', 'જૂન', 'જુલાઈ', 'ઑગસ્ટ', 'સપ્ટે', 'ઓક્ટો', 'નવે', 'ડિસે'],
        wide: ['જાન્યુઆરી', 'ફેબ્રુઆરી', 'માર્ચ', 'એપ્રિલ', 'મે', 'જૂન', 'જુલાઇ', 'ઓગસ્ટ', 'સપ્ટેમ્બર', 'ઓક્ટોબર', 'નવેમ્બર', 'ડિસેમ્બર'] // https://www.unicode.org/cldr/charts/32/summary/gu.html
        // #1727 - #1768

      };
      var dayValues = {
        narrow: ['ર', 'સો', 'મં', 'બુ', 'ગુ', 'શુ', 'શ'],
        short: ['ર', 'સો', 'મં', 'બુ', 'ગુ', 'શુ', 'શ'],
        abbreviated: ['રવિ', 'સોમ', 'મંગળ', 'બુધ', 'ગુરુ', 'શુક્ર', 'શનિ'],
        wide: ['રવિવાર'
        /* Sunday */
        , 'સોમવાર'
        /* Monday */
        , 'મંગળવાર'
        /* Tuesday */
        , 'બુધવાર'
        /* Wednesday */
        , 'ગુરુવાર'
        /* Thursday */
        , 'શુક્રવાર'
        /* Friday */
        , 'શનિવાર'
        /* Saturday */
        ] // https://www.unicode.org/cldr/charts/32/summary/gu.html
        // #1783 - #1824

      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'મ.રાત્રિ',
          noon: 'બ.',
          morning: 'સવારે',
          afternoon: 'બપોરે',
          evening: 'સાંજે',
          night: 'રાત્રે'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: '​મધ્યરાત્રિ',
          noon: 'બપોરે',
          morning: 'સવારે',
          afternoon: 'બપોરે',
          evening: 'સાંજે',
          night: 'રાત્રે'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: '​મધ્યરાત્રિ',
          noon: 'બપોરે',
          morning: 'સવારે',
          afternoon: 'બપોરે',
          evening: 'સાંજે',
          night: 'રાત્રે'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'મ.રાત્રિ',
          noon: 'બપોરે',
          morning: 'સવારે',
          afternoon: 'બપોરે',
          evening: 'સાંજે',
          night: 'રાત્રે'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'મધ્યરાત્રિ',
          noon: 'બપોરે',
          morning: 'સવારે',
          afternoon: 'બપોરે',
          evening: 'સાંજે',
          night: 'રાત્રે'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: '​મધ્યરાત્રિ',
          noon: 'બપોરે',
          morning: 'સવારે',
          afternoon: 'બપોરે',
          evening: 'સાંજે',
          night: 'રાત્રે'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 597 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ઈસપૂ|ઈસ)/i,
        abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
        wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
      };
      var parseEraPatterns = {
        any: [/^(ઈસપૂ|ઈસ)/i, /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i, /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
        abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
        wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
      };
      var parseMonthPatterns = {
        narrow: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i],
        any: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i]
      };
      var matchDayPatterns = {
        narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
        short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
        abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
        wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
      };
      var parseDayPatterns = {
        narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
        any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
        any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^મ\.?/i,
          noon: /^બ/i,
          morning: /સ/i,
          afternoon: /બ/i,
          evening: /સાં/i,
          night: /રા/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 598 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(599);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(600);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(601);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(602);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(603);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Hebrew locale.
       * @language Hebrew
       * @iso-639-2 heb
       * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
       */


      var locale = {
        code: 'he',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 599 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'פחות משנייה',
          two: 'פחות משתי שניות',
          other: 'פחות מ־{{count}} שניות'
        },
        xSeconds: {
          one: 'שנייה',
          two: 'שתי שניות',
          other: '{{count}} שניות'
        },
        halfAMinute: 'חצי דקה',
        lessThanXMinutes: {
          one: 'פחות מדקה',
          two: 'פחות משתי דקות',
          other: 'פחות מ־{{count}} דקות'
        },
        xMinutes: {
          one: 'דקה',
          two: 'שתי דקות',
          other: '{{count}} דקות'
        },
        aboutXHours: {
          one: 'כשעה',
          two: 'כשעתיים',
          other: 'כ־{{count}} שעות'
        },
        xHours: {
          one: 'שעה',
          two: 'שעתיים',
          other: '{{count}} שעות'
        },
        xDays: {
          one: 'יום',
          two: 'יומיים',
          other: '{{count}} ימים'
        },
        aboutXWeeks: {
          one: 'כשבוע',
          two: 'כשבועיים',
          other: 'כ־{{count}} שבועות'
        },
        xWeeks: {
          one: 'שבוע',
          two: 'שבועיים',
          other: '{{count}} שבועות'
        },
        aboutXMonths: {
          one: 'כחודש',
          two: 'כחודשיים',
          other: 'כ־{{count}} חודשים'
        },
        xMonths: {
          one: 'חודש',
          two: 'חודשיים',
          other: '{{count}} חודשים'
        },
        aboutXYears: {
          one: 'כשנה',
          two: 'כשנתיים',
          other: 'כ־{{count}} שנים'
        },
        xYears: {
          one: 'שנה',
          two: 'שנתיים',
          other: '{{count}} שנים'
        },
        overXYears: {
          one: 'יותר משנה',
          two: 'יותר משנתיים',
          other: 'יותר מ־{{count}} שנים'
        },
        almostXYears: {
          one: 'כמעט שנה',
          two: 'כמעט שנתיים',
          other: 'כמעט {{count}} שנים'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {}; // Return word instead of `in one day` or `one day ago`

        if (token === 'xDays' && options.addSuffix && count <= 2) {
          var past = {
            1: 'אתמול',
            2: 'שלשום'
          };
          var future = {
            1: 'מחר',
            2: 'מחרתיים'
          };
          return options.comparison > 0 ? future[count] : past[count];
        }

        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2) {
          result = formatDistanceLocale[token].two;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'בעוד ' + result;
          } else {
            return 'לפני ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 600 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d בMMMM y',
        long: 'd בMMMM y',
        medium: 'd בMMM y',
        short: 'd.M.y'
      };
      var timeFormats = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'בשעה' {{time}}",
        long: "{{date}} 'בשעה' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 601 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'שעבר בשעה' p",
        yesterday: "'אתמול בשעה' p",
        today: "'היום בשעה' p",
        tomorrow: "'מחר בשעה' p",
        nextWeek: "eeee 'בשעה' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 602 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['לפנה״ס', 'לספירה'],
        abbreviated: ['לפנה״ס', 'לספירה'],
        wide: ['לפני הספירה', 'לספירה']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['רבעון 1', 'רבעון 2', 'רבעון 3', 'רבעון 4']
      };
      var monthValues = {
        narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        abbreviated: ['ינו׳', 'פבר׳', 'מרץ', 'אפר׳', 'מאי', 'יוני', 'יולי', 'אוג׳', 'ספט׳', 'אוק׳', 'נוב׳', 'דצמ׳'],
        wide: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר']
      };
      var dayValues = {
        narrow: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
        short: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
        abbreviated: ['יום א׳', 'יום ב׳', 'יום ג׳', 'יום ד׳', 'יום ה׳', 'יום ו׳', 'שבת'],
        wide: ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'יום שבת']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'לפנה״צ',
          pm: 'אחה״צ',
          midnight: 'חצות',
          noon: 'צהריים',
          morning: 'בוקר',
          afternoon: 'אחר הצהריים',
          evening: 'ערב',
          night: 'לילה'
        },
        abbreviated: {
          am: 'לפנה״צ',
          pm: 'אחה״צ',
          midnight: 'חצות',
          noon: 'צהריים',
          morning: 'בוקר',
          afternoon: 'אחר הצהריים',
          evening: 'ערב',
          night: 'לילה'
        },
        wide: {
          am: 'לפנה״צ',
          pm: 'אחה״צ',
          midnight: 'חצות',
          noon: 'צהריים',
          morning: 'בוקר',
          afternoon: 'אחר הצהריים',
          evening: 'ערב',
          night: 'לילה'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'לפנה״צ',
          pm: 'אחה״צ',
          midnight: 'חצות',
          noon: 'צהריים',
          morning: 'בבוקר',
          afternoon: 'בצהריים',
          evening: 'בערב',
          night: 'בלילה'
        },
        abbreviated: {
          am: 'לפנה״צ',
          pm: 'אחה״צ',
          midnight: 'חצות',
          noon: 'צהריים',
          morning: 'בבוקר',
          afternoon: 'אחר הצהריים',
          evening: 'בערב',
          night: 'בלילה'
        },
        wide: {
          am: 'לפנה״צ',
          pm: 'אחה״צ',
          midnight: 'חצות',
          noon: 'צהריים',
          morning: 'בבוקר',
          afternoon: 'אחר הצהריים',
          evening: 'בערב',
          night: 'בלילה'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber); // We only show words till 10

        if (number <= 0 || number > 10) return number;
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var isFemale = ['year', 'hour', 'minute', 'second'].indexOf(unit) >= 0;
        var male = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שביעי', 'שמיני', 'תשיעי', 'עשירי'];
        var female = ['ראשונה', 'שנייה', 'שלישית', 'רביעית', 'חמישית', 'שישית', 'שביעית', 'שמינית', 'תשיעית', 'עשירית'];
        var index = number - 1;
        return isFemale ? female[index] : male[index];
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 603 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
      var parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
      var matchEraPatterns = {
        narrow: /^ל(ספירה|פנה״ס)/i,
        abbreviated: /^ל(ספירה|פנה״ס)/i,
        wide: /^ל(פני ה)?ספירה/i
      };
      var parseEraPatterns = {
        any: [/^לפ/i, /^לס/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^רבעון [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^\d+/i,
        abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
        wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
      };
      var parseMonthPatterns = {
        narrow: [/^1$/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
        any: [/^ינ/i, /^פ/i, /^מר/i, /^אפ/i, /^מא/i, /^יונ/i, /^יול/i, /^אוג/i, /^ס/i, /^אוק/i, /^נ/i, /^ד/i]
      };
      var matchDayPatterns = {
        narrow: /^[אבגדהוש]׳/i,
        short: /^[אבגדהוש]׳/i,
        abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
        wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
      };
      var parseDayPatterns = {
        abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
        wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
        any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^לפ/i,
          pm: /^אחה/i,
          midnight: /^ח/i,
          noon: /^צ/i,
          morning: /בוקר/i,
          afternoon: /בצ|אחר/i,
          evening: /ערב/i,
          night: /לילה/i
        }
      };
      var ordinalName = ['רא', 'שנ', 'של', 'רב', 'ח', 'שי', 'שב', 'שמ', 'ת', 'ע'];
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 604 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(605);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(606);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(607);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(97);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(608);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Hindi locale (India).
       * @language Hindi
       * @iso-639-2 hin
       * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
       */


      var locale = {
        code: 'hi',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 605 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__localize_index_js__ = __webpack_require__(97); // Source: https://www.unicode.org/cldr/charts/32/summary/hi.html


      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: '१ सेकंड से कम',
          // CLDR #1310
          other: '{{count}} सेकंड से कम'
        },
        xSeconds: {
          one: '१ सेकंड',
          other: '{{count}} सेकंड'
        },
        halfAMinute: 'आधा मिनट',
        lessThanXMinutes: {
          one: '१ मिनट से कम',
          other: '{{count}} मिनट से कम'
        },
        xMinutes: {
          one: '१ मिनट',
          // CLDR #1307
          other: '{{count}} मिनट'
        },
        aboutXHours: {
          one: 'लगभग १ घंटा',
          other: 'लगभग {{count}} घंटे'
        },
        xHours: {
          one: '१ घंटा',
          // CLDR #1304
          other: '{{count}} घंटे' // CLDR #4467

        },
        xDays: {
          one: '१ दिन',
          // CLDR #1286
          other: '{{count}} दिन'
        },
        aboutXWeeks: {
          one: 'लगभग १ सप्ताह',
          other: 'लगभग {{count}} सप्ताह'
        },
        xWeeks: {
          one: '१ सप्ताह',
          other: '{{count}} सप्ताह'
        },
        aboutXMonths: {
          one: 'लगभग १ महीना',
          other: 'लगभग {{count}} महीने'
        },
        xMonths: {
          one: '१ महीना',
          other: '{{count}} महीने'
        },
        aboutXYears: {
          one: 'लगभग १ वर्ष',
          other: 'लगभग {{count}} वर्ष' // CLDR #4823

        },
        xYears: {
          one: '१ वर्ष',
          other: '{{count}} वर्ष'
        },
        overXYears: {
          one: '१ वर्ष से अधिक',
          other: '{{count}} वर्ष से अधिक'
        },
        almostXYears: {
          one: 'लगभग १ वर्ष',
          other: 'लगभग {{count}} वर्ष'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', __WEBPACK_IMPORTED_MODULE_0__localize_index_js__["a"
          /* default */
          ].numberToLocale(count));
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + 'मे ';
          } else {
            return result + ' पहले';
          }
        }

        return result;
      }
      /***/

    },
    /* 606 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, do MMMM, y',
        // CLDR #1787
        long: 'do MMMM, y',
        // CLDR #1788
        medium: 'd MMM, y',
        // CLDR #1789
        short: 'dd/MM/yyyy' // CLDR #1790

      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        // CLDR #1791
        long: 'h:mm:ss a z',
        // CLDR #1792
        medium: 'h:mm:ss a',
        // CLDR #1793
        short: 'h:mm a' // CLDR #1794

      };
      var dateTimeFormats = {
        full: "{{date}} 'को' {{time}}",
        // CLDR #1795
        long: "{{date}} 'को' {{time}}",
        // CLDR #1796
        medium: '{{date}}, {{time}}',
        // CLDR #1797
        short: '{{date}}, {{time}}' // CLDR #1798

      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 607 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'पिछले' eeee p",
        yesterday: "'कल' p",
        today: "'आज' p",
        tomorrow: "'कल' p",
        nextWeek: "eeee 'को' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 608 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__localize_index_js__ = __webpack_require__(97);

      var matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
      var parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
      var matchEraPatterns = {
        narrow: /^(ईसा-पूर्व|ईस्वी)/i,
        abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
        wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(a|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ति[1234]/i,
        wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
        abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
        wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ज/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^न/i, /^दि/i],
        any: [/^जन/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^नव/i, /^दिस/i]
      };
      var matchDayPatterns = {
        narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
        short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
        abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
        wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
      };
      var parseDayPatterns = {
        narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
        any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
        any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^पूर्वाह्न/i,
          pm: /^अपराह्न/i,
          midnight: /^मध्य/i,
          noon: /^दो/i,
          morning: /सु/i,
          afternoon: /दो/i,
          evening: /शा/i,
          night: /रा/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: __WEBPACK_IMPORTED_MODULE_2__localize_index_js__["a"
          /* default */
          ].localeToNumber
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 609 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(610);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(611);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(612);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(613);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(614);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Croatian locale.
       * @language Croatian
       * @iso-639-2 hrv
       * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
       * @author Manico [@manico]{@link https://github.com/manico}
       * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
       */


      var locale = {
        code: 'hr',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 610 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
          },
          dual: 'manje od {{count}} sekunde',
          other: 'manje od {{count}} sekundi'
        },
        xSeconds: {
          one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
          },
          dual: '{{count}} sekunde',
          other: '{{count}} sekundi'
        },
        halfAMinute: 'pola minute',
        lessThanXMinutes: {
          one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
          },
          dual: 'manje od {{count}} minute',
          other: 'manje od {{count}} minuta'
        },
        xMinutes: {
          one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
          },
          dual: '{{count}} minute',
          other: '{{count}} minuta'
        },
        aboutXHours: {
          one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
          },
          dual: 'oko {{count}} sata',
          other: 'oko {{count}} sati'
        },
        xHours: {
          one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
          },
          dual: '{{count}} sata',
          other: '{{count}} sati'
        },
        xDays: {
          one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
          },
          dual: '{{count}} dana',
          other: '{{count}} dana'
        },
        aboutXWeeks: {
          one: {
            standalone: 'oko 1 tjedan',
            withPrepositionAgo: 'oko 1 tjedan',
            withPrepositionIn: 'oko 1 tjedan'
          },
          dual: 'oko {{count}} tjedna',
          other: 'oko {{count}} tjedana'
        },
        xWeeks: {
          one: {
            standalone: '1 tjedan',
            withPrepositionAgo: '1 tjedan',
            withPrepositionIn: '1 tjedan'
          },
          dual: '{{count}} tjedna',
          other: '{{count}} tjedana'
        },
        aboutXMonths: {
          one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
          },
          dual: 'oko {{count}} mjeseca',
          other: 'oko {{count}} mjeseci'
        },
        xMonths: {
          one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
          },
          dual: '{{count}} mjeseca',
          other: '{{count}} mjeseci'
        },
        aboutXYears: {
          one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
          },
          dual: 'oko {{count}} godine',
          other: 'oko {{count}} godina'
        },
        xYears: {
          one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
          },
          dual: '{{count}} godine',
          other: '{{count}} godina'
        },
        overXYears: {
          one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
          },
          dual: 'preko {{count}} godine',
          other: 'preko {{count}} godina'
        },
        almostXYears: {
          one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
          },
          dual: 'gotovo {{count}} godine',
          other: 'gotovo {{count}} godina'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              result = formatDistanceLocale[token].one.withPrepositionIn;
            } else {
              result = formatDistanceLocale[token].one.withPrepositionAgo;
            }
          } else {
            result = formatDistanceLocale[token].one.standalone;
          }
        } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
        String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
        ) {
          result = formatDistanceLocale[token].dual.replace('{{count}}', count);
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'za ' + result;
          } else {
            return 'prije ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 611 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d. MMMM y.',
        long: 'd. MMMM y.',
        medium: 'd. MMM y.',
        short: 'dd. MM. y.'
      };
      var timeFormats = {
        full: 'HH:mm:ss (zzzz)',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'u' {{time}}",
        long: "{{date}} 'u' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 612 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function lastWeek(date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'prošlu nedjelju u' p";

            case 3:
              return "'prošlu srijedu u' p";

            case 6:
              return "'prošlu subotu u' p";

            default:
              return "'prošli' EEEE 'u' p";
          }
        },
        yesterday: "'jučer u' p",
        today: "'danas u' p",
        tomorrow: "'sutra u' p",
        nextWeek: function nextWeek(date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'iduću nedjelju u' p";

            case 3:
              return "'iduću srijedu u' p";

            case 6:
              return "'iduću subotu u' p";

            default:
              return "'prošli' EEEE 'u' p";
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date);
        }

        return format;
      }
      /***/

    },
    /* 613 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number).concat('.');
      }

      var eraValues = {
        narrow: ['pr.n.e.', 'AD'],
        abbreviated: ['pr. Kr.', 'po. Kr.'],
        wide: ['Prije Krista', 'Poslije Krista']
      };
      var monthValues = {
        narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
        abbreviated: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
        wide: ['siječanj', 'veljača', 'ožujak', 'travanj', 'svibanj', 'lipanj', 'srpanj', 'kolovoz', 'rujan', 'listopad', 'studeni', 'prosinac']
      };
      var formattingMonthValues = {
        narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
        abbreviated: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
        wide: ['siječnja', 'veljače', 'ožujka', 'travnja', 'svibnja', 'lipnja', 'srpnja', 'kolovoza', 'rujna', 'listopada', 'studenog', 'prosinca']
      };
      var quarterValues = {
        narrow: ['1.', '2.', '3.', '4.'],
        abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
        wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
      };
      var dayValues = {
        narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
        short: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
        abbreviated: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
        wide: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota']
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutro',
          afternoon: 'popodne',
          evening: 'navečer',
          night: 'noću'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutro',
          afternoon: 'popodne',
          evening: 'navečer',
          night: 'noću'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutro',
          afternoon: 'poslije podne',
          evening: 'navečer',
          night: 'noću'
        }
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutro',
          afternoon: 'popodne',
          evening: 'navečer',
          night: 'noću'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutro',
          afternoon: 'popodne',
          evening: 'navečer',
          night: 'noću'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutro',
          afternoon: 'poslije podne',
          evening: 'navečer',
          night: 'noću'
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 614 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(pr\.n\.e\.|AD)/i,
        abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
        wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
      };
      var parseEraPatterns = {
        any: [/^pr/i, /^(po|nova)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\.\s?kv\.?/i,
        wide: /^[1234]\. kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(10|11|12|[123456789])\./i,
        abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
        wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
      };
      var parseMonthPatterns = {
        narrow: [/(10|11|12|[123456789])/i],
        abbreviated: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i],
        wide: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i]
      };
      var matchDayPatterns = {
        narrow: /^[npusčc]/i,
        short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
        abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
        wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^pono/i,
          noon: /^pod/i,
          morning: /jutro/i,
          afternoon: /(poslije\s|po)+podne/i,
          evening: /(navece|naveče)/i,
          night: /(nocu|noću)/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 615 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(616);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(617);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(618);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(619);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(620);
      /**
       * @type {Locale}
       * @category Locales
       *
       * @summary Hungarian locale.
       * @language Hungarian
       *
       * @iso-639-2 hun
       *
       * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
       * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
       * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
       */


      var locale = {
        code: 'hu',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 616 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var translations = {
        about: 'körülbelül',
        over: 'több mint',
        almost: 'majdnem',
        lessthan: 'kevesebb mint'
      };
      var withoutSuffixes = {
        xseconds: ' másodperc',
        halfaminute: 'fél perc',
        xminutes: ' perc',
        xhours: ' óra',
        xdays: ' nap',
        xweeks: ' hét',
        xmonths: ' hónap',
        xyears: ' év'
      };
      var withSuffixes = {
        xseconds: {
          '-1': ' másodperccel ezelőtt',
          '1': ' másodperc múlva',
          '0': ' másodperce'
        },
        halfaminute: {
          '-1': 'fél perccel ezelőtt',
          '1': 'fél perc múlva',
          '0': 'fél perce'
        },
        xminutes: {
          '-1': ' perccel ezelőtt',
          '1': ' perc múlva',
          '0': ' perce'
        },
        xhours: {
          '-1': ' órával ezelőtt',
          '1': ' óra múlva',
          '0': ' órája'
        },
        xdays: {
          '-1': ' nappal ezelőtt',
          '1': ' nap múlva',
          '0': ' napja'
        },
        xweeks: {
          '-1': ' héttel ezelőtt',
          '1': ' hét múlva',
          '0': ' hete'
        },
        xmonths: {
          '-1': ' hónappal ezelőtt',
          '1': ' hónap múlva',
          '0': ' hónapja'
        },
        xyears: {
          '-1': ' évvel ezelőtt',
          '1': ' év múlva',
          '0': ' éve'
        }
      };

      function translate(number, addSuffix, key, comparison) {
        var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];

        if (key === 'halfaminute') {
          return translated;
        }

        return number + translated;
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var adverb = token.match(/about|over|almost|lessthan/i);
        var unit = token.replace(adverb, '');
        var result;
        result = translate(count, options.addSuffix, unit.toLowerCase(), options.comparison);

        if (adverb) {
          result = translations[adverb[0].toLowerCase()] + ' ' + result;
        }

        return result;
      }
      /***/

    },
    /* 617 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'y. MMMM d., EEEE',
        long: 'y. MMMM d.',
        medium: 'y. MMM d.',
        short: 'y. MM. dd.'
      };
      var timeFormats = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 618 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var accusativeWeekdays = ['vasárnap', 'hétfőn', 'kedden', 'szerdán', 'csütörtökön', 'pénteken', 'szombaton'];

      function week(isFuture) {
        return function (date, _baseDate, _options) {
          var day = date.getUTCDay();
          return (isFuture ? '' : "'múlt' ") + "'" + accusativeWeekdays[day] + "'" + " p'-kor'";
        };
      }

      var formatRelativeLocale = {
        lastWeek: week(false),
        yesterday: "'tegnap' p'-kor'",
        today: "'ma' p'-kor'",
        tomorrow: "'holnap' p'-kor'",
        nextWeek: week(true),
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 619 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['ie.', 'isz.'],
        abbreviated: ['i. e.', 'i. sz.'],
        wide: ['Krisztus előtt', 'időszámításunk szerint']
      };
      var quarterValues = {
        narrow: ['1.', '2.', '3.', '4.'],
        abbreviated: ['1. n.év', '2. n.év', '3. n.év', '4. n.év'],
        wide: ['1. negyedév', '2. negyedév', '3. negyedév', '4. negyedév']
      };
      var formattingQuarterValues = {
        narrow: ['I.', 'II.', 'III.', 'IV.'],
        abbreviated: ['I. n.év', 'II. n.év', 'III. n.év', 'IV. n.év'],
        wide: ['I. negyedév', 'II. negyedév', 'III. negyedév', 'IV. negyedév']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'Á', 'M', 'J', 'J', 'A', 'Sz', 'O', 'N', 'D'],
        abbreviated: ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'],
        wide: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december']
      };
      var dayValues = {
        narrow: ['V', 'H', 'K', 'Sz', 'Cs', 'P', 'Sz'],
        short: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
        abbreviated: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
        wide: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'de.',
          pm: 'du.',
          midnight: 'éjfél',
          noon: 'dél',
          morning: 'reggel',
          afternoon: 'du.',
          evening: 'este',
          night: 'éjjel'
        },
        abbreviated: {
          am: 'de.',
          pm: 'du.',
          midnight: 'éjfél',
          noon: 'dél',
          morning: 'reggel',
          afternoon: 'du.',
          evening: 'este',
          night: 'éjjel'
        },
        wide: {
          am: 'de.',
          pm: 'du.',
          midnight: 'éjfél',
          noon: 'dél',
          morning: 'reggel',
          afternoon: 'délután',
          evening: 'este',
          night: 'éjjel'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          formattingValues: formattingQuarterValues,
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 620 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ie\.|isz\.)/i,
        abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
        wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
      };
      var parseEraPatterns = {
        narrow: [/ie/i, /isz/i],
        abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
        any: [/előtt/i, /(szerint|i. sz.)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]\.?/i,
        abbreviated: /^[1234]?\.?\s?n\.év/i,
        wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
      };
      var parseQuarterPatterns = {
        any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmaásond]|sz/i,
        abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
        wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^([vhkpc]|sz|cs|sz)/i,
        short: /^([vhkp]|sze|cs|szo)/i,
        abbreviated: /^([vhkp]|sze|cs|szo)/i,
        wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
      };
      var parseDayPatterns = {
        narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
        any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
      };
      var matchDayPeriodPatterns = {
        any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^de\.?/i,
          pm: /^du\.?/i,
          midnight: /^éjf/i,
          noon: /^dé/i,
          morning: /reg/i,
          afternoon: /^délu\.?/i,
          evening: /es/i,
          night: /éjj/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 621 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(622);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(623);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(624);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(625);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(626);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Armenian locale
       * @language Armenian
       * @iso-639-2 arm
       * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
       */


      var locale = {
        code: 'hy',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 622 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'ավելի քիչ քան 1 վայրկյան',
          other: 'ավելի քիչ քան {{count}} վայրկյան'
        },
        xSeconds: {
          one: '1 վայրկյան',
          other: '{{count}} վայրկյան'
        },
        halfAMinute: 'կես րոպե',
        lessThanXMinutes: {
          one: 'ավելի քիչ քան 1 րոպե',
          other: 'ավելի քիչ քան {{count}} րոպե'
        },
        xMinutes: {
          one: '1 րոպե',
          other: '{{count}} րոպե'
        },
        aboutXHours: {
          one: 'մոտ 1 ժամ',
          other: 'մոտ {{count}} ժամ'
        },
        xHours: {
          one: '1 ժամ',
          other: '{{count}} ժամ'
        },
        xDays: {
          one: '1 օր',
          other: '{{count}} օր'
        },
        aboutXWeeks: {
          one: 'մոտ 1 շաբաթ',
          other: 'մոտ {{count}} շաբաթ'
        },
        xWeeks: {
          one: '1 շաբաթ',
          other: '{{count}} շաբաթ'
        },
        aboutXMonths: {
          one: 'մոտ 1 ամիս',
          other: 'մոտ {{count}} ամիս'
        },
        xMonths: {
          one: '1 ամիս',
          other: '{{count}} ամիս'
        },
        aboutXYears: {
          one: 'մոտ 1 տարի',
          other: 'մոտ {{count}} տարի'
        },
        xYears: {
          one: '1 տարի',
          other: '{{count}} տարի'
        },
        overXYears: {
          one: 'ավելի քան 1 տարի',
          other: 'ավելի քան {{count}} տարի'
        },
        almostXYears: {
          one: 'համարյա 1 տարի',
          other: 'համարյա {{count}} տարի'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + ' հետո';
          } else {
            return result + ' առաջ';
          }
        }

        return result;
      }
      /***/

    },
    /* 623 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'd MMMM, y, EEEE',
        long: 'd MMMM, y',
        medium: 'd MMM, y',
        short: 'dd.MM.yyyy'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'ժ․'{{time}}",
        long: "{{date}} 'ժ․'{{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 624 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'նախորդ' eeee p'֊ին'",
        yesterday: "'երեկ' p'֊ին'",
        today: "'այսօր' p'֊ին'",
        tomorrow: "'վաղը' p'֊ին'",
        nextWeek: "'հաջորդ' eeee p'֊ին'",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 625 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['Ք', 'Մ'],
        abbreviated: ['ՔԱ', 'ՄԹ'],
        wide: ['Քրիստոսից առաջ', 'Մեր թվարկության']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Ք1', 'Ք2', 'Ք3', 'Ք4'],
        wide: ['1֊ին քառորդ', '2֊րդ քառորդ', '3֊րդ քառորդ', '4֊րդ քառորդ']
      };
      var monthValues = {
        narrow: ['Հ', 'Փ', 'Մ', 'Ա', 'Մ', 'Հ', 'Հ', 'Օ', 'Ս', 'Հ', 'Ն', 'Դ'],
        abbreviated: ['հուն', 'փետ', 'մար', 'ապր', 'մայ', 'հուն', 'հուլ', 'օգս', 'սեպ', 'հոկ', 'նոյ', 'դեկ'],
        wide: ['հունվար', 'փետրվար', 'մարտ', 'ապրիլ', 'մայիս', 'հունիս', 'հուլիս', 'օգոստոս', 'սեպտեմբեր', 'հոկտեմբեր', 'նոյեմբեր', 'դեկտեմբեր']
      };
      var dayValues = {
        narrow: ['Կ', 'Ե', 'Ե', 'Չ', 'Հ', 'Ո', 'Շ'],
        short: ['կր', 'եր', 'եք', 'չք', 'հգ', 'ուր', 'շբ'],
        abbreviated: ['կիր', 'երկ', 'երք', 'չոր', 'հնգ', 'ուրբ', 'շաբ'],
        wide: ['կիրակի', 'երկուշաբթի', 'երեքշաբթի', 'չորեքշաբթի', 'հինգշաբթի', 'ուրբաթ', 'շաբաթ']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'կեսգշ',
          noon: 'կեսօր',
          morning: 'առավոտ',
          afternoon: 'ցերեկ',
          evening: 'երեկո',
          night: 'գիշեր'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'կեսգիշեր',
          noon: 'կեսօր',
          morning: 'առավոտ',
          afternoon: 'ցերեկ',
          evening: 'երեկո',
          night: 'գիշեր'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'կեսգիշեր',
          noon: 'կեսօր',
          morning: 'առավոտ',
          afternoon: 'ցերեկ',
          evening: 'երեկո',
          night: 'գիշեր'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'կեսգշ',
          noon: 'կեսօր',
          morning: 'առավոտը',
          afternoon: 'ցերեկը',
          evening: 'երեկոյան',
          night: 'գիշերը'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'կեսգիշերին',
          noon: 'կեսօրին',
          morning: 'առավոտը',
          afternoon: 'ցերեկը',
          evening: 'երեկոյան',
          night: 'գիշերը'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'կեսգիշերին',
          noon: 'կեսօրին',
          morning: 'առավոտը',
          afternoon: 'ցերեկը',
          evening: 'երեկոյան',
          night: 'գիշերը'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var rem100 = number % 100;

        if (rem100 < 10) {
          if (rem100 % 10 === 1) {
            return number + '֊ին';
          }
        }

        return number + '֊րդ';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 626 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(Ք|Մ)/i,
        abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
        wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
      };
      var parseEraPatterns = {
        any: [/^(ք|մ)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ք[1234]/i,
        wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[հփմաօսնդ]/i,
        abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
        wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
      };
      var parseMonthPatterns = {
        narrow: [/^հ/i, /^փ/i, /^մ/i, /^ա/i, /^մ/i, /^հ/i, /^հ/i, /^օ/i, /^ս/i, /^հ/i, /^ն/i, /^դ/i],
        any: [/^հու/i, /^փ/i, /^մար/i, /^ա/i, /^մայ/i, /^հուն/i, /^հուլ/i, /^օ/i, /^ս/i, /^հոկ/i, /^ն/i, /^դ/i]
      };
      var matchDayPatterns = {
        narrow: /^[եչհոշկ]/i,
        short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
        abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
        wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
      };
      var parseDayPatterns = {
        narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
        short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
        abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
        wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
        any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /կեսգիշեր/i,
          noon: /կեսօր/i,
          morning: /առավոտ/i,
          afternoon: /ցերեկ/i,
          evening: /երեկո/i,
          night: /գիշեր/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 627 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(628);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(629);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(630);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(631);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(632);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Indonesian locale.
       * @language Indonesian
       * @iso-639-2 ind
       * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
       * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
       * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
       * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
       */


      var locale = {
        code: 'id',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 628 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'kurang dari 1 detik',
          other: 'kurang dari {{count}} detik'
        },
        xSeconds: {
          one: '1 detik',
          other: '{{count}} detik'
        },
        halfAMinute: 'setengah menit',
        lessThanXMinutes: {
          one: 'kurang dari 1 menit',
          other: 'kurang dari {{count}} menit'
        },
        xMinutes: {
          one: '1 menit',
          other: '{{count}} menit'
        },
        aboutXHours: {
          one: 'sekitar 1 jam',
          other: 'sekitar {{count}} jam'
        },
        xHours: {
          one: '1 jam',
          other: '{{count}} jam'
        },
        xDays: {
          one: '1 hari',
          other: '{{count}} hari'
        },
        aboutXWeeks: {
          one: 'sekitar 1 minggu',
          other: 'sekitar {{count}} minggu'
        },
        xWeeks: {
          one: '1 minggu',
          other: '{{count}} minggu'
        },
        aboutXMonths: {
          one: 'sekitar 1 bulan',
          other: 'sekitar {{count}} bulan'
        },
        xMonths: {
          one: '1 bulan',
          other: '{{count}} bulan'
        },
        aboutXYears: {
          one: 'sekitar 1 tahun',
          other: 'sekitar {{count}} tahun'
        },
        xYears: {
          one: '1 tahun',
          other: '{{count}} tahun'
        },
        overXYears: {
          one: 'lebih dari 1 tahun',
          other: 'lebih dari {{count}} tahun'
        },
        almostXYears: {
          one: 'hampir 1 tahun',
          other: 'hampir {{count}} tahun'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'dalam waktu ' + result;
          } else {
            return result + ' yang lalu';
          }
        }

        return result;
      }
      /***/

    },
    /* 629 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM yyyy',
        medium: 'd MMM yyyy',
        short: 'd/M/yyyy'
      };
      var timeFormats = {
        full: 'HH.mm.ss',
        long: 'HH.mm.ss',
        medium: 'HH.mm',
        short: 'HH.mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'pukul' {{time}}",
        long: "{{date}} 'pukul' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 630 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'lalu pukul' p",
        yesterday: "'Kemarin pukul' p",
        today: "'Hari ini pukul' p",
        tomorrow: "'Besok pukul' p",
        nextWeek: "eeee 'pukul' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 631 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3); // All data for localization are taken from this page
      // https://www.unicode.org/cldr/charts/32/summary/id.html


      var eraValues = {
        narrow: ['SM', 'M'],
        abbreviated: ['SM', 'M'],
        wide: ['Sebelum Masehi', 'Masehi']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['K1', 'K2', 'K3', 'K4'],
        wide: ['Kuartal ke-1', 'Kuartal ke-2', 'Kuartal ke-3', 'Kuartal ke-4'] // Note: in Indonesian, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sep', 'Okt', 'Nov', 'Des'],
        wide: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
      };
      var dayValues = {
        narrow: ['M', 'S', 'S', 'R', 'K', 'J', 'S'],
        short: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        abbreviated: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
        wide: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'siang',
          evening: 'sore',
          night: 'malam'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'siang',
          evening: 'sore',
          night: 'malam'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'siang',
          evening: 'sore',
          night: 'malam'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'siang',
          evening: 'sore',
          night: 'malam'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'siang',
          evening: 'sore',
          night: 'malam'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'siang',
          evening: 'sore',
          night: 'malam'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed

        switch (number) {
          default:
            return 'ke-' + number;
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 632 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(sm|m)/i,
        abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
        wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
      };
      var parseEraPatterns = {
        any: [/^s/i, /^(m|e)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K-?\s[1234]/i,
        wide: /^Kuartal ke-?\s?[1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
        wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[srkjm]/i,
        short: /^(min|sen|sel|rab|kam|jum|sab)/i,
        abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
        wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
      };
      var parseDayPatterns = {
        narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
        any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
        any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^pm/i,
          midnight: /^tengah m/i,
          noon: /^tengah h/i,
          morning: /pagi/i,
          afternoon: /siang/i,
          evening: /sore/i,
          night: /malam/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 633 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(634);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(635);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(636);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(637);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(638);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Icelandic locale.
       * @language Icelandic
       * @iso-639-2 isl
       * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
       * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
       */


      var locale = {
        code: 'is',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 634 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'minna en 1 sekúnda',
          other: 'minna en {{count}} sekúndur'
        },
        xSeconds: {
          one: '1 sekúnda',
          other: '{{count}} sekúndur'
        },
        halfAMinute: 'hálf mínúta',
        lessThanXMinutes: {
          one: 'minna en 1 mínúta',
          other: 'minna en {{count}} mínútur'
        },
        xMinutes: {
          one: '1 mínúta',
          other: '{{count}} mínútur'
        },
        aboutXHours: {
          one: 'u.þ.b. 1 klukkustund',
          other: 'u.þ.b. {{count}} klukkustundir'
        },
        xHours: {
          one: '1 klukkustund',
          other: '{{count}} klukkustundir'
        },
        xDays: {
          one: '1 dagur',
          other: '{{count}} dagar'
        },
        aboutXWeeks: {
          one: 'um viku',
          other: 'um {{count}} vikur'
        },
        xWeeks: {
          one: '1 viku',
          other: '{{count}} vikur'
        },
        aboutXMonths: {
          one: 'u.þ.b. 1 mánuður',
          other: 'u.þ.b. {{count}} mánuðir'
        },
        xMonths: {
          one: '1 mánuður',
          other: '{{count}} mánuðir'
        },
        aboutXYears: {
          one: 'u.þ.b. 1 ár',
          other: 'u.þ.b. {{count}} ár'
        },
        xYears: {
          one: '1 ár',
          other: '{{count}} ár'
        },
        overXYears: {
          one: 'meira en 1 ár',
          other: 'meira en {{count}} ár'
        },
        almostXYears: {
          one: 'næstum 1 ár',
          other: 'næstum {{count}} ár'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'í ' + result;
          } else {
            return result + ' síðan';
          }
        }

        return result;
      }
      /***/

    },
    /* 635 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, do MMMM y',
        long: 'do MMMM y',
        medium: 'do MMM y',
        short: 'd.MM.y'
      };
      var timeFormats = {
        full: "'kl'. HH:mm:ss zzzz",
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl.' {{time}}",
        long: "{{date}} 'kl.' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 636 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'síðasta' dddd 'kl.' p",
        yesterday: "'í gær kl.' p",
        today: "'í dag kl.' p",
        tomorrow: "'á morgun kl.' p",
        nextWeek: "dddd 'kl.' p",
        other: 'L'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 637 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['f.Kr.', 'e.Kr.'],
        abbreviated: ['f.Kr.', 'e.Kr.'],
        wide: ['fyrir Krist', 'eftir Krist']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1F', '2F', '3F', '4F'],
        wide: ['1. fjórðungur', '2. fjórðungur', '3. fjórðungur', '4. fjórðungur']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'Á', 'S', 'Ó', 'N', 'D'],
        abbreviated: ['jan.', 'feb.', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'sept.', 'okt.', 'nóv.', 'des.'],
        wide: ['janúar', 'febrúar', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'september', 'október', 'nóvember', 'desember']
      };
      var dayValues = {
        narrow: ['S', 'M', 'Þ', 'M', 'F', 'F', 'L'],
        short: ['Su', 'Má', 'Þr', 'Mi', 'Fi', 'Fö', 'La'],
        abbreviated: ['sun.', 'mán.', 'þri.', 'mið.', 'fim.', 'fös.', 'lau'],
        wide: ['sunnudagur', 'mánudagur', 'þriðjudagur', 'miðvikudagur', 'fimmtudagur', 'föstudagur', 'laugardagur']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'f',
          pm: 'e',
          midnight: 'miðnætti',
          noon: 'hádegi',
          morning: 'morgunn',
          afternoon: 'síðdegi',
          evening: 'kvöld',
          night: 'nótt'
        },
        abbreviated: {
          am: 'f.h.',
          pm: 'e.h.',
          midnight: 'miðnætti',
          noon: 'hádegi',
          morning: 'morgunn',
          afternoon: 'síðdegi',
          evening: 'kvöld',
          night: 'nótt'
        },
        wide: {
          am: 'fyrir hádegi',
          pm: 'eftir hádegi',
          midnight: 'miðnætti',
          noon: 'hádegi',
          morning: 'morgunn',
          afternoon: 'síðdegi',
          evening: 'kvöld',
          night: 'nótt'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'f',
          pm: 'e',
          midnight: 'á miðnætti',
          noon: 'á hádegi',
          morning: 'að morgni',
          afternoon: 'síðdegis',
          evening: 'um kvöld',
          night: 'um nótt'
        },
        abbreviated: {
          am: 'f.h.',
          pm: 'e.h.',
          midnight: 'á miðnætti',
          noon: 'á hádegi',
          morning: 'að morgni',
          afternoon: 'síðdegis',
          evening: 'um kvöld',
          night: 'um nótt'
        },
        wide: {
          am: 'fyrir hádegi',
          pm: 'eftir hádegi',
          midnight: 'á miðnætti',
          noon: 'á hádegi',
          morning: 'að morgni',
          afternoon: 'síðdegis',
          evening: 'um kvöld',
          night: 'um nótt'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 638 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(f\.Kr\.|e\.Kr\.)/i,
        abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
        wide: /^(fyrir Krist|eftir Krist)/i
      };
      var parseEraPatterns = {
        any: [/^(f\.Kr\.|e\.Kr\.)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234] fjórðungur/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmásónd]/i,
        abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
        wide: /^(januar|februar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^á/i, /^s/i, /^ó/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maí/i, /^jún/i, /^júl/i, /^áu/i, /^s/i, /^ó/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtwf]/i,
        short: /^(su|má|þr|mi|fi|fö|la)/i,
        abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
        wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
        any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
        any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^f/i,
          pm: /^e/i,
          midnight: /^mi/i,
          noon: /^há/i,
          morning: /morgunn/i,
          afternoon: /síðdegi/i,
          evening: /kvöld/i,
          night: /nótt/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 639 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(640);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(641);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(642);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(643);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(644);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Italian locale.
       * @language Italian
       * @iso-639-2 ita
       * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
       * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
       * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
       */


      var locale = {
        code: 'it',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 640 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'meno di un secondo',
          other: 'meno di {{count}} secondi'
        },
        xSeconds: {
          one: 'un secondo',
          other: '{{count}} secondi'
        },
        halfAMinute: 'alcuni secondi',
        lessThanXMinutes: {
          one: 'meno di un minuto',
          other: 'meno di {{count}} minuti'
        },
        xMinutes: {
          one: 'un minuto',
          other: '{{count}} minuti'
        },
        aboutXHours: {
          one: "circa un'ora",
          other: 'circa {{count}} ore'
        },
        xHours: {
          one: "un'ora",
          other: '{{count}} ore'
        },
        xDays: {
          one: 'un giorno',
          other: '{{count}} giorni'
        },
        aboutXWeeks: {
          one: 'circa una settimana',
          other: 'circa {{count}} settimane'
        },
        xWeeks: {
          one: 'una settimana',
          other: '{{count}} settimane'
        },
        aboutXMonths: {
          one: 'circa un mese',
          other: 'circa {{count}} mesi'
        },
        xMonths: {
          one: 'un mese',
          other: '{{count}} mesi'
        },
        aboutXYears: {
          one: 'circa un anno',
          other: 'circa {{count}} anni'
        },
        xYears: {
          one: 'un anno',
          other: '{{count}} anni'
        },
        overXYears: {
          one: 'più di un anno',
          other: 'più di {{count}} anni'
        },
        almostXYears: {
          one: 'quasi un anno',
          other: 'quasi {{count}} anni'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'tra ' + result;
          } else {
            return result + ' fa';
          }
        }

        return result;
      }
      /***/

    },
    /* 641 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE d MMMM y',
        long: 'd MMMM y',
        medium: 'd MMM y',
        short: 'dd/MM/y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 642 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13);

      var weekdays = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];

      function _lastWeek3(day) {
        switch (day) {
          case 0:
            return "'domenica scorsa alle' p";

          default:
            return "'" + weekdays[day] + " scorso alle' p";
        }
      }

      function thisWeek(day) {
        return "'" + weekdays[day] + " alle' p";
      }

      function _nextWeek3(day) {
        switch (day) {
          case 0:
            return "'domenica prossima alle' p";

          default:
            return "'" + weekdays[day] + " prossimo alle' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _lastWeek3(day);
          }
        },
        yesterday: "'ieri alle' p",
        today: "'oggi alle' p",
        tomorrow: "'domani alle' p",
        nextWeek: function nextWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _nextWeek3(day);
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 643 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['aC', 'dC'],
        abbreviated: ['a.C.', 'd.C.'],
        wide: ['avanti Cristo', 'dopo Cristo']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['T1', 'T2', 'T3', 'T4'],
        wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
      };
      var monthValues = {
        narrow: ['G', 'F', 'M', 'A', 'M', 'G', 'L', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
        wide: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']
      };
      var dayValues = {
        narrow: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
        short: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
        abbreviated: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
        wide: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'm.',
          pm: 'p.',
          midnight: 'mezzanotte',
          noon: 'mezzogiorno',
          morning: 'mattina',
          afternoon: 'pomeriggio',
          evening: 'sera',
          night: 'notte'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'mezzanotte',
          noon: 'mezzogiorno',
          morning: 'mattina',
          afternoon: 'pomeriggio',
          evening: 'sera',
          night: 'notte'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'mezzanotte',
          noon: 'mezzogiorno',
          morning: 'mattina',
          afternoon: 'pomeriggio',
          evening: 'sera',
          night: 'notte'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'm.',
          pm: 'p.',
          midnight: 'mezzanotte',
          noon: 'mezzogiorno',
          morning: 'di mattina',
          afternoon: 'del pomeriggio',
          evening: 'di sera',
          night: 'di notte'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'mezzanotte',
          noon: 'mezzogiorno',
          morning: 'di mattina',
          afternoon: 'del pomeriggio',
          evening: 'di sera',
          night: 'di notte'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'mezzanotte',
          noon: 'mezzogiorno',
          morning: 'di mattina',
          afternoon: 'del pomeriggio',
          evening: 'di sera',
          night: 'di notte'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + 'º';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 644 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(aC|dC)/i,
        abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
        wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
      };
      var parseEraPatterns = {
        any: [/^a/i, /^(d|e)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^t[1234]/i,
        wide: /^[1234](º)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[gfmalsond]/i,
        abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
        wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
      };
      var parseMonthPatterns = {
        narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmgvs]/i,
        short: /^(do|lu|ma|me|gi|ve|sa)/i,
        abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
        wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
        any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
        any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mezza/i,
          noon: /^mezzo/i,
          morning: /mattina/i,
          afternoon: /pomeriggio/i,
          evening: /sera/i,
          night: /notte/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 645 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(646);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(647);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(648);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(649);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(650);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Japanese locale.
       * @language Japanese
       * @iso-639-2 jpn
       * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
       * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
       * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
       * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
       * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
       */


      var locale = {
        code: 'ja',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 646 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: '1秒未満',
          other: '{{count}}秒未満',
          oneWithSuffix: '約1秒',
          otherWithSuffix: '約{{count}}秒'
        },
        xSeconds: {
          one: '1秒',
          other: '{{count}}秒'
        },
        halfAMinute: '30秒',
        lessThanXMinutes: {
          one: '1分未満',
          other: '{{count}}分未満',
          oneWithSuffix: '約1分',
          otherWithSuffix: '約{{count}}分'
        },
        xMinutes: {
          one: '1分',
          other: '{{count}}分'
        },
        aboutXHours: {
          one: '約1時間',
          other: '約{{count}}時間'
        },
        xHours: {
          one: '1時間',
          other: '{{count}}時間'
        },
        xDays: {
          one: '1日',
          other: '{{count}}日'
        },
        aboutXWeeks: {
          one: '約1週間',
          other: '約{{count}}週間'
        },
        xWeeks: {
          one: '1週間',
          other: '{{count}}週間'
        },
        aboutXMonths: {
          one: '約1か月',
          other: '約{{count}}か月'
        },
        xMonths: {
          one: '1か月',
          other: '{{count}}か月'
        },
        aboutXYears: {
          one: '約1年',
          other: '約{{count}}年'
        },
        xYears: {
          one: '1年',
          other: '{{count}}年'
        },
        overXYears: {
          one: '1年以上',
          other: '{{count}}年以上'
        },
        almostXYears: {
          one: '1年近く',
          other: '{{count}}年近く'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix && formatDistanceLocale[token].oneWithSuffix) {
            result = formatDistanceLocale[token].oneWithSuffix;
          } else {
            result = formatDistanceLocale[token].one;
          }
        } else {
          if (options.addSuffix && formatDistanceLocale[token].otherWithSuffix) {
            result = formatDistanceLocale[token].otherWithSuffix.replace('{{count}}', count);
          } else {
            result = formatDistanceLocale[token].other.replace('{{count}}', count);
          }
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + '後';
          } else {
            return result + '前';
          }
        }

        return result;
      }
      /***/

    },
    /* 647 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'y年M月d日EEEE',
        long: 'y年M月d日',
        medium: 'y/MM/dd',
        short: 'y/MM/dd'
      };
      var timeFormats = {
        full: 'H時mm分ss秒 zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 648 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: '先週のeeeeのp',
        yesterday: '昨日のp',
        today: '今日のp',
        tomorrow: '明日のp',
        nextWeek: '翌週のeeeeのp',
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 649 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['BC', 'AC'],
        abbreviated: ['紀元前', '西暦'],
        wide: ['紀元前', '西暦']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['第1四半期', '第2四半期', '第3四半期', '第4四半期']
      };
      var monthValues = {
        narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        wide: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
      };
      var dayValues = {
        narrow: ['日', '月', '火', '水', '木', '金', '土'],
        short: ['日', '月', '火', '水', '木', '金', '土'],
        abbreviated: ['日', '月', '火', '水', '木', '金', '土'],
        wide: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
      };
      var dayPeriodValues = {
        narrow: {
          am: '午前',
          pm: '午後',
          midnight: '深夜',
          noon: '正午',
          morning: '朝',
          afternoon: '午後',
          evening: '夜',
          night: '深夜'
        },
        abbreviated: {
          am: '午前',
          pm: '午後',
          midnight: '深夜',
          noon: '正午',
          morning: '朝',
          afternoon: '午後',
          evening: '夜',
          night: '深夜'
        },
        wide: {
          am: '午前',
          pm: '午後',
          midnight: '深夜',
          noon: '正午',
          morning: '朝',
          afternoon: '午後',
          evening: '夜',
          night: '深夜'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: '午前',
          pm: '午後',
          midnight: '深夜',
          noon: '正午',
          morning: '朝',
          afternoon: '午後',
          evening: '夜',
          night: '深夜'
        },
        abbreviated: {
          am: '午前',
          pm: '午後',
          midnight: '深夜',
          noon: '正午',
          morning: '朝',
          afternoon: '午後',
          evening: '夜',
          night: '深夜'
        },
        wide: {
          am: '午前',
          pm: '午後',
          midnight: '深夜',
          noon: '正午',
          morning: '朝',
          afternoon: '午後',
          evening: '夜',
          night: '深夜'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var options = dirtyOptions || {};
        var unit = String(options.unit);

        if (unit === 'date') {
          return number + '日';
        }

        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 650 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^第?\d+(日)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(B\.?C\.?|A\.?D\.?)/i,
        abbreviated: /^(紀元[前後]|西暦)/i,
        wide: /^(紀元[前後]|西暦)/i
      };
      var parseEraPatterns = {
        narrow: [/^B/i, /^A/i],
        any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^Q[1234]/i,
        wide: /^第[1234一二三四１２３４]四半期/i
      };
      var parseQuarterPatterns = {
        any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
      };
      var matchMonthPatterns = {
        narrow: /^([123456789]|1[012])/,
        abbreviated: /^([123456789]|1[012])月/i,
        wide: /^([123456789]|1[012])月/i
      };
      var parseMonthPatterns = {
        any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
      };
      var matchDayPatterns = {
        narrow: /^[日月火水木金土]/,
        short: /^[日月火水木金土]/,
        abbreviated: /^[日月火水木金土]/,
        wide: /^[日月火水木金土]曜日/
      };
      var parseDayPatterns = {
        any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
      };
      var matchDayPeriodPatterns = {
        any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^(A|午前)/i,
          pm: /^(P|午後)/i,
          midnight: /^深夜|真夜中/i,
          noon: /^正午/i,
          morning: /^朝/i,
          afternoon: /^午後/i,
          evening: /^夜/i,
          night: /^深夜/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 651 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(652);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(653);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(654);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(655);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(656);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Georgian locale.
       * @language Georgian
       * @iso-639-2 geo
       * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
       * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
       */


      var locale = {
        code: 'ka',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 652 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          past: '{{count}} წამზე ნაკლები ხნის წინ',
          present: '{{count}} წამზე ნაკლები',
          future: '{{count}} წამზე ნაკლებში'
        },
        xSeconds: {
          past: '{{count}} წამის წინ',
          present: '{{count}} წამი',
          future: '{{count}} წამში'
        },
        halfAMinute: {
          past: 'ნახევარი წუთის წინ',
          present: 'ნახევარი წუთი',
          future: 'ნახევარი წუთში'
        },
        lessThanXMinutes: {
          past: '{{count}} წუთზე ნაკლები ხნის წინ',
          present: '{{count}} წუთზე ნაკლები',
          future: '{{count}} წუთზე ნაკლებში'
        },
        xMinutes: {
          past: '{{count}} წუთის წინ',
          present: '{{count}} წუთი',
          future: '{{count}} წუთში'
        },
        aboutXHours: {
          past: 'დაახლოებით {{count}} საათის წინ',
          present: 'დაახლოებით {{count}} საათი',
          future: 'დაახლოებით {{count}} საათში'
        },
        xHours: {
          past: '{{count}} საათის წინ',
          present: '{{count}} საათი',
          future: '{{count}} საათში'
        },
        xDays: {
          past: '{{count}} დღის წინ',
          present: '{{count}} დღე',
          future: '{{count}} დღეში'
        },
        aboutXWeeks: {
          past: 'დაახლოებით {{count}} კვირას წინ',
          present: 'დაახლოებით {{count}} კვირა',
          future: 'დაახლოებით {{count}} კვირაში'
        },
        xWeeks: {
          past: '{{count}} კვირას კვირა',
          present: '{{count}} კვირა',
          future: '{{count}} კვირაში'
        },
        aboutXMonths: {
          past: 'დაახლოებით {{count}} თვის წინ',
          present: 'დაახლოებით {{count}} თვე',
          future: 'დაახლოებით {{count}} თვეში'
        },
        xMonths: {
          past: '{{count}} თვის წინ',
          present: '{{count}} თვე',
          future: '{{count}} თვეში'
        },
        aboutXYears: {
          past: 'დაახლოებით {{count}} წლის წინ',
          present: 'დაახლოებით {{count}} წელი',
          future: 'დაახლოებით {{count}} წელში'
        },
        xYears: {
          past: '{{count}} წლის წინ',
          present: '{{count}} წელი',
          future: '{{count}} წელში'
        },
        overXYears: {
          past: '{{count}} წელზე მეტი ხნის წინ',
          present: '{{count}} წელზე მეტი',
          future: '{{count}} წელზე მეტი ხნის შემდეგ'
        },
        almostXYears: {
          past: 'თითქმის {{count}} წლის წინ',
          present: 'თითქმის {{count}} წელი',
          future: 'თითქმის {{count}} წელში'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (options.addSuffix && options.comparison > 0) {
          result = formatDistanceLocale[token].future.replace('{{count}}', count);
        } else if (options.addSuffix && options.comparison <= 0) {
          result = formatDistanceLocale[token].past.replace('{{count}}', count);
        } else {
          result = formatDistanceLocale[token].present.replace('{{count}}', count);
        }

        return result;
      }
      /***/

    },
    /* 653 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, do MMMM, y',
        long: 'do, MMMM, y',
        medium: 'd, MMM, y',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}'-ზე'",
        long: "{{date}} {{time}}'-ზე'",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 654 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'წინა' eeee LT'-ზე'",
        yesterday: "'გუშინ' LT'-ზე'",
        today: "'დღეს' LT'-ზე'",
        tomorrow: "'ხვალ' LT'-ზე'",
        nextWeek: "'შემდეგი' eeee LT'-ზე'",
        other: 'L'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 655 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['ჩ.წ-მდე', 'ჩ.წ'],
        abbreviated: ['ჩვ.წ-მდე', 'ჩვ.წ'],
        wide: ['ჩვენს წელთაღრიცხვამდე', 'ჩვენი წელთაღრიცხვით']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1-ლი კვ', '2-ე კვ', '3-ე კვ', '4-ე კვ'],
        wide: ['1-ლი კვარტალი', '2-ე კვარტალი', '3-ე კვარტალი', '4-ე კვარტალი'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['ია', 'თე', 'მა', 'აპ', 'მს', 'ვნ', 'ვლ', 'აგ', 'სე', 'ოქ', 'ნო', 'დე'],
        abbreviated: ['იან', 'თებ', 'მარ', 'აპრ', 'მაი', 'ივნ', 'ივლ', 'აგვ', 'სექ', 'ოქტ', 'ნოე', 'დეკ'],
        wide: ['იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი', 'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი']
      };
      var dayValues = {
        narrow: ['კვ', 'ორ', 'სა', 'ოთ', 'ხუ', 'პა', 'შა'],
        short: ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
        abbreviated: ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
        wide: ['კვირა', 'ორშაბათი', 'სამშაბათი', 'ოთხშაბათი', 'ხუთშაბათი', 'პარასკევი', 'შაბათი']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'შუაღამე',
          noon: 'შუადღე',
          morning: 'დილა',
          afternoon: 'საღამო',
          evening: 'საღამო',
          night: 'ღამე'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'შუაღამე',
          noon: 'შუადღე',
          morning: 'დილა',
          afternoon: 'საღამო',
          evening: 'საღამო',
          night: 'ღამე'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'შუაღამე',
          noon: 'შუადღე',
          morning: 'დილა',
          afternoon: 'საღამო',
          evening: 'საღამო',
          night: 'ღამე'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'შუაღამით',
          noon: 'შუადღისას',
          morning: 'დილით',
          afternoon: 'ნაშუადღევს',
          evening: 'საღამოს',
          night: 'ღამით'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'შუაღამით',
          noon: 'შუადღისას',
          morning: 'დილით',
          afternoon: 'ნაშუადღევს',
          evening: 'საღამოს',
          night: 'ღამით'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'შუაღამით',
          noon: 'შუადღისას',
          morning: 'დილით',
          afternoon: 'ნაშუადღევს',
          evening: 'საღამოს',
          night: 'ღამით'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        if (number === 1) {
          return number + '-ლი';
        }

        return number + '-ე';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 656 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ჩვ?\.წ)/i,
        abbreviated: /^(ჩვ?\.წ)/i,
        wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
      };
      var parseEraPatterns = {
        any: [/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i, /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]-(ლი|ე)? კვ/i,
        wide: /^[1234]-(ლი|ე)? კვარტალი/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
      };
      var parseMonthPatterns = {
        any: [/^ია/i, /^თ/i, /^მარ/i, /^აპ/i, /^მაი/i, /^ი?ვნ/i, /^ი?ვლ/i, /^აგ/i, /^ს/i, /^ო/i, /^ნ/i, /^დ/i]
      };
      var matchDayPatterns = {
        narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
        short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
        long: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
      };
      var parseDayPatterns = {
        any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
      };
      var matchDayPeriodPatterns = {
        any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^შუაღ/i,
          noon: /^შუადღ/i,
          morning: /^დილ/i,
          afternoon: /ნაშუადღევს/i,
          evening: /საღამო/i,
          night: /ღამ/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 657 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(658);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(659);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(660);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(661);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(662);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Kazakh locale.
       * @language Kazakh
       * @iso-639-2 kaz
       * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
       */


      var locale = {
        code: 'kk',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 658 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;

      function declension(scheme, count) {
        // scheme for count=1 exists
        if (scheme.one !== undefined && count === 1) {
          return scheme.one;
        }

        var rem10 = count % 10;
        var rem100 = count % 100; // 1, 21, 31, ...

        if (rem10 === 1 && rem100 !== 11) {
          return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
        } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
          return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
        } else {
          return scheme.pluralGenitive.replace('{{count}}', count);
        }
      }

      function buildLocalizeTokenFn(scheme) {
        return function (count, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              if (scheme.future) {
                return declension(scheme.future, count);
              } else {
                return declension(scheme.regular, count) + ' кейін';
              }
            } else {
              if (scheme.past) {
                return declension(scheme.past, count);
              } else {
                return declension(scheme.regular, count) + ' бұрын';
              }
            }
          } else {
            return declension(scheme.regular, count);
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          regular: {
            one: '1 секундтан аз',
            singularNominative: '{{count}} секундтан аз',
            singularGenitive: '{{count}} секундтан аз',
            pluralGenitive: '{{count}} секундтан аз'
          },
          future: {
            one: 'бір секундтан кейін',
            singularNominative: '{{count}} секундтан кейін',
            singularGenitive: '{{count}} секундтан кейін',
            pluralGenitive: '{{count}} секундтан кейін'
          }
        }),
        xSeconds: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} секунд',
            singularGenitive: '{{count}} секунд',
            pluralGenitive: '{{count}} секунд'
          },
          past: {
            singularNominative: '{{count}} секунд бұрын',
            singularGenitive: '{{count}} секунд бұрын',
            pluralGenitive: '{{count}} секунд бұрын'
          },
          future: {
            singularNominative: '{{count}} секундтан кейін',
            singularGenitive: '{{count}} секундтан кейін',
            pluralGenitive: '{{count}} секундтан кейін'
          }
        }),
        halfAMinute: function halfAMinute(_, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              return 'жарты минут ішінде';
            } else {
              return 'жарты минут бұрын';
            }
          }

          return 'жарты минут';
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          regular: {
            one: '1 минуттан аз',
            singularNominative: '{{count}} минуттан аз',
            singularGenitive: '{{count}} минуттан аз',
            pluralGenitive: '{{count}} минуттан аз'
          },
          future: {
            one: 'минуттан кем ',
            singularNominative: '{{count}} минуттан кем',
            singularGenitive: '{{count}} минуттан кем',
            pluralGenitive: '{{count}} минуттан кем'
          }
        }),
        xMinutes: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} минут',
            singularGenitive: '{{count}} минут',
            pluralGenitive: '{{count}} минут'
          },
          past: {
            singularNominative: '{{count}} минут бұрын',
            singularGenitive: '{{count}} минут бұрын',
            pluralGenitive: '{{count}} минут бұрын'
          },
          future: {
            singularNominative: '{{count}} минуттан кейін',
            singularGenitive: '{{count}} минуттан кейін',
            pluralGenitive: '{{count}} минуттан кейін'
          }
        }),
        aboutXHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'шамамен {{count}} сағат',
            singularGenitive: 'шамамен {{count}} сағат',
            pluralGenitive: 'шамамен {{count}} сағат'
          },
          future: {
            singularNominative: 'шамамен {{count}} сағаттан кейін',
            singularGenitive: 'шамамен {{count}} сағаттан кейін',
            pluralGenitive: 'шамамен {{count}} сағаттан кейін'
          }
        }),
        xHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} сағат',
            singularGenitive: '{{count}} сағат',
            pluralGenitive: '{{count}} сағат'
          }
        }),
        xDays: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} күн',
            singularGenitive: '{{count}} күн',
            pluralGenitive: '{{count}} күн'
          },
          future: {
            singularNominative: '{{count}} күннен кейін',
            singularGenitive: '{{count}} күннен кейін',
            pluralGenitive: '{{count}} күннен кейін'
          }
        }),
        aboutXWeeks: {
          one: 'шамамен 1 апта',
          other: 'шамамен {{count}} апта'
        },
        xWeeks: {
          one: '1 апта',
          other: '{{count}} апта'
        },
        aboutXMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'шамамен {{count}} ай',
            singularGenitive: 'шамамен {{count}} ай',
            pluralGenitive: 'шамамен {{count}} ай'
          },
          future: {
            singularNominative: 'шамамен {{count}} айдан кейін',
            singularGenitive: 'шамамен {{count}} айдан кейін',
            pluralGenitive: 'шамамен {{count}} айдан кейін'
          }
        }),
        xMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} ай',
            singularGenitive: '{{count}} ай',
            pluralGenitive: '{{count}} ай'
          }
        }),
        aboutXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'шамамен {{count}} жыл',
            singularGenitive: 'шамамен {{count}} жыл',
            pluralGenitive: 'шамамен {{count}} жыл'
          },
          future: {
            singularNominative: 'шамамен {{count}} жылдан кейін',
            singularGenitive: 'шамамен {{count}} жылдан кейін',
            pluralGenitive: 'шамамен {{count}} жылдан кейін'
          }
        }),
        xYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} жыл',
            singularGenitive: '{{count}} жыл',
            pluralGenitive: '{{count}} жыл'
          },
          future: {
            singularNominative: '{{count}} жылдан кейін',
            singularGenitive: '{{count}} жылдан кейін',
            pluralGenitive: '{{count}} жылдан кейін'
          }
        }),
        overXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} жылдан астам',
            singularGenitive: '{{count}} жылдан астам',
            pluralGenitive: '{{count}} жылдан астам'
          },
          future: {
            singularNominative: '{{count}} жылдан астам',
            singularGenitive: '{{count}} жылдан астам',
            pluralGenitive: '{{count}} жылдан астам'
          }
        }),
        almostXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} жылға жақын',
            singularGenitive: '{{count}} жылға жақын',
            pluralGenitive: '{{count}} жылға жақын'
          },
          future: {
            singularNominative: '{{count}} жылдан кейін',
            singularGenitive: '{{count}} жылдан кейін',
            pluralGenitive: '{{count}} жылдан кейін'
          }
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        return formatDistanceLocale[token](count, options);
      }
      /***/

    },
    /* 659 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, do MMMM y 'ж.'",
        long: "do MMMM y 'ж.'",
        medium: "d MMM y 'ж.'",
        short: 'dd.MM.yyyy'
      };
      var timeFormats = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        any: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 660 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13);

      var accusativeWeekdays = ['жексенбіде', 'дүйсенбіде', 'сейсенбіде', 'сәрсенбіде', 'бейсенбіде', 'жұмада', 'сенбіде'];

      function _lastWeek4(day) {
        var weekday = accusativeWeekdays[day];
        return "'өткен " + weekday + " сағат' p'-де'";
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];
        return "'" + weekday + " сағат' p'-де'";
      }

      function _nextWeek4(day) {
        var weekday = accusativeWeekdays[day];
        return "'келесі " + weekday + " сағат' p'-де'";
      }

      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _lastWeek4(day);
          }
        },
        yesterday: "'кеше сағат' p'-де'",
        today: "'бүгін сағат' p'-де'",
        tomorrow: "'ертең сағат' p'-де'",
        nextWeek: function nextWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _nextWeek4(day);
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 661 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['б.з.д.', 'б.з.'],
        abbreviated: ['б.з.д.', 'б.з.'],
        wide: ['біздің заманымызға дейін', 'біздің заманымыз']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1-ші тоқ.', '2-ші тоқ.', '3-ші тоқ.', '4-ші тоқ.'],
        wide: ['1-ші тоқсан', '2-ші тоқсан', '3-ші тоқсан', '4-ші тоқсан']
      };
      var monthValues = {
        narrow: ['Қ', 'А', 'Н', 'С', 'М', 'М', 'Ш', 'Т', 'Қ', 'Қ', 'Қ', 'Ж'],
        abbreviated: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
        wide: ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан']
      };
      var formattingMonthValues = {
        narrow: ['Қ', 'А', 'Н', 'С', 'М', 'М', 'Ш', 'Т', 'Қ', 'Қ', 'Қ', 'Ж'],
        abbreviated: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
        wide: ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан']
      };
      var dayValues = {
        narrow: ['Ж', 'Д', 'С', 'С', 'Б', 'Ж', 'С'],
        short: ['жс', 'дс', 'сс', 'ср', 'бс', 'жм', 'сб'],
        abbreviated: ['жс', 'дс', 'сс', 'ср', 'бс', 'жм', 'сб'],
        wide: ['жексенбі', 'дүйсенбі', 'сейсенбі', 'сәрсенбі', 'бейсенбі', 'жұма', 'сенбі']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ТД',
          pm: 'ТК',
          midnight: 'түн ортасы',
          noon: 'түс',
          morning: 'таң',
          afternoon: 'күндіз',
          evening: 'кеш',
          night: 'түн'
        },
        wide: {
          am: 'ТД',
          pm: 'ТК',
          midnight: 'түн ортасы',
          noon: 'түс',
          morning: 'таң',
          afternoon: 'күндіз',
          evening: 'кеш',
          night: 'түн'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ТД',
          pm: 'ТК',
          midnight: 'түн ортасында',
          noon: 'түс',
          morning: 'таң',
          afternoon: 'күн',
          evening: 'кеш',
          night: 'түн'
        },
        wide: {
          am: 'ТД',
          pm: 'ТК',
          midnight: 'түн ортасында',
          noon: 'түсте',
          morning: 'таңертең',
          afternoon: 'күндіз',
          evening: 'кеште',
          night: 'түнде'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (unit === 'date') {
          suffix = '-ші';
        } else if (unit === 'week' || unit === 'minute' || unit === 'second') {
          suffix = '-ші';
        } else {
          suffix = '-ші';
        }

        return dirtyNumber + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'any',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 662 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((б )?з\.?\s?д\.?)/i,
        abbreviated: /^((б )?з\.?\s?д\.?)/i,
        wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
      };
      var parseEraPatterns = {
        any: [/^б/i, /^з/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?ші)? тоқ.?/i,
        wide: /^[1234](-?ші)? тоқсан/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
        abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
        wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
      };
      var parseMonthPatterns = {
        narrow: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i],
        abbreviated: [/^қаң/i, /^ақп/i, /^нау/i, /^сәу/i, /^мам/i, /^мау/i, /^шіл/i, /^там/i, /^қыр/i, /^қаз/i, /^қар/i, /^жел/i],
        any: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i]
      };
      var matchDayPatterns = {
        narrow: /^(ж|д|с|с|б|ж|с)/i,
        short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
        wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
      };
      var parseDayPatterns = {
        narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
        short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
        any: [/^ж[ек]/i, /^д[үй]/i, /^сe[й]/i, /^сә[р]/i, /^б[ей]/i, /^ж[ұм]/i, /^се[н]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
        wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
        any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ТД/i,
          pm: /^ТК/i,
          midnight: /^түн орта/i,
          noon: /^күндіз/i,
          morning: /таң/i,
          afternoon: /түс/i,
          evening: /кеш/i,
          night: /түн/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 663 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(664);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(665);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(666);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(667);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(668);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Kannada locale (India).
       * @language Kannada
       * @iso-639-2 kan
       * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
       */


      var locale = {
        code: 'kn',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 664 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            default: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
            future: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
            past: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ'
          },
          other: {
            default: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
            future: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
            past: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ'
          }
        },
        xSeconds: {
          one: {
            default: '1 ಸೆಕೆಂಡ್',
            future: '1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ',
            past: '1 ಸೆಕೆಂಡ್ ಹಿಂದೆ'
          },
          other: {
            default: '{{count}} ಸೆಕೆಂಡುಗಳು',
            future: '{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ',
            past: '{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ'
          }
        },
        halfAMinute: {
          other: {
            default: 'ಅರ್ಧ ನಿಮಿಷ',
            future: 'ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ',
            past: 'ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ'
          }
        },
        lessThanXMinutes: {
          one: {
            default: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
            future: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
            past: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ'
          },
          other: {
            default: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
            future: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
            past: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ'
          }
        },
        xMinutes: {
          one: {
            default: '1 ನಿಮಿಷ',
            future: '1 ನಿಮಿಷದಲ್ಲಿ',
            past: '1 ನಿಮಿಷದ ಹಿಂದೆ'
          },
          other: {
            default: '{{count}} ನಿಮಿಷಗಳು',
            future: '{{count}} ನಿಮಿಷಗಳಲ್ಲಿ',
            past: '{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ'
          }
        },
        aboutXHours: {
          one: {
            default: 'ಸುಮಾರು 1 ಗಂಟೆ',
            future: 'ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ',
            past: 'ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ'
          },
          other: {
            default: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳು',
            future: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ',
            past: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ'
          }
        },
        xHours: {
          one: {
            default: '1 ಗಂಟೆ',
            future: '1 ಗಂಟೆಯಲ್ಲಿ',
            past: '1 ಗಂಟೆ ಹಿಂದೆ'
          },
          other: {
            default: '{{count}} ಗಂಟೆಗಳು',
            future: '{{count}} ಗಂಟೆಗಳಲ್ಲಿ',
            past: '{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ'
          }
        },
        xDays: {
          one: {
            default: '1 ದಿನ',
            future: '1 ದಿನದಲ್ಲಿ',
            past: '1 ದಿನದ ಹಿಂದೆ'
          },
          other: {
            default: '{{count}} ದಿನಗಳು',
            future: '{{count}} ದಿನಗಳಲ್ಲಿ',
            past: '{{count}} ದಿನಗಳ ಹಿಂದೆ'
          }
        },
        aboutXMonths: {
          one: {
            default: 'ಸುಮಾರು 1 ತಿಂಗಳು',
            future: 'ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ',
            past: 'ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ'
          },
          other: {
            default: 'ಸುಮಾರು {{count}} ತಿಂಗಳು',
            future: 'ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ',
            past: 'ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ'
          }
        },
        xMonths: {
          one: {
            default: '1 ತಿಂಗಳು',
            future: '1 ತಿಂಗಳಲ್ಲಿ',
            past: '1 ತಿಂಗಳ ಹಿಂದೆ'
          },
          other: {
            default: '{{count}} ತಿಂಗಳು',
            future: '{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ',
            past: '{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ'
          }
        },
        aboutXYears: {
          one: {
            default: 'ಸುಮಾರು 1 ವರ್ಷ',
            future: 'ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ',
            past: 'ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ'
          },
          other: {
            default: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳು',
            future: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ',
            past: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ'
          }
        },
        xYears: {
          one: {
            default: '1 ವರ್ಷ',
            future: '1 ವರ್ಷದಲ್ಲಿ',
            past: '1 ವರ್ಷದ ಹಿಂದೆ'
          },
          other: {
            default: '{{count}} ವರ್ಷಗಳು',
            future: '{{count}} ವರ್ಷಗಳಲ್ಲಿ',
            past: '{{count}} ವರ್ಷಗಳ ಹಿಂದೆ'
          }
        },
        overXYears: {
          one: {
            default: '1 ವರ್ಷದ ಮೇಲೆ',
            future: '1 ವರ್ಷದ ಮೇಲೆ',
            past: '1 ವರ್ಷದ ಮೇಲೆ'
          },
          other: {
            default: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ',
            future: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ',
            past: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ'
          }
        },
        almostXYears: {
          one: {
            default: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ',
            future: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ',
            past: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ'
          },
          other: {
            default: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ',
            future: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ',
            past: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ'
          }
        }
      };

      function getResultByTense(parentToken, options) {
        if (options.addSuffix) {
          if (options.comparison > 0) {
            return parentToken.future;
          } else {
            return parentToken.past;
          }
        }

        return parentToken.default;
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = getResultByTense(formatDistanceLocale[token].one, options);
        } else {
          result = getResultByTense(formatDistanceLocale[token].other, options);
        }

        return result.replace('{{count}}', count);
      }
      /***/

    },
    /* 665 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2); // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html


      var dateFormats = {
        full: 'EEEE, MMMM d, y',
        // CLDR 1816
        long: 'MMMM d, y',
        // CLDR 1817
        medium: 'MMM d, y',
        // CLDR 1818
        short: 'd/M/yy' // CLDR 1819

      };
      var timeFormats = {
        full: 'hh:mm:ss a zzzz',
        // CLDR 1820
        long: 'hh:mm:ss a z',
        // CLDR 1821
        medium: 'hh:mm:ss a',
        // CLDR 1822
        short: 'hh:mm a' // CLDR 1823

      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        // CLDR 1824
        long: '{{date}} {{time}}',
        // CLDR 1825
        medium: '{{date}} {{time}}',
        // CLDR 1826
        short: '{{date}} {{time}}' // CLDR 1827

      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 666 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
        yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
        today: "'ಇಂದು' p 'ಕ್ಕೆ'",
        tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
        nextWeek: "eeee p 'ಕ್ಕೆ'",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 667 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3); // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html


      var eraValues = {
        narrow: ['ಕ್ರಿ.ಪೂ', 'ಕ್ರಿ.ಶ'],
        abbreviated: ['ಕ್ರಿ.ಪೂ', 'ಕ್ರಿ.ಶ'],
        // CLDR #1618, #1620
        wide: ['ಕ್ರಿಸ್ತ ಪೂರ್ವ', 'ಕ್ರಿಸ್ತ ಶಕ'] // CLDR #1614, #1616

      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['ತ್ರೈ 1', 'ತ್ರೈ 2', 'ತ್ರೈ 3', 'ತ್ರೈ 4'],
        // CLDR #1630 - #1638
        wide: ['1ನೇ ತ್ರೈಮಾಸಿಕ', '2ನೇ ತ್ರೈಮಾಸಿಕ', '3ನೇ ತ್ರೈಮಾಸಿಕ', '4ನೇ ತ್ರೈಮಾಸಿಕ'] // CLDR #1622 - #1629
        // CLDR #1646 - #1717

      };
      var monthValues = {
        narrow: ['ಜ', 'ಫೆ', 'ಮಾ', 'ಏ', 'ಮೇ', 'ಜೂ', 'ಜು', 'ಆ', 'ಸೆ', 'ಅ', 'ನ', 'ಡಿ'],
        abbreviated: ['ಜನ', 'ಫೆಬ್ರ', 'ಮಾರ್ಚ್', 'ಏಪ್ರಿ', 'ಮೇ', 'ಜೂನ್', 'ಜುಲೈ', 'ಆಗ', 'ಸೆಪ್ಟೆಂ', 'ಅಕ್ಟೋ', 'ನವೆಂ', 'ಡಿಸೆಂ'],
        wide: ['ಜನವರಿ', 'ಫೆಬ್ರವರಿ', 'ಮಾರ್ಚ್', 'ಏಪ್ರಿಲ್', 'ಮೇ', 'ಜೂನ್', 'ಜುಲೈ', 'ಆಗಸ್ಟ್', 'ಸೆಪ್ಟೆಂಬರ್', 'ಅಕ್ಟೋಬರ್', 'ನವೆಂಬರ್', 'ಡಿಸೆಂಬರ್'] // CLDR #1718 - #1773

      };
      var dayValues = {
        narrow: ['ಭಾ', 'ಸೋ', 'ಮಂ', 'ಬು', 'ಗು', 'ಶು', 'ಶ'],
        short: ['ಭಾನು', 'ಸೋಮ', 'ಮಂಗಳ', 'ಬುಧ', 'ಗುರು', 'ಶುಕ್ರ', 'ಶನಿ'],
        abbreviated: ['ಭಾನು', 'ಸೋಮ', 'ಮಂಗಳ', 'ಬುಧ', 'ಗುರು', 'ಶುಕ್ರ', 'ಶನಿ'],
        wide: ['ಭಾನುವಾರ', 'ಸೋಮವಾರ', 'ಮಂಗಳವಾರ', 'ಬುಧವಾರ', 'ಗುರುವಾರ', 'ಶುಕ್ರವಾರ', 'ಶನಿವಾರ'] // CLDR #1774 - #1815

      };
      var dayPeriodValues = {
        narrow: {
          am: 'ಪೂರ್ವಾಹ್ನ',
          pm: 'ಅಪರಾಹ್ನ',
          midnight: 'ಮಧ್ಯರಾತ್ರಿ',
          noon: 'ಮಧ್ಯಾಹ್ನ',
          morning: 'ಬೆಳಗ್ಗೆ',
          afternoon: 'ಮಧ್ಯಾಹ್ನ',
          evening: 'ಸಂಜೆ',
          night: 'ರಾತ್ರಿ'
        },
        abbreviated: {
          am: 'ಪೂರ್ವಾಹ್ನ',
          pm: 'ಅಪರಾಹ್ನ',
          midnight: 'ಮಧ್ಯರಾತ್ರಿ',
          noon: 'ಮಧ್ಯಾನ್ಹ',
          morning: 'ಬೆಳಗ್ಗೆ',
          afternoon: 'ಮಧ್ಯಾನ್ಹ',
          evening: 'ಸಂಜೆ',
          night: 'ರಾತ್ರಿ'
        },
        wide: {
          am: 'ಪೂರ್ವಾಹ್ನ',
          pm: 'ಅಪರಾಹ್ನ',
          midnight: 'ಮಧ್ಯರಾತ್ರಿ',
          noon: 'ಮಧ್ಯಾನ್ಹ',
          morning: 'ಬೆಳಗ್ಗೆ',
          afternoon: 'ಮಧ್ಯಾನ್ಹ',
          evening: 'ಸಂಜೆ',
          night: 'ರಾತ್ರಿ'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ಪೂ',
          pm: 'ಅ',
          midnight: 'ಮಧ್ಯರಾತ್ರಿ',
          noon: 'ಮಧ್ಯಾನ್ಹ',
          morning: 'ಬೆಳಗ್ಗೆ',
          afternoon: 'ಮಧ್ಯಾನ್ಹ',
          evening: 'ಸಂಜೆ',
          night: 'ರಾತ್ರಿ'
        },
        abbreviated: {
          am: 'ಪೂರ್ವಾಹ್ನ',
          pm: 'ಅಪರಾಹ್ನ',
          midnight: 'ಮಧ್ಯ ರಾತ್ರಿ',
          noon: 'ಮಧ್ಯಾನ್ಹ',
          morning: 'ಬೆಳಗ್ಗೆ',
          afternoon: 'ಮಧ್ಯಾನ್ಹ',
          evening: 'ಸಂಜೆ',
          night: 'ರಾತ್ರಿ'
        },
        wide: {
          am: 'ಪೂರ್ವಾಹ್ನ',
          pm: 'ಅಪರಾಹ್ನ',
          midnight: 'ಮಧ್ಯ ರಾತ್ರಿ',
          noon: 'ಮಧ್ಯಾನ್ಹ',
          morning: 'ಬೆಳಗ್ಗೆ',
          afternoon: 'ಮಧ್ಯಾನ್ಹ',
          evening: 'ಸಂಜೆ',
          night: 'ರಾತ್ರಿ'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + 'ನೇ';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 668 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
        abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
        wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
      };
      var parseEraPatterns = {
        any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
        wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
        abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
        wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ಜ$/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂ/i, /^ಜು$/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i],
        any: [/^ಜನ/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂನ್/i, /^ಜುಲೈ/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i]
      };
      var matchDayPatterns = {
        narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
        short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
        abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
        wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
      };
      var parseDayPatterns = {
        narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
        any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
        any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ಪೂ/i,
          pm: /^ಅ/i,
          midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
          noon: /ಮಧ್ಯಾನ್ಹ/i,
          morning: /ಬೆಳಗ್ಗೆ/i,
          afternoon: /ಮಧ್ಯಾನ್ಹ/i,
          evening: /ಸಂಜೆ/i,
          night: /ರಾತ್ರಿ/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 669 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(670);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(671);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(672);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(673);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(674);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Korean locale.
       * @language Korean
       * @iso-639-2 kor
       * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
       * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
       * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
       */


      var locale = {
        code: 'ko',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 670 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: '1초 미만',
          other: '{{count}}초 미만'
        },
        xSeconds: {
          one: '1초',
          other: '{{count}}초'
        },
        halfAMinute: '30초',
        lessThanXMinutes: {
          one: '1분 미만',
          other: '{{count}}분 미만'
        },
        xMinutes: {
          one: '1분',
          other: '{{count}}분'
        },
        aboutXHours: {
          one: '약 1시간',
          other: '약 {{count}}시간'
        },
        xHours: {
          one: '1시간',
          other: '{{count}}시간'
        },
        xDays: {
          one: '1일',
          other: '{{count}}일'
        },
        aboutXWeeks: {
          one: '약 1주',
          other: '약 {{count}}주'
        },
        xWeeks: {
          one: '1주',
          other: '{{count}}주'
        },
        aboutXMonths: {
          one: '약 1개월',
          other: '약 {{count}}개월'
        },
        xMonths: {
          one: '1개월',
          other: '{{count}}개월'
        },
        aboutXYears: {
          one: '약 1년',
          other: '약 {{count}}년'
        },
        xYears: {
          one: '1년',
          other: '{{count}}년'
        },
        overXYears: {
          one: '1년 이상',
          other: '{{count}}년 이상'
        },
        almostXYears: {
          one: '거의 1년',
          other: '거의 {{count}}년'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + ' 후';
          } else {
            return result + ' 전';
          }
        }

        return result;
      }
      /***/

    },
    /* 671 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'y년 M월 d일 EEEE',
        long: 'y년 M월 d일',
        medium: 'y.MM.dd',
        short: 'y.MM.dd'
      };
      var timeFormats = {
        full: 'a H시 mm분 ss초 zzzz',
        long: 'a H:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 672 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'지난' eeee p",
        yesterday: "'어제' p",
        today: "'오늘' p",
        tomorrow: "'내일' p",
        nextWeek: "'다음' eeee p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 673 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['BC', 'AD'],
        abbreviated: ['BC', 'AD'],
        wide: ['기원전', '서기']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1분기', '2분기', '3분기', '4분기']
      };
      var monthValues = {
        narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        abbreviated: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
        wide: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
      };
      var dayValues = {
        narrow: ['일', '월', '화', '수', '목', '금', '토'],
        short: ['일', '월', '화', '수', '목', '금', '토'],
        abbreviated: ['일', '월', '화', '수', '목', '금', '토'],
        wide: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
      };
      var dayPeriodValues = {
        narrow: {
          am: '오전',
          pm: '오후',
          midnight: '자정',
          noon: '정오',
          morning: '아침',
          afternoon: '오후',
          evening: '저녁',
          night: '밤'
        },
        abbreviated: {
          am: '오전',
          pm: '오후',
          midnight: '자정',
          noon: '정오',
          morning: '아침',
          afternoon: '오후',
          evening: '저녁',
          night: '밤'
        },
        wide: {
          am: '오전',
          pm: '오후',
          midnight: '자정',
          noon: '정오',
          morning: '아침',
          afternoon: '오후',
          evening: '저녁',
          night: '밤'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: '오전',
          pm: '오후',
          midnight: '자정',
          noon: '정오',
          morning: '아침',
          afternoon: '오후',
          evening: '저녁',
          night: '밤'
        },
        abbreviated: {
          am: '오전',
          pm: '오후',
          midnight: '자정',
          noon: '정오',
          morning: '아침',
          afternoon: '오후',
          evening: '저녁',
          night: '밤'
        },
        wide: {
          am: '오전',
          pm: '오후',
          midnight: '자정',
          noon: '정오',
          morning: '아침',
          afternoon: '오후',
          evening: '저녁',
          night: '밤'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);

        switch (unit) {
          case 'minute':
          case 'second':
            return number;

          case 'date':
            return number + '일';

          default:
            return number + '번째';
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 674 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
        wide: /^(기원전|서기)/i
      };
      var parseEraPatterns = {
        any: [/^(bc|기원전)/i, /^(ad|서기)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234]사?분기/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(1[012]|[123456789])/,
        abbreviated: /^(1[012]|[123456789])월/i,
        wide: /^(1[012]|[123456789])월/i
      };
      var parseMonthPatterns = {
        any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
      };
      var matchDayPatterns = {
        narrow: /^[일월화수목금토]/,
        short: /^[일월화수목금토]/,
        abbreviated: /^[일월화수목금토]/,
        wide: /^[일월화수목금토]요일/
      };
      var parseDayPatterns = {
        any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^(am|오전)/i,
          pm: /^(pm|오후)/i,
          midnight: /^자정/i,
          noon: /^정오/i,
          morning: /^아침/i,
          afternoon: /^오후/i,
          evening: /^저녁/i,
          night: /^밤/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 675 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(676);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(677);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(678);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(679);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(680);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Luxembourgish locale.
       * @language Luxembourgish
       * @iso-639-2 ltz
       * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
       */


      var locale = {
        code: 'lb',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 676 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          standalone: {
            one: 'manner wéi eng Sekonn',
            other: 'manner wéi {{count}} Sekonnen'
          },
          withPreposition: {
            one: 'manner wéi enger Sekonn',
            other: 'manner wéi {{count}} Sekonnen'
          }
        },
        xSeconds: {
          standalone: {
            one: 'eng Sekonn',
            other: '{{count}} Sekonnen'
          },
          withPreposition: {
            one: 'enger Sekonn',
            other: '{{count}} Sekonnen'
          }
        },
        halfAMinute: {
          standalone: 'eng hallef Minutt',
          withPreposition: 'enger hallwer Minutt'
        },
        lessThanXMinutes: {
          standalone: {
            one: 'manner wéi eng Minutt',
            other: 'manner wéi {{count}} Minutten'
          },
          withPreposition: {
            one: 'manner wéi enger Minutt',
            other: 'manner wéi {{count}} Minutten'
          }
        },
        xMinutes: {
          standalone: {
            one: 'eng Minutt',
            other: '{{count}} Minutten'
          },
          withPreposition: {
            one: 'enger Minutt',
            other: '{{count}} Minutten'
          }
        },
        aboutXHours: {
          standalone: {
            one: 'ongeféier eng Stonn',
            other: 'ongeféier {{count}} Stonnen'
          },
          withPreposition: {
            one: 'ongeféier enger Stonn',
            other: 'ongeféier {{count}} Stonnen'
          }
        },
        xHours: {
          standalone: {
            one: 'eng Stonn',
            other: '{{count}} Stonnen'
          },
          withPreposition: {
            one: 'enger Stonn',
            other: '{{count}} Stonnen'
          }
        },
        xDays: {
          standalone: {
            one: 'een Dag',
            other: '{{count}} Deeg'
          },
          withPreposition: {
            one: 'engem Dag',
            other: '{{count}} Deeg'
          }
        },
        aboutXWeeks: {
          standalone: {
            one: 'ongeféier eng Woch',
            other: 'ongeféier {{count}} Wochen'
          },
          withPreposition: {
            one: 'ongeféier enger Woche',
            other: 'ongeféier {{count}} Wochen'
          }
        },
        xWeeks: {
          standalone: {
            one: 'eng Woch',
            other: '{{count}} Wochen'
          },
          withPreposition: {
            one: 'enger Woch',
            other: '{{count}} Wochen'
          }
        },
        aboutXMonths: {
          standalone: {
            one: 'ongeféier ee Mount',
            other: 'ongeféier {{count}} Méint'
          },
          withPreposition: {
            one: 'ongeféier engem Mount',
            other: 'ongeféier {{count}} Méint'
          }
        },
        xMonths: {
          standalone: {
            one: 'ee Mount',
            other: '{{count}} Méint'
          },
          withPreposition: {
            one: 'engem Mount',
            other: '{{count}} Méint'
          }
        },
        aboutXYears: {
          standalone: {
            one: 'ongeféier ee Joer',
            other: 'ongeféier {{count}} Joer'
          },
          withPreposition: {
            one: 'ongeféier engem Joer',
            other: 'ongeféier {{count}} Joer'
          }
        },
        xYears: {
          standalone: {
            one: 'ee Joer',
            other: '{{count}} Joer'
          },
          withPreposition: {
            one: 'engem Joer',
            other: '{{count}} Joer'
          }
        },
        overXYears: {
          standalone: {
            one: 'méi wéi ee Joer',
            other: 'méi wéi {{count}} Joer'
          },
          withPreposition: {
            one: 'méi wéi engem Joer',
            other: 'méi wéi {{count}} Joer'
          }
        },
        almostXYears: {
          standalone: {
            one: 'bal ee Joer',
            other: 'bal {{count}} Joer'
          },
          withPreposition: {
            one: 'bal engem Joer',
            other: 'bal {{count}} Joer'
          }
        }
      };
      var EXCEPTION_CONSONANTS = ['d', 'h', 'n', 't', 'z'];
      var VOWELS = ['a,', 'e', 'i', 'o', 'u'];
      var DIGITS_SPOKEN_N_NEEDED = [0, 1, 2, 3, 8, 9];
      var FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [40, 50, 60, 70]; // Eifeler Regel

      function isFinalNNeeded(nextWords) {
        var firstLetter = nextWords.charAt(0).toLowerCase();

        if (VOWELS.indexOf(firstLetter) != -1 || EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) {
          return true;
        } // Numbers would need to converted into words for checking.
        // Therefore, I have listed the digits that require a preceeding n with a few exceptions.


        var firstWord = nextWords.split(' ')[0];
        var number = parseInt(firstWord);

        if (!isNaN(number) && DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) {
          return true;
        } // Omit other checks as they are not expected here.


        return false;
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
        var result;

        if (typeof usageGroup === 'string') {
          result = usageGroup;
        } else if (count === 1) {
          result = usageGroup.one;
        } else {
          result = usageGroup.other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'a' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
          } else {
            return 'viru' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 677 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2); // DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008


      var dateFormats = {
        full: 'EEEE, do MMMM y',
        // Méindeg, 7. Januar 2018
        long: 'do MMMM y',
        // 7. Januar 2018
        medium: 'do MMM y',
        // 7. Jan 2018
        short: 'dd.MM.yy' // 07.01.18

      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'um' {{time}}",
        long: "{{date}} 'um' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 678 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function lastWeek(date) {
          var day = date.getUTCDay();
          var result = "'läschte";

          if (day === 2 || day === 4) {
            // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
            result += 'n';
          }

          result += "' eeee 'um' p";
          return result;
        },
        yesterday: "'gëschter um' p",
        today: "'haut um' p",
        tomorrow: "'moien um' p",
        nextWeek: "eeee 'um' p",
        other: 'P'
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date);
        }

        return format;
      }
      /***/

    },
    /* 679 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['v.Chr.', 'n.Chr.'],
        abbreviated: ['v.Chr.', 'n.Chr.'],
        wide: ['viru Christus', 'no Christus']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Jan', 'Feb', 'Mäe', 'Abr', 'Mee', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
        wide: ['Januar', 'Februar', 'Mäerz', 'Abrëll', 'Mee', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
      };
      var dayValues = {
        narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
        short: ['So', 'Mé', 'Dë', 'Më', 'Do', 'Fr', 'Sa'],
        abbreviated: ['So.', 'Mé.', 'Dë.', 'Më.', 'Do.', 'Fr.', 'Sa.'],
        wide: ['Sonndeg', 'Méindeg', 'Dënschdeg', 'Mëttwoch', 'Donneschdeg', 'Freideg', 'Samschdeg']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'mo.',
          pm: 'nomë.',
          midnight: 'Mëtternuecht',
          noon: 'Mëtteg',
          morning: 'Moien',
          afternoon: 'Nomëtteg',
          evening: 'Owend',
          night: 'Nuecht'
        },
        abbreviated: {
          am: 'moies',
          pm: 'nomëttes',
          midnight: 'Mëtternuecht',
          noon: 'Mëtteg',
          morning: 'Moien',
          afternoon: 'Nomëtteg',
          evening: 'Owend',
          night: 'Nuecht'
        },
        wide: {
          am: 'moies',
          pm: 'nomëttes',
          midnight: 'Mëtternuecht',
          noon: 'Mëtteg',
          morning: 'Moien',
          afternoon: 'Nomëtteg',
          evening: 'Owend',
          night: 'Nuecht'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'mo.',
          pm: 'nom.',
          midnight: 'Mëtternuecht',
          noon: 'mëttes',
          morning: 'moies',
          afternoon: 'nomëttes',
          evening: 'owes',
          night: 'nuets'
        },
        abbreviated: {
          am: 'moies',
          pm: 'nomëttes',
          midnight: 'Mëtternuecht',
          noon: 'mëttes',
          morning: 'moies',
          afternoon: 'nomëttes',
          evening: 'owes',
          night: 'nuets'
        },
        wide: {
          am: 'moies',
          pm: 'nomëttes',
          midnight: 'Mëtternuecht',
          noon: 'mëttes',
          morning: 'moies',
          afternoon: 'nomëttes',
          evening: 'owes',
          night: 'nuets'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 680 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
        abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
        wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
      };
      var parseEraPatterns = {
        any: [/^v/i, /^n/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](\.)? Quartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
        wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mä/i, /^ab/i, /^me/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smdf]/i,
        short: /^(so|mé|dë|më|do|fr|sa)/i,
        abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
        wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
      };
      var parseDayPatterns = {
        any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
        abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
        wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^m/i,
          pm: /^n/i,
          midnight: /^Mëtter/i,
          noon: /^mëttes/i,
          morning: /moies/i,
          afternoon: /nomëttes/i,
          // will never be matched. Afternoon is matched by `pm`
          evening: /owes/i,
          night: /nuets/i // will never be matched. Night is matched by `pm`

        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 681 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(682);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(683);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(684);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(685);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(686);
      /**
       * @type {Locale}
       * @category Locales
       *
       * @summary Lithuanian locale.
       * @language Lithuanian
       *
       * @iso-639-2 lit
       *
       * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
       * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
       */


      var locale = {
        code: 'lt',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 682 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: translateSeconds,
          other: translate
        },
        xSeconds: {
          one: translateSeconds,
          other: translate
        },
        halfAMinute: 'pusė minutės',
        lessThanXMinutes: {
          one: translateSingular,
          other: translate
        },
        xMinutes: {
          one: translateSingular,
          other: translate
        },
        aboutXHours: {
          one: translateSingular,
          other: translate
        },
        xHours: {
          one: translateSingular,
          other: translate
        },
        xDays: {
          one: translateSingular,
          other: translate
        },
        aboutWeeks: {
          one: translateSingular,
          other: translate
        },
        xWeeks: {
          one: translateSingular,
          other: translate
        },
        aboutXMonths: {
          one: translateSingular,
          other: translate
        },
        xMonths: {
          one: translateSingular,
          other: translate
        },
        aboutXYears: {
          one: translateSingular,
          other: translate
        },
        xYears: {
          one: translateSingular,
          other: translate
        },
        overXYears: {
          one: translateSingular,
          other: translate
        },
        almostXYears: {
          one: translateSingular,
          other: translate
        }
      };
      var translations = {
        xseconds_other: 'sekundė_sekundžių_sekundes',
        xminutes_one: 'minutė_minutės_minutę',
        xminutes_other: 'minutės_minučių_minutes',
        xhours_one: 'valanda_valandos_valandą',
        xhours_other: 'valandos_valandų_valandas',
        xdays_one: 'diena_dienos_dieną',
        xdays_other: 'dienos_dienų_dienas',
        xweeks_one: 'savaitė_savaitės_savaitę',
        xweeks_other: 'savaitės_savaičių_savaites',
        xmonths_one: 'mėnuo_mėnesio_mėnesį',
        xmonths_other: 'mėnesiai_mėnesių_mėnesius',
        xyears_one: 'metai_metų_metus',
        xyears_other: 'metai_metų_metus',
        about: 'apie',
        over: 'daugiau nei',
        almost: 'beveik',
        lessthan: 'mažiau nei'
      };

      function translateSeconds(number, addSuffix, key, isFuture) {
        if (!addSuffix) {
          return 'kelios sekundės';
        } else {
          return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
      }

      function translateSingular(number, addSuffix, key, isFuture) {
        return !addSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
      }

      function special(number) {
        return number % 10 === 0 || number > 10 && number < 20;
      }

      function forms(key) {
        return translations[key].split('_');
      }

      function translate(number, addSuffix, key, isFuture) {
        var result = number + ' ';

        if (number === 1) {
          return result + translateSingular(number, addSuffix, key[0], isFuture);
        } else if (!addSuffix) {
          return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
          if (isFuture) {
            return result + forms(key)[1];
          } else {
            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
          }
        }
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var adverb = token.match(/about|over|almost|lessthan/i);
        var unit = token.replace(adverb, '');
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one(count, options.addSuffix, unit.toLowerCase() + '_one');
        } else {
          result = formatDistanceLocale[token].other(count, options.addSuffix, unit.toLowerCase() + '_other');
        }

        if (adverb) {
          result = translations[adverb[0].toLowerCase()] + ' ' + result;
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'po ' + result;
          } else {
            return 'prieš ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 683 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "y 'm'. MMMM d 'd'., EEEE",
        long: "y 'm'. MMMM d 'd'.",
        medium: 'y-MM-dd',
        short: 'y-MM-dd'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 684 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'Praėjusį' eeee p",
        yesterday: "'Vakar' p",
        today: "'Šiandien' p",
        tomorrow: "'Rytoj' p",
        nextWeek: 'eeee p',
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 685 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['pr. Kr.', 'po Kr.'],
        abbreviated: ['pr. Kr.', 'po Kr.'],
        wide: ['prieš Kristų', 'po Kristaus']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['I ketv.', 'II ketv.', 'III ketv.', 'IV ketv.'],
        wide: ['I ketvirtis', 'II ketvirtis', 'III ketvirtis', 'IV ketvirtis']
      };
      var formattingQuarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['I k.', 'II k.', 'III k.', 'IV k.'],
        wide: ['I ketvirtis', 'II ketvirtis', 'III ketvirtis', 'IV ketvirtis']
      };
      var monthValues = {
        narrow: ['S', 'V', 'K', 'B', 'G', 'B', 'L', 'R', 'R', 'S', 'L', 'G'],
        abbreviated: ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.', 'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
        wide: ['sausis', 'vasaris', 'kovas', 'balandis', 'gegužė', 'birželis', 'liepa', 'rugpjūtis', 'rugsėjis', 'spalis', 'lapkritis', 'gruodis']
      };
      var formattingMonthValues = {
        narrow: ['S', 'V', 'K', 'B', 'G', 'B', 'L', 'R', 'R', 'S', 'L', 'G'],
        abbreviated: ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.', 'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
        wide: ['sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio', 'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio']
      };
      var dayValues = {
        narrow: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],
        short: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
        abbreviated: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
        wide: ['sekmadienis', 'pirmadienis', 'antradienis', 'trečiadienis', 'ketvirtadienis', 'penktadienis', 'šeštadienis']
      };
      var formattingDayValues = {
        narrow: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],
        short: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
        abbreviated: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
        wide: ['sekmadienį', 'pirmadienį', 'antradienį', 'trečiadienį', 'ketvirtadienį', 'penktadienį', 'šeštadienį']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'pr. p.',
          pm: 'pop.',
          midnight: 'vidurnaktis',
          noon: 'vidurdienis',
          morning: 'rytas',
          afternoon: 'diena',
          evening: 'vakaras',
          night: 'naktis'
        },
        abbreviated: {
          am: 'priešpiet',
          pm: 'popiet',
          midnight: 'vidurnaktis',
          noon: 'vidurdienis',
          morning: 'rytas',
          afternoon: 'diena',
          evening: 'vakaras',
          night: 'naktis'
        },
        wide: {
          am: 'priešpiet',
          pm: 'popiet',
          midnight: 'vidurnaktis',
          noon: 'vidurdienis',
          morning: 'rytas',
          afternoon: 'diena',
          evening: 'vakaras',
          night: 'naktis'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'pr. p.',
          pm: 'pop.',
          midnight: 'vidurnaktis',
          noon: 'perpiet',
          morning: 'rytas',
          afternoon: 'popietė',
          evening: 'vakaras',
          night: 'naktis'
        },
        abbreviated: {
          am: 'priešpiet',
          pm: 'popiet',
          midnight: 'vidurnaktis',
          noon: 'perpiet',
          morning: 'rytas',
          afternoon: 'popietė',
          evening: 'vakaras',
          night: 'naktis'
        },
        wide: {
          am: 'priešpiet',
          pm: 'popiet',
          midnight: 'vidurnaktis',
          noon: 'perpiet',
          morning: 'rytas',
          afternoon: 'popietė',
          evening: 'vakaras',
          night: 'naktis'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + '-oji';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          formattingValues: formattingQuarterValues,
          defaultFormattingWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayValues,
          defaultFormattingWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 686 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
        abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
        wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
      };
      var parseEraPatterns = {
        wide: [/prieš/i, /(po|mūsų)/i],
        any: [/^pr/i, /^(po|m)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^([1234])/i,
        abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
        wide: /^(I|II|III|IV)\s?ketvirtis/i
      };
      var parseQuarterPatterns = {
        narrow: [/1/i, /2/i, /3/i, /4/i],
        any: [/I$/i, /II$/i, /III/i, /IV/i]
      };
      var matchMonthPatterns = {
        narrow: /^[svkbglr]/i,
        abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
        wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
      };
      var parseMonthPatterns = {
        narrow: [/^s/i, /^v/i, /^k/i, /^b/i, /^g/i, /^b/i, /^l/i, /^r/i, /^r/i, /^s/i, /^l/i, /^g/i],
        any: [/^saus/i, /^vas/i, /^kov/i, /^bal/i, /^geg/i, /^birž/i, /^liep/i, /^rugp/i, /^rugs/i, /^spal/i, /^lapkr/i, /^gruod/i]
      };
      var matchDayPatterns = {
        narrow: /^[spatkš]/i,
        short: /^(sk|pr|an|tr|kt|pn|št)/i,
        abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
        wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
        wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
        any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
        any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
      };
      var parseDayPeriodPatterns = {
        narrow: {
          am: /^pr/i,
          pm: /^pop./i,
          midnight: /^vidurnaktis/i,
          noon: /^(vidurdienis|perp)/i,
          morning: /rytas/i,
          afternoon: /(die|popietė)/i,
          evening: /vakaras/i,
          night: /naktis/i
        },
        any: {
          am: /^pr/i,
          pm: /^popiet$/i,
          midnight: /^vidurnaktis/i,
          noon: /^(vidurdienis|perp)/i,
          morning: /rytas/i,
          afternoon: /(die|popietė)/i,
          evening: /vakaras/i,
          night: /naktis/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 687 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(688);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(689);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(690);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(691);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(692);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Latvian locale (Latvia).
       * @language Latvian
       * @iso-639-2 lav
       * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
       */


      var locale = {
        code: 'lv',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 688 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;

      function buildLocalizeTokenFn(schema) {
        return function (count, options) {
          if (count === 1) {
            if (options.addSuffix) {
              return schema.one[0].replace('{{time}}', schema.one[2]);
            } else {
              return schema.one[0].replace('{{time}}', schema.one[1]);
            }
          } else {
            var rem = count % 10 === 1 && count % 100 !== 11;

            if (options.addSuffix) {
              return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', count);
            } else {
              return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', count);
            }
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          one: ['mazāk par {{time}}', 'sekundi', 'sekundi'],
          other: ['mazāk nekā {{count}} {{time}}', 'sekunde', 'sekundes', 'sekundes', 'sekundēm']
        }),
        xSeconds: buildLocalizeTokenFn({
          one: ['1 {{time}}', 'sekunde', 'sekundes'],
          other: ['{{count}} {{time}}', 'sekunde', 'sekundes', 'sekundes', 'sekundēm']
        }),
        halfAMinute: function halfAMinute(count, options) {
          if (options.addSuffix) {
            return 'pusminūtes';
          } else {
            return 'pusminūte';
          }
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          one: ['mazāk par {{time}}', 'minūti', 'minūti'],
          other: ['mazāk nekā {{count}} {{time}}', 'minūte', 'minūtes', 'minūtes', 'minūtēm']
        }),
        xMinutes: buildLocalizeTokenFn({
          one: ['1 {{time}}', 'minūte', 'minūtes'],
          other: ['{{count}} {{time}}', 'minūte', 'minūtes', 'minūtes', 'minūtēm']
        }),
        aboutXHours: buildLocalizeTokenFn({
          one: ['apmēram 1 {{time}}', 'stunda', 'stundas'],
          other: ['apmēram {{count}} {{time}}', 'stunda', 'stundas', 'stundas', 'stundām']
        }),
        xHours: buildLocalizeTokenFn({
          one: ['1 {{time}}', 'stunda', 'stundas'],
          other: ['{{count}} {{time}}', 'stunda', 'stundas', 'stundas', 'stundām']
        }),
        xDays: buildLocalizeTokenFn({
          one: ['1 {{time}}', 'diena', 'dienas'],
          other: ['{{count}} {{time}}', 'diena', 'dienas', 'dienas', 'dienām']
        }),
        aboutXWeeks: buildLocalizeTokenFn({
          one: ['apmēram 1 {{time}}', 'nedēļa', 'nedēļas'],
          other: ['apmēram {{count}} {{time}}', 'nedēļa', 'nedēļu', 'nedēļas', 'nedēļām']
        }),
        xWeeks: buildLocalizeTokenFn({
          one: ['1 {{time}}', 'nedēļa', 'nedēļas'],
          other: ['{{count}} {{time}}', // TODO
          'nedēļa', 'nedēļu', 'nedēļas', 'nedēļām']
        }),
        aboutXMonths: buildLocalizeTokenFn({
          one: ['apmēram 1 {{time}}', 'mēnesis', 'mēneša'],
          other: ['apmēram {{count}} {{time}}', 'mēnesis', 'mēneši', 'mēneša', 'mēnešiem']
        }),
        xMonths: buildLocalizeTokenFn({
          one: ['1 {{time}}', 'mēnesis', 'mēneša'],
          other: ['{{count}} {{time}}', 'mēnesis', 'mēneši', 'mēneša', 'mēnešiem']
        }),
        aboutXYears: buildLocalizeTokenFn({
          one: ['apmēram 1 {{time}}', 'gads', 'gada'],
          other: ['apmēram {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
        }),
        xYears: buildLocalizeTokenFn({
          one: ['1 {{time}}', 'gads', 'gada'],
          other: ['{{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
        }),
        overXYears: buildLocalizeTokenFn({
          one: ['ilgāk par 1 {{time}}', 'gadu', 'gadu'],
          other: ['vairāk nekā {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
        }),
        almostXYears: buildLocalizeTokenFn({
          one: ['gandrīz 1 {{time}}', 'gads', 'gada'],
          other: ['vairāk nekā {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result = formatDistanceLocale[token](count, options);

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'pēc ' + result;
          } else {
            return 'pirms ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 689 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "y. 'gada' M. MMMM., EEEE",
        long: "y. 'gada' M. MMMM",
        medium: 'dd.MM.y.',
        short: 'dd.MM.y.'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'plkst.' {{time}}",
        long: "{{date}} 'plkst.' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 690 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13);

      var weekdays = ['svētdienā', 'pirmdienā', 'otrdienā', 'trešdienā', 'ceturtdienā', 'piektdienā', 'sestdienā'];
      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, baseDate, options) {
          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return "eeee 'plkst.' p";
          }

          var weekday = weekdays[date.getUTCDay()];
          return "'Pagājušā " + weekday + " plkst.' p";
        },
        yesterday: "'Vakar plkst.' p",
        today: "'Šodien plkst.' p",
        tomorrow: "'Rīt plkst.' p",
        nextWeek: function nextWeek(date, baseDate, options) {
          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return "eeee 'plkst.' p";
          }

          var weekday = weekdays[date.getUTCDay()];
          return "'Nākamajā " + weekday + " plkst.' p";
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 691 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['p.m.ē', 'm.ē'],
        abbreviated: ['p. m. ē.', 'm. ē.'],
        wide: ['pirms mūsu ēras', 'mūsu ērā']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1. cet.', '2. cet.', '3. cet.', '4. cet.'],
        wide: ['pirmais ceturksnis', 'otrais ceturksnis', 'trešais ceturksnis', 'ceturtais ceturksnis']
      };
      var formattingQuarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1. cet.', '2. cet.', '3. cet.', '4. cet.'],
        wide: ['pirmajā ceturksnī', 'otrajā ceturksnī', 'trešajā ceturksnī', 'ceturtajā ceturksnī']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['janv.', 'febr.', 'marts', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
        wide: ['janvāris', 'februāris', 'marts', 'aprīlis', 'maijs', 'jūnijs', 'jūlijs', 'augusts', 'septembris', 'oktobris', 'novembris', 'decembris']
      };
      var formattingMonthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['janv.', 'febr.', 'martā', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
        wide: ['janvārī', 'februārī', 'martā', 'aprīlī', 'maijā', 'jūnijā', 'jūlijā', 'augustā', 'septembrī', 'oktobrī', 'novembrī', 'decembrī']
      };
      var dayValues = {
        narrow: ['S', 'P', 'O', 'T', 'C', 'P', 'S'],
        short: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
        abbreviated: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
        wide: ['svētdiena', 'pirmdiena', 'otrdiena', 'trešdiena', 'ceturtdiena', 'piektdiena', 'sestdiena']
      };
      var formattingDayValues = {
        narrow: ['S', 'P', 'O', 'T', 'C', 'P', 'S'],
        short: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
        abbreviated: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
        wide: ['svētdienā', 'pirmdienā', 'otrdienā', 'trešdienā', 'ceturtdienā', 'piektdienā', 'sestdienā']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'am',
          pm: 'pm',
          midnight: 'pusn.',
          noon: 'pusd.',
          morning: 'rīts',
          afternoon: 'diena',
          evening: 'vakars',
          night: 'nakts'
        },
        abbreviated: {
          am: 'am',
          pm: 'pm',
          midnight: 'pusn.',
          noon: 'pusd.',
          morning: 'rīts',
          afternoon: 'pēcpusd.',
          evening: 'vakars',
          night: 'nakts'
        },
        wide: {
          am: 'am',
          pm: 'pm',
          midnight: 'pusnakts',
          noon: 'pusdienlaiks',
          morning: 'rīts',
          afternoon: 'pēcpusdiena',
          evening: 'vakars',
          night: 'nakts'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'am',
          pm: 'pm',
          midnight: 'pusn.',
          noon: 'pusd.',
          morning: 'rītā',
          afternoon: 'dienā',
          evening: 'vakarā',
          night: 'naktī'
        },
        abbreviated: {
          am: 'am',
          pm: 'pm',
          midnight: 'pusn.',
          noon: 'pusd.',
          morning: 'rītā',
          afternoon: 'pēcpusd.',
          evening: 'vakarā',
          night: 'naktī'
        },
        wide: {
          am: 'am',
          pm: 'pm',
          midnight: 'pusnaktī',
          noon: 'pusdienlaikā',
          morning: 'rītā',
          afternoon: 'pēcpusdienā',
          evening: 'vakarā',
          night: 'naktī'
        }
      };

      function ordinalNumber(number, _options) {
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          formattingValues: formattingQuarterValues,
          defaultFormattingWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayValues,
          defaultFormattingWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 692 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(p\.m\.ē|m\.ē)/i,
        abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
        wide: /^(pirms mūsu ēras|mūsu ērā)/i
      };
      var parseEraPatterns = {
        any: [/^p/i, /^m/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](\. cet\.)/i,
        wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
      };
      var parseQuarterPatterns = {
        narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
        abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
        wide: [/^p/i, /^o/i, /^t/i, /^c/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
        wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jūn/i, /^jūl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[spotc]/i,
        short: /^(sv|pi|o|t|c|pk|s)/i,
        abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
        wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
        any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
        abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
        wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /^pusn/i,
          noon: /^pusd/i,
          morning: /^r/i,
          afternoon: /^(d|pēc)/i,
          evening: /^v/i,
          night: /^n/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 693 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(694);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(695);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(696);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(697);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(698);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Macedonian locale.
       * @language Macedonian
       * @iso-639-2 mkd
       * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
       * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
       */


      var locale = {
        code: 'mk',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 694 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'помалку од секунда',
          other: 'помалку од {{count}} секунди'
        },
        xSeconds: {
          one: '1 секунда',
          other: '{{count}} секунди'
        },
        halfAMinute: 'половина минута',
        lessThanXMinutes: {
          one: 'помалку од минута',
          other: 'помалку од {{count}} минути'
        },
        xMinutes: {
          one: '1 минута',
          other: '{{count}} минути'
        },
        aboutXHours: {
          one: 'околу 1 час',
          other: 'околу {{count}} часа'
        },
        xHours: {
          one: '1 час',
          other: '{{count}} часа'
        },
        xDays: {
          one: '1 ден',
          other: '{{count}} дена'
        },
        aboutXWeeks: {
          one: 'околу 1 недела',
          other: 'околу {{count}} месеци'
        },
        xWeeks: {
          one: '1 недела',
          other: '{{count}} недели'
        },
        aboutXMonths: {
          one: 'околу 1 месец',
          other: 'околу {{count}} недели'
        },
        xMonths: {
          one: '1 месец',
          other: '{{count}} месеци'
        },
        aboutXYears: {
          one: 'околу 1 година',
          other: 'околу {{count}} години'
        },
        xYears: {
          one: '1 година',
          other: '{{count}} години'
        },
        overXYears: {
          one: 'повеќе од 1 година',
          other: 'повеќе од {{count}} години'
        },
        almostXYears: {
          one: 'безмалку 1 година',
          other: 'безмалку {{count}} години'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'за ' + result;
          } else {
            return 'пред ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 695 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, dd MMMM yyyy',
        long: 'dd MMMM yyyy',
        medium: 'dd MMM yyyy',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        any: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 696 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13);

      var weekdays = ['недела', 'понеделник', 'вторник', 'среда', 'четврток', 'петок', 'сабота'];

      function _lastWeek5(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'минатата " + weekday + " во' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'минатиот " + weekday + " во' p";
        }
      }

      function thisWeek(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'ова " + weekday + " вo' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'овој " + weekday + " вo' p";
        }
      }

      function _nextWeek5(day) {
        var weekday = weekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 6:
            return "'следната " + weekday + " вo' p";

          case 1:
          case 2:
          case 4:
          case 5:
            return "'следниот " + weekday + " вo' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _lastWeek5(day);
          }
        },
        yesterday: "'вчера во' p",
        today: "'денес во' p",
        tomorrow: "'утре во' p",
        nextWeek: function nextWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _nextWeek5(day);
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 697 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['пр.н.е.', 'н.е.'],
        abbreviated: ['пред н. е.', 'н. е.'],
        wide: ['пред нашата ера', 'нашата ера']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1-ви кв.', '2-ри кв.', '3-ти кв.', '4-ти кв.'],
        wide: ['1-ви квартал', '2-ри квартал', '3-ти квартал', '4-ти квартал']
      };
      var monthValues = {
        abbreviated: ['јан', 'фев', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'септ', 'окт', 'ноем', 'дек'],
        wide: ['јануари', 'февруари', 'март', 'април', 'мај', 'јуни', 'јули', 'август', 'септември', 'октомври', 'ноември', 'декември']
      };
      var dayValues = {
        narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
        short: ['не', 'по', 'вт', 'ср', 'че', 'пе', 'са'],
        abbreviated: ['нед', 'пон', 'вто', 'сре', 'чет', 'пет', 'саб'],
        wide: ['недела', 'понеделник', 'вторник', 'среда', 'четврток', 'петок', 'сабота']
      };
      var dayPeriodValues = {
        wide: {
          am: 'претпладне',
          pm: 'попладне',
          midnight: 'полноќ',
          noon: 'напладне',
          morning: 'наутро',
          afternoon: 'попладне',
          evening: 'навечер',
          night: 'ноќе'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
              return number + '-ви';

            case 2:
              return number + '-ри';

            case 7:
            case 8:
              return number + '-ми';
          }
        }

        return number + '-ти';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 698 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((пр)?н\.?\s?е\.?)/i,
        abbreviated: /^((пр)?н\.?\s?е\.?)/i,
        wide: /^(пред нашата ера|нашата ера)/i
      };
      var parseEraPatterns = {
        any: [/^п/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
        wide: /^[1234](-?[врт]?и?)? квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchDayPatterns = {
        narrow: /^[нпвсч]/i,
        short: /^(не|по|вт|ср|че|пе|са)/i,
        abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
        wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
      };
      var parseDayPatterns = {
        narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
      };
      var matchMonthPatterns = {
        abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
        wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
      };
      var parseMonthPatterns = {
        any: [/^ја/i, /^Ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /претпладне/i,
          pm: /попладне/i,
          midnight: /полноќ/i,
          noon: /напладне/i,
          morning: /наутро/i,
          afternoon: /попладне/i,
          evening: /навечер/i,
          night: /ноќе/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 699 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(700);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(701);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(702);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(703);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(704);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Malay locale.
       * @language Malay
       * @iso-639-2 msa
       * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
       */


      var locale = {
        code: 'ms',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 700 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'kurang dari 1 saat',
          other: 'kurang dari {{count}} saat'
        },
        xSeconds: {
          one: '1 saat',
          other: '{{count}} saat'
        },
        halfAMinute: 'setengah minit',
        lessThanXMinutes: {
          one: 'kurang dari 1 minit',
          other: 'kurang dari {{count}} minit'
        },
        xMinutes: {
          one: '1 minit',
          other: '{{count}} minit'
        },
        aboutXHours: {
          one: 'sekitar 1 jam',
          other: 'sekitar {{count}} jam'
        },
        xHours: {
          one: '1 jam',
          other: '{{count}} jam'
        },
        xDays: {
          one: '1 hari',
          other: '{{count}} hari'
        },
        aboutXWeeks: {
          one: 'sekitar 1 minggu',
          other: 'sekitar {{count}} minggu'
        },
        xWeeks: {
          one: '1 minggu',
          other: '{{count}} minggu'
        },
        aboutXMonths: {
          one: 'sekitar 1 bulan',
          other: 'sekitar {{count}} bulan'
        },
        xMonths: {
          one: '1 bulan',
          other: '{{count}} bulan'
        },
        aboutXYears: {
          one: 'sekitar 1 tahun',
          other: 'sekitar {{count}} tahun'
        },
        xYears: {
          one: '1 tahun',
          other: '{{count}} tahun'
        },
        overXYears: {
          one: 'lebih dari 1 tahun',
          other: 'lebih dari {{count}} tahun'
        },
        almostXYears: {
          one: 'hampir 1 tahun',
          other: 'hampir {{count}} tahun'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'dalam masa ' + result;
          } else {
            return result + ' yang lalu';
          }
        }

        return result;
      }
      /***/

    },
    /* 701 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM yyyy',
        medium: 'd MMM yyyy',
        short: 'd/M/yyyy'
      };
      var timeFormats = {
        full: 'HH.mm.ss',
        long: 'HH.mm.ss',
        medium: 'HH.mm',
        short: 'HH.mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'pukul' {{time}}",
        long: "{{date}} 'pukul' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 702 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'lepas pada jam' p",
        yesterday: "'Semalam pada jam' p",
        today: "'Hari ini pada jam' p",
        tomorrow: "'Esok pada jam' p",
        nextWeek: "eeee 'pada jam' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 703 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3); // Most data for localization are taken from this page
      // https://www.unicode.org/cldr/charts/32/summary/ms.html


      var eraValues = {
        narrow: ['SM', 'M'],
        abbreviated: ['SM', 'M'],
        wide: ['Sebelum Masihi', 'Masihi']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['S1', 'S2', 'S3', 'S4'],
        wide: ['Suku pertama', 'Suku kedua', 'Suku ketiga', 'Suku keempat'] // Note: in Malay, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'O', 'S', 'O', 'N', 'D'],
        abbreviated: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'],
        wide: ['Januari', 'Februari', 'Mac', 'April', 'Mei', 'Jun', 'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember']
      };
      var dayValues = {
        narrow: ['A', 'I', 'S', 'R', 'K', 'J', 'S'],
        short: ['Ahd', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
        abbreviated: ['Ahd', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
        wide: ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'am',
          pm: 'pm',
          midnight: 'tgh malam',
          noon: 'tgh hari',
          morning: 'pagi',
          afternoon: 'tengah hari',
          evening: 'petang',
          night: 'malam'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'tengah hari',
          evening: 'petang',
          night: 'malam'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'tengah hari',
          evening: 'petang',
          night: 'malam'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'am',
          pm: 'pm',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'tengah hari',
          evening: 'petang',
          night: 'malam'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'tengah hari',
          evening: 'petang',
          night: 'malam'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'tengah malam',
          noon: 'tengah hari',
          morning: 'pagi',
          afternoon: 'tengah hari',
          evening: 'petang',
          night: 'malam'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed

        switch (number) {
          default:
            return 'ke-' + number;
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 704 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
      var parseOrdinalNumberPattern = /petama|\d+/i;
      var matchEraPatterns = {
        narrow: /^(sm|m)/i,
        abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
        wide: /^(sebelum masihi|masihi)/i
      };
      var parseEraPatterns = {
        any: [/^s/i, /^(m)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^S[1234]/i,
        wide: /Suku (pertama|kedua|ketiga|keempat)/i
      };
      var parseQuarterPatterns = {
        any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
        wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^og/i, /^s/i, /^ok/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[aisrkj]/i,
        short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
        abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
        wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
      };
      var parseDayPatterns = {
        narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
        any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
        any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^pm/i,
          midnight: /^tengah m/i,
          noon: /^tengah h/i,
          morning: /pa/i,
          afternoon: /tengah h/i,
          evening: /pe/i,
          night: /m/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 705 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(706);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(707);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(708);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(709);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(710);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Maltese locale.
       * @language Maltese
       * @iso-639-2 mlt
       * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
       * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
       */


      var locale = {
        code: 'mt',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 706 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'inqas minn sekonda',
          other: 'inqas minn {{count}} sekondi'
        },
        xSeconds: {
          one: 'sekonda',
          other: '{{count}} sekondi'
        },
        halfAMinute: 'nofs minuta',
        lessThanXMinutes: {
          one: 'inqas minn minuta',
          other: 'inqas minn {{count}} minuti'
        },
        xMinutes: {
          one: 'minuta',
          other: '{{count}} minuti'
        },
        aboutXHours: {
          one: 'madwar siegħa',
          other: 'madwar {{count}} siegħat'
        },
        xHours: {
          one: 'siegħa',
          other: '{{count}} siegħat'
        },
        xDays: {
          one: 'ġurnata',
          other: '{{count}} ġranet'
        },
        aboutXWeeks: {
          one: 'madwar ġimgħa',
          other: 'madwar {{count}} ġimgħat'
        },
        xWeeks: {
          one: 'ġimgħa',
          other: '{{count}} ġimgħat'
        },
        aboutXMonths: {
          one: 'madwar xahar',
          other: 'madwar {{count}} xhur'
        },
        xMonths: {
          one: 'xahar',
          other: '{{count}} xhur'
        },
        aboutXYears: {
          one: 'madwar sena',
          two: 'madwar sentejn',
          other: 'madwar {{count}} snin'
        },
        xYears: {
          one: 'sena',
          two: 'sentejn',
          other: '{{count}} snin'
        },
        overXYears: {
          one: 'aktar minn sena',
          two: 'aktar minn sentejn',
          other: 'aktar minn {{count}} snin'
        },
        almostXYears: {
          one: 'kważi sena',
          two: 'kważi sentejn',
          other: 'kważi {{count}} snin'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var adverb = token.match(/years/i);
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else if (count === 2 && adverb) {
          result = formatDistanceLocale[token].two;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return "f'" + result;
          } else {
            return result + ' ilu';
          }
        }

        return result;
      }
      /***/

    },
    /* 707 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM yyyy',
        medium: 'd MMM yyyy',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 708 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'li għadda' 'fil-'p",
        yesterday: "'Il-bieraħ fil-'p",
        today: "'Illum fil-'p",
        tomorrow: "'Għada fil-'p",
        nextWeek: "eeee 'fil-'p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 709 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['Q', 'W'],
        abbreviated: ['QK', 'WK'],
        wide: ['qabel Kristu', 'wara Kristu']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['K1', 'K2', 'K3', 'K4'],
        wide: ['1. kwart', '2. kwart', '3. kwart', '4. kwart']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'Ġ', 'L', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Jan', 'Fra', 'Mar', 'Apr', 'Mej', 'Ġun', 'Lul', 'Aww', 'Set', 'Ott', 'Nov', 'Diċ'],
        wide: ['Jannar', 'Frar', 'Marzu', 'April', 'Mejju', 'Ġunju', 'Lulju', 'Awwissu', 'Settembru', 'Ottubru', 'Novembru', 'Diċembru']
      };
      var dayValues = {
        narrow: ['Ħ', 'T', 'T', 'E', 'Ħ', 'Ġ', 'S'],
        short: ['Ħa', 'Tn', 'Tl', 'Er', 'Ħa', 'Ġi', 'Si'],
        abbreviated: ['Ħad', 'Tne', 'Tli', 'Erb', 'Ħam', 'Ġim', 'Sib'],
        wide: ['Il-Ħadd', 'It-Tnejn', 'It-Tlieta', 'L-Erbgħa', 'Il-Ħamis', 'Il-Ġimgħa', 'Is-Sibt']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'nofsillejl',
          noon: 'nofsinhar',
          morning: 'għodwa',
          afternoon: 'wara nofsinhar',
          evening: 'filgħaxija',
          night: 'lejl'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'nofsillejl',
          noon: 'nofsinhar',
          morning: 'għodwa',
          afternoon: 'wara nofsinhar',
          evening: 'filgħaxija',
          night: 'lejl'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'nofsillejl',
          noon: 'nofsinhar',
          morning: 'għodwa',
          afternoon: 'wara nofsinhar',
          evening: 'filgħaxija',
          night: 'lejl'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: "f'nofsillejl",
          noon: "f'nofsinhar",
          morning: 'filgħodu',
          afternoon: 'wara nofsinhar',
          evening: 'filgħaxija',
          night: 'billejl'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: "f'nofsillejl",
          noon: "f'nofsinhar",
          morning: 'filgħodu',
          afternoon: 'wara nofsinhar',
          evening: 'filgħaxija',
          night: 'billejl'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: "f'nofsillejl",
          noon: "f'nofsinhar",
          morning: 'filgħodu',
          afternoon: 'wara nofsinhar',
          evening: 'filgħaxija',
          night: 'billejl'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + 'º';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 710 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(q|w)/i,
        abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
        wide: /^(qabel kristu|before common era|wara kristu|common era)/i
      };
      var parseEraPatterns = {
        any: [/^(q|b)/i, /^(w|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^k[1234]/i,
        wide: /^[1234](\.)? kwart/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmaglsond]/i,
        abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
        wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^ġ/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mej/i, /^ġ/i, /^l/i, /^aw/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[ħteġs]/i,
        short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
        abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
        wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
      };
      var parseDayPatterns = {
        narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
        any: [/^(il-)?ħad/i, /^(it-)?tn/i, /^(it-)?tl/i, /^(l-)?er/i, /^(il-)?ham/i, /^(il-)?ġi/i, /^(is-)?si/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
        any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^f'nofsillejl/i,
          noon: /^f'nofsinhar/i,
          morning: /għodwa/i,
          afternoon: /wara(\s.*)nofsinhar/i,
          evening: /filgħaxija/i,
          night: /lejl/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 711 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(712);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(713);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(714);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(715);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(716);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Norwegian Bokmål locale.
       * @language Norwegian Bokmål
       * @iso-639-2 nob
       * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
       * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
       * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
       */


      var locale = {
        code: 'nb',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 712 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          singular: 'mindre enn ett sekund',
          plural: 'mindre enn {{count}} sekunder'
        },
        xSeconds: {
          singular: 'ett sekund',
          plural: '{{count}} sekunder'
        },
        halfAMinute: 'et halvt minutt',
        lessThanXMinutes: {
          singular: 'mindre enn ett minutt',
          plural: 'mindre enn {{count}} minutter'
        },
        xMinutes: {
          singular: 'ett minutt',
          plural: '{{count}} minutter'
        },
        aboutXHours: {
          singular: 'omtrent en time',
          plural: 'omtrent {{count}} timer'
        },
        xHours: {
          singular: 'en time',
          plural: '{{count}} timer'
        },
        xDays: {
          singular: 'en dag',
          plural: '{{count}} dager'
        },
        aboutXWeeks: {
          singular: 'omtrent en uke',
          plural: 'omtrent {{count}} uker'
        },
        xWeeks: {
          singular: 'en uke',
          plural: '{{count}} uker'
        },
        aboutXMonths: {
          singular: 'omtrent en måned',
          plural: 'omtrent {{count}} måneder'
        },
        xMonths: {
          singular: 'en måned',
          plural: '{{count}} måneder'
        },
        aboutXYears: {
          singular: 'omtrent ett år',
          plural: 'omtrent {{count}} år'
        },
        xYears: {
          singular: 'ett år',
          plural: '{{count}} år'
        },
        overXYears: {
          singular: 'over ett år',
          plural: 'over {{count}} år'
        },
        almostXYears: {
          singular: 'nesten ett år',
          plural: 'nesten {{count}} år'
        }
      };
      var wordMapping = ['null', 'en', 'to', 'tre', 'fire', 'fem', 'seks', 'sju', 'åtte', 'ni', 'ti', 'elleve', 'tolv'];

      function formatDistance(token, count, options) {
        options = options || {
          onlyNumeric: false
        };
        var translation = formatDistanceLocale[token];
        var result;

        if (typeof translation === 'string') {
          result = translation;
        } else if (count === 0 || count > 1) {
          if (options.onlyNumeric) {
            result = translation.plural.replace('{{count}}', count);
          } else {
            result = translation.plural.replace('{{count}}', count < 13 ? wordMapping[count] : count);
          }
        } else {
          result = translation.singular;
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'om ' + result;
          } else {
            return result + ' siden';
          }
        }

        return result;
      }
      /***/

    },
    /* 713 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE d. MMMM y',
        long: 'd. MMMM y',
        medium: 'd. MMM y',
        short: 'dd.MM.y'
      };
      var timeFormats = {
        full: "'kl'. HH:mm:ss zzzz",
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl.' {{time}}",
        long: "{{date}} 'kl.' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 714 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'forrige' eeee 'kl.' p",
        yesterday: "'i går kl.' p",
        today: "'i dag kl.' p",
        tomorrow: "'i morgen kl.' p",
        nextWeek: "EEEE 'kl.' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 715 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['f.Kr.', 'e.Kr.'],
        abbreviated: ['f.Kr.', 'e.Kr.'],
        wide: ['før Kristus', 'etter Kristus']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
        wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
      };
      var dayValues = {
        narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
        short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
        abbreviated: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
        wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'på morg.',
          afternoon: 'på etterm.',
          evening: 'på kvelden',
          night: 'på natten'
        },
        abbreviated: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'på morg.',
          afternoon: 'på etterm.',
          evening: 'på kvelden',
          night: 'på natten'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'på morgenen',
          afternoon: 'på ettermiddagen',
          evening: 'på kvelden',
          night: 'på natten'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 716 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
        abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
        wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
      };
      var parseEraPatterns = {
        any: [/^f/i, /^e/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](\.)? kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
        wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtofl]/i,
        short: /^(sø|ma|ti|on|to|fr|lø)/i,
        abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
        wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
      };
      var parseDayPatterns = {
        any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
        any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a(\.?\s?m\.?)?$/i,
          pm: /^p(\.?\s?m\.?)?$/i,
          midnight: /^midn/i,
          noon: /^midd/i,
          morning: /morgen/i,
          afternoon: /ettermiddag/i,
          evening: /kveld/i,
          night: /natt/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 717 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(718);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(719);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(720);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(721);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(722);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Dutch locale.
       * @language Dutch
       * @iso-639-2 nld
       * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
       * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
       * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
       * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
       * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
       * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
       */


      var locale = {
        code: 'nl',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 718 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'minder dan een seconde',
          other: 'minder dan {{count}} seconden'
        },
        xSeconds: {
          one: '1 seconde',
          other: '{{count}} seconden'
        },
        halfAMinute: 'een halve minuut',
        lessThanXMinutes: {
          one: 'minder dan een minuut',
          other: 'minder dan {{count}} minuten'
        },
        xMinutes: {
          one: 'een minuut',
          other: '{{count}} minuten'
        },
        aboutXHours: {
          one: 'ongeveer 1 uur',
          other: 'ongeveer {{count}} uur'
        },
        xHours: {
          one: '1 uur',
          other: '{{count}} uur'
        },
        xDays: {
          one: '1 dag',
          other: '{{count}} dagen'
        },
        aboutXWeeks: {
          one: 'ongeveer 1 week',
          other: 'ongeveer {{count}} weken'
        },
        xWeeks: {
          one: '1 week',
          other: '{{count}} weken'
        },
        aboutXMonths: {
          one: 'ongeveer 1 maand',
          other: 'ongeveer {{count}} maanden'
        },
        xMonths: {
          one: '1 maand',
          other: '{{count}} maanden'
        },
        aboutXYears: {
          one: 'ongeveer 1 jaar',
          other: 'ongeveer {{count}} jaar'
        },
        xYears: {
          one: '1 jaar',
          other: '{{count}} jaar'
        },
        overXYears: {
          one: 'meer dan 1 jaar',
          other: 'meer dan {{count}} jaar'
        },
        almostXYears: {
          one: 'bijna 1 jaar',
          other: 'bijna {{count}} jaar'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'over ' + result;
          } else {
            return result + ' geleden';
          }
        }

        return result;
      }
      /***/

    },
    /* 719 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE d MMMM y',
        long: 'd MMMM y',
        medium: 'd MMM y',
        short: 'dd-MM-y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'om' {{time}}",
        long: "{{date}} 'om' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 720 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'afgelopen' eeee 'om' p",
        yesterday: "'gisteren om' p",
        today: "'vandaag om' p",
        tomorrow: "'morgen om' p",
        nextWeek: "eeee 'om' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 721 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['v.C.', 'n.C.'],
        abbreviated: ['v.Chr.', 'n.Chr.'],
        wide: ['voor Christus', 'na Christus']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['K1', 'K2', 'K3', 'K4'],
        wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
        wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
      };
      var dayValues = {
        narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
        short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
        abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
        wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'middernacht',
          noon: 'het middaguur',
          morning: "'s ochtends",
          afternoon: "'s middags",
          evening: "'s avonds",
          night: "'s nachts"
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'middernacht',
          noon: 'het middaguur',
          morning: "'s ochtends",
          afternoon: "'s middags",
          evening: "'s avonds",
          night: "'s nachts"
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'middernacht',
          noon: 'het middaguur',
          morning: "'s ochtends",
          afternoon: "'s middags",
          evening: "'s avonds",
          night: "'s nachts"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + 'e';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 722 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)e?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([vn]\.? ?C\.?)/,
        abbreviated: /^([vn]\. ?Chr\.?)/,
        wide: /^((voor|na) Christus)/
      };
      var parseEraPatterns = {
        any: [/^v/, /^n/]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K[1234]/i,
        wide: /^[1234]e kwartaal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
        wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
      };
      var matchDayPatterns = {
        narrow: /^[zmdwv]/i,
        short: /^(zo|ma|di|wo|do|vr|za)/i,
        abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
        wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
      };
      var parseDayPatterns = {
        narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
        any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /^middernacht/i,
          noon: /^het middaguur/i,
          morning: /ochtend/i,
          afternoon: /middag/i,
          evening: /avond/i,
          night: /nacht/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 723 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(724);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(725);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(726);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(727);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(728);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Dutch locale.
       * @language Dutch
       * @iso-639-2 nld
       * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
       * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
       * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
       * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
       */


      var locale = {
        code: 'nl-BE',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 724 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'minder dan een seconde',
          other: 'minder dan {{count}} seconden'
        },
        xSeconds: {
          one: '1 seconde',
          other: '{{count}} seconden'
        },
        halfAMinute: 'een halve minuut',
        lessThanXMinutes: {
          one: 'minder dan een minuut',
          other: 'minder dan {{count}} minuten'
        },
        xMinutes: {
          one: 'een minuut',
          other: '{{count}} minuten'
        },
        aboutXHours: {
          one: 'ongeveer 1 uur',
          other: 'ongeveer {{count}} uur'
        },
        xHours: {
          one: '1 uur',
          other: '{{count}} uur'
        },
        xDays: {
          one: '1 dag',
          other: '{{count}} dagen'
        },
        aboutXWeeks: {
          one: 'ongeveer 1 week',
          other: 'ongeveer {{count}} weken'
        },
        xWeeks: {
          one: '1 week',
          other: '{{count}} weken'
        },
        aboutXMonths: {
          one: 'ongeveer 1 maand',
          other: 'ongeveer {{count}} maanden'
        },
        xMonths: {
          one: '1 maand',
          other: '{{count}} maanden'
        },
        aboutXYears: {
          one: 'ongeveer 1 jaar',
          other: 'ongeveer {{count}} jaar'
        },
        xYears: {
          one: '1 jaar',
          other: '{{count}} jaar'
        },
        overXYears: {
          one: 'meer dan 1 jaar',
          other: 'meer dan {{count}} jaar'
        },
        almostXYears: {
          one: 'bijna 1 jaar',
          other: 'bijna {{count}} jaar'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'over ' + result;
          } else {
            return result + ' geleden';
          }
        }

        return result;
      }
      /***/

    },
    /* 725 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE d MMMM y',
        long: 'd MMMM y',
        medium: 'd MMM y',
        short: 'dd-MM-y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'om' {{time}}",
        long: "{{date}} 'om' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 726 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'vorige' eeee 'om' p",
        yesterday: "'gisteren om' p",
        today: "'vandaag om' p",
        tomorrow: "'morgen om' p",
        nextWeek: "eeee 'om' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 727 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['v.C.', 'n.C.'],
        abbreviated: ['v.Chr.', 'n.Chr.'],
        wide: ['voor Christus', 'na Christus']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['K1', 'K2', 'K3', 'K4'],
        wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
        wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
      };
      var dayValues = {
        narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
        short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
        abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
        wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'middernacht',
          noon: 'het middag',
          morning: "'s ochtends",
          afternoon: "'s namiddags",
          evening: "'s avonds",
          night: "'s nachts"
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'middernacht',
          noon: 'het middag',
          morning: "'s ochtends",
          afternoon: "'s namiddags",
          evening: "'s avonds",
          night: "'s nachts"
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'middernacht',
          noon: 'het middag',
          morning: "'s ochtends",
          afternoon: "'s namiddags",
          evening: "'s avonds",
          night: "'s nachts"
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + 'e';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 728 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)e?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([vn]\.? ?C\.?)/,
        abbreviated: /^([vn]\. ?Chr\.?)/,
        wide: /^((voor|na) Christus)/
      };
      var parseEraPatterns = {
        any: [/^v/, /^n/]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^K[1234]/i,
        wide: /^[1234]e kwartaal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
        wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
      };
      var matchDayPatterns = {
        narrow: /^[zmdwv]/i,
        short: /^(zo|ma|di|wo|do|vr|za)/i,
        abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
        wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
      };
      var parseDayPatterns = {
        narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
        any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /^middernacht/i,
          noon: /^het middaguur/i,
          morning: /ochtend/i,
          afternoon: /middag/i,
          evening: /avond/i,
          night: /nacht/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 729 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(730);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(731);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(732);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(733);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(734);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Norwegian Nynorsk locale.
       * @language Norwegian Nynorsk
       * @iso-639-2 nno
       * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
       */


      var locale = {
        code: 'nn',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 730 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          singular: 'mindre enn eitt sekund',
          plural: 'mindre enn {{count}} sekund'
        },
        xSeconds: {
          singular: 'eitt sekund',
          plural: '{{count}} sekund'
        },
        halfAMinute: 'eit halvt minutt',
        lessThanXMinutes: {
          singular: 'mindre enn eitt minutt',
          plural: 'mindre enn {{count}} minutt'
        },
        xMinutes: {
          singular: 'eitt minutt',
          plural: '{{count}} minutt'
        },
        aboutXHours: {
          singular: 'omtrent ein time',
          plural: 'omtrent {{count}} timar'
        },
        xHours: {
          singular: 'ein time',
          plural: '{{count}} timar'
        },
        xDays: {
          singular: 'ein dag',
          plural: '{{count}} dagar'
        },
        aboutXWeeks: {
          singular: 'omtrent ei veke',
          plural: 'omtrent {{count}} veker'
        },
        xWeeks: {
          singular: 'ei veke',
          plural: '{{count}} veker'
        },
        aboutXMonths: {
          singular: 'omtrent ein månad',
          plural: 'omtrent {{count}} månader'
        },
        xMonths: {
          singular: 'ein månad',
          plural: '{{count}} månader'
        },
        aboutXYears: {
          singular: 'omtrent eitt år',
          plural: 'omtrent {{count}} år'
        },
        xYears: {
          singular: 'eitt år',
          plural: '{{count}} år'
        },
        overXYears: {
          singular: 'over eitt år',
          plural: 'over {{count}} år'
        },
        almostXYears: {
          singular: 'nesten eitt år',
          plural: 'nesten {{count}} år'
        }
      };
      var wordMapping = ['null', 'ein', 'to', 'tre', 'fire', 'fem', 'seks', 'sju', 'åtte', 'ni', 'ti', 'elleve', 'tolv'];

      function formatDistance(token, count, options) {
        options = options || {
          onlyNumeric: false
        };
        var translation = formatDistanceLocale[token];
        var result;

        if (typeof translation === 'string') {
          result = translation;
        } else if (count === 0 || count > 1) {
          if (options.onlyNumeric) {
            result = translation.plural.replace('{{count}}', count);
          } else {
            result = translation.plural.replace('{{count}}', count < 13 ? wordMapping[count] : count);
          }
        } else {
          result = translation.singular;
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'om ' + result;
          } else {
            return result + ' sidan';
          }
        }

        return result;
      }
      /***/

    },
    /* 731 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE d. MMMM y',
        long: 'd. MMMM y',
        medium: 'd. MMM y',
        short: 'dd.MM.y'
      };
      var timeFormats = {
        full: "'kl'. HH:mm:ss zzzz",
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl.' {{time}}",
        long: "{{date}} 'kl.' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 732 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'førre' eeee 'kl.' p",
        yesterday: "'i går kl.' p",
        today: "'i dag kl.' p",
        tomorrow: "'i morgon kl.' p",
        nextWeek: "EEEE 'kl.' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 733 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['f.Kr.', 'e.Kr.'],
        abbreviated: ['f.Kr.', 'e.Kr.'],
        wide: ['før Kristus', 'etter Kristus']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
        wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
      };
      var dayValues = {
        narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
        short: ['su', 'må', 'ty', 'on', 'to', 'fr', 'lau'],
        abbreviated: ['sun', 'mån', 'tys', 'ons', 'tor', 'fre', 'laur'],
        wide: ['sundag', 'måndag', 'tysdag', 'onsdag', 'torsdag', 'fredag', 'laurdag']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'på morg.',
          afternoon: 'på etterm.',
          evening: 'på kvelden',
          night: 'på natta'
        },
        abbreviated: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'på morg.',
          afternoon: 'på etterm.',
          evening: 'på kvelden',
          night: 'på natta'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'på morgonen',
          afternoon: 'på ettermiddagen',
          evening: 'på kvelden',
          night: 'på natta'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 734 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
        abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
        wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
      };
      var parseEraPatterns = {
        any: [/^f/i, /^e/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](\.)? kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
        wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtofl]/i,
        short: /^(su|må|ty|on|to|fr|la)/i,
        abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
        wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
      };
      var parseDayPatterns = {
        any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
        any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a(\.?\s?m\.?)?$/i,
          pm: /^p(\.?\s?m\.?)?$/i,
          midnight: /^midn/i,
          noon: /^midd/i,
          morning: /morgon/i,
          afternoon: /ettermiddag/i,
          evening: /kveld/i,
          night: /natt/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 735 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(736);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(737);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(738);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(739);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(740);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Polish locale.
       * @language Polish
       * @iso-639-2 pol
       * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
       * @author Just RAG [@justrag]{@link https://github.com/justrag}
       * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
       * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
       */


      var locale = {
        code: 'pl',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 736 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;

      function declensionGroup(scheme, count) {
        if (count === 1) {
          return scheme.one;
        }

        var rem100 = count % 100; // ends with 11-20

        if (rem100 <= 20 && rem100 > 10) {
          return scheme.other;
        }

        var rem10 = rem100 % 10; // ends with 2, 3, 4

        if (rem10 >= 2 && rem10 <= 4) {
          return scheme.twoFour;
        }

        return scheme.other;
      }

      function declension(scheme, count, time) {
        time = time || 'regular';
        var group = declensionGroup(scheme, count);
        var finalText = group[time] || group;
        return finalText.replace('{{count}}', count);
      }

      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            regular: 'mniej niż sekunda',
            past: 'mniej niż sekundę',
            future: 'mniej niż sekundę'
          },
          twoFour: 'mniej niż {{count}} sekundy',
          other: 'mniej niż {{count}} sekund'
        },
        xSeconds: {
          one: {
            regular: 'sekunda',
            past: 'sekundę',
            future: 'sekundę'
          },
          twoFour: '{{count}} sekundy',
          other: '{{count}} sekund'
        },
        halfAMinute: {
          one: 'pół minuty',
          twoFour: 'pół minuty',
          other: 'pół minuty'
        },
        lessThanXMinutes: {
          one: {
            regular: 'mniej niż minuta',
            past: 'mniej niż minutę',
            future: 'mniej niż minutę'
          },
          twoFour: 'mniej niż {{count}} minuty',
          other: 'mniej niż {{count}} minut'
        },
        xMinutes: {
          one: {
            regular: 'minuta',
            past: 'minutę',
            future: 'minutę'
          },
          twoFour: '{{count}} minuty',
          other: '{{count}} minut'
        },
        aboutXHours: {
          one: {
            regular: 'około godzina',
            past: 'około godziny',
            future: 'około godzinę'
          },
          twoFour: 'około {{count}} godziny',
          other: 'około {{count}} godzin'
        },
        xHours: {
          one: {
            regular: 'godzina',
            past: 'godzinę',
            future: 'godzinę'
          },
          twoFour: '{{count}} godziny',
          other: '{{count}} godzin'
        },
        xDays: {
          one: {
            regular: 'dzień',
            past: 'dzień',
            future: '1 dzień'
          },
          twoFour: '{{count}} dni',
          other: '{{count}} dni'
        },
        aboutXWeeks: {
          one: 'około tygodnia',
          twoFour: 'około {{count}} tygodni',
          other: 'około {{count}} tygodni'
        },
        xWeeks: {
          one: 'tydzień',
          twoFour: '{{count}} tygodnie',
          other: '{{count}} tygodni'
        },
        aboutXMonths: {
          one: 'około miesiąc',
          twoFour: 'około {{count}} miesiące',
          other: 'około {{count}} miesięcy'
        },
        xMonths: {
          one: 'miesiąc',
          twoFour: '{{count}} miesiące',
          other: '{{count}} miesięcy'
        },
        aboutXYears: {
          one: 'około rok',
          twoFour: 'około {{count}} lata',
          other: 'około {{count}} lat'
        },
        xYears: {
          one: 'rok',
          twoFour: '{{count}} lata',
          other: '{{count}} lat'
        },
        overXYears: {
          one: 'ponad rok',
          twoFour: 'ponad {{count}} lata',
          other: 'ponad {{count}} lat'
        },
        almostXYears: {
          one: 'prawie rok',
          twoFour: 'prawie {{count}} lata',
          other: 'prawie {{count}} lat'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var scheme = formatDistanceLocale[token];

        if (!options.addSuffix) {
          return declension(scheme, count);
        }

        if (options.comparison > 0) {
          return 'za ' + declension(scheme, count, 'future');
        } else {
          return declension(scheme, count, 'past') + ' temu';
        }
      }
      /***/

    },
    /* 737 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, do MMMM y',
        long: 'do MMMM y',
        medium: 'do MMM y',
        short: 'dd.MM.y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 738 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13);

      var adjectivesLastWeek = {
        masculine: 'ostatni',
        feminine: 'ostatnia'
      };
      var adjectivesThisWeek = {
        masculine: 'ten',
        feminine: 'ta'
      };
      var adjectivesNextWeek = {
        masculine: 'następny',
        feminine: 'następna'
      };
      var dayGrammaticalGender = {
        0: 'feminine',
        1: 'masculine',
        2: 'masculine',
        3: 'feminine',
        4: 'masculine',
        5: 'masculine',
        6: 'feminine'
      };

      function getAdjectives(token, date, baseDate, options) {
        if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
        /* default */
        ](date, baseDate, options)) {
          return adjectivesThisWeek;
        } else if (token === 'lastWeek') {
          return adjectivesLastWeek;
        } else if (token === 'nextWeek') {
          return adjectivesNextWeek;
        } else {
          throw new Error("Cannot determine adjectives for token ".concat(token));
        }
      }

      function getAdjective(token, date, baseDate, options) {
        var day = date.getUTCDay();
        var adjectives = getAdjectives(token, date, baseDate, options);
        var grammaticalGender = dayGrammaticalGender[day];
        return adjectives[grammaticalGender];
      }

      function dayAndTimeWithAdjective(token, date, baseDate, options) {
        var adjective = getAdjective(token, date, baseDate, options);
        return "'".concat(adjective, "' eeee 'o' p");
      }

      var formatRelativeLocale = {
        lastWeek: dayAndTimeWithAdjective,
        yesterday: "'wczoraj o' p",
        today: "'dzisiaj o' p",
        tomorrow: "'jutro o' p",
        nextWeek: dayAndTimeWithAdjective,
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(token, date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 739 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number);
      }

      var eraValues = {
        narrow: ['p.n.e.', 'n.e.'],
        abbreviated: ['p.n.e.', 'n.e.'],
        wide: ['przed naszą erą', 'naszej ery']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['I kw.', 'II kw.', 'III kw.', 'IV kw.'],
        wide: ['I kwartał', 'II kwartał', 'III kwartał', 'IV kwartał']
      };
      var monthValues = {
        narrow: ['S', 'L', 'M', 'K', 'M', 'C', 'L', 'S', 'W', 'P', 'L', 'G'],
        abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
        wide: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień']
      };
      var monthFormattingValues = {
        narrow: ['s', 'l', 'm', 'k', 'm', 'c', 'l', 's', 'w', 'p', 'l', 'g'],
        abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
        wide: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']
      };
      var dayValues = {
        narrow: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
        short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
        abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
        wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
      };
      var dayFormattingValues = {
        narrow: ['n', 'p', 'w', 'ś', 'c', 'p', 's'],
        short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
        abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
        wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'półn.',
          noon: 'poł',
          morning: 'rano',
          afternoon: 'popoł.',
          evening: 'wiecz.',
          night: 'noc'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'północ',
          noon: 'południe',
          morning: 'rano',
          afternoon: 'popołudnie',
          evening: 'wieczór',
          night: 'noc'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'północ',
          noon: 'południe',
          morning: 'rano',
          afternoon: 'popołudnie',
          evening: 'wieczór',
          night: 'noc'
        }
      };
      var dayPeriodFormattingValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'o półn.',
          noon: 'w poł.',
          morning: 'rano',
          afternoon: 'po poł.',
          evening: 'wiecz.',
          night: 'w nocy'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'o północy',
          noon: 'w południe',
          morning: 'rano',
          afternoon: 'po południu',
          evening: 'wieczorem',
          night: 'w nocy'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'o północy',
          noon: 'w południe',
          morning: 'rano',
          afternoon: 'po południu',
          evening: 'wieczorem',
          night: 'w nocy'
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: monthFormattingValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide',
          formattingValues: dayFormattingValues,
          defaultFormattingWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: dayPeriodFormattingValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 740 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
        abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
        wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
      };
      var parseEraPatterns = {
        any: [/^p/i, /^n/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
        wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
      };
      var parseQuarterPatterns = {
        narrow: [/1/i, /2/i, /3/i, /4/i],
        any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
      };
      var matchMonthPatterns = {
        narrow: /^[slmkcwpg]/i,
        abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
        wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
      };
      var parseMonthPatterns = {
        narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
        any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
      };
      var matchDayPatterns = {
        narrow: /^[npwścs]/i,
        short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
        abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
        wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
      };
      var parseDayPatterns = {
        narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
        abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
        any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
        any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
      };
      var parseDayPeriodPatterns = {
        narrow: {
          am: /^a$/i,
          pm: /^p$/i,
          midnight: /pó(ł|l)n/i,
          noon: /po(ł|l)/i,
          morning: /rano/i,
          afternoon: /po\s*po(ł|l)/i,
          evening: /wiecz/i,
          night: /noc/i
        },
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /pó(ł|l)n/i,
          noon: /po(ł|l)/i,
          morning: /rano/i,
          afternoon: /po\s*po(ł|l)/i,
          evening: /wiecz/i,
          night: /noc/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 741 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(742);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(743);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(744);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(745);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(746);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Portuguese locale.
       * @language Portuguese
       * @iso-639-2 por
       * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
       * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
       */


      var locale = {
        code: 'pt',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 742 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'menos de um segundo',
          other: 'menos de {{count}} segundos'
        },
        xSeconds: {
          one: '1 segundo',
          other: '{{count}} segundos'
        },
        halfAMinute: 'meio minuto',
        lessThanXMinutes: {
          one: 'menos de um minuto',
          other: 'menos de {{count}} minutos'
        },
        xMinutes: {
          one: '1 minuto',
          other: '{{count}} minutos'
        },
        aboutXHours: {
          one: 'aproximadamente 1 hora',
          other: 'aproximadamente {{count}} horas'
        },
        xHours: {
          one: '1 hora',
          other: '{{count}} horas'
        },
        xDays: {
          one: '1 dia',
          other: '{{count}} dias'
        },
        aboutXWeeks: {
          one: 'aproximadamente 1 mês',
          // TODO
          other: 'aproximadamente {{count}} meses' // TODO

        },
        xWeeks: {
          one: '1 mês',
          // TODO
          other: '{{count}} meses' // TODO

        },
        aboutXMonths: {
          one: 'aproximadamente 1 mês',
          other: 'aproximadamente {{count}} meses'
        },
        xMonths: {
          one: '1 mês',
          other: '{{count}} meses'
        },
        aboutXYears: {
          one: 'aproximadamente 1 ano',
          other: 'aproximadamente {{count}} anos'
        },
        xYears: {
          one: '1 ano',
          other: '{{count}} anos'
        },
        overXYears: {
          one: 'mais de 1 ano',
          other: 'mais de {{count}} anos'
        },
        almostXYears: {
          one: 'quase 1 ano',
          other: 'quase {{count}} anos'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'daqui a ' + result;
          } else {
            return 'há ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 743 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, d 'de' MMMM 'de' y",
        long: "d 'de' MMMM 'de' y",
        medium: "d 'de' MMM 'de' y",
        short: 'dd/MM/y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'às' {{time}}",
        long: "{{date}} 'às' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 744 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'na última' eeee 'às' p",
        yesterday: "'ontem às' p",
        today: "'hoje às' p",
        tomorrow: "'amanhã às' p",
        nextWeek: "eeee 'às' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 745 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number + 'º';
      }

      var eraValues = {
        narrow: ['aC', 'dC'],
        abbreviated: ['a.C.', 'd.C.'],
        wide: ['antes de Cristo', 'depois de Cristo']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['T1', 'T2', 'T3', 'T4'],
        wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
      };
      var monthValues = {
        narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
        abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
        wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
      };
      var dayValues = {
        narrow: ['d', 's', 't', 'q', 'q', 's', 's'],
        short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
        abbreviated: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
        wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'manhã',
          afternoon: 'tarde',
          evening: 'noite',
          night: 'madrugada'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'manhã',
          afternoon: 'tarde',
          evening: 'noite',
          night: 'madrugada'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'manhã',
          afternoon: 'tarde',
          evening: 'noite',
          night: 'madrugada'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'da manhã',
          afternoon: 'da tarde',
          evening: 'da noite',
          night: 'da madrugada'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'da manhã',
          afternoon: 'da tarde',
          evening: 'da noite',
          night: 'da madrugada'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'da manhã',
          afternoon: 'da tarde',
          evening: 'da noite',
          night: 'da madrugada'
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 746 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ac|dc|a|d)/i,
        abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
        wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
      };
      var parseEraPatterns = {
        any: [/^ac/i, /^dc/i],
        wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](º|ª)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
        wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dstq]/i,
        short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
        abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
        wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
        any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
        any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^meia/i,
          noon: /^meio/i,
          morning: /manh[ãa]/i,
          afternoon: /tarde/i,
          evening: /noite/i,
          night: /madrugada/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 747 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(748);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(749);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(750);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(751);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(752);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Portuguese locale (Brazil).
       * @language Portuguese
       * @iso-639-2 por
       * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
       * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
       */


      var locale = {
        code: 'pt-BR',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 748 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'menos de um segundo',
          other: 'menos de {{count}} segundos'
        },
        xSeconds: {
          one: '1 segundo',
          other: '{{count}} segundos'
        },
        halfAMinute: 'meio minuto',
        lessThanXMinutes: {
          one: 'menos de um minuto',
          other: 'menos de {{count}} minutos'
        },
        xMinutes: {
          one: '1 minuto',
          other: '{{count}} minutos'
        },
        aboutXHours: {
          one: 'cerca de 1 hora',
          other: 'cerca de {{count}} horas'
        },
        xHours: {
          one: '1 hora',
          other: '{{count}} horas'
        },
        xDays: {
          one: '1 dia',
          other: '{{count}} dias'
        },
        aboutXWeeks: {
          one: 'cerca de 1 mês',
          other: 'cerca de {{count}} meses'
        },
        xWeeks: {
          one: '1 mês',
          other: '{{count}} meses'
        },
        aboutXMonths: {
          one: 'cerca de 1 mês',
          other: 'cerca de {{count}} meses'
        },
        xMonths: {
          one: '1 mês',
          other: '{{count}} meses'
        },
        aboutXYears: {
          one: 'cerca de 1 ano',
          other: 'cerca de {{count}} anos'
        },
        xYears: {
          one: '1 ano',
          other: '{{count}} anos'
        },
        overXYears: {
          one: 'mais de 1 ano',
          other: 'mais de {{count}} anos'
        },
        almostXYears: {
          one: 'quase 1 ano',
          other: 'quase {{count}} anos'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'em ' + result;
          } else {
            return 'há ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 749 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, d 'de' MMMM 'de' y",
        long: "d 'de' MMMM 'de' y",
        medium: 'd MMM y',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'às' {{time}}",
        long: "{{date}} 'às' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 750 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, _baseDate, _options) {
          var weekday = date.getUTCDay();
          var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
          return "'" + last + "' eeee 'às' p";
        },
        yesterday: "'ontem às' p",
        today: "'hoje às' p",
        tomorrow: "'amanhã às' p",
        nextWeek: "eeee 'às' p",
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 751 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['AC', 'DC'],
        abbreviated: ['AC', 'DC'],
        wide: ['antes de cristo', 'depois de cristo']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['T1', 'T2', 'T3', 'T4'],
        wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
      };
      var monthValues = {
        narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
        abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
        wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
      };
      var dayValues = {
        narrow: ['do', '2ª', '3ª', '4ª', '5ª', '6ª', 'sá'],
        short: ['do', '2ª', '3ª', '4ª', '5ª', '6ª', 'sá'],
        abbreviated: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
        wide: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mn',
          noon: 'md',
          morning: 'manhã',
          afternoon: 'tarde',
          evening: 'tarde',
          night: 'noite'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'manhã',
          afternoon: 'tarde',
          evening: 'tarde',
          night: 'noite'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'manhã',
          afternoon: 'tarde',
          evening: 'tarde',
          night: 'noite'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mn',
          noon: 'md',
          morning: 'da manhã',
          afternoon: 'da tarde',
          evening: 'da tarde',
          night: 'da noite'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'da manhã',
          afternoon: 'da tarde',
          evening: 'da tarde',
          night: 'da noite'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'meia-noite',
          noon: 'meio-dia',
          morning: 'da manhã',
          afternoon: 'da tarde',
          evening: 'da tarde',
          night: 'da noite'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);

        if (unit === 'week' || unit === 'isoWeek') {
          return number + 'ª';
        }

        return number + 'º';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 752 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ac|dc|a|d)/i,
        abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
        wide: /^(antes de cristo|depois de cristo)/i
      };
      var parseEraPatterns = {
        any: [/^ac/i, /^dc/i],
        wide: [/^antes de cristo/i, /^depois de cristo/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^[1234](º)? trimestre/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmajsond]/i,
        abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
        wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
      };
      var matchDayPatterns = {
        narrow: /^(dom|[23456]ª?|s[aá]b)/i,
        short: /^(dom|[23456]ª?|s[aá]b)/i,
        abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
        wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
      };
      var parseDayPatterns = {
        short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
        narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
        any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
        any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mn|^meia[-\s]noite/i,
          noon: /^md|^meio[-\s]dia/i,
          morning: /manhã/i,
          afternoon: /tarde/i,
          evening: /tarde/i,
          night: /noite/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 753 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(754);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(755);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(756);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(757);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(758);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Romanian locale.
       * @language Romanian
       * @iso-639-2 ron
       * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
       * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
       * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
       */


      var locale = {
        code: 'ro',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 754 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'mai puțin de o secundă',
          other: 'mai puțin de {{count}} secunde'
        },
        xSeconds: {
          one: '1 secundă',
          other: '{{count}} secunde'
        },
        halfAMinute: 'jumătate de minut',
        lessThanXMinutes: {
          one: 'mai puțin de un minut',
          other: 'mai puțin de {{count}} minute'
        },
        xMinutes: {
          one: '1 minut',
          other: '{{count}} minute'
        },
        aboutXHours: {
          one: 'circa 1 oră',
          other: 'circa {{count}} ore'
        },
        xHours: {
          one: '1 oră',
          other: '{{count}} ore'
        },
        xDays: {
          one: '1 zi',
          other: '{{count}} zile'
        },
        aboutXWeeks: {
          one: 'circa o săptămână',
          other: 'circa {{count}} săptămâni'
        },
        xWeeks: {
          one: '1 săptămână',
          other: '{{count}} săptămâni'
        },
        aboutXMonths: {
          one: 'circa 1 lună',
          other: 'circa {{count}} luni'
        },
        xMonths: {
          one: '1 lună',
          other: '{{count}} luni'
        },
        aboutXYears: {
          one: 'circa 1 an',
          other: 'circa {{count}} ani'
        },
        xYears: {
          one: '1 an',
          other: '{{count}} ani'
        },
        overXYears: {
          one: 'peste 1 an',
          other: 'peste {{count}} ani'
        },
        almostXYears: {
          one: 'aproape 1 an',
          other: 'aproape {{count}} ani'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'în ' + result;
          } else {
            return result + ' în urmă';
          }
        }

        return result;
      }
      /***/

    },
    /* 755 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d MMMM yyyy',
        long: 'd MMMM yyyy',
        medium: 'd MMM yyyy',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'la' {{time}}",
        long: "{{date}} 'la' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 756 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'trecută la' p",
        yesterday: "'ieri la' p",
        today: "'astăzi la' p",
        tomorrow: "'mâine la' p",
        nextWeek: "eeee 'viitoare la' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 757 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['Î', 'D'],
        abbreviated: ['Î.d.C.', 'D.C.'],
        wide: ['Înainte de Cristos', 'După Cristos']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['T1', 'T2', 'T3', 'T4'],
        wide: ['primul trimestru', 'al doilea trimestru', 'al treilea trimestru', 'al patrulea trimestru']
      };
      var monthValues = {
        narrow: ['I', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'noi', 'dec'],
        wide: ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie']
      };
      var dayValues = {
        narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
        short: ['du', 'lu', 'ma', 'mi', 'jo', 'vi', 'sâ'],
        abbreviated: ['dum', 'lun', 'mar', 'mie', 'joi', 'vin', 'sâm'],
        wide: ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mn',
          noon: 'ami',
          morning: 'dim',
          afternoon: 'da',
          evening: 's',
          night: 'n'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'miezul nopții',
          noon: 'amiază',
          morning: 'dimineață',
          afternoon: 'după-amiază',
          evening: 'seară',
          night: 'noapte'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'miezul nopții',
          noon: 'amiază',
          morning: 'dimineață',
          afternoon: 'după-amiază',
          evening: 'seară',
          night: 'noapte'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'mn',
          noon: 'amiază',
          morning: 'dimineață',
          afternoon: 'după-amiază',
          evening: 'seară',
          night: 'noapte'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'miezul nopții',
          noon: 'amiază',
          morning: 'dimineață',
          afternoon: 'după-amiază',
          evening: 'seară',
          night: 'noapte'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'miezul nopții',
          noon: 'amiază',
          morning: 'dimineață',
          afternoon: 'după-amiază',
          evening: 'seară',
          night: 'noapte'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 758 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(Î|D)/i,
        abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
        wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
      };
      var parseEraPatterns = {
        any: [/^ÎC/i, /^DC/i],
        wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^T[1234]/i,
        wide: /^trimestrul [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[ifmaasond]/i,
        abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
        wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
      };
      var parseMonthPatterns = {
        narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[dlmjvs]/i,
        short: /^(d|l|ma|mi|j|v|s)/i,
        abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
        wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
      };
      var parseDayPatterns = {
        narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
        any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
        any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^mn/i,
          noon: /amiaza/i,
          morning: /dimineaţa/i,
          afternoon: /după-amiaza/i,
          evening: /seara/i,
          night: /noaptea/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 759 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(760);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(761);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(762);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(763);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(764);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Russian locale.
       * @language Russian
       * @iso-639-2 rus
       * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
       * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
       */


      var locale = {
        code: 'ru',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 760 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;

      function declension(scheme, count) {
        // scheme for count=1 exists
        if (scheme.one !== undefined && count === 1) {
          return scheme.one;
        }

        var rem10 = count % 10;
        var rem100 = count % 100; // 1, 21, 31, ...

        if (rem10 === 1 && rem100 !== 11) {
          return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
        } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
          return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
        } else {
          return scheme.pluralGenitive.replace('{{count}}', count);
        }
      }

      function buildLocalizeTokenFn(scheme) {
        return function (count, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              if (scheme.future) {
                return declension(scheme.future, count);
              } else {
                return 'через ' + declension(scheme.regular, count);
              }
            } else {
              if (scheme.past) {
                return declension(scheme.past, count);
              } else {
                return declension(scheme.regular, count) + ' назад';
              }
            }
          } else {
            return declension(scheme.regular, count);
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          regular: {
            one: 'меньше секунды',
            singularNominative: 'меньше {{count}} секунды',
            singularGenitive: 'меньше {{count}} секунд',
            pluralGenitive: 'меньше {{count}} секунд'
          },
          future: {
            one: 'меньше, чем через секунду',
            singularNominative: 'меньше, чем через {{count}} секунду',
            singularGenitive: 'меньше, чем через {{count}} секунды',
            pluralGenitive: 'меньше, чем через {{count}} секунд'
          }
        }),
        xSeconds: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} секунда',
            singularGenitive: '{{count}} секунды',
            pluralGenitive: '{{count}} секунд'
          },
          past: {
            singularNominative: '{{count}} секунду назад',
            singularGenitive: '{{count}} секунды назад',
            pluralGenitive: '{{count}} секунд назад'
          },
          future: {
            singularNominative: 'через {{count}} секунду',
            singularGenitive: 'через {{count}} секунды',
            pluralGenitive: 'через {{count}} секунд'
          }
        }),
        halfAMinute: function halfAMinute(_, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              return 'через полминуты';
            } else {
              return 'полминуты назад';
            }
          }

          return 'полминуты';
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          regular: {
            one: 'меньше минуты',
            singularNominative: 'меньше {{count}} минуты',
            singularGenitive: 'меньше {{count}} минут',
            pluralGenitive: 'меньше {{count}} минут'
          },
          future: {
            one: 'меньше, чем через минуту',
            singularNominative: 'меньше, чем через {{count}} минуту',
            singularGenitive: 'меньше, чем через {{count}} минуты',
            pluralGenitive: 'меньше, чем через {{count}} минут'
          }
        }),
        xMinutes: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} минута',
            singularGenitive: '{{count}} минуты',
            pluralGenitive: '{{count}} минут'
          },
          past: {
            singularNominative: '{{count}} минуту назад',
            singularGenitive: '{{count}} минуты назад',
            pluralGenitive: '{{count}} минут назад'
          },
          future: {
            singularNominative: 'через {{count}} минуту',
            singularGenitive: 'через {{count}} минуты',
            pluralGenitive: 'через {{count}} минут'
          }
        }),
        aboutXHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'около {{count}} часа',
            singularGenitive: 'около {{count}} часов',
            pluralGenitive: 'около {{count}} часов'
          },
          future: {
            singularNominative: 'приблизительно через {{count}} час',
            singularGenitive: 'приблизительно через {{count}} часа',
            pluralGenitive: 'приблизительно через {{count}} часов'
          }
        }),
        xHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} час',
            singularGenitive: '{{count}} часа',
            pluralGenitive: '{{count}} часов'
          }
        }),
        xDays: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} день',
            singularGenitive: '{{count}} дня',
            pluralGenitive: '{{count}} дней'
          }
        }),
        aboutXWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'около {{count}} недели',
            singularGenitive: 'около {{count}} недель',
            pluralGenitive: 'около {{count}} недель'
          },
          future: {
            singularNominative: 'приблизительно через {{count}} неделю',
            singularGenitive: 'приблизительно через {{count}} недели',
            pluralGenitive: 'приблизительно через {{count}} недель'
          }
        }),
        xWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} неделя',
            singularGenitive: '{{count}} недели',
            pluralGenitive: '{{count}} недель'
          }
        }),
        aboutXMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'около {{count}} месяца',
            singularGenitive: 'около {{count}} месяцев',
            pluralGenitive: 'около {{count}} месяцев'
          },
          future: {
            singularNominative: 'приблизительно через {{count}} месяц',
            singularGenitive: 'приблизительно через {{count}} месяца',
            pluralGenitive: 'приблизительно через {{count}} месяцев'
          }
        }),
        xMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} месяц',
            singularGenitive: '{{count}} месяца',
            pluralGenitive: '{{count}} месяцев'
          }
        }),
        aboutXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'около {{count}} года',
            singularGenitive: 'около {{count}} лет',
            pluralGenitive: 'около {{count}} лет'
          },
          future: {
            singularNominative: 'приблизительно через {{count}} год',
            singularGenitive: 'приблизительно через {{count}} года',
            pluralGenitive: 'приблизительно через {{count}} лет'
          }
        }),
        xYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} год',
            singularGenitive: '{{count}} года',
            pluralGenitive: '{{count}} лет'
          }
        }),
        overXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'больше {{count}} года',
            singularGenitive: 'больше {{count}} лет',
            pluralGenitive: 'больше {{count}} лет'
          },
          future: {
            singularNominative: 'больше, чем через {{count}} год',
            singularGenitive: 'больше, чем через {{count}} года',
            pluralGenitive: 'больше, чем через {{count}} лет'
          }
        }),
        almostXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'почти {{count}} год',
            singularGenitive: 'почти {{count}} года',
            pluralGenitive: 'почти {{count}} лет'
          },
          future: {
            singularNominative: 'почти через {{count}} год',
            singularGenitive: 'почти через {{count}} года',
            pluralGenitive: 'почти через {{count}} лет'
          }
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        return formatDistanceLocale[token](count, options);
      }
      /***/

    },
    /* 761 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, do MMMM y 'г.'",
        long: "do MMMM y 'г.'",
        medium: "d MMM y 'г.'",
        short: 'dd.MM.y'
      };
      var timeFormats = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        any: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 762 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13);

      var accusativeWeekdays = ['воскресенье', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу'];

      function _lastWeek6(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
            return "'в прошлое " + weekday + " в' p";

          case 1:
          case 2:
          case 4:
            return "'в прошлый " + weekday + " в' p";

          case 3:
          case 5:
          case 6:
            return "'в прошлую " + weekday + " в' p";
        }
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];

        if (day === 2
        /* Tue */
        ) {
          return "'во " + weekday + " в' p";
        } else {
          return "'в " + weekday + " в' p";
        }
      }

      function _nextWeek6(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
            return "'в следующее " + weekday + " в' p";

          case 1:
          case 2:
          case 4:
            return "'в следующий " + weekday + " в' p";

          case 3:
          case 5:
          case 6:
            return "'в следующую " + weekday + " в' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _lastWeek6(day);
          }
        },
        yesterday: "'вчера в' p",
        today: "'сегодня в' p",
        tomorrow: "'завтра в' p",
        nextWeek: function nextWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _nextWeek6(day);
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 763 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['до н.э.', 'н.э.'],
        abbreviated: ['до н. э.', 'н. э.'],
        wide: ['до нашей эры', 'нашей эры']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
        wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
      };
      var monthValues = {
        narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
        abbreviated: ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
        wide: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь']
      };
      var formattingMonthValues = {
        narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
        abbreviated: ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июн.', 'июл.', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
        wide: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
      };
      var dayValues = {
        narrow: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
        short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
        abbreviated: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
        wide: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'полн.',
          noon: 'полд.',
          morning: 'утро',
          afternoon: 'день',
          evening: 'веч.',
          night: 'ночь'
        },
        abbreviated: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'полн.',
          noon: 'полд.',
          morning: 'утро',
          afternoon: 'день',
          evening: 'веч.',
          night: 'ночь'
        },
        wide: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'полночь',
          noon: 'полдень',
          morning: 'утро',
          afternoon: 'день',
          evening: 'вечер',
          night: 'ночь'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'полн.',
          noon: 'полд.',
          morning: 'утра',
          afternoon: 'дня',
          evening: 'веч.',
          night: 'ночи'
        },
        abbreviated: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'полн.',
          noon: 'полд.',
          morning: 'утра',
          afternoon: 'дня',
          evening: 'веч.',
          night: 'ночи'
        },
        wide: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'полночь',
          noon: 'полдень',
          morning: 'утра',
          afternoon: 'дня',
          evening: 'вечера',
          night: 'ночи'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (unit === 'date') {
          suffix = '-е';
        } else if (unit === 'week' || unit === 'minute' || unit === 'second') {
          suffix = '-я';
        } else {
          suffix = '-й';
        }

        return dirtyNumber + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'any',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 764 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((до )?н\.?\s?э\.?)/i,
        abbreviated: /^((до )?н\.?\s?э\.?)/i,
        wide: /^(до нашей эры|нашей эры|наша эра)/i
      };
      var parseEraPatterns = {
        any: [/^д/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
        wide: /^[1234](-?[ыои]?й?)? квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[яфмаисонд]/i,
        abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)/i,
        wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
      };
      var parseMonthPatterns = {
        narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
        any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
      };
      var matchDayPatterns = {
        narrow: /^[впсч]/i,
        short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
        abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
        wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
      };
      var parseDayPatterns = {
        narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
        abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
        wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^дп/i,
          pm: /^пп/i,
          midnight: /^полн/i,
          noon: /^полд/i,
          morning: /^у/i,
          afternoon: /^д[ен]/i,
          evening: /^в/i,
          night: /^н/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 765 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(766);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(767);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(768);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(769);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(770);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Slovak locale.
       * @language Slovak
       * @iso-639-2 slk
       * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
       */


      var locale = {
        code: 'sk',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 766 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance; // NOTE: should prolly be improved
      // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308

      function declensionGroup(scheme, count) {
        if (count === 1) {
          return scheme.one;
        }

        if (count >= 2 && count <= 4) {
          return scheme.twoFour;
        } // if count === null || count === 0 || count >= 5


        return scheme.other;
      }

      function declension(scheme, count, time) {
        var group = declensionGroup(scheme, count);
        var finalText = group[time] || group;
        return finalText.replace('{{count}}', count);
      }

      function extractPreposition(token) {
        var result = ['lessThan', 'about', 'over', 'almost'].filter(function (preposition) {
          return !!token.match(new RegExp('^' + preposition));
        });
        return result[0];
      }

      function prefixPreposition(preposition) {
        var translation = '';

        if (preposition === 'almost') {
          translation = 'takmer';
        }

        if (preposition === 'about') {
          translation = 'približne';
        }

        return translation.length > 0 ? translation + ' ' : '';
      }

      function suffixPreposition(preposition) {
        var translation = '';

        if (preposition === 'lessThan') {
          translation = 'menej než';
        }

        if (preposition === 'over') {
          translation = 'viac než';
        }

        return translation.length > 0 ? translation + ' ' : '';
      }

      function lowercaseFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
      }

      var formatDistanceLocale = {
        xSeconds: {
          one: {
            regular: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
          },
          twoFour: {
            regular: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
          },
          other: {
            regular: '{{count}} sekúnd',
            past: '{{count}} sekundami',
            future: '{{count}} sekúnd'
          }
        },
        halfAMinute: {
          other: {
            regular: 'pol minúty',
            past: 'pol minútou',
            future: 'pol minúty'
          }
        },
        xMinutes: {
          one: {
            regular: 'minúta',
            past: 'minútou',
            future: 'minútu'
          },
          twoFour: {
            regular: '{{count}} minúty',
            past: '{{count}} minútami',
            future: '{{count}} minúty'
          },
          other: {
            regular: '{{count}} minút',
            past: '{{count}} minútami',
            future: '{{count}} minút'
          }
        },
        xHours: {
          one: {
            regular: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
          },
          twoFour: {
            regular: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
          },
          other: {
            regular: '{{count}} hodín',
            past: '{{count}} hodinami',
            future: '{{count}} hodín'
          }
        },
        xDays: {
          one: {
            regular: 'deň',
            past: 'dňom',
            future: 'deň'
          },
          twoFour: {
            regular: '{{count}} dni',
            past: '{{count}} dňami',
            future: '{{count}} dni'
          },
          other: {
            regular: '{{count}} dní',
            past: '{{count}} dňami',
            future: '{{count}} dní'
          }
        },
        xWeeks: {
          one: {
            regular: 'mesiac',
            // TODO
            past: 'mesiacom',
            // TODO
            future: 'mesiac' // TODO

          },
          twoFour: {
            regular: '{{count}} mesiace',
            // TODO
            past: '{{count}} mesiacmi',
            // TODO
            future: '{{count}} mesiace' // TODO

          },
          other: {
            regular: '{{count}} mesiacov',
            // TODO
            past: '{{count}} mesiacmi',
            // TODO
            future: '{{count}} mesiacov' // TODO

          }
        },
        xMonths: {
          one: {
            regular: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
          },
          twoFour: {
            regular: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
          },
          other: {
            regular: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
          }
        },
        xYears: {
          one: {
            regular: 'rok',
            past: 'rokom',
            future: 'rok'
          },
          twoFour: {
            regular: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
          },
          other: {
            regular: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
          }
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var preposition = extractPreposition(token) || '';
        var key = lowercaseFirstLetter(token.substring(preposition.length));
        var scheme = formatDistanceLocale[key];

        if (!options.addSuffix) {
          return prefixPreposition(preposition) + suffixPreposition(preposition) + declension(scheme, count, 'regular');
        }

        if (options.comparison > 0) {
          return prefixPreposition(preposition) + 'o ' + suffixPreposition(preposition) + declension(scheme, count, 'future');
        } else {
          return prefixPreposition(preposition) + 'pred ' + suffixPreposition(preposition) + declension(scheme, count, 'past');
        }
      }
      /***/

    },
    /* 767 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2); // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986


      var dateFormats = {
        full: 'EEEE d. MMMM y',
        long: 'd. MMMM y',
        medium: 'd. M. y',
        short: 'd. M. y' // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149

      };
      var timeFormats = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm' // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994

      };
      var dateTimeFormats = {
        full: '{{date}}, {{time}}',
        long: '{{date}}, {{time}}',
        medium: '{{date}}, {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 768 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13); // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308


      var accusativeWeekdays = ['nedeľu', 'pondelok', 'utorok', 'stredu', 'štvrtok', 'piatok', 'sobotu'];

      function _lastWeek7(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          /* Sun */

          case 3:
          /* Wed */

          case 6
          /* Sat */
          :
            return "'minulú " + weekday + " o' p";

          default:
            return "'minulý' eeee 'o' p";
        }
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];

        if (day === 4
        /* Thu */
        ) {
          return "'vo' eeee 'o' p";
        } else {
          return "'v " + weekday + " o' p";
        }
      }

      function _nextWeek7(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          /* Sun */

          case 4:
          /* Wed */

          case 6
          /* Sat */
          :
            return "'budúcu' " + weekday + " 'o' p";

          default:
            return "'budúci' eeee 'o' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _lastWeek7(day);
          }
        },
        yesterday: "'včera o' p",
        today: "'dnes o' p",
        tomorrow: "'zajtra o' p",
        nextWeek: function nextWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _nextWeek7(day);
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 769 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3); // https://www.unicode.org/cldr/charts/32/summary/sk.html#1772


      var eraValues = {
        narrow: ['pred Kr.', 'po Kr.'],
        abbreviated: ['pred Kr.', 'po Kr.'],
        wide: ['pred Kristom', 'po Kristovi'] // https://www.unicode.org/cldr/charts/32/summary/sk.html#1780

      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1. štvrťrok', '2. štvrťrok', '3. štvrťrok', '4. štvrťrok'] // https://www.unicode.org/cldr/charts/32/summary/sk.html#1804

      };
      var monthValues = {
        narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
        abbreviated: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
        wide: ['január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl', 'august', 'september', 'október', 'november', 'december']
      };
      var formattingMonthValues = {
        narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
        abbreviated: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
        wide: ['januára', 'februára', 'marca', 'apríla', 'mája', 'júna', 'júla', 'augusta', 'septembra', 'októbra', 'novembra', 'decembra'] // https://www.unicode.org/cldr/charts/32/summary/sk.html#1876

      };
      var dayValues = {
        narrow: ['n', 'p', 'u', 's', 'š', 'p', 's'],
        short: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
        abbreviated: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
        wide: ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota'] // https://www.unicode.org/cldr/charts/32/summary/sk.html#1932

      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'poln.',
          noon: 'pol.',
          morning: 'ráno',
          afternoon: 'pop.',
          evening: 'več.',
          night: 'noc'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'poln.',
          noon: 'pol.',
          morning: 'ráno',
          afternoon: 'popol.',
          evening: 'večer',
          night: 'noc'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'polnoc',
          noon: 'poludnie',
          morning: 'ráno',
          afternoon: 'popoludnie',
          evening: 'večer',
          night: 'noc'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'o poln.',
          noon: 'nap.',
          morning: 'ráno',
          afternoon: 'pop.',
          evening: 'več.',
          night: 'v n.'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'o poln.',
          noon: 'napol.',
          morning: 'ráno',
          afternoon: 'popol.',
          evening: 'večer',
          night: 'v noci'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'o polnoci',
          noon: 'napoludnie',
          morning: 'ráno',
          afternoon: 'popoludní',
          evening: 'večer',
          night: 'v noci'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues // defaultWidth: 'wide'

        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 770 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)\.?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
        abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
        wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
      };
      var parseEraPatterns = {
        any: [/^pr/i, /^(po|n)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234]\. [šs]tvr[ťt]rok/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
        wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[npusšp]/i,
        short: /^(ne|po|ut|st|št|pi|so)/i,
        abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
        wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
      };
      var parseDayPatterns = {
        narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
        any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
        abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
        any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^am/i,
          pm: /^pm/i,
          midnight: /poln/i,
          noon: /^(nap|(na)?pol(\.|u))/i,
          morning: /^r[áa]no/i,
          afternoon: /^pop/i,
          evening: /^ve[čc]/i,
          night: /^(noc|v n\.)/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 771 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(772);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(773);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(774);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(775);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(776);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Slovenian locale.
       * @language Slovenian
       * @iso-639-2 slv
       * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
       * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
       */


      var locale = {
        code: 'sl',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 772 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var distanceInWordsLocale = {
        lessThanXSeconds: {
          one: 'manj kot {{count}} sekunda',
          two: 'manj kot {{count}} sekundi',
          few: 'manj kot {{count}} sekunde',
          other: 'manj kot {{count}} sekund'
        },
        xSeconds: {
          one: '{{count}} sekunda',
          two: '{{count}} sekundi',
          few: '{{count}} sekunde',
          other: '{{count}} sekund'
        },
        halfAMinute: 'pol minute',
        lessThanXMinutes: {
          one: 'manj kot {{count}} minuta',
          two: 'manj kot {{count}} minuti',
          few: 'manj kot {{count}} minute',
          other: 'manj kot {{count}} minut'
        },
        xMinutes: {
          one: '{{count}} minuta',
          two: '{{count}} minuti',
          few: '{{count}} minute',
          other: '{{count}} minut'
        },
        aboutXHours: {
          one: 'približno {{count}} ura',
          two: 'približno {{count}} uri',
          few: 'približno {{count}} ure',
          other: 'približno {{count}} ur'
        },
        xHours: {
          one: '{{count}} ura',
          two: '{{count}} uri',
          few: '{{count}} ure',
          other: '{{count}} ur'
        },
        xDays: {
          one: '{{count}} dan',
          two: '{{count}} dni',
          few: '{{count}} dni',
          other: '{{count}} dni'
        },
        aboutXWeeks: {
          one: 'približno {{count}} teden',
          two: 'približno {{count}} tedna',
          few: 'približno {{count}} tedne',
          other: 'približno {{count}} tednov'
        },
        xWeeks: {
          one: '{{count}} teden',
          two: '{{count}} tedna',
          few: '{{count}} tedne',
          other: '{{count}} tednov'
        },
        aboutXMonths: {
          one: 'približno {{count}} mesec',
          two: 'približno {{count}} meseca',
          few: 'približno {{count}} mesece',
          other: 'približno {{count}} mesecev'
        },
        xMonths: {
          one: '{{count}} mesec',
          two: '{{count}} meseca',
          few: '{{count}} meseci',
          other: '{{count}} mesecev'
        },
        aboutXYears: {
          one: 'približno {{count}} leto',
          two: 'približno {{count}} leti',
          few: 'približno {{count}} leta',
          other: 'približno {{count}} let'
        },
        xYears: {
          one: '{{count}} leto',
          two: '{{count}} leti',
          few: '{{count}} leta',
          other: '{{count}} let'
        },
        overXYears: {
          one: 'več kot {{count}} leto',
          two: 'več kot {{count}} leti',
          few: 'več kot {{count}} leta',
          other: 'več kot {{count}} let'
        },
        almostXYears: {
          one: 'skoraj {{count}} leto',
          two: 'skoraj {{count}} leti',
          few: 'skoraj {{count}} leta',
          other: 'skoraj {{count}} let'
        }
      };
      var distanceInWordsLocalePast = {
        lessThanXSeconds: {
          one: 'manj kot {{count}} sekundo',
          two: 'manj kot {{count}} sekundama',
          few: 'manj kot {{count}} sekundami',
          other: 'manj kot {{count}} sekundami'
        },
        xSeconds: {
          one: '{{count}} sekundo',
          two: '{{count}} sekundama',
          few: '{{count}} sekundami',
          other: '{{count}} sekundami'
        },
        halfAMinute: 'pol minute',
        lessThanXMinutes: {
          one: 'manj kot {{count}} minuto',
          two: 'manj kot {{count}} minutama',
          few: 'manj kot {{count}} minutami',
          other: 'manj kot {{count}} minutami'
        },
        xMinutes: {
          one: '{{count}} minuto',
          two: '{{count}} minutama',
          few: '{{count}} minutami',
          other: '{{count}} minutami'
        },
        aboutXHours: {
          one: 'približno {{count}} uro',
          two: 'približno {{count}} urama',
          few: 'približno {{count}} urami',
          other: 'približno {{count}} urami'
        },
        xHours: {
          one: '{{count}} uro',
          two: '{{count}} urama',
          few: '{{count}} urami',
          other: '{{count}} urami'
        },
        xDays: {
          one: '{{count}} dnem',
          two: '{{count}} dnevoma',
          few: '{{count}} dnevi',
          other: '{{count}} dnevi'
        },
        aboutXMonths: {
          one: 'približno {{count}} mesecem',
          two: 'približno {{count}} mesecema',
          few: 'približno {{count}} meseci',
          other: 'približno {{count}} meseci'
        },
        xMonths: {
          one: '{{count}} mesecem',
          two: '{{count}} mesecema',
          few: '{{count}} meseci',
          other: '{{count}} meseci'
        },
        aboutXYears: {
          one: 'približno {{count}} letom',
          two: 'približno {{count}} letoma',
          few: 'približno {{count}} leti',
          other: 'približno {{count}} leti'
        },
        xYears: {
          one: '{{count}} letom',
          two: '{{count}} letoma',
          few: '{{count}} leti',
          other: '{{count}} leti'
        },
        overXYears: {
          one: 'več kot {{count}} letom',
          two: 'več kot {{count}} letoma',
          few: 'več kot {{count}} leti',
          other: 'več kot {{count}} leti'
        },
        almostXYears: {
          one: 'skoraj {{count}} letom',
          two: 'skoraj {{count}} letoma',
          few: 'skoraj {{count}} leti',
          other: 'skoraj {{count}} leti'
        }
      };
      var distanceInWordsLocaleFuture = {
        lessThanXSeconds: {
          one: 'manj kot {{count}} sekundo',
          two: 'manj kot {{count}} sekundi',
          few: 'manj kot {{count}} sekunde',
          other: 'manj kot {{count}} sekund'
        },
        xSeconds: {
          one: '{{count}} sekundo',
          two: '{{count}} sekundi',
          few: '{{count}} sekunde',
          other: '{{count}} sekund'
        },
        halfAMinute: 'pol minute',
        lessThanXMinutes: {
          one: 'manj kot {{count}} minuto',
          two: 'manj kot {{count}} minuti',
          few: 'manj kot {{count}} minute',
          other: 'manj kot {{count}} minut'
        },
        xMinutes: {
          one: '{{count}} minuto',
          two: '{{count}} minuti',
          few: '{{count}} minute',
          other: '{{count}} minut'
        },
        aboutXHours: {
          one: 'približno {{count}} uro',
          two: 'približno {{count}} uri',
          few: 'približno {{count}} ure',
          other: 'približno {{count}} ur'
        },
        xHours: {
          one: '{{count}} uro',
          two: '{{count}} uri',
          few: '{{count}} ure',
          other: '{{count}} ur'
        },
        xDays: {
          one: '{{count}} dan',
          two: '{{count}} dni',
          few: '{{count}} dni',
          other: '{{count}} dni'
        },
        aboutXMonths: {
          one: 'približno {{count}} mesec',
          two: 'približno {{count}} meseca',
          few: 'približno {{count}} mesece',
          other: 'približno {{count}} mesecev'
        },
        xMonths: {
          one: '{{count}} mesec',
          two: '{{count}} meseca',
          few: '{{count}} mesece',
          other: '{{count}} mesecev'
        },
        aboutXYears: {
          one: 'približno {{count}} leto',
          two: 'približno {{count}} leti',
          few: 'približno {{count}} leta',
          other: 'približno {{count}} let'
        },
        xYears: {
          one: '{{count}} leto',
          two: '{{count}} leti',
          few: '{{count}} leta',
          other: '{{count}} let'
        },
        overXYears: {
          one: 'več kot {{count}} leto',
          two: 'več kot {{count}} leti',
          few: 'več kot {{count}} leta',
          other: 'več kot {{count}} let'
        },
        almostXYears: {
          one: 'skoraj {{count}} leto',
          two: 'skoraj {{count}} leti',
          few: 'skoraj {{count}} leta',
          other: 'skoraj {{count}} let'
        }
      };

      function getFormFromCount(count) {
        switch (count % 100) {
          case 1:
            return 'one';

          case 2:
            return 'two';

          case 3:
          case 4:
            return 'few';

          default:
            return 'other';
        }
      }

      function formatDistance(token, count, options) {
        options = options || {};
        var localeObject = distanceInWordsLocale;
        var result = '';

        if (options.addSuffix) {
          if (options.comparison > 0) {
            localeObject = distanceInWordsLocaleFuture;
            result += 'čez ';
          } else {
            localeObject = distanceInWordsLocalePast;
            result += 'pred ';
          }
        }

        if (typeof localeObject[token] === 'string') {
          result += localeObject[token];
        } else {
          var form = getFormFromCount(count);
          result += localeObject[token][form].replace('{{count}}', count);
        }

        return result;
      }
      /***/

    },
    /* 773 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, dd. MMMM y',
        long: 'dd. MMMM y',
        medium: 'd. MMM y',
        short: 'd. MM. yy'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 774 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function lastWeek(date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'prejšnjo nedeljo ob' p";

            case 3:
              return "'prejšnjo sredo ob' p";

            case 6:
              return "'prejšnjo soboto ob' p";

            default:
              return "'prejšnji' EEEE 'ob' p";
          }
        },
        yesterday: "'včeraj ob' p",
        today: "'danes ob' p",
        tomorrow: "'jutri ob' p",
        nextWeek: function nextWeek(date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'naslednjo nedeljo ob' p";

            case 3:
              return "'naslednjo sredo ob' p";

            case 6:
              return "'naslednjo soboto ob' p";

            default:
              return "'naslednji' EEEE 'ob' p";
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date);
        }

        return format;
      }
      /***/

    },
    /* 775 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number).concat('.');
      }

      var eraValues = {
        narrow: ['pr. n. št.', 'po n. št.'],
        abbreviated: ['pr. n. št.', 'po n. št.'],
        wide: ['pred našim štetjem', 'po našem štetju']
      };
      var monthValues = {
        narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
        abbreviated: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
        wide: ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1. čet.', '2. čet.', '3. čet.', '4. čet.'],
        wide: ['1. četrtletje', '2. četrtletje', '3. četrtletje', '4. četrtletje']
      };
      var dayValues = {
        narrow: ['n', 'p', 't', 's', 'č', 'p', 's'],
        short: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
        abbreviated: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
        wide: ['nedelja', 'ponedeljek', 'torek', 'sreda', 'četrtek', 'petek', 'sobota']
      };
      var dayPeriodValuesStandalone = {
        narrow: {
          am: 'd',
          pm: 'p',
          midnight: '24.00',
          noon: '12.00',
          morning: 'j',
          afternoon: 'p',
          evening: 'v',
          night: 'n'
        },
        abbreviated: {
          am: 'dop.',
          pm: 'pop.',
          midnight: 'poln.',
          noon: 'pold.',
          morning: 'jut.',
          afternoon: 'pop.',
          evening: 'več.',
          night: 'noč'
        },
        wide: {
          am: 'dop.',
          pm: 'pop.',
          midnight: 'polnoč',
          noon: 'poldne',
          morning: 'jutro',
          afternoon: 'popoldne',
          evening: 'večer',
          night: 'noč'
        }
      };
      var dayPeriodValuesFormatting = {
        narrow: {
          am: 'd',
          pm: 'p',
          midnight: '24.00',
          noon: '12.00',
          morning: 'zj',
          afternoon: 'p',
          evening: 'zv',
          night: 'po'
        },
        abbreviated: {
          am: 'dop.',
          pm: 'pop.',
          midnight: 'opoln.',
          noon: 'opold.',
          morning: 'zjut.',
          afternoon: 'pop.',
          evening: 'zveč.',
          night: 'ponoči'
        },
        wide: {
          am: 'dop.',
          pm: 'pop.',
          midnight: 'opolnoči',
          noon: 'opoldne',
          morning: 'zjutraj',
          afternoon: 'popoldan',
          evening: 'zvečer',
          night: 'ponoči'
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValuesStandalone,
          defaultWidth: 'wide',
          formattingValues: dayPeriodValuesFormatting,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 776 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
        wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
      };
      var parseEraPatterns = {
        any: [/^pr/i, /^(po|na[sš]em)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\.\s?[čc]et\.?/i,
        wide: /^[1234]\. [čc]etrtletje/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
        wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        abbreviated: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i],
        wide: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[nptsčc]/i,
        short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
        abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
        wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
      };
      var parseDayPatterns = {
        narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
        any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
        any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
      };
      var parseDayPeriodPatterns = {
        narrow: {
          am: /^d/i,
          pm: /^p/i,
          midnight: /^24/i,
          noon: /^12/i,
          morning: /^(z?j)/i,
          afternoon: /^p/i,
          evening: /^(z?v)/i,
          night: /^(n|po)/i
        },
        any: {
          am: /^dop\./i,
          pm: /^pop\./i,
          midnight: /^o?poln/i,
          noon: /^o?pold/i,
          morning: /j/i,
          afternoon: /^pop\./i,
          evening: /^z?ve/i,
          night: /(po)?no/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 777 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(778);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(779);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(780);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(781);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(782);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Serbian cyrillic locale.
       * @language Serbian
       * @iso-639-2 srp
       * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
       */


      var locale = {
        code: 'sr',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 778 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            standalone: 'мање од 1 секунде',
            withPrepositionAgo: 'мање од 1 секунде',
            withPrepositionIn: 'мање од 1 секунду'
          },
          dual: 'мање од {{count}} секунде',
          other: 'мање од {{count}} секунди'
        },
        xSeconds: {
          one: {
            standalone: '1 секунда',
            withPrepositionAgo: '1 секунде',
            withPrepositionIn: '1 секунду'
          },
          dual: '{{count}} секунде',
          other: '{{count}} секунди'
        },
        halfAMinute: 'пола минуте',
        lessThanXMinutes: {
          one: {
            standalone: 'мање од 1 минуте',
            withPrepositionAgo: 'мање од 1 минуте',
            withPrepositionIn: 'мање од 1 минуту'
          },
          dual: 'мање од {{count}} минуте',
          other: 'мање од {{count}} минута'
        },
        xMinutes: {
          one: {
            standalone: '1 минута',
            withPrepositionAgo: '1 минуте',
            withPrepositionIn: '1 минуту'
          },
          dual: '{{count}} минуте',
          other: '{{count}} минута'
        },
        aboutXHours: {
          one: {
            standalone: 'око 1 сат',
            withPrepositionAgo: 'око 1 сат',
            withPrepositionIn: 'око 1 сат'
          },
          dual: 'око {{count}} сата',
          other: 'око {{count}} сати'
        },
        xHours: {
          one: {
            standalone: '1 сат',
            withPrepositionAgo: '1 сат',
            withPrepositionIn: '1 сат'
          },
          dual: '{{count}} сата',
          other: '{{count}} сати'
        },
        xDays: {
          one: {
            standalone: '1 дан',
            withPrepositionAgo: '1 дан',
            withPrepositionIn: '1 дан'
          },
          dual: '{{count}} дана',
          other: '{{count}} дана'
        },
        aboutXWeeks: {
          one: {
            standalone: 'око 1 недељу',
            withPrepositionAgo: 'око 1 недељу',
            withPrepositionIn: 'око 1 недељу'
          },
          dual: 'око {{count}} недеље',
          other: 'око {{count}} недеље'
        },
        xWeeks: {
          one: {
            standalone: '1 недељу',
            withPrepositionAgo: '1 недељу',
            withPrepositionIn: '1 недељу'
          },
          dual: '{{count}} недеље',
          other: '{{count}} недеље'
        },
        aboutXMonths: {
          one: {
            standalone: 'око 1 месец',
            withPrepositionAgo: 'око 1 месец',
            withPrepositionIn: 'око 1 месец'
          },
          dual: 'око {{count}} месеца',
          other: 'око {{count}} месеци'
        },
        xMonths: {
          one: {
            standalone: '1 месец',
            withPrepositionAgo: '1 месец',
            withPrepositionIn: '1 месец'
          },
          dual: '{{count}} месеца',
          other: '{{count}} месеци'
        },
        aboutXYears: {
          one: {
            standalone: 'око 1 годину',
            withPrepositionAgo: 'око 1 годину',
            withPrepositionIn: 'око 1 годину'
          },
          dual: 'око {{count}} године',
          other: 'око {{count}} година'
        },
        xYears: {
          one: {
            standalone: '1 година',
            withPrepositionAgo: '1 године',
            withPrepositionIn: '1 годину'
          },
          dual: '{{count}} године',
          other: '{{count}} година'
        },
        overXYears: {
          one: {
            standalone: 'преко 1 годину',
            withPrepositionAgo: 'преко 1 годину',
            withPrepositionIn: 'преко 1 годину'
          },
          dual: 'преко {{count}} године',
          other: 'преко {{count}} година'
        },
        almostXYears: {
          one: {
            standalone: 'готово 1 годину',
            withPrepositionAgo: 'готово 1 годину',
            withPrepositionIn: 'готово 1 годину'
          },
          dual: 'готово {{count}} године',
          other: 'готово {{count}} година'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              result = formatDistanceLocale[token].one.withPrepositionIn;
            } else {
              result = formatDistanceLocale[token].one.withPrepositionAgo;
            }
          } else {
            result = formatDistanceLocale[token].one.standalone;
          }
        } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
        String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
        ) {
          result = formatDistanceLocale[token].dual.replace('{{count}}', count);
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'за ' + result;
          } else {
            return 'пре ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 779 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d. MMMM yyyy.',
        long: 'd. MMMM yyyy.',
        medium: 'd. MMM yy.',
        short: 'dd. MM. yy.'
      };
      var timeFormats = {
        full: 'HH:mm:ss (zzzz)',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'у' {{time}}",
        long: "{{date}} 'у' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 780 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function lastWeek(date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'прошле недеље у' p";

            case 3:
              return "'прошле среде у' p";

            case 6:
              return "'прошле суботе у' p";

            default:
              return "'прошли' EEEE 'у' p";
          }
        },
        yesterday: "'јуче у' p",
        today: "'данас у' p",
        tomorrow: "'сутра у' p",
        nextWeek: function nextWeek(date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'следеће недеље у' p";

            case 3:
              return "'следећу среду у' p";

            case 6:
              return "'следећу суботу у' p";

            default:
              return "'следећи' EEEE 'у' p";
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date);
        }

        return format;
      }
      /***/

    },
    /* 781 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number).concat('.');
      }

      var eraValues = {
        narrow: ['пр.н.е.', 'АД'],
        abbreviated: ['пр. Хр.', 'по. Хр.'],
        wide: ['Пре Христа', 'После Христа']
      };
      var monthValues = {
        narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
        abbreviated: ['јан', 'феб', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'сеп', 'окт', 'нов', 'дец'],
        wide: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар']
      };
      var formattingMonthValues = {
        narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
        abbreviated: ['јан', 'феб', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'сеп', 'окт', 'нов', 'дец'],
        wide: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар']
      };
      var quarterValues = {
        narrow: ['1.', '2.', '3.', '4.'],
        abbreviated: ['1. кв.', '2. кв.', '3. кв.', '4. кв.'],
        wide: ['1. квартал', '2. квартал', '3. квартал', '4. квартал']
      };
      var dayValues = {
        narrow: ['Н', 'П', 'У', 'С', 'Ч', 'П', 'С'],
        short: ['нед', 'пон', 'уто', 'сре', 'чет', 'пет', 'суб'],
        abbreviated: ['нед', 'пон', 'уто', 'сре', 'чет', 'пет', 'суб'],
        wide: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота']
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'АМ',
          pm: 'ПМ',
          midnight: 'поноћ',
          noon: 'подне',
          morning: 'ујутру',
          afternoon: 'поподне',
          evening: 'увече',
          night: 'ноћу'
        },
        abbreviated: {
          am: 'АМ',
          pm: 'ПМ',
          midnight: 'поноћ',
          noon: 'подне',
          morning: 'ујутру',
          afternoon: 'поподне',
          evening: 'увече',
          night: 'ноћу'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'поноћ',
          noon: 'подне',
          morning: 'ујутру',
          afternoon: 'после подне',
          evening: 'увече',
          night: 'ноћу'
        }
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'поноћ',
          noon: 'подне',
          morning: 'ујутру',
          afternoon: 'поподне',
          evening: 'увече',
          night: 'ноћу'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'поноћ',
          noon: 'подне',
          morning: 'ујутру',
          afternoon: 'поподне',
          evening: 'увече',
          night: 'ноћу'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'поноћ',
          noon: 'подне',
          morning: 'ујутру',
          afternoon: 'после подне',
          evening: 'увече',
          night: 'ноћу'
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 782 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(пр\.н\.е\.|АД)/i,
        abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
        wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
      };
      var parseEraPatterns = {
        any: [/^пр/i, /^(по|нова)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\.\s?кв\.?/i,
        wide: /^[1234]\. квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(10|11|12|[123456789])\./i,
        abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
        wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
      };
      var parseMonthPatterns = {
        narrow: [/(10|11|12|[123456789])/i],
        any: [/^ја/i, /^ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^авг/i, /^с/i, /^о/i, /^н/i, /^д/i]
      };
      var matchDayPatterns = {
        narrow: /^[пусчн]/i,
        short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
        abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
        wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
      };
      var parseDayPatterns = {
        narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^н/i],
        any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^поно/i,
          noon: /^под/i,
          morning: /ујутру/i,
          afternoon: /(после\s|по)+подне/i,
          evening: /(увече)/i,
          night: /(ноћу)/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 783 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(784);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(785);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(786);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(787);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(788);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Serbian latin locale.
       * @language Serbian
       * @iso-639-2 srp
       * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
       */


      var locale = {
        code: 'sr-Latn',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 784 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
          },
          dual: 'manje od {{count}} sekunde',
          other: 'manje od {{count}} sekundi'
        },
        xSeconds: {
          one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
          },
          dual: '{{count}} sekunde',
          other: '{{count}} sekundi'
        },
        halfAMinute: 'pola minute',
        lessThanXMinutes: {
          one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
          },
          dual: 'manje od {{count}} minute',
          other: 'manje od {{count}} minuta'
        },
        xMinutes: {
          one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
          },
          dual: '{{count}} minute',
          other: '{{count}} minuta'
        },
        aboutXHours: {
          one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
          },
          dual: 'oko {{count}} sata',
          other: 'oko {{count}} sati'
        },
        xHours: {
          one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
          },
          dual: '{{count}} sata',
          other: '{{count}} sati'
        },
        xDays: {
          one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
          },
          dual: '{{count}} dana',
          other: '{{count}} dana'
        },
        aboutXWeeks: {
          one: {
            standalone: 'oko 1 nedelju',
            withPrepositionAgo: 'oko 1 nedelju',
            withPrepositionIn: 'oko 1 nedelju'
          },
          dual: 'oko {{count}} nedelje',
          other: 'oko {{count}} nedelje'
        },
        xWeeks: {
          one: {
            standalone: '1 nedelju',
            withPrepositionAgo: '1 nedelju',
            withPrepositionIn: '1 nedelju'
          },
          dual: '{{count}} nedelje',
          other: '{{count}} nedelje'
        },
        aboutXMonths: {
          one: {
            standalone: 'oko 1 mesec',
            withPrepositionAgo: 'oko 1 mesec',
            withPrepositionIn: 'oko 1 mesec'
          },
          dual: 'oko {{count}} meseca',
          other: 'oko {{count}} meseci'
        },
        xMonths: {
          one: {
            standalone: '1 mesec',
            withPrepositionAgo: '1 mesec',
            withPrepositionIn: '1 mesec'
          },
          dual: '{{count}} meseca',
          other: '{{count}} meseci'
        },
        aboutXYears: {
          one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
          },
          dual: 'oko {{count}} godine',
          other: 'oko {{count}} godina'
        },
        xYears: {
          one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
          },
          dual: '{{count}} godine',
          other: '{{count}} godina'
        },
        overXYears: {
          one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
          },
          dual: 'preko {{count}} godine',
          other: 'preko {{count}} godina'
        },
        almostXYears: {
          one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
          },
          dual: 'gotovo {{count}} godine',
          other: 'gotovo {{count}} godina'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              result = formatDistanceLocale[token].one.withPrepositionIn;
            } else {
              result = formatDistanceLocale[token].one.withPrepositionAgo;
            }
          } else {
            result = formatDistanceLocale[token].one.standalone;
          }
        } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
        String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
        ) {
          result = formatDistanceLocale[token].dual.replace('{{count}}', count);
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'za ' + result;
          } else {
            return 'pre ' + result;
          }
        }

        return result;
      }
      /***/

    },
    /* 785 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, d. MMMM yyyy.',
        long: 'd. MMMM yyyy.',
        medium: 'd. MMM yy.',
        short: 'dd. MM. yy.'
      };
      var timeFormats = {
        full: 'HH:mm:ss (zzzz)',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'u' {{time}}",
        long: "{{date}} 'u' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 786 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: function lastWeek(date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'prošle nedelje u' p";

            case 3:
              return "'prošle srede u' p";

            case 6:
              return "'prošle subote u' p";

            default:
              return "'prošli' EEEE 'u' p";
          }
        },
        yesterday: "'juče u' p",
        today: "'danas u' p",
        tomorrow: "'sutra u' p",
        nextWeek: function nextWeek(date) {
          var day = date.getUTCDay();

          switch (day) {
            case 0:
              return "'sledeće nedelje u' p";

            case 3:
              return "'sledeću sredu u' p";

            case 6:
              return "'sledeću subotu u' p";

            default:
              return "'sledeći' EEEE 'u' p";
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date);
        }

        return format;
      }
      /***/

    },
    /* 787 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return String(number).concat('.');
      }

      var eraValues = {
        narrow: ['pr.n.e.', 'AD'],
        abbreviated: ['pr. Hr.', 'po. Hr.'],
        wide: ['Pre Hrista', 'Posle Hrista']
      };
      var monthValues = {
        narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
        abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
        wide: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
      };
      var formattingMonthValues = {
        narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
        abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
        wide: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
      };
      var quarterValues = {
        narrow: ['1.', '2.', '3.', '4.'],
        abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
        wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
      };
      var dayValues = {
        narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
        short: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
        abbreviated: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
        wide: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota']
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutru',
          afternoon: 'popodne',
          evening: 'uveče',
          night: 'noću'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutru',
          afternoon: 'popodne',
          evening: 'uveče',
          night: 'noću'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutru',
          afternoon: 'posle podne',
          evening: 'uveče',
          night: 'noću'
        }
      };
      var dayPeriodValues = {
        narrow: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutru',
          afternoon: 'popodne',
          evening: 'uveče',
          night: 'noću'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutru',
          afternoon: 'popodne',
          evening: 'uveče',
          night: 'noću'
        },
        wide: {
          am: 'AM',
          pm: 'PM',
          midnight: 'ponoć',
          noon: 'podne',
          morning: 'ujutru',
          afternoon: 'posle podne',
          evening: 'uveče',
          night: 'noću'
        }
      };
      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 788 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__ = __webpack_require__(5);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);

      var matchOrdinalNumberPattern = /^(\d+)\./i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(pr\.n\.e\.|AD)/i,
        abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
        wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
      };
      var parseEraPatterns = {
        any: [/^pr/i, /^(po|nova)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]\.\s?kv\.?/i,
        wide: /^[1234]\. kvartal/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(10|11|12|[123456789])\./i,
        abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
        wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
      };
      var parseMonthPatterns = {
        narrow: [/(10|11|12|[123456789])/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[npusčc]/i,
        short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
        abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
        wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
      };
      var parseDayPatterns = {
        narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
        any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^pono/i,
          noon: /^pod/i,
          morning: /jutro/i,
          afternoon: /(posle\s|po)+podne/i,
          evening: /(uvece|uveče)/i,
          night: /(nocu|noću)/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 789 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(790);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(791);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(792);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(793);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(794);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Swedish locale.
       * @language Swedish
       * @iso-639-2 swe
       * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
       * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
       * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
       */


      var locale = {
        code: 'sv',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 790 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          singular: 'mindre än en sekund',
          plural: 'mindre än {{count}} sekunder'
        },
        xSeconds: {
          singular: 'en sekund',
          plural: '{{count}} sekunder'
        },
        halfAMinute: 'en halv minut',
        lessThanXMinutes: {
          singular: 'mindre än en minut',
          plural: 'mindre än {{count}} minuter'
        },
        xMinutes: {
          singular: 'en minut',
          plural: '{{count}} minuter'
        },
        aboutXHours: {
          singular: 'ungefär en timme',
          plural: 'ungefär {{count}} timmar'
        },
        xHours: {
          singular: 'en timme',
          plural: '{{count}} timmar'
        },
        xDays: {
          singular: 'en dag',
          plural: '{{count}} dagar'
        },
        aboutXWeeks: {
          singular: 'ungefär en vecka',
          plural: 'ungefär {{count}} vecka'
        },
        xWeeks: {
          singular: 'en vecka',
          plural: '{{count}} vecka'
        },
        aboutXMonths: {
          singular: 'ungefär en månad',
          plural: 'ungefär {{count}} månader'
        },
        xMonths: {
          singular: 'en månad',
          plural: '{{count}} månader'
        },
        aboutXYears: {
          singular: 'ungefär ett år',
          plural: 'ungefär {{count}} år'
        },
        xYears: {
          singular: 'ett år',
          plural: '{{count}} år'
        },
        overXYears: {
          singular: 'över ett år',
          plural: 'över {{count}} år'
        },
        almostXYears: {
          singular: 'nästan ett år',
          plural: 'nästan {{count}} år'
        }
      };
      var wordMapping = ['noll', 'en', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio', 'tio', 'elva', 'tolv'];

      function formatDistance(token, count, options) {
        options = options || {
          onlyNumeric: false
        };
        var translation = formatDistanceLocale[token];
        var result;

        if (typeof translation === 'string') {
          result = translation;
        } else if (count === 0 || count > 1) {
          if (options.onlyNumeric) {
            result = translation.plural.replace('{{count}}', count);
          } else {
            result = translation.plural.replace('{{count}}', count < 13 ? wordMapping[count] : count);
          }
        } else {
          result = translation.singular;
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return 'om ' + result;
          } else {
            return result + ' sedan';
          }
        }

        return result;
      }
      /***/

    },
    /* 791 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE d MMMM y',
        long: 'd MMMM y',
        medium: 'd MMM y',
        short: 'y-MM-dd'
      };
      var timeFormats = {
        full: "'kl'. HH:mm:ss zzzz",
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'kl.' {{time}}",
        long: "{{date}} 'kl.' {{time}}",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 792 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'i' EEEE's kl.' p",
        yesterday: "'igår kl.' p",
        today: "'idag kl.' p",
        tomorrow: "'imorgon kl.' p",
        nextWeek: "EEEE 'kl.' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 793 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['f.Kr.', 'e.Kr.'],
        abbreviated: ['f.Kr.', 'e.Kr.'],
        wide: ['före Kristus', 'efter Kristus']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['1:a kvartalet', '2:a kvartalet', '3:e kvartalet', '4:e kvartalet']
      };
      var monthValues = {
        narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
        wide: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
      };
      var dayValues = {
        narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
        short: ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
        abbreviated: ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'],
        wide: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'] // https://www.unicode.org/cldr/charts/32/summary/sv.html#1888

      };
      var dayPeriodValues = {
        narrow: {
          am: 'fm',
          pm: 'em',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'morg.',
          afternoon: 'efterm.',
          evening: 'kväll',
          night: 'natt'
        },
        abbreviated: {
          am: 'f.m.',
          pm: 'e.m.',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'morgon',
          afternoon: 'efterm.',
          evening: 'kväll',
          night: 'natt'
        },
        wide: {
          am: 'förmiddag',
          pm: 'eftermiddag',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'morgon',
          afternoon: 'eftermiddag',
          evening: 'kväll',
          night: 'natt'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'fm',
          pm: 'em',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'på morg.',
          afternoon: 'på efterm.',
          evening: 'på kvällen',
          night: 'på natten'
        },
        abbreviated: {
          am: 'fm',
          pm: 'em',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'på morg.',
          afternoon: 'på efterm.',
          evening: 'på kvällen',
          night: 'på natten'
        },
        wide: {
          am: 'fm',
          pm: 'em',
          midnight: 'midnatt',
          noon: 'middag',
          morning: 'på morgonen',
          afternoon: 'på eftermiddagen',
          evening: 'på kvällen',
          night: 'på natten'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        var rem100 = number % 100;

        if (rem100 > 20 || rem100 < 10) {
          switch (rem100 % 10) {
            case 1:
            case 2:
              return number + ':a';
          }
        }

        return number + ':e';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 794 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
        abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
        wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
      };
      var parseEraPatterns = {
        any: [/^f/i, /^[ev]/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](:a|:e)? kvartalet/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[jfmasond]/i,
        abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec)\.?/i,
        wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
      };
      var parseMonthPatterns = {
        narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[smtofl]/i,
        short: /^(sö|må|ti|on|to|fr|lö)/i,
        abbreviated: /^(sön|mån|tis|ons|tor|fre|lör)/i,
        wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
      };
      var parseDayPatterns = {
        any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
      };
      var matchDayPeriodPatterns = {
        any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^f/i,
          pm: /^e/i,
          midnight: /^midn/i,
          noon: /^midd/i,
          morning: /morgon/i,
          afternoon: /eftermiddag/i,
          evening: /kväll/i,
          night: /natt/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 795 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(796);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(797);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(798);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(799);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(800);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Tamil locale (India).
       * @language Tamil
       * @iso-639-2 tam
       * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
       */


      var locale = {
        code: 'ta',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 796 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: {
            default: 'ஒரு வினாடிக்கு குறைவாக',
            in: 'ஒரு வினாடிக்குள்',
            ago: 'ஒரு வினாடிக்கு முன்பு'
          },
          other: {
            default: '{{count}} வினாடிகளுக்கு குறைவாக',
            in: '{{count}} வினாடிகளுக்குள்',
            ago: '{{count}} வினாடிகளுக்கு முன்பு'
          }
        },
        xSeconds: {
          one: {
            default: '1 வினாடி',
            in: '1 வினாடியில்',
            ago: '1 வினாடி முன்பு'
          },
          other: {
            default: '{{count}} விநாடிகள்',
            in: '{{count}} வினாடிகளில்',
            ago: '{{count}} விநாடிகளுக்கு முன்பு'
          }
        },
        halfAMinute: {
          default: 'அரை நிமிடம்',
          in: 'அரை நிமிடத்தில்',
          ago: 'அரை நிமிடம் முன்பு'
        },
        lessThanXMinutes: {
          one: {
            default: 'ஒரு நிமிடத்திற்கும் குறைவாக',
            in: 'ஒரு நிமிடத்திற்குள்',
            ago: 'ஒரு நிமிடத்திற்கு முன்பு'
          },
          other: {
            default: '{{count}} நிமிடங்களுக்கும் குறைவாக',
            in: '{{count}} நிமிடங்களுக்குள்',
            ago: '{{count}} நிமிடங்களுக்கு முன்பு'
          }
        },
        xMinutes: {
          one: {
            default: '1 நிமிடம்',
            in: '1 நிமிடத்தில்',
            ago: '1 நிமிடம் முன்பு'
          },
          other: {
            default: '{{count}} நிமிடங்கள்',
            in: '{{count}} நிமிடங்களில்',
            ago: '{{count}} நிமிடங்களுக்கு முன்பு'
          }
        },
        aboutXHours: {
          one: {
            default: 'சுமார் 1 மணி நேரம்',
            in: 'சுமார் 1 மணி நேரத்தில்',
            ago: 'சுமார் 1 மணி நேரத்திற்கு முன்பு'
          },
          other: {
            default: 'சுமார் {{count}} மணி நேரம்',
            in: 'சுமார் {{count}} மணி நேரத்திற்கு முன்பு',
            ago: 'சுமார் {{count}} மணி நேரத்தில்'
          }
        },
        xHours: {
          one: {
            default: '1 மணி நேரம்',
            in: '1 மணி நேரத்தில்',
            ago: '1 மணி நேரத்திற்கு முன்பு'
          },
          other: {
            default: '{{count}} மணி நேரம்',
            in: '{{count}} மணி நேரத்தில்',
            ago: '{{count}} மணி நேரத்திற்கு முன்பு'
          }
        },
        xDays: {
          one: {
            default: '1 நாள்',
            in: '1 நாளில்',
            ago: '1 நாள் முன்பு'
          },
          other: {
            default: '{{count}} நாட்கள்',
            in: '{{count}} நாட்களில்',
            ago: '{{count}} நாட்களுக்கு முன்பு'
          }
        },
        aboutXWeeks: {
          one: {
            default: 'சுமார் 1 வாரம்',
            in: 'சுமார் 1 வாரத்தில்',
            ago: 'சுமார் 1 வாரம் முன்பு'
          },
          other: {
            default: 'சுமார் {{count}} வாரங்கள்',
            in: 'சுமார் {{count}} வாரங்களில்',
            ago: 'சுமார் {{count}} வாரங்களுக்கு முன்பு'
          }
        },
        xWeeks: {
          one: {
            default: '1 வாரம்',
            in: '1 வாரத்தில்',
            ago: '1 வாரம் முன்பு'
          },
          other: {
            default: '{{count}} வாரங்கள்',
            in: '{{count}} வாரங்களில்',
            ago: '{{count}} வாரங்களுக்கு முன்பு'
          }
        },
        aboutXMonths: {
          one: {
            default: 'சுமார் 1 மாதம்',
            in: 'சுமார் 1 மாதத்தில்',
            ago: 'சுமார் 1 மாதத்திற்கு முன்பு'
          },
          other: {
            default: 'சுமார் {{count}} மாதங்கள்',
            in: 'சுமார் {{count}} மாதங்களில்',
            ago: 'சுமார் {{count}} மாதங்களுக்கு முன்பு'
          }
        },
        xMonths: {
          one: {
            default: '1 மாதம்',
            in: '1 மாதத்தில்',
            ago: '1 மாதம் முன்பு'
          },
          other: {
            default: '{{count}} மாதங்கள்',
            in: '{{count}} மாதங்களில்',
            ago: '{{count}} மாதங்களுக்கு முன்பு'
          }
        },
        aboutXYears: {
          one: {
            default: 'சுமார் 1 வருடம்',
            in: 'சுமார் 1 ஆண்டில்',
            ago: 'சுமார் 1 வருடம் முன்பு'
          },
          other: {
            default: 'சுமார் {{count}} ஆண்டுகள்',
            in: 'சுமார் {{count}} ஆண்டுகளில்',
            ago: 'சுமார் {{count}} ஆண்டுகளுக்கு முன்பு'
          }
        },
        xYears: {
          one: {
            default: '1 வருடம்',
            in: '1 ஆண்டில்',
            ago: '1 வருடம் முன்பு'
          },
          other: {
            default: '{{count}} ஆண்டுகள்',
            in: '{{count}} ஆண்டுகளில்',
            ago: '{{count}} ஆண்டுகளுக்கு முன்பு'
          }
        },
        overXYears: {
          one: {
            default: '1 வருடத்திற்கு மேல்',
            in: '1 வருடத்திற்கும் மேலாக',
            ago: '1 வருடம் முன்பு'
          },
          other: {
            default: '{{count}} ஆண்டுகளுக்கும் மேலாக',
            in: '{{count}} ஆண்டுகளில்',
            ago: '{{count}} ஆண்டுகளுக்கு முன்பு'
          }
        },
        almostXYears: {
          one: {
            default: 'கிட்டத்தட்ட 1 வருடம்',
            in: 'கிட்டத்தட்ட 1 ஆண்டில்',
            ago: 'கிட்டத்தட்ட 1 வருடம் முன்பு'
          },
          other: {
            default: 'கிட்டத்தட்ட {{count}} ஆண்டுகள்',
            in: 'கிட்டத்தட்ட {{count}} ஆண்டுகளில்',
            ago: 'கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு'
          }
        }
      };

      function getFormatDistanceLocaleWithSuffix(resultObj, options) {
        if (options.addSuffix) {
          if (options.comparison > 0) {
            return resultObj.in;
          } else {
            return resultObj.ago;
          }
        }

        return resultObj.default;
      }

      function formatDistance(token, count) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var result;

        if (formatDistanceLocale[token].default) {
          result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token], options);
        } else if (count === 1) {
          result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token].one, options);
        } else {
          result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale[token].other, options);
        }

        return result.replace('{{count}}', count);
      }
      /***/

    },
    /* 797 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2); // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
      // CLDR #1846 - #1849


      var dateFormats = {
        full: 'EEEE, d MMMM, y',
        long: 'd MMMM, y',
        medium: 'd MMM, y',
        short: 'd/M/yy' // CLDR #1850 - #1853

      };
      var timeFormats = {
        full: 'a h:mm:ss zzzz',
        long: 'a h:mm:ss z',
        medium: 'a h:mm:ss',
        short: 'a h:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 798 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
        yesterday: "'நேற்று ' p 'மணிக்கு'",
        today: "'இன்று ' p 'மணிக்கு'",
        tomorrow: "'நாளை ' p 'மணிக்கு'",
        nextWeek: "eeee p 'மணிக்கு'",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 799 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3); // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html


      var eraValues = {
        narrow: ['கி.மு.', 'கி.பி.'],
        abbreviated: ['கி.மு.', 'கி.பி.'],
        // CLDR #1624, #1626
        wide: ['கிறிஸ்துவுக்கு முன்', 'அன்னோ டோமினி'] // CLDR #1620, #1622

      };
      var quarterValues = {
        // CLDR #1644 - #1647
        narrow: ['1', '2', '3', '4'],
        // CLDR #1636 - #1639
        abbreviated: ['காலா.1', 'காலா.2', 'காலா.3', 'காலா.4'],
        // CLDR #1628 - #1631
        wide: ['ஒன்றாம் காலாண்டு', 'இரண்டாம் காலாண்டு', 'மூன்றாம் காலாண்டு', 'நான்காம் காலாண்டு']
      };
      var monthValues = {
        // CLDR #700 - #711
        narrow: ['ஜ', 'பி', 'மா', 'ஏ', 'மே', 'ஜூ', 'ஜூ', 'ஆ', 'செ', 'அ', 'ந', 'டி'],
        // CLDR #1676 - #1687
        abbreviated: ['ஜன.', 'பிப்.', 'மார்.', 'ஏப்.', 'மே', 'ஜூன்', 'ஜூலை', 'ஆக.', 'செப்.', 'அக்.', 'நவ.', 'டிச.'],
        // CLDR #1652 - #1663
        wide: ['ஜனவரி', // January
        'பிப்ரவரி', // February
        'மார்ச்', // March
        'ஏப்ரல்', // April
        'மே', // May
        'ஜூன்', // June
        'ஜூலை', // July
        'ஆகஸ்ட்', // August
        'செப்டம்பர்', // September
        'அக்டோபர்', // October
        'நவம்பர்', // November
        'டிசம்பர்' // December
        ]
      };
      var dayValues = {
        // CLDR #1766 - #1772
        narrow: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
        // CLDR #1752 - #1758
        short: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
        // CLDR #1738 - #1744
        abbreviated: ['ஞாயி.', 'திங்.', 'செவ்.', 'புத.', 'வியா.', 'வெள்.', 'சனி'],
        // CLDR #1724 - #1730
        wide: ['ஞாயிறு', // Sunday
        'திங்கள்', // Monday
        'செவ்வாய்', // Tuesday
        'புதன்', // Wednesday
        'வியாழன்', // Thursday
        'வெள்ளி', // Friday
        'சனி' // Saturday
        ] // CLDR #1780 - #1845

      };
      var dayPeriodValues = {
        narrow: {
          am: 'மு.ப',
          pm: 'பி.ப',
          midnight: 'நள்.',
          noon: 'நண்.',
          morning: 'கா.',
          afternoon: 'மதி.',
          evening: 'மா.',
          night: 'இர.'
        },
        abbreviated: {
          am: 'முற்பகல்',
          pm: 'பிற்பகல்',
          midnight: 'நள்ளிரவு',
          noon: 'நண்பகல்',
          morning: 'காலை',
          afternoon: 'மதியம்',
          evening: 'மாலை',
          night: 'இரவு'
        },
        wide: {
          am: 'முற்பகல்',
          pm: 'பிற்பகல்',
          midnight: 'நள்ளிரவு',
          noon: 'நண்பகல்',
          morning: 'காலை',
          afternoon: 'மதியம்',
          evening: 'மாலை',
          night: 'இரவு'
        } // CLDR #1780 - #1845

      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'மு.ப',
          pm: 'பி.ப',
          midnight: 'நள்.',
          noon: 'நண்.',
          morning: 'கா.',
          afternoon: 'மதி.',
          evening: 'மா.',
          night: 'இர.'
        },
        abbreviated: {
          am: 'முற்பகல்',
          pm: 'பிற்பகல்',
          midnight: 'நள்ளிரவு',
          noon: 'நண்பகல்',
          morning: 'காலை',
          afternoon: 'மதியம்',
          evening: 'மாலை',
          night: 'இரவு'
        },
        wide: {
          am: 'முற்பகல்',
          pm: 'பிற்பகல்',
          midnight: 'நள்ளிரவு',
          noon: 'நண்பகல்',
          morning: 'காலை',
          afternoon: 'மதியம்',
          evening: 'மாலை',
          night: 'இரவு'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'
        // var rem100 = number % 100
        // if (rem100 > 20 || rem100 < 10) {
        //   switch (rem100 % 10) {
        //     case 1:
        //       return number + 'st'
        //     case 2:
        //       return number + 'nd'
        //     case 3:
        //       return number + 'rd'
        //   }
        // }
        // return number + 'th'

        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 800 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(கி.மு.|கி.பி.)/i,
        abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
        wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
      };
      var parseEraPatterns = {
        any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^காலா.[1234]/i,
        wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
      };
      var parseQuarterPatterns = {
        narrow: [/1/i, /2/i, /3/i, /4/i],
        any: [/(1|காலா.1|ஒன்றாம்)/i, /(2|காலா.2|இரண்டாம்)/i, /(3|காலா.3|மூன்றாம்)/i, /(4|காலா.4|நான்காம்)/i]
      };
      var matchMonthPatterns = {
        narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
        abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
        wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ஜ$/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூ/i, /^ஜூ/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i],
        any: [/^ஜன/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூன்/i, /^ஜூலை/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i]
      };
      var matchDayPatterns = {
        narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
        short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
        abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
        wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
      };
      var parseDayPatterns = {
        narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
        any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
        any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^மு/i,
          pm: /^பி/i,
          midnight: /^நள்/i,
          noon: /^நண்/i,
          morning: /காலை/i,
          afternoon: /மதியம்/i,
          evening: /மாலை/i,
          night: /இரவு/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 801 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(802);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(803);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(804);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(805);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(806);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Telugu locale
       * @language Telugu
       * @iso-639-2 tel
       * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
       */


      var locale = {
        code: 'te',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 802 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance; // Source: https://www.unicode.org/cldr/charts/32/summary/te.html

      var formatDistanceLocale = {
        lessThanXSeconds: {
          standalone: {
            one: 'సెకను కన్నా తక్కువ',
            other: '{{count}} సెకన్ల కన్నా తక్కువ'
          },
          withPreposition: {
            one: 'సెకను',
            other: '{{count}} సెకన్ల'
          }
        },
        xSeconds: {
          standalone: {
            one: 'ఒక సెకను',
            // CLDR #1314
            other: '{{count}} సెకన్ల'
          },
          withPreposition: {
            one: 'ఒక సెకను',
            other: '{{count}} సెకన్ల'
          }
        },
        halfAMinute: {
          standalone: 'అర నిమిషం',
          withPreposition: 'అర నిమిషం'
        },
        lessThanXMinutes: {
          standalone: {
            one: 'ఒక నిమిషం కన్నా తక్కువ',
            other: '{{count}} నిమిషాల కన్నా తక్కువ'
          },
          withPreposition: {
            one: 'ఒక నిమిషం',
            other: '{{count}} నిమిషాల'
          }
        },
        xMinutes: {
          standalone: {
            one: 'ఒక నిమిషం',
            // CLDR #1311
            other: '{{count}} నిమిషాలు'
          },
          withPreposition: {
            one: 'ఒక నిమిషం',
            // CLDR #1311
            other: '{{count}} నిమిషాల'
          }
        },
        aboutXHours: {
          standalone: {
            one: 'సుమారు ఒక గంట',
            other: 'సుమారు {{count}} గంటలు'
          },
          withPreposition: {
            one: 'సుమారు ఒక గంట',
            other: 'సుమారు {{count}} గంటల'
          }
        },
        xHours: {
          standalone: {
            one: 'ఒక గంట',
            // CLDR #1308
            other: '{{count}} గంటలు'
          },
          withPreposition: {
            one: 'ఒక గంట',
            other: '{{count}} గంటల'
          }
        },
        xDays: {
          standalone: {
            one: 'ఒక రోజు',
            // CLDR #1292
            other: '{{count}} రోజులు'
          },
          withPreposition: {
            one: 'ఒక రోజు',
            other: '{{count}} రోజుల'
          }
        },
        aboutXWeeks: {
          standalone: {
            one: 'సుమారు ఒక వారం',
            other: 'సుమారు {{count}} వారాలు'
          },
          withPreposition: {
            one: 'సుమారు ఒక వారం',
            other: 'సుమారు {{count}} వారాలల'
          }
        },
        xWeeks: {
          standalone: {
            one: 'ఒక వారం',
            other: '{{count}} వారాలు'
          },
          withPreposition: {
            one: 'ఒక వారం',
            other: '{{count}} వారాలల'
          }
        },
        aboutXMonths: {
          standalone: {
            one: 'సుమారు ఒక నెల',
            other: 'సుమారు {{count}} నెలలు'
          },
          withPreposition: {
            one: 'సుమారు ఒక నెల',
            other: 'సుమారు {{count}} నెలల'
          }
        },
        xMonths: {
          standalone: {
            one: 'ఒక నెల',
            // CLDR #1281
            other: '{{count}} నెలలు'
          },
          withPreposition: {
            one: 'ఒక నెల',
            other: '{{count}} నెలల'
          }
        },
        aboutXYears: {
          standalone: {
            one: 'సుమారు ఒక సంవత్సరం',
            other: 'సుమారు {{count}} సంవత్సరాలు'
          },
          withPreposition: {
            one: 'సుమారు ఒక సంవత్సరం',
            other: 'సుమారు {{count}} సంవత్సరాల'
          }
        },
        xYears: {
          standalone: {
            one: 'ఒక సంవత్సరం',
            // CLDR #1275
            other: '{{count}} సంవత్సరాలు'
          },
          withPreposition: {
            one: 'ఒక సంవత్సరం',
            other: '{{count}} సంవత్సరాల'
          }
        },
        overXYears: {
          standalone: {
            one: 'ఒక సంవత్సరం పైగా',
            other: '{{count}} సంవత్సరాలకు పైగా'
          },
          withPreposition: {
            one: 'ఒక సంవత్సరం',
            other: '{{count}} సంవత్సరాల'
          }
        },
        almostXYears: {
          standalone: {
            one: 'దాదాపు ఒక సంవత్సరం',
            other: 'దాదాపు {{count}} సంవత్సరాలు'
          },
          withPreposition: {
            one: 'దాదాపు ఒక సంవత్సరం',
            other: 'దాదాపు {{count}} సంవత్సరాల'
          }
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var usageGroup = options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
        var result;

        if (typeof usageGroup === 'string') {
          result = usageGroup;
        } else if (count === 1) {
          result = usageGroup.one;
        } else {
          result = usageGroup.other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + 'లో';
          } else {
            return result + ' క్రితం';
          }
        }

        return result;
      }
      /***/

    },
    /* 803 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2); // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
      // CLDR #1807 - #1811


      var dateFormats = {
        full: 'd, MMMM y, EEEE',
        long: 'd MMMM, y',
        medium: 'd MMM, y',
        short: 'dd-MM-yy' // CLDR #1807 - #1811

      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a' // CLDR #1815 - #1818

      };
      var dateTimeFormats = {
        full: "{{date}} {{time}}'కి'",
        long: "{{date}} {{time}}'కి'",
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 804 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative; // Source: https://www.unicode.org/cldr/charts/32/summary/te.html

      var formatRelativeLocale = {
        lastWeek: "'గత' eeee p",
        // CLDR #1384
        yesterday: "'నిన్న' p",
        // CLDR #1393
        today: "'ఈ రోజు' p",
        // CLDR #1394
        tomorrow: "'రేపు' p",
        // CLDR #1395
        nextWeek: "'తదుపరి' eeee p",
        // CLDR #1386
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 805 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3); // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
      // Source: https://dsal.uchicago.edu/dictionaries/brown/
      // CLDR #1605 - #1608


      var eraValues = {
        narrow: ['క్రీ.పూ.', 'క్రీ.శ.'],
        abbreviated: ['క్రీ.పూ.', 'క్రీ.శ.'],
        wide: ['క్రీస్తు పూర్వం', 'క్రీస్తుశకం'] // CLDR #1613 - #1628

      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['త్రై1', 'త్రై2', 'త్రై3', 'త్రై4'],
        wide: ['1వ త్రైమాసికం', '2వ త్రైమాసికం', '3వ త్రైమాసికం', '4వ త్రైమాసికం'] // CLDR #1637 - #1708

      };
      var monthValues = {
        narrow: ['జ', 'ఫి', 'మా', 'ఏ', 'మే', 'జూ', 'జు', 'ఆ', 'సె', 'అ', 'న', 'డి'],
        abbreviated: ['జన', 'ఫిబ్ర', 'మార్చి', 'ఏప్రి', 'మే', 'జూన్', 'జులై', 'ఆగ', 'సెప్టెం', 'అక్టో', 'నవం', 'డిసెం'],
        wide: ['జనవరి', 'ఫిబ్రవరి', 'మార్చి', 'ఏప్రిల్', 'మే', 'జూన్', 'జులై', 'ఆగస్టు', 'సెప్టెంబర్', 'అక్టోబర్', 'నవంబర్', 'డిసెంబర్'] // CLDR #1709 - #1764

      };
      var dayValues = {
        narrow: ['ఆ', 'సో', 'మ', 'బు', 'గు', 'శు', 'శ'],
        short: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
        abbreviated: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
        wide: ['ఆదివారం', 'సోమవారం', 'మంగళవారం', 'బుధవారం', 'గురువారం', 'శుక్రవారం', 'శనివారం'] // CLDR #1767 - #1806

      };
      var dayPeriodValues = {
        narrow: {
          am: 'పూర్వాహ్నం',
          pm: 'అపరాహ్నం',
          midnight: 'అర్ధరాత్రి',
          noon: 'మిట్టమధ్యాహ్నం',
          morning: 'ఉదయం',
          afternoon: 'మధ్యాహ్నం',
          evening: 'సాయంత్రం',
          night: 'రాత్రి'
        },
        abbreviated: {
          am: 'పూర్వాహ్నం',
          pm: 'అపరాహ్నం',
          midnight: 'అర్ధరాత్రి',
          noon: 'మిట్టమధ్యాహ్నం',
          morning: 'ఉదయం',
          afternoon: 'మధ్యాహ్నం',
          evening: 'సాయంత్రం',
          night: 'రాత్రి'
        },
        wide: {
          am: 'పూర్వాహ్నం',
          pm: 'అపరాహ్నం',
          midnight: 'అర్ధరాత్రి',
          noon: 'మిట్టమధ్యాహ్నం',
          morning: 'ఉదయం',
          afternoon: 'మధ్యాహ్నం',
          evening: 'సాయంత్రం',
          night: 'రాత్రి'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'పూర్వాహ్నం',
          pm: 'అపరాహ్నం',
          midnight: 'అర్ధరాత్రి',
          noon: 'మిట్టమధ్యాహ్నం',
          morning: 'ఉదయం',
          afternoon: 'మధ్యాహ్నం',
          evening: 'సాయంత్రం',
          night: 'రాత్రి'
        },
        abbreviated: {
          am: 'పూర్వాహ్నం',
          pm: 'అపరాహ్నం',
          midnight: 'అర్ధరాత్రి',
          noon: 'మిట్టమధ్యాహ్నం',
          morning: 'ఉదయం',
          afternoon: 'మధ్యాహ్నం',
          evening: 'సాయంత్రం',
          night: 'రాత్రి'
        },
        wide: {
          am: 'పూర్వాహ్నం',
          pm: 'అపరాహ్నం',
          midnight: 'అర్ధరాత్రి',
          noon: 'మిట్టమధ్యాహ్నం',
          morning: 'ఉదయం',
          afternoon: 'మధ్యాహ్నం',
          evening: 'సాయంత్రం',
          night: 'రాత్రి'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + 'వ';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 806 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
        abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
        wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
      };
      var parseEraPatterns = {
        any: [/^(పూ|శ)/i, /^సా/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^త్రై[1234]/i,
        wide: /^[1234](వ)? త్రైమాసికం/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
        abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
        wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
      };
      var parseMonthPatterns = {
        narrow: [/^జ/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూ/i, /^జు/i, /^ఆ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i],
        any: [/^జన/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూన్/i, /^జులై/i, /^ఆగ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i]
      };
      var matchDayPatterns = {
        narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
        short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
        abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
        wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
      };
      var parseDayPatterns = {
        narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
        any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
        any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^పూర్వాహ్నం/i,
          pm: /^అపరాహ్నం/i,
          midnight: /^అర్ధ/i,
          noon: /^మిట్ట/i,
          morning: /ఉదయం/i,
          afternoon: /మధ్యాహ్నం/i,
          evening: /సాయంత్రం/i,
          night: /రాత్రి/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 807 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(808);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(809);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(810);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(811);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(812);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Thai locale.
       * @language Thai
       * @iso-639-2 tha
       * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
       * @author [@hawkup]{@link https://github.com/hawkup}
       * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
       */


      var locale = {
        code: 'th',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 808 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'น้อยกว่า 1 วินาที',
          other: 'น้อยกว่า {{count}} วินาที'
        },
        xSeconds: {
          one: '1 วินาที',
          other: '{{count}} วินาที'
        },
        halfAMinute: 'ครึ่งนาที',
        lessThanXMinutes: {
          one: 'น้อยกว่า 1 นาที',
          other: 'น้อยกว่า {{count}} นาที'
        },
        xMinutes: {
          one: '1 นาที',
          other: '{{count}} นาที'
        },
        aboutXHours: {
          one: 'ประมาณ 1 ชั่วโมง',
          other: 'ประมาณ {{count}} ชั่วโมง'
        },
        xHours: {
          one: '1 ชั่วโมง',
          other: '{{count}} ชั่วโมง'
        },
        xDays: {
          one: '1 วัน',
          other: '{{count}} วัน'
        },
        aboutXWeeks: {
          one: 'ประมาณ 1 สัปดาห์',
          other: 'ประมาณ {{count}} สัปดาห์'
        },
        xWeeks: {
          one: '1 สัปดาห์',
          other: '{{count}} สัปดาห์'
        },
        aboutXMonths: {
          one: 'ประมาณ 1 เดือน',
          other: 'ประมาณ {{count}} เดือน'
        },
        xMonths: {
          one: '1 เดือน',
          other: '{{count}} เดือน'
        },
        aboutXYears: {
          one: 'ประมาณ 1 ปี',
          other: 'ประมาณ {{count}} ปี'
        },
        xYears: {
          one: '1 ปี',
          other: '{{count}} ปี'
        },
        overXYears: {
          one: 'มากกว่า 1 ปี',
          other: 'มากกว่า {{count}} ปี'
        },
        almostXYears: {
          one: 'เกือบ 1 ปี',
          other: 'เกือบ {{count}} ปี'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            if (token === 'halfAMinute') {
              return 'ใน' + result;
            } else {
              return 'ใน ' + result;
            }
          } else {
            return result + 'ที่ผ่านมา';
          }
        }

        return result;
      }
      /***/

    },
    /* 809 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'วันEEEEที่ do MMMM y',
        long: 'do MMMM y',
        medium: 'd MMM y',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'H:mm:ss น. zzzz',
        long: 'H:mm:ss น. z',
        medium: 'H:mm:ss น.',
        short: 'H:mm น.'
      };
      var dateTimeFormats = {
        full: "{{date}} 'เวลา' {{time}}",
        long: "{{date}} 'เวลา' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'medium'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 810 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee'ที่แล้วเวลา' p",
        yesterday: "'เมื่อวานนี้เวลา' p",
        today: "'วันนี้เวลา' p",
        tomorrow: "'พรุ่งนี้เวลา' p",
        nextWeek: "eeee 'เวลา' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 811 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['B', 'คศ'],
        abbreviated: ['BC', 'ค.ศ.'],
        wide: ['ปีก่อนคริสตกาล', 'คริสต์ศักราช']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['ไตรมาสแรก', 'ไตรมาสที่สอง', 'ไตรมาสที่สาม', 'ไตรมาสที่สี่']
      };
      var dayValues = {
        narrow: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
        short: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
        abbreviated: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
        wide: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']
      };
      var monthValues = {
        narrow: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
        abbreviated: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
        wide: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ก่อนเที่ยง',
          pm: 'หลังเที่ยง',
          midnight: 'เที่ยงคืน',
          noon: 'เที่ยง',
          morning: 'เช้า',
          afternoon: 'บ่าย',
          evening: 'เย็น',
          night: 'กลางคืน'
        },
        abbreviated: {
          am: 'ก่อนเที่ยง',
          pm: 'หลังเที่ยง',
          midnight: 'เที่ยงคืน',
          noon: 'เที่ยง',
          morning: 'เช้า',
          afternoon: 'บ่าย',
          evening: 'เย็น',
          night: 'กลางคืน'
        },
        wide: {
          am: 'ก่อนเที่ยง',
          pm: 'หลังเที่ยง',
          midnight: 'เที่ยงคืน',
          noon: 'เที่ยง',
          morning: 'เช้า',
          afternoon: 'บ่าย',
          evening: 'เย็น',
          night: 'กลางคืน'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ก่อนเที่ยง',
          pm: 'หลังเที่ยง',
          midnight: 'เที่ยงคืน',
          noon: 'เที่ยง',
          morning: 'ตอนเช้า',
          afternoon: 'ตอนกลางวัน',
          evening: 'ตอนเย็น',
          night: 'ตอนกลางคืน'
        },
        abbreviated: {
          am: 'ก่อนเที่ยง',
          pm: 'หลังเที่ยง',
          midnight: 'เที่ยงคืน',
          noon: 'เที่ยง',
          morning: 'ตอนเช้า',
          afternoon: 'ตอนกลางวัน',
          evening: 'ตอนเย็น',
          night: 'ตอนกลางคืน'
        },
        wide: {
          am: 'ก่อนเที่ยง',
          pm: 'หลังเที่ยง',
          midnight: 'เที่ยงคืน',
          noon: 'เที่ยง',
          morning: 'ตอนเช้า',
          afternoon: 'ตอนกลางวัน',
          evening: 'ตอนเย็น',
          night: 'ตอนกลางคืน'
        }
      };

      function ordinalNumber(dirtyNumber) {
        var number = Number(dirtyNumber);
        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 812 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^\d+/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^([bB]|[aA]|คศ)/i,
        abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
        wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
      };
      var parseEraPatterns = {
        any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^ไตรมาส(ที่)? ?[1234]/i
      };
      var parseQuarterPatterns = {
        any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
      };
      var matchMonthPatterns = {
        narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
        abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
        wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
      };
      var parseMonthPatterns = {
        wide: [/^มก/i, /^กุม/i, /^มี/i, /^เม/i, /^พฤษ/i, /^มิ/i, /^กรก/i, /^ส/i, /^กัน/i, /^ต/i, /^พฤศ/i, /^ธ/i],
        any: [/^ม\.?ค\.?/i, /^ก\.?พ\.?/i, /^มี\.?ค\.?/i, /^เม\.?ย\.?/i, /^พ\.?ค\.?/i, /^มิ\.?ย\.?/i, /^ก\.?ค\.?/i, /^ส\.?ค\.?/i, /^ก\.?ย\.?/i, /^ต\.?ค\.?/i, /^พ\.?ย\.?/i, /^ธ\.?ค\.?/i]
      };
      var matchDayPatterns = {
        narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
        short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
        abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
        wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
      };
      var parseDayPatterns = {
        wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
        any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ก่อนเที่ยง/i,
          pm: /^หลังเที่ยง/i,
          midnight: /^เที่ยงคืน/i,
          noon: /^เที่ยง/i,
          morning: /เช้า/i,
          afternoon: /บ่าย/i,
          evening: /เย็น/i,
          night: /กลางคืน/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 813 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(814);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(815);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(816);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(817);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(818);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Turkish locale.
       * @language Turkish
       * @iso-639-2 tur
       * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
       * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
       * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
       * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
       *
       *
       */


      var locale = {
        code: 'tr',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 814 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'bir saniyeden az',
          other: '{{count}} saniyeden az'
        },
        xSeconds: {
          one: '1 saniye',
          other: '{{count}} saniye'
        },
        halfAMinute: 'yarım dakika',
        lessThanXMinutes: {
          one: 'bir dakikadan az',
          other: '{{count}} dakikadan az'
        },
        xMinutes: {
          one: '1 dakika',
          other: '{{count}} dakika'
        },
        aboutXHours: {
          one: 'yaklaşık 1 saat',
          other: 'yaklaşık {{count}} saat'
        },
        xHours: {
          one: '1 saat',
          other: '{{count}} saat'
        },
        xDays: {
          one: '1 gün',
          other: '{{count}} gün'
        },
        aboutXWeeks: {
          one: 'yaklaşık 1 hafta',
          other: 'yaklaşık {{count}} hafta'
        },
        xWeeks: {
          one: '1 hafta',
          other: '{{count}} hafta'
        },
        aboutXMonths: {
          one: 'yaklaşık 1 ay',
          other: 'yaklaşık {{count}} ay'
        },
        xMonths: {
          one: '1 ay',
          other: '{{count}} ay'
        },
        aboutXYears: {
          one: 'yaklaşık 1 yıl',
          other: 'yaklaşık {{count}} yıl'
        },
        xYears: {
          one: '1 yıl',
          other: '{{count}} yıl'
        },
        overXYears: {
          one: '1 yıldan fazla',
          other: '{{count}} yıldan fazla'
        },
        almostXYears: {
          one: 'neredeyse 1 yıl',
          other: 'neredeyse {{count}} yıl'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + ' sonra';
          } else {
            return result + ' önce';
          }
        }

        return result;
      }
      /***/

    },
    /* 815 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'd MMMM y EEEE',
        long: 'd MMMM y',
        medium: 'd MMM y',
        short: 'dd.MM.yyyy'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'saat' {{time}}",
        long: "{{date}} 'saat' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 816 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'geçen hafta' eeee 'saat' p",
        yesterday: "'dün saat' p",
        today: "'bugün saat' p",
        tomorrow: "'yarın saat' p",
        nextWeek: "eeee 'saat' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 817 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        abbreviated: ['MÖ', 'MS'],
        narrow: ['MÖ', 'MS'],
        wide: ['Milattan Önce', 'Milattan Sonra']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1Ç', '2Ç', '3Ç', '4Ç'],
        wide: ['İlk çeyrek', 'İkinci Çeyrek', 'Üçüncü çeyrek', 'Son çeyrek']
      };
      var monthValues = {
        narrow: ['O', 'Ş', 'M', 'N', 'M', 'H', 'T', 'A', 'E', 'E', 'K', 'A'],
        abbreviated: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
        wide: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
      };
      var dayValues = {
        narrow: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
        short: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
        abbreviated: ['Paz', 'Pts', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
        wide: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'öö',
          pm: 'ös',
          midnight: 'gy',
          noon: 'ö',
          morning: 'sa',
          afternoon: 'ös',
          evening: 'ak',
          night: 'ge'
        },
        abbreviated: {
          am: 'ÖÖ',
          pm: 'ÖS',
          midnight: 'gece yarısı',
          noon: 'öğle',
          morning: 'sabah',
          afternoon: 'öğleden sonra',
          evening: 'akşam',
          night: 'gece'
        },
        wide: {
          am: 'Ö.Ö.',
          pm: 'Ö.S.',
          midnight: 'gece yarısı',
          noon: 'öğle',
          morning: 'sabah',
          afternoon: 'öğleden sonra',
          evening: 'akşam',
          night: 'gece'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'öö',
          pm: 'ös',
          midnight: 'gy',
          noon: 'ö',
          morning: 'sa',
          afternoon: 'ös',
          evening: 'ak',
          night: 'ge'
        },
        abbreviated: {
          am: 'ÖÖ',
          pm: 'ÖS',
          midnight: 'gece yarısı',
          noon: 'öğlen',
          morning: 'sabahleyin',
          afternoon: 'öğleden sonra',
          evening: 'akşamleyin',
          night: 'geceleyin'
        },
        wide: {
          am: 'ö.ö.',
          pm: 'ö.s.',
          midnight: 'gece yarısı',
          noon: 'öğlen',
          morning: 'sabahleyin',
          afternoon: 'öğleden sonra',
          evening: 'akşamleyin',
          night: 'geceleyin'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber);
        return number + '.';
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaulFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 818 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(mö|ms)/i,
        abbreviated: /^(mö|ms)/i,
        wide: /^(milattan önce|milattan sonra)/i
      };
      var parseEraPatterns = {
        any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234]ç/i,
        wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i],
        abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
        wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
      };
      var matchMonthPatterns = {
        narrow: /^[oşmnhtaek]/i,
        abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
        wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
      };
      var parseMonthPatterns = {
        narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
        any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
      };
      var matchDayPatterns = {
        narrow: /^[psçc]/i,
        short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
        abbreviated: /^(paz|pts|sal|çar|per|cum|cts)/i,
        wide: /^(pazar|pazartesi|salı|çarşamba|perşembe|cuma|cumartesi)/i
      };
      var parseDayPatterns = {
        narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
        any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
        wide: [/^pazar/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma/i, /cumartesi/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
        any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ö\.?ö\.?/i,
          pm: /^ö\.?s\.?/i,
          midnight: /^(gy|gece yarısı)/i,
          noon: /^öğ/i,
          morning: /^sa/i,
          afternoon: /^öğleden sonra/i,
          evening: /^ak/i,
          night: /^ge/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 819 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(820);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(821);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(822);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(823);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(824);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Uighur locale
       * @language Uighur
       * @iso-639-2 uig
       * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
       */


      var locale = {
        code: 'ug',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 0
          /* Sunday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 820 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'بىر سىكۇنت ئىچىدە',
          other: 'سىكۇنت ئىچىدە {{count}}'
        },
        xSeconds: {
          one: 'بىر سىكۇنت',
          other: 'سىكۇنت {{count}}'
        },
        halfAMinute: 'يىرىم مىنۇت',
        lessThanXMinutes: {
          one: 'بىر مىنۇت ئىچىدە',
          other: 'مىنۇت ئىچىدە {{count}}'
        },
        xMinutes: {
          one: 'بىر مىنۇت',
          other: 'مىنۇت {{count}}'
        },
        aboutXHours: {
          one: 'تەخمىنەن بىر سائەت',
          other: 'سائەت {{count}} تەخمىنەن'
        },
        xHours: {
          one: 'بىر سائەت',
          other: 'سائەت {{count}}'
        },
        xDays: {
          one: 'بىر كۈن',
          other: 'كۈن {{count}}'
        },
        aboutXWeeks: {
          one: 'تەخمىنەن بىرھەپتە',
          other: 'ھەپتە {{count}} تەخمىنەن'
        },
        xWeeks: {
          one: 'بىرھەپتە',
          other: 'ھەپتە {{count}}'
        },
        aboutXMonths: {
          one: 'تەخمىنەن بىر ئاي',
          other: 'ئاي {{count}} تەخمىنەن'
        },
        xMonths: {
          one: 'بىر ئاي',
          other: 'ئاي {{count}}'
        },
        aboutXYears: {
          one: 'تەخمىنەن بىر يىل',
          other: 'يىل {{count}} تەخمىنەن'
        },
        xYears: {
          one: 'بىر يىل',
          other: 'يىل {{count}}'
        },
        overXYears: {
          one: 'بىر يىلدىن ئارتۇق',
          other: 'يىلدىن ئارتۇق {{count}}'
        },
        almostXYears: {
          one: 'ئاساسەن بىر يىل',
          other: 'يىل {{count}} ئاساسەن'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result;
          } else {
            return result + ' بولدى';
          }
        }

        return result;
      }
      /***/

    },
    /* 821 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, MMMM do, y',
        long: 'MMMM do, y',
        medium: 'MMM d, y',
        short: 'MM/dd/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss a zzzz',
        long: 'h:mm:ss a z',
        medium: 'h:mm:ss a',
        short: 'h:mm a'
      };
      var dateTimeFormats = {
        full: "{{date}} 'دە' {{time}}",
        long: "{{date}} 'دە' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 822 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'ئ‍ۆتكەن' eeee 'دە' p",
        yesterday: "'تۈنۈگۈن دە' p",
        today: "'بۈگۈن دە' p",
        tomorrow: "'ئەتە دە' p",
        nextWeek: "eeee 'دە' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 823 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['ب', 'ك'],
        abbreviated: ['ب', 'ك'],
        wide: ['مىيلادىدىن بۇرۇن', 'مىيلادىدىن كىيىن']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1', '2', '3', '4'],
        wide: ['بىرىنجى چارەك', 'ئىككىنجى چارەك', 'ئۈچىنجى چارەك', 'تۆتىنجى چارەك'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['ي', 'ف', 'م', 'ا', 'م', 'ى', 'ى', 'ا', 'س', 'ۆ', 'ن', 'د'],
        abbreviated: ['يانۋار', 'فېۋىرال', 'مارت', 'ئاپرىل', 'ماي', 'ئىيۇن', 'ئىيول', 'ئاۋغۇست', 'سىنتەبىر', 'ئۆكتەبىر', 'نويابىر', 'دىكابىر'],
        wide: ['يانۋار', 'فېۋىرال', 'مارت', 'ئاپرىل', 'ماي', 'ئىيۇن', 'ئىيول', 'ئاۋغۇست', 'سىنتەبىر', 'ئۆكتەبىر', 'نويابىر', 'دىكابىر']
      };
      var dayValues = {
        narrow: ['ي', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
        short: ['ي', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
        abbreviated: ['يەكشەنبە', 'دۈشەنبە', 'سەيشەنبە', 'چارشەنبە', 'پەيشەنبە', 'جۈمە', 'شەنبە'],
        wide: ['يەكشەنبە', 'دۈشەنبە', 'سەيشەنبە', 'چارشەنبە', 'پەيشەنبە', 'جۈمە', 'شەنبە']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ئە',
          pm: 'چ',
          midnight: 'ك',
          noon: 'چ',
          morning: 'ئەتىگەن',
          afternoon: 'چۈشتىن كىيىن',
          evening: 'ئاخشىم',
          night: 'كىچە'
        },
        abbreviated: {
          am: 'ئە',
          pm: 'چ',
          midnight: 'ك',
          noon: 'چ',
          morning: 'ئەتىگەن',
          afternoon: 'چۈشتىن كىيىن',
          evening: 'ئاخشىم',
          night: 'كىچە'
        },
        wide: {
          am: 'ئە',
          pm: 'چ',
          midnight: 'ك',
          noon: 'چ',
          morning: 'ئەتىگەن',
          afternoon: 'چۈشتىن كىيىن',
          evening: 'ئاخشىم',
          night: 'كىچە'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ئە',
          pm: 'چ',
          midnight: 'ك',
          noon: 'چ',
          morning: 'ئەتىگەندە',
          afternoon: 'چۈشتىن كىيىن',
          evening: 'ئاخشامدا',
          night: 'كىچىدە'
        },
        abbreviated: {
          am: 'ئە',
          pm: 'چ',
          midnight: 'ك',
          noon: 'چ',
          morning: 'ئەتىگەندە',
          afternoon: 'چۈشتىن كىيىن',
          evening: 'ئاخشامدا',
          night: 'كىچىدە'
        },
        wide: {
          am: 'ئە',
          pm: 'چ',
          midnight: 'ك',
          noon: 'چ',
          morning: 'ئەتىگەندە',
          afternoon: 'چۈشتىن كىيىن',
          evening: 'ئاخشامدا',
          night: 'كىچىدە'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        return String(dirtyNumber);
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 824 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(ب|ك)/i,
        wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
      };
      var parseEraPatterns = {
        any: [/^بۇرۇن/i, /^كىيىن/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^چ[1234]/i,
        wide: /^چارەك [1234]/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[يفمئامئ‍ئاسۆند]/i,
        abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
        wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
      };
      var parseMonthPatterns = {
        narrow: [/^ي/i, /^ف/i, /^م/i, /^ا/i, /^م/i, /^ى‍/i, /^ى‍/i, /^ا‍/i, /^س/i, /^ۆ/i, /^ن/i, /^د/i],
        any: [/^يان/i, /^فېۋ/i, /^مار/i, /^ئاپ/i, /^ماي/i, /^ئىيۇن/i, /^ئىيول/i, /^ئاۋ/i, /^سىن/i, /^ئۆك/i, /^نوي/i, /^دىك/i]
      };
      var matchDayPatterns = {
        narrow: /^[دسچپجشي]/i,
        short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
        abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
        wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
      };
      var parseDayPatterns = {
        narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
        any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
        any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^ئە/i,
          pm: /^چ/i,
          midnight: /^ك/i,
          noon: /^چ/i,
          morning: /ئەتىگەن/i,
          afternoon: /چۈشتىن كىيىن/i,
          evening: /ئاخشىم/i,
          night: /كىچە/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 825 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(826);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(827);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(828);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(829);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(830);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Ukrainian locale.
       * @language Ukrainian
       * @iso-639-2 ukr
       * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
       * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
       */


      var locale = {
        code: 'uk',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 826 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;

      function declension(scheme, count) {
        // scheme for count=1 exists
        if (scheme.one !== undefined && count === 1) {
          return scheme.one;
        }

        var rem10 = count % 10;
        var rem100 = count % 100; // 1, 21, 31, ...

        if (rem10 === 1 && rem100 !== 11) {
          return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
        } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
          return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
        } else {
          return scheme.pluralGenitive.replace('{{count}}', count);
        }
      }

      function buildLocalizeTokenFn(scheme) {
        return function (count, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              if (scheme.future) {
                return declension(scheme.future, count);
              } else {
                return 'за ' + declension(scheme.regular, count);
              }
            } else {
              if (scheme.past) {
                return declension(scheme.past, count);
              } else {
                return declension(scheme.regular, count) + ' тому';
              }
            }
          } else {
            return declension(scheme.regular, count);
          }
        };
      }

      var formatDistanceLocale = {
        lessThanXSeconds: buildLocalizeTokenFn({
          regular: {
            one: 'менше секунди',
            singularNominative: 'менше {{count}} секунди',
            singularGenitive: 'менше {{count}} секунд',
            pluralGenitive: 'менше {{count}} секунд'
          },
          future: {
            one: 'менше, ніж за секунду',
            singularNominative: 'менше, ніж за {{count}} секунду',
            singularGenitive: 'менше, ніж за {{count}} секунди',
            pluralGenitive: 'менше, ніж за {{count}} секунд'
          }
        }),
        xSeconds: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} секунда',
            singularGenitive: '{{count}} секунди',
            pluralGenitive: '{{count}} секунд'
          },
          past: {
            singularNominative: '{{count}} секунду тому',
            singularGenitive: '{{count}} секунди тому',
            pluralGenitive: '{{count}} секунд тому'
          },
          future: {
            singularNominative: 'за {{count}} секунду',
            singularGenitive: 'за {{count}} секунди',
            pluralGenitive: 'за {{count}} секунд'
          }
        }),
        halfAMinute: function halfAMinute(_, options) {
          if (options.addSuffix) {
            if (options.comparison > 0) {
              return 'за півхвилини';
            } else {
              return 'півхвилини тому';
            }
          }

          return 'півхвилини';
        },
        lessThanXMinutes: buildLocalizeTokenFn({
          regular: {
            one: 'менше хвилини',
            singularNominative: 'менше {{count}} хвилини',
            singularGenitive: 'менше {{count}} хвилин',
            pluralGenitive: 'менше {{count}} хвилин'
          },
          future: {
            one: 'менше, ніж за хвилину',
            singularNominative: 'менше, ніж за {{count}} хвилину',
            singularGenitive: 'менше, ніж за {{count}} хвилини',
            pluralGenitive: 'менше, ніж за {{count}} хвилин'
          }
        }),
        xMinutes: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} хвилина',
            singularGenitive: '{{count}} хвилини',
            pluralGenitive: '{{count}} хвилин'
          },
          past: {
            singularNominative: '{{count}} хвилину тому',
            singularGenitive: '{{count}} хвилини тому',
            pluralGenitive: '{{count}} хвилин тому'
          },
          future: {
            singularNominative: 'за {{count}} хвилину',
            singularGenitive: 'за {{count}} хвилини',
            pluralGenitive: 'за {{count}} хвилин'
          }
        }),
        aboutXHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'близько {{count}} години',
            singularGenitive: 'близько {{count}} годин',
            pluralGenitive: 'близько {{count}} годин'
          },
          future: {
            singularNominative: 'приблизно за {{count}} годину',
            singularGenitive: 'приблизно за {{count}} години',
            pluralGenitive: 'приблизно за {{count}} годин'
          }
        }),
        xHours: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} годину',
            singularGenitive: '{{count}} години',
            pluralGenitive: '{{count}} годин'
          }
        }),
        xDays: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} день',
            singularGenitive: '{{count}} дня',
            pluralGenitive: '{{count}} днів'
          }
        }),
        aboutXWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'близько {{count}} тижня',
            singularGenitive: 'близько {{count}} тижнів',
            pluralGenitive: 'близько {{count}} тижнів'
          },
          future: {
            singularNominative: 'приблизно за {{count}} тиждень',
            singularGenitive: 'приблизно за {{count}} тижні',
            pluralGenitive: 'приблизно за {{count}} тижні'
          }
        }),
        xWeeks: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} тиждень',
            singularGenitive: '{{count}} тижня',
            pluralGenitive: '{{count}} тижні'
          }
        }),
        aboutXMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'близько {{count}} місяця',
            singularGenitive: 'близько {{count}} місяців',
            pluralGenitive: 'близько {{count}} місяців'
          },
          future: {
            singularNominative: 'приблизно за {{count}} місяць',
            singularGenitive: 'приблизно за {{count}} місяця',
            pluralGenitive: 'приблизно за {{count}} місяців'
          }
        }),
        xMonths: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} місяць',
            singularGenitive: '{{count}} місяця',
            pluralGenitive: '{{count}} місяців'
          }
        }),
        aboutXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'близько {{count}} року',
            singularGenitive: 'близько {{count}} років',
            pluralGenitive: 'близько {{count}} років'
          },
          future: {
            singularNominative: 'приблизно за {{count}} рік',
            singularGenitive: 'приблизно за {{count}} роки',
            pluralGenitive: 'приблизно за {{count}} років'
          }
        }),
        xYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: '{{count}} рік',
            singularGenitive: '{{count}} роки',
            pluralGenitive: '{{count}} років'
          }
        }),
        overXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'більше {{count}} року',
            singularGenitive: 'більше {{count}} років',
            pluralGenitive: 'більше {{count}} років'
          },
          future: {
            singularNominative: 'більше, ніж за {{count}} рік',
            singularGenitive: 'більше, ніж за {{count}} роки',
            pluralGenitive: 'більше, ніж за {{count}} років'
          }
        }),
        almostXYears: buildLocalizeTokenFn({
          regular: {
            singularNominative: 'майже {{count}} рік',
            singularGenitive: 'майже {{count}} роки',
            pluralGenitive: 'майже {{count}} років'
          },
          future: {
            singularNominative: 'майже за {{count}} рік',
            singularGenitive: 'майже за {{count}} роки',
            pluralGenitive: 'майже за {{count}} років'
          }
        })
      };

      function formatDistance(token, count, options) {
        options = options || {};
        return formatDistanceLocale[token](count, options);
      }
      /***/

    },
    /* 827 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "EEEE, do MMMM y 'р.'",
        long: "do MMMM y 'р.'",
        medium: "d MMM y 'р.'",
        short: 'dd.MM.y'
      };
      var timeFormats = {
        full: 'H:mm:ss zzzz',
        long: 'H:mm:ss z',
        medium: 'H:mm:ss',
        short: 'H:mm'
      };
      var dateTimeFormats = {
        full: "{{date}} 'о' {{time}}",
        long: "{{date}} 'о' {{time}}",
        medium: '{{date}}, {{time}}',
        short: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 828 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13);

      var accusativeWeekdays = ['неділю', 'понеділок', 'вівторок', 'середу', 'четвер', 'п’ятницю', 'суботу'];

      function _lastWeek8(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 5:
          case 6:
            return "'у минулу " + weekday + " о' p";

          case 1:
          case 2:
          case 4:
            return "'у минулий " + weekday + " о' p";
        }
      }

      function thisWeek(day) {
        var weekday = accusativeWeekdays[day];
        return "'у " + weekday + " о' p";
      }

      function _nextWeek8(day) {
        var weekday = accusativeWeekdays[day];

        switch (day) {
          case 0:
          case 3:
          case 5:
          case 6:
            return "'у наступну " + weekday + " о' p";

          case 1:
          case 2:
          case 4:
            return "'у наступний " + weekday + " о' p";
        }
      }

      var formatRelativeLocale = {
        lastWeek: function lastWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _lastWeek8(day);
          }
        },
        yesterday: "'вчора о' p",
        today: "'сьогодні о' p",
        tomorrow: "'завтра о' p",
        nextWeek: function nextWeek(date, baseDate, options) {
          var day = date.getUTCDay();

          if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
          /* default */
          ](date, baseDate, options)) {
            return thisWeek(day);
          } else {
            return _nextWeek8(day);
          }
        },
        other: 'P'
      };

      function formatRelative(token, date, baseDate, options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(date, baseDate, options);
        }

        return format;
      }
      /***/

    },
    /* 829 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['до н.е.', 'н.е.'],
        abbreviated: ['до н. е.', 'н. е.'],
        wide: ['до нашої ери', 'нашої ери']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
        wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
      };
      var monthValues = {
        // ДСТУ 3582:2013
        narrow: ['С', 'Л', 'Б', 'К', 'Т', 'Ч', 'Л', 'С', 'В', 'Ж', 'Л', 'Г'],
        abbreviated: ['січ.', 'лют.', 'берез.', 'квіт.', 'трав.', 'черв.', 'лип.', 'серп.', 'верес.', 'жовт.', 'листоп.', 'груд.'],
        wide: ['січень', 'лютий', 'березень', 'квітень', 'травень', 'червень', 'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень']
      };
      var formattingMonthValues = {
        narrow: ['С', 'Л', 'Б', 'К', 'Т', 'Ч', 'Л', 'С', 'В', 'Ж', 'Л', 'Г'],
        abbreviated: ['січ.', 'лют.', 'берез.', 'квіт.', 'трав.', 'черв.', 'лип.', 'серп.', 'верес.', 'жовт.', 'листоп.', 'груд.'],
        wide: ['січня', 'лютого', 'березня', 'квітня', 'травня', 'червня', 'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня']
      };
      var dayValues = {
        narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
        short: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
        abbreviated: ['нед', 'пон', 'вів', 'сер', 'чтв', 'птн', 'суб'],
        wide: ['неділя', 'понеділок', 'вівторок', 'середа', 'четвер', 'п’ятниця', 'субота']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'півн.',
          noon: 'пол.',
          morning: 'ранок',
          afternoon: 'день',
          evening: 'веч.',
          night: 'ніч'
        },
        abbreviated: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'півн.',
          noon: 'пол.',
          morning: 'ранок',
          afternoon: 'день',
          evening: 'веч.',
          night: 'ніч'
        },
        wide: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'північ',
          noon: 'полудень',
          morning: 'ранок',
          afternoon: 'день',
          evening: 'вечір',
          night: 'ніч'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'півн.',
          noon: 'пол.',
          morning: 'ранку',
          afternoon: 'дня',
          evening: 'веч.',
          night: 'ночі'
        },
        abbreviated: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'півн.',
          noon: 'пол.',
          morning: 'ранку',
          afternoon: 'дня',
          evening: 'веч.',
          night: 'ночі'
        },
        wide: {
          am: 'ДП',
          pm: 'ПП',
          midnight: 'північ',
          noon: 'полудень',
          morning: 'ранку',
          afternoon: 'дня',
          evening: 'веч.',
          night: 'ночі'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var suffix;

        if (unit === 'date') {
          if (dirtyNumber === 3 || dirtyNumber === 23) {
            suffix = '-є';
          } else {
            suffix = '-е';
          }
        } else if (unit === 'minute' || unit === 'second' || unit === 'hour') {
          suffix = '-а';
        } else {
          suffix = '-й';
        }

        return dirtyNumber + suffix;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'any',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 830 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^((до )?н\.?\s?е\.?)/i,
        abbreviated: /^((до )?н\.?\s?е\.?)/i,
        wide: /^(до нашої ери|нашої ери|наша ера)/i
      };
      var parseEraPatterns = {
        any: [/^д/i, /^н/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
        wide: /^[1234](-?[иі]?й?)? квартал/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[слбктчвжг]/i,
        abbreviated: /^(січ|лют|бер|берез|кві|трав?|чер|лип|сер|вер|жов|лис(топ)?|груд)\.?/i,
        wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопада?|грудень|грудня)/i
      };
      var parseMonthPatterns = {
        narrow: [/^с/i, /^л/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^с/i, /^в/i, /^ж/i, /^л/i, /^г/i],
        any: [/^сі/i, /^лю/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^лип/i, /^се/i, /^в/i, /^ж/i, /^лис/i, /^г/i]
      };
      var matchDayPatterns = {
        narrow: /^[нпвсч]/i,
        short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
        abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
        wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
      };
      var parseDayPatterns = {
        narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
        any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
        abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
        wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^дп/i,
          pm: /^пп/i,
          midnight: /^півн/i,
          noon: /^пол/i,
          morning: /^р/i,
          afternoon: /^д[ен]/i,
          evening: /^в/i,
          night: /^н/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 831 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(832);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(833);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(834);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(835);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(836);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Uzbek locale.
       * @language Uzbek
       * @iso-639-2 uzb
       * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
       */


      var locale = {
        code: 'uz',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 832 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'sekunddan kam',
          other: '{{count}} sekunddan kam'
        },
        xSeconds: {
          one: '1 sekund',
          other: '{{count}} sekund'
        },
        halfAMinute: 'yarim minut',
        lessThanXMinutes: {
          one: 'bir minutdan kam',
          other: '{{count}} minutdan kam'
        },
        xMinutes: {
          one: '1 minut',
          other: '{{count}} minut'
        },
        aboutXHours: {
          one: 'tahminan 1 soat',
          other: 'tahminan {{count}} soat'
        },
        xHours: {
          one: '1 soat',
          other: '{{count}} soat'
        },
        xDays: {
          one: '1 kun',
          other: '{{count}} kun'
        },
        aboutXWeeks: {
          one: 'tahminan 1 hafta',
          other: 'tahminan {{count}} hafta'
        },
        xWeeks: {
          one: '1 hafta',
          other: '{{count}} hafta'
        },
        aboutXMonths: {
          one: 'tahminan 1 oy',
          other: 'tahminan {{count}} oy'
        },
        xMonths: {
          one: '1 oy',
          other: '{{count}} oy'
        },
        aboutXYears: {
          one: 'tahminan 1 yil',
          other: 'tahminan {{count}} yil'
        },
        xYears: {
          one: '1 yil',
          other: '{{count}} yil'
        },
        overXYears: {
          one: "1 yildan ko'p",
          other: "{{count}} yildan ko'p"
        },
        almostXYears: {
          one: 'deyarli 1 yil',
          other: 'deyarli {{count}} yil'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + ' dan keyin';
          } else {
            return result + ' oldin';
          }
        }

        return result;
      }
      /***/

    },
    /* 833 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: 'EEEE, do MMMM, y',
        long: 'do MMMM, y',
        medium: 'd MMM, y',
        short: 'dd/MM/yyyy'
      };
      var timeFormats = {
        full: 'h:mm:ss zzzz',
        long: 'h:mm:ss z',
        medium: 'h:mm:ss',
        short: 'h:mm'
      };
      var dateTimeFormats = {
        any: '{{date}}, {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 834 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'oldingi' eeee p 'da'",
        yesterday: "'kecha' p 'da'",
        today: "'bugun' p 'da'",
        tomorrow: "'ertaga' p 'da'",
        nextWeek: "eeee p 'da'",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 835 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['M.A', 'M.'],
        abbreviated: ['M.A', 'M.'],
        wide: ['Miloddan Avvalgi', 'Milodiy']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['CH.1', 'CH.2', 'CH.3', 'CH.4'],
        wide: ['1-chi chorak', '2-chi chorak', '3-chi chorak', '4-chi chorak'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['Y', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
        abbreviated: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'Iyun', 'Iyul', 'Avg', 'Sen', 'Okt', 'Noy', 'Dek'],
        wide: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun', 'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr']
      };
      var dayValues = {
        narrow: ['Y', 'D', 'S', 'CH', 'P', 'J', 'SH'],
        short: ['Ya', 'Du', 'Se', 'Cho', 'Pa', 'Ju', 'Sha'],
        abbreviated: ['Yak', 'Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Shan'],
        wide: ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba']
      };
      var dayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'y.t',
          noon: 'p.',
          morning: 'ertalab',
          afternoon: 'tushdan keyin',
          evening: 'kechqurun',
          night: 'tun'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'yarim tun',
          noon: 'peshin',
          morning: 'ertalab',
          afternoon: 'tushdan keyin',
          evening: 'kechqurun',
          night: 'tun'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'yarim tun',
          noon: 'peshin',
          morning: 'ertalab',
          afternoon: 'tushdan keyin',
          evening: 'kechqurun',
          night: 'tun'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'a',
          pm: 'p',
          midnight: 'y.t',
          noon: 'p.',
          morning: 'ertalab',
          afternoon: 'tushdan keyin',
          evening: 'kechqurun',
          night: 'tun'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'yarim tun',
          noon: 'peshin',
          morning: 'ertalab',
          afternoon: 'tushdan keyin',
          evening: 'kechqurun',
          night: 'tun'
        },
        wide: {
          am: 'a.m.',
          pm: 'p.m.',
          midnight: 'yarim tun',
          noon: 'peshin',
          morning: 'ertalab',
          afternoon: 'tushdan keyin',
          evening: 'kechqurun',
          night: 'tun'
        }
      };

      function ordinalNumber(dirtyNumber, _dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 836 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(m\.a|m\.)/i,
        abbreviated: /^(m\.a\.?\s?m\.?)/i,
        wide: /^(miloddan avval|miloddan keyin)/i
      };
      var parseEraPatterns = {
        any: [/^b/i, /^(a|c)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^q[1234]/i,
        wide: /^[1234](chi)? chorak/i
      };
      var parseQuarterPatterns = {
        any: [/1/i, /2/i, /3/i, /4/i]
      };
      var matchMonthPatterns = {
        narrow: /^[yfmasond]/i,
        abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
        wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
      };
      var parseMonthPatterns = {
        narrow: [/^y/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
        any: [/^ya/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^iyun/i, /^iyul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
      };
      var matchDayPatterns = {
        narrow: /^[ydschj]/i,
        short: /^(ya|du|se|cho|pa|ju|sha)/i,
        abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
        wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
      };
      var parseDayPatterns = {
        narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
        any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
        any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^a/i,
          pm: /^p/i,
          midnight: /^y\.t/i,
          noon: /^pe/i,
          morning: /ertalab/i,
          afternoon: /tushdan keyin/i,
          evening: /kechqurun/i,
          night: /tun/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 837 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(838);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(839);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(840);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(841);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(842);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Vietnamese locale (Vietnam).
       * @language Vietnamese
       * @iso-639-2 vie
       * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
       * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
       */


      var locale = {
        code: 'vi',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 1
          /* First week of new year contains Jan 1st  */

        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 838 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: 'dưới 1 giây',
          other: 'dưới {{count}} giây'
        },
        xSeconds: {
          one: '1 giây',
          other: '{{count}} giây'
        },
        halfAMinute: 'nửa phút',
        lessThanXMinutes: {
          one: 'dưới 1 phút',
          other: 'dưới {{count}} phút'
        },
        xMinutes: {
          one: '1 phút',
          other: '{{count}} phút'
        },
        aboutXHours: {
          one: 'khoảng 1 giờ',
          other: 'khoảng {{count}} giờ'
        },
        xHours: {
          one: '1 giờ',
          other: '{{count}} giờ'
        },
        xDays: {
          one: '1 ngày',
          other: '{{count}} ngày'
        },
        aboutXWeeks: {
          one: 'khoảng 1 tuần',
          other: 'khoảng {{count}} tuần'
        },
        xWeeks: {
          one: '1 tuần',
          other: '{{count}} tuần'
        },
        aboutXMonths: {
          one: 'khoảng 1 tháng',
          other: 'khoảng {{count}} tháng'
        },
        xMonths: {
          one: '1 tháng',
          other: '{{count}} tháng'
        },
        aboutXYears: {
          one: 'khoảng 1 năm',
          other: 'khoảng {{count}} năm'
        },
        xYears: {
          one: '1 năm',
          other: '{{count}} năm'
        },
        overXYears: {
          one: 'hơn 1 năm',
          other: 'hơn {{count}} năm'
        },
        almostXYears: {
          one: 'gần 1 năm',
          other: 'gần {{count}} năm'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + ' nữa';
          } else {
            return result + ' trước';
          }
        }

        return result;
      }
      /***/

    },
    /* 839 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        // thứ Sáu, ngày 25 tháng 08 năm 2017
        full: "EEEE, 'ngày' d MMMM 'năm' y",
        // ngày 25 tháng 08 năm 2017
        long: "'ngày' d MMMM 'năm' y",
        // 25 thg 08 năm 2017
        medium: "d MMM 'năm' y",
        // 25/08/2017
        short: 'dd/MM/y'
      };
      var timeFormats = {
        full: 'HH:mm:ss zzzz',
        long: 'HH:mm:ss z',
        medium: 'HH:mm:ss',
        short: 'HH:mm'
      };
      var dateTimeFormats = {
        // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
        full: '{{date}} {{time}}',
        // ngày 25 tháng 08 năm 2017 23:25
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 840 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "eeee 'tuần trước vào lúc' p",
        yesterday: "'hôm qua vào lúc' p",
        today: "'hôm nay vào lúc' p",
        tomorrow: "'ngày mai vào lúc' p",
        nextWeek: "eeee 'tới vào lúc' p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 841 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3); // Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
      // Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134


      var eraValues = {
        narrow: ['TCN', 'SCN'],
        abbreviated: ['trước CN', 'sau CN'],
        wide: ['trước Công Nguyên', 'sau Công Nguyên']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        wide: ['Quý 1', 'Quý 2', 'Quý 3', 'Quý 4']
      };
      var formattingQuarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
        // I notice many news outlet use this "quý II/2018"
        wide: ['quý I', 'quý II', 'quý III', 'quý IV'] // Note: in English, the names of days of the week and months are capitalized.
        // If you are making a new locale based on this one, check if the same is true for the language you're working on.
        // Generally, formatted dates should look like they are in the middle of a sentence,
        // e.g. in Spanish language the weekdays and months should be in the lowercase.

      };
      var monthValues = {
        narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        abbreviated: ['Thg 1', 'Thg 2', 'Thg 3', 'Thg 4', 'Thg 5', 'Thg 6', 'Thg 7', 'Thg 8', 'Thg 9', 'Thg 10', 'Thg 11', 'Thg 12'],
        wide: ['Tháng Một', 'Tháng Hai', 'Tháng Ba', 'Tháng Tư', 'Tháng Năm', 'Tháng Sáu', 'Tháng Bảy', 'Tháng Tám', 'Tháng Chín', 'Tháng Mười', 'Tháng Mười Một', 'Tháng Mười Hai'] // In Vietnamese date formatting, month number less than 10 expected to have leading zero

      };
      var formattingMonthValues = {
        narrow: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        abbreviated: ['thg 1', 'thg 2', 'thg 3', 'thg 4', 'thg 5', 'thg 6', 'thg 7', 'thg 8', 'thg 9', 'thg 10', 'thg 11', 'thg 12'],
        wide: ['tháng 01', 'tháng 02', 'tháng 03', 'tháng 04', 'tháng 05', 'tháng 06', 'tháng 07', 'tháng 08', 'tháng 09', 'tháng 10', 'tháng 11', 'tháng 12']
      };
      var dayValues = {
        narrow: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
        short: ['CN', 'Th 2', 'Th 3', 'Th 4', 'Th 5', 'Th 6', 'Th 7'],
        abbreviated: ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'],
        wide: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy'] // Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
        // `abbreviated` are just like English but I'm leaving the `wide`
        // format being localized with abbreviations found in some systems (SÁng / CHiều);
        // however, personally, I don't think `Chiều` sounds appropriate for `PM`

      };
      var dayPeriodValues = {
        // narrow date period is extremely rare in Vietnamese
        // I used abbreviated form for noon, morning and afternoon
        // which are regconizable by Vietnamese, others cannot be any shorter
        narrow: {
          am: 'am',
          pm: 'pm',
          midnight: 'nửa đêm',
          noon: 'tr',
          morning: 'sg',
          afternoon: 'ch',
          evening: 'tối',
          night: 'đêm'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'nửa đêm',
          noon: 'trưa',
          morning: 'sáng',
          afternoon: 'chiều',
          evening: 'tối',
          night: 'đêm'
        },
        wide: {
          am: 'SA',
          pm: 'CH',
          midnight: 'nửa đêm',
          noon: 'trưa',
          morning: 'sáng',
          afternoon: 'chiều',
          evening: 'tối',
          night: 'đêm'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: 'am',
          pm: 'pm',
          midnight: 'nửa đêm',
          noon: 'tr',
          morning: 'sg',
          afternoon: 'ch',
          evening: 'tối',
          night: 'đêm'
        },
        abbreviated: {
          am: 'AM',
          pm: 'PM',
          midnight: 'nửa đêm',
          noon: 'trưa',
          morning: 'sáng',
          afternoon: 'chiều',
          evening: 'tối',
          night: 'đêm'
        },
        wide: {
          am: 'SA',
          pm: 'CH',
          midnight: 'nửa đêm',
          noon: 'giữa trưa',
          morning: 'vào buổi sáng',
          afternoon: 'vào buổi chiều',
          evening: 'vào buổi tối',
          night: 'vào ban đêm'
        } // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
        // 'dayOfMonth' or 'dayOfWeek'

      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var options = dirtyOptions || {};
        var unit = String(options.unit);
        var number = parseInt(dirtyNumber, 10);

        if (unit === 'quarter') {
          // many news outlets use "quý I"...
          switch (number) {
            case 1:
              return 'I';

            case 2:
              return 'II';

            case 3:
              return 'III';

            case 4:
              return 'IV';
          }
        } else if (unit === 'day') {
          // day of week in Vietnamese has ordinal number meaning,
          // so we should use them, else it'll sound weird
          switch (number) {
            case 1:
              return 'thứ 2';
            // meaning 2nd day but it's the first day of the week :D

            case 2:
              return 'thứ 3';
            // meaning 3rd day

            case 3:
              return 'thứ 4';
            // meaning 4th day and so on

            case 4:
              return 'thứ 5';

            case 5:
              return 'thứ 6';

            case 6:
              return 'thứ 7';

            case 7:
              return 'chủ nhật';
            // meaning Sunday, there's no 8th day :D
          }
        } else if (unit === 'week') {
          if (number === 1) {
            return 'thứ nhất';
          } else {
            return 'thứ ' + number;
          }
        } else if (unit === 'dayOfYear') {
          if (number === 1) {
            return 'đầu tiên';
          } else {
            return 'thứ ' + number;
          }
        } // there are no different forms of ordinal numbers in Vietnamese


        return number;
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          formattingValues: formattingQuarterValues,
          defaultFormattingWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide',
          formattingValues: formattingMonthValues,
          defaultFormattingWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 842 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(\d+)/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(tcn|scn)/i,
        abbreviated: /^(trước CN|sau CN)/i,
        wide: /^(trước Công Nguyên|sau Công Nguyên)/i
      };
      var parseEraPatterns = {
        any: [/^t/i, /^s/i]
      };
      var matchQuarterPatterns = {
        narrow: /^([1234]|i{1,3}v?)/i,
        abbreviated: /^q([1234]|i{1,3}v?)/i,
        wide: /^quý ([1234]|i{1,3}v?)/i
      };
      var parseQuarterPatterns = {
        any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
      };
      var matchMonthPatterns = {
        // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
        // note the order of '1' since it is a sub-string of '10', so must be lower priority
        narrow: /^(0?[2-9]|10|11|12|0?1)/i,
        // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
        abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
        // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
        wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
      };
      var parseMonthPatterns = {
        narrow: [/0?1$/i, /0?2/i, /3/, /4/, /5/, /6/, /7/, /8/, /9/, /10/, /11/, /12/],
        abbreviated: [/^thg[ _]?0?1(?!\d)/i, /^thg[ _]?0?2/i, /^thg[ _]?0?3/i, /^thg[ _]?0?4/i, /^thg[ _]?0?5/i, /^thg[ _]?0?6/i, /^thg[ _]?0?7/i, /^thg[ _]?0?8/i, /^thg[ _]?0?9/i, /^thg[ _]?10/i, /^thg[ _]?11/i, /^thg[ _]?12/i],
        wide: [/^tháng ?(Một|0?1(?!\d))/i, /^tháng ?(Hai|0?2)/i, /^tháng ?(Ba|0?3)/i, /^tháng ?(Tư|0?4)/i, /^tháng ?(Năm|0?5)/i, /^tháng ?(Sáu|0?6)/i, /^tháng ?(Bảy|0?7)/i, /^tháng ?(Tám|0?8)/i, /^tháng ?(Chín|0?9)/i, /^tháng ?(Mười|10)/i, /^tháng ?(Mười ?Một|11)/i, /^tháng ?(Mười ?Hai|12)/i]
      };
      var matchDayPatterns = {
        narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
        short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
        abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
        wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
      };
      var parseDayPatterns = {
        narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
        short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
        abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
        wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
      };
      var matchDayPeriodPatterns = {
        narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
        abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
        wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^(a|sa)/i,
          pm: /^(p|ch[^i]*)/i,
          midnight: /nửa đêm/i,
          noon: /trưa/i,
          morning: /sáng/i,
          afternoon: /chiều/i,
          evening: /tối/i,
          night: /^đêm/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 843 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(844);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(845);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(846);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(847);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(848);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Chinese Simplified locale.
       * @language Chinese Simplified
       * @iso-639-2 zho
       * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
       * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
       * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
       * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
       * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
       */


      var locale = {
        code: 'zh-CN',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 844 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: '不到 1 秒',
          other: '不到 {{count}} 秒'
        },
        xSeconds: {
          one: '1 秒',
          other: '{{count}} 秒'
        },
        halfAMinute: '半分钟',
        lessThanXMinutes: {
          one: '不到 1 分钟',
          other: '不到 {{count}} 分钟'
        },
        xMinutes: {
          one: '1 分钟',
          other: '{{count}} 分钟'
        },
        xHours: {
          one: '1 小时',
          other: '{{count}} 小时'
        },
        aboutXHours: {
          one: '大约 1 小时',
          other: '大约 {{count}} 小时'
        },
        xDays: {
          one: '1 天',
          other: '{{count}} 天'
        },
        aboutXWeeks: {
          one: '大约 1 个星期',
          other: '大约 {{count}} 个星期'
        },
        xWeeks: {
          one: '1 个星期',
          other: '{{count}} 个星期'
        },
        aboutXMonths: {
          one: '大约 1 个月',
          other: '大约 {{count}} 个月'
        },
        xMonths: {
          one: '1 个月',
          other: '{{count}} 个月'
        },
        aboutXYears: {
          one: '大约 1 年',
          other: '大约 {{count}} 年'
        },
        xYears: {
          one: '1 年',
          other: '{{count}} 年'
        },
        overXYears: {
          one: '超过 1 年',
          other: '超过 {{count}} 年'
        },
        almostXYears: {
          one: '将近 1 年',
          other: '将近 {{count}} 年'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + '内';
          } else {
            return result + '前';
          }
        }

        return result;
      }
      /***/

    },
    /* 845 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "y'年'M'月'd'日' EEEE",
        long: "y'年'M'月'd'日'",
        medium: 'yyyy-MM-dd',
        short: 'yy-MM-dd'
      };
      var timeFormats = {
        full: 'zzzz a h:mm:ss',
        long: 'z a h:mm:ss',
        medium: 'a h:mm:ss',
        short: 'a h:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 846 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__ = __webpack_require__(13);

      function checkWeek(_date, _baseDate, _options, baseFormat) {
        if (__WEBPACK_IMPORTED_MODULE_0__lib_isSameUTCWeek_index_js__["a"
        /* default */
        ](_date, _baseDate, _options)) {
          return baseFormat; // in same week
        } else if (_date.getTime() > _baseDate.getTime()) {
          return "'下个'" + baseFormat; // in next week
        }

        return "'上个'" + baseFormat; // in last week
      }

      var formatRelativeLocale = {
        lastWeek: checkWeek,
        // days before yesterday, maybe in this week or last week
        yesterday: "'昨天' p",
        today: "'今天' p",
        tomorrow: "'明天' p",
        nextWeek: checkWeek,
        // days after tomorrow, maybe in this week or next week
        other: 'PP p'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        var format = formatRelativeLocale[token];

        if (typeof format === 'function') {
          return format(_date, _baseDate, _options, 'eeee p');
        }

        return format;
      }
      /***/

    },
    /* 847 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['前', '公元'],
        abbreviated: ['前', '公元'],
        wide: ['公元前', '公元']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['第一刻', '第二刻', '第三刻', '第四刻'],
        wide: ['第一刻钟', '第二刻钟', '第三刻钟', '第四刻钟']
      };
      var monthValues = {
        narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
        abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
      };
      var dayValues = {
        narrow: ['日', '一', '二', '三', '四', '五', '六'],
        short: ['日', '一', '二', '三', '四', '五', '六'],
        abbreviated: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
        wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      };
      var dayPeriodValues = {
        narrow: {
          am: '上',
          pm: '下',
          midnight: '凌晨',
          noon: '午',
          morning: '早',
          afternoon: '下午',
          evening: '晚',
          night: '夜'
        },
        abbreviated: {
          am: '上午',
          pm: '下午',
          midnight: '凌晨',
          noon: '中午',
          morning: '早晨',
          afternoon: '中午',
          evening: '晚上',
          night: '夜间'
        },
        wide: {
          am: '上午',
          pm: '下午',
          midnight: '凌晨',
          noon: '中午',
          morning: '早晨',
          afternoon: '中午',
          evening: '晚上',
          night: '夜间'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: '上',
          pm: '下',
          midnight: '凌晨',
          noon: '午',
          morning: '早',
          afternoon: '下午',
          evening: '晚',
          night: '夜'
        },
        abbreviated: {
          am: '上午',
          pm: '下午',
          midnight: '凌晨',
          noon: '中午',
          morning: '早晨',
          afternoon: '中午',
          evening: '晚上',
          night: '夜间'
        },
        wide: {
          am: '上午',
          pm: '下午',
          midnight: '凌晨',
          noon: '中午',
          morning: '早晨',
          afternoon: '中午',
          evening: '晚上',
          night: '夜间'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'
        var number = Number(dirtyNumber);
        var options = dirtyOptions || {};
        var unit = String(options.unit);

        switch (unit) {
          case 'date':
            return number.toString() + '日';

          case 'hour':
            return number.toString() + '时';

          case 'minute':
            return number.toString() + '分';

          case 'second':
            return number.toString() + '秒';

          default:
            return '第 ' + number.toString();
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 848 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(前)/i,
        abbreviated: /^(前)/i,
        wide: /^(公元前|公元)/i
      };
      var parseEraPatterns = {
        any: [/^(前)/i, /^(公元)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^第[一二三四]刻/i,
        wide: /^第[一二三四]刻钟/i
      };
      var parseQuarterPatterns = {
        any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
      };
      var matchMonthPatterns = {
        narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
        abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
        wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
      };
      var parseMonthPatterns = {
        narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
        any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
      };
      var matchDayPatterns = {
        narrow: /^[一二三四五六日]/i,
        short: /^[一二三四五六日]/i,
        abbreviated: /^周[一二三四五六日]/i,
        wide: /^星期[一二三四五六日]/i
      };
      var parseDayPatterns = {
        any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^上午?/i,
          pm: /^下午?/i,
          midnight: /^午夜/i,
          noon: /^[中正]午/i,
          morning: /^早上/i,
          afternoon: /^下午/i,
          evening: /^晚上?/i,
          night: /^凌晨/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 849 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(850);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(851);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(852);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(853);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(854);
      /**
       * @type {Locale}
       * @category Locales
       * @summary Chinese Traditional locale.
       * @language Chinese Traditional
       * @iso-639-2 zho
       * @author tonypai [@tpai]{@link https://github.com/tpai}
       * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
       * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
       */


      var locale = {
        code: 'zh-TW',
        formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a"
        /* default */
        ],
        formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a"
        /* default */
        ],
        formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a"
        /* default */
        ],
        localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a"
        /* default */
        ],
        match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a"
        /* default */
        ],
        options: {
          weekStartsOn: 1
          /* Monday */
          ,
          firstWeekContainsDate: 4
        }
      };
      /* harmony default export */

      __webpack_exports__["a"] = locale;
      /***/
    },
    /* 850 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatDistance;
      var formatDistanceLocale = {
        lessThanXSeconds: {
          one: '少於 1 秒',
          other: '少於 {{count}} 秒'
        },
        xSeconds: {
          one: '1 秒',
          other: '{{count}} 秒'
        },
        halfAMinute: '半分鐘',
        lessThanXMinutes: {
          one: '少於 1 分鐘',
          other: '少於 {{count}} 分鐘'
        },
        xMinutes: {
          one: '1 分鐘',
          other: '{{count}} 分鐘'
        },
        xHours: {
          one: '1 小時',
          other: '{{count}} 小時'
        },
        aboutXHours: {
          one: '大約 1 小時',
          other: '大約 {{count}} 小時'
        },
        xDays: {
          one: '1 天',
          other: '{{count}} 天'
        },
        aboutXWeeks: {
          one: '大約 1 个星期',
          other: '大約 {{count}} 个星期'
        },
        xWeeks: {
          one: '1 个星期',
          other: '{{count}} 个星期'
        },
        aboutXMonths: {
          one: '大約 1 個月',
          other: '大約 {{count}} 個月'
        },
        xMonths: {
          one: '1 個月',
          other: '{{count}} 個月'
        },
        aboutXYears: {
          one: '大約 1 年',
          other: '大約 {{count}} 年'
        },
        xYears: {
          one: '1 年',
          other: '{{count}} 年'
        },
        overXYears: {
          one: '超過 1 年',
          other: '超過 {{count}} 年'
        },
        almostXYears: {
          one: '將近 1 年',
          other: '將近 {{count}} 年'
        }
      };

      function formatDistance(token, count, options) {
        options = options || {};
        var result;

        if (typeof formatDistanceLocale[token] === 'string') {
          result = formatDistanceLocale[token];
        } else if (count === 1) {
          result = formatDistanceLocale[token].one;
        } else {
          result = formatDistanceLocale[token].other.replace('{{count}}', count);
        }

        if (options.addSuffix) {
          if (options.comparison > 0) {
            return result + '內';
          } else {
            return result + '前';
          }
        }

        return result;
      }
      /***/

    },
    /* 851 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(2);

      var dateFormats = {
        full: "y'年'M'月'd'日' EEEE",
        long: "y'年'M'月'd'日'",
        medium: 'yyyy-MM-dd',
        short: 'yy-MM-dd'
      };
      var timeFormats = {
        full: 'zzzz a h:mm:ss',
        long: 'z a h:mm:ss',
        medium: 'a h:mm:ss',
        short: 'a h:mm'
      };
      var dateTimeFormats = {
        full: '{{date}} {{time}}',
        long: '{{date}} {{time}}',
        medium: '{{date}} {{time}}',
        short: '{{date}} {{time}}'
      };
      var formatLong = {
        date: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateFormats,
          defaultWidth: 'full'
        }),
        time: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: timeFormats,
          defaultWidth: 'full'
        }),
        dateTime: __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a"
        /* default */
        ]({
          formats: dateTimeFormats,
          defaultWidth: 'full'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = formatLong;
      /***/
    },
    /* 852 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony export (immutable) */

      __webpack_exports__["a"] = formatRelative;
      var formatRelativeLocale = {
        lastWeek: "'上個' eeee p",
        yesterday: "'昨天' p",
        today: "'今天' p",
        tomorrow: "'明天' p",
        nextWeek: "'下個' eeee p",
        other: 'P'
      };

      function formatRelative(token, _date, _baseDate, _options) {
        return formatRelativeLocale[token];
      }
      /***/

    },
    /* 853 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(3);

      var eraValues = {
        narrow: ['前', '公元'],
        abbreviated: ['前', '公元'],
        wide: ['公元前', '公元']
      };
      var quarterValues = {
        narrow: ['1', '2', '3', '4'],
        abbreviated: ['第一刻', '第二刻', '第三刻', '第四刻'],
        wide: ['第一刻鐘', '第二刻鐘', '第三刻鐘', '第四刻鐘']
      };
      var monthValues = {
        narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
        abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
      };
      var dayValues = {
        narrow: ['日', '一', '二', '三', '四', '五', '六'],
        short: ['日', '一', '二', '三', '四', '五', '六'],
        abbreviated: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
        wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      };
      var dayPeriodValues = {
        narrow: {
          am: '上',
          pm: '下',
          midnight: '凌晨',
          noon: '午',
          morning: '早',
          afternoon: '下午',
          evening: '晚',
          night: '夜'
        },
        abbreviated: {
          am: '上午',
          pm: '下午',
          midnight: '凌晨',
          noon: '中午',
          morning: '早晨',
          afternoon: '中午',
          evening: '晚上',
          night: '夜間'
        },
        wide: {
          am: '上午',
          pm: '下午',
          midnight: '凌晨',
          noon: '中午',
          morning: '早晨',
          afternoon: '中午',
          evening: '晚上',
          night: '夜間'
        }
      };
      var formattingDayPeriodValues = {
        narrow: {
          am: '上',
          pm: '下',
          midnight: '凌晨',
          noon: '午',
          morning: '早',
          afternoon: '下午',
          evening: '晚',
          night: '夜'
        },
        abbreviated: {
          am: '上午',
          pm: '下午',
          midnight: '凌晨',
          noon: '中午',
          morning: '早晨',
          afternoon: '中午',
          evening: '晚上',
          night: '夜間'
        },
        wide: {
          am: '上午',
          pm: '下午',
          midnight: '凌晨',
          noon: '中午',
          morning: '早晨',
          afternoon: '中午',
          evening: '晚上',
          night: '夜間'
        }
      };

      function ordinalNumber(dirtyNumber, dirtyOptions) {
        var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
        // if they are different for different grammatical genders,
        // use `options.unit`:
        //
        //   var options = dirtyOptions || {}
        //   var unit = String(options.unit)
        //
        // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
        // 'day', 'hour', 'minute', 'second'

        var options = dirtyOptions || {};
        var unit = String(options.unit);

        switch (unit) {
          case 'date':
            return number.toString() + '日';

          case 'hour':
            return number.toString() + '時';

          case 'minute':
            return number.toString() + '分';

          case 'second':
            return number.toString() + '秒';

          default:
            return '第 ' + number.toString();
        }
      }

      var localize = {
        ordinalNumber: ordinalNumber,
        era: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: eraValues,
          defaultWidth: 'wide'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: quarterValues,
          defaultWidth: 'wide',
          argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: monthValues,
          defaultWidth: 'wide'
        }),
        day: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayValues,
          defaultWidth: 'wide'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a"
        /* default */
        ]({
          values: dayPeriodValues,
          defaultWidth: 'wide',
          formattingValues: formattingDayPeriodValues,
          defaultFormattingWidth: 'wide'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = localize;
      /***/
    },
    /* 854 */

    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";
      /* harmony import */

      var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(4);
      /* harmony import */


      var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(5);

      var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
      var parseOrdinalNumberPattern = /\d+/i;
      var matchEraPatterns = {
        narrow: /^(前)/i,
        abbreviated: /^(前)/i,
        wide: /^(公元前|公元)/i
      };
      var parseEraPatterns = {
        any: [/^(前)/i, /^(公元)/i]
      };
      var matchQuarterPatterns = {
        narrow: /^[1234]/i,
        abbreviated: /^第[一二三四]刻/i,
        wide: /^第[一二三四]刻鐘/i
      };
      var parseQuarterPatterns = {
        any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
      };
      var matchMonthPatterns = {
        narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
        abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
        wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
      };
      var parseMonthPatterns = {
        narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
        any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
      };
      var matchDayPatterns = {
        narrow: /^[一二三四五六日]/i,
        short: /^[一二三四五六日]/i,
        abbreviated: /^週[一二三四五六日]/i,
        wide: /^星期[一二三四五六日]/i
      };
      var parseDayPatterns = {
        any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
      };
      var matchDayPeriodPatterns = {
        any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
      };
      var parseDayPeriodPatterns = {
        any: {
          am: /^上午?/i,
          pm: /^下午?/i,
          midnight: /^午夜/i,
          noon: /^[中正]午/i,
          morning: /^早上/i,
          afternoon: /^下午/i,
          evening: /^晚上?/i,
          night: /^凌晨/i
        }
      };
      var match = {
        ordinalNumber: __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a"
        /* default */
        ]({
          matchPattern: matchOrdinalNumberPattern,
          parsePattern: parseOrdinalNumberPattern,
          valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
          }
        }),
        era: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchEraPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseEraPatterns,
          defaultParseWidth: 'any'
        }),
        quarter: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchQuarterPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseQuarterPatterns,
          defaultParseWidth: 'any',
          valueCallback: function valueCallback(index) {
            return index + 1;
          }
        }),
        month: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchMonthPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseMonthPatterns,
          defaultParseWidth: 'any'
        }),
        day: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPatterns,
          defaultMatchWidth: 'wide',
          parsePatterns: parseDayPatterns,
          defaultParseWidth: 'any'
        }),
        dayPeriod: __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a"
        /* default */
        ]({
          matchPatterns: matchDayPeriodPatterns,
          defaultMatchWidth: 'any',
          parsePatterns: parseDayPeriodPatterns,
          defaultParseWidth: 'any'
        })
      };
      /* harmony default export */

      __webpack_exports__["a"] = match;
      /***/
    },
    /* 855 */

    /***/
    function (module, exports) {// removed by extract-text-webpack-plugin

      /***/
    },
    /* 856 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var GT_ACCESS_TOKEN = exports.GT_ACCESS_TOKEN = 'GT_ACCESS_TOKEN';
      var GT_VERSION = exports.GT_VERSION = "1.7.2"; // eslint-disable-line

      var GT_COMMENT = exports.GT_COMMENT = 'GT_COMMENT';
      /***/
    },
    /* 857 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      Object.defineProperty(exports, "__esModule", {
        value: true
      });

      var _toConsumableArray2 = __webpack_require__(858);

      var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

      var _util = __webpack_require__(121);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      var getQL = function getQL(vars, pagerDirection) {
        var cursorDirection = pagerDirection === 'last' ? 'before' : 'after';
        var ql = '\n  query getIssueAndComments(\n    $owner: String!,\n    $repo: String!,\n    $id: Int!,\n    $cursor: String,\n    $pageSize: Int!\n  ) {\n    repository(owner: $owner, name: $repo) {\n      issue(number: $id) {\n        title\n        url\n        bodyHTML\n        createdAt\n        comments(' + pagerDirection + ': $pageSize, ' + cursorDirection + ': $cursor) {\n          totalCount\n          pageInfo {\n            ' + (pagerDirection === 'last' ? 'hasPreviousPage' : 'hasNextPage') + '\n            ' + (cursorDirection === 'before' ? 'startCursor' : 'endCursor') + '\n          }\n          nodes {\n            id\n            databaseId\n            author {\n              avatarUrl\n              login\n              url\n            }\n            bodyHTML\n            body\n            createdAt\n            reactions(first: 100, content: HEART) {\n              totalCount\n              viewerHasReacted\n              pageInfo{\n                hasNextPage\n              }\n              nodes {\n                id\n                databaseId\n                user {\n                  login\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n  ';
        if (vars.cursor === null) delete vars.cursor;
        return {
          operationName: 'getIssueAndComments',
          query: ql,
          variables: vars
        };
      };

      function getComments(issue) {
        var _this = this;

        var _options = this.options,
            owner = _options.owner,
            repo = _options.repo,
            perPage = _options.perPage,
            pagerDirection = _options.pagerDirection,
            defaultAuthor = _options.defaultAuthor;
        var _state = this.state,
            cursor = _state.cursor,
            comments = _state.comments;
        return _util.axiosGithub.post('/graphql', getQL({
          owner: owner,
          repo: repo,
          id: issue.number,
          pageSize: perPage,
          cursor: cursor
        }, pagerDirection), {
          headers: {
            Authorization: 'bearer ' + this.accessToken
          }
        }).then(function (res) {
          var data = res.data.data.repository.issue.comments;
          var items = data.nodes.map(function (node) {
            var author = node.author || defaultAuthor;
            return {
              id: node.databaseId,
              gId: node.id,
              user: {
                avatar_url: author.avatarUrl,
                login: author.login,
                html_url: author.url
              },
              created_at: node.createdAt,
              body_html: node.bodyHTML,
              body: node.body,
              html_url: 'https://github.com/' + owner + '/' + repo + '/issues/' + issue.number + '#issuecomment-' + node.databaseId,
              reactions: node.reactions
            };
          });
          var cs = void 0;

          if (pagerDirection === 'last') {
            cs = [].concat((0, _toConsumableArray3.default)(items), (0, _toConsumableArray3.default)(comments));
          } else {
            cs = [].concat((0, _toConsumableArray3.default)(comments), (0, _toConsumableArray3.default)(items));
          }

          var isLoadOver = data.pageInfo.hasPreviousPage === false || data.pageInfo.hasNextPage === false;

          _this.setState({
            comments: cs,
            isLoadOver: isLoadOver,
            cursor: data.pageInfo.startCursor || data.pageInfo.endCursor
          });

          return cs;
        });
      }

      exports.default = getComments;
      /***/
    },
    /* 858 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      exports.__esModule = true;

      var _from = __webpack_require__(859);

      var _from2 = _interopRequireDefault(_from);

      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          default: obj
        };
      }

      exports.default = function (arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
            arr2[i] = arr[i];
          }

          return arr2;
        } else {
          return (0, _from2.default)(arr);
        }
      };
      /***/

    },
    /* 859 */

    /***/
    function (module, exports, __webpack_require__) {
      module.exports = {
        "default": __webpack_require__(860),
        __esModule: true
      };
      /***/
    },
    /* 860 */

    /***/
    function (module, exports, __webpack_require__) {
      __webpack_require__(40);

      __webpack_require__(861);

      module.exports = __webpack_require__(7).Array.from;
      /***/
    },
    /* 861 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var ctx = __webpack_require__(29);

      var $export = __webpack_require__(11);

      var toObject = __webpack_require__(33);

      var call = __webpack_require__(107);

      var isArrayIter = __webpack_require__(108);

      var toLength = __webpack_require__(72);

      var createProperty = __webpack_require__(862);

      var getIterFn = __webpack_require__(77);

      $export($export.S + $export.F * !__webpack_require__(113)(function (iter) {
        Array.from(iter);
      }), 'Array', {
        // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
        from: function from(arrayLike
        /* , mapfn = undefined, thisArg = undefined */
        ) {
          var O = toObject(arrayLike);
          var C = typeof this == 'function' ? this : Array;
          var aLen = arguments.length;
          var mapfn = aLen > 1 ? arguments[1] : undefined;
          var mapping = mapfn !== undefined;
          var index = 0;
          var iterFn = getIterFn(O);
          var length, result, step, iterator;
          if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

          if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
            for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
              createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
            }
          } else {
            length = toLength(O.length);

            for (result = new C(length); length > index; index++) {
              createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
            }
          }

          result.length = index;
          return result;
        }
      });
      /***/
    },
    /* 862 */

    /***/
    function (module, exports, __webpack_require__) {
      "use strict";

      var $defineProperty = __webpack_require__(16);

      var createDesc = __webpack_require__(39);

      module.exports = function (object, index, value) {
        if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
      };
      /***/

    }
    /******/
    ])
  );
});